export const data = [
  {
    "inf": [
      "Synthesis of a Ni(I) Complex Storing One Electron from H<sub>2</sub",
      "(<sup>1</sup>Grad. Sch. of Eng., Kyushu Univ., <sup>2</sup>I2CNER, <sup>3</sup>sMol, <sup>4</sup>Fac. of Sci. and Eng., Kindai Univ.) 〇Chiaki TAKAHASHI<sup>1,2</sup>, Takeshi YATABE<sup>1,2,3</sup>, Hidetaka NAKAI<sup>4</sup>, Seiji OGO<sup>1,2,3</sup>"
    ],
    "lab": "1Aa-02",
    "pdf": "pdf/1Aa-02.pdf",
    "pre": "tn/1Aa-02.jpg",
    "reg": "74226",
    "sea": "Ni",
    "ses": "1Aa",
    "con": "1Aa-02 Synthesis of a Ni(I) Complex Storing One Electron from H<sub>2</sub (<sup>1</sup>Grad. Sch. of Eng., Kyushu Univ., <sup>2</sup>I2CNER, <sup>3</sup>sMol, <sup>4</sup>Fac. of Sci. and Eng., Kindai Univ.) 〇Chiaki TAKAHASHI<sup>1,2</sup>, Takeshi YATABE<sup>1,2,3</sup>, Hidetaka NAKAI<sup>4</sup>, Seiji OGO<sup>1,2,3</sup> Ni"
  },
  {
    "inf": [
      "Synthesis of solvated barium(II) complexes with square antiprismatic and cubic coordination geometries",
      "(<sup>1</sup>Hiroshima University, Graduate School of Advanced Science and Engineering) ★Ayano Umakoshi<sup>1</sup>, Takuo Minato<sup>1</sup>, Yusuke Kanematsu<sup>1</sup>, Masahiro Sadakane<sup>1</sup>"
    ],
    "lab": "1Aa-03",
    "pdf": "pdf/1Aa-03.pdf",
    "pre": "tn/1Aa-03.jpg",
    "reg": "74585",
    "sea": "Ba",
    "ses": "1Aa",
    "con": "1Aa-03 Synthesis of solvated barium(II) complexes with square antiprismatic and cubic coordination geometries (<sup>1</sup>Hiroshima University, Graduate School of Advanced Science and Engineering) ★Ayano Umakoshi<sup>1</sup>, Takuo Minato<sup>1</sup>, Yusuke Kanematsu<sup>1</sup>, Masahiro Sadakane<sup>1</sup> Ba"
  },
  {
    "inf": [
      "Tuning Host Properties of Organic Macrocycles by Confinement in Coordination Cages",
      "(<sup>1</sup>Grad. Sch. Eng., The Univ. of Tokyo, <sup>2</sup>UTIAS, <sup>3</sup>IMS) ★Kenta IIZUKA<sup>1</sup>, Hiroki TAKEZAWA<sup>1</sup>, Makoto FUJITA<sup>1,2,3</sup>"
    ],
    "lab": "1Aa-04",
    "pdf": "pdf/1Aa-04.pdf",
    "pre": "tn/1Aa-04.jpg",
    "reg": "74151",
    "sea": "Pt, Pd",
    "ses": "1Aa",
    "con": "1Aa-04 Tuning Host Properties of Organic Macrocycles by Confinement in Coordination Cages (<sup>1</sup>Grad. Sch. Eng., The Univ. of Tokyo, <sup>2</sup>UTIAS, <sup>3</sup>IMS) ★Kenta IIZUKA<sup>1</sup>, Hiroki TAKEZAWA<sup>1</sup>, Makoto FUJITA<sup>1,2,3</sup> Pt, Pd"
  },
  {
    "inf": [
      "Molecular encapsulation regulates a cooperative binding of lanthanide ions by a tetrahedral organic cage molecule",
      "(<sup>1</sup>Degree Programs in Pure and Applied Sciences, Graduate School of Science and Technology, University of Tsukuba) ★Miu MUTO<sup>1</sup>, Daiki ITO<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Masayuki NIHEI<sup>1</sup>"
    ],
    "lab": "1Aa-05",
    "pdf": "pdf/1Aa-05.pdf",
    "pre": "tn/1Aa-05.jpg",
    "reg": "74560",
    "sea": "La",
    "ses": "1Aa",
    "con": "1Aa-05 Molecular encapsulation regulates a cooperative binding of lanthanide ions by a tetrahedral organic cage molecule (<sup>1</sup>Degree Programs in Pure and Applied Sciences, Graduate School of Science and Technology, University of Tsukuba) ★Miu MUTO<sup>1</sup>, Daiki ITO<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Masayuki NIHEI<sup>1</sup> La"
  },
  {
    "inf": [
      "Booster stimulus strategy for chirality inversion in a dynamic helical closed cage tricobalt(III) cryptand by alkali metal ion binding",
      "(<sup>1</sup>Nano Life Science Institute, Kanazawa University, <sup>2</sup>Graduate School of Natural Science and Technology, Kanazawa University) 〇Sk Asif Ikbal<sup>1</sup>, Shigehisa Akine<sup>1,2</sup>"
    ],
    "lab": "1Aa-06",
    "pdf": "pdf/1Aa-06.pdf",
    "pre": "tn/1Aa-06.jpg",
    "reg": "74481",
    "sea": "Co",
    "ses": "1Aa",
    "con": "1Aa-06 Booster stimulus strategy for chirality inversion in a dynamic helical closed cage tricobalt(III) cryptand by alkali metal ion binding (<sup>1</sup>Nano Life Science Institute, Kanazawa University, <sup>2</sup>Graduate School of Natural Science and Technology, Kanazawa University) 〇Sk Asif Ikbal<sup>1</sup>, Shigehisa Akine<sup>1,2</sup> Co"
  },
  {
    "inf": [
      "Stimuli–Responsive Structural Conversion of Helical Co(II) Complexes with Chiral Ligands Containing 3–Substituted Benzene ",
      "(<sup>1</sup>Osaka Metro. Univ.) ★Kenichi HATTORI<sup>1</sup>, Eiko MIEDA<sup>1</sup>, Satoshi SHINODA<sup>1</sup>, Hiroyuki MIYAKE<sup>1</sup>"
    ],
    "lab": "1Aa-07",
    "pdf": "pdf/1Aa-07.pdf",
    "pre": "tn/1Aa-07.jpg",
    "reg": "74201",
    "sea": "Co",
    "ses": "1Aa",
    "con": "1Aa-07 Stimuli–Responsive Structural Conversion of Helical Co(II) Complexes with Chiral Ligands Containing 3–Substituted Benzene  (<sup>1</sup>Osaka Metro. Univ.) ★Kenichi HATTORI<sup>1</sup>, Eiko MIEDA<sup>1</sup>, Satoshi SHINODA<sup>1</sup>, Hiroyuki MIYAKE<sup>1</sup> Co"
  },
  {
    "inf": [
      "Stereoisomeric Effects of Ligand and Coordination Chirality on Iron(II) Bis(diimine) Spin Crossover",
      "(<sup>1</sup>The University of Electro-Communications) ★Rina Takano<sup>1</sup>, Mio Yoshida<sup>1</sup>, Yoshio Kobayashi<sup>1</sup>, Takayuki Ishida<sup>1</sup>"
    ],
    "lab": "1Aa-08",
    "pdf": "pdf/1Aa-08.pdf",
    "pre": "tn/1Aa-08.jpg",
    "reg": "74204",
    "sea": "Fe",
    "ses": "1Aa",
    "con": "1Aa-08 Stereoisomeric Effects of Ligand and Coordination Chirality on Iron(II) Bis(diimine) Spin Crossover (<sup>1</sup>The University of Electro-Communications) ★Rina Takano<sup>1</sup>, Mio Yoshida<sup>1</sup>, Yoshio Kobayashi<sup>1</sup>, Takayuki Ishida<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Luminescence Changes of Tricarbonyl and Tetracarbonylrhenium(I) Complexes Induced by Protonation/Deprotonation on the Bidentate Azolylpyridine Ligands",
      "(<sup>1</sup>Graduate School of Science, Osaka University, <sup>2</sup>Graduate School of Science, University of Hyogo, <sup>3</sup>Radioisotope Research Center, Institute for Radiation Science, Osaka University) ★Sodai MIYAMOTO<sup>1</sup>, Yuki MATSUDA<sup>2</sup>, Masaaki ABE<sup>2</sup>, Takashi YOSHIMURA<sup>3</sup>"
    ],
    "lab": "1Ab-02",
    "pdf": "pdf/1Ab-02.pdf",
    "pre": "tn/1Ab-02.jpg",
    "reg": "74173",
    "sea": "Re",
    "ses": "1Ab",
    "con": "1Ab-02 Luminescence Changes of Tricarbonyl and Tetracarbonylrhenium(I) Complexes Induced by Protonation/Deprotonation on the Bidentate Azolylpyridine Ligands (<sup>1</sup>Graduate School of Science, Osaka University, <sup>2</sup>Graduate School of Science, University of Hyogo, <sup>3</sup>Radioisotope Research Center, Institute for Radiation Science, Osaka University) ★Sodai MIYAMOTO<sup>1</sup>, Yuki MATSUDA<sup>2</sup>, Masaaki ABE<sup>2</sup>, Takashi YOSHIMURA<sup>3</sup> Re"
  },
  {
    "inf": [
      "_In-Situ_ Observation of Guest-Induced Crystal-to-Crystal and Amorphous-to-Crystal Dynamic Transformation in a Photoluminescent Rhenium(I) Complex",
      "(<sup>1</sup>Univ. of Hyogo, <sup>2</sup>Kyushu Univ., <sup>3</sup>Osaka Univ., <sup>4</sup>Kindai Univ., <sup>5</sup>JASRI) ★Yuki MATSUDA<sup>1</sup>, Yoshiki OZAWA<sup>1</sup>, Keishiro TAHARA<sup>1</sup>, Toshikazu ONO<sup>2</sup>, Nobuto YOSHINARI<sup>3</sup>, Takumi KONNO<sup>3</sup>, Kunihisa SUGIMOTO<sup>4</sup>, Shintaro KOBAYASHI<sup>5</sup>, Shogo KAWAGUCHI<sup>5</sup>, Masaaki ABE<sup>1</sup>"
    ],
    "lab": "1Ab-03",
    "pdf": "pdf/1Ab-03.pdf",
    "pre": "tn/1Ab-03.jpg",
    "reg": "74389",
    "sea": "Re",
    "ses": "1Ab",
    "con": "1Ab-03 _In-Situ_ Observation of Guest-Induced Crystal-to-Crystal and Amorphous-to-Crystal Dynamic Transformation in a Photoluminescent Rhenium(I) Complex (<sup>1</sup>Univ. of Hyogo, <sup>2</sup>Kyushu Univ., <sup>3</sup>Osaka Univ., <sup>4</sup>Kindai Univ., <sup>5</sup>JASRI) ★Yuki MATSUDA<sup>1</sup>, Yoshiki OZAWA<sup>1</sup>, Keishiro TAHARA<sup>1</sup>, Toshikazu ONO<sup>2</sup>, Nobuto YOSHINARI<sup>3</sup>, Takumi KONNO<sup>3</sup>, Kunihisa SUGIMOTO<sup>4</sup>, Shintaro KOBAYASHI<sup>5</sup>, Shogo KAWAGUCHI<sup>5</sup>, Masaaki ABE<sup>1</sup> Re"
  },
  {
    "inf": [
      "8–キノリンアミド含有らせん型配位子からなるキラルなZn(II)錯体の形成と外部刺激応答性発光",
      "(<sup>1</sup>阪公大院理) 〇和田 翔平<sup>1</sup>・三枝 栄子<sup>1</sup>・篠田 哲史<sup>1</sup>・三宅 弘之<sup>1</sup>",
      "Synthesis and Stimuli–Responsive Luminescence of Chiral Zn(II) Complex with Helical Ligand Containing 8–Quinoline Amide",
      "(<sup>1</sup>Osaka Metro. Univ.) 〇Shohei WADA<sup>1</sup>, Eiko MIEDA<sup>1</sup>, Satoshi SHINODA<sup>1</sup>, Hiroyuki MIYAKE<sup>1</sup>"
    ],
    "lab": "1Ab-04",
    "pdf": "pdf/1Ab-04.pdf",
    "pre": "tn/1Ab-04.jpg",
    "reg": "74426",
    "sea": "Zn",
    "ses": "1Ab",
    "con": "1Ab-04 8–キノリンアミド含有らせん型配位子からなるキラルなZn(II)錯体の形成と外部刺激応答性発光 (<sup>1</sup>阪公大院理) 〇和田 翔平<sup>1</sup>・三枝 栄子<sup>1</sup>・篠田 哲史<sup>1</sup>・三宅 弘之<sup>1</sup> Synthesis and Stimuli–Responsive Luminescence of Chiral Zn(II) Complex with Helical Ligand Containing 8–Quinoline Amide (<sup>1</sup>Osaka Metro. Univ.) 〇Shohei WADA<sup>1</sup>, Eiko MIEDA<sup>1</sup>, Satoshi SHINODA<sup>1</sup>, Hiroyuki MIYAKE<sup>1</sup> Zn"
  },
  {
    "inf": [
      "ピリジルチアゾール配位子を含む新規白金(II)錯体の合成と構造および固体発光特性",
      "(<sup>1</sup>兵庫県立大院理) 〇橋本廉<sup>1</sup>・中村瞭汰<sup>1</sup>・小澤芳樹<sup>1</sup>・阿部正明<sup>1</sup>",
      "Synthesis, Structures, and Solid-Stata Photoluminescence of Novel Platinum(II) Complexes Containing a Pyridylthiazole Ligand",
      "(<sup>1</sup>Graduate School of Science, University of Hyogo) 〇Ren HASHIMOTO<sup>1</sup>, Ryota NAKAMURA<sup>1</sup>, Yoshiki OZAWA<sup>1</sup>, Masaski ABE<sup>1</sup>"
    ],
    "lab": "1Ab-05",
    "pdf": "pdf/1Ab-05.pdf",
    "pre": "tn/1Ab-05.jpg",
    "reg": "74424",
    "sea": "Pt",
    "ses": "1Ab",
    "con": "1Ab-05 ピリジルチアゾール配位子を含む新規白金(II)錯体の合成と構造および固体発光特性 (<sup>1</sup>兵庫県立大院理) 〇橋本廉<sup>1</sup>・中村瞭汰<sup>1</sup>・小澤芳樹<sup>1</sup>・阿部正明<sup>1</sup> Synthesis, Structures, and Solid-Stata Photoluminescence of Novel Platinum(II) Complexes Containing a Pyridylthiazole Ligand (<sup>1</sup>Graduate School of Science, University of Hyogo) 〇Ren HASHIMOTO<sup>1</sup>, Ryota NAKAMURA<sup>1</sup>, Yoshiki OZAWA<sup>1</sup>, Masaski ABE<sup>1</sup> Pt"
  },
  {
    "inf": [
      "柔軟なアルキル鎖をもつ白金(II)-NHC錯体のフルカラークロミック発光",
      "(<sup>1</sup>関学大院理工・<sup>2</sup>北大院総化・<sup>3</sup>関学大生命環境) 〇田中 芙佳<sup>1</sup>・佐々木 この<sup>2</sup>・吉田 将己<sup>3</sup>・加藤 昌子<sup>3</sup>",
      "Full-Color Chromic Luminescence of a Platinum(II)-NHC Complex with Flexible Alkyl Chain",
      "(<sup>1</sup>Kwansei Gakuin Univ., <sup>2</sup>Hokkaido Univ., <sup>3</sup>Kwansei Gakuin Univ.) 〇Fuka TANAKA<sup>1</sup>, Kono SASAKI<sup>2</sup>, Masaki YOSHIDA<sup>3</sup>, Masako KATO<sup>3</sup>"
    ],
    "lab": "1Ab-06",
    "pdf": "pdf/1Ab-06.pdf",
    "pre": "tn/1Ab-06.jpg",
    "reg": "74076",
    "sea": "Pt",
    "ses": "1Ab",
    "con": "1Ab-06 柔軟なアルキル鎖をもつ白金(II)-NHC錯体のフルカラークロミック発光 (<sup>1</sup>関学大院理工・<sup>2</sup>北大院総化・<sup>3</sup>関学大生命環境) 〇田中 芙佳<sup>1</sup>・佐々木 この<sup>2</sup>・吉田 将己<sup>3</sup>・加藤 昌子<sup>3</sup> Full-Color Chromic Luminescence of a Platinum(II)-NHC Complex with Flexible Alkyl Chain (<sup>1</sup>Kwansei Gakuin Univ., <sup>2</sup>Hokkaido Univ., <sup>3</sup>Kwansei Gakuin Univ.) 〇Fuka TANAKA<sup>1</sup>, Kono SASAKI<sup>2</sup>, Masaki YOSHIDA<sup>3</sup>, Masako KATO<sup>3</sup> Pt"
  },
  {
    "inf": [
      "Synthesis and Photochromism of a Tetrathiazole-based Bis-terpyridine Hexadentate Ligand and its Iron(II) Complex",
      "(<sup>1</sup>NAIST, <sup>2</sup>Univ. of Granada, <sup>3</sup>Osaka Metropolitan Univ.) 〇Mihoko Yamada<sup></sup>, Masato Nishi<sup></sup>, Pablo Reine<sup></sup>, Shouhei Katao<sup></sup>, Yoshiko Nishikawa<sup></sup>, Takuya Nakashima<sup></sup>, Tsuyoshi Kawai<sup></sup>"
    ],
    "lab": "1Ab-07",
    "pdf": "pdf/1Ab-07.pdf",
    "pre": "tn/1Ab-07.jpg",
    "reg": "74551",
    "sea": "Fe",
    "ses": "1Ab",
    "con": "1Ab-07 Synthesis and Photochromism of a Tetrathiazole-based Bis-terpyridine Hexadentate Ligand and its Iron(II) Complex (<sup>1</sup>NAIST, <sup>2</sup>Univ. of Granada, <sup>3</sup>Osaka Metropolitan Univ.) 〇Mihoko Yamada<sup></sup>, Masato Nishi<sup></sup>, Pablo Reine<sup></sup>, Shouhei Katao<sup></sup>, Yoshiko Nishikawa<sup></sup>, Takuya Nakashima<sup></sup>, Tsuyoshi Kawai<sup></sup> Fe"
  },
  {
    "inf": [
      "キラルな1,4,7,10-テトラアザシクロドデカン骨格を有するサマリウム錯体の合成と構造および発光特性",
      "(<sup>1</sup>近畿大院総理工) 〇原田 和海<sup>1</sup>・松井 久宜<sup>1</sup>・中井 英隆<sup>1</sup>",
      "Synthesis, Structure, and Luminescence Properties of Samarium Complexes with Chiral 1,4,7,10-Tetraazacyclododecane Skeletons",
      "(<sup>1</sup>Graduate School of Sci. and Eng., Kindai Univ.) 〇Kazuhiro HARADA<sup>1</sup>, Hisaki MATSUI<sup>1</sup>, Hidetaka NAKAI<sup>1</sup>"
    ],
    "lab": "1Ab-08",
    "pdf": "pdf/1Ab-08.pdf",
    "pre": "tn/1Ab-08.jpg",
    "reg": "74543",
    "sea": "Sm",
    "ses": "1Ab",
    "con": "1Ab-08 キラルな1,4,7,10-テトラアザシクロドデカン骨格を有するサマリウム錯体の合成と構造および発光特性 (<sup>1</sup>近畿大院総理工) 〇原田 和海<sup>1</sup>・松井 久宜<sup>1</sup>・中井 英隆<sup>1</sup> Synthesis, Structure, and Luminescence Properties of Samarium Complexes with Chiral 1,4,7,10-Tetraazacyclododecane Skeletons (<sup>1</sup>Graduate School of Sci. and Eng., Kindai Univ.) 〇Kazuhiro HARADA<sup>1</sup>, Hisaki MATSUI<sup>1</sup>, Hidetaka NAKAI<sup>1</sup> Sm"
  },
  {
    "inf": [
      "Synthesis and Photothermal Conversion Properties of a Mixed Valence Manganese-oxo Cluster Ligated with Tridentate Triptycenes",
      "(<sup>1</sup>Sch. Mater. Chem. Tech., Tokyo Tech., <sup>2</sup>CLS, Tokyo Tech., <sup>3</sup>ASMat, Tokyo Tech.) ★Mikiya KATO<sup>1,2</sup>, Tomoya FUKUI<sup>1,2,3</sup>, Takanori FUKUSHIMA<sup>1,2,3</sup>"
    ],
    "lab": "1Ac-02",
    "pdf": "pdf/1Ac-02.pdf",
    "pre": "tn/1Ac-02.jpg",
    "reg": "74215",
    "sea": "Mn",
    "ses": "1Ac",
    "con": "1Ac-02 Synthesis and Photothermal Conversion Properties of a Mixed Valence Manganese-oxo Cluster Ligated with Tridentate Triptycenes (<sup>1</sup>Sch. Mater. Chem. Tech., Tokyo Tech., <sup>2</sup>CLS, Tokyo Tech., <sup>3</sup>ASMat, Tokyo Tech.) ★Mikiya KATO<sup>1,2</sup>, Tomoya FUKUI<sup>1,2,3</sup>, Takanori FUKUSHIMA<sup>1,2,3</sup> Mn"
  },
  {
    "inf": [
      "Redox-Active Ruthenium-Organic Polyhedra with Tunable Surface Functionality and Porosities",
      "(<sup>1</sup>iCeMS, Kyoto Univ., <sup>2</sup>IAdChem, UAM., <sup>3</sup>Chuo Univ.) 〇Fuerkaiti Tayier<sup>1</sup>, Javier Troyano<sup>1,2</sup>, Shun Tokuda<sup>1</sup>, Zaoming Wang<sup>1</sup>, Masa-aki Haga<sup>3</sup>, Shuhei Furukawa<sup>1</sup>"
    ],
    "lab": "1Ac-03",
    "pdf": "pdf/1Ac-03.pdf",
    "pre": "tn/1Ac-03.jpg",
    "reg": "74117",
    "sea": "Ru",
    "ses": "1Ac",
    "con": "1Ac-03 Redox-Active Ruthenium-Organic Polyhedra with Tunable Surface Functionality and Porosities (<sup>1</sup>iCeMS, Kyoto Univ., <sup>2</sup>IAdChem, UAM., <sup>3</sup>Chuo Univ.) 〇Fuerkaiti Tayier<sup>1</sup>, Javier Troyano<sup>1,2</sup>, Shun Tokuda<sup>1</sup>, Zaoming Wang<sup>1</sup>, Masa-aki Haga<sup>3</sup>, Shuhei Furukawa<sup>1</sup> Ru"
  },
  {
    "inf": [
      "A Series of Ru-MOFs with Different Length Nitrogen-based Heterocyclic Ligands: Structural Characterization and CO<sub>2</sub> Adsorption Capacity",
      "(<sup>1</sup>Tokyo Tech, <sup>2</sup>ENEOS Corporation) ★Wang Zhang<sup>1</sup>, Hiroyoshi Ohtsu<sup>1</sup>, Pavel M. Usov<sup>1</sup>, Takaya Matsumoto<sup>1,2</sup>, Masaki Kawano<sup>1</sup>"
    ],
    "lab": "1Ac-04",
    "pdf": "pdf/1Ac-04.pdf",
    "pre": "tn/1Ac-04.jpg",
    "reg": "74471",
    "sea": "Ru",
    "ses": "1Ac",
    "con": "1Ac-04 A Series of Ru-MOFs with Different Length Nitrogen-based Heterocyclic Ligands: Structural Characterization and CO<sub>2</sub> Adsorption Capacity (<sup>1</sup>Tokyo Tech, <sup>2</sup>ENEOS Corporation) ★Wang Zhang<sup>1</sup>, Hiroyoshi Ohtsu<sup>1</sup>, Pavel M. Usov<sup>1</sup>, Takaya Matsumoto<sup>1,2</sup>, Masaki Kawano<sup>1</sup> Ru"
  },
  {
    "inf": [
      "Unveiling the Potential of Novel Silver and Copper Cluster-based Metal-Organic Frameworks for Diverse Applications",
      "(<sup>1</sup>Graduate School of Science, Tokyo Univ. of Science, <sup>2</sup>Tokyo Univ. of Science, <sup>3</sup>Institute of Multidisciplinary Research for Advanced Materials, Tohoku Univ.) ★Riki NAKATANI<sup>1</sup>, Jin SAKAI<sup>1</sup>, Sourav BISWAS<sup>1</sup>, Tsukasa IRIE<sup>1</sup>, Rina TOMIOKA<sup>1</sup>, Ayumu KONDO<sup>2</sup>, Yoshiki NIIHORI<sup>1</sup>, Saikat DAS<sup>1</sup>, Yuichi NEGISHI<sup>1,2,3</sup>"
    ],
    "lab": "1Ac-05",
    "pdf": "pdf/1Ac-05.pdf",
    "pre": "tn/1Ac-05.jpg",
    "reg": "74159",
    "sea": "Ag,Cu",
    "ses": "1Ac",
    "con": "1Ac-05 Unveiling the Potential of Novel Silver and Copper Cluster-based Metal-Organic Frameworks for Diverse Applications (<sup>1</sup>Graduate School of Science, Tokyo Univ. of Science, <sup>2</sup>Tokyo Univ. of Science, <sup>3</sup>Institute of Multidisciplinary Research for Advanced Materials, Tohoku Univ.) ★Riki NAKATANI<sup>1</sup>, Jin SAKAI<sup>1</sup>, Sourav BISWAS<sup>1</sup>, Tsukasa IRIE<sup>1</sup>, Rina TOMIOKA<sup>1</sup>, Ayumu KONDO<sup>2</sup>, Yoshiki NIIHORI<sup>1</sup>, Saikat DAS<sup>1</sup>, Yuichi NEGISHI<sup>1,2,3</sup> Ag,Cu"
  },
  {
    "inf": [
      "Synthesis, Structure, and Gas Adsorption Property of a Dinuclear Complex with Tungsten–Silicon Double Bonds Linked by Oligosiloxanes",
      "(<sup>1</sup>Tohoku Univ., <sup>2</sup>Interdisciplinary Research Center for Catalytic Chemistry, National Institute of Advanced Industrial Science and Technology (AIST), <sup>3</sup>Institute for Materials Research, Tohoku University) ★Ryo Nakamura<sup>1</sup>, Koichi Nagata<sup>1</sup>, Takahiro Kawatsu<sup>2</sup>, Kazuhiro Matsumoto<sup>2</sup>, Yumiko Nakajima<sup>2</sup>, Wataru Kosaka<sup>3</sup>, Hitoshi Miyasaka<sup>3</sup>, Hisako Hashimoto<sup>1</sup>"
    ],
    "lab": "1Ac-06",
    "pdf": "pdf/1Ac-06.pdf",
    "pre": "tn/1Ac-06.jpg",
    "reg": "74217",
    "sea": "W",
    "ses": "1Ac",
    "con": "1Ac-06 Synthesis, Structure, and Gas Adsorption Property of a Dinuclear Complex with Tungsten–Silicon Double Bonds Linked by Oligosiloxanes (<sup>1</sup>Tohoku Univ., <sup>2</sup>Interdisciplinary Research Center for Catalytic Chemistry, National Institute of Advanced Industrial Science and Technology (AIST), <sup>3</sup>Institute for Materials Research, Tohoku University) ★Ryo Nakamura<sup>1</sup>, Koichi Nagata<sup>1</sup>, Takahiro Kawatsu<sup>2</sup>, Kazuhiro Matsumoto<sup>2</sup>, Yumiko Nakajima<sup>2</sup>, Wataru Kosaka<sup>3</sup>, Hitoshi Miyasaka<sup>3</sup>, Hisako Hashimoto<sup>1</sup> W"
  },
  {
    "inf": [
      "高濃度ゼラチンを用いたダブルジェット法による単斜晶Cu-BTCの合成",
      "(<sup>1</sup>長岡技科大) 〇梅田 大輝<sup>1</sup>・高橋 由紀子<sup>1</sup>",
      "Synthesis of monoclinic Cu-BTC by double-jet method in high-concentration gelatin solutions",
      "(<sup>1</sup>Nagaoka Univ. Tech.) 〇Hiroki UMEDA<sup>1</sup>, Yukiko TAKAHASHI<sup>1</sup>"
    ],
    "lab": "1Ac-07",
    "pdf": "pdf/1Ac-07.pdf",
    "pre": "tn/1Ac-07.jpg",
    "reg": "74073",
    "sea": "Cu",
    "ses": "1Ac",
    "con": "1Ac-07 高濃度ゼラチンを用いたダブルジェット法による単斜晶Cu-BTCの合成 (<sup>1</sup>長岡技科大) 〇梅田 大輝<sup>1</sup>・高橋 由紀子<sup>1</sup> Synthesis of monoclinic Cu-BTC by double-jet method in high-concentration gelatin solutions (<sup>1</sup>Nagaoka Univ. Tech.) 〇Hiroki UMEDA<sup>1</sup>, Yukiko TAKAHASHI<sup>1</sup> Cu"
  },
  {
    "inf": [
      "Variation of Gate-opening Adsorption Properties of Kagome-type MOFs with Branched Alkoxy Groups Depending on Synthetic Conditions",
      "(<sup>1</sup>Nagoya Univ.) ★Yukino TAKEUCHI<sup></sup>, Jenny PIRILLO<sup></sup>, Liyuan QU<sup></sup>, Shinpei KUSAKA<sup></sup>, Yuh HIJIKATA<sup></sup>, Hiroaki IGUCHI<sup></sup>, Ryotaro MATSUDA<sup></sup>"
    ],
    "lab": "1Ac-08",
    "pdf": "pdf/1Ac-08.pdf",
    "pre": "tn/1Ac-08.jpg",
    "reg": "74527",
    "sea": "Cu",
    "ses": "1Ac",
    "con": "1Ac-08 Variation of Gate-opening Adsorption Properties of Kagome-type MOFs with Branched Alkoxy Groups Depending on Synthetic Conditions (<sup>1</sup>Nagoya Univ.) ★Yukino TAKEUCHI<sup></sup>, Jenny PIRILLO<sup></sup>, Liyuan QU<sup></sup>, Shinpei KUSAKA<sup></sup>, Yuh HIJIKATA<sup></sup>, Hiroaki IGUCHI<sup></sup>, Ryotaro MATSUDA<sup></sup> Cu"
  },
  {
    "inf": [
      "Impact of Scaffold Design on Formation and Growth of Small Silver Clusters in Porous Ionic Crystals",
      "(<sup>1</sup>Sch. of Arts and Sci., The Univ. of Tokyo) ★Naoya HARAGUCHI<sup>1</sup>, Taisei KUROSAKI<sup>1</sup>, Sayaka UCHIDA<sup>1</sup>"
    ],
    "lab": "1Ad-05",
    "pdf": "pdf/1Ad-05.pdf",
    "pre": "tn/1Ad-05.jpg",
    "reg": "74342",
    "sea": "Ag, Mo, W",
    "ses": "1Ad",
    "con": "1Ad-05 Impact of Scaffold Design on Formation and Growth of Small Silver Clusters in Porous Ionic Crystals (<sup>1</sup>Sch. of Arts and Sci., The Univ. of Tokyo) ★Naoya HARAGUCHI<sup>1</sup>, Taisei KUROSAKI<sup>1</sup>, Sayaka UCHIDA<sup>1</sup> Ag, Mo, W"
  },
  {
    "inf": [
      "Phosphatase Inhibitor Effect of Polyoxovanadates with Alkali and Alkali Earth Metal Cations",
      "(<sup>1</sup>Graduate School of Natural Science, Kanazawa University) ★Iqbal Aulia Fajri<sup>1</sup>, Yuji Kikukawa<sup>1</sup>, Yoshihito Hayashi<sup>1</sup>"
    ],
    "lab": "1Ad-06",
    "pdf": "pdf/1Ad-06.pdf",
    "pre": "tn/1Ad-06.jpg",
    "reg": "74083",
    "sea": "Phosphatase Inhibitor",
    "ses": "1Ad",
    "con": "1Ad-06 Phosphatase Inhibitor Effect of Polyoxovanadates with Alkali and Alkali Earth Metal Cations (<sup>1</sup>Graduate School of Natural Science, Kanazawa University) ★Iqbal Aulia Fajri<sup>1</sup>, Yuji Kikukawa<sup>1</sup>, Yoshihito Hayashi<sup>1</sup> Phosphatase Inhibitor"
  },
  {
    "inf": [
      "Development of Porphyrin–Polyoxometalate Molecular Hybrid Photocatalysts with High Activity and Durability",
      "(<sup>1</sup>School of Engineering, The University of Tokyo, <sup>2</sup>Institute of Industrial Science, The University of Tokyo) ★Masahiro YAMAGUCHI<sup>1</sup>, Kaito SHIOYA<sup>1</sup>, Chifeng LI<sup>1</sup>, Kentaro YONESATO<sup>1</sup>, Kei MURATA<sup>2</sup>, Kazuyuki ISHII<sup>2</sup>, Kosuke SUZUKI<sup>1</sup>, Kazuya YAMAGUCHI<sup>1</sup>"
    ],
    "lab": "1Ad-07",
    "pdf": "pdf/1Ad-07.pdf",
    "pre": "tn/1Ad-07.jpg",
    "reg": "74462",
    "sea": "W",
    "ses": "1Ad",
    "con": "1Ad-07 Development of Porphyrin–Polyoxometalate Molecular Hybrid Photocatalysts with High Activity and Durability (<sup>1</sup>School of Engineering, The University of Tokyo, <sup>2</sup>Institute of Industrial Science, The University of Tokyo) ★Masahiro YAMAGUCHI<sup>1</sup>, Kaito SHIOYA<sup>1</sup>, Chifeng LI<sup>1</sup>, Kentaro YONESATO<sup>1</sup>, Kei MURATA<sup>2</sup>, Kazuyuki ISHII<sup>2</sup>, Kosuke SUZUKI<sup>1</sup>, Kazuya YAMAGUCHI<sup>1</sup> W"
  },
  {
    "inf": [
      "ポスト金属イオン置換によるヘテロ金属酸化物クラスターの合成とその形成機構",
      "(<sup>1</sup>東工大物質・<sup>2</sup>東工大化生研・<sup>3</sup>東工大ASMat) 〇齋藤 貴則<sup>1,2</sup>・伊藤 圭亮<sup>1,2</sup>・嘉藤 幹也<sup>1,2</sup>・福井 智也<sup>1,2,3</sup>・福島 孝典<sup>1,2,3</sup>",
      "Synthesis and formation mechanism of hetero-metal-oxo clusters by a post-metal-ion-substitution reaction",
      "(<sup>1</sup>Sch. Mater. Chem. Tech., Tokyo Tech., <sup>2</sup>CLS, Tokyo Tech., <sup>3</sup>ASMat, Tokyo Tech.) 〇Takanori SAITO<sup>1,2</sup>, Keisuke ITO<sup>1,2</sup>, Mikiya KATO<sup>1,2</sup>, Tomoya FUKUI<sup>1,2,3</sup>, Takanori FUKUSHIMA<sup>1,2,3</sup>"
    ],
    "lab": "1Ad-08",
    "pdf": "pdf/1Ad-08.pdf",
    "pre": "tn/1Ad-08.jpg",
    "reg": "74153",
    "sea": "Co, Zn",
    "ses": "1Ad",
    "con": "1Ad-08 ポスト金属イオン置換によるヘテロ金属酸化物クラスターの合成とその形成機構 (<sup>1</sup>東工大物質・<sup>2</sup>東工大化生研・<sup>3</sup>東工大ASMat) 〇齋藤 貴則<sup>1,2</sup>・伊藤 圭亮<sup>1,2</sup>・嘉藤 幹也<sup>1,2</sup>・福井 智也<sup>1,2,3</sup>・福島 孝典<sup>1,2,3</sup> Synthesis and formation mechanism of hetero-metal-oxo clusters by a post-metal-ion-substitution reaction (<sup>1</sup>Sch. Mater. Chem. Tech., Tokyo Tech., <sup>2</sup>CLS, Tokyo Tech., <sup>3</sup>ASMat, Tokyo Tech.) 〇Takanori SAITO<sup>1,2</sup>, Keisuke ITO<sup>1,2</sup>, Mikiya KATO<sup>1,2</sup>, Tomoya FUKUI<sup>1,2,3</sup>, Takanori FUKUSHIMA<sup>1,2,3</sup> Co, Zn"
  },
  {
    "inf": [
      "Enhanced Luminescence of Mixed Crystals of Pt(II)/Pd(II) Complexes with Unusual Thermal Effects",
      "(<sup>1</sup>Kwansei Gakuin University School of Biological and Environmental Sciences Department of Applied Chemistry for Environment, <sup>2</sup>Hokkaido University Faculty of Information Science and Technology) ★Kaito SEGAWA<sup>1</sup>, Masaki YOSHIDA<sup>1</sup>, Junichi TAKAYAMA<sup>2</sup>, Satoshi HIURA<sup>2</sup>, Hiroto KISE<sup>2</sup>, Akihiro MURAYAMA<sup>2</sup>, Masako KATO<sup>1</sup>"
    ],
    "lab": "1B-02",
    "pdf": "pdf/1B-02.pdf",
    "pre": "tn/1B-02.jpg",
    "reg": "74072",
    "sea": "Pt, Pd",
    "ses": "1B",
    "con": "1B-02 Enhanced Luminescence of Mixed Crystals of Pt(II)/Pd(II) Complexes with Unusual Thermal Effects (<sup>1</sup>Kwansei Gakuin University School of Biological and Environmental Sciences Department of Applied Chemistry for Environment, <sup>2</sup>Hokkaido University Faculty of Information Science and Technology) ★Kaito SEGAWA<sup>1</sup>, Masaki YOSHIDA<sup>1</sup>, Junichi TAKAYAMA<sup>2</sup>, Satoshi HIURA<sup>2</sup>, Hiroto KISE<sup>2</sup>, Akihiro MURAYAMA<sup>2</sup>, Masako KATO<sup>1</sup> Pt, Pd"
  },
  {
    "inf": [
      "Mechanical and Thermal ON−OFF Switching of the Vapochromic Behavior of a Luminescent          Polymorphic Pt(II) Complex",
      "(<sup>1</sup>NanoMaterials Research Institute, Kanazawa Univ., <sup>2</sup>Graduate School of Natural Science and Technology, Kanazawa Univ., <sup>3</sup>Department of Applied Chemistry for Environment, School of Biological and Environmental Sciences, Kwansei Gakuin Univ.) 〇Yasuhiro SHIGETA<sup>1,2</sup>, Tatsuya NOMOTO<sup>2</sup>, Masako KATO<sup>3</sup>, Motohiro MIZUNO<sup>1,2</sup>"
    ],
    "lab": "1B-03",
    "pdf": "pdf/1B-03.pdf",
    "pre": "tn/1B-03.jpg",
    "reg": "74196",
    "sea": "Pt",
    "ses": "1B",
    "con": "1B-03 Mechanical and Thermal ON−OFF Switching of the Vapochromic Behavior of a Luminescent          Polymorphic Pt(II) Complex (<sup>1</sup>NanoMaterials Research Institute, Kanazawa Univ., <sup>2</sup>Graduate School of Natural Science and Technology, Kanazawa Univ., <sup>3</sup>Department of Applied Chemistry for Environment, School of Biological and Environmental Sciences, Kwansei Gakuin Univ.) 〇Yasuhiro SHIGETA<sup>1,2</sup>, Tatsuya NOMOTO<sup>2</sup>, Masako KATO<sup>3</sup>, Motohiro MIZUNO<sup>1,2</sup> Pt"
  },
  {
    "inf": [
      "Energy Transfer Between Lanthanides in Luminescent Tb(III)-Nd(III) Mixed Complexes",
      "(<sup>1</sup>Graduate School of Chemical Sciences and Engineering, Hokkaido Univ., <sup>2</sup>Faculty of Engineering, Hokkaido Univ., <sup>3</sup>WPI-ICReDD, Hokkaido Univ.) ★Yusaku YAMAGUCHI<sup>1</sup>, Takuma NAKAI<sup>1</sup>, Mengfei WANG<sup>2,3</sup>, Yasuchika HASEGAWA<sup>2,3</sup>, Yuichi KITAGAWA<sup>2,3</sup>"
    ],
    "lab": "1B-04",
    "pdf": "pdf/1B-04.pdf",
    "pre": "tn/1B-04.jpg",
    "reg": "74460",
    "sea": "Tb, Nd",
    "ses": "1B",
    "con": "1B-04 Energy Transfer Between Lanthanides in Luminescent Tb(III)-Nd(III) Mixed Complexes (<sup>1</sup>Graduate School of Chemical Sciences and Engineering, Hokkaido Univ., <sup>2</sup>Faculty of Engineering, Hokkaido Univ., <sup>3</sup>WPI-ICReDD, Hokkaido Univ.) ★Yusaku YAMAGUCHI<sup>1</sup>, Takuma NAKAI<sup>1</sup>, Mengfei WANG<sup>2,3</sup>, Yasuchika HASEGAWA<sup>2,3</sup>, Yuichi KITAGAWA<sup>2,3</sup> Tb, Nd"
  },
  {
    "inf": [
      "長鎖重水素化アルキル基を導入した白金-ヨウ素擬一次元錯体 [Pt(en)<sub>2</sub>I] (L-Asp-<sup>17D</sup>C8)<sub>2</sub>・H<sub>2</sub>Oの電子状態",
      "(<sup>1</sup>東北大・理・<sup>2</sup>千歳科技大・理工・<sup>3</sup>名古屋大・工) 〇船越 伸斗<sup>1</sup>・高石 慎也<sup>1</sup>・<sup>1</sup>・脇坂 聖憲<sup>2</sup>・井口 弘章<sup>3</sup>・伊東 裕<sup>3</sup>・山下 正廣<sup>1</sup>",
      "The electronic state of 1D Iodine bridged Pt complexes with deuterio long alkyl derivatives ",
      "(<sup>1</sup>Graduate School of Science, Tohoku University, <sup>2</sup>Chitose Institute of Science and Technology, <sup>3</sup>Graduate School of  Engineering, Nagoya University) 〇Nobuto Funakoshi<sup>1</sup>, Shinya Takaishi<sup>1</sup>, Min Seob Shin<sup>1</sup>, Masanori Wakizaka<sup>2</sup>, Hiroaki Iguchi<sup>3</sup>, Hiroshi Ito<sup>3</sup>, Masahiro Yamashita<sup>1</sup>"
    ],
    "lab": "1B-05",
    "pdf": "pdf/1B-05.pdf",
    "pre": "tn/1B-05.jpg",
    "reg": "74203",
    "sea": "Pt",
    "ses": "1B",
    "con": "1B-05 長鎖重水素化アルキル基を導入した白金-ヨウ素擬一次元錯体 [Pt(en)<sub>2</sub>I] (L-Asp-<sup>17D</sup>C8)<sub>2</sub>・H<sub>2</sub>Oの電子状態 (<sup>1</sup>東北大・理・<sup>2</sup>千歳科技大・理工・<sup>3</sup>名古屋大・工) 〇船越 伸斗<sup>1</sup>・高石 慎也<sup>1</sup>・<sup>1</sup>・脇坂 聖憲<sup>2</sup>・井口 弘章<sup>3</sup>・伊東 裕<sup>3</sup>・山下 正廣<sup>1</sup> The electronic state of 1D Iodine bridged Pt complexes with deuterio long alkyl derivatives  (<sup>1</sup>Graduate School of Science, Tohoku University, <sup>2</sup>Chitose Institute of Science and Technology, <sup>3</sup>Graduate School of  Engineering, Nagoya University) 〇Nobuto Funakoshi<sup>1</sup>, Shinya Takaishi<sup>1</sup>, Min Seob Shin<sup>1</sup>, Masanori Wakizaka<sup>2</sup>, Hiroaki Iguchi<sup>3</sup>, Hiroshi Ito<sup>3</sup>, Masahiro Yamashita<sup>1</sup> Pt"
  },
  {
    "inf": [
      "ポルフィリン系弾性結晶の温度低下に伴う軟化挙動とピンポイント構造計測によるキャラクタリゼーション",
      "(<sup>1</sup>奈良女大院・<sup>2</sup>高輝度光科学研究センター) 〇加藤 日菜子<sup>1</sup>・堀井 洋司<sup>1</sup>・佐々木 俊之<sup>2</sup>・一柳 光平<sup>2</sup>・梶原 孝志<sup>1</sup>",
      "Softening behavior of a porphyrin-based elastic crystal upon cooling and characterization by pinpoint X-ray structural crystallography",
      "(<sup>1</sup>Nara Women's University, <sup>2</sup>JASRI) 〇Hinako KATO<sup>1</sup>, Yoji HORII<sup>1</sup>, Toshiyuki SASAKI<sup>2</sup>, Kohei ICHIYANAGI<sup>2</sup>, Takashi KAJIWARA<sup>1</sup>"
    ],
    "lab": "1B-06",
    "pdf": "pdf/1B-06.pdf",
    "pre": "tn/1B-06.jpg",
    "reg": "74297",
    "sea": "Ni",
    "ses": "1B",
    "con": "1B-06 ポルフィリン系弾性結晶の温度低下に伴う軟化挙動とピンポイント構造計測によるキャラクタリゼーション (<sup>1</sup>奈良女大院・<sup>2</sup>高輝度光科学研究センター) 〇加藤 日菜子<sup>1</sup>・堀井 洋司<sup>1</sup>・佐々木 俊之<sup>2</sup>・一柳 光平<sup>2</sup>・梶原 孝志<sup>1</sup> Softening behavior of a porphyrin-based elastic crystal upon cooling and characterization by pinpoint X-ray structural crystallography (<sup>1</sup>Nara Women's University, <sup>2</sup>JASRI) 〇Hinako KATO<sup>1</sup>, Yoji HORII<sup>1</sup>, Toshiyuki SASAKI<sup>2</sup>, Kohei ICHIYANAGI<sup>2</sup>, Takashi KAJIWARA<sup>1</sup> Ni"
  },
  {
    "inf": [
      "Synthesis of N<sub>2</sub>-type superatomic molecules",
      "(<sup>1</sup>Institute for Chemical Research, Kyoto University, <sup>2</sup>Graduate School of Engineering, Kyoto University) 〇Katsuhiro Isozaki<sup>1,2</sup>, Ryohei Saito<sup>1,2</sup>, Yoshiyuki Mizuhata<sup>1</sup>, Masaharu Nakamura<sup>1,2</sup>"
    ],
    "lab": "1B-07",
    "pdf": "pdf/1B-07.pdf",
    "pre": "tn/1B-07.jpg",
    "reg": "74031",
    "sea": "Au, Pd, Pt",
    "ses": "1B",
    "con": "1B-07 Synthesis of N<sub>2</sub>-type superatomic molecules (<sup>1</sup>Institute for Chemical Research, Kyoto University, <sup>2</sup>Graduate School of Engineering, Kyoto University) 〇Katsuhiro Isozaki<sup>1,2</sup>, Ryohei Saito<sup>1,2</sup>, Yoshiyuki Mizuhata<sup>1</sup>, Masaharu Nakamura<sup>1,2</sup> Au, Pd, Pt"
  },
  {
    "inf": [
      "Dinuclear Cu(I) molecular catalyst for CO<sub>2</sub>/CO-to-C<sub>3+</sub> product electrochemical conversion",
      "(<sup>1</sup>Toyota Central R&D Labs., Inc.) 〇Naonari Sakamoto<sup>1</sup>, Keita Sekizawa<sup>1</sup>, Soichi Shirai<sup>1</sup>, Takamasa Nonaka<sup>1</sup>, Takeo Arai<sup>1</sup>, Shunsuke Sato<sup>1</sup>, Takeshi Morikawa<sup>1</sup>"
    ],
    "lab": "1C-02",
    "pdf": "pdf/1C-02.pdf",
    "pre": "tn/1C-02.jpg",
    "reg": "74020",
    "sea": "Cu",
    "ses": "1C",
    "con": "1C-02 Dinuclear Cu(I) molecular catalyst for CO<sub>2</sub>/CO-to-C<sub>3+</sub> product electrochemical conversion (<sup>1</sup>Toyota Central R&D Labs., Inc.) 〇Naonari Sakamoto<sup>1</sup>, Keita Sekizawa<sup>1</sup>, Soichi Shirai<sup>1</sup>, Takamasa Nonaka<sup>1</sup>, Takeo Arai<sup>1</sup>, Shunsuke Sato<sup>1</sup>, Takeshi Morikawa<sup>1</sup> Cu"
  },
  {
    "inf": [
      "On the possibility of heterolytic methane hydroxylation in copper zeolites",
      "(<sup>1</sup>Nagoya University, <sup>2</sup>KU Leuven) 〇Quan Manh Phung<sup>1</sup>, Takeshi Yanai<sup>1</sup>, Dieter Plessers<sup>2</sup>, Bert F. Sels<sup>2</sup>, Robert A. Schoonheydt<sup>2</sup>, Kristine Pierloot<sup>2</sup>"
    ],
    "lab": "1C-03",
    "pdf": "pdf/1C-03.pdf",
    "pre": "tn/1C-03.jpg",
    "reg": "74009",
    "sea": "Cu",
    "ses": "1C",
    "con": "1C-03 On the possibility of heterolytic methane hydroxylation in copper zeolites (<sup>1</sup>Nagoya University, <sup>2</sup>KU Leuven) 〇Quan Manh Phung<sup>1</sup>, Takeshi Yanai<sup>1</sup>, Dieter Plessers<sup>2</sup>, Bert F. Sels<sup>2</sup>, Robert A. Schoonheydt<sup>2</sup>, Kristine Pierloot<sup>2</sup> Cu"
  },
  {
    "inf": [
      "Mechanistic insights into specific acceleration of H<sub>2</sub>O<sub>2</sub> activation and alkane oxidation by a series of monocopper complexes with Rdpa tridentate ligands",
      "(<sup>1</sup>Doshisha Univ.) 〇Kyosuke Fujikawa <sup>1</sup>, Hiroaki Kitagishi<sup>1</sup>, Masahito Kodera<sup>1</sup>"
    ],
    "lab": "1C-04",
    "pdf": "pdf/1C-04.pdf",
    "pre": "tn/1C-04.jpg",
    "reg": "74595",
    "sea": "Cu",
    "ses": "1C",
    "con": "1C-04 Mechanistic insights into specific acceleration of H<sub>2</sub>O<sub>2</sub> activation and alkane oxidation by a series of monocopper complexes with Rdpa tridentate ligands (<sup>1</sup>Doshisha Univ.) 〇Kyosuke Fujikawa <sup>1</sup>, Hiroaki Kitagishi<sup>1</sup>, Masahito Kodera<sup>1</sup> Cu"
  },
  {
    "inf": [
      "CO<sub>2</sub> to CH<sub>4</sub> conversion catalyzed by a [Mo<sub>3</sub>S<sub>4</sub>Fe] cluster",
      "(<sup>1</sup>ICR, Kyoto U., <sup>2</sup>Dept. Chem. & Mol. Biol. U. Gothenburg) ★Yuto MATSUOKA<sup>1</sup>, W. M. C. SAMEERA<sup>2</sup>, Kazuki TANIFUJI<sup>1</sup>, Yasuhiro OHKI<sup>1</sup>"
    ],
    "lab": "1C-05",
    "pdf": "pdf/1C-05.pdf",
    "pre": "tn/1C-05.jpg",
    "reg": "74155",
    "sea": "Fe, Mo",
    "ses": "1C",
    "con": "1C-05 CO<sub>2</sub> to CH<sub>4</sub> conversion catalyzed by a [Mo<sub>3</sub>S<sub>4</sub>Fe] cluster (<sup>1</sup>ICR, Kyoto U., <sup>2</sup>Dept. Chem. & Mol. Biol. U. Gothenburg) ★Yuto MATSUOKA<sup>1</sup>, W. M. C. SAMEERA<sup>2</sup>, Kazuki TANIFUJI<sup>1</sup>, Yasuhiro OHKI<sup>1</sup> Fe, Mo"
  },
  {
    "inf": [
      "Visible-Light-Driven Carboxylation of Phenyl Vinyl Sulfone Using CO<SUB>2</SUB> Catalyzed by Re Complexes",
      "(<sup>1</sup>Osaka Univ., <sup>2</sup>Tokyo Institute of Technology) ★Phurinat LORWONGKAMOL<sup>1</sup>, Taito WATANABE<sup>1</sup>, Masaki KITADA<sup>1,2</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "1C-06",
    "pdf": "pdf/1C-06.pdf",
    "pre": "tn/1C-06.jpg",
    "reg": "74279",
    "sea": "Re",
    "ses": "1C",
    "con": "1C-06 Visible-Light-Driven Carboxylation of Phenyl Vinyl Sulfone Using CO<SUB>2</SUB> Catalyzed by Re Complexes (<sup>1</sup>Osaka Univ., <sup>2</sup>Tokyo Institute of Technology) ★Phurinat LORWONGKAMOL<sup>1</sup>, Taito WATANABE<sup>1</sup>, Masaki KITADA<sup>1,2</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup> Re"
  },
  {
    "inf": [
      "Photocatalytic CO<sub>2</sub> reduction using a Ru(II) complex catalyst with a bidentate phosphine ligand",
      "(<sup>1</sup>Tokyo Tech., <sup>2</sup>Hiroshima Univ.) 〇Naoki HOSOKAWA<sup>1</sup>, Osamu ISHITANI<sup>2</sup>"
    ],
    "lab": "1C-07",
    "pdf": "pdf/1C-07.pdf",
    "pre": "tn/1C-07.jpg",
    "reg": "74579",
    "sea": "Ru",
    "ses": "1C",
    "con": "1C-07 Photocatalytic CO<sub>2</sub> reduction using a Ru(II) complex catalyst with a bidentate phosphine ligand (<sup>1</sup>Tokyo Tech., <sup>2</sup>Hiroshima Univ.) 〇Naoki HOSOKAWA<sup>1</sup>, Osamu ISHITANI<sup>2</sup> Ru"
  },
  {
    "inf": [
      "A Novel Platinum-Dimer-Based Hydrogen-Evolving Molecular Photocatalyst Showing High Durability and Red-Light-Responsivity",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ. , <sup>2</sup>Dept. Chem. Ottawa Univ.) ★Toma KUNIKUBO<sup>1</sup>, Jaclyn BRUSSO<sup>2</sup>, Muralee MURUGESU<sup>2</sup>, Kosei YAMAUCHI<sup>1</sup>, Hironobu OZAWA<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "1C-08",
    "pdf": "pdf/1C-08.pdf",
    "pre": "tn/1C-08.jpg",
    "reg": "74178",
    "sea": "Pt",
    "ses": "1C",
    "con": "1C-08 A Novel Platinum-Dimer-Based Hydrogen-Evolving Molecular Photocatalyst Showing High Durability and Red-Light-Responsivity (<sup>1</sup>Dept. Chem. Kyushu Univ. , <sup>2</sup>Dept. Chem. Ottawa Univ.) ★Toma KUNIKUBO<sup>1</sup>, Jaclyn BRUSSO<sup>2</sup>, Muralee MURUGESU<sup>2</sup>, Kosei YAMAUCHI<sup>1</sup>, Hironobu OZAWA<sup>1</sup>, Ken SAKAI<sup>1</sup> Pt"
  },
  {
    "inf": [
      "Synthesis and Reactivity of Nickel–Rhodium Bimetallic Complexes",
      "(<sup>1</sup>Kyoto Univ.) ★Kouki FUJITA<sup></sup>, Kazuhiko SEMBA<sup></sup>, Yoshiaki NAKAO<sup></sup>"
    ],
    "lab": "1D-02",
    "pdf": "pdf/1D-02.pdf",
    "pre": "tn/1D-02.jpg",
    "reg": "74052",
    "sea": "Ni, Rh",
    "ses": "1D",
    "con": "1D-02 Synthesis and Reactivity of Nickel–Rhodium Bimetallic Complexes (<sup>1</sup>Kyoto Univ.) ★Kouki FUJITA<sup></sup>, Kazuhiko SEMBA<sup></sup>, Yoshiaki NAKAO<sup></sup> Ni, Rh"
  },
  {
    "inf": [
      "Optical dynamics of the photoinduced phase transition in cyanido-bridged Co-W assemblies",
      "(<sup>1</sup>Univ. of Tokyo, <sup>2</sup>Univ. de Rennes, <sup>3</sup>DYNACOM IRL2015 Univ. of Tokyo - CNRS - Univ. de Rennes) ★Kazuki Nakamura<sup>1,3</sup>, Gaël Privault<sup>2,3</sup>, Laurent Guérin<sup>2,3</sup>, Koji Nakabayashi<sup>1,3</sup>, Marius Hervé<sup>2,3</sup>, Eric Collet<sup>2,3</sup>, Shin-ichi Ohkoshi<sup>1,3</sup>"
    ],
    "lab": "1D-03",
    "pdf": "pdf/1D-03.pdf",
    "pre": "tn/1D-03.jpg",
    "reg": "74071",
    "sea": "Co, W",
    "ses": "1D",
    "con": "1D-03 Optical dynamics of the photoinduced phase transition in cyanido-bridged Co-W assemblies (<sup>1</sup>Univ. of Tokyo, <sup>2</sup>Univ. de Rennes, <sup>3</sup>DYNACOM IRL2015 Univ. of Tokyo - CNRS - Univ. de Rennes) ★Kazuki Nakamura<sup>1,3</sup>, Gaël Privault<sup>2,3</sup>, Laurent Guérin<sup>2,3</sup>, Koji Nakabayashi<sup>1,3</sup>, Marius Hervé<sup>2,3</sup>, Eric Collet<sup>2,3</sup>, Shin-ichi Ohkoshi<sup>1,3</sup> Co, W"
  },
  {
    "inf": [
      "タングステン触媒を用いたアゾベンゼンと二種のアルキンの三成分カップリング反応による多置換ピロール誘導体の合成",
      "(<sup>1</sup>阪大院基礎工・<sup>2</sup>阪大院工) 〇笠原 汰央<sup>1</sup>・秋山 拓弥<sup>1</sup>・草本 哲郎<sup>1</sup>・劒 隼人<sup>2</sup>",
      "Synthesis of Multi-substituted Pyrrole Derivatives via Three-Component Coupling Reaction of Azobenzene and Two Different Alkynes Catalyzed by Tungsten Complexes",
      "(<sup>1</sup>Graduate School of Engineering Science, Osaka University, <sup>2</sup>Graduate School of Engineering, Osaka University) 〇Tao KASAHARA<sup>1</sup>, Takuya AKIYAMA<sup>1</sup>, Tetsuro KUSAMOTO<sup>1</sup>, Hayato TSURUGI<sup>2</sup>"
    ],
    "lab": "1D-04",
    "pdf": "pdf/1D-04.pdf",
    "pre": "tn/1D-04.jpg",
    "reg": "74281",
    "sea": "W",
    "ses": "1D",
    "con": "1D-04 タングステン触媒を用いたアゾベンゼンと二種のアルキンの三成分カップリング反応による多置換ピロール誘導体の合成 (<sup>1</sup>阪大院基礎工・<sup>2</sup>阪大院工) 〇笠原 汰央<sup>1</sup>・秋山 拓弥<sup>1</sup>・草本 哲郎<sup>1</sup>・劒 隼人<sup>2</sup> Synthesis of Multi-substituted Pyrrole Derivatives via Three-Component Coupling Reaction of Azobenzene and Two Different Alkynes Catalyzed by Tungsten Complexes (<sup>1</sup>Graduate School of Engineering Science, Osaka University, <sup>2</sup>Graduate School of Engineering, Osaka University) 〇Tao KASAHARA<sup>1</sup>, Takuya AKIYAMA<sup>1</sup>, Tetsuro KUSAMOTO<sup>1</sup>, Hayato TSURUGI<sup>2</sup> W"
  },
  {
    "inf": [
      "Development of Samarium Complexes as PCET Catalysts toward Molybdenum-Catalyzed Nitrogen Fixation",
      "(<sup>1</sup>Graduate School of Engineering, The University of Tokyo) ★Taichi MITSUMOTO<sup>1</sup>, Yoshiaki NISHIBAYASHI<sup>1</sup>"
    ],
    "lab": "1D-05",
    "pdf": "pdf/1D-05.pdf",
    "pre": "tn/1D-05.jpg",
    "reg": "74388",
    "sea": "Sm, Mo",
    "ses": "1D",
    "con": "1D-05 Development of Samarium Complexes as PCET Catalysts toward Molybdenum-Catalyzed Nitrogen Fixation (<sup>1</sup>Graduate School of Engineering, The University of Tokyo) ★Taichi MITSUMOTO<sup>1</sup>, Yoshiaki NISHIBAYASHI<sup>1</sup> Sm, Mo"
  },
  {
    "inf": [
      "Properties and Reactivities of Nickel Complexes Bearing a Phenalenyl-Based Tridentate Ligand",
      "(<sup>1</sup>Graduate School of Engineering, Osaka Univ., <sup>2</sup>ICS-OTRI, Osaka Univ., <sup>3</sup>Tokyo Metropolitan Univ.) ★Hikaru NOGUCHI<sup>1</sup>, Takuya KODAMA<sup>1,2</sup>, Soichi KIKKAWA<sup>3</sup>, Seiji YAMAZOE<sup>3</sup>, Hayato TSURUGI<sup>1,2</sup>, Mamoru TOBISU<sup>1,2</sup>"
    ],
    "lab": "1D-06",
    "pdf": "pdf/1D-06.pdf",
    "pre": "tn/1D-06.jpg",
    "reg": "74156",
    "sea": "Ni",
    "ses": "1D",
    "con": "1D-06 Properties and Reactivities of Nickel Complexes Bearing a Phenalenyl-Based Tridentate Ligand (<sup>1</sup>Graduate School of Engineering, Osaka Univ., <sup>2</sup>ICS-OTRI, Osaka Univ., <sup>3</sup>Tokyo Metropolitan Univ.) ★Hikaru NOGUCHI<sup>1</sup>, Takuya KODAMA<sup>1,2</sup>, Soichi KIKKAWA<sup>3</sup>, Seiji YAMAZOE<sup>3</sup>, Hayato TSURUGI<sup>1,2</sup>, Mamoru TOBISU<sup>1,2</sup> Ni"
  },
  {
    "inf": [
      "フェナレニル骨格を基盤とする2座配位子を持つニッケル1価錯体の合成、物性、および触媒反応への応用",
      "(<sup>1</sup>阪大院工・<sup>2</sup>阪大ICS-OTRI・<sup>3</sup>都立大院理) 〇有馬 大貴<sup>1</sup>・兒玉 拓也<sup>1,2</sup>・吉川 聡一<sup>3</sup>・山添 誠司<sup>3</sup>・鳶巣 守<sup>1,2</sup>",
      "Synthesis, Properties and Catalytic Application of a Nickel(I) Complex Bearing a Phenalenyl-Based          Bidentate Ligand          ",
      "(<sup>1</sup>Graduate School of Engineering, Osaka Univ., <sup>2</sup>ICS-OTRI, Osaka Univ., <sup>3</sup>Graduate School of Science, Tokyo Metropolitan Univ.) 〇Taiki ARIMA<sup>1</sup>, Takuya KODAMA<sup>1,2</sup>, Soichi KIKKAWA<sup>3</sup>, Seiji YAMAZOE<sup>3</sup>, Mamoru TOBISU<sup>1,2</sup>"
    ],
    "lab": "1D-07",
    "pdf": "pdf/1D-07.pdf",
    "pre": "tn/1D-07.jpg",
    "reg": "74377",
    "sea": "Ni",
    "ses": "1D",
    "con": "1D-07 フェナレニル骨格を基盤とする2座配位子を持つニッケル1価錯体の合成、物性、および触媒反応への応用 (<sup>1</sup>阪大院工・<sup>2</sup>阪大ICS-OTRI・<sup>3</sup>都立大院理) 〇有馬 大貴<sup>1</sup>・兒玉 拓也<sup>1,2</sup>・吉川 聡一<sup>3</sup>・山添 誠司<sup>3</sup>・鳶巣 守<sup>1,2</sup> Synthesis, Properties and Catalytic Application of a Nickel(I) Complex Bearing a Phenalenyl-Based          Bidentate Ligand           (<sup>1</sup>Graduate School of Engineering, Osaka Univ., <sup>2</sup>ICS-OTRI, Osaka Univ., <sup>3</sup>Graduate School of Science, Tokyo Metropolitan Univ.) 〇Taiki ARIMA<sup>1</sup>, Takuya KODAMA<sup>1,2</sup>, Soichi KIKKAWA<sup>3</sup>, Seiji YAMAZOE<sup>3</sup>, Mamoru TOBISU<sup>1,2</sup> Ni"
  },
  {
    "inf": [
      "Development of a New Biosynthetic Pathway for Production of Abiotic Metalloporphyrins in _Escherichia coli_",
      "(<sup>1</sup>Graduate School of Engineering, Osaka University) ★Shunsuke KONISHI<sup>1</sup>, Shunsuke KATO<sup>1</sup>, Takashi HAYASHI<sup>1</sup>"
    ],
    "lab": "1E-02",
    "pdf": "pdf/1E-02.pdf",
    "pre": "tn/1E-02.jpg",
    "reg": "74139",
    "sea": "Co, Mn, Cu, Rh",
    "ses": "1E",
    "con": "1E-02 Development of a New Biosynthetic Pathway for Production of Abiotic Metalloporphyrins in _Escherichia coli_ (<sup>1</sup>Graduate School of Engineering, Osaka University) ★Shunsuke KONISHI<sup>1</sup>, Shunsuke KATO<sup>1</sup>, Takashi HAYASHI<sup>1</sup> Co, Mn, Cu, Rh"
  },
  {
    "inf": [
      "Development of Artificial Non-heme Metalloenzymes for Stereoselective Inverse Electron-Demand Hetero Diels-Alder Reactions",
      "(<sup>1</sup>Osaka Metro. Univ., <sup>2</sup>Osaka Pref. Univ.) ★Ryusei Matsumoto<sup>1</sup>, Saho YOSHIOKA<sup>2</sup>, Yoshitsugu MORITA<sup>1</sup>, Nobutaka FUJIEDA<sup>1,2</sup>"
    ],
    "lab": "1E-03",
    "pdf": "pdf/1E-03.pdf",
    "pre": "tn/1E-03.jpg",
    "reg": "74252",
    "sea": "Cu",
    "ses": "1E",
    "con": "1E-03 Development of Artificial Non-heme Metalloenzymes for Stereoselective Inverse Electron-Demand Hetero Diels-Alder Reactions (<sup>1</sup>Osaka Metro. Univ., <sup>2</sup>Osaka Pref. Univ.) ★Ryusei Matsumoto<sup>1</sup>, Saho YOSHIOKA<sup>2</sup>, Yoshitsugu MORITA<sup>1</sup>, Nobutaka FUJIEDA<sup>1,2</sup> Cu"
  },
  {
    "inf": [
      "Formation of Metal–CO<sub>2</sub><sup>2–</sup> Species Using H<sub>2</sub> as an Electron Source",
      "(<sup>1</sup>Grad. Sch. of Eng., Kyushu Univ., <sup>2</sup>I2CNER, <sup>3</sup>sMol, <sup>4</sup>Fac. of Sci. and Eng., Kindai Univ.) ★Daiki SHIMAUCHI<sup>1</sup>, Takeshi YATABE<sup>1,2,3</sup>, Hidetaka NAKAI<sup>4</sup>, Seiji OGO<sup>1,2,3</sup>"
    ],
    "lab": "1E-04",
    "pdf": "pdf/1E-04.pdf",
    "pre": "tn/1E-04.jpg",
    "reg": "74329",
    "sea": "Ir",
    "ses": "1E",
    "con": "1E-04 Formation of Metal–CO<sub>2</sub><sup>2–</sup> Species Using H<sub>2</sub> as an Electron Source (<sup>1</sup>Grad. Sch. of Eng., Kyushu Univ., <sup>2</sup>I2CNER, <sup>3</sup>sMol, <sup>4</sup>Fac. of Sci. and Eng., Kindai Univ.) ★Daiki SHIMAUCHI<sup>1</sup>, Takeshi YATABE<sup>1,2,3</sup>, Hidetaka NAKAI<sup>4</sup>, Seiji OGO<sup>1,2,3</sup> Ir"
  },
  {
    "inf": [
      "環状および籠状配位子内に構築した多核銅中心によるアルカンの触媒的C–H水酸化反応",
      "(<sup>1</sup>阪大院理) 〇西村 環<sup>1</sup>・水野 瑠緯<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup>",
      "Catalytic C–H Hydroxylation of Alkanes Mediated by Multicopper Centers Encapsulated in Macrocyclic or Cage-type Ligands",
      "(<sup>1</sup>Osaka Univ.) 〇Tamaki NISHIMURA<sup>1</sup>, Rui MIZUNO<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup>"
    ],
    "lab": "1E-05",
    "pdf": "pdf/1E-05.pdf",
    "pre": "tn/1E-05.jpg",
    "reg": "74142",
    "sea": "Cu",
    "ses": "1E",
    "con": "1E-05 環状および籠状配位子内に構築した多核銅中心によるアルカンの触媒的C–H水酸化反応 (<sup>1</sup>阪大院理) 〇西村 環<sup>1</sup>・水野 瑠緯<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup> Catalytic C–H Hydroxylation of Alkanes Mediated by Multicopper Centers Encapsulated in Macrocyclic or Cage-type Ligands (<sup>1</sup>Osaka Univ.) 〇Tamaki NISHIMURA<sup>1</sup>, Rui MIZUNO<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup> Cu"
  },
  {
    "inf": [
      "Fabrication of red-light responsive photosensitizer using metal-free PPIX and cytochrome c from thermophilus",
      "(<sup>1</sup>Graduate School of Science, Osaka Metropolitan Univ., <sup>2</sup>Graduate School of Science, Osaka City Univ.) 〇Hiroshi NAKAJIMA<sup>1</sup>, Makishi OHNISHI<sup>1</sup>, Kenta OHSHIMA<sup>2</sup>, Kunitaka NISHIOKA<sup>1</sup>"
    ],
    "lab": "1E-06",
    "pdf": "pdf/1E-06.pdf",
    "pre": "tn/1E-06.jpg",
    "reg": "74106",
    "sea": "Fe",
    "ses": "1E",
    "con": "1E-06 Fabrication of red-light responsive photosensitizer using metal-free PPIX and cytochrome c from thermophilus (<sup>1</sup>Graduate School of Science, Osaka Metropolitan Univ., <sup>2</sup>Graduate School of Science, Osaka City Univ.) 〇Hiroshi NAKAJIMA<sup>1</sup>, Makishi OHNISHI<sup>1</sup>, Kenta OHSHIMA<sup>2</sup>, Kunitaka NISHIOKA<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Chemical modification of biomolecules based on specific affinity of transition metals for olefins",
      "(<sup>1</sup>Div. Mater. Sci., Nara Institute of Science and Technology) Asuki OKADA<sup></sup>, Tsubasa KINUGAWA<sup></sup>, Shun HIROTA<sup></sup>, 〇Takashi MATSUO<sup></sup>"
    ],
    "lab": "1E-07",
    "pdf": "pdf/1E-07.pdf",
    "pre": "tn/1E-07.jpg",
    "reg": "74029",
    "sea": "Ru",
    "ses": "1E",
    "con": "1E-07 Chemical modification of biomolecules based on specific affinity of transition metals for olefins (<sup>1</sup>Div. Mater. Sci., Nara Institute of Science and Technology) Asuki OKADA<sup></sup>, Tsubasa KINUGAWA<sup></sup>, Shun HIROTA<sup></sup>, 〇Takashi MATSUO<sup></sup> Ru"
  },
  {
    "inf": [
      "Identification of Single Monomer Mutation on a Polymer Chain Realized by MOF Nanopores",
      "(<sup>1</sup>Grad. Sch. of Eng., Univ. of Tokyo) ★Haruaki Suzuki<sup>1</sup>, Nobuhiko Hosono<sup>1</sup>, Takashi Uemura<sup>1</sup>"
    ],
    "lab": "1Fa-01",
    "pdf": "pdf/1Fa-01.pdf",
    "pre": "tn/1Fa-01.jpg",
    "reg": "74098",
    "sea": "Zr",
    "ses": "1Fa",
    "con": "1Fa-01 Identification of Single Monomer Mutation on a Polymer Chain Realized by MOF Nanopores (<sup>1</sup>Grad. Sch. of Eng., Univ. of Tokyo) ★Haruaki Suzuki<sup>1</sup>, Nobuhiko Hosono<sup>1</sup>, Takashi Uemura<sup>1</sup> Zr"
  },
  {
    "inf": [
      "Chemical controls of in-plane distortion in two-dimensional ferroelectric proton conductors",
      "(<sup>1</sup>Kyushu univ.) 〇Ryo Ohtani<sup>1</sup>, Masaaki Ohba<sup>1</sup>"
    ],
    "lab": "1Fa-02",
    "pdf": "pdf/1Fa-02.pdf",
    "pre": "tn/1Fa-02.jpg",
    "reg": "74157",
    "sea": "Mn, Re",
    "ses": "1Fa",
    "con": "1Fa-02 Chemical controls of in-plane distortion in two-dimensional ferroelectric proton conductors (<sup>1</sup>Kyushu univ.) 〇Ryo Ohtani<sup>1</sup>, Masaaki Ohba<sup>1</sup> Mn, Re"
  },
  {
    "inf": [
      "Semiconductive Property of Elastic Coordination Polymers with Cd–S Network",
      "(<sup>1</sup>School of Science, Kwansei Gakuin University, <sup>2</sup>Graduate School of Enginnering, Osaka University, <sup>3</sup>School of Engineering Science, Kochi University of Technology, <sup>4</sup>Research Institute for Electronic Science Hokkaido University) ★Serina NOJIMA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Shotaro HAYASHI<sup>3</sup>, Hiroshi UJI<sup>4</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "1Fa-03",
    "pdf": "pdf/1Fa-03.pdf",
    "pre": "tn/1Fa-03.jpg",
    "reg": "74355",
    "sea": "Cd",
    "ses": "1Fa",
    "con": "1Fa-03 Semiconductive Property of Elastic Coordination Polymers with Cd–S Network (<sup>1</sup>School of Science, Kwansei Gakuin University, <sup>2</sup>Graduate School of Enginnering, Osaka University, <sup>3</sup>School of Engineering Science, Kochi University of Technology, <sup>4</sup>Research Institute for Electronic Science Hokkaido University) ★Serina NOJIMA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Shotaro HAYASHI<sup>3</sup>, Hiroshi UJI<sup>4</sup>, Daisuke TANAKA<sup>1</sup> Cd"
  },
  {
    "inf": [
      "Porous Supra-Supramolecular Polymers Assembled from Metal-Organic Octahedra",
      "(<sup>1</sup>Grad. Sch. Eng., Kyoto Univ., <sup>2</sup>iCeMS, Kyoto Univ.) ★Ayana MIYATA<sup>1,2</sup>, Shun TOKUDA<sup>2</sup>, Shuhei FURUKAWA<sup>1,2</sup>"
    ],
    "lab": "1Fa-04",
    "pdf": "pdf/1Fa-04.pdf",
    "pre": "tn/1Fa-04.jpg",
    "reg": "74465",
    "sea": "Cu",
    "ses": "1Fa",
    "con": "1Fa-04 Porous Supra-Supramolecular Polymers Assembled from Metal-Organic Octahedra (<sup>1</sup>Grad. Sch. Eng., Kyoto Univ., <sup>2</sup>iCeMS, Kyoto Univ.) ★Ayana MIYATA<sup>1,2</sup>, Shun TOKUDA<sup>2</sup>, Shuhei FURUKAWA<sup>1,2</sup> Cu"
  },
  {
    "inf": [
      "Spin Dynamics in Molecular Qubit based on Spin 1/2 Chromium(V) Complexes",
      "(<sup>1</sup>Department of Chemistry, Grad. School of Science, Kyushu Univ., <sup>2</sup>Institute for Molecular Science) ★Naoya Yamamoto<sup>1</sup>, Mizue Asada<sup>2</sup>, Benjamin Le Ouay<sup>1</sup>, Ryo Ohtani<sup>1</sup>, Toshikazu Nakamura<sup>2</sup>, Masaaki Ohba<sup>1</sup>"
    ],
    "lab": "1Fa-05",
    "pdf": "pdf/1Fa-05.pdf",
    "pre": "tn/1Fa-05.jpg",
    "reg": "74147",
    "sea": "Cr",
    "ses": "1Fa",
    "con": "1Fa-05 Spin Dynamics in Molecular Qubit based on Spin 1/2 Chromium(V) Complexes (<sup>1</sup>Department of Chemistry, Grad. School of Science, Kyushu Univ., <sup>2</sup>Institute for Molecular Science) ★Naoya Yamamoto<sup>1</sup>, Mizue Asada<sup>2</sup>, Benjamin Le Ouay<sup>1</sup>, Ryo Ohtani<sup>1</sup>, Toshikazu Nakamura<sup>2</sup>, Masaaki Ohba<sup>1</sup> Cr"
  },
  {
    "inf": [
      "Investigation of novel alignment of π-conjugated acenes using crystalline molecular gear-box",
      "(<sup>1</sup>Graduate School of Chemical Science and Engineering, Hokkaido University, <sup>2</sup>WPI-ICReDD, Hokkaido University) ★Hikaru Yammamoto<sup>1</sup>, Rempei Ando<sup>1</sup>, Mingoo Jin<sup>2</sup>"
    ],
    "lab": "1Fa-06",
    "pdf": "pdf/1Fa-06.pdf",
    "pre": "tn/1Fa-06.jpg",
    "reg": "74172",
    "sea": "Au",
    "ses": "1Fa",
    "con": "1Fa-06 Investigation of novel alignment of π-conjugated acenes using crystalline molecular gear-box (<sup>1</sup>Graduate School of Chemical Science and Engineering, Hokkaido University, <sup>2</sup>WPI-ICReDD, Hokkaido University) ★Hikaru Yammamoto<sup>1</sup>, Rempei Ando<sup>1</sup>, Mingoo Jin<sup>2</sup> Au"
  },
  {
    "inf": [
      "Hydrocarbon-Adsorption-Induced Spin-State Switching in a Monomeric Cobalt(II) Complex with the Porous Nature",
      "(<sup>1</sup>Institute for Materials Research, Tohoku University, <sup>2</sup>Department of Material Science, Graduate School of Science, Josai University, <sup>3</sup>Department of Chemistry, Graduate School of Science and Technology, Kumamoto University, <sup>4</sup>Institute of Industrial Nanomaterials, Kumamoto University) 〇Wataru KOSAKA<sup>1</sup>, Manabu NAKAYA<sup>2</sup>, Shinya HAYAMI<sup>3,4</sup>, Hitoshi MIYASAKA<sup>1</sup>"
    ],
    "lab": "1Fa-07",
    "pdf": "pdf/1Fa-07.pdf",
    "pre": "tn/1Fa-07.jpg",
    "reg": "74026",
    "sea": "Co",
    "ses": "1Fa",
    "con": "1Fa-07 Hydrocarbon-Adsorption-Induced Spin-State Switching in a Monomeric Cobalt(II) Complex with the Porous Nature (<sup>1</sup>Institute for Materials Research, Tohoku University, <sup>2</sup>Department of Material Science, Graduate School of Science, Josai University, <sup>3</sup>Department of Chemistry, Graduate School of Science and Technology, Kumamoto University, <sup>4</sup>Institute of Industrial Nanomaterials, Kumamoto University) 〇Wataru KOSAKA<sup>1</sup>, Manabu NAKAYA<sup>2</sup>, Shinya HAYAMI<sup>3,4</sup>, Hitoshi MIYASAKA<sup>1</sup> Co"
  },
  {
    "inf": [
      "Solid-State <sup>2</sup>H-NMR Study of Dynamics and Hierarchical Water Structure Confined to Molecular Nano-Porous Crystals",
      "(<sup>1</sup>Tokyo Univ. of Sci., <sup>2</sup>Kanazawa Univ.) ★Tomoya NAMIKI<sup>1</sup>, Yuta NUMAGAMI<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Takuya KURIHARA<sup>2</sup>, Motohiro MIZUNO<sup>2</sup>, Makoto TADOKORO<sup>1</sup>"
    ],
    "lab": "1Fa-08",
    "pdf": "pdf/1Fa-08.pdf",
    "pre": "tn/1Fa-08.jpg",
    "reg": "74592",
    "sea": "Co",
    "ses": "1Fa",
    "con": "1Fa-08 Solid-State <sup>2</sup>H-NMR Study of Dynamics and Hierarchical Water Structure Confined to Molecular Nano-Porous Crystals (<sup>1</sup>Tokyo Univ. of Sci., <sup>2</sup>Kanazawa Univ.) ★Tomoya NAMIKI<sup>1</sup>, Yuta NUMAGAMI<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Takuya KURIHARA<sup>2</sup>, Motohiro MIZUNO<sup>2</sup>, Makoto TADOKORO<sup>1</sup> Co"
  },
  {
    "inf": [
      "Controlling Aggregated Structures for Time-Dependent Dual Phosphorescence and Polymorphic Luminescence in Gold(I) _N_-Heterocyclic Carbene Complexes",
      "(<sup>1</sup>Ritsumeikan University, Dept. of Appl. Chem., <sup>2</sup>Indian Institute of Technology Hyderabad, Dept. of Chem.) ★Arushi RAWAT<sup>1</sup>, Siddhant KUMAR<sup>1</sup>, Kohsuke MATSUMOTO<sup>1</sup>, Ganesan PRABUSANKAR <sup>2</sup>, Osamu TSUTSUMI <sup>1</sup>"
    ],
    "lab": "1Fb-01",
    "pdf": "pdf/1Fb-01.pdf",
    "pre": "tn/1Fb-01.jpg",
    "reg": "74111",
    "sea": "Au",
    "ses": "1Fb",
    "con": "1Fb-01 Controlling Aggregated Structures for Time-Dependent Dual Phosphorescence and Polymorphic Luminescence in Gold(I) _N_-Heterocyclic Carbene Complexes (<sup>1</sup>Ritsumeikan University, Dept. of Appl. Chem., <sup>2</sup>Indian Institute of Technology Hyderabad, Dept. of Chem.) ★Arushi RAWAT<sup>1</sup>, Siddhant KUMAR<sup>1</sup>, Kohsuke MATSUMOTO<sup>1</sup>, Ganesan PRABUSANKAR <sup>2</sup>, Osamu TSUTSUMI <sup>1</sup> Au"
  },
  {
    "inf": [
      "Chirality Induction of Achiral Luminous Terbium Complex by Immobilization to Silica Surface Functionalized with Chiral Phenylethylamines",
      "(<sup>1</sup>Dept. Chem. Grad. Sch. Sci. Nagoya Univ., <sup>2</sup>Dept. Energy Mater. Grad. Sch. Sci. Eng. Kindai Univ., <sup>3</sup>IMS, <sup>4</sup>RCMS, Nagoya Univ.) 〇Sora Shirai<sup>1</sup>, Satoshi Muratsugu<sup>1</sup>, Hidetaka Nakai<sup>2</sup>, Masahiro Ehara<sup>3</sup>, Mizuki Tada<sup>1,4</sup>"
    ],
    "lab": "1Fb-02",
    "pdf": "pdf/1Fb-02.pdf",
    "pre": "tn/1Fb-02.jpg",
    "reg": "74013",
    "sea": "Tb",
    "ses": "1Fb",
    "con": "1Fb-02 Chirality Induction of Achiral Luminous Terbium Complex by Immobilization to Silica Surface Functionalized with Chiral Phenylethylamines (<sup>1</sup>Dept. Chem. Grad. Sch. Sci. Nagoya Univ., <sup>2</sup>Dept. Energy Mater. Grad. Sch. Sci. Eng. Kindai Univ., <sup>3</sup>IMS, <sup>4</sup>RCMS, Nagoya Univ.) 〇Sora Shirai<sup>1</sup>, Satoshi Muratsugu<sup>1</sup>, Hidetaka Nakai<sup>2</sup>, Masahiro Ehara<sup>3</sup>, Mizuki Tada<sup>1,4</sup> Tb"
  },
  {
    "inf": [
      "Chiral Solvent Vapor-Induced Molecular Arrangement Switching in Luminescent Aluminium(III) Complex",
      "(<sup>1</sup>Tokyo Univ. of Sci.) 〇Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup>"
    ],
    "lab": "1Fb-03",
    "pdf": "pdf/1Fb-03.pdf",
    "pre": "tn/1Fb-03.jpg",
    "reg": "74466",
    "sea": "Al",
    "ses": "1Fb",
    "con": "1Fb-03 Chiral Solvent Vapor-Induced Molecular Arrangement Switching in Luminescent Aluminium(III) Complex (<sup>1</sup>Tokyo Univ. of Sci.) 〇Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup> Al"
  },
  {
    "inf": [
      "Development of Red to Near-Infrared Photoluminescent Properties of Aluminum-based Dinuclear Triple-Stranded Helicates",
      "(<sup>1</sup>Grad. Sch. of Eng., Kyushu Univ., <sup>2</sup>Grad. Sch. of Sci., Kyushu Univ., <sup>3</sup>Center for Molecular Systems (CMS), Kyushu Univ.) ★Yuto KONISHI<sup>1</sup>, Takumi EHARA<sup>2</sup>, Teruyuki HONDA<sup>2</sup>, Tomohiro OGAWA<sup>2</sup>, Kiyoshi MIYATA<sup>2</sup>, Ken ONDA<sup>2</sup>, Yu HOSHINO<sup>1, 3</sup>, Toshikazu ONO<sup>1, 3</sup>"
    ],
    "lab": "1Fb-04",
    "pdf": "pdf/1Fb-04.pdf",
    "pre": "tn/1Fb-04.jpg",
    "reg": "74392",
    "sea": "Al",
    "ses": "1Fb",
    "con": "1Fb-04 Development of Red to Near-Infrared Photoluminescent Properties of Aluminum-based Dinuclear Triple-Stranded Helicates (<sup>1</sup>Grad. Sch. of Eng., Kyushu Univ., <sup>2</sup>Grad. Sch. of Sci., Kyushu Univ., <sup>3</sup>Center for Molecular Systems (CMS), Kyushu Univ.) ★Yuto KONISHI<sup>1</sup>, Takumi EHARA<sup>2</sup>, Teruyuki HONDA<sup>2</sup>, Tomohiro OGAWA<sup>2</sup>, Kiyoshi MIYATA<sup>2</sup>, Ken ONDA<sup>2</sup>, Yu HOSHINO<sup>1, 3</sup>, Toshikazu ONO<sup>1, 3</sup> Al"
  },
  {
    "inf": [
      "白金とルテニウムを含有する新規複合金属リン化物の調製と構造解析",
      "(<sup>1</sup>名大院理・<sup>2</sup>名大物国セ) 〇中西 舞<sup>1</sup>・森山 拓海<sup>1</sup>・邨次 智<sup>1</sup>・唯 美津木<sup>1, 2</sup>",
      "Preparation and Structural Characterization of Novel Mixed Metal Phosphide with Platinum and Ruthenium",
      "(<sup>1</sup>Grad. Sch. Sci., Nagoya Univ., <sup>2</sup>RCMS, Nagoya Univ.) 〇Mai NAKANISHI<sup>1</sup>, Takumi MORIYAMA<sup>1</sup>, Satoshi MURATSUGU<sup>1</sup>, Mizuki TADA<sup>1, 2</sup>"
    ],
    "lab": "1Fb-05",
    "pdf": "pdf/1Fb-05.pdf",
    "pre": "tn/1Fb-05.jpg",
    "reg": "74094",
    "sea": "Pt, Ru",
    "ses": "1Fb",
    "con": "1Fb-05 白金とルテニウムを含有する新規複合金属リン化物の調製と構造解析 (<sup>1</sup>名大院理・<sup>2</sup>名大物国セ) 〇中西 舞<sup>1</sup>・森山 拓海<sup>1</sup>・邨次 智<sup>1</sup>・唯 美津木<sup>1, 2</sup> Preparation and Structural Characterization of Novel Mixed Metal Phosphide with Platinum and Ruthenium (<sup>1</sup>Grad. Sch. Sci., Nagoya Univ., <sup>2</sup>RCMS, Nagoya Univ.) 〇Mai NAKANISHI<sup>1</sup>, Takumi MORIYAMA<sup>1</sup>, Satoshi MURATSUGU<sup>1</sup>, Mizuki TADA<sup>1, 2</sup> Pt, Ru"
  },
  {
    "inf": [
      "Preparation of Platinum-Gadolinium Alloy Nanoparticles from Organometallic Precursors for Efficient Oxygen Reduction Reaction Electrocatalysts",
      "(<sup>1</sup>Grad. Sch. Sci., Nagoya Univ., <sup>2</sup>RCMS, Nagoya Univ.) ★Takumi MORIYAMA<sup>1</sup>, Satoshi MURATSUGU<sup>1</sup>, Mizuki TADA<sup>1,2</sup>"
    ],
    "lab": "1Fb-06",
    "pdf": "pdf/1Fb-06.pdf",
    "pre": "tn/1Fb-06.jpg",
    "reg": "74014",
    "sea": "Pt, Gd",
    "ses": "1Fb",
    "con": "1Fb-06 Preparation of Platinum-Gadolinium Alloy Nanoparticles from Organometallic Precursors for Efficient Oxygen Reduction Reaction Electrocatalysts (<sup>1</sup>Grad. Sch. Sci., Nagoya Univ., <sup>2</sup>RCMS, Nagoya Univ.) ★Takumi MORIYAMA<sup>1</sup>, Satoshi MURATSUGU<sup>1</sup>, Mizuki TADA<sup>1,2</sup> Pt, Gd"
  },
  {
    "inf": [
      "Synthesis and Catalysis of a Small Palladium Nanocluster within a Ring-Shaped Polyoxometalate",
      "(<sup>1</sup>School of Engineering, The University of Tokyo) 〇Rui XI<sup>1</sup>, Yoshihiro KOIZUMI<sup>1</sup>, Kentaro YONESATO<sup>1</sup>, Takafumi YATABE<sup>1</sup>, Kosuke SUZUKI<sup>1</sup>, Kazuya YAMAGUCHI<sup>1</sup>"
    ],
    "lab": "1Fb-07",
    "pdf": "pdf/1Fb-07.pdf",
    "pre": "tn/1Fb-07.jpg",
    "reg": "74569",
    "sea": "Pd",
    "ses": "1Fb",
    "con": "1Fb-07 Synthesis and Catalysis of a Small Palladium Nanocluster within a Ring-Shaped Polyoxometalate (<sup>1</sup>School of Engineering, The University of Tokyo) 〇Rui XI<sup>1</sup>, Yoshihiro KOIZUMI<sup>1</sup>, Kentaro YONESATO<sup>1</sup>, Takafumi YATABE<sup>1</sup>, Kosuke SUZUKI<sup>1</sup>, Kazuya YAMAGUCHI<sup>1</sup> Pd"
  },
  {
    "inf": [
      "サレン錯体とポリオキソメタレートを構成要素とする多孔性イオン結晶を用いた水素発生反応",
      "(<sup>1</sup>東大院総合文化) 〇堤 由太朗<sup>1</sup>・下山 雄人<sup>1</sup>・荻原 直希<sup>1</sup>・内田 さやか<sup>1</sup>",
      "Hydrogen Evolution Reaction catalyzed by porous ionic crystals composed of salen complexes and polyoxometalates",
      "(<sup>1</sup>University of Tokyo) 〇Yutaro Tsutsumi<sup>1</sup>, Yuto Shimoyama<sup>1</sup>, Naoki Ogiwara<sup>1</sup>, Sayaka Uchida<sup>1</sup>"
    ],
    "lab": "1Fb-08",
    "pdf": "pdf/1Fb-08.pdf",
    "pre": "tn/1Fb-08.jpg",
    "reg": "74274",
    "sea": "Mn,Co,Zn,P,Si",
    "ses": "1Fb",
    "con": "1Fb-08 サレン錯体とポリオキソメタレートを構成要素とする多孔性イオン結晶を用いた水素発生反応 (<sup>1</sup>東大院総合文化) 〇堤 由太朗<sup>1</sup>・下山 雄人<sup>1</sup>・荻原 直希<sup>1</sup>・内田 さやか<sup>1</sup> Hydrogen Evolution Reaction catalyzed by porous ionic crystals composed of salen complexes and polyoxometalates (<sup>1</sup>University of Tokyo) 〇Yutaro Tsutsumi<sup>1</sup>, Yuto Shimoyama<sup>1</sup>, Naoki Ogiwara<sup>1</sup>, Sayaka Uchida<sup>1</sup> Mn,Co,Zn,P,Si"
  },
  {
    "inf": [
      "Tuning of guest uptake/release kinetics of dinuclear cobalt(III) metallohosts by auxiliary amine ligands",
      "(<sup>1</sup>Grad. Sch. of Natl. Sci. and Tech., Kanazawa Univ., <sup>2</sup>Grad. Sch. of Eng., Nagoya Univ., <sup>3</sup>NanoLSI, Kanazawa Univ.) ★Dejan Walter<sup>1</sup>, Yoko Sakata<sup>2</sup>, Shigehisa Akine<sup>1,3</sup>"
    ],
    "lab": "1Fc-01",
    "pdf": "pdf/1Fc-01.pdf",
    "pre": "tn/1Fc-01.jpg",
    "reg": "74090",
    "sea": "Co, Na, K, Rb, Cs",
    "ses": "1Fc",
    "con": "1Fc-01 Tuning of guest uptake/release kinetics of dinuclear cobalt(III) metallohosts by auxiliary amine ligands (<sup>1</sup>Grad. Sch. of Natl. Sci. and Tech., Kanazawa Univ., <sup>2</sup>Grad. Sch. of Eng., Nagoya Univ., <sup>3</sup>NanoLSI, Kanazawa Univ.) ★Dejan Walter<sup>1</sup>, Yoko Sakata<sup>2</sup>, Shigehisa Akine<sup>1,3</sup> Co, Na, K, Rb, Cs"
  },
  {
    "inf": [
      "Arraying of Metalloporphyrins in Nanochannels of Nanoporous Liquid Crystal          ",
      "(<sup>1</sup>Nagoya Univ.) 〇Shin-ichiro KAWANO<sup>1</sup>, Atsuhito DEGUCHI<sup>1</sup>, Takuya SAKATA<sup>1</sup>, Kentaro TANAKA<sup>1</sup>"
    ],
    "lab": "1Fc-02",
    "pdf": "pdf/1Fc-02.pdf",
    "pre": "tn/1Fc-02.jpg",
    "reg": "74598",
    "sea": "Sn",
    "ses": "1Fc",
    "con": "1Fc-02 Arraying of Metalloporphyrins in Nanochannels of Nanoporous Liquid Crystal           (<sup>1</sup>Nagoya Univ.) 〇Shin-ichiro KAWANO<sup>1</sup>, Atsuhito DEGUCHI<sup>1</sup>, Takuya SAKATA<sup>1</sup>, Kentaro TANAKA<sup>1</sup> Sn"
  },
  {
    "inf": [
      "External modification of a metal–peptide M<sub>60</sub>L<sub>60</sub> cage for solubility enhancement",
      "(<sup>1</sup>Lab. for Chem. & Life Sci., Tokyo Tech, <sup>2</sup>JST-PRESTO) ★Nao SAGARA<sup>1</sup>, Michito YOSHIZAWA<sup>1</sup>, Tomohisa SAWADA<sup>1,2</sup>"
    ],
    "lab": "1Fc-03",
    "pdf": "pdf/1Fc-03.pdf",
    "pre": "tn/1Fc-03.jpg",
    "reg": "74198",
    "sea": "Cu",
    "ses": "1Fc",
    "con": "1Fc-03 External modification of a metal–peptide M<sub>60</sub>L<sub>60</sub> cage for solubility enhancement (<sup>1</sup>Lab. for Chem. & Life Sci., Tokyo Tech, <sup>2</sup>JST-PRESTO) ★Nao SAGARA<sup>1</sup>, Michito YOSHIZAWA<sup>1</sup>, Tomohisa SAWADA<sup>1,2</sup> Cu"
  },
  {
    "inf": [
      "Selective Binding of Perfluorinated Compounds by Pt/Pd-Linked Polyaromatic Capsules",
      "(<sup>1</sup>Lab. for Chem. & Life Sci., Tokyo Tech) ★Urara KAI<sup>1</sup>, Ryuki SUMIDA<sup>1</sup>, Yuya TANAKA<sup>1</sup>, Michito YOSHIZAWA<sup>1</sup>"
    ],
    "lab": "1Fc-04",
    "pdf": "pdf/1Fc-04.pdf",
    "pre": "tn/1Fc-04.jpg",
    "reg": "74348",
    "sea": "Pt, Pd",
    "ses": "1Fc",
    "con": "1Fc-04 Selective Binding of Perfluorinated Compounds by Pt/Pd-Linked Polyaromatic Capsules (<sup>1</sup>Lab. for Chem. & Life Sci., Tokyo Tech) ★Urara KAI<sup>1</sup>, Ryuki SUMIDA<sup>1</sup>, Yuya TANAKA<sup>1</sup>, Michito YOSHIZAWA<sup>1</sup> Pt, Pd"
  },
  {
    "inf": [
      "Synthesis of Ruthenium tris(N-hexylbiimidazole) for a Thermocell using Proton-Coupled Electron Transfer reaction with high solubility",
      "(<sup>1</sup>Tokyo Univ.) ★Taiga TSUCHIYA<sup>1</sup>, Mizuha UJITA<sup>1</sup>, Hongyao ZHOU<sup>1</sup>, Teppei YAMADA<sup>1</sup>"
    ],
    "lab": "1Fc-05",
    "pdf": "pdf/1Fc-05.pdf",
    "pre": "tn/1Fc-05.jpg",
    "reg": "74282",
    "sea": "Ru",
    "ses": "1Fc",
    "con": "1Fc-05 Synthesis of Ruthenium tris(N-hexylbiimidazole) for a Thermocell using Proton-Coupled Electron Transfer reaction with high solubility (<sup>1</sup>Tokyo Univ.) ★Taiga TSUCHIYA<sup>1</sup>, Mizuha UJITA<sup>1</sup>, Hongyao ZHOU<sup>1</sup>, Teppei YAMADA<sup>1</sup> Ru"
  },
  {
    "inf": [
      "Solubility improvement of terpyridine iron complexes and its application to posolytes of redox flow batteries",
      "(<sup>1</sup>Waseda Univ.) 〇Atsushi Okazawa<sup>1</sup>, Keisuke Akahori<sup>1</sup>, Takayuki Kakuchi<sup>1</sup>, Kosuke Kawai<sup>1</sup>, Masashi Okubo<sup>1</sup>"
    ],
    "lab": "1Fc-06",
    "pdf": "pdf/1Fc-06.pdf",
    "pre": "tn/1Fc-06.jpg",
    "reg": "74154",
    "sea": "Fe",
    "ses": "1Fc",
    "con": "1Fc-06 Solubility improvement of terpyridine iron complexes and its application to posolytes of redox flow batteries (<sup>1</sup>Waseda Univ.) 〇Atsushi Okazawa<sup>1</sup>, Keisuke Akahori<sup>1</sup>, Takayuki Kakuchi<sup>1</sup>, Kosuke Kawai<sup>1</sup>, Masashi Okubo<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Synthesis of bis(diimino)palladium nanosheets as highly efficient electrocatalyst for hydrogen evolution reaction",
      "(<sup>1</sup>Research Institute for Science and Technology, Tokyo University of Science, <sup>2</sup>School of Science, The University of Tokyo, <sup>3</sup>Graduate School of Science and Technology, Tokyo University of Science, <sup>4</sup>Japan Synchrotron Radiation Research Institute, <sup>5</sup>Faculty of Fiber Science and Engineering, Kyoto Institute of Technology, <sup>6</sup>RIKEN SPring-8 Center, <sup>7</sup>Research Center for Materials Nanoarchitectonics, National Institute for Materials Science) 〇Hiroaki MAEDA<sup>1</sup>, Eunice Jia Han PHUA<sup>2</sup>, Yuta SUDO<sup>3</sup>, Sayoko NAGASHIMA<sup>1</sup>, Wentai CHEN<sup>3</sup>, Mayumi FUJINO<sup>3</sup>, Kenji TAKADA<sup>1</sup>, Naoya FUKUI<sup>1</sup>, Hiroyasu MASUNAGA<sup>4</sup>, Sono SASAKI<sup>5,6</sup>, Kazuhito TSUKAGOSHI<sup>7</sup>, Hiroshi NISHIHARA<sup>1,3</sup>"
    ],
    "lab": "1Fc-07",
    "pdf": "pdf/1Fc-07.pdf",
    "pre": "tn/1Fc-07.jpg",
    "reg": "74358",
    "sea": "Pd",
    "ses": "1Fc",
    "con": "1Fc-07 Synthesis of bis(diimino)palladium nanosheets as highly efficient electrocatalyst for hydrogen evolution reaction (<sup>1</sup>Research Institute for Science and Technology, Tokyo University of Science, <sup>2</sup>School of Science, The University of Tokyo, <sup>3</sup>Graduate School of Science and Technology, Tokyo University of Science, <sup>4</sup>Japan Synchrotron Radiation Research Institute, <sup>5</sup>Faculty of Fiber Science and Engineering, Kyoto Institute of Technology, <sup>6</sup>RIKEN SPring-8 Center, <sup>7</sup>Research Center for Materials Nanoarchitectonics, National Institute for Materials Science) 〇Hiroaki MAEDA<sup>1</sup>, Eunice Jia Han PHUA<sup>2</sup>, Yuta SUDO<sup>3</sup>, Sayoko NAGASHIMA<sup>1</sup>, Wentai CHEN<sup>3</sup>, Mayumi FUJINO<sup>3</sup>, Kenji TAKADA<sup>1</sup>, Naoya FUKUI<sup>1</sup>, Hiroyasu MASUNAGA<sup>4</sup>, Sono SASAKI<sup>5,6</sup>, Kazuhito TSUKAGOSHI<sup>7</sup>, Hiroshi NISHIHARA<sup>1,3</sup> Pd"
  },
  {
    "inf": [
      "Facile Fabrication of Chemical Sensing Devices by Direct Electrocrystallization of Porous Molecular Conductors",
      "(<sup>1</sup>Graduate School of Science, Tohoku University, <sup>2</sup>Graduate School of Engineering, Nagoya University, <sup>3</sup>Department of Chemistry, Dartmouth College) ★Tappei TANABE<sup>1,2,3</sup>, Hiroaki IGUCHI<sup>2</sup>, Ryotaro MATSUDA<sup>2</sup>, Katherine A. MIRICA<sup>3</sup>, Ryota SAKAMOTO<sup>1</sup>"
    ],
    "lab": "1Fc-08",
    "pdf": "pdf/1Fc-08.pdf",
    "pre": "tn/1Fc-08.jpg",
    "reg": "74568",
    "sea": "Cd,Zn",
    "ses": "1Fc",
    "con": "1Fc-08 Facile Fabrication of Chemical Sensing Devices by Direct Electrocrystallization of Porous Molecular Conductors (<sup>1</sup>Graduate School of Science, Tohoku University, <sup>2</sup>Graduate School of Engineering, Nagoya University, <sup>3</sup>Department of Chemistry, Dartmouth College) ★Tappei TANABE<sup>1,2,3</sup>, Hiroaki IGUCHI<sup>2</sup>, Ryotaro MATSUDA<sup>2</sup>, Katherine A. MIRICA<sup>3</sup>, Ryota SAKAMOTO<sup>1</sup> Cd,Zn"
  },
  {
    "inf": [
      "Albumin nanoparticle electrostatically loaded with highly anionic Gd-thiacalixarene complex for MRI-guided neutron capture therapy",
      "(<sup>1</sup>Tohoku Univ., <sup>2</sup>QST, <sup>3</sup>Osaka Metropolitan Univ., <sup>4</sup>Kyoto Univ.) Kohei OHAMA<sup>1</sup>, Miku KOMIYA<sup>1</sup>, Takumi YAMATOYA<sup>1</sup>, Ryota SAWAMURA<sup>1</sup>, Ryunosuke KARASHIMADA<sup>1</sup>, Shan GAO<sup>2</sup>, Yoshikazu OZAWA<sup>2</sup>, Kensuke OSADA<sup>2</sup>, Ichio AOKI<sup>2</sup>, Takeshi NAGASAKI<sup>3</sup>, Minoru SUZUKI<sup>4</sup>, 〇Nobuhiko IKI<sup>1</sup>"
    ],
    "lab": "1Fd-01",
    "pdf": "pdf/1Fd-01.pdf",
    "pre": "tn/1Fd-01.jpg",
    "reg": "74016",
    "sea": "Gd",
    "ses": "1Fd",
    "con": "1Fd-01 Albumin nanoparticle electrostatically loaded with highly anionic Gd-thiacalixarene complex for MRI-guided neutron capture therapy (<sup>1</sup>Tohoku Univ., <sup>2</sup>QST, <sup>3</sup>Osaka Metropolitan Univ., <sup>4</sup>Kyoto Univ.) Kohei OHAMA<sup>1</sup>, Miku KOMIYA<sup>1</sup>, Takumi YAMATOYA<sup>1</sup>, Ryota SAWAMURA<sup>1</sup>, Ryunosuke KARASHIMADA<sup>1</sup>, Shan GAO<sup>2</sup>, Yoshikazu OZAWA<sup>2</sup>, Kensuke OSADA<sup>2</sup>, Ichio AOKI<sup>2</sup>, Takeshi NAGASAKI<sup>3</sup>, Minoru SUZUKI<sup>4</sup>, 〇Nobuhiko IKI<sup>1</sup> Gd"
  },
  {
    "inf": [
      "Design and synthesis of iridium(III) complex-cyclic peptide hybrids and mechanistic study for induction of cancer cell death",
      "(<sup>1</sup>Faculty of Pharmaceutical Sciences, Tokyo University of Science, <sup>2</sup>Research Institute for Science and Technology, Tokyo University of Science) ★Nozomi NARUSHIMA<sup>1</sup>, Toshifumi TOJO<sup>1</sup>, Shin AOKI<sup>1,2</sup>"
    ],
    "lab": "1Fd-02",
    "pdf": "pdf/1Fd-02.pdf",
    "pre": "tn/1Fd-02.jpg",
    "reg": "74246",
    "sea": "Ir",
    "ses": "1Fd",
    "con": "1Fd-02 Design and synthesis of iridium(III) complex-cyclic peptide hybrids and mechanistic study for induction of cancer cell death (<sup>1</sup>Faculty of Pharmaceutical Sciences, Tokyo University of Science, <sup>2</sup>Research Institute for Science and Technology, Tokyo University of Science) ★Nozomi NARUSHIMA<sup>1</sup>, Toshifumi TOJO<sup>1</sup>, Shin AOKI<sup>1,2</sup> Ir"
  },
  {
    "inf": [
      "Synthesis of Highly photostable Fluorinated Phthalocyanine Complexes for PDT          ",
      "(<sup>1</sup>IIS, The Univ. of Tokyo) ★Hongfeng Liu<sup>1</sup>, Kei Murata<sup>1</sup>, Jiaqi Tian<sup>1</sup>, Kazuaki Kudo<sup>1</sup>, Kazuyuki Ishii<sup>1</sup>"
    ],
    "lab": "1Fd-03",
    "pdf": "pdf/1Fd-03.pdf",
    "pre": "tn/1Fd-03.jpg",
    "reg": "74567",
    "sea": "Zn",
    "ses": "1Fd",
    "con": "1Fd-03 Synthesis of Highly photostable Fluorinated Phthalocyanine Complexes for PDT           (<sup>1</sup>IIS, The Univ. of Tokyo) ★Hongfeng Liu<sup>1</sup>, Kei Murata<sup>1</sup>, Jiaqi Tian<sup>1</sup>, Kazuaki Kudo<sup>1</sup>, Kazuyuki Ishii<sup>1</sup> Zn"
  },
  {
    "inf": [
      "Red Light-Induced Generation of Chromanone Derivatives from Organorhodium Phthalocyanine Photocages",
      "(<sup>1</sup>IIS, UTokyo, <sup>2</sup>RIKEN CSRS) 〇Kei MURATA<sup>1,2</sup>, Yu JI<sup>1</sup>, Kazuyuki ISHII<sup>1</sup>"
    ],
    "lab": "1Fd-04",
    "pdf": "pdf/1Fd-04.pdf",
    "pre": "tn/1Fd-04.jpg",
    "reg": "74537",
    "sea": "Rh",
    "ses": "1Fd",
    "con": "1Fd-04 Red Light-Induced Generation of Chromanone Derivatives from Organorhodium Phthalocyanine Photocages (<sup>1</sup>IIS, UTokyo, <sup>2</sup>RIKEN CSRS) 〇Kei MURATA<sup>1,2</sup>, Yu JI<sup>1</sup>, Kazuyuki ISHII<sup>1</sup> Rh"
  },
  {
    "inf": [
      "An Icosahedral 55-Iron-Atom Nanocluster Paired with an Octahedral 6-Iron-Atom Cluster: Isolation and Characterization",
      "(<sup>1</sup>Institute for Chemical Research, Kyoto Univ., <sup>2</sup>Graduate School of Science and RCMS, Nagoya Univ., <sup>3</sup>Dept of Chem., Univ. of Colombo, <sup>4</sup>Graduate School of Science, Tokyo Metropolitan Univ., <sup>5</sup>Dept of Chem., Univ. of Tsukuba, <sup>6</sup>Fukui Institute for Fundamental Chemistry, <sup>7</sup>Dept of Chem., Univ. of Hawaii, <sup>8</sup>Dept of Chem & Pharm, FAU Erlangen-Nürnberg) ◎Kanata TANAKA<sup>1</sup>, Shunya OISHI<sup>2</sup>, Koki KAWAMOTO<sup>2</sup>, Mizuki TADA<sup>2</sup>, W. M. C SAMEERA<sup>3</sup>, Ryo TAKAHATA<sup>1</sup>, Toshiharu TERANISHI<sup>1</sup>, Soichi KIKKAWA<sup>4</sup>, Seiji YAMAZOE<sup>4</sup>, Takuya SHIGA<sup>5</sup>, Masayuki NIHEI<sup>5</sup>, Tatsuhisa KATO<sup>6</sup>, Roger E. CRAMER<sup>7</sup>, Zihan ZHANG<sup>8</sup>, Karsten MEYER<sup>8</sup>, Tatsuya HIGAKI<sup>1</sup>, Yasuhiro OHKI<sup>1</sup>"
    ],
    "lab": "1PA-01",
    "pdf": "pdf/1PA-01.pdf",
    "pre": "tn/1PA-01.jpg",
    "reg": "74168",
    "sea": "Fe",
    "ses": "1PA",
    "con": "1PA-01 An Icosahedral 55-Iron-Atom Nanocluster Paired with an Octahedral 6-Iron-Atom Cluster: Isolation and Characterization (<sup>1</sup>Institute for Chemical Research, Kyoto Univ., <sup>2</sup>Graduate School of Science and RCMS, Nagoya Univ., <sup>3</sup>Dept of Chem., Univ. of Colombo, <sup>4</sup>Graduate School of Science, Tokyo Metropolitan Univ., <sup>5</sup>Dept of Chem., Univ. of Tsukuba, <sup>6</sup>Fukui Institute for Fundamental Chemistry, <sup>7</sup>Dept of Chem., Univ. of Hawaii, <sup>8</sup>Dept of Chem & Pharm, FAU Erlangen-Nürnberg) ◎Kanata TANAKA<sup>1</sup>, Shunya OISHI<sup>2</sup>, Koki KAWAMOTO<sup>2</sup>, Mizuki TADA<sup>2</sup>, W. M. C SAMEERA<sup>3</sup>, Ryo TAKAHATA<sup>1</sup>, Toshiharu TERANISHI<sup>1</sup>, Soichi KIKKAWA<sup>4</sup>, Seiji YAMAZOE<sup>4</sup>, Takuya SHIGA<sup>5</sup>, Masayuki NIHEI<sup>5</sup>, Tatsuhisa KATO<sup>6</sup>, Roger E. CRAMER<sup>7</sup>, Zihan ZHANG<sup>8</sup>, Karsten MEYER<sup>8</sup>, Tatsuya HIGAKI<sup>1</sup>, Yasuhiro OHKI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "The structure in solid/solution states of a Ni(II) inclusion complex with β-cyclodextrins",
      "(<sup>1</sup>Faculty of Science, Fukuoka University) 〇Tomohiko Hamaguchi<sup>1</sup>, Yuudai Iseki<sup>1</sup>, Yuuma Yoshioka<sup>1</sup>, Ryuta Ishikawa<sup>1</sup>, Akio Mishima<sup>1</sup>, Satoshi Kawata<sup>1</sup>"
    ],
    "lab": "1PA-02",
    "pdf": "pdf/1PA-02.pdf",
    "pre": "tn/1PA-02.jpg",
    "reg": "74048",
    "sea": "Ni",
    "ses": "1PA",
    "con": "1PA-02 The structure in solid/solution states of a Ni(II) inclusion complex with β-cyclodextrins (<sup>1</sup>Faculty of Science, Fukuoka University) 〇Tomohiko Hamaguchi<sup>1</sup>, Yuudai Iseki<sup>1</sup>, Yuuma Yoshioka<sup>1</sup>, Ryuta Ishikawa<sup>1</sup>, Akio Mishima<sup>1</sup>, Satoshi Kawata<sup>1</sup> Ni"
  },
  {
    "inf": [
      "Porous Ionic Crystals Composed of Polyoxovanadates and Chromium Trinuclear Complexes",
      "(<sup>1</sup> The Univ. of Tokyo, <sup>2</sup>Kanazawa Univ.) 〇Seoji YANG<sup>1</sup>, Naoki OGIWARA<sup>1</sup>, Taisei KUROSAKI<sup>1</sup>, Shunsuke MOCHIZUKI<sup>1</sup>, Tsukasa IWANO<sup>1</sup>, Yuji KIKUKAWA<sup>2</sup>, Sakaya UCHIDA<sup>1</sup>"
    ],
    "lab": "1PA-03",
    "pdf": "pdf/1PA-03.pdf",
    "pre": "tn/1PA-03.jpg",
    "reg": "74230",
    "sea": "V, Cr",
    "ses": "1PA",
    "con": "1PA-03 Porous Ionic Crystals Composed of Polyoxovanadates and Chromium Trinuclear Complexes (<sup>1</sup> The Univ. of Tokyo, <sup>2</sup>Kanazawa Univ.) 〇Seoji YANG<sup>1</sup>, Naoki OGIWARA<sup>1</sup>, Taisei KUROSAKI<sup>1</sup>, Shunsuke MOCHIZUKI<sup>1</sup>, Tsukasa IWANO<sup>1</sup>, Yuji KIKUKAWA<sup>2</sup>, Sakaya UCHIDA<sup>1</sup> V, Cr"
  },
  {
    "inf": [
      "8つのアルキル鎖を持つFe(II)SCO単核錯体の合成、構造と磁性",
      "(<sup>1</sup>筑波大院数物) ◎小田嶋 欧<sup>1</sup>・志賀 拓也<sup>1</sup>・三原 のぞみ<sup>1</sup>・二瓶 雅之<sup>1</sup>",
      "Syntheses, structures, and magnetic properties of Fe(II)SCO mononuclear complex with eight alkyl chains",
      "(<sup>1</sup>Degree Programs in Pure and Applied Sciences, Graduate School of Science and Technology, University of Tsukuba) ◎Yu ODASHIMA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Masayuki NIHEI<sup>1</sup>"
    ],
    "lab": "1PA-04",
    "pdf": "pdf/1PA-04.pdf",
    "pre": "tn/1PA-04.jpg",
    "reg": "74056",
    "sea": "Fe",
    "ses": "1PA",
    "con": "1PA-04 8つのアルキル鎖を持つFe(II)SCO単核錯体の合成、構造と磁性 (<sup>1</sup>筑波大院数物) ◎小田嶋 欧<sup>1</sup>・志賀 拓也<sup>1</sup>・三原 のぞみ<sup>1</sup>・二瓶 雅之<sup>1</sup> Syntheses, structures, and magnetic properties of Fe(II)SCO mononuclear complex with eight alkyl chains (<sup>1</sup>Degree Programs in Pure and Applied Sciences, Graduate School of Science and Technology, University of Tsukuba) ◎Yu ODASHIMA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Masayuki NIHEI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "キラルシッフ塩基ニッケル(II)錯体の電解重合による高分子膜の合成と円偏光二色性",
      "(<sup>1</sup>神奈川大理・<sup>2</sup>工学院大) 〇桑村 直人<sup>2</sup>・岡西 一真<sup>1</sup>・冨田 琉生<sup>1</sup>・力石 紀子<sup>1</sup>・廣津 昌和<sup>1</sup>",
      "Synthesis of Polymer Films by Electropolymerization of Chiral Schiff Base Nickel(II) Complexes and Their Circular Dichroism",
      "(<sup>1</sup>Kanagawa Univ., <sup>2</sup>Kogakuin Univ.) 〇Naoto KUWAMURA<sup>2</sup>, Kazuma OKANISHI<sup>1</sup>, Ryusei TOMITA<sup>1</sup>, Noriko CHIKARAISHI<sup>1</sup>, Masakazu HIROTSU<sup>1</sup>"
    ],
    "lab": "1PA-05",
    "pdf": "pdf/1PA-05.pdf",
    "pre": "tn/1PA-05.jpg",
    "reg": "74209",
    "sea": "Ni",
    "ses": "1PA",
    "con": "1PA-05 キラルシッフ塩基ニッケル(II)錯体の電解重合による高分子膜の合成と円偏光二色性 (<sup>1</sup>神奈川大理・<sup>2</sup>工学院大) 〇桑村 直人<sup>2</sup>・岡西 一真<sup>1</sup>・冨田 琉生<sup>1</sup>・力石 紀子<sup>1</sup>・廣津 昌和<sup>1</sup> Synthesis of Polymer Films by Electropolymerization of Chiral Schiff Base Nickel(II) Complexes and Their Circular Dichroism (<sup>1</sup>Kanagawa Univ., <sup>2</sup>Kogakuin Univ.) 〇Naoto KUWAMURA<sup>2</sup>, Kazuma OKANISHI<sup>1</sup>, Ryusei TOMITA<sup>1</sup>, Noriko CHIKARAISHI<sup>1</sup>, Masakazu HIROTSU<sup>1</sup> Ni"
  },
  {
    "inf": [
      "テトラカルボン酸を用いた新規ジルコニウム配位高分子の合成",
      "(<sup>1</sup>東理大院理) 〇久住 遥香<sup>1</sup>・貞清 正彰<sup>1</sup>",
      "Synthesis  of a novel zirconium metal–organic framework  with a tetracarboxylate ligand",
      "(<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Haruka KUSUMI<sup>1</sup>, Masaaki SADAKIYO<sup>1</sup>"
    ],
    "lab": "1PA-06",
    "pdf": "pdf/1PA-06.pdf",
    "pre": "tn/1PA-06.jpg",
    "reg": "74221",
    "sea": "Zr",
    "ses": "1PA",
    "con": "1PA-06 テトラカルボン酸を用いた新規ジルコニウム配位高分子の合成 (<sup>1</sup>東理大院理) 〇久住 遥香<sup>1</sup>・貞清 正彰<sup>1</sup> Synthesis  of a novel zirconium metal–organic framework  with a tetracarboxylate ligand (<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Haruka KUSUMI<sup>1</sup>, Masaaki SADAKIYO<sup>1</sup> Zr"
  },
  {
    "inf": [
      "非対称な単核白金錯体と銀イオンの反応によって生成する階層的集合構造の確認とその光物性",
      "(<sup>1</sup>長崎大・<sup>2</sup>東大) ◎楊 益鳴<sup>1</sup>・堀内 新之介<sup>2</sup>・尾本 賢⼀郎<sup>1</sup>・作⽥ 絵⾥<sup>1</sup>・有川 康弘<sup>1</sup>・⾺越 啓介<sup>1</sup>",
      "Hierarchical Assemblies of Unsymmetric Pt Complexes with Ag ions: Two Types of Assembling Modes Depended on the Remote Ancillary Group in the Organic Ligands",
      "(<sup>1</sup>Nagasaki Univ., <sup>2</sup>The Univ. of Tokyo) ◎Yiming Yang<sup>1</sup>, Shinnosuke Horiuchi<sup>2</sup>, Kenichiro Omoto<sup>1</sup>, Eri Sakuda<sup>1</sup>, Yasuhiro Arikawa<sup>1</sup>, Keisuke  Umakoshi<sup>1</sup>"
    ],
    "lab": "1PA-07",
    "pdf": "pdf/1PA-07.pdf",
    "pre": "tn/1PA-07.jpg",
    "reg": "74063",
    "sea": "Pt, Ag",
    "ses": "1PA",
    "con": "1PA-07 非対称な単核白金錯体と銀イオンの反応によって生成する階層的集合構造の確認とその光物性 (<sup>1</sup>長崎大・<sup>2</sup>東大) ◎楊 益鳴<sup>1</sup>・堀内 新之介<sup>2</sup>・尾本 賢⼀郎<sup>1</sup>・作⽥ 絵⾥<sup>1</sup>・有川 康弘<sup>1</sup>・⾺越 啓介<sup>1</sup> Hierarchical Assemblies of Unsymmetric Pt Complexes with Ag ions: Two Types of Assembling Modes Depended on the Remote Ancillary Group in the Organic Ligands (<sup>1</sup>Nagasaki Univ., <sup>2</sup>The Univ. of Tokyo) ◎Yiming Yang<sup>1</sup>, Shinnosuke Horiuchi<sup>2</sup>, Kenichiro Omoto<sup>1</sup>, Eri Sakuda<sup>1</sup>, Yasuhiro Arikawa<sup>1</sup>, Keisuke  Umakoshi<sup>1</sup> Pt, Ag"
  },
  {
    "inf": [
      "Characterization and Chemical Behavior of Ruthenium(II)-dmso Complex with Methyl-picolinate",
      "(<sup>1</sup>Kyoto Univ., <sup>2</sup>Osaka Electro-Communication Univ., <sup>3</sup>Meiji Univ.) 〇Mari TOYAMA<sup>1,2,3</sup>, Yuto ONISHI<sup>2</sup>, Noriharu NAGAO<sup>3</sup>"
    ],
    "lab": "1PA-08",
    "pdf": "pdf/1PA-08.pdf",
    "pre": "tn/1PA-08.jpg",
    "reg": "74023",
    "sea": "Ru",
    "ses": "1PA",
    "con": "1PA-08 Characterization and Chemical Behavior of Ruthenium(II)-dmso Complex with Methyl-picolinate (<sup>1</sup>Kyoto Univ., <sup>2</sup>Osaka Electro-Communication Univ., <sup>3</sup>Meiji Univ.) 〇Mari TOYAMA<sup>1,2,3</sup>, Yuto ONISHI<sup>2</sup>, Noriharu NAGAO<sup>3</sup> Ru"
  },
  {
    "inf": [
      "配位特性が異なる三価の金属イオンを導入した配位高分子の合成",
      "(<sup>1</sup>東理大院理) 〇橋本 脩平<sup>1</sup>・貞清 正彰<sup>1</sup>",
      "Synthesis of Metal–Organic Frameworks Including Trivalent Metal Ions with Different Coordination Properties",
      "(<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Shuhei HASHIMOTO<sup>1</sup>, Masaaki SADAKIYO<sup>1</sup>"
    ],
    "lab": "1PA-09",
    "pdf": "pdf/1PA-09.pdf",
    "pre": "tn/1PA-09.jpg",
    "reg": "74295",
    "sea": "Zr, Cr, Ga",
    "ses": "1PA",
    "con": "1PA-09 配位特性が異なる三価の金属イオンを導入した配位高分子の合成 (<sup>1</sup>東理大院理) 〇橋本 脩平<sup>1</sup>・貞清 正彰<sup>1</sup> Synthesis of Metal–Organic Frameworks Including Trivalent Metal Ions with Different Coordination Properties (<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Shuhei HASHIMOTO<sup>1</sup>, Masaaki SADAKIYO<sup>1</sup> Zr, Cr, Ga"
  },
  {
    "inf": [
      "環状ポリオキソメタレートを利用したニッケルナノクラスターの合成",
      "(<sup>1</sup>東大院工) ◎平尾 翔<sup></sup>・小泉 慶洋<sup></sup>・米里 健太郎<sup></sup>・鈴木 康介<sup></sup>・山口 和也<sup></sup>",
      "Synthesis of Nickel Nanoclusters Using Ring-Shaped Polyoxometalates",
      "(<sup>1</sup>School of Engineering, University of Tokyo) ◎Kakeru HIRAO<sup></sup>, Yoshihiro KOIZUMI<sup></sup>, Kentaro YONESATO<sup></sup>, Kosuke SUZUKI<sup></sup>, Kazuya YAMAGUCHI<sup></sup>"
    ],
    "lab": "1PA-10",
    "pdf": "pdf/1PA-10.pdf",
    "pre": "tn/1PA-10.jpg",
    "reg": "74113",
    "sea": "Ni, W",
    "ses": "1PA",
    "con": "1PA-10 環状ポリオキソメタレートを利用したニッケルナノクラスターの合成 (<sup>1</sup>東大院工) ◎平尾 翔<sup></sup>・小泉 慶洋<sup></sup>・米里 健太郎<sup></sup>・鈴木 康介<sup></sup>・山口 和也<sup></sup> Synthesis of Nickel Nanoclusters Using Ring-Shaped Polyoxometalates (<sup>1</sup>School of Engineering, University of Tokyo) ◎Kakeru HIRAO<sup></sup>, Yoshihiro KOIZUMI<sup></sup>, Kentaro YONESATO<sup></sup>, Kosuke SUZUKI<sup></sup>, Kazuya YAMAGUCHI<sup></sup> Ni, W"
  },
  {
    "inf": [
      "Synthesis and magnetic properties of          cyanido-bridged Fe<sup>II</sup>          -W<sup>IV</sup> complex          incorporating three types of organic ligands",
      "(<sup>1</sup>筑波大院数理, <sup>2</sup>東大院理) 〇Daiki Kobayashi<sup>1</sup>, Shuntaro Nagashima<sup>1</sup>, Junhao Wang<sup>1</sup>, Shin-ichi Ohkoshi<sup>2</sup>, Hiroko Tokoro<sup>1</sup>"
    ],
    "lab": "1PA-11",
    "pdf": "pdf/1PA-11.pdf",
    "pre": "tn/1PA-11.jpg",
    "reg": "74100",
    "sea": "Fe,W",
    "ses": "1PA",
    "con": "1PA-11 Synthesis and magnetic properties of          cyanido-bridged Fe<sup>II</sup>          -W<sup>IV</sup> complex          incorporating three types of organic ligands (<sup>1</sup>筑波大院数理, <sup>2</sup>東大院理) 〇Daiki Kobayashi<sup>1</sup>, Shuntaro Nagashima<sup>1</sup>, Junhao Wang<sup>1</sup>, Shin-ichi Ohkoshi<sup>2</sup>, Hiroko Tokoro<sup>1</sup> Fe,W"
  },
  {
    "inf": [
      "Soma-Iwamoto type cyano coordination polymer [Fe(Quinazoline)<sub>2</sub>[Au(CN)<sub>2</sub>]<sub>2</sub>]",
      "(<sup>1</sup>Toho Univ.) 〇Kosuke Kitase<sup>1</sup>, Daisuke Akahoshi<sup>1</sup>, Takafumi Kitazawa<sup>1</sup>"
    ],
    "lab": "1PA-12",
    "pdf": "pdf/1PA-12.pdf",
    "pre": "tn/1PA-12.jpg",
    "reg": "74197",
    "sea": "Fe, Au",
    "ses": "1PA",
    "con": "1PA-12 Soma-Iwamoto type cyano coordination polymer [Fe(Quinazoline)<sub>2</sub>[Au(CN)<sub>2</sub>]<sub>2</sub>] (<sup>1</sup>Toho Univ.) 〇Kosuke Kitase<sup>1</sup>, Daisuke Akahoshi<sup>1</sup>, Takafumi Kitazawa<sup>1</sup> Fe, Au"
  },
  {
    "inf": [
      "溶液中で熱的に安定なパラジウム-白金バイメタルサイトを有するケギン型ポリオキソタングステートの合成",
      "(<sup>1</sup>静大院理) ◎杉浦 生<sup>1</sup>・加藤 知香<sup>1</sup>",
      "Synthesis of Keggin-type polyoxotungstate with a thermally stable palladium-platinum bimetal site in solution",
      "(<sup>1</sup>Shizuoka Univ.) ◎Ikiru SUGIURA<sup>1</sup>, Chika KATO<sup>1</sup>"
    ],
    "lab": "1PA-13",
    "pdf": "pdf/1PA-13.pdf",
    "pre": "tn/1PA-13.jpg",
    "reg": "74118",
    "sea": "W, Pt, Pd",
    "ses": "1PA",
    "con": "1PA-13 溶液中で熱的に安定なパラジウム-白金バイメタルサイトを有するケギン型ポリオキソタングステートの合成 (<sup>1</sup>静大院理) ◎杉浦 生<sup>1</sup>・加藤 知香<sup>1</sup> Synthesis of Keggin-type polyoxotungstate with a thermally stable palladium-platinum bimetal site in solution (<sup>1</sup>Shizuoka Univ.) ◎Ikiru SUGIURA<sup>1</sup>, Chika KATO<sup>1</sup> W, Pt, Pd"
  },
  {
    "inf": [
      "マグネシウム塩を包接したMIL-101類縁体の合成",
      "(<sup>1</sup>東理大院理) 〇薄井 綾香<sup>1</sup>・貞清 正彰<sup>1</sup>",
      "Synthesis of MIL-101 analogues including magnesium salt",
      "(<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Ayaka USUI<sup>1</sup>, Masaaki SADAKIYO<sup>1</sup>"
    ],
    "lab": "1PA-14",
    "pdf": "pdf/1PA-14.pdf",
    "pre": "tn/1PA-14.jpg",
    "reg": "74442",
    "sea": "Cr, Mg",
    "ses": "1PA",
    "con": "1PA-14 マグネシウム塩を包接したMIL-101類縁体の合成 (<sup>1</sup>東理大院理) 〇薄井 綾香<sup>1</sup>・貞清 正彰<sup>1</sup> Synthesis of MIL-101 analogues including magnesium salt (<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Ayaka USUI<sup>1</sup>, Masaaki SADAKIYO<sup>1</sup> Cr, Mg"
  },
  {
    "inf": [
      "Studies on ferroelectricity coupled with proton conduction in a non-polar Na<sub>2</sub>MnN(CN)<sub>4</sub>·3H<sub>2</sub>O",
      "(<sup>1</sup>Kyushu Univ.) 〇YUXIN SHI<sup>1</sup>, Ryo Ohtani<sup>1</sup>, Masaaki Ohba<sup>1</sup>"
    ],
    "lab": "1PA-15",
    "pdf": "pdf/1PA-15.pdf",
    "pre": "tn/1PA-15.jpg",
    "reg": "74240",
    "sea": "Na,Mn",
    "ses": "1PA",
    "con": "1PA-15 Studies on ferroelectricity coupled with proton conduction in a non-polar Na<sub>2</sub>MnN(CN)<sub>4</sub>·3H<sub>2</sub>O (<sup>1</sup>Kyushu Univ.) 〇YUXIN SHI<sup>1</sup>, Ryo Ohtani<sup>1</sup>, Masaaki Ohba<sup>1</sup> Na,Mn"
  },
  {
    "inf": [
      "含窒素芳香族部位を有するエチレンジアミン型五座配位子を含む銅(Ⅱ)単核錯体の構造と電気化学的特性",
      "(<sup>1</sup>奈良女大院人間文化・<sup>2</sup>奈良女大共生セ) ◎明渡 美結<sup>1</sup>・濵本 絵里奈<sup>1</sup>・吉田 祥子<sup>1</sup>・庄司 淳<sup>1</sup>・三方 裕司<sup>1,2</sup>",
      "Structure and Electrochemical Properties of Mononuclear Copper(Ⅱ) Complexes with Ethylenediamine-Based Pentadentate Ligands bearing Heteroaromatic Moieties",
      "(<sup>1</sup>Graduate School of Humanities and Sciences, <sup>2</sup>KYOUSEI Science Center, Nara Women's University) ◎Miyu Akedo<sup>1</sup>, Erina HAMAMOTO<sup>1</sup>, Shoko YOSHIDA<sup>1</sup>, Sunao SHOJI<sup>1</sup>, Yuji MIKATA<sup>1,2</sup>"
    ],
    "lab": "1PA-16",
    "pdf": "pdf/1PA-16.pdf",
    "pre": "tn/1PA-16.jpg",
    "reg": "74148",
    "sea": "Cu",
    "ses": "1PA",
    "con": "1PA-16 含窒素芳香族部位を有するエチレンジアミン型五座配位子を含む銅(Ⅱ)単核錯体の構造と電気化学的特性 (<sup>1</sup>奈良女大院人間文化・<sup>2</sup>奈良女大共生セ) ◎明渡 美結<sup>1</sup>・濵本 絵里奈<sup>1</sup>・吉田 祥子<sup>1</sup>・庄司 淳<sup>1</sup>・三方 裕司<sup>1,2</sup> Structure and Electrochemical Properties of Mononuclear Copper(Ⅱ) Complexes with Ethylenediamine-Based Pentadentate Ligands bearing Heteroaromatic Moieties (<sup>1</sup>Graduate School of Humanities and Sciences, <sup>2</sup>KYOUSEI Science Center, Nara Women's University) ◎Miyu Akedo<sup>1</sup>, Erina HAMAMOTO<sup>1</sup>, Shoko YOSHIDA<sup>1</sup>, Sunao SHOJI<sup>1</sup>, Yuji MIKATA<sup>1,2</sup> Cu"
  },
  {
    "inf": [
      "Enhancement of Phosphorescence Efficiency and Photocatalytic Activity of IrAu<sub>12</sub> Cluster by Introducing Iodide Ligands",
      "(<sup>1</sup>Graduate School of Science, The University of Tokyo) 〇Haru HIRAI<sup>1</sup>, Shinjiro TAKANO<sup>1</sup>, Shinya MASUDA<sup>1</sup>, Tatsuya TSUKUDA<sup>1</sup>"
    ],
    "lab": "1PA-17",
    "pdf": "pdf/1PA-17.pdf",
    "pre": "tn/1PA-17.jpg",
    "reg": "74351",
    "sea": "Au, Ir",
    "ses": "1PA",
    "con": "1PA-17 Enhancement of Phosphorescence Efficiency and Photocatalytic Activity of IrAu<sub>12</sub> Cluster by Introducing Iodide Ligands (<sup>1</sup>Graduate School of Science, The University of Tokyo) 〇Haru HIRAI<sup>1</sup>, Shinjiro TAKANO<sup>1</sup>, Shinya MASUDA<sup>1</sup>, Tatsuya TSUKUDA<sup>1</sup> Au, Ir"
  },
  {
    "inf": [
      "Interfacial synthesis and electronic functions of bis(terpyridine)copper(II) nanosheets",
      "(<sup>1</sup>Tokyo University of Science, Research Institute for Science and Technology, <sup>2</sup>Karlsruhe Institute of Technology, Institute of Nanotechnology, <sup>3</sup>Kyoto Institute of Technology, Faculty of Fiber Science and Engineering, <sup>4</sup>RIKEN SPring-8 Center, <sup>5</sup>Japan Synchrotron Radiation Research Institute) 〇Kenji TAKADA<sup>1</sup>, Joe KOMEDA<sup>2</sup>, Hiroaki MAEDA<sup>1</sup>, Naoya FUKUI<sup>1</sup>, Sono SASAKI<sup>3,4</sup>, Hiroyasu MASUNAGA<sup>5</sup>, Hiroshi NISHIHARA<sup>1</sup>"
    ],
    "lab": "1PA-18",
    "pdf": "pdf/1PA-18.pdf",
    "pre": "tn/1PA-18.jpg",
    "reg": "74354",
    "sea": "Cu",
    "ses": "1PA",
    "con": "1PA-18 Interfacial synthesis and electronic functions of bis(terpyridine)copper(II) nanosheets (<sup>1</sup>Tokyo University of Science, Research Institute for Science and Technology, <sup>2</sup>Karlsruhe Institute of Technology, Institute of Nanotechnology, <sup>3</sup>Kyoto Institute of Technology, Faculty of Fiber Science and Engineering, <sup>4</sup>RIKEN SPring-8 Center, <sup>5</sup>Japan Synchrotron Radiation Research Institute) 〇Kenji TAKADA<sup>1</sup>, Joe KOMEDA<sup>2</sup>, Hiroaki MAEDA<sup>1</sup>, Naoya FUKUI<sup>1</sup>, Sono SASAKI<sup>3,4</sup>, Hiroyasu MASUNAGA<sup>5</sup>, Hiroshi NISHIHARA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "NHC を支持配位子とする Fe<sub>4</sub>S<sub>4</sub> ハライドクラスターの合成と反応性",
      "(<sup>1</sup>阪公大院理) ◎中山 雅記<sup>1</sup>・矢野 龍玄<sup>1</sup>・竹本 真<sup>1</sup>・松坂 裕之<sup>1</sup>",
      "Synthesis and Reactivity of NHC-Supported Fe<sub>4</sub>S<sub>4</sub> Halide Clusters",
      "(<sup>1</sup>Osaka Metropolitan Univ.) ◎Masaki NAKAYAMA<sup>1</sup>, Ryugen YANO<sup>1</sup>, Shin TAKEMOTO<sup>1</sup>, Hiroyuki MATSUZAKA<sup>1</sup>"
    ],
    "lab": "1PA-19",
    "pdf": "pdf/1PA-19.pdf",
    "pre": "tn/1PA-19.jpg",
    "reg": "74174",
    "sea": "Fe",
    "ses": "1PA",
    "con": "1PA-19 NHC を支持配位子とする Fe<sub>4</sub>S<sub>4</sub> ハライドクラスターの合成と反応性 (<sup>1</sup>阪公大院理) ◎中山 雅記<sup>1</sup>・矢野 龍玄<sup>1</sup>・竹本 真<sup>1</sup>・松坂 裕之<sup>1</sup> Synthesis and Reactivity of NHC-Supported Fe<sub>4</sub>S<sub>4</sub> Halide Clusters (<sup>1</sup>Osaka Metropolitan Univ.) ◎Masaki NAKAYAMA<sup>1</sup>, Ryugen YANO<sup>1</sup>, Shin TAKEMOTO<sup>1</sup>, Hiroyuki MATSUZAKA<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Syntheses, crystal structures, and photophysical properties of copper(I) halogenido complex assemblies with hydrogen bonds",
      "(<sup>1</sup>School of Science, University of Toyama) 〇Atsushi TAKAMORI<sup>1</sup>, Hideki OHTSU<sup>1</sup>, Kiyoshi TSUGE<sup>1</sup>"
    ],
    "lab": "1PA-20",
    "pdf": "pdf/1PA-20.pdf",
    "pre": "tn/1PA-20.jpg",
    "reg": "74362",
    "sea": "Cu",
    "ses": "1PA",
    "con": "1PA-20 Syntheses, crystal structures, and photophysical properties of copper(I) halogenido complex assemblies with hydrogen bonds (<sup>1</sup>School of Science, University of Toyama) 〇Atsushi TAKAMORI<sup>1</sup>, Hideki OHTSU<sup>1</sup>, Kiyoshi TSUGE<sup>1</sup> Cu"
  },
  {
    "inf": [
      "**Inner-space Modification of a {Mo<sub>132</sub>} Cage Host with Thiol-appended Carboxylate Ligands**",
      "(<sup>1</sup>Grad. School of Env. Sci., Hokkaido Univ., <sup>2</sup>Fac. of Env. Earth Sci., Hokkaido Univ.) 〇Md Mahedi Hassan<sup>1</sup>, Akari Nakashuku<sup>1</sup>, Yukatsu Shichibu<sup>1,2</sup>, Katsuaki Konishi<sup>1,2</sup>"
    ],
    "lab": "1PA-21",
    "pdf": "pdf/1PA-21.pdf",
    "pre": "tn/1PA-21.jpg",
    "reg": "74382",
    "sea": "Mo",
    "ses": "1PA",
    "con": "1PA-21 **Inner-space Modification of a {Mo<sub>132</sub>} Cage Host with Thiol-appended Carboxylate Ligands** (<sup>1</sup>Grad. School of Env. Sci., Hokkaido Univ., <sup>2</sup>Fac. of Env. Earth Sci., Hokkaido Univ.) 〇Md Mahedi Hassan<sup>1</sup>, Akari Nakashuku<sup>1</sup>, Yukatsu Shichibu<sup>1,2</sup>, Katsuaki Konishi<sup>1,2</sup> Mo"
  },
  {
    "inf": [
      "Cu<sub>4</sub>I<sub>4</sub>クラウンモチーフを有する_i_-mnt錯体の合成と構造制御",
      "(<sup>1</sup>近畿大理工・<sup>2</sup>近畿大理工総研) ◎田中 俊丞<sup>1</sup>・GOO Zi Lang<sup>1</sup>・竹入 史隆<sup>1</sup>・前川 雅彦<sup>2</sup>・黒田 孝義<sup>1</sup>・杉本 邦久<sup>1</sup>",
      "**Syntheses and Structural Control of Square Planar _i_-mnt Coordination Complexes Decorated with Cu<sub>4</sub>I<sub>4</sub> Crown Motif**",
      "(<sup>1</sup>Faculty of Science of Engineering, Kindai University, <sup>2</sup>Research Institute of Science and and Technology, Kindai University) ◎Shunsuke TANAKA<sup>1</sup>, Zi Lang GOO<sup>1</sup>, Fumitaka TAKEIRI<sup>1</sup>, Masahiko MAEKAWA<sup>2</sup>, Takayoshi KURODA-SOWA<sup>1</sup>, Kunihisa SUGIMOTO<sup>1</sup>"
    ],
    "lab": "1PA-22",
    "pdf": "pdf/1PA-22.pdf",
    "pre": "tn/1PA-22.jpg",
    "reg": "74187",
    "sea": "Ni, Pd, Pt, Cu",
    "ses": "1PA",
    "con": "1PA-22 Cu<sub>4</sub>I<sub>4</sub>クラウンモチーフを有する_i_-mnt錯体の合成と構造制御 (<sup>1</sup>近畿大理工・<sup>2</sup>近畿大理工総研) ◎田中 俊丞<sup>1</sup>・GOO Zi Lang<sup>1</sup>・竹入 史隆<sup>1</sup>・前川 雅彦<sup>2</sup>・黒田 孝義<sup>1</sup>・杉本 邦久<sup>1</sup> **Syntheses and Structural Control of Square Planar _i_-mnt Coordination Complexes Decorated with Cu<sub>4</sub>I<sub>4</sub> Crown Motif** (<sup>1</sup>Faculty of Science of Engineering, Kindai University, <sup>2</sup>Research Institute of Science and and Technology, Kindai University) ◎Shunsuke TANAKA<sup>1</sup>, Zi Lang GOO<sup>1</sup>, Fumitaka TAKEIRI<sup>1</sup>, Masahiko MAEKAWA<sup>2</sup>, Takayoshi KURODA-SOWA<sup>1</sup>, Kunihisa SUGIMOTO<sup>1</sup> Ni, Pd, Pt, Cu"
  },
  {
    "inf": [
      "Synthesis of heterometallic coordination nanosheet from colloidal platinadithiolene nanosheet coordinating to various metal ions",
      "(<sup>1</sup>Research Institute for Science and Technology, Tokyo University of Science, <sup>2</sup>Graduate School of Science and Technology, Tokyo University of Science) 〇Naoya Fukui<sup>1</sup>, Marie Suzuki<sup>1</sup>, Katsuya Mizuno<sup>1</sup>, Kenji Takada<sup>1</sup>, Hiroaki Maeda<sup>1</sup>, Hiroshi Nishihara<sup>1,2</sup>"
    ],
    "lab": "1PA-23",
    "pdf": "pdf/1PA-23.pdf",
    "pre": "tn/1PA-23.jpg",
    "reg": "74383",
    "sea": "Pt",
    "ses": "1PA",
    "con": "1PA-23 Synthesis of heterometallic coordination nanosheet from colloidal platinadithiolene nanosheet coordinating to various metal ions (<sup>1</sup>Research Institute for Science and Technology, Tokyo University of Science, <sup>2</sup>Graduate School of Science and Technology, Tokyo University of Science) 〇Naoya Fukui<sup>1</sup>, Marie Suzuki<sup>1</sup>, Katsuya Mizuno<sup>1</sup>, Kenji Takada<sup>1</sup>, Hiroaki Maeda<sup>1</sup>, Hiroshi Nishihara<sup>1,2</sup> Pt"
  },
  {
    "inf": [
      "A Syntheses and Characterization of Coordination Compounds",
      "(<sup>1</sup>TITech.) 〇Rui CHENG<sup>1</sup>, Xianjun LI<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Mio KONDO<sup>1</sup>"
    ],
    "lab": "1PA-24",
    "pdf": "pdf/1PA-24.pdf",
    "pre": "tn/1PA-24.jpg",
    "reg": "74398",
    "sea": "Fe, Ni",
    "ses": "1PA",
    "con": "1PA-24 A Syntheses and Characterization of Coordination Compounds (<sup>1</sup>TITech.) 〇Rui CHENG<sup>1</sup>, Xianjun LI<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Mio KONDO<sup>1</sup> Fe, Ni"
  },
  {
    "inf": [
      "M<sub>60</sub>L<sub>60</sub>ペプチドケージの空間活用に向けた官能基修飾",
      "(<sup>1</sup>東京工業大学 化生研・<sup>2</sup>JSTさきがけ) ◎日野 栞<sup>1</sup>・吉沢 道人<sup>1</sup>・澤田 知久<sup>1,2</sup>",
      "Inner chemical modification of an M<sub>60</sub>L<sub>60</sub> peptide cage for the cavity utilization",
      "(<sup>1</sup>Lab. for Chem. & Life Sci., Tokyo Tech, <sup>2</sup>JST PRESTO) ◎Shiori HINO<sup>1</sup>, Michito YOSHIZAWA<sup>1</sup>, Tomohisa SAWADA<sup>1,2</sup>"
    ],
    "lab": "1PA-25",
    "pdf": "pdf/1PA-25.pdf",
    "pre": "tn/1PA-25.jpg",
    "reg": "74194",
    "sea": "Cu",
    "ses": "1PA",
    "con": "1PA-25 M<sub>60</sub>L<sub>60</sub>ペプチドケージの空間活用に向けた官能基修飾 (<sup>1</sup>東京工業大学 化生研・<sup>2</sup>JSTさきがけ) ◎日野 栞<sup>1</sup>・吉沢 道人<sup>1</sup>・澤田 知久<sup>1,2</sup> Inner chemical modification of an M<sub>60</sub>L<sub>60</sub> peptide cage for the cavity utilization (<sup>1</sup>Lab. for Chem. & Life Sci., Tokyo Tech, <sup>2</sup>JST PRESTO) ◎Shiori HINO<sup>1</sup>, Michito YOSHIZAWA<sup>1</sup>, Tomohisa SAWADA<sup>1,2</sup> Cu"
  },
  {
    "inf": [
      "Photo-induced spin crossover in an iron-octacyanidoniobate complex with organic ligands bridging Fe(II) sites",
      "(<sup>1</sup>The university of Tokyo) 〇Itsuki Fukagawa<sup>1</sup>, Shota Kobayashi<sup>1</sup>, Kenta Imoto<sup>1</sup>, Koji Nakabayashi<sup>1</sup>, Kazuki Nakamura<sup>1</sup>, Guanping Li<sup>1</sup>, Yuuki Mineo<sup>1</sup>, Shin-ichi Ohkoshi<sup>1</sup>"
    ],
    "lab": "1PA-26",
    "pdf": "pdf/1PA-26.pdf",
    "pre": "tn/1PA-26.jpg",
    "reg": "74429",
    "sea": "Fe, Nb",
    "ses": "1PA",
    "con": "1PA-26 Photo-induced spin crossover in an iron-octacyanidoniobate complex with organic ligands bridging Fe(II) sites (<sup>1</sup>The university of Tokyo) 〇Itsuki Fukagawa<sup>1</sup>, Shota Kobayashi<sup>1</sup>, Kenta Imoto<sup>1</sup>, Koji Nakabayashi<sup>1</sup>, Kazuki Nakamura<sup>1</sup>, Guanping Li<sup>1</sup>, Yuuki Mineo<sup>1</sup>, Shin-ichi Ohkoshi<sup>1</sup> Fe, Nb"
  },
  {
    "inf": [
      "Microwave synthesis and carbon dioxide adsorption properties of one-dimensional copper coordination polymers with paddle-wheel dimer units",
      "(<sup>1</sup>Graduate School of Environmental Science, Hokkaido University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Yuhong Yin<sup>1</sup>, Xin Zheng<sup>1,2</sup>, Yuki Saito <sup>1,2</sup>, Shin-ichiro Noro <sup>1,2</sup>"
    ],
    "lab": "1PA-27",
    "pdf": "pdf/1PA-27.pdf",
    "pre": "tn/1PA-27.jpg",
    "reg": "74438",
    "sea": "Cu",
    "ses": "1PA",
    "con": "1PA-27 Microwave synthesis and carbon dioxide adsorption properties of one-dimensional copper coordination polymers with paddle-wheel dimer units (<sup>1</sup>Graduate School of Environmental Science, Hokkaido University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Yuhong Yin<sup>1</sup>, Xin Zheng<sup>1,2</sup>, Yuki Saito <sup>1,2</sup>, Shin-ichiro Noro <sup>1,2</sup> Cu"
  },
  {
    "inf": [
      "窒素上にベンゾイミダゾリルメチル基を有するイミダゾリウム塩あるいはその脱プロトン化体が配位したニッケル(II)錯体の合成、結晶構造および色変化挙動",
      "(<sup>1</sup>弘前大院理工) ◎村上 辰成<sup>1</sup>・岡崎 雅明<sup>1</sup>・太田 俊<sup>1</sup>",
      "Synthesis, Crystal Structures, and Color Change Behavior of Ni(II) Complexes Coordinated by N-Benzimidazolylmethylated Imidazolium Salts or Their Deprotonated Forms",
      "(<sup>1</sup>Gad. Sch. of Sci. and Tech., Hirosaki Univ.) ◎Tatsunari MURAKAMI<sup>1</sup>, Masaaki OKAZAKI<sup>1</sup>, Shun OHTA<sup>1</sup>"
    ],
    "lab": "1PA-28",
    "pdf": "pdf/1PA-28.pdf",
    "pre": "tn/1PA-28.jpg",
    "reg": "74220",
    "sea": "Ni",
    "ses": "1PA",
    "con": "1PA-28 窒素上にベンゾイミダゾリルメチル基を有するイミダゾリウム塩あるいはその脱プロトン化体が配位したニッケル(II)錯体の合成、結晶構造および色変化挙動 (<sup>1</sup>弘前大院理工) ◎村上 辰成<sup>1</sup>・岡崎 雅明<sup>1</sup>・太田 俊<sup>1</sup> Synthesis, Crystal Structures, and Color Change Behavior of Ni(II) Complexes Coordinated by N-Benzimidazolylmethylated Imidazolium Salts or Their Deprotonated Forms (<sup>1</sup>Gad. Sch. of Sci. and Tech., Hirosaki Univ.) ◎Tatsunari MURAKAMI<sup>1</sup>, Masaaki OKAZAKI<sup>1</sup>, Shun OHTA<sup>1</sup> Ni"
  },
  {
    "inf": [
      "Based on Cobalt Polyoxometalates Immobilized in Metal Organic Frameworks for Photocatalytic Water Oxidation",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Daokuan LI<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "1PA-29",
    "pdf": "pdf/1PA-29.pdf",
    "pre": "tn/1PA-29.jpg",
    "reg": "74531",
    "sea": "Co, Ru",
    "ses": "1PA",
    "con": "1PA-29 Based on Cobalt Polyoxometalates Immobilized in Metal Organic Frameworks for Photocatalytic Water Oxidation (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Daokuan LI<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Co, Ru"
  },
  {
    "inf": [
      "Single-crystal X-ray crystallographic evidence of polyanion vacancies in (NH<sub>4</sub>)<sub>4</sub>[ɑ-SiW<sub>12</sub>O<sub>40</sub>] Keggin-type polyoxometalate          ",
      "(<sup>1</sup>Hiroshima Univ., <sup>2</sup>Tokyo Univ.) 〇Sugiarto<sup>1</sup>, Yuta Yamada<sup>2</sup>, Tsukasa Iwano<sup>2</sup>, Sayaka Uchida<sup>2</sup>, Masahiro Sadakane<sup>1</sup>"
    ],
    "lab": "1PA-30",
    "pdf": "pdf/1PA-30.pdf",
    "pre": "tn/1PA-30.jpg",
    "reg": "74559",
    "sea": "W",
    "ses": "1PA",
    "con": "1PA-30 Single-crystal X-ray crystallographic evidence of polyanion vacancies in (NH<sub>4</sub>)<sub>4</sub>[ɑ-SiW<sub>12</sub>O<sub>40</sub>] Keggin-type polyoxometalate           (<sup>1</sup>Hiroshima Univ., <sup>2</sup>Tokyo Univ.) 〇Sugiarto<sup>1</sup>, Yuta Yamada<sup>2</sup>, Tsukasa Iwano<sup>2</sup>, Sayaka Uchida<sup>2</sup>, Masahiro Sadakane<sup>1</sup> W"
  },
  {
    "inf": [
      "π曲面を有するお椀型イミン配位子の合成と多核錯体の形成",
      "(<sup>1</sup>金沢大院自然・<sup>2</sup>金沢大NanoLSI) ◎池上 耕亮<sup>1</sup>・秋根 茂久<sup>1,2</sup>",
      "Synthesis of bowl-shaped imine ligands with π-curved surfaces and formation of multinuclear complexes",
      "(<sup>1</sup>Grad. Sch. of Nat. Sci. and Tech., Kanazawa Univ., <sup>2</sup>NanoLSI, Kanazawa Univ.) ◎Kosuke IKEGAMI<sup>1</sup>, Shigehisa AKINE<sup>1,2</sup>"
    ],
    "lab": "1PA-31",
    "pdf": "pdf/1PA-31.pdf",
    "pre": "tn/1PA-31.jpg",
    "reg": "74241",
    "sea": "Ni",
    "ses": "1PA",
    "con": "1PA-31 π曲面を有するお椀型イミン配位子の合成と多核錯体の形成 (<sup>1</sup>金沢大院自然・<sup>2</sup>金沢大NanoLSI) ◎池上 耕亮<sup>1</sup>・秋根 茂久<sup>1,2</sup> Synthesis of bowl-shaped imine ligands with π-curved surfaces and formation of multinuclear complexes (<sup>1</sup>Grad. Sch. of Nat. Sci. and Tech., Kanazawa Univ., <sup>2</sup>NanoLSI, Kanazawa Univ.) ◎Kosuke IKEGAMI<sup>1</sup>, Shigehisa AKINE<sup>1,2</sup> Ni"
  },
  {
    "inf": [
      "Synthesis and perchlorate anion removal properties of cobalt coordination polymer",
      "(<sup>1</sup>Graduate School of Environmental Science, Hokkaido University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Umme Fariha Tasnim<sup>1</sup>, Aditya Irfan Witono<sup>1</sup>, Xin Zheng<sup>1,2</sup>, Shin-ichiro Noro<sup>1,2</sup>"
    ],
    "lab": "1PA-32",
    "pdf": "pdf/1PA-32.pdf",
    "pre": "tn/1PA-32.jpg",
    "reg": "74443",
    "sea": "Co",
    "ses": "1PA",
    "con": "1PA-32 Synthesis and perchlorate anion removal properties of cobalt coordination polymer (<sup>1</sup>Graduate School of Environmental Science, Hokkaido University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Umme Fariha Tasnim<sup>1</sup>, Aditya Irfan Witono<sup>1</sup>, Xin Zheng<sup>1,2</sup>, Shin-ichiro Noro<sup>1,2</sup> Co"
  },
  {
    "inf": [
      "The Efficiency and the Mechanism of Amide-UIO-68 Photocatalyst for CO<sub>2</sub> Reduction Reaction",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ. ) 〇Tongsa YANG<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "1PA-33",
    "pdf": "pdf/1PA-33.pdf",
    "pre": "tn/1PA-33.jpg",
    "reg": "74570",
    "sea": "Ru, Zr, Pt",
    "ses": "1PA",
    "con": "1PA-33 The Efficiency and the Mechanism of Amide-UIO-68 Photocatalyst for CO<sub>2</sub> Reduction Reaction (<sup>1</sup>Dept. Chem. Kyushu Univ. ) 〇Tongsa YANG<sup>1</sup>, Ken SAKAI<sup>1</sup> Ru, Zr, Pt"
  },
  {
    "inf": [
      "ジシラン架橋環状分子の光物性における溶媒効果",
      "(<sup>1</sup>東大院理) ◎金子 友哉<sup>1</sup>・山野井 慶徳<sup>1</sup>・山田 鉄兵<sup>1</sup>",
      "Solvent Effects on Photophysical Properties of Disilane-Bridged Cyclic Molecules",
      "(<sup>1</sup>The Univ. of Tokyo) ◎Yuya Kaneko<sup>1</sup>, Yoshinori Yamanoi<sup>1</sup>, Teppei Yamada<sup>1</sup>"
    ],
    "lab": "1PA-34",
    "pdf": "pdf/1PA-34.pdf",
    "pre": "tn/1PA-34.jpg",
    "reg": "74247",
    "sea": "Si",
    "ses": "1PA",
    "con": "1PA-34 ジシラン架橋環状分子の光物性における溶媒効果 (<sup>1</sup>東大院理) ◎金子 友哉<sup>1</sup>・山野井 慶徳<sup>1</sup>・山田 鉄兵<sup>1</sup> Solvent Effects on Photophysical Properties of Disilane-Bridged Cyclic Molecules (<sup>1</sup>The Univ. of Tokyo) ◎Yuya Kaneko<sup>1</sup>, Yoshinori Yamanoi<sup>1</sup>, Teppei Yamada<sup>1</sup> Si"
  },
  {
    "inf": [
      "Post-synthetic installation of Ln<sub>4</sub>(OH)<sub>4</sub> cubane clusters into L-cysteinato Ir<sub>4</sub>Zn<sub>4</sub> metallosupramolecular frameworks",
      "(<sup>1</sup>Graduate School of Scinece, Osaka University, <sup>2</sup>National Taiwan Normal University) Supaphorn THAMMAKAN<sup>1</sup>, Takumi KONNO<sup>1,2</sup>, 〇Nobuto YOSHINARI<sup>1</sup>"
    ],
    "lab": "1PA-35",
    "pdf": "pdf/1PA-35.pdf",
    "pre": "tn/1PA-35.jpg",
    "reg": "74571",
    "sea": "Lu",
    "ses": "1PA",
    "con": "1PA-35 Post-synthetic installation of Ln<sub>4</sub>(OH)<sub>4</sub> cubane clusters into L-cysteinato Ir<sub>4</sub>Zn<sub>4</sub> metallosupramolecular frameworks (<sup>1</sup>Graduate School of Scinece, Osaka University, <sup>2</sup>National Taiwan Normal University) Supaphorn THAMMAKAN<sup>1</sup>, Takumi KONNO<sup>1,2</sup>, 〇Nobuto YOSHINARI<sup>1</sup> Lu"
  },
  {
    "inf": [
      "Rational design of porous coordination polymers with heteroatoms-functionalized ligand for guest adsorption",
      "(<sup>1</sup>Faculty of Science, Khon Kaen Univ., <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido Univ.) 〇Jitti Suebphanpho<sup>1</sup>, Sujitra Tunsrichon<sup>1</sup>, Xin Zheng<sup>2</sup>, Shin-ichiro Noro<sup>2</sup>, Jaursup Boonmak<sup>1</sup>"
    ],
    "lab": "1PA-36",
    "pdf": "pdf/1PA-36.pdf",
    "pre": "tn/1PA-36.jpg",
    "reg": "74488",
    "sea": "Zn, Co",
    "ses": "1PA",
    "con": "1PA-36 Rational design of porous coordination polymers with heteroatoms-functionalized ligand for guest adsorption (<sup>1</sup>Faculty of Science, Khon Kaen Univ., <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido Univ.) 〇Jitti Suebphanpho<sup>1</sup>, Sujitra Tunsrichon<sup>1</sup>, Xin Zheng<sup>2</sup>, Shin-ichiro Noro<sup>2</sup>, Jaursup Boonmak<sup>1</sup> Zn, Co"
  },
  {
    "inf": [
      "オリゴエーテル鎖機能化による水溶性非イオン型ポルフィリン配位二量体の合成と光物性",
      "(<sup>1</sup>東理大院理) ◎大木 舞<sup>1</sup>・武重 レオナルド 隼人<sup>1</sup>・佐竹 彰治<sup>1</sup>",
      "Synthesis and photophysical properties of water-soluble nonionic Zn porphyrin coordination dimers through oligoether chain functionalization",
      "(<sup>1</sup>Graduate School of Science, Tokyo University of Science) ◎Mai OHKI<sup>1</sup>, Leonardo Hayato TAKESHIGE<sup>1</sup>, Akiharu SATAKE<sup>1</sup>"
    ],
    "lab": "1PA-37",
    "pdf": "pdf/1PA-37.pdf",
    "pre": "tn/1PA-37.jpg",
    "reg": "74267",
    "sea": "Zn",
    "ses": "1PA",
    "con": "1PA-37 オリゴエーテル鎖機能化による水溶性非イオン型ポルフィリン配位二量体の合成と光物性 (<sup>1</sup>東理大院理) ◎大木 舞<sup>1</sup>・武重 レオナルド 隼人<sup>1</sup>・佐竹 彰治<sup>1</sup> Synthesis and photophysical properties of water-soluble nonionic Zn porphyrin coordination dimers through oligoether chain functionalization (<sup>1</sup>Graduate School of Science, Tokyo University of Science) ◎Mai OHKI<sup>1</sup>, Leonardo Hayato TAKESHIGE<sup>1</sup>, Akiharu SATAKE<sup>1</sup> Zn"
  },
  {
    "inf": [
      "Synthesis and Magnetic Properties of Lanthanide(III) Complexes Incorporating a Tris-chelate Cobalt(III) Complex as a Metalloligand",
      "(<sup>1</sup>Inst. of Lib. Arts and Sci., Kanazawa University, <sup>2</sup>Dept. of Chem., Grad. Sch. of Nat. Sci. and Tech., Kanazawa University) 〇Ryoji MITSUHASHI<sup>1</sup>, Md. Saddam Hossain<sup>2</sup>, Yuya Imai<sup>2</sup>, Yuji Kikukawa<sup>2</sup>, Yoshihito Hayashi<sup>2</sup>"
    ],
    "lab": "1PA-38",
    "pdf": "pdf/1PA-38.pdf",
    "pre": "tn/1PA-38.jpg",
    "reg": "74577",
    "sea": "Dy, Co",
    "ses": "1PA",
    "con": "1PA-38 Synthesis and Magnetic Properties of Lanthanide(III) Complexes Incorporating a Tris-chelate Cobalt(III) Complex as a Metalloligand (<sup>1</sup>Inst. of Lib. Arts and Sci., Kanazawa University, <sup>2</sup>Dept. of Chem., Grad. Sch. of Nat. Sci. and Tech., Kanazawa University) 〇Ryoji MITSUHASHI<sup>1</sup>, Md. Saddam Hossain<sup>2</sup>, Yuya Imai<sup>2</sup>, Yuji Kikukawa<sup>2</sup>, Yoshihito Hayashi<sup>2</sup> Dy, Co"
  },
  {
    "inf": [
      "Benzoquinoline Cu(Ⅰ) thiocyanate showing luminescence and second harmonic generation",
      "(<sup>1</sup>The University of Tokyo) 〇Ryushin Kanasaki<sup>1</sup>, Kazuki Nakamura<sup>1</sup>, Kunal Kumar<sup>1</sup>, Koji Nakabayashi<sup>1</sup>, Shin-ichi Ohkoshi<sup>1</sup>"
    ],
    "lab": "1PA-39",
    "pdf": "pdf/1PA-39.pdf",
    "pre": "tn/1PA-39.jpg",
    "reg": "74594",
    "sea": "Cu",
    "ses": "1PA",
    "con": "1PA-39 Benzoquinoline Cu(Ⅰ) thiocyanate showing luminescence and second harmonic generation (<sup>1</sup>The University of Tokyo) 〇Ryushin Kanasaki<sup>1</sup>, Kazuki Nakamura<sup>1</sup>, Kunal Kumar<sup>1</sup>, Koji Nakabayashi<sup>1</sup>, Shin-ichi Ohkoshi<sup>1</sup> Cu"
  },
  {
    "inf": [
      "キャスト法による二次元 Cu<sub>3</sub>(HHTP)<sub>2</sub>配向膜の作製と評価",
      "(<sup>1</sup>東京理科大学) ◎張 啓原<sup>1</sup>・原口 知之<sup>1</sup>",
      "The Fabrication and Evaluation of Oriented 2-D Cu<sub>3</sub>(HHTP)<sub>2</sub> Thin Film by Casting Method ",
      "(<sup>1</sup>Tokyo Univ. Sci) ◎Qiyuan ZHANG<sup>1</sup>, Tomoyuki HARAGUCHI<sup>1</sup>"
    ],
    "lab": "1PA-40",
    "pdf": "pdf/1PA-40.pdf",
    "pre": "tn/1PA-40.jpg",
    "reg": "74275",
    "sea": "Cu",
    "ses": "1PA",
    "con": "1PA-40 キャスト法による二次元 Cu<sub>3</sub>(HHTP)<sub>2</sub>配向膜の作製と評価 (<sup>1</sup>東京理科大学) ◎張 啓原<sup>1</sup>・原口 知之<sup>1</sup> The Fabrication and Evaluation of Oriented 2-D Cu<sub>3</sub>(HHTP)<sub>2</sub> Thin Film by Casting Method  (<sup>1</sup>Tokyo Univ. Sci) ◎Qiyuan ZHANG<sup>1</sup>, Tomoyuki HARAGUCHI<sup>1</sup> Cu"
  },
  {
    "inf": [
      "ニトロベンゼン,及びアセトニトリルから再結晶した,白金(II)五配位正方錘型錯体の結晶構造",
      "(<sup>1</sup>福教大・<sup>2</sup>ブルカージャパン) 〇長澤 五十六<sup>1</sup>・星野 智香<sup>1</sup>・与座 健治<sup>2</sup>",
      "Crystal structures of five-coordinated square pyramidal Pt(II) complexes recrystallized from nitrobenzene and acetonitrile.",
      "(<sup>1</sup>Univ. of Teacher Education Fukuoka, <sup>2</sup>Bruker Jpn) 〇Isoroku NAGASAWA<sup>1</sup>, Satoka HOSHINO<sup>1</sup>, Kenji YOZA<sup>2</sup>"
    ],
    "lab": "1PA-41",
    "pdf": "pdf/1PA-41.pdf",
    "pre": "tn/1PA-41.jpg",
    "reg": "74007",
    "sea": "Pt",
    "ses": "1PA",
    "con": "1PA-41 ニトロベンゼン,及びアセトニトリルから再結晶した,白金(II)五配位正方錘型錯体の結晶構造 (<sup>1</sup>福教大・<sup>2</sup>ブルカージャパン) 〇長澤 五十六<sup>1</sup>・星野 智香<sup>1</sup>・与座 健治<sup>2</sup> Crystal structures of five-coordinated square pyramidal Pt(II) complexes recrystallized from nitrobenzene and acetonitrile. (<sup>1</sup>Univ. of Teacher Education Fukuoka, <sup>2</sup>Bruker Jpn) 〇Isoroku NAGASAWA<sup>1</sup>, Satoka HOSHINO<sup>1</sup>, Kenji YOZA<sup>2</sup> Pt"
  },
  {
    "inf": [
      "ジホスフィンとジチオグリセロールをもつねじれ環状型金(I)錯体の合成と発光特性",
      "(<sup>1</sup>阪大院理・<sup>2</sup>阪大院基礎工・<sup>3</sup>東工大理) 〇馬場 大知<sup>1,3</sup>・松岡 亮太<sup>2</sup>・草本 哲郎<sup>2</sup>・吉成 信人<sup>1</sup>",
      "Synthesis and photoluminescence properties of twisted gold(I) complexes with diphosphines and dithioglycerol",
      "(<sup>1</sup>Graduate School of Science, Osaka University, <sup>2</sup>Graduate School of Engineering Science, Osaka University, <sup>3</sup>School of Science, Tokyo Institute of Technology) 〇Taichi BABA<sup>1,3</sup>, Ryota MATSUOKA<sup>2</sup>, Tetsuro KUSAMOTO<sup>2</sup>, Nobuto YOSHINARI<sup>1</sup>"
    ],
    "lab": "1PA-42",
    "pdf": "pdf/1PA-42.pdf",
    "pre": "tn/1PA-42.jpg",
    "reg": "74012",
    "sea": "Au",
    "ses": "1PA",
    "con": "1PA-42 ジホスフィンとジチオグリセロールをもつねじれ環状型金(I)錯体の合成と発光特性 (<sup>1</sup>阪大院理・<sup>2</sup>阪大院基礎工・<sup>3</sup>東工大理) 〇馬場 大知<sup>1,3</sup>・松岡 亮太<sup>2</sup>・草本 哲郎<sup>2</sup>・吉成 信人<sup>1</sup> Synthesis and photoluminescence properties of twisted gold(I) complexes with diphosphines and dithioglycerol (<sup>1</sup>Graduate School of Science, Osaka University, <sup>2</sup>Graduate School of Engineering Science, Osaka University, <sup>3</sup>School of Science, Tokyo Institute of Technology) 〇Taichi BABA<sup>1,3</sup>, Ryota MATSUOKA<sup>2</sup>, Tetsuro KUSAMOTO<sup>2</sup>, Nobuto YOSHINARI<sup>1</sup> Au"
  },
  {
    "inf": [
      "異種ポリピリジル系スピンクロスオーバー錯体のシード結晶化によるブロック共結晶の構築",
      "(<sup>1</sup>東工大物質・<sup>2</sup>東工大化生研・<sup>3</sup>東工大ASMat) ◎三田 尚哉<sup>1,2</sup>・福井 智也<sup>1,2,3</sup>・福島 孝典<sup>1,2,3</sup>",
      "Construction of block co-crystals composed of different polypyridine spin-crossover metal complexes",
      "(<sup>1</sup>Sch. Mater. Chem. Tech., Tokyo Tech., <sup>2</sup>CLS, Tokyo Tech., <sup>3</sup>ASMat, Tokyo Tech.) ◎Naoya MITA<sup>1,2</sup>, Tomoya FUKUI<sup>1,2,3</sup>, Takanori FUKUSHIMA<sup>1,2,3</sup>"
    ],
    "lab": "1PA-43",
    "pdf": "pdf/1PA-43.pdf",
    "pre": "tn/1PA-43.jpg",
    "reg": "74301",
    "sea": "Co, Mn, Ni",
    "ses": "1PA",
    "con": "1PA-43 異種ポリピリジル系スピンクロスオーバー錯体のシード結晶化によるブロック共結晶の構築 (<sup>1</sup>東工大物質・<sup>2</sup>東工大化生研・<sup>3</sup>東工大ASMat) ◎三田 尚哉<sup>1,2</sup>・福井 智也<sup>1,2,3</sup>・福島 孝典<sup>1,2,3</sup> Construction of block co-crystals composed of different polypyridine spin-crossover metal complexes (<sup>1</sup>Sch. Mater. Chem. Tech., Tokyo Tech., <sup>2</sup>CLS, Tokyo Tech., <sup>3</sup>ASMat, Tokyo Tech.) ◎Naoya MITA<sup>1,2</sup>, Tomoya FUKUI<sup>1,2,3</sup>, Takanori FUKUSHIMA<sup>1,2,3</sup> Co, Mn, Ni"
  },
  {
    "inf": [
      "チオフェン縮環アルサベンゼンの分子間相互作用の解明と錯形成挙動",
      "(<sup>1</sup>京工繊大院工芸) 〇隅田 滉史<sup>1</sup>・井本 裕顕<sup>1</sup>・中 建介<sup>1</sup>",
      "Investigation of the intermolecular interactions and coordination behavior of thiophene-fused arsabenzenes",
      "(<sup>1</sup>Kyoto Institute of Technology) 〇Akifumi SUMIDA<sup>1</sup>, Hiroaki IMOTO<sup>1</sup>, Kensuke NAKA<sup>1</sup>"
    ],
    "lab": "1PA-44",
    "pdf": "pdf/1PA-44.pdf",
    "pre": "tn/1PA-44.jpg",
    "reg": "74062",
    "sea": "As, W",
    "ses": "1PA",
    "con": "1PA-44 チオフェン縮環アルサベンゼンの分子間相互作用の解明と錯形成挙動 (<sup>1</sup>京工繊大院工芸) 〇隅田 滉史<sup>1</sup>・井本 裕顕<sup>1</sup>・中 建介<sup>1</sup> Investigation of the intermolecular interactions and coordination behavior of thiophene-fused arsabenzenes (<sup>1</sup>Kyoto Institute of Technology) 〇Akifumi SUMIDA<sup>1</sup>, Hiroaki IMOTO<sup>1</sup>, Kensuke NAKA<sup>1</sup> As, W"
  },
  {
    "inf": [
      "嵩高い置換基を持つCp配位子と三脚型配位子からなるメタロセンの合成と回転挙動の評価",
      "(<sup>1</sup>奈良先端大物質創成科学領域・<sup>2</sup>トゥールーズ大学) 〇伊藤 直紀<sup>1</sup>・西野 智雄<sup>1</sup>・Gwénaël Rapenne<sup>1,2</sup>",
      "Synthesis of metallocenes composed of Cp ligand functionalized with bulky substituent and tripodal ligand",
      "(<sup>1</sup>Division of Materials Science, NAIST, <sup>2</sup>University of Toulouse) 〇Naoki Ito<sup>1</sup>, Toshio Nishino<sup>1</sup>, Gwénaël Rapenne<sup>1,2</sup>"
    ],
    "lab": "1PA-45",
    "pdf": "pdf/1PA-45.pdf",
    "pre": "tn/1PA-45.jpg",
    "reg": "74064",
    "sea": "Ru",
    "ses": "1PA",
    "con": "1PA-45 嵩高い置換基を持つCp配位子と三脚型配位子からなるメタロセンの合成と回転挙動の評価 (<sup>1</sup>奈良先端大物質創成科学領域・<sup>2</sup>トゥールーズ大学) 〇伊藤 直紀<sup>1</sup>・西野 智雄<sup>1</sup>・Gwénaël Rapenne<sup>1,2</sup> Synthesis of metallocenes composed of Cp ligand functionalized with bulky substituent and tripodal ligand (<sup>1</sup>Division of Materials Science, NAIST, <sup>2</sup>University of Toulouse) 〇Naoki Ito<sup>1</sup>, Toshio Nishino<sup>1</sup>, Gwénaël Rapenne<sup>1,2</sup> Ru"
  },
  {
    "inf": [
      "デンドリマー錯体を前駆体としたビスマスサブナノ粒子の合成",
      "(<sup>1</sup>東工大化生研) ◎橋本 遼太郎<sup>1</sup>・飯塚 忠寿<sup>1</sup>・神戸 徹也<sup>1</sup>・森合 達也<sup>1</sup>・今岡 享稔<sup>1</sup>・山元 公寿<sup>1</sup>",
      "Synthesis of bismuth sub-nanoparticles using dendrimer complexes as precursors",
      "(<sup>1</sup>Lab. Chem. Life Sci., Tokyo Tech.) ◎Ryotaro HASHIMOTO<sup>1</sup>, Tadatoshi IITSUKA <sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Tatsuya MORIAI<sup>1</sup>, Takane IMAOKA<sup>1</sup>, Kimihisa YAMAMOTO<sup>1</sup>"
    ],
    "lab": "1PA-46",
    "pdf": "pdf/1PA-46.pdf",
    "pre": "tn/1PA-46.jpg",
    "reg": "74336",
    "sea": "Bi",
    "ses": "1PA",
    "con": "1PA-46 デンドリマー錯体を前駆体としたビスマスサブナノ粒子の合成 (<sup>1</sup>東工大化生研) ◎橋本 遼太郎<sup>1</sup>・飯塚 忠寿<sup>1</sup>・神戸 徹也<sup>1</sup>・森合 達也<sup>1</sup>・今岡 享稔<sup>1</sup>・山元 公寿<sup>1</sup> Synthesis of bismuth sub-nanoparticles using dendrimer complexes as precursors (<sup>1</sup>Lab. Chem. Life Sci., Tokyo Tech.) ◎Ryotaro HASHIMOTO<sup>1</sup>, Tadatoshi IITSUKA <sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Tatsuya MORIAI<sup>1</sup>, Takane IMAOKA<sup>1</sup>, Kimihisa YAMAMOTO<sup>1</sup> Bi"
  },
  {
    "inf": [
      "Cs[Ni<sup>II</sup>(imidzole)<sub>2</sub>][W<sup>V</sup>(CN)<sub>8</sub>]錯体の結晶構造と磁気特性",
      "(<sup>1</sup>筑波大院数理・<sup>2</sup>東大院理) 〇佐藤 颯太<sup>1</sup>・赤木 慎太郎<sup>1</sup>・王 駿豪<sup>1</sup>・大越 慎一<sup>2</sup>・所 裕子<sup>1</sup>",
      "Crystal Structure and Magnesium of Cesium-Nickel-Octacyanotungusten",
      "(<sup>1</sup>Univ. of Tsukuba, <sup>2</sup>The Univ. of Tokyo) 〇Sota Sato<sup>1</sup>, Shintaro Akagi<sup>1</sup>, Wang Junhao<sup>1</sup>, Shin-ichi Ohkoshi<sup>2</sup>, Hiroko Tokoro<sup>1</sup>"
    ],
    "lab": "1PA-47",
    "pdf": "pdf/1PA-47.pdf",
    "pre": "tn/1PA-47.jpg",
    "reg": "74067",
    "sea": "W, Ni, Cs",
    "ses": "1PA",
    "con": "1PA-47 Cs[Ni<sup>II</sup>(imidzole)<sub>2</sub>][W<sup>V</sup>(CN)<sub>8</sub>]錯体の結晶構造と磁気特性 (<sup>1</sup>筑波大院数理・<sup>2</sup>東大院理) 〇佐藤 颯太<sup>1</sup>・赤木 慎太郎<sup>1</sup>・王 駿豪<sup>1</sup>・大越 慎一<sup>2</sup>・所 裕子<sup>1</sup> Crystal Structure and Magnesium of Cesium-Nickel-Octacyanotungusten (<sup>1</sup>Univ. of Tsukuba, <sup>2</sup>The Univ. of Tokyo) 〇Sota Sato<sup>1</sup>, Shintaro Akagi<sup>1</sup>, Wang Junhao<sup>1</sup>, Shin-ichi Ohkoshi<sup>2</sup>, Hiroko Tokoro<sup>1</sup> W, Ni, Cs"
  },
  {
    "inf": [
      "トリチオシアヌル酸を配位子とした三次元半導体配位高分子の合成と金属イオン種の半導体特性への影響の評価          ",
      "(<sup>1</sup>関学大理・<sup>2</sup>阪大院工・<sup>3</sup>阪大蛋白研・<sup>4</sup>日本電子 YOKOGUSHI 協働研究所) 〇松田慶一<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯昭紀<sup>2</sup>・中根崇智<sup>3, 4</sup>・川本晃大<sup>3, 4</sup>・栗栖源嗣<sup>3, 4</sup>・田中大輔<sup>1</sup>",
      "Synthesis of semiconductor coordination polymers with  three-dimensional structure composed of trithiocyanuric acid and the effect of metal ion species on the semiconductor properties",
      "(<sup>1</sup>School of Science, Kwansei Gakuin University, <sup>2</sup>Graduate School of Engineering, Osaka University, <sup>3</sup>Institute for Protein Research, Osaka University, <sup>4</sup>JEOL YOKOGUSHI Research Alliance Laboratories) 〇Keiichi Matsuda<sup>1</sup>, Ryohei Akiyoshi<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Takanori NAKANE<sup>3, 4</sup>, Akihiro KAWAMOTO<sup>3, 4</sup>, Genji KURISU<sup>3, 4</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "1PA-48",
    "pdf": "pdf/1PA-48.pdf",
    "pre": "tn/1PA-48.jpg",
    "reg": "74068",
    "sea": "Zn, Mn",
    "ses": "1PA",
    "con": "1PA-48 トリチオシアヌル酸を配位子とした三次元半導体配位高分子の合成と金属イオン種の半導体特性への影響の評価           (<sup>1</sup>関学大理・<sup>2</sup>阪大院工・<sup>3</sup>阪大蛋白研・<sup>4</sup>日本電子 YOKOGUSHI 協働研究所) 〇松田慶一<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯昭紀<sup>2</sup>・中根崇智<sup>3, 4</sup>・川本晃大<sup>3, 4</sup>・栗栖源嗣<sup>3, 4</sup>・田中大輔<sup>1</sup> Synthesis of semiconductor coordination polymers with  three-dimensional structure composed of trithiocyanuric acid and the effect of metal ion species on the semiconductor properties (<sup>1</sup>School of Science, Kwansei Gakuin University, <sup>2</sup>Graduate School of Engineering, Osaka University, <sup>3</sup>Institute for Protein Research, Osaka University, <sup>4</sup>JEOL YOKOGUSHI Research Alliance Laboratories) 〇Keiichi Matsuda<sup>1</sup>, Ryohei Akiyoshi<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Takanori NAKANE<sup>3, 4</sup>, Akihiro KAWAMOTO<sup>3, 4</sup>, Genji KURISU<sup>3, 4</sup>, Daisuke TANAKA<sup>1</sup> Zn, Mn"
  },
  {
    "inf": [
      "トリス(2-アミノエタンチオラト)コバルト(III)錯体配位子をもつ混合金属Ag<sup>I</sup><sub>x</sub>Au<sup>I</sup><sub>3-x</sub>錯体の結晶化挙動",
      "(<sup>1</sup>阪大院理) ◎中西 将司<sup>1</sup>・吉成 信人<sup>1</sup>",
      "Crystallization behavior of heterometallic Ag<sup>I</sup><sub>x</sub>Au<sup>I</sup><sub>3-x</sub> complexes with two tris(2-aminoethanethiolato)cobalt(III) metalloligands ",
      "(<sup>1</sup>Graduate school of Science, Osaka univ.) ◎Masashi NAKANISHI<sup>1</sup>, Nobuto YOSHINARI<sup>1</sup>"
    ],
    "lab": "1PA-49",
    "pdf": "pdf/1PA-49.pdf",
    "pre": "tn/1PA-49.jpg",
    "reg": "74427",
    "sea": "Au, Ag",
    "ses": "1PA",
    "con": "1PA-49 トリス(2-アミノエタンチオラト)コバルト(III)錯体配位子をもつ混合金属Ag<sup>I</sup><sub>x</sub>Au<sup>I</sup><sub>3-x</sub>錯体の結晶化挙動 (<sup>1</sup>阪大院理) ◎中西 将司<sup>1</sup>・吉成 信人<sup>1</sup> Crystallization behavior of heterometallic Ag<sup>I</sup><sub>x</sub>Au<sup>I</sup><sub>3-x</sub> complexes with two tris(2-aminoethanethiolato)cobalt(III) metalloligands  (<sup>1</sup>Graduate school of Science, Osaka univ.) ◎Masashi NAKANISHI<sup>1</sup>, Nobuto YOSHINARI<sup>1</sup> Au, Ag"
  },
  {
    "inf": [
      "二核バナジウム窒素錯体のN-N結合開裂によって生じる新規錯体の合成と構造",
      "(<sup>1</sup>愛工大工) 〇海出 直揮<sup>1</sup>・小久保 佳亮<sup>1</sup>・梶田 裕二<sup>1</sup>",
      "Synthesis and Structure of a Novel Divanadium Complex Formed by N-N Bond Cleavage of a Dinitrogen Divanadium Complex",
      "(<sup>1</sup>Aichi Institute of Technology) 〇Naoki KAIDE<sup>1</sup>, Yoshiaki KOKUBO<sup>1</sup>, Yuji KAJITA<sup>1</sup>"
    ],
    "lab": "1PA-50",
    "pdf": "pdf/1PA-50.pdf",
    "pre": "tn/1PA-50.jpg",
    "reg": "74074",
    "sea": "V",
    "ses": "1PA",
    "con": "1PA-50 二核バナジウム窒素錯体のN-N結合開裂によって生じる新規錯体の合成と構造 (<sup>1</sup>愛工大工) 〇海出 直揮<sup>1</sup>・小久保 佳亮<sup>1</sup>・梶田 裕二<sup>1</sup> Synthesis and Structure of a Novel Divanadium Complex Formed by N-N Bond Cleavage of a Dinitrogen Divanadium Complex (<sup>1</sup>Aichi Institute of Technology) 〇Naoki KAIDE<sup>1</sup>, Yoshiaki KOKUBO<sup>1</sup>, Yuji KAJITA<sup>1</sup> V"
  },
  {
    "inf": [
      "ピラジンで架橋されたMnW系オクタシアノ錯体の結晶構造と磁気特性",
      "(<sup>1</sup>筑波大院数理・<sup>2</sup>東大院理) 〇赤木 慎太郎<sup>1</sup>・Junhao WANG<sup>1</sup>・大越 慎一<sup>2</sup>・所 裕子<sup>1</sup>",
      "Crystal structure and magnetic properties of pyrizine bridged Mn-W cyanide framework           ",
      "(<sup>1</sup>Univ. of Tsukuba, <sup>2</sup>The univ. of Tokyo) 〇Shintaro AKAGI<sup>1</sup>, Junhao WANG<sup>1</sup>, Shin-ichi OHKOSHI<sup>2</sup>, Hiroko TOKORO<sup>1</sup>"
    ],
    "lab": "1PA-51",
    "pdf": "pdf/1PA-51.pdf",
    "pre": "tn/1PA-51.jpg",
    "reg": "74070",
    "sea": "Mn, W",
    "ses": "1PA",
    "con": "1PA-51 ピラジンで架橋されたMnW系オクタシアノ錯体の結晶構造と磁気特性 (<sup>1</sup>筑波大院数理・<sup>2</sup>東大院理) 〇赤木 慎太郎<sup>1</sup>・Junhao WANG<sup>1</sup>・大越 慎一<sup>2</sup>・所 裕子<sup>1</sup> Crystal structure and magnetic properties of pyrizine bridged Mn-W cyanide framework            (<sup>1</sup>Univ. of Tsukuba, <sup>2</sup>The univ. of Tokyo) 〇Shintaro AKAGI<sup>1</sup>, Junhao WANG<sup>1</sup>, Shin-ichi OHKOSHI<sup>2</sup>, Hiroko TOKORO<sup>1</sup> Mn, W"
  },
  {
    "inf": [
      "有機修飾型ポリオキソメタレートを用いた多孔性イオン結晶の合成と吸着特性",
      "(<sup>1</sup>東大院総合文化) ◎望月 舜介<sup>1</sup>・翁 哲偉<sup>1</sup>・荻原 直希<sup>1</sup>・内田 さやか<sup>1</sup>",
      "Synthesis and adsorption behavior of porous ionic crystals based on organically decorated type polyoxometalate",
      "(<sup>1</sup>Grad. Sch. Arts and Sci., The Univ. of Tokyo) ◎Shunsuke Mochizuki<sup>1</sup>, Zhewei Weng<sup>1</sup>, Naoki Ogiwara<sup>1</sup>, Sayaka Uchida<sup>1</sup>"
    ],
    "lab": "1PA-52",
    "pdf": "pdf/1PA-52.pdf",
    "pre": "tn/1PA-52.jpg",
    "reg": "74458",
    "sea": "Mn,Mo,Cr",
    "ses": "1PA",
    "con": "1PA-52 有機修飾型ポリオキソメタレートを用いた多孔性イオン結晶の合成と吸着特性 (<sup>1</sup>東大院総合文化) ◎望月 舜介<sup>1</sup>・翁 哲偉<sup>1</sup>・荻原 直希<sup>1</sup>・内田 さやか<sup>1</sup> Synthesis and adsorption behavior of porous ionic crystals based on organically decorated type polyoxometalate (<sup>1</sup>Grad. Sch. Arts and Sci., The Univ. of Tokyo) ◎Shunsuke Mochizuki<sup>1</sup>, Zhewei Weng<sup>1</sup>, Naoki Ogiwara<sup>1</sup>, Sayaka Uchida<sup>1</sup> Mn,Mo,Cr"
  },
  {
    "inf": [
      "4-(ピラジン-2-イル)-2,2'-ビピリジンを配位子とする多核Cu(I)-エチレン錯体の合成および構造",
      "(<sup>1</sup>近畿大学大学院 総合理工学研究科・<sup>2</sup>近畿大学 理工学総合研究所) 〇吉村 祥<sup>1</sup>・前川 雅彦<sup>2</sup>・グー ジーラン<sup>1</sup>・杉本 邦久<sup>1</sup>・黒田 孝義<sup>1</sup>",
      "Syntheses and structures of polynuclear Cu(I)-C<sub>2</sub>H<sub>4</sub> complexes bridged by 4-(pyrazin-2-yl)-2,2'-bipyridine",
      "(<sup>1</sup>Graduate School of Science and Engineering, Kindai University , <sup>2</sup>Science and Technology Research Institute, Kindai University) 〇Sho YOSHIMURA<sup>1</sup>, Masahiko MAEKAWA<sup>2</sup>, Zi Lang GOO<sup>1</sup>, Kunihisa SUGIMOTO<sup>1</sup>, Takayoshi KURODA-SOWA<sup>1</sup>"
    ],
    "lab": "1PA-53",
    "pdf": "pdf/1PA-53.pdf",
    "pre": "tn/1PA-53.jpg",
    "reg": "74075",
    "sea": "Cu",
    "ses": "1PA",
    "con": "1PA-53 4-(ピラジン-2-イル)-2,2'-ビピリジンを配位子とする多核Cu(I)-エチレン錯体の合成および構造 (<sup>1</sup>近畿大学大学院 総合理工学研究科・<sup>2</sup>近畿大学 理工学総合研究所) 〇吉村 祥<sup>1</sup>・前川 雅彦<sup>2</sup>・グー ジーラン<sup>1</sup>・杉本 邦久<sup>1</sup>・黒田 孝義<sup>1</sup> Syntheses and structures of polynuclear Cu(I)-C<sub>2</sub>H<sub>4</sub> complexes bridged by 4-(pyrazin-2-yl)-2,2'-bipyridine (<sup>1</sup>Graduate School of Science and Engineering, Kindai University , <sup>2</sup>Science and Technology Research Institute, Kindai University) 〇Sho YOSHIMURA<sup>1</sup>, Masahiko MAEKAWA<sup>2</sup>, Zi Lang GOO<sup>1</sup>, Kunihisa SUGIMOTO<sup>1</sup>, Takayoshi KURODA-SOWA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "均一網目ゲルを指向したMOFの自己拡張",
      "(<sup>1</sup>東大院工) 〇大椙 悠斗<sup>1</sup>・西島 杏実<sup>1</sup>・植村 卓史<sup>1</sup>",
      "Synthesis of uniformly cross-linked polymer networks via self-expansion of MOFs",
      "(<sup>1</sup>Graduate School of Engineering, The Univ. of Tokyo) 〇Yuto OSUGI<sup>1</sup>, Ami NISHIJIMA<sup>1</sup>, Takashi UEMURA<sup>1</sup>"
    ],
    "lab": "1PA-54",
    "pdf": "pdf/1PA-54.pdf",
    "pre": "tn/1PA-54.jpg",
    "reg": "74077",
    "sea": "Zr, Al",
    "ses": "1PA",
    "con": "1PA-54 均一網目ゲルを指向したMOFの自己拡張 (<sup>1</sup>東大院工) 〇大椙 悠斗<sup>1</sup>・西島 杏実<sup>1</sup>・植村 卓史<sup>1</sup> Synthesis of uniformly cross-linked polymer networks via self-expansion of MOFs (<sup>1</sup>Graduate School of Engineering, The Univ. of Tokyo) 〇Yuto OSUGI<sup>1</sup>, Ami NISHIJIMA<sup>1</sup>, Takashi UEMURA<sup>1</sup> Zr, Al"
  },
  {
    "inf": [
      "スチリルピリジン配位子を有する一次元Cd配位高分子の光二量化挙動",
      "(<sup>1</sup>北大院環境・<sup>2</sup>北大院地球環境) ◎立石 新<sup>1</sup>・陳 ユン<sup>1</sup>・張 雲雅<sup>1</sup>・齋藤 結⼤<sup>1,2</sup>・鄭 キン<sup>1,2</sup>・野呂 真⼀郎<sup>1,2</sup>",
      "Photodimerization behaviors of one-dimensional Cd coordination polymers with styrylpyridine ligands ",
      "(<sup>1</sup>Graduate School of Environmental Science, Hokkaido University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) ◎Arata Tateishi<sup>1</sup>, Yun Chen<sup>1</sup>, Yunya Zhang<sup>1</sup>, Yuki Saito<sup>1,2</sup>, Xin Zheng<sup>1,2</sup>, Shin-ichiro Noro<sup>1,2</sup>"
    ],
    "lab": "1PA-55",
    "pdf": "pdf/1PA-55.pdf",
    "pre": "tn/1PA-55.jpg",
    "reg": "74461",
    "sea": "Cd",
    "ses": "1PA",
    "con": "1PA-55 スチリルピリジン配位子を有する一次元Cd配位高分子の光二量化挙動 (<sup>1</sup>北大院環境・<sup>2</sup>北大院地球環境) ◎立石 新<sup>1</sup>・陳 ユン<sup>1</sup>・張 雲雅<sup>1</sup>・齋藤 結⼤<sup>1,2</sup>・鄭 キン<sup>1,2</sup>・野呂 真⼀郎<sup>1,2</sup> Photodimerization behaviors of one-dimensional Cd coordination polymers with styrylpyridine ligands  (<sup>1</sup>Graduate School of Environmental Science, Hokkaido University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) ◎Arata Tateishi<sup>1</sup>, Yun Chen<sup>1</sup>, Yunya Zhang<sup>1</sup>, Yuki Saito<sup>1,2</sup>, Xin Zheng<sup>1,2</sup>, Shin-ichiro Noro<sup>1,2</sup> Cd"
  },
  {
    "inf": [
      "フッ素化フタル酸を配位子とする1次元鎖及び2次元シート金属錯体(M=Co,Ni,Cu,Zn)の系統的合成 ",
      "(<sup>1</sup>芝浦工大) 〇高野 康平<sup>1</sup>・阿部 将大<sup>1</sup>・實方 友輝<sup>1</sup>・堀 顕子<sup>1</sup>",
      "Synthetic screening of 1D Chain and 2D Sheet Metal Complexes (M = Co, Ni, Cu, Zn) with Fluorinated Phthalic Acid ",
      "(<sup>1</sup>Shibaura Institute of Technology) 〇Kohei Takano<sup>1</sup>, Masahiro Abe<sup>1</sup>, Tomoki Jitsukata<sup>1</sup>, Akiko Hori<sup>1</sup>"
    ],
    "lab": "1PA-56",
    "pdf": "pdf/1PA-56.pdf",
    "pre": "tn/1PA-56.jpg",
    "reg": "74078",
    "sea": "Co,Ni,Cu,Zn",
    "ses": "1PA",
    "con": "1PA-56 フッ素化フタル酸を配位子とする1次元鎖及び2次元シート金属錯体(M=Co,Ni,Cu,Zn)の系統的合成  (<sup>1</sup>芝浦工大) 〇高野 康平<sup>1</sup>・阿部 将大<sup>1</sup>・實方 友輝<sup>1</sup>・堀 顕子<sup>1</sup> Synthetic screening of 1D Chain and 2D Sheet Metal Complexes (M = Co, Ni, Cu, Zn) with Fluorinated Phthalic Acid  (<sup>1</sup>Shibaura Institute of Technology) 〇Kohei Takano<sup>1</sup>, Masahiro Abe<sup>1</sup>, Tomoki Jitsukata<sup>1</sup>, Akiko Hori<sup>1</sup> Co,Ni,Cu,Zn"
  },
  {
    "inf": [
      "ホスホリル配位子を有する (bpy)<sub>2</sub>Ru 錯体の合成と反応性 ",
      "(<sup>1</sup>大阪公立大院理) 〇玉置 光一\\t<sup>1</sup>・西森 里絵\\t<sup>1</sup>・磯野 敦鷹\\t<sup>1</sup>・大橋 竜馬<sup>1</sup>・竹本 真\\t<sup>1</sup>・松坂 裕之<sup>1</sup>",
      "Synthesis and Reactivity of (bpy)<sub>2</sub>Ru Complexes with Phosphoryl Ligands ",
      "(<sup>1</sup>Osaka Metropolitan Univ.) 〇Koichi TAMAKI<sup>1</sup>, Rie NISHIMORI <sup>1</sup>, Atsutaka ISONO<sup>1</sup>, Ryoma OHASHI<sup>1</sup>, Shin TAKEMOTO<sup>1</sup>, Hiroyuki MATSUZAKA<sup>1</sup>"
    ],
    "lab": "1PA-57",
    "pdf": "pdf/1PA-57.pdf",
    "pre": "tn/1PA-57.jpg",
    "reg": "74079",
    "sea": "Ru",
    "ses": "1PA",
    "con": "1PA-57 ホスホリル配位子を有する (bpy)<sub>2</sub>Ru 錯体の合成と反応性  (<sup>1</sup>大阪公立大院理) 〇玉置 光一\\t<sup>1</sup>・西森 里絵\\t<sup>1</sup>・磯野 敦鷹\\t<sup>1</sup>・大橋 竜馬<sup>1</sup>・竹本 真\\t<sup>1</sup>・松坂 裕之<sup>1</sup> Synthesis and Reactivity of (bpy)<sub>2</sub>Ru Complexes with Phosphoryl Ligands  (<sup>1</sup>Osaka Metropolitan Univ.) 〇Koichi TAMAKI<sup>1</sup>, Rie NISHIMORI <sup>1</sup>, Atsutaka ISONO<sup>1</sup>, Ryoma OHASHI<sup>1</sup>, Shin TAKEMOTO<sup>1</sup>, Hiroyuki MATSUZAKA<sup>1</sup> Ru"
  },
  {
    "inf": [
      "化学修飾によるFe(III)錯体におけるスピンクロスオーバー現象と遅い磁気緩和の創出",
      "(<sup>1</sup>熊大院先端) ◎中嶋 悠人<sup>1</sup>・張 中岳<sup>1</sup>・関根 良博<sup>1</sup>・速水 真也<sup>1</sup>",
      "Development of spin crossover and slow magnetic relaxation in Fe(III) complexes based on chemical modification",
      "(<sup>1</sup>Kumamoto Univ.) ◎Yuto NAKASHIMA<sup>1</sup>, Zhang ZHONGYUE<sup>1</sup>, Yoshihiro SEKINE<sup>1</sup>, Shinya HAYAMI<sup>1</sup>"
    ],
    "lab": "1PA-58",
    "pdf": "pdf/1PA-58.pdf",
    "pre": "tn/1PA-58.jpg",
    "reg": "74492",
    "sea": "Fe",
    "ses": "1PA",
    "con": "1PA-58 化学修飾によるFe(III)錯体におけるスピンクロスオーバー現象と遅い磁気緩和の創出 (<sup>1</sup>熊大院先端) ◎中嶋 悠人<sup>1</sup>・張 中岳<sup>1</sup>・関根 良博<sup>1</sup>・速水 真也<sup>1</sup> Development of spin crossover and slow magnetic relaxation in Fe(III) complexes based on chemical modification (<sup>1</sup>Kumamoto Univ.) ◎Yuto NAKASHIMA<sup>1</sup>, Zhang ZHONGYUE<sup>1</sup>, Yoshihiro SEKINE<sup>1</sup>, Shinya HAYAMI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "ビピリドナート配位子を有する四核鉄オキソ錯体の合成と構造",
      "(<sup>1</sup>奈良女大理) 〇酒井 彩乃<sup>1</sup>・阪本 愛菜<sup>1</sup>・梶原 孝志<sup>1</sup>・佐々木 捷悟<sup>1</sup>・浦 康之<sup>1</sup>",
      "Synthesis and Structure of Tetranuclear Iron-oxo Complexes Having Bipyridonate Ligands",
      "(<sup>1</sup>Nara Women's Univ.) 〇Ayano SAKAI<sup>1</sup>, Aina SAKAMOTO<sup>1</sup>, Takashi KAJIWARA<sup>1</sup>, Shogo SASAKI<sup>1</sup>, Yasuyuki URA<sup>1</sup>"
    ],
    "lab": "1PA-59",
    "pdf": "pdf/1PA-59.pdf",
    "pre": "tn/1PA-59.jpg",
    "reg": "74084",
    "sea": "Fe",
    "ses": "1PA",
    "con": "1PA-59 ビピリドナート配位子を有する四核鉄オキソ錯体の合成と構造 (<sup>1</sup>奈良女大理) 〇酒井 彩乃<sup>1</sup>・阪本 愛菜<sup>1</sup>・梶原 孝志<sup>1</sup>・佐々木 捷悟<sup>1</sup>・浦 康之<sup>1</sup> Synthesis and Structure of Tetranuclear Iron-oxo Complexes Having Bipyridonate Ligands (<sup>1</sup>Nara Women's Univ.) 〇Ayano SAKAI<sup>1</sup>, Aina SAKAMOTO<sup>1</sup>, Takashi KAJIWARA<sup>1</sup>, Shogo SASAKI<sup>1</sup>, Yasuyuki URA<sup>1</sup> Fe"
  },
  {
    "inf": [
      "構造中にCd-S-ハロゲンネットワークを有する半導体配位高分子の合成と物性評価",
      "(<sup>1</sup>関学大理・<sup>2</sup>阪大院工) 〇東 和哉<sup>1</sup>・秋吉 亮平<sup>1</sup>・佐伯 昭紀<sup>2</sup>・田中 大輔<sup>1</sup>",
      "Synthesis and Properties of Semiconductive Coordination Polymers Containing Cd-S-Halogen Networks",
      "(<sup>1</sup>Kwansei Gakuin University, <sup>2</sup>Osaka University) 〇Yuya AZUMA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "1PA-60",
    "pdf": "pdf/1PA-60.pdf",
    "pre": "tn/1PA-60.jpg",
    "reg": "74119",
    "sea": "Cd",
    "ses": "1PA",
    "con": "1PA-60 構造中にCd-S-ハロゲンネットワークを有する半導体配位高分子の合成と物性評価 (<sup>1</sup>関学大理・<sup>2</sup>阪大院工) 〇東 和哉<sup>1</sup>・秋吉 亮平<sup>1</sup>・佐伯 昭紀<sup>2</sup>・田中 大輔<sup>1</sup> Synthesis and Properties of Semiconductive Coordination Polymers Containing Cd-S-Halogen Networks (<sup>1</sup>Kwansei Gakuin University, <sup>2</sup>Osaka University) 〇Yuya AZUMA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Daisuke TANAKA<sup>1</sup> Cd"
  },
  {
    "inf": [
      "種々の置換基を導入した非対称型コバルト(II)錯体結晶の合成と柔軟性評価",
      "(<sup>1</sup>城西大院理) ◎菊地 颯人<sup>1</sup>・仲谷 学<sup>1</sup>",
      "Synthesis of flexible molecular crystals consisting of asymmetric cobalt(II) complexes",
      "(<sup>1</sup>Graduate School of Science, Josai University) ◎Hayato KIKUCHI<sup>1</sup>, Manabu NAKAYA<sup>1</sup>"
    ],
    "lab": "1PA-61",
    "pdf": "pdf/1PA-61.pdf",
    "pre": "tn/1PA-61.jpg",
    "reg": "74497",
    "sea": "Co",
    "ses": "1PA",
    "con": "1PA-61 種々の置換基を導入した非対称型コバルト(II)錯体結晶の合成と柔軟性評価 (<sup>1</sup>城西大院理) ◎菊地 颯人<sup>1</sup>・仲谷 学<sup>1</sup> Synthesis of flexible molecular crystals consisting of asymmetric cobalt(II) complexes (<sup>1</sup>Graduate School of Science, Josai University) ◎Hayato KIKUCHI<sup>1</sup>, Manabu NAKAYA<sup>1</sup> Co"
  },
  {
    "inf": [
      "二酸化炭素還元光触媒反応におけるピンサー型ビス(カルベン)配位子の置換基効果",
      "(<sup>1</sup>長崎大院工) 〇守永 桃<sup>1</sup>・有川 康弘<sup>1</sup>・尾本 賢一郎<sup>1</sup>・作田 絵里<sup>1</sup>・馬越 啓介<sup>1</sup>",
      "Comparison of Substituents on a Pincer-type bis(carbene) Ligand of Ruthenium Catalysts in Photochemical CO<sub>2</sub> Reduction",
      "(<sup>1</sup>Graduate School of Engineering. Nagasaki University) 〇Momo MORINAGA<sup>1</sup>, Yasuhiro ARIKAWA<sup>1</sup>, Kenichiro OMOTO<sup>1</sup>, Eri SAKUDA<sup>1</sup>, Keisuke UMAKOSHI<sup>1</sup>"
    ],
    "lab": "1PA-62",
    "pdf": "pdf/1PA-62.pdf",
    "pre": "tn/1PA-62.jpg",
    "reg": "74123",
    "sea": "Ru",
    "ses": "1PA",
    "con": "1PA-62 二酸化炭素還元光触媒反応におけるピンサー型ビス(カルベン)配位子の置換基効果 (<sup>1</sup>長崎大院工) 〇守永 桃<sup>1</sup>・有川 康弘<sup>1</sup>・尾本 賢一郎<sup>1</sup>・作田 絵里<sup>1</sup>・馬越 啓介<sup>1</sup> Comparison of Substituents on a Pincer-type bis(carbene) Ligand of Ruthenium Catalysts in Photochemical CO<sub>2</sub> Reduction (<sup>1</sup>Graduate School of Engineering. Nagasaki University) 〇Momo MORINAGA<sup>1</sup>, Yasuhiro ARIKAWA<sup>1</sup>, Kenichiro OMOTO<sup>1</sup>, Eri SAKUDA<sup>1</sup>, Keisuke UMAKOSHI<sup>1</sup> Ru"
  },
  {
    "inf": [
      "第二級ホスフィンオキシド部位またはホスフィン酸エステル部位を有する多座配位子を用いた鉄錯体の合成",
      "(<sup>1</sup>奈良女大理) 〇谷口 明日香<sup>1</sup>・佐々木 捷悟<sup>1</sup>・浦 康之<sup>1</sup>",
      "Synthesis of Iron Complexes with Multidentate Ligands Bearing a Secondary Phosphine Oxide or a Phosphinic Ester Moiety",
      "(<sup>1</sup>Nara Women's Univ.) 〇Asuka TANIGUCHI<sup>1</sup>, Shogo SASAKI<sup>1</sup>, Yasuyuki URA<sup>1</sup>"
    ],
    "lab": "1PA-63",
    "pdf": "pdf/1PA-63.pdf",
    "pre": "tn/1PA-63.jpg",
    "reg": "74092",
    "sea": "Fe",
    "ses": "1PA",
    "con": "1PA-63 第二級ホスフィンオキシド部位またはホスフィン酸エステル部位を有する多座配位子を用いた鉄錯体の合成 (<sup>1</sup>奈良女大理) 〇谷口 明日香<sup>1</sup>・佐々木 捷悟<sup>1</sup>・浦 康之<sup>1</sup> Synthesis of Iron Complexes with Multidentate Ligands Bearing a Secondary Phosphine Oxide or a Phosphinic Ester Moiety (<sup>1</sup>Nara Women's Univ.) 〇Asuka TANIGUCHI<sup>1</sup>, Shogo SASAKI<sup>1</sup>, Yasuyuki URA<sup>1</sup> Fe"
  },
  {
    "inf": [
      "イソインドリン-ビス(ピラゾール)骨格をもつプロティックなピンサー型銅(I)錯体の合成",
      "(<sup>1</sup>立命館大生命科学・<sup>2</sup>東工大物質理工) ◎伊東 篤志<sup>1</sup>・林 暐軒<sup>2</sup>・杉山 傑<sup>2</sup>・榧木 啓人<sup>2</sup>・桑田 繁樹<sup>1</sup>",
      "Synthesis of Protic Pincer-Type Copper(I) Complexes Bearing an Isoindoline-Bis(pyrazole) Skeleton",
      "(<sup>1</sup>Ritsumeikan Univ., <sup>2</sup>Tokyo Inst. Tech.) ◎Atsushi ITO<sup>1</sup>, Wei-Syuan LIN<sup>2</sup>, Takeru SUGIYAMA<sup>2</sup>, Yoshihito KAYAKI<sup>2</sup>, Shigeki KUWATA<sup>1</sup>"
    ],
    "lab": "1PA-64",
    "pdf": "pdf/1PA-64.pdf",
    "pre": "tn/1PA-64.jpg",
    "reg": "74499",
    "sea": "Cu",
    "ses": "1PA",
    "con": "1PA-64 イソインドリン-ビス(ピラゾール)骨格をもつプロティックなピンサー型銅(I)錯体の合成 (<sup>1</sup>立命館大生命科学・<sup>2</sup>東工大物質理工) ◎伊東 篤志<sup>1</sup>・林 暐軒<sup>2</sup>・杉山 傑<sup>2</sup>・榧木 啓人<sup>2</sup>・桑田 繁樹<sup>1</sup> Synthesis of Protic Pincer-Type Copper(I) Complexes Bearing an Isoindoline-Bis(pyrazole) Skeleton (<sup>1</sup>Ritsumeikan Univ., <sup>2</sup>Tokyo Inst. Tech.) ◎Atsushi ITO<sup>1</sup>, Wei-Syuan LIN<sup>2</sup>, Takeru SUGIYAMA<sup>2</sup>, Yoshihito KAYAKI<sup>2</sup>, Shigeki KUWATA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "ビス(ベンゾイミダゾール)配位ニッケルジブロミド錯体を基盤とする水素結合性有機構造体の合成、構造および有機蒸気の吸着特性",
      "(<sup>1</sup>弘前大院理工・<sup>2</sup>長岡技科大院工) 〇菊谷 博斗<sup>1</sup>・戸田 智之<sup>2</sup>・岡崎 雅明<sup>1</sup>・太田 俊<sup>1</sup>",
      "Synthesis, Crystal Structure and Organic Vapor Adsorption Properties of a Hydrogen-bonded Organic Framework based on a Bis(benzimidazole)-coordinated Nickel Dibromido Complex",
      "(<sup>1</sup>Grad. Sch. of Sci. and Tech., Hirosaki Univ., <sup>2</sup>Dept. of Mat. Sci. and Bioeng., Nagaoka Univ. of Tech.) 〇Hiroto Kikuya<sup>1</sup>, Tomoyuki Toda<sup>2</sup>, Masaaki Okazaki<sup>1</sup>, Shun Ohta<sup>1</sup>"
    ],
    "lab": "1PA-65",
    "pdf": "pdf/1PA-65.pdf",
    "pre": "tn/1PA-65.jpg",
    "reg": "74130",
    "sea": "Ni",
    "ses": "1PA",
    "con": "1PA-65 ビス(ベンゾイミダゾール)配位ニッケルジブロミド錯体を基盤とする水素結合性有機構造体の合成、構造および有機蒸気の吸着特性 (<sup>1</sup>弘前大院理工・<sup>2</sup>長岡技科大院工) 〇菊谷 博斗<sup>1</sup>・戸田 智之<sup>2</sup>・岡崎 雅明<sup>1</sup>・太田 俊<sup>1</sup> Synthesis, Crystal Structure and Organic Vapor Adsorption Properties of a Hydrogen-bonded Organic Framework based on a Bis(benzimidazole)-coordinated Nickel Dibromido Complex (<sup>1</sup>Grad. Sch. of Sci. and Tech., Hirosaki Univ., <sup>2</sup>Dept. of Mat. Sci. and Bioeng., Nagaoka Univ. of Tech.) 〇Hiroto Kikuya<sup>1</sup>, Tomoyuki Toda<sup>2</sup>, Masaaki Okazaki<sup>1</sup>, Shun Ohta<sup>1</sup> Ni"
  },
  {
    "inf": [
      "チオラートージスルフィド交換反応を利用した金ナノクラスターの特異な構造変換",
      "(<sup>1</sup>兵県大院工) 〇森垣 斗夢<sup>1</sup>・鈴木 航<sup>1</sup>・梅山 有和<sup>1</sup>",
      "Unique structural transformation of gold nanoclusters using thiolate disulfide exchange reaction",
      "(<sup>1</sup>Department of Applied Chemistry, Graduate School of Engineering, University of Hyogo) 〇Tomu Morigaki<sup>1</sup>, Wataru Suzuki<sup>1</sup>, Tomokazu Umeyama<sup>1</sup>"
    ],
    "lab": "1PA-66",
    "pdf": "pdf/1PA-66.pdf",
    "pre": "tn/1PA-66.jpg",
    "reg": "74133",
    "sea": "Au",
    "ses": "1PA",
    "con": "1PA-66 チオラートージスルフィド交換反応を利用した金ナノクラスターの特異な構造変換 (<sup>1</sup>兵県大院工) 〇森垣 斗夢<sup>1</sup>・鈴木 航<sup>1</sup>・梅山 有和<sup>1</sup> Unique structural transformation of gold nanoclusters using thiolate disulfide exchange reaction (<sup>1</sup>Department of Applied Chemistry, Graduate School of Engineering, University of Hyogo) 〇Tomu Morigaki<sup>1</sup>, Wataru Suzuki<sup>1</sup>, Tomokazu Umeyama<sup>1</sup> Au"
  },
  {
    "inf": [
      "NHC/ピリジル混合系配位子を有する第10族遷移金属錯体:構造特性と触媒機能",
      "(<sup>1</sup>神奈川大工) ◎今泉 公太<sup>1</sup>・小花 咲季<sup>1</sup>・北原 美彩<sup>1</sup>・鈴木 伶奈<sup>1</sup>・岡村 将也<sup>1</sup>・引地 史郎<sup>1</sup>",
      "Group 10 Transition Metal Complexes with a NHC/Pyridyl Hybrid Ligand: Structural Characteristics and Catalytic Properties",
      "(<sup>1</sup>Kanagawa Univ.) ◎Kota IMAIZUMI<sup>1</sup>, Saki KOBANA<sup>1</sup>, Misa KITAHARA<sup>1</sup>, Rena SUZUKI<sup>1</sup>, Masaya OKAMURA<sup>1</sup>, Shiro HIKICHI<sup>1</sup>"
    ],
    "lab": "1PA-67",
    "pdf": "pdf/1PA-67.pdf",
    "pre": "tn/1PA-67.jpg",
    "reg": "74503",
    "sea": "Ni, Pd, Pt",
    "ses": "1PA",
    "con": "1PA-67 NHC/ピリジル混合系配位子を有する第10族遷移金属錯体:構造特性と触媒機能 (<sup>1</sup>神奈川大工) ◎今泉 公太<sup>1</sup>・小花 咲季<sup>1</sup>・北原 美彩<sup>1</sup>・鈴木 伶奈<sup>1</sup>・岡村 将也<sup>1</sup>・引地 史郎<sup>1</sup> Group 10 Transition Metal Complexes with a NHC/Pyridyl Hybrid Ligand: Structural Characteristics and Catalytic Properties (<sup>1</sup>Kanagawa Univ.) ◎Kota IMAIZUMI<sup>1</sup>, Saki KOBANA<sup>1</sup>, Misa KITAHARA<sup>1</sup>, Rena SUZUKI<sup>1</sup>, Masaya OKAMURA<sup>1</sup>, Shiro HIKICHI<sup>1</sup> Ni, Pd, Pt"
  },
  {
    "inf": [
      "Gd(Ⅲ)単核錯体における遅い磁化緩和の発現と集積化が緩和速度に及ぼす効果",
      "(<sup>1</sup>奈良女大院) 〇前田 みのり<sup>1</sup>・村井 文歌<sup>1</sup>・上岡 萌音<sup>1</sup>・中西 咲葵<sup>1</sup>・堀井 洋司<sup>1</sup>・梶原 孝志<sup>1</sup>",
      "Developing of slow magnetization relaxation in mononuclear Gd(Ⅲ) complexes and effect of aggregation on the relaxation rate",
      "(<sup>1</sup>Nara Women's Univ.) 〇Minori MAEDA<sup>1</sup>, Fumika MURAI<sup>1</sup>, Mone KAMIOKA<sup>1</sup>, Saki NAKANISHI<sup>1</sup>, Yoji HORII<sup>1</sup>, Takashi KAJIWARA<sup>1</sup>"
    ],
    "lab": "1PA-68",
    "pdf": "pdf/1PA-68.pdf",
    "pre": "tn/1PA-68.jpg",
    "reg": "74102",
    "sea": "Gd",
    "ses": "1PA",
    "con": "1PA-68 Gd(Ⅲ)単核錯体における遅い磁化緩和の発現と集積化が緩和速度に及ぼす効果 (<sup>1</sup>奈良女大院) 〇前田 みのり<sup>1</sup>・村井 文歌<sup>1</sup>・上岡 萌音<sup>1</sup>・中西 咲葵<sup>1</sup>・堀井 洋司<sup>1</sup>・梶原 孝志<sup>1</sup> Developing of slow magnetization relaxation in mononuclear Gd(Ⅲ) complexes and effect of aggregation on the relaxation rate (<sup>1</sup>Nara Women's Univ.) 〇Minori MAEDA<sup>1</sup>, Fumika MURAI<sup>1</sup>, Mone KAMIOKA<sup>1</sup>, Saki NAKANISHI<sup>1</sup>, Yoji HORII<sup>1</sup>, Takashi KAJIWARA<sup>1</sup> Gd"
  },
  {
    "inf": [
      "発光性白金(Ⅱ)錯体におけるペンタフルオロアリルエチニル配位子の効果 ",
      "(<sup>1</sup>名工大院工) 〇川口 航矢<sup>1</sup>・山元 麻鈴<sup>1</sup>・神林 美生<sup>1</sup>・塩塚 理仁<sup>1</sup>",
      "The electric and structural effect of pentafluorophenylethynyl ligand for phosphorescent platinum complexes",
      "(<sup>1</sup>Nagoya Institute of Tech.) 〇Koya KAWAGUCHI<sup>1</sup>, Masuzu YAMAMOTO<sup>1</sup>, Miu KAMBAYASHI<sup>1</sup>, Michito SHIOTSUKA<sup>1</sup>"
    ],
    "lab": "1PA-69",
    "pdf": "pdf/1PA-69.pdf",
    "pre": "tn/1PA-69.jpg",
    "reg": "74165",
    "sea": "Pt",
    "ses": "1PA",
    "con": "1PA-69 発光性白金(Ⅱ)錯体におけるペンタフルオロアリルエチニル配位子の効果  (<sup>1</sup>名工大院工) 〇川口 航矢<sup>1</sup>・山元 麻鈴<sup>1</sup>・神林 美生<sup>1</sup>・塩塚 理仁<sup>1</sup> The electric and structural effect of pentafluorophenylethynyl ligand for phosphorescent platinum complexes (<sup>1</sup>Nagoya Institute of Tech.) 〇Koya KAWAGUCHI<sup>1</sup>, Masuzu YAMAMOTO<sup>1</sup>, Miu KAMBAYASHI<sup>1</sup>, Michito SHIOTSUKA<sup>1</sup> Pt"
  },
  {
    "inf": [
      "逐次反応によるヘテロ金属配位ナノシートの合成と導入された金属種の違いが物性に与える影響",
      "(<sup>1</sup>東理大院創域理工・<sup>2</sup>東理大総研) ◎伊藤 実祐<sup>1</sup>・福居 直哉<sup>2</sup>・高田 健司<sup>2</sup>・前田 啓明<sup>2</sup>・西原 寛<sup>1,2</sup>",
      "Synthesis of heterometallic coordination nanosheets by sequential reactions and effects of secondary introduced metal species on their physical properties",
      "(<sup>1</sup>Graduate School of Science and Technology, Tokyo University of Science, <sup>2</sup>Research Institute for Science and Technology, Tokyo University of Science) ◎Miyu ITO<sup>1</sup>, Naoya FUKUI<sup>2</sup>, Kenji TAKADA<sup>2</sup>, Hiroaki MAEDA<sup>2</sup>, Hiroshi NISHIHARA<sup>1,2</sup>"
    ],
    "lab": "1PA-70",
    "pdf": "pdf/1PA-70.pdf",
    "pre": "tn/1PA-70.jpg",
    "reg": "74516",
    "sea": "Ni",
    "ses": "1PA",
    "con": "1PA-70 逐次反応によるヘテロ金属配位ナノシートの合成と導入された金属種の違いが物性に与える影響 (<sup>1</sup>東理大院創域理工・<sup>2</sup>東理大総研) ◎伊藤 実祐<sup>1</sup>・福居 直哉<sup>2</sup>・高田 健司<sup>2</sup>・前田 啓明<sup>2</sup>・西原 寛<sup>1,2</sup> Synthesis of heterometallic coordination nanosheets by sequential reactions and effects of secondary introduced metal species on their physical properties (<sup>1</sup>Graduate School of Science and Technology, Tokyo University of Science, <sup>2</sup>Research Institute for Science and Technology, Tokyo University of Science) ◎Miyu ITO<sup>1</sup>, Naoya FUKUI<sup>2</sup>, Kenji TAKADA<sup>2</sup>, Hiroaki MAEDA<sup>2</sup>, Hiroshi NISHIHARA<sup>1,2</sup> Ni"
  },
  {
    "inf": [
      "環状ポリオキソメタレートに内包された銀ナノクラスターの電子状態制御",
      "(<sup>1</sup>東大院工・<sup>2</sup>都立大理) 〇屋内 大輝<sup>1</sup>・米里 健太郎<sup>1</sup>・吉川 聡一<sup>2</sup>・山添 誠司<sup>2</sup>・鈴木 康介<sup>1</sup>・山口 和也<sup>1</sup>",
      "Control of Electronic State of Ag Nanoclusters within a Ring-Shaped Polyoxometalate",
      "(<sup>1</sup>Sch. of Eng., The Univ. of Tokyo, <sup>2</sup>Grad. Sch. of Sci., Tokyo Metropolitan Univ) 〇Daiki YANAI<sup>1</sup>, Kentaro YONESATO<sup>1</sup>, Soichi KIKKAWA<sup>2</sup>, Seiji YAMAZOE<sup>2</sup>, Kosuke SUZUKI<sup>1</sup>, Kazuya YAMAGUCHI<sup>1</sup>"
    ],
    "lab": "1PA-71",
    "pdf": "pdf/1PA-71.pdf",
    "pre": "tn/1PA-71.jpg",
    "reg": "74167",
    "sea": "Ag, W",
    "ses": "1PA",
    "con": "1PA-71 環状ポリオキソメタレートに内包された銀ナノクラスターの電子状態制御 (<sup>1</sup>東大院工・<sup>2</sup>都立大理) 〇屋内 大輝<sup>1</sup>・米里 健太郎<sup>1</sup>・吉川 聡一<sup>2</sup>・山添 誠司<sup>2</sup>・鈴木 康介<sup>1</sup>・山口 和也<sup>1</sup> Control of Electronic State of Ag Nanoclusters within a Ring-Shaped Polyoxometalate (<sup>1</sup>Sch. of Eng., The Univ. of Tokyo, <sup>2</sup>Grad. Sch. of Sci., Tokyo Metropolitan Univ) 〇Daiki YANAI<sup>1</sup>, Kentaro YONESATO<sup>1</sup>, Soichi KIKKAWA<sup>2</sup>, Seiji YAMAZOE<sup>2</sup>, Kosuke SUZUKI<sup>1</sup>, Kazuya YAMAGUCHI<sup>1</sup> Ag, W"
  },
  {
    "inf": [
      "Zn<sub>2</sub>(Zn-TCPP)(DABCO) MOF配向膜のキャスト法による構築と評価",
      "(<sup>1</sup>東京理科大学) 〇張 嘉浩<sup>1</sup>・張 啓原<sup>1</sup>・原口 知之<sup>1</sup>",
      "Fabrication and Evaluation of Zn<sub>2</sub> (Zn-TCPP)(DABCO) Oriented MOF Thin Film by Casting Method",
      "(<sup>1</sup>Tokyo University of Science) 〇Jiahao ZHANG<sup>1</sup>, Qiyuan ZHANG<sup>1</sup>, Tomoyuki HARAGUCHI<sup>1</sup>"
    ],
    "lab": "1PA-72",
    "pdf": "pdf/1PA-72.pdf",
    "pre": "tn/1PA-72.jpg",
    "reg": "74175",
    "sea": "Zn",
    "ses": "1PA",
    "con": "1PA-72 Zn<sub>2</sub>(Zn-TCPP)(DABCO) MOF配向膜のキャスト法による構築と評価 (<sup>1</sup>東京理科大学) 〇張 嘉浩<sup>1</sup>・張 啓原<sup>1</sup>・原口 知之<sup>1</sup> Fabrication and Evaluation of Zn<sub>2</sub> (Zn-TCPP)(DABCO) Oriented MOF Thin Film by Casting Method (<sup>1</sup>Tokyo University of Science) 〇Jiahao ZHANG<sup>1</sup>, Qiyuan ZHANG<sup>1</sup>, Tomoyuki HARAGUCHI<sup>1</sup> Zn"
  },
  {
    "inf": [
      "シアノ架橋[Fe<sub>2</sub>Co<sub>2</sub>]四角型錯体の分子結晶における四段階の磁気転移",
      "(<sup>1</sup>九大院理・<sup>2</sup>九大先導物質化学研究所) ◎池田 泰輔<sup>1</sup>・蘇 勝群<sup>1,2</sup>・佐藤 治<sup>1,2</sup>",
      "Four-Step Magnetic Transition in a Molecular Crystal of Cyano-Bridged [Fe<sub>2</sub>Co<sub>2</sub>] Square Complex",
      "(<sup>1</sup>Kyushu University, Graduate School of Science , <sup>2</sup>Kyushu University, Institute for Materials Chemistry and Engineering) ◎Taisuke IKEDA<sup>1</sup>, Sheng-qun SU<sup>1,2</sup>, Osamu SATO<sup>1,2</sup>"
    ],
    "lab": "1PA-73",
    "pdf": "pdf/1PA-73.pdf",
    "pre": "tn/1PA-73.jpg",
    "reg": "74523",
    "sea": "Fe, Co",
    "ses": "1PA",
    "con": "1PA-73 シアノ架橋[Fe<sub>2</sub>Co<sub>2</sub>]四角型錯体の分子結晶における四段階の磁気転移 (<sup>1</sup>九大院理・<sup>2</sup>九大先導物質化学研究所) ◎池田 泰輔<sup>1</sup>・蘇 勝群<sup>1,2</sup>・佐藤 治<sup>1,2</sup> Four-Step Magnetic Transition in a Molecular Crystal of Cyano-Bridged [Fe<sub>2</sub>Co<sub>2</sub>] Square Complex (<sup>1</sup>Kyushu University, Graduate School of Science , <sup>2</sup>Kyushu University, Institute for Materials Chemistry and Engineering) ◎Taisuke IKEDA<sup>1</sup>, Sheng-qun SU<sup>1,2</sup>, Osamu SATO<sup>1,2</sup> Fe, Co"
  },
  {
    "inf": [
      "10座かご型配位子を持つ希土類単核錯体の合成,構造と磁気特性",
      "(<sup>1</sup>奈良女大院) 〇玉代勢 沙帆<sup>1</sup>・中村 有稀<sup>1</sup>・堀井 彩可<sup>1</sup>・堀井 洋司<sup>1</sup>・梶原 孝志<sup>1</sup>",
      "Syntheses, structures, and slow magnetic properties of lanthanide complexes constructed with a deca-dentate cage-type ligand",
      "(<sup>1</sup>Nara Women's Univ.) 〇Saho TAMAYOSE<sup>1</sup>, Yuki NAKAMURA<sup>1</sup>, Ayaka HORII<sup>1</sup>, Yoji HORII<sup>1</sup>, Takashi KAJIWARA<sup>1</sup>"
    ],
    "lab": "1PA-74",
    "pdf": "pdf/1PA-74.pdf",
    "pre": "tn/1PA-74.jpg",
    "reg": "74134",
    "sea": "Tb, Dy",
    "ses": "1PA",
    "con": "1PA-74 10座かご型配位子を持つ希土類単核錯体の合成,構造と磁気特性 (<sup>1</sup>奈良女大院) 〇玉代勢 沙帆<sup>1</sup>・中村 有稀<sup>1</sup>・堀井 彩可<sup>1</sup>・堀井 洋司<sup>1</sup>・梶原 孝志<sup>1</sup> Syntheses, structures, and slow magnetic properties of lanthanide complexes constructed with a deca-dentate cage-type ligand (<sup>1</sup>Nara Women's Univ.) 〇Saho TAMAYOSE<sup>1</sup>, Yuki NAKAMURA<sup>1</sup>, Ayaka HORII<sup>1</sup>, Yoji HORII<sup>1</sup>, Takashi KAJIWARA<sup>1</sup> Tb, Dy"
  },
  {
    "inf": [
      "アクアおよびヒドロキシドを有するビス(2-ピリジルメチル)エーテル鉄錯体の合成",
      "(<sup>1</sup>上智大理工) 〇五十嵐 柊有<sup>1</sup>・三澤 智世<sup>1</sup>・長尾 宏隆<sup>1</sup>",
      "Syntheses of Aqua- and Hydoroxido-cordinated Iron Complexes Bearing Bis(2-pyridylmethyl)ether ",
      "(<sup>1</sup>Fac. of Sci. and Tech., Sophia Univ.) 〇Shu IGARASHI<sup>1</sup>, Tomoyo MISAWA<sup>1</sup>, Hirotaka NAGAO<sup>1</sup>"
    ],
    "lab": "1PA-75",
    "pdf": "pdf/1PA-75.pdf",
    "pre": "tn/1PA-75.jpg",
    "reg": "74177",
    "sea": "Fe",
    "ses": "1PA",
    "con": "1PA-75 アクアおよびヒドロキシドを有するビス(2-ピリジルメチル)エーテル鉄錯体の合成 (<sup>1</sup>上智大理工) 〇五十嵐 柊有<sup>1</sup>・三澤 智世<sup>1</sup>・長尾 宏隆<sup>1</sup> Syntheses of Aqua- and Hydoroxido-cordinated Iron Complexes Bearing Bis(2-pyridylmethyl)ether  (<sup>1</sup>Fac. of Sci. and Tech., Sophia Univ.) 〇Shu IGARASHI<sup>1</sup>, Tomoyo MISAWA<sup>1</sup>, Hirotaka NAGAO<sup>1</sup> Fe"
  },
  {
    "inf": [
      "ヘキサタンタル酸テトラメチルアンモニウムの調製",
      "(<sup>1</sup>関学大理) ◎岸本 有彩<sup>1</sup>・矢ヶ崎 篤<sup>1</sup>",
      "Preparation of tetramethylammonium hexatantalate",
      "(<sup>1</sup>Kwansei Gakuin Univ.) ◎Arisa Kishimoto<sup>1</sup>, Atsushi Yagasaki<sup>1</sup>"
    ],
    "lab": "1PA-76",
    "pdf": "pdf/1PA-76.pdf",
    "pre": "tn/1PA-76.jpg",
    "reg": "74526",
    "sea": "Ta",
    "ses": "1PA",
    "con": "1PA-76 ヘキサタンタル酸テトラメチルアンモニウムの調製 (<sup>1</sup>関学大理) ◎岸本 有彩<sup>1</sup>・矢ヶ崎 篤<sup>1</sup> Preparation of tetramethylammonium hexatantalate (<sup>1</sup>Kwansei Gakuin Univ.) ◎Arisa Kishimoto<sup>1</sup>, Atsushi Yagasaki<sup>1</sup> Ta"
  },
  {
    "inf": [
      "燐光発光性ルテニウム‐白金二核錯体の光物性とクロミック特性 ",
      "(<sup>1</sup>名工大院工) 〇西原 祐巳<sup>1</sup>・久堀 樹<sup>1</sup>・塩塚 理仁<sup>1</sup>",
      "Photophysical properties and chromism of phosphorescent ruthenium-platinum heteronuclear complexes",
      "(<sup>1</sup>Nagoya Institute of Technology) 〇Takumi NISHIHARA<sup>1</sup>, Itsuki KUBORI<sup>1</sup>, Michito SHIOTSUKA<sup>1</sup>"
    ],
    "lab": "1PA-77",
    "pdf": "pdf/1PA-77.pdf",
    "pre": "tn/1PA-77.jpg",
    "reg": "74166",
    "sea": "Ru, Pt",
    "ses": "1PA",
    "con": "1PA-77 燐光発光性ルテニウム‐白金二核錯体の光物性とクロミック特性  (<sup>1</sup>名工大院工) 〇西原 祐巳<sup>1</sup>・久堀 樹<sup>1</sup>・塩塚 理仁<sup>1</sup> Photophysical properties and chromism of phosphorescent ruthenium-platinum heteronuclear complexes (<sup>1</sup>Nagoya Institute of Technology) 〇Takumi NISHIHARA<sup>1</sup>, Itsuki KUBORI<sup>1</sup>, Michito SHIOTSUKA<sup>1</sup> Ru, Pt"
  },
  {
    "inf": [
      "ビス(ベンゾイミダゾール)配位亜鉛ジクロリド錯体を基盤とする多孔性分子結晶のゲスト交換特性",
      "(<sup>1</sup>弘前大院理工) 〇石井 萌々<sup>1</sup>・岡崎 雅明<sup>1</sup>・太田 俊<sup>1</sup>",
      "Guest Exchange Properties of Porous Molecular Crystals Based on a Bis(benzimidazole)-coordinated Zinc Dichlorido Complex",
      "(<sup>1</sup>1\\tGrad. Sch. of Sci. and Tech., Hirosaki Univ.) 〇Momo ISHII<sup>1</sup>, Masaaki OKAZAKI<sup>1</sup>, Shun OHTA<sup>1</sup>"
    ],
    "lab": "1PA-78",
    "pdf": "pdf/1PA-78.pdf",
    "pre": "tn/1PA-78.jpg",
    "reg": "74188",
    "sea": "Zn",
    "ses": "1PA",
    "con": "1PA-78 ビス(ベンゾイミダゾール)配位亜鉛ジクロリド錯体を基盤とする多孔性分子結晶のゲスト交換特性 (<sup>1</sup>弘前大院理工) 〇石井 萌々<sup>1</sup>・岡崎 雅明<sup>1</sup>・太田 俊<sup>1</sup> Guest Exchange Properties of Porous Molecular Crystals Based on a Bis(benzimidazole)-coordinated Zinc Dichlorido Complex (<sup>1</sup>1\\tGrad. Sch. of Sci. and Tech., Hirosaki Univ.) 〇Momo ISHII<sup>1</sup>, Masaaki OKAZAKI<sup>1</sup>, Shun OHTA<sup>1</sup> Zn"
  },
  {
    "inf": [
      "NDI誘導体を用いた有機無機ハイブリッドにおけるメカノクロミズム挙動の集積構造依存性",
      "(<sup>1</sup>神奈川大院工) ◎井手 拓美<sup>1</sup>・増田 峻也<sup>1</sup>・楠本 壮太郎<sup>1</sup>・小出 芳弘<sup>1</sup>",
      "Assembled Structure Dependence of Mechanochromic Behavior in Organic-Inorganic Metal Halide Hybrids Using NDI Derivatives",
      "(<sup>1</sup>Grad. Sch. Eng. Kanagawa Univ.) ◎Takumi IDE<sup>1</sup>, Shunya MASUDA<sup>1</sup>, Sotaro KUSUMOTO<sup>1</sup>, Yoshihiro KOIDE<sup>1</sup>"
    ],
    "lab": "1PA-79",
    "pdf": "pdf/1PA-79.pdf",
    "pre": "tn/1PA-79.jpg",
    "reg": "74536",
    "sea": "Sn, Zn",
    "ses": "1PA",
    "con": "1PA-79 NDI誘導体を用いた有機無機ハイブリッドにおけるメカノクロミズム挙動の集積構造依存性 (<sup>1</sup>神奈川大院工) ◎井手 拓美<sup>1</sup>・増田 峻也<sup>1</sup>・楠本 壮太郎<sup>1</sup>・小出 芳弘<sup>1</sup> Assembled Structure Dependence of Mechanochromic Behavior in Organic-Inorganic Metal Halide Hybrids Using NDI Derivatives (<sup>1</sup>Grad. Sch. Eng. Kanagawa Univ.) ◎Takumi IDE<sup>1</sup>, Shunya MASUDA<sup>1</sup>, Sotaro KUSUMOTO<sup>1</sup>, Yoshihiro KOIDE<sup>1</sup> Sn, Zn"
  },
  {
    "inf": [
      "Keggin型ポリオキソメタレートのサイト選択的な酸素-硫黄交換反応",
      "(<sup>1</sup>東大院工) 〇渡辺 陽太<sup>1</sup>・米里 健太郎<sup>1</sup>・鈴木 康介<sup>1</sup>・山口 和也<sup>1</sup>",
      "Site-selective oxygen-sulfur substitution reaction of Keggin-type polyoxometalate",
      "(<sup>1</sup>Univ. Tokyo) 〇Yota WATANABE<sup>1</sup>, Kentaro YONESATO<sup>1</sup>, Kosuke SUZUKI<sup>1</sup>, Kazuya YAMAGUCHI<sup>1</sup>"
    ],
    "lab": "1PA-80",
    "pdf": "pdf/1PA-80.pdf",
    "pre": "tn/1PA-80.jpg",
    "reg": "74193",
    "sea": "W",
    "ses": "1PA",
    "con": "1PA-80 Keggin型ポリオキソメタレートのサイト選択的な酸素-硫黄交換反応 (<sup>1</sup>東大院工) 〇渡辺 陽太<sup>1</sup>・米里 健太郎<sup>1</sup>・鈴木 康介<sup>1</sup>・山口 和也<sup>1</sup> Site-selective oxygen-sulfur substitution reaction of Keggin-type polyoxometalate (<sup>1</sup>Univ. Tokyo) 〇Yota WATANABE<sup>1</sup>, Kentaro YONESATO<sup>1</sup>, Kosuke SUZUKI<sup>1</sup>, Kazuya YAMAGUCHI<sup>1</sup> W"
  },
  {
    "inf": [
      "キャスト法による[NPr<sub>4</sub>][MnCr(C<sub>2</sub>O<sub>4</sub>)<sub>3</sub>] MOF 配向膜の作製",
      "(<sup>1</sup>東理大院理) 〇舟橋 友紀<sup>1</sup>・張 啓原<sup>1</sup>・原口 知之<sup>1</sup>",
      "Fabrication of Crystalline Oriented [NPr<sub>4</sub>][MnCr(C<sub>2</sub>O<sub>4</sub>)<sub>3</sub>]MOF Thin Film by Casting Method",
      "(<sup>1</sup>Graduate School of Sci, Tokyo University of Sci) 〇Yuki FUNAHASHI<sup>1</sup>, Qiyuan ZHANG<sup>1</sup>, Tomoyuki HARAGUCHI<sup>1</sup>"
    ],
    "lab": "1PA-81",
    "pdf": "pdf/1PA-81.pdf",
    "pre": "tn/1PA-81.jpg",
    "reg": "74176",
    "sea": "Mn, Cr",
    "ses": "1PA",
    "con": "1PA-81 キャスト法による[NPr<sub>4</sub>][MnCr(C<sub>2</sub>O<sub>4</sub>)<sub>3</sub>] MOF 配向膜の作製 (<sup>1</sup>東理大院理) 〇舟橋 友紀<sup>1</sup>・張 啓原<sup>1</sup>・原口 知之<sup>1</sup> Fabrication of Crystalline Oriented [NPr<sub>4</sub>][MnCr(C<sub>2</sub>O<sub>4</sub>)<sub>3</sub>]MOF Thin Film by Casting Method (<sup>1</sup>Graduate School of Sci, Tokyo University of Sci) 〇Yuki FUNAHASHI<sup>1</sup>, Qiyuan ZHANG<sup>1</sup>, Tomoyuki HARAGUCHI<sup>1</sup> Mn, Cr"
  },
  {
    "inf": [
      "ハニカム型ナノポーラス金属錯体の構造変化およびスピン転移による吸着熱の変化",
      "(<sup>1</sup>名大院工) ◎大野 華子<sup>1</sup>・Pirillo Jenny<sup>1 </sup>・Qu Liyuan<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1 </sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup>",
      "Change of Adsorption Heat by Structural Change and Spin Transition of Honeycomb-type Nanoporous Metal Complexes",
      "(<sup>1</sup>Nagoya Univ.) ◎Kako OHNO<sup>1</sup>, Jenny PIRILLO<sup>1 </sup>, Liyuan QU<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1 </sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup>"
    ],
    "lab": "1PA-82",
    "pdf": "pdf/1PA-82.pdf",
    "pre": "tn/1PA-82.jpg",
    "reg": "74553",
    "sea": "Co,Zn,Cu",
    "ses": "1PA",
    "con": "1PA-82 ハニカム型ナノポーラス金属錯体の構造変化およびスピン転移による吸着熱の変化 (<sup>1</sup>名大院工) ◎大野 華子<sup>1</sup>・Pirillo Jenny<sup>1 </sup>・Qu Liyuan<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1 </sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup> Change of Adsorption Heat by Structural Change and Spin Transition of Honeycomb-type Nanoporous Metal Complexes (<sup>1</sup>Nagoya Univ.) ◎Kako OHNO<sup>1</sup>, Jenny PIRILLO<sup>1 </sup>, Liyuan QU<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1 </sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup> Co,Zn,Cu"
  },
  {
    "inf": [
      "酸素ドナー配位子を有するコバルト二核および三核錯体の合成",
      "(<sup>1</sup>上智大理工) 〇伊東 稜晟<sup>1</sup>・三澤 智世<sup>1</sup>・長尾 宏隆<sup>1</sup>",
      "Syntheses of Dinuclear and Trinuclear Cobalt Complexes with the Oxygen-Donor Ligands",
      "(<sup>1</sup>Fac. of Sci. and Tech., Sophia Univ.) 〇Ryosei ITO<sup>1</sup>, Tomoyo MISAWA<sup>1</sup>, Hirotaka NAGAO<sup>1</sup>"
    ],
    "lab": "1PA-83",
    "pdf": "pdf/1PA-83.pdf",
    "pre": "tn/1PA-83.jpg",
    "reg": "74181",
    "sea": "Co",
    "ses": "1PA",
    "con": "1PA-83 酸素ドナー配位子を有するコバルト二核および三核錯体の合成 (<sup>1</sup>上智大理工) 〇伊東 稜晟<sup>1</sup>・三澤 智世<sup>1</sup>・長尾 宏隆<sup>1</sup> Syntheses of Dinuclear and Trinuclear Cobalt Complexes with the Oxygen-Donor Ligands (<sup>1</sup>Fac. of Sci. and Tech., Sophia Univ.) 〇Ryosei ITO<sup>1</sup>, Tomoyo MISAWA<sup>1</sup>, Hirotaka NAGAO<sup>1</sup> Co"
  },
  {
    "inf": [
      "ヘミアミナールエーテル構造を持つキラル遷移金属錯体に対するキラルアルコール導入反応におけるエナンチオ選択制",
      "(<sup>1</sup>東邦大院理) 〇篠塚 悠希<sup>1</sup>・横山 眞之介<sup>1</sup>・加知 千裕<sup>1</sup>",
      "Enantioselectivity in the reaction of chiral transition metal complexes bearing hemiaminal-ether moiety with chiral alcohols",
      "(<sup>1</sup>Toho Univ.) 〇Yuuki SINOZUKA<sup>1</sup>, Shinnosuke YOKOYAMA<sup>1</sup>, Chihiro KACHI-TERAJIMA<sup>1</sup>"
    ],
    "lab": "1PA-84",
    "pdf": "pdf/1PA-84.pdf",
    "pre": "tn/1PA-84.jpg",
    "reg": "74195",
    "sea": "Co, Ni",
    "ses": "1PA",
    "con": "1PA-84 ヘミアミナールエーテル構造を持つキラル遷移金属錯体に対するキラルアルコール導入反応におけるエナンチオ選択制 (<sup>1</sup>東邦大院理) 〇篠塚 悠希<sup>1</sup>・横山 眞之介<sup>1</sup>・加知 千裕<sup>1</sup> Enantioselectivity in the reaction of chiral transition metal complexes bearing hemiaminal-ether moiety with chiral alcohols (<sup>1</sup>Toho Univ.) 〇Yuuki SINOZUKA<sup>1</sup>, Shinnosuke YOKOYAMA<sup>1</sup>, Chihiro KACHI-TERAJIMA<sup>1</sup> Co, Ni"
  },
  {
    "inf": [
      "[2.2]パラシクロファンを配位子とした二核及び三核白金サンドイッチ錯体の合成",
      "(<sup>1</sup>東工大物質理工・<sup>2</sup>防衛大応用科学) ◎末永 東子<sup>1</sup>・田村 崚介<sup>1</sup>・山本 浩二<sup>2</sup>・重田 翼<sup>1</sup>・村橋 哲郎<sup>1</sup>",
      "Synthesis of Pt<sub>2</sub> and Pt<sub>3</sub> Sandwich Complexes Bearing [2.2]Paracyclophane Ligands",
      "(<sup>1</sup>Tokyo Institute of Technology, <sup>2</sup>National Defence Academy) ◎Toko SUENAGA<sup>1</sup>, Ryosuke TAMURA<sup>1</sup>, Koji YAMAMOTO<sup>2</sup>, Tsubasa OMODA<sup>1</sup>, Tetsuro Murahashi<sup>1</sup>"
    ],
    "lab": "1PA-85",
    "pdf": "pdf/1PA-85.pdf",
    "pre": "tn/1PA-85.jpg",
    "reg": "74558",
    "sea": "Pt",
    "ses": "1PA",
    "con": "1PA-85 [2.2]パラシクロファンを配位子とした二核及び三核白金サンドイッチ錯体の合成 (<sup>1</sup>東工大物質理工・<sup>2</sup>防衛大応用科学) ◎末永 東子<sup>1</sup>・田村 崚介<sup>1</sup>・山本 浩二<sup>2</sup>・重田 翼<sup>1</sup>・村橋 哲郎<sup>1</sup> Synthesis of Pt<sub>2</sub> and Pt<sub>3</sub> Sandwich Complexes Bearing [2.2]Paracyclophane Ligands (<sup>1</sup>Tokyo Institute of Technology, <sup>2</sup>National Defence Academy) ◎Toko SUENAGA<sup>1</sup>, Ryosuke TAMURA<sup>1</sup>, Koji YAMAMOTO<sup>2</sup>, Tsubasa OMODA<sup>1</sup>, Tetsuro Murahashi<sup>1</sup> Pt"
  },
  {
    "inf": [
      "簡素なAlkyldiamineから誘導されるN4O2型分岐状多座配位子を含む希土類錯体の合成と分光学的性質",
      "(<sup>1</sup>佐賀大院理工・<sup>2</sup>佐賀大理工) 〇堀部 和暉<sup>1</sup>・小川 由季<sup>1</sup>・黒岩 美鈴<sup>1</sup>・一木 駿佑<sup>2</sup>・坂田 士龍<sup>2</sup>・郡 大心<sup>2</sup>・米田 宏<sup>2</sup>・鯉川 雅之<sup>2</sup>・山田 泰教<sup>1,2</sup>",
      "Syntheses and Spectroscopic Properties of Rare-Earth(III) Complexes with N4O2-Type Branched Polydentate Ligands Derived from Simple Alkyldiamine Compounds",
      "(<sup>1</sup>Saga Univ., <sup>2</sup>Saga Univ.) 〇Kazuki HORIBE<sup>1</sup>, Yuki OGAWA<sup>1</sup>, Misuzu KUROIWA<sup>1</sup>, Shunsuke ICHIKI<sup>2</sup>, Shiryu SAKATA<sup>2</sup>, Daishin KORI<sup>2</sup>, Ko YONEDA<sup>2</sup>, Masayuki KOIKAWA<sup>2</sup>, Yasunori YAMADA<sup>1,2</sup>"
    ],
    "lab": "1PA-86",
    "pdf": "pdf/1PA-86.pdf",
    "pre": "tn/1PA-86.jpg",
    "reg": "74202",
    "sea": "Y, Tb",
    "ses": "1PA",
    "con": "1PA-86 簡素なAlkyldiamineから誘導されるN4O2型分岐状多座配位子を含む希土類錯体の合成と分光学的性質 (<sup>1</sup>佐賀大院理工・<sup>2</sup>佐賀大理工) 〇堀部 和暉<sup>1</sup>・小川 由季<sup>1</sup>・黒岩 美鈴<sup>1</sup>・一木 駿佑<sup>2</sup>・坂田 士龍<sup>2</sup>・郡 大心<sup>2</sup>・米田 宏<sup>2</sup>・鯉川 雅之<sup>2</sup>・山田 泰教<sup>1,2</sup> Syntheses and Spectroscopic Properties of Rare-Earth(III) Complexes with N4O2-Type Branched Polydentate Ligands Derived from Simple Alkyldiamine Compounds (<sup>1</sup>Saga Univ., <sup>2</sup>Saga Univ.) 〇Kazuki HORIBE<sup>1</sup>, Yuki OGAWA<sup>1</sup>, Misuzu KUROIWA<sup>1</sup>, Shunsuke ICHIKI<sup>2</sup>, Shiryu SAKATA<sup>2</sup>, Daishin KORI<sup>2</sup>, Ko YONEDA<sup>2</sup>, Masayuki KOIKAWA<sup>2</sup>, Yasunori YAMADA<sup>1,2</sup> Y, Tb"
  },
  {
    "inf": [
      "オキシド一重およびアセタト二重架橋ルテニウム(III)二核錯体の還元によるフレームワーク変換",
      "(<sup>1</sup>上智大理工) 〇林 昌弘<sup>1</sup>・三澤 智世<sup>1</sup>・長尾 宏隆<sup>1</sup>",
      "Framework Conversion of the Dinuclear Ruthenium(III) Complex Having an Oxido- and Two Acetato-bridged Structure upon Reduction",
      "(<sup>1</sup>Fac. of Sci. and Tech., Sophia Univ.) 〇Masahiro HAYASHI<sup>1</sup>, Tomoyo MISAWA<sup>1</sup>, Hirotaka NAGAO<sup>1</sup>"
    ],
    "lab": "1PA-87",
    "pdf": "pdf/1PA-87.pdf",
    "pre": "tn/1PA-87.jpg",
    "reg": "74182",
    "sea": "Ru",
    "ses": "1PA",
    "con": "1PA-87 オキシド一重およびアセタト二重架橋ルテニウム(III)二核錯体の還元によるフレームワーク変換 (<sup>1</sup>上智大理工) 〇林 昌弘<sup>1</sup>・三澤 智世<sup>1</sup>・長尾 宏隆<sup>1</sup> Framework Conversion of the Dinuclear Ruthenium(III) Complex Having an Oxido- and Two Acetato-bridged Structure upon Reduction (<sup>1</sup>Fac. of Sci. and Tech., Sophia Univ.) 〇Masahiro HAYASHI<sup>1</sup>, Tomoyo MISAWA<sup>1</sup>, Hirotaka NAGAO<sup>1</sup> Ru"
  },
  {
    "inf": [
      "ベンゼントリアミド誘導体を配位子とする金属錯体菱形十二面体",
      "(<sup>1</sup>京大院工・<sup>2</sup>京大iCeMS) ◎吉田 亮平<sup>1,2</sup>・徳田 駿<sup>2</sup>・宮田 彩名<sup>1,2</sup>・古川 修平<sup>1,2</sup>",
      "Metal-Organic Rhombic dodecahedra based on benzenetriamide derivative ligands",
      "(<sup>1</sup>Kyoto University Graduate School of Engineering, <sup>2</sup>Kyoto University iCeMS, Institute for Integrated Cell-Material Sciences) ◎Ryohei YOSHIDA<sup>1,2</sup>, Shun TOKUDA<sup>2</sup>, Ayana MIYATA<sup>1,2</sup>, Shuhei FURUKAWA<sup>1,2</sup>"
    ],
    "lab": "1PA-88",
    "pdf": "pdf/1PA-88.pdf",
    "pre": "tn/1PA-88.jpg",
    "reg": "74575",
    "sea": "Cu",
    "ses": "1PA",
    "con": "1PA-88 ベンゼントリアミド誘導体を配位子とする金属錯体菱形十二面体 (<sup>1</sup>京大院工・<sup>2</sup>京大iCeMS) ◎吉田 亮平<sup>1,2</sup>・徳田 駿<sup>2</sup>・宮田 彩名<sup>1,2</sup>・古川 修平<sup>1,2</sup> Metal-Organic Rhombic dodecahedra based on benzenetriamide derivative ligands (<sup>1</sup>Kyoto University Graduate School of Engineering, <sup>2</sup>Kyoto University iCeMS, Institute for Integrated Cell-Material Sciences) ◎Ryohei YOSHIDA<sup>1,2</sup>, Shun TOKUDA<sup>2</sup>, Ayana MIYATA<sup>1,2</sup>, Shuhei FURUKAWA<sup>1,2</sup> Cu"
  },
  {
    "inf": [
      "疎水性基で外面修飾した有機ケージ分子内での酸化亜鉛ナノ粒子合成",
      "(<sup>1</sup>筑波大院数物) 〇多田 結香<sup>1</sup>・三原 のぞみ<sup>1</sup>・志賀 拓也<sup>1</sup>・二瓶 雅之<sup>1</sup>",
      "Synthesis of zinc oxide nanoparticle in an organic cage molecule with the hydrophobic exterior surface",
      "(<sup>1</sup>Degree Programs in Pure and Applied Sciences, Graduate School of Science and Technology, University of Tsukuba) 〇Yuika TADA<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Masayuki NIHEI<sup>1</sup>"
    ],
    "lab": "1PA-89",
    "pdf": "pdf/1PA-89.pdf",
    "pre": "tn/1PA-89.jpg",
    "reg": "74232",
    "sea": "Zn",
    "ses": "1PA",
    "con": "1PA-89 疎水性基で外面修飾した有機ケージ分子内での酸化亜鉛ナノ粒子合成 (<sup>1</sup>筑波大院数物) 〇多田 結香<sup>1</sup>・三原 のぞみ<sup>1</sup>・志賀 拓也<sup>1</sup>・二瓶 雅之<sup>1</sup> Synthesis of zinc oxide nanoparticle in an organic cage molecule with the hydrophobic exterior surface (<sup>1</sup>Degree Programs in Pure and Applied Sciences, Graduate School of Science and Technology, University of Tsukuba) 〇Yuika TADA<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Masayuki NIHEI<sup>1</sup> Zn"
  },
  {
    "inf": [
      "Tris(1H-pyrazol-3-ylmethylene)-1,3,5-cyclohexanetriamine を含む新規 3d 錯体の合成と構造評価",
      "(<sup>1</sup>岡山大院環境生命自然・<sup>2</sup>兵庫県大院理・<sup>3</sup>岡山大基礎研) 〇妹尾 赳瑠<sup>1</sup>・大川 真輝<sup>1</sup>・髙原 一真<sup>2</sup>・磯部 寛<sup>3</sup>・鈴木 孝義<sup>1,3</sup>",
      "Synthesis of the Novel 3d Complexes Bearing Tris(1H-pyrazol-3-ylmethylene)-1,3,5-cyclohexanetriamine and Examination of their Structural Properties",
      "(<sup>1</sup>Graduate School of Environmental, Life, Natural Science and Technology, Okayama Univ., <sup>2</sup>Graduate School of Science, University of Hyogo, <sup>3</sup>RIIS, Okayama Univ.) 〇Takeru SENOO<sup>1</sup>, Masaki OKAWA<sup>1</sup>, Kazuma TAKAHARA<sup>2</sup>, Hiroshi ISOBE<sup>3</sup>, Takayoshi SUZUKI<sup>1,3</sup>"
    ],
    "lab": "1PA-90",
    "pdf": "pdf/1PA-90.pdf",
    "pre": "tn/1PA-90.jpg",
    "reg": "74207",
    "sea": "Ni",
    "ses": "1PA",
    "con": "1PA-90 Tris(1H-pyrazol-3-ylmethylene)-1,3,5-cyclohexanetriamine を含む新規 3d 錯体の合成と構造評価 (<sup>1</sup>岡山大院環境生命自然・<sup>2</sup>兵庫県大院理・<sup>3</sup>岡山大基礎研) 〇妹尾 赳瑠<sup>1</sup>・大川 真輝<sup>1</sup>・髙原 一真<sup>2</sup>・磯部 寛<sup>3</sup>・鈴木 孝義<sup>1,3</sup> Synthesis of the Novel 3d Complexes Bearing Tris(1H-pyrazol-3-ylmethylene)-1,3,5-cyclohexanetriamine and Examination of their Structural Properties (<sup>1</sup>Graduate School of Environmental, Life, Natural Science and Technology, Okayama Univ., <sup>2</sup>Graduate School of Science, University of Hyogo, <sup>3</sup>RIIS, Okayama Univ.) 〇Takeru SENOO<sup>1</sup>, Masaki OKAWA<sup>1</sup>, Kazuma TAKAHARA<sup>2</sup>, Hiroshi ISOBE<sup>3</sup>, Takayoshi SUZUKI<sup>1,3</sup> Ni"
  },
  {
    "inf": [
      "一酸化窒素還元酵素を模倣した水溶性ヘム/非ヘム鉄二核超分子錯体とNO結合挙動の検討",
      "(<sup>1</sup>同志社大院理工) 〇大塚 広幹<sup>1</sup>・中上 敦貴<sup>1</sup>・小寺 政人<sup>1</sup>・北岸 宏亮<sup>1</sup>",
      "Investigation of the NO binding of a water-soluble heme/non-heme iron binuclear supramolecular complex that mimics nitric oxide reductase",
      "(<sup>1</sup>Doshisha Univ.) 〇Hiroki OTSUKA<sup>1</sup>, Atsuki NAKAGAMI<sup>1</sup>, Masahito KODERA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>"
    ],
    "lab": "1PA-91",
    "pdf": "pdf/1PA-91.pdf",
    "pre": "tn/1PA-91.jpg",
    "reg": "74233",
    "sea": "Fe",
    "ses": "1PA",
    "con": "1PA-91 一酸化窒素還元酵素を模倣した水溶性ヘム/非ヘム鉄二核超分子錯体とNO結合挙動の検討 (<sup>1</sup>同志社大院理工) 〇大塚 広幹<sup>1</sup>・中上 敦貴<sup>1</sup>・小寺 政人<sup>1</sup>・北岸 宏亮<sup>1</sup> Investigation of the NO binding of a water-soluble heme/non-heme iron binuclear supramolecular complex that mimics nitric oxide reductase (<sup>1</sup>Doshisha Univ.) 〇Hiroki OTSUKA<sup>1</sup>, Atsuki NAKAGAMI<sup>1</sup>, Masahito KODERA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "高原子価ビス-μ-オキソ種の生成を目指した4座アミン型鉄(Ⅱ)錯体の合成と性質",
      "(<sup>1</sup>名工大院工・<sup>2</sup>愛工大工) 〇山本 彩未<sup>1</sup>・<sup>1</sup>・<sup>1</sup>・<sup>1</sup>・<sup>2</sup>",
      "Synthesis and characterization of Fe(II) complex with an tetraamino-type ligand directed to the formation of high-valent bis-μ-oxo species.",
      "(<sup>1</sup>2Graduate School of Engineering, Nagoya Institute of Technology, <sup>2</sup>Aichi Institute of Technology) 〇Ayami Yamamoto<sup>1</sup>, Itsuki Igarashi<sup>1</sup>, Tomohiko Inomata<sup>1</sup>, Tomohiro Ozawa<sup>1</sup>, Hideki Masuda <sup>2</sup>"
    ],
    "lab": "1PA-92",
    "pdf": "pdf/1PA-92.pdf",
    "pre": "tn/1PA-92.jpg",
    "reg": "74234",
    "sea": "Fe",
    "ses": "1PA",
    "con": "1PA-92 高原子価ビス-μ-オキソ種の生成を目指した4座アミン型鉄(Ⅱ)錯体の合成と性質 (<sup>1</sup>名工大院工・<sup>2</sup>愛工大工) 〇山本 彩未<sup>1</sup>・<sup>1</sup>・<sup>1</sup>・<sup>1</sup>・<sup>2</sup> Synthesis and characterization of Fe(II) complex with an tetraamino-type ligand directed to the formation of high-valent bis-μ-oxo species. (<sup>1</sup>2Graduate School of Engineering, Nagoya Institute of Technology, <sup>2</sup>Aichi Institute of Technology) 〇Ayami Yamamoto<sup>1</sup>, Itsuki Igarashi<sup>1</sup>, Tomohiko Inomata<sup>1</sup>, Tomohiro Ozawa<sup>1</sup>, Hideki Masuda <sup>2</sup> Fe"
  },
  {
    "inf": [
      "テトラフルオロイソフタル酸を用いた亜鉛(Ⅱ)錯体の二次元シート間距離の拡張及び吸着挙動",
      "(<sup>1</sup>芝浦工大) 〇横田 悠斗<sup>1</sup>・阿部 将大<sup>1</sup>・實方 友輝<sup>1</sup>・堀 顕子<sup>1</sup>",
      "Expansion of two-dimensional sheet distance and adsorption behavior of zinc(Ⅱ) complex using tetrafluoroisophthalic acid",
      "(<sup>1</sup>Shibaura Inst. Tech.) 〇Yuto Yokota<sup>1</sup>, Masahiro Abe<sup>1</sup>, Tomoki Jitsukata<sup>1</sup>, Akiko Hori<sup>1</sup>"
    ],
    "lab": "1PA-93",
    "pdf": "pdf/1PA-93.pdf",
    "pre": "tn/1PA-93.jpg",
    "reg": "74257",
    "sea": "Zn",
    "ses": "1PA",
    "con": "1PA-93 テトラフルオロイソフタル酸を用いた亜鉛(Ⅱ)錯体の二次元シート間距離の拡張及び吸着挙動 (<sup>1</sup>芝浦工大) 〇横田 悠斗<sup>1</sup>・阿部 将大<sup>1</sup>・實方 友輝<sup>1</sup>・堀 顕子<sup>1</sup> Expansion of two-dimensional sheet distance and adsorption behavior of zinc(Ⅱ) complex using tetrafluoroisophthalic acid (<sup>1</sup>Shibaura Inst. Tech.) 〇Yuto Yokota<sup>1</sup>, Masahiro Abe<sup>1</sup>, Tomoki Jitsukata<sup>1</sup>, Akiko Hori<sup>1</sup> Zn"
  },
  {
    "inf": [
      "低過電圧化を指向した新規コバルトポルフィリン酸素生成触媒の合成と分子性TiO<sub>2</sub>フォトアノードへの応用",
      "(<sup>1</sup>九大院理) 〇中村 拓海<sup>1</sup>・酒井 健<sup>1</sup>・小澤 弘宜<sup>1</sup>",
      "Synthesis of a novel Co porphyrin as a low overpotential water oxidation catalyst and its application to the molecular-based TiO<sub>2</sub> photoanode",
      "(<sup>1</sup>Kyushu univ.) 〇Takumi NAKAMURA<sup>1</sup>, Ken SAKAI<sup>1</sup>, Hironobu OZAWA<sup>1</sup>"
    ],
    "lab": "1PA-94",
    "pdf": "pdf/1PA-94.pdf",
    "pre": "tn/1PA-94.jpg",
    "reg": "74390",
    "sea": "Co, Cu",
    "ses": "1PA",
    "con": "1PA-94 低過電圧化を指向した新規コバルトポルフィリン酸素生成触媒の合成と分子性TiO<sub>2</sub>フォトアノードへの応用 (<sup>1</sup>九大院理) 〇中村 拓海<sup>1</sup>・酒井 健<sup>1</sup>・小澤 弘宜<sup>1</sup> Synthesis of a novel Co porphyrin as a low overpotential water oxidation catalyst and its application to the molecular-based TiO<sub>2</sub> photoanode (<sup>1</sup>Kyushu univ.) 〇Takumi NAKAMURA<sup>1</sup>, Ken SAKAI<sup>1</sup>, Hironobu OZAWA<sup>1</sup> Co, Cu"
  },
  {
    "inf": [
      "**Acetylene-induced unique electronic state modulations in a layered MOF**",
      "(<sup>1</sup>Institute for Materials Research, Tohoku University) ◎Masaki Mimura<sup>1</sup>, Wataru Kosaka<sup>1</sup>, Hitoshi Miyasaka<sup>1</sup>"
    ],
    "lab": "1PB-01",
    "pdf": "pdf/1PB-01.pdf",
    "pre": "tn/1PB-01.jpg",
    "reg": "74242",
    "sea": "Ru",
    "ses": "1PB",
    "con": "1PB-01 **Acetylene-induced unique electronic state modulations in a layered MOF** (<sup>1</sup>Institute for Materials Research, Tohoku University) ◎Masaki Mimura<sup>1</sup>, Wataru Kosaka<sup>1</sup>, Hitoshi Miyasaka<sup>1</sup> Ru"
  },
  {
    "inf": [
      "Ru<sub>2</sub>-TCNQからなる金属-有機構造体における分子構造と磁気的相互作用の関係に関する理論研究",
      "(<sup>1</sup>阪大院基礎工・<sup>2</sup>東北大金研) 〇甘水 君佳<sup>1</sup>・多田 幸平<sup>1</sup>・岸 亮平<sup>1</sup>・高坂 亘<sup>2</sup>・宮坂 等<sup>2</sup>・北河 康隆<sup>1</sup>",
      "Theoretical study on relationship between local molecular structure and magnetic exchange interaction in metal-organic frameworks consisting of Ru<sub>2</sub> complexes and TCNQ derivatives.",
      "(<sup>1</sup>Graduate School of Engineering Science, Osaka Univ., <sup>2</sup>IMR, Tohoku Univ.) 〇Naoka AMAMIZU<sup>1</sup>, Kohei TADA<sup>1</sup>, Ryohei KISHI<sup>1</sup>, Wataru KOSAKA<sup>2</sup>, Hitoshi MIYASAKA<sup>2</sup>, Yasutaka KITAGAWA<sup>1</sup>"
    ],
    "lab": "1PB-02",
    "pdf": "pdf/1PB-02.pdf",
    "pre": "tn/1PB-02.jpg",
    "reg": "74101",
    "sea": "Ru",
    "ses": "1PB",
    "con": "1PB-02 Ru<sub>2</sub>-TCNQからなる金属-有機構造体における分子構造と磁気的相互作用の関係に関する理論研究 (<sup>1</sup>阪大院基礎工・<sup>2</sup>東北大金研) 〇甘水 君佳<sup>1</sup>・多田 幸平<sup>1</sup>・岸 亮平<sup>1</sup>・高坂 亘<sup>2</sup>・宮坂 等<sup>2</sup>・北河 康隆<sup>1</sup> Theoretical study on relationship between local molecular structure and magnetic exchange interaction in metal-organic frameworks consisting of Ru<sub>2</sub> complexes and TCNQ derivatives. (<sup>1</sup>Graduate School of Engineering Science, Osaka Univ., <sup>2</sup>IMR, Tohoku Univ.) 〇Naoka AMAMIZU<sup>1</sup>, Kohei TADA<sup>1</sup>, Ryohei KISHI<sup>1</sup>, Wataru KOSAKA<sup>2</sup>, Hitoshi MIYASAKA<sup>2</sup>, Yasutaka KITAGAWA<sup>1</sup> Ru"
  },
  {
    "inf": [
      "Mechanistic Insights into Selective Formate Formation by Ni-NHC Catalysts: Nucleophilic Attack of Metal Hydride to CO<sub>2</sub>",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) ◎Chen LIAO<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "1PB-03",
    "pdf": "pdf/1PB-03.pdf",
    "pre": "tn/1PB-03.jpg",
    "reg": "74294",
    "sea": "Ni",
    "ses": "1PB",
    "con": "1PB-03 Mechanistic Insights into Selective Formate Formation by Ni-NHC Catalysts: Nucleophilic Attack of Metal Hydride to CO<sub>2</sub> (<sup>1</sup>Dept. Chem. Kyushu Univ.) ◎Chen LIAO<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Ni"
  },
  {
    "inf": [
      "トリオキソトリアンギュレンと超分子錯体カチオンからなる高導電性結晶の構造と物性",
      "(<sup>1</sup>愛工大工) 〇村田 剛志<sup>1</sup>・唐澤 美琴<sup>1</sup>・森田 靖<sup>1</sup>",
      "Conductive crystals composed of trioxotriangulene and supramolecular complex cations",
      "(<sup>1</sup>AICHI INSTITUTE OF TECHNOLOGY) 〇Tsuyoshi MURATA<sup>1</sup>, Mikoto KARASAWA<sup>1</sup>, Yasushi MORITA<sup>1</sup>"
    ],
    "lab": "1PB-04",
    "pdf": "pdf/1PB-04.pdf",
    "pre": "tn/1PB-04.jpg",
    "reg": "74005",
    "sea": "K",
    "ses": "1PB",
    "con": "1PB-04 トリオキソトリアンギュレンと超分子錯体カチオンからなる高導電性結晶の構造と物性 (<sup>1</sup>愛工大工) 〇村田 剛志<sup>1</sup>・唐澤 美琴<sup>1</sup>・森田 靖<sup>1</sup> Conductive crystals composed of trioxotriangulene and supramolecular complex cations (<sup>1</sup>AICHI INSTITUTE OF TECHNOLOGY) 〇Tsuyoshi MURATA<sup>1</sup>, Mikoto KARASAWA<sup>1</sup>, Yasushi MORITA<sup>1</sup> K"
  },
  {
    "inf": [
      "中心元素を変更した金属5核錯体の合成と性質",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇濱野 輝<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup>",
      "Synthesis and properties of core-modified pentanuclear metal complexes",
      "(<sup>1</sup>1.\\tGraduate School of Engineering, Osaka University, <sup>2</sup>2.\\tSchool of Science, Tokyo Institute of Technology) 〇Hikaru HAMANO<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tatsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "1PB-05",
    "pdf": "pdf/1PB-05.pdf",
    "pre": "tn/1PB-05.jpg",
    "reg": "74394",
    "sea": "Fe",
    "ses": "1PB",
    "con": "1PB-05 中心元素を変更した金属5核錯体の合成と性質 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇濱野 輝<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup> Synthesis and properties of core-modified pentanuclear metal complexes (<sup>1</sup>1.\\tGraduate School of Engineering, Osaka University, <sup>2</sup>2.\\tSchool of Science, Tokyo Institute of Technology) 〇Hikaru HAMANO<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tatsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup> Fe"
  },
  {
    "inf": [
      "ヨウ化テルルを用いた有機-無機ハイブリッド型一次元キラル単結晶の合成と光電変換特性",
      "(<sup>1</sup>早稲田大) ◎中村 大輝<sup>1</sup>・鈴木 ひかり<sup>1</sup>・木下 雄介<sup>1</sup>・石井 あゆみ<sup>1</sup>",
      "Synthesis and photoelectric conversion of Tellurium(Ⅳ) iodide based one-dimensional chiral single crystal with organic/inorganic hybrid structure",
      "(<sup>1</sup>Waseda Univ) ◎Daiki Nakamura<sup>1</sup>, Hikari Suzuki<sup>1</sup>, Yusuke Kinoshita<sup>1</sup>, Ayumi Ishii<sup>1</sup>"
    ],
    "lab": "1PB-06",
    "pdf": "pdf/1PB-06.pdf",
    "pre": "tn/1PB-06.jpg",
    "reg": "74288",
    "sea": "Te",
    "ses": "1PB",
    "con": "1PB-06 ヨウ化テルルを用いた有機-無機ハイブリッド型一次元キラル単結晶の合成と光電変換特性 (<sup>1</sup>早稲田大) ◎中村 大輝<sup>1</sup>・鈴木 ひかり<sup>1</sup>・木下 雄介<sup>1</sup>・石井 あゆみ<sup>1</sup> Synthesis and photoelectric conversion of Tellurium(Ⅳ) iodide based one-dimensional chiral single crystal with organic/inorganic hybrid structure (<sup>1</sup>Waseda Univ) ◎Daiki Nakamura<sup>1</sup>, Hikari Suzuki<sup>1</sup>, Yusuke Kinoshita<sup>1</sup>, Ayumi Ishii<sup>1</sup> Te"
  },
  {
    "inf": [
      "ベンゼンチオール誘導体を配位子とする鉛二価半導体配位高分子の系統的な合成と置換基効果",
      "(<sup>1</sup>関学大理・<sup>2</sup>阪大院工) 〇井上実優<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯昭紀<sup>2</sup>・田中大輔<sup>1</sup>",
      "Synthesis of Semiconductive Lead(II) Coordination Polymers with benzenethiol derivatives ligands and Substituent Effect",
      "(<sup>1</sup>School of Science, Kwansei Gakuin University, <sup>2</sup>Graduate School of Engineering, Osaka University) 〇Miyu INOUE<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "1PB-07",
    "pdf": "pdf/1PB-07.pdf",
    "pre": "tn/1PB-07.jpg",
    "reg": "74037",
    "sea": "Pb",
    "ses": "1PB",
    "con": "1PB-07 ベンゼンチオール誘導体を配位子とする鉛二価半導体配位高分子の系統的な合成と置換基効果 (<sup>1</sup>関学大理・<sup>2</sup>阪大院工) 〇井上実優<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯昭紀<sup>2</sup>・田中大輔<sup>1</sup> Synthesis of Semiconductive Lead(II) Coordination Polymers with benzenethiol derivatives ligands and Substituent Effect (<sup>1</sup>School of Science, Kwansei Gakuin University, <sup>2</sup>Graduate School of Engineering, Osaka University) 〇Miyu INOUE<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Daisuke TANAKA<sup>1</sup> Pb"
  },
  {
    "inf": [
      "アニオン架橋金属鎖状骨格を有する多孔性分子導体の系統的合成と構造制御",
      "(<sup>1</sup>名大院工) 〇白木 風渡<sup>1</sup>・Pirillo Jenny<sup>1</sup>・Qu Liyuan<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1</sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup>",
      "Systematic Syntheses and Structural Control of Porous Molecular Conductors with Anion-Bridged Metal Chain Structure",
      "(<sup>1</sup>Nagoya Univ.) 〇Kazato SHIRAKI<sup>1</sup>, Pirillo Jenny<sup>1</sup>, Qu Liyuan<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1</sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup>"
    ],
    "lab": "1PB-08",
    "pdf": "pdf/1PB-08.pdf",
    "pre": "tn/1PB-08.jpg",
    "reg": "74517",
    "sea": "Fe, Mn, Cd, Zn",
    "ses": "1PB",
    "con": "1PB-08 アニオン架橋金属鎖状骨格を有する多孔性分子導体の系統的合成と構造制御 (<sup>1</sup>名大院工) 〇白木 風渡<sup>1</sup>・Pirillo Jenny<sup>1</sup>・Qu Liyuan<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1</sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup> Systematic Syntheses and Structural Control of Porous Molecular Conductors with Anion-Bridged Metal Chain Structure (<sup>1</sup>Nagoya Univ.) 〇Kazato SHIRAKI<sup>1</sup>, Pirillo Jenny<sup>1</sup>, Qu Liyuan<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1</sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup> Fe, Mn, Cd, Zn"
  },
  {
    "inf": [
      "レドックス活性な5-ヒドロキシ-4(9_H_)-アクリジノンを用いたスズ錯体の合成と構造",
      "(<sup>1</sup>学習院大理) ◎岩本 誠矢<sup>1</sup>・高橋 慎太郎<sup>1</sup>・狩野 直和<sup>1</sup>",
      "Synthesis and structure of a tin complex using redox-active 5-hydroxy-4(9_H_)-acridinone",
      "(<sup>1</sup>Gakushuin Univ.) ◎Seiya IWAMOTO<sup>1</sup>, Shintaro TAKAHASHI<sup>1</sup>, Naokazu KANO<sup>1</sup>"
    ],
    "lab": "1PB-09",
    "pdf": "pdf/1PB-09.pdf",
    "pre": "tn/1PB-09.jpg",
    "reg": "74439",
    "sea": "Sn, Si",
    "ses": "1PB",
    "con": "1PB-09 レドックス活性な5-ヒドロキシ-4(9_H_)-アクリジノンを用いたスズ錯体の合成と構造 (<sup>1</sup>学習院大理) ◎岩本 誠矢<sup>1</sup>・高橋 慎太郎<sup>1</sup>・狩野 直和<sup>1</sup> Synthesis and structure of a tin complex using redox-active 5-hydroxy-4(9_H_)-acridinone (<sup>1</sup>Gakushuin Univ.) ◎Seiya IWAMOTO<sup>1</sup>, Shintaro TAKAHASHI<sup>1</sup>, Naokazu KANO<sup>1</sup> Sn, Si"
  },
  {
    "inf": [
      "シクロペンタジエノンタンタル(I)錯体の合成と電子状態",
      "(<sup>1</sup>東大院工・<sup>2</sup>都立大理) 〇近藤 誉也<sup>1</sup>・楠本 周平<sup>2</sup>・ 野崎 京子<sup>1</sup>",
      "Synthesis and Electronic States of Cyclopentadienone Tantalum(I) Complex",
      "(<sup>1</sup>Univ. of Tokyo, Grad. School of Eng., <sup>2</sup>Tokyo Metropolitan Univ. Faculty of Sci.) 〇Takaya KONDO<sup>1</sup>, Shuhei KUSUMOTO<sup>2</sup>, Kyoko NOZAKI<sup>1</sup>"
    ],
    "lab": "1PB-10",
    "pdf": "pdf/1PB-10.pdf",
    "pre": "tn/1PB-10.jpg",
    "reg": "74096",
    "sea": "Ta",
    "ses": "1PB",
    "con": "1PB-10 シクロペンタジエノンタンタル(I)錯体の合成と電子状態 (<sup>1</sup>東大院工・<sup>2</sup>都立大理) 〇近藤 誉也<sup>1</sup>・楠本 周平<sup>2</sup>・ 野崎 京子<sup>1</sup> Synthesis and Electronic States of Cyclopentadienone Tantalum(I) Complex (<sup>1</sup>Univ. of Tokyo, Grad. School of Eng., <sup>2</sup>Tokyo Metropolitan Univ. Faculty of Sci.) 〇Takaya KONDO<sup>1</sup>, Shuhei KUSUMOTO<sup>2</sup>, Kyoko NOZAKI<sup>1</sup> Ta"
  },
  {
    "inf": [
      "ニトロキシドラジカル置換トリイミンおよびジイミン類による常磁性スピンクロスオーバー配位子の開発",
      "(<sup>1</sup>電通大基盤理工) 野口 義正<sup>1</sup>・長谷 朱音<sup>1</sup>・高野 莉奈<sup>1</sup>・〇石田 尚行<sup>1</sup>",
      "Development of Nitroxide-Substituted Paramagnetic Triimines and Diimines for Spin-Crossover Ligands",
      "(<sup>1</sup>The Univ. of Electro-Communications) Yoshimasa Noguchi<sup>1</sup>, Akane Hase<sup>1</sup>, Rina Takano<sup>1</sup>, 〇Takayuki Ishida<sup>1</sup>"
    ],
    "lab": "1PB-11",
    "pdf": "pdf/1PB-11.pdf",
    "pre": "tn/1PB-11.jpg",
    "reg": "74219",
    "sea": "Fe",
    "ses": "1PB",
    "con": "1PB-11 ニトロキシドラジカル置換トリイミンおよびジイミン類による常磁性スピンクロスオーバー配位子の開発 (<sup>1</sup>電通大基盤理工) 野口 義正<sup>1</sup>・長谷 朱音<sup>1</sup>・高野 莉奈<sup>1</sup>・〇石田 尚行<sup>1</sup> Development of Nitroxide-Substituted Paramagnetic Triimines and Diimines for Spin-Crossover Ligands (<sup>1</sup>The Univ. of Electro-Communications) Yoshimasa Noguchi<sup>1</sup>, Akane Hase<sup>1</sup>, Rina Takano<sup>1</sup>, 〇Takayuki Ishida<sup>1</sup> Fe"
  },
  {
    "inf": [
      "高周期pブロック元素DOTAM錯体の非共有電子対が配位構造に及ぼす効果",
      "(<sup>1</sup>阪大院理・<sup>2</sup>阪大Core-FC・<sup>3</sup>阪大理) ◎青戸 宏樹<sup>1</sup>・永田 光知郎<sup>2</sup>・金子 政志<sup>1</sup>・風間 裕行<sup>1</sup>・前田 遥香<sup>1</sup>・川岸 英峻<sup>3</sup>・笠松 良崇<sup>1</sup>",
      "Structual Effect of the Lone Pair on Heavy P-block DOTAM Complexes",
      "(<sup>1</sup>Graduate School of Science, OSAKA UNIVERSITY, <sup>2</sup>Core Facility Center, OSAKA UNIVERSITY, <sup>3</sup>School of Science, OSAKA UNIVERSITY) ◎Hiroki AOTO<sup>1</sup>, Kojiro NAGATA<sup>2</sup>, Masashi KANEKO<sup>1</sup>, Hiroyuki KAZAMA<sup>1</sup>, Haruka MAEDA<sup>1</sup>, Eishun KAWAGISHI<sup>3</sup>, Yoshitaka KASAMATSU<sup>1</sup>"
    ],
    "lab": "1PB-12",
    "pdf": "pdf/1PB-12.pdf",
    "pre": "tn/1PB-12.jpg",
    "reg": "74487",
    "sea": "Tl, Pb, Bi, Sn",
    "ses": "1PB",
    "con": "1PB-12 高周期pブロック元素DOTAM錯体の非共有電子対が配位構造に及ぼす効果 (<sup>1</sup>阪大院理・<sup>2</sup>阪大Core-FC・<sup>3</sup>阪大理) ◎青戸 宏樹<sup>1</sup>・永田 光知郎<sup>2</sup>・金子 政志<sup>1</sup>・風間 裕行<sup>1</sup>・前田 遥香<sup>1</sup>・川岸 英峻<sup>3</sup>・笠松 良崇<sup>1</sup> Structual Effect of the Lone Pair on Heavy P-block DOTAM Complexes (<sup>1</sup>Graduate School of Science, OSAKA UNIVERSITY, <sup>2</sup>Core Facility Center, OSAKA UNIVERSITY, <sup>3</sup>School of Science, OSAKA UNIVERSITY) ◎Hiroki AOTO<sup>1</sup>, Kojiro NAGATA<sup>2</sup>, Masashi KANEKO<sup>1</sup>, Hiroyuki KAZAMA<sup>1</sup>, Haruka MAEDA<sup>1</sup>, Eishun KAWAGISHI<sup>3</sup>, Yoshitaka KASAMATSU<sup>1</sup> Tl, Pb, Bi, Sn"
  },
  {
    "inf": [
      "Bond Formation Between Organohalide and Styrene Using a Rh<sup>I</sup> complex Storing Electrons from H<sub>2</sub>",
      "(<sup>1</sup>Grad. Sch. of Eng., Kyushu Univ., <sup>2</sup>I2CNER, <sup>3</sup>sMol, <sup>4</sup>Fac. of Sci. and Eng., Kindai Univ.) ◎Kaho YAMADA<sup>1,2</sup>, Yuu KAJIWARA<sup>1,2</sup>, Takeshi YATABE<sup>1,2,3</sup>, Hidetaka NAKAI<sup>4</sup>, Seiji OGO<sup>1,2,3</sup>"
    ],
    "lab": "1PC-01",
    "pdf": "pdf/1PC-01.pdf",
    "pre": "tn/1PC-01.jpg",
    "reg": "74352",
    "sea": "Rh",
    "ses": "1PC",
    "con": "1PC-01 Bond Formation Between Organohalide and Styrene Using a Rh<sup>I</sup> complex Storing Electrons from H<sub>2</sub> (<sup>1</sup>Grad. Sch. of Eng., Kyushu Univ., <sup>2</sup>I2CNER, <sup>3</sup>sMol, <sup>4</sup>Fac. of Sci. and Eng., Kindai Univ.) ◎Kaho YAMADA<sup>1,2</sup>, Yuu KAJIWARA<sup>1,2</sup>, Takeshi YATABE<sup>1,2,3</sup>, Hidetaka NAKAI<sup>4</sup>, Seiji OGO<sup>1,2,3</sup> Rh"
  },
  {
    "inf": [
      "準安定なPd(II)環状錯体のヘテロレプテックな段階的自己集合",
      "(<sup>1</sup>東大院総合文化) 〇真田 直樹<sup>1</sup>・阿部 司<sup>1</sup>・竹内 啓介<sup>1</sup>・平岡 秀一<sup>1</sup>",
      "Stepwise formation of heteroleptic assemblies from metastable Pd(II) cyclic complexes",
      "(<sup>1</sup>The Univ. of Tokyo) 〇Naoki SANADA<sup>1</sup>, Tsukasa ABE<sup>1</sup>, Keisuke TAKEUCHI<sup>1</sup>, Shuichi HIRAOKA<sup>1</sup>"
    ],
    "lab": "1PC-02",
    "pdf": "pdf/1PC-02.pdf",
    "pre": "tn/1PC-02.jpg",
    "reg": "74044",
    "sea": "Pd",
    "ses": "1PC",
    "con": "1PC-02 準安定なPd(II)環状錯体のヘテロレプテックな段階的自己集合 (<sup>1</sup>東大院総合文化) 〇真田 直樹<sup>1</sup>・阿部 司<sup>1</sup>・竹内 啓介<sup>1</sup>・平岡 秀一<sup>1</sup> Stepwise formation of heteroleptic assemblies from metastable Pd(II) cyclic complexes (<sup>1</sup>The Univ. of Tokyo) 〇Naoki SANADA<sup>1</sup>, Tsukasa ABE<sup>1</sup>, Keisuke TAKEUCHI<sup>1</sup>, Shuichi HIRAOKA<sup>1</sup> Pd"
  },
  {
    "inf": [
      "Overall Water Splitting by a Single Semiconductor Photocatalyst Utilizing Cobalt-Based Polyoxometalates as a Hole Reservoir and a Water Oxidation Catalyst",
      "(<sup>1</sup>Kyoto Univ., <sup>2</sup>PRESTO/JST) ◎Harutaka NINOMIYA<sup>1</sup>, Osamu TOMITA<sup>1</sup>, Hajime SUZUKI<sup>1</sup>, Akinobu NAKADA<sup>1,2</sup>, Ryu ABE<sup>1</sup>"
    ],
    "lab": "1PC-03",
    "pdf": "pdf/1PC-03.pdf",
    "pre": "tn/1PC-03.jpg",
    "reg": "74408",
    "sea": "Co, W",
    "ses": "1PC",
    "con": "1PC-03 Overall Water Splitting by a Single Semiconductor Photocatalyst Utilizing Cobalt-Based Polyoxometalates as a Hole Reservoir and a Water Oxidation Catalyst (<sup>1</sup>Kyoto Univ., <sup>2</sup>PRESTO/JST) ◎Harutaka NINOMIYA<sup>1</sup>, Osamu TOMITA<sup>1</sup>, Hajime SUZUKI<sup>1</sup>, Akinobu NAKADA<sup>1,2</sup>, Ryu ABE<sup>1</sup> Co, W"
  },
  {
    "inf": [
      "還元的ラジカル-極性クロスオーバー機構によるCO<sub>2</sub>を用いたアルケンの可視光駆動3成分カルボカルボキシル化反応",
      "(<sup>1</sup>阪大院工・<sup>2</sup>レーゲンスブルク大学・<sup>3</sup>東工大院理) 〇渡部 太登<sup>1</sup>・ロールウォンカモル プリナット<sup>1</sup>・ゴーシュ インドラジット<sup>2</sup>・小杉 健斗<sup>1,3</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,3</sup>・ケーニッヒ ブルクハルト<sup>2</sup>・正岡 重行<sup>1</sup>",
      "Visible-light-driven Three-component Carbocarboxylation of Alkenes with CO<sub>2</sub> via Reductive Radical-polar Crossover Mechanism",
      "(<sup>1</sup>Osaka University, <sup>2</sup>University of Regensburg, <sup>3</sup>Tokyo Institute of Technology) 〇Taito Watanabe<sup>1</sup>, Phurinat Lorwongkamol<sup>1</sup>, Indrajit Ghosh<sup>2</sup>, Kento Kosugi<sup>1,3</sup>, Yutaka Saga<sup>1</sup>, Tetsuya Kambe<sup>1</sup>, Mio Kondo<sup>1,3</sup>, Burkhard König<sup>2</sup>, Shigeyuki Masaoka<sup>1</sup>"
    ],
    "lab": "1PC-04",
    "pdf": "pdf/1PC-04.pdf",
    "pre": "tn/1PC-04.jpg",
    "reg": "74132",
    "sea": "Ir",
    "ses": "1PC",
    "con": "1PC-04 還元的ラジカル-極性クロスオーバー機構によるCO<sub>2</sub>を用いたアルケンの可視光駆動3成分カルボカルボキシル化反応 (<sup>1</sup>阪大院工・<sup>2</sup>レーゲンスブルク大学・<sup>3</sup>東工大院理) 〇渡部 太登<sup>1</sup>・ロールウォンカモル プリナット<sup>1</sup>・ゴーシュ インドラジット<sup>2</sup>・小杉 健斗<sup>1,3</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,3</sup>・ケーニッヒ ブルクハルト<sup>2</sup>・正岡 重行<sup>1</sup> Visible-light-driven Three-component Carbocarboxylation of Alkenes with CO<sub>2</sub> via Reductive Radical-polar Crossover Mechanism (<sup>1</sup>Osaka University, <sup>2</sup>University of Regensburg, <sup>3</sup>Tokyo Institute of Technology) 〇Taito Watanabe<sup>1</sup>, Phurinat Lorwongkamol<sup>1</sup>, Indrajit Ghosh<sup>2</sup>, Kento Kosugi<sup>1,3</sup>, Yutaka Saga<sup>1</sup>, Tetsuya Kambe<sup>1</sup>, Mio Kondo<sup>1,3</sup>, Burkhard König<sup>2</sup>, Shigeyuki Masaoka<sup>1</sup> Ir"
  },
  {
    "inf": [
      "Metal-Organic Frameworks Constructed by Coexisting Carboxyl/Carboxylate Groups for Small Molecule Conversion",
      "(<sup>1</sup>School of Science, Tokyo Institute of Technology, <sup>2</sup>Graduate School of Engineering, Osaka University) ◎XIANJUN LI<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Shigeyuki MASAOKA<sup>2</sup>, Mio KONDO<sup>1</sup>"
    ],
    "lab": "1PC-05",
    "pdf": "pdf/1PC-05.pdf",
    "pre": "tn/1PC-05.jpg",
    "reg": "74493",
    "sea": "Fe, Co, Ni",
    "ses": "1PC",
    "con": "1PC-05 Metal-Organic Frameworks Constructed by Coexisting Carboxyl/Carboxylate Groups for Small Molecule Conversion (<sup>1</sup>School of Science, Tokyo Institute of Technology, <sup>2</sup>Graduate School of Engineering, Osaka University) ◎XIANJUN LI<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Shigeyuki MASAOKA<sup>2</sup>, Mio KONDO<sup>1</sup> Fe, Co, Ni"
  },
  {
    "inf": [
      "アントリルフェニル基を有するレニウム錯体触媒による光化学的二酸化炭素還元反応における置換位置の影響",
      "(<sup>1</sup>立教大院理) 〇石野 遥<sup></sup>・瀧本 翔<sup></sup>・和田 亨<sup></sup>",
      "Substitution position effects on the photochemical CO<sub>2</sub> reduction catalyzed by rhenium complexes with an anthrylphenyl group.",
      "(<sup>1</sup>Rikkyo Univ.) 〇Haruka Ishino<sup></sup>, Shyou Takimoto<sup></sup>, Tohru Wada<sup></sup>"
    ],
    "lab": "1PC-06",
    "pdf": "pdf/1PC-06.pdf",
    "pre": "tn/1PC-06.jpg",
    "reg": "74502",
    "sea": "Re",
    "ses": "1PC",
    "con": "1PC-06 アントリルフェニル基を有するレニウム錯体触媒による光化学的二酸化炭素還元反応における置換位置の影響 (<sup>1</sup>立教大院理) 〇石野 遥<sup></sup>・瀧本 翔<sup></sup>・和田 亨<sup></sup> Substitution position effects on the photochemical CO<sub>2</sub> reduction catalyzed by rhenium complexes with an anthrylphenyl group. (<sup>1</sup>Rikkyo Univ.) 〇Haruka Ishino<sup></sup>, Shyou Takimoto<sup></sup>, Tohru Wada<sup></sup> Re"
  },
  {
    "inf": [
      "長さの異なるアルキレン鎖によって架橋された二核ニッケル(Ⅲ)錯体の構造と反応性",
      "(<sup>1</sup>東工大院) ◎廣瀬拓也<sup>1</sup>・森本祐麻<sup>1</sup>・山下 誠<sup>1</sup>",
      "Structure and reactivity of di(µ-oxido)Ni<sub>2</sub>(III) complexes bridged by alkylene linkers of varying length",
      "(<sup>1</sup>Tokyo Tech) ◎Takuya Hirose<sup>1</sup>, Yuma Morimoto<sup>1</sup>, Makoto Yamashita<sup>1</sup>"
    ],
    "lab": "1PC-07",
    "pdf": "pdf/1PC-07.pdf",
    "pre": "tn/1PC-07.jpg",
    "reg": "74331",
    "sea": "Ni",
    "ses": "1PC",
    "con": "1PC-07 長さの異なるアルキレン鎖によって架橋された二核ニッケル(Ⅲ)錯体の構造と反応性 (<sup>1</sup>東工大院) ◎廣瀬拓也<sup>1</sup>・森本祐麻<sup>1</sup>・山下 誠<sup>1</sup> Structure and reactivity of di(µ-oxido)Ni<sub>2</sub>(III) complexes bridged by alkylene linkers of varying length (<sup>1</sup>Tokyo Tech) ◎Takuya Hirose<sup>1</sup>, Yuma Morimoto<sup>1</sup>, Makoto Yamashita<sup>1</sup> Ni"
  },
  {
    "inf": [
      "グアニジノ基を有するアミン系四座配位子に支持された銅錯体の構造と反応性",
      "(<sup>1</sup>大阪大学工学研究科・<sup>2</sup>大阪大学産業科学研究所) 〇伊藤 凜<sup>1</sup>・杉本秀樹<sup>1</sup>・伊東 忍<sup>2</sup>",
      "Structure and Reactivity of Copper Complexes Supported by a Tetradentate Amine Ligand Bearing Guanidino Groups",
      "(<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>The Institute of Scientific and Industrial Research, Osaka University) 〇Rin Ito<sup>1</sup>, Hideki Sugimoto<sup>1</sup>, Shinobu Itoh<sup>2</sup>"
    ],
    "lab": "1PC-08",
    "pdf": "pdf/1PC-08.pdf",
    "pre": "tn/1PC-08.jpg",
    "reg": "74483",
    "sea": "Cu",
    "ses": "1PC",
    "con": "1PC-08 グアニジノ基を有するアミン系四座配位子に支持された銅錯体の構造と反応性 (<sup>1</sup>大阪大学工学研究科・<sup>2</sup>大阪大学産業科学研究所) 〇伊藤 凜<sup>1</sup>・杉本秀樹<sup>1</sup>・伊東 忍<sup>2</sup> Structure and Reactivity of Copper Complexes Supported by a Tetradentate Amine Ligand Bearing Guanidino Groups (<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>The Institute of Scientific and Industrial Research, Osaka University) 〇Rin Ito<sup>1</sup>, Hideki Sugimoto<sup>1</sup>, Shinobu Itoh<sup>2</sup> Cu"
  },
  {
    "inf": [
      "過酸化水素活性化とアルカン酸化に対する二核銅部位の最適化",
      "(<sup>1</sup>同志社大大学院理工) ◎四宮 聖菜<sup>1</sup>・藤川 恭祐<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup>",
      "Optimization of dicopper site for H<sub>2</sub>O<sub>2</sub> activation and alkane oxidation",
      "(<sup>1</sup>Department of Science and Engineering, Doshisha Univ.) ◎Seina SHINOMIYA<sup>1</sup>, Kyosuke FUJIKAWA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masahito KODERA<sup>1</sup>"
    ],
    "lab": "1PC-09",
    "pdf": "pdf/1PC-09.pdf",
    "pre": "tn/1PC-09.jpg",
    "reg": "74435",
    "sea": "Cu",
    "ses": "1PC",
    "con": "1PC-09 過酸化水素活性化とアルカン酸化に対する二核銅部位の最適化 (<sup>1</sup>同志社大大学院理工) ◎四宮 聖菜<sup>1</sup>・藤川 恭祐<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup> Optimization of dicopper site for H<sub>2</sub>O<sub>2</sub> activation and alkane oxidation (<sup>1</sup>Department of Science and Engineering, Doshisha Univ.) ◎Seina SHINOMIYA<sup>1</sup>, Kyosuke FUJIKAWA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masahito KODERA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "バナジウム (V) 錯体におけるニトリド配位子のアルキル化反応",
      "(<sup>1</sup>東工大理) 〇菅原 大地<sup>1</sup>・石田 豊<sup>1</sup>・川口 博之<sup>1</sup>",
      "Alkylation of the nitride ligand on the vanadium(V) complex",
      "(<sup>1</sup>School of Science, Tokyo Institute of Technology) 〇Daichi Sugawara<sup>1</sup>, Yutaka Ishida<sup>1</sup>, Hiroyuki Kawaguchi<sup>1</sup>"
    ],
    "lab": "1PC-10",
    "pdf": "pdf/1PC-10.pdf",
    "pre": "tn/1PC-10.jpg",
    "reg": "74338",
    "sea": "V",
    "ses": "1PC",
    "con": "1PC-10 バナジウム (V) 錯体におけるニトリド配位子のアルキル化反応 (<sup>1</sup>東工大理) 〇菅原 大地<sup>1</sup>・石田 豊<sup>1</sup>・川口 博之<sup>1</sup> Alkylation of the nitride ligand on the vanadium(V) complex (<sup>1</sup>School of Science, Tokyo Institute of Technology) 〇Daichi Sugawara<sup>1</sup>, Yutaka Ishida<sup>1</sup>, Hiroyuki Kawaguchi<sup>1</sup> V"
  },
  {
    "inf": [
      "ドナー・アクセプター有機触媒を用いたアルケンの可視光駆動型メタルフリーヒドロアシル化反応の開発",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇景山 那優<sup>1</sup>・渡部 太登<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup>",
      "Visible-Light-Driven Hydroacylation of Alkenes Using Using a Donor-Acceptor Organocatalyst under Metal-free Conditions",
      "(<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>Graduate School of Engineering, Osaka University) 〇Nayu KAGEYAMA<sup>1</sup>, Taito WATANABE<sup>1</sup>, Yutaka SAGA <sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>,  Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "1PC-11",
    "pdf": "pdf/1PC-11.pdf",
    "pre": "tn/1PC-11.jpg",
    "reg": "74599",
    "sea": "Ir",
    "ses": "1PC",
    "con": "1PC-11 ドナー・アクセプター有機触媒を用いたアルケンの可視光駆動型メタルフリーヒドロアシル化反応の開発 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇景山 那優<sup>1</sup>・渡部 太登<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup> Visible-Light-Driven Hydroacylation of Alkenes Using Using a Donor-Acceptor Organocatalyst under Metal-free Conditions (<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>Graduate School of Engineering, Osaka University) 〇Nayu KAGEYAMA<sup>1</sup>, Taito WATANABE<sup>1</sup>, Yutaka SAGA <sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>,  Shigeyuki MASAOKA<sup>1</sup> Ir"
  },
  {
    "inf": [
      "アルコキシドを捕集配位子としたRe(I)錯体へのCO<sub>2</sub>挿入反応の速度論分析 ",
      "(<sup>1</sup>広島大院先進理工・<sup>2</sup>東工大理) ◎阿比留 悠斗<sup>1</sup>・鴨川 径<sup>2</sup>・安倍 学<sup>1</sup>・石谷 治<sup>1</sup>",
      "Kinetic analysis of CO<sub>2</sub> insertion into Re(I) complexes with alkoxide ligands",
      "(<sup>1</sup>Hiroshima Univ., <sup>2</sup>Tokyo Tech.) ◎Yuto ABIRU<sup>1</sup>, Kei KAMOGAWA<sup>2</sup>, Manabu ABE<sup>1</sup>, Osamu ISHITANI<sup>1</sup>"
    ],
    "lab": "1PC-12",
    "pdf": "pdf/1PC-12.pdf",
    "pre": "tn/1PC-12.jpg",
    "reg": "74455",
    "sea": "Re",
    "ses": "1PC",
    "con": "1PC-12 アルコキシドを捕集配位子としたRe(I)錯体へのCO<sub>2</sub>挿入反応の速度論分析  (<sup>1</sup>広島大院先進理工・<sup>2</sup>東工大理) ◎阿比留 悠斗<sup>1</sup>・鴨川 径<sup>2</sup>・安倍 学<sup>1</sup>・石谷 治<sup>1</sup> Kinetic analysis of CO<sub>2</sub> insertion into Re(I) complexes with alkoxide ligands (<sup>1</sup>Hiroshima Univ., <sup>2</sup>Tokyo Tech.) ◎Yuto ABIRU<sup>1</sup>, Kei KAMOGAWA<sup>2</sup>, Manabu ABE<sup>1</sup>, Osamu ISHITANI<sup>1</sup> Re"
  },
  {
    "inf": [
      "結晶面抽出戦略に立脚した新規錯体の開拓",
      "(<sup>1</sup>東工大院理) 〇今井 真秀<sup>1</sup>・小杉 健斗<sup>1</sup>・近藤 美欧<sup>1</sup>",
      "Development of a novel complex based on facet extraction strategy",
      "(<sup>1</sup>Tokyo Tech.) 〇Maho IMAI<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Mio KONDO<sup>1</sup>"
    ],
    "lab": "1PC-13",
    "pdf": "pdf/1PC-13.pdf",
    "pre": "tn/1PC-13.jpg",
    "reg": "74385",
    "sea": "Cu",
    "ses": "1PC",
    "con": "1PC-13 結晶面抽出戦略に立脚した新規錯体の開拓 (<sup>1</sup>東工大院理) 〇今井 真秀<sup>1</sup>・小杉 健斗<sup>1</sup>・近藤 美欧<sup>1</sup> Development of a novel complex based on facet extraction strategy (<sup>1</sup>Tokyo Tech.) 〇Maho IMAI<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Mio KONDO<sup>1</sup> Cu"
  },
  {
    "inf": [
      "NAD<sup>+</sup>モデルZn錯体によるNAD<sup>+</sup>/NADH型変換と共役したエタノールの光酸化反応",
      "(<sup>1</sup>富山大理・<sup>2</sup>富山大院理工) 〇上原 大輝<sup>1</sup>・手塚 陽介<sup>2</sup>・柘植 清志<sup>1, 2</sup>・大津 英揮<sup> 1, 2</sup>",
      "Photo-Driven Ethanol Oxidation Reaction Coupled with NAD<sup>+</sup>/NADH-Type Conversion by an NAD<sup>+</sup> Model Zn(II) Complex",
      "(<sup>1</sup>Fac. Sci., Univ. of Toyama, <sup>2</sup>Grad. School of Sci. and Eng., Univ. of Toyama) 〇Daiki UEHARA<sup>1</sup>, Yosuke TEZUKA<sup>2</sup>, Kiyoshi TSUGE<sup>1, 2</sup>, Hideki OHTSU<sup> 1, 2</sup>"
    ],
    "lab": "1PC-14",
    "pdf": "pdf/1PC-14.pdf",
    "pre": "tn/1PC-14.jpg",
    "reg": "74588",
    "sea": "Zn",
    "ses": "1PC",
    "con": "1PC-14 NAD<sup>+</sup>モデルZn錯体によるNAD<sup>+</sup>/NADH型変換と共役したエタノールの光酸化反応 (<sup>1</sup>富山大理・<sup>2</sup>富山大院理工) 〇上原 大輝<sup>1</sup>・手塚 陽介<sup>2</sup>・柘植 清志<sup>1, 2</sup>・大津 英揮<sup> 1, 2</sup> Photo-Driven Ethanol Oxidation Reaction Coupled with NAD<sup>+</sup>/NADH-Type Conversion by an NAD<sup>+</sup> Model Zn(II) Complex (<sup>1</sup>Fac. Sci., Univ. of Toyama, <sup>2</sup>Grad. School of Sci. and Eng., Univ. of Toyama) 〇Daiki UEHARA<sup>1</sup>, Yosuke TEZUKA<sup>2</sup>, Kiyoshi TSUGE<sup>1, 2</sup>, Hideki OHTSU<sup> 1, 2</sup> Zn"
  },
  {
    "inf": [
      "イミノチオラト架橋銅(I)多核錯体における核数変換平衡反応の速度論とその機構",
      "(<sup>1</sup>兵庫県立大院理) ◎野本 康平<sup>1</sup>・小澤 芳樹<sup>1</sup>・阿部 正明<sup>1</sup>",
      "Kinetic and mechanistic study on cluster-to-cluster conversion reactions for iminothiolato-bridged copper(I) polynuclear clusters",
      "(<sup>1</sup>Graduate School of Science, University of Hyogo) ◎Kohei NOMOTO<sup>1</sup>, Yoshiki OZAWA<sup>1</sup>, Masaaki ABE<sup>1</sup>"
    ],
    "lab": "1PC-15",
    "pdf": "pdf/1PC-15.pdf",
    "pre": "tn/1PC-15.jpg",
    "reg": "74524",
    "sea": "Cu",
    "ses": "1PC",
    "con": "1PC-15 イミノチオラト架橋銅(I)多核錯体における核数変換平衡反応の速度論とその機構 (<sup>1</sup>兵庫県立大院理) ◎野本 康平<sup>1</sup>・小澤 芳樹<sup>1</sup>・阿部 正明<sup>1</sup> Kinetic and mechanistic study on cluster-to-cluster conversion reactions for iminothiolato-bridged copper(I) polynuclear clusters (<sup>1</sup>Graduate School of Science, University of Hyogo) ◎Kohei NOMOTO<sup>1</sup>, Yoshiki OZAWA<sup>1</sup>, Masaaki ABE<sup>1</sup> Cu"
  },
  {
    "inf": [
      "Development and activity evaluation of novel heterogeneous catalysts obtained from post-synthetic modification of metal-organic frameworks",
      "(<sup>1</sup>School of Science, Tokyo Institute of Technology, <sup>2</sup>Central Technical Research Laboratory, ENEOS Corporation) ◎Misaki AIMOTO<sup>1</sup>, Pavel M. USOV<sup>1</sup>, Yuki WADA<sup>1</sup>, Takaya MATSUMOTO<sup>1, 2</sup>, Masaki KAWANO<sup>1</sup>"
    ],
    "lab": "1PD-01",
    "pdf": "pdf/1PD-01.pdf",
    "pre": "tn/1PD-01.jpg",
    "reg": "74556",
    "sea": "Zr, Ir",
    "ses": "1PD",
    "con": "1PD-01 Development and activity evaluation of novel heterogeneous catalysts obtained from post-synthetic modification of metal-organic frameworks (<sup>1</sup>School of Science, Tokyo Institute of Technology, <sup>2</sup>Central Technical Research Laboratory, ENEOS Corporation) ◎Misaki AIMOTO<sup>1</sup>, Pavel M. USOV<sup>1</sup>, Yuki WADA<sup>1</sup>, Takaya MATSUMOTO<sup>1, 2</sup>, Masaki KAWANO<sup>1</sup> Zr, Ir"
  },
  {
    "inf": [
      "シクロヘプタトリエニル配位子を有する13核パラジウムクラスターの配位子交換反応",
      "(<sup>1</sup>東工大物質理工・<sup>2</sup>防衛大応用化学) 〇藤川 紘彰<sup>1</sup>・岩田 晃輔<sup>1</sup>・宮澤 孝矢<sup>1</sup>・高比良 裕太<sup>1</sup>・山本 浩二<sup>2</sup>・重田 翼<sup>1</sup>・村橋 哲郎<sup>1</sup>",
      "Ligand Exchange Reaction of a Pd<sub>13</sub> Cluster Bearing Cycloheptatrienyl Ligands",
      "(<sup>1</sup>Tokyo Institute of Technology, <sup>2</sup>National Defense Academy) 〇Hiroaki FUJIKAWA<sup>1</sup>, Kosuke IWATA<sup>1</sup>, Koshi MIYAZAWA<sup>1</sup>, Yuta TAKAHIRA<sup>1</sup>, Koji YAMAMOTO<sup>2</sup>, Tsubasa OMODA<sup>1</sup>, Tetsuro MURAHASHI<sup>1</sup>"
    ],
    "lab": "1PD-02",
    "pdf": "pdf/1PD-02.pdf",
    "pre": "tn/1PD-02.jpg",
    "reg": "74538",
    "sea": "Pd",
    "ses": "1PD",
    "con": "1PD-02 シクロヘプタトリエニル配位子を有する13核パラジウムクラスターの配位子交換反応 (<sup>1</sup>東工大物質理工・<sup>2</sup>防衛大応用化学) 〇藤川 紘彰<sup>1</sup>・岩田 晃輔<sup>1</sup>・宮澤 孝矢<sup>1</sup>・高比良 裕太<sup>1</sup>・山本 浩二<sup>2</sup>・重田 翼<sup>1</sup>・村橋 哲郎<sup>1</sup> Ligand Exchange Reaction of a Pd<sub>13</sub> Cluster Bearing Cycloheptatrienyl Ligands (<sup>1</sup>Tokyo Institute of Technology, <sup>2</sup>National Defense Academy) 〇Hiroaki FUJIKAWA<sup>1</sup>, Kosuke IWATA<sup>1</sup>, Koshi MIYAZAWA<sup>1</sup>, Yuta TAKAHIRA<sup>1</sup>, Koji YAMAMOTO<sup>2</sup>, Tsubasa OMODA<sup>1</sup>, Tetsuro MURAHASHI<sup>1</sup> Pd"
  },
  {
    "inf": [
      "直座状四座ホスフィン配位子に支持された銅9核および13核ヒドリドクラスターの合成",
      "(<sup>1</sup>奈良女子大理) ◎島田 円香<sup></sup>・小村 優理花<sup></sup>・坂部 靖奈<sup></sup>・中島 隆行<sup></sup>・棚瀬 知明<sup></sup>",
      "Synthesis of Cu9 and Cu13 Hydride Clusters Supported by Linear Tetraphosphine Ligand.",
      "(<sup>1</sup>Nara Women's Univ.) ◎Madoka SHIMADA<sup></sup>, Yurika KOMURA<sup></sup>, Seina SAKABE<sup></sup>, Takayuki NAKAJIMA<sup></sup>, Tomoaki TANASE<sup></sup>"
    ],
    "lab": "1PD-03",
    "pdf": "pdf/1PD-03.pdf",
    "pre": "tn/1PD-03.jpg",
    "reg": "74120",
    "sea": "Cu",
    "ses": "1PD",
    "con": "1PD-03 直座状四座ホスフィン配位子に支持された銅9核および13核ヒドリドクラスターの合成 (<sup>1</sup>奈良女子大理) ◎島田 円香<sup></sup>・小村 優理花<sup></sup>・坂部 靖奈<sup></sup>・中島 隆行<sup></sup>・棚瀬 知明<sup></sup> Synthesis of Cu9 and Cu13 Hydride Clusters Supported by Linear Tetraphosphine Ligand. (<sup>1</sup>Nara Women's Univ.) ◎Madoka SHIMADA<sup></sup>, Yurika KOMURA<sup></sup>, Seina SAKABE<sup></sup>, Takayuki NAKAJIMA<sup></sup>, Tomoaki TANASE<sup></sup> Cu"
  },
  {
    "inf": [
      "ベンゼン環およびベンゾフラン環が縮環したイリダオキサベンゼン錯体の反応性",
      "(<sup>1</sup>中大院理工・<sup>2</sup>京工繊大院工芸) 〇阿部田 陽奈子<sup>1</sup>・鈴木 美香<sup>1</sup>・岩本 貴寛<sup>2</sup>・石井 洋一<sup>1</sup>",
      "Reactivities of Benzo- and Benzofuran-fused Iridaoxabenzenes",
      "(<sup>1</sup>Chuo Univ., <sup>2</sup>Kyoto Institute of Technology) 〇Hinako ABETA<sup>1</sup>, Mika SUZUKI<sup>1</sup>, Takahiro IWAMOTO<sup>2</sup>, Youichi ISHII<sup>1</sup>"
    ],
    "lab": "1PD-04",
    "pdf": "pdf/1PD-04.pdf",
    "pre": "tn/1PD-04.jpg",
    "reg": "74135",
    "sea": "Ir",
    "ses": "1PD",
    "con": "1PD-04 ベンゼン環およびベンゾフラン環が縮環したイリダオキサベンゼン錯体の反応性 (<sup>1</sup>中大院理工・<sup>2</sup>京工繊大院工芸) 〇阿部田 陽奈子<sup>1</sup>・鈴木 美香<sup>1</sup>・岩本 貴寛<sup>2</sup>・石井 洋一<sup>1</sup> Reactivities of Benzo- and Benzofuran-fused Iridaoxabenzenes (<sup>1</sup>Chuo Univ., <sup>2</sup>Kyoto Institute of Technology) 〇Hinako ABETA<sup>1</sup>, Mika SUZUKI<sup>1</sup>, Takahiro IWAMOTO<sup>2</sup>, Youichi ISHII<sup>1</sup> Ir"
  },
  {
    "inf": [
      "エチニルアントリル基を有する新規発光性銅(I)錯体の分光学的性質と光二量化",
      "(<sup>1</sup>芝浦工大院理工・<sup>2</sup>早大先進理工) ◎竹内 優太<sup>1</sup>・佐々木 達也<sup>1</sup>・川﨑 矩史<sup>1</sup>・一杉 礼央<sup>1</sup>・溝口 隆介<sup>2</sup>・石井 あゆみ<sup>2</sup>・堀 顕子<sup>1</sup>",
      "Spectroscopic properties and photodimerization of Cu(I) complexes with ethynyl-anthryl groups",
      "(<sup>1</sup>Shibaura Inst.Tech., <sup>2</sup>Waseda Univ.) ◎Yuta TAKEUCHI<sup>1</sup>, Tatsuya SASAKI<sup>1</sup>, Tadashi KAWASAKI<sup>1</sup>, Reo ICHISUGI<sup>1</sup>, Ryusuke MIZOGUCHI<sup>2</sup>, Ayumi ISHII<sup>2</sup>, Akiko HORI<sup>1</sup>"
    ],
    "lab": "1PD-05",
    "pdf": "pdf/1PD-05.pdf",
    "pre": "tn/1PD-05.jpg",
    "reg": "74189",
    "sea": "Cu",
    "ses": "1PD",
    "con": "1PD-05 エチニルアントリル基を有する新規発光性銅(I)錯体の分光学的性質と光二量化 (<sup>1</sup>芝浦工大院理工・<sup>2</sup>早大先進理工) ◎竹内 優太<sup>1</sup>・佐々木 達也<sup>1</sup>・川﨑 矩史<sup>1</sup>・一杉 礼央<sup>1</sup>・溝口 隆介<sup>2</sup>・石井 あゆみ<sup>2</sup>・堀 顕子<sup>1</sup> Spectroscopic properties and photodimerization of Cu(I) complexes with ethynyl-anthryl groups (<sup>1</sup>Shibaura Inst.Tech., <sup>2</sup>Waseda Univ.) ◎Yuta TAKEUCHI<sup>1</sup>, Tatsuya SASAKI<sup>1</sup>, Tadashi KAWASAKI<sup>1</sup>, Reo ICHISUGI<sup>1</sup>, Ryusuke MIZOGUCHI<sup>2</sup>, Ayumi ISHII<sup>2</sup>, Akiko HORI<sup>1</sup> Cu"
  },
  {
    "inf": [
      "BINAPを含むヘテロレプティック二核イリジウム錯体の合成と光物性          ",
      "(<sup>1</sup>成蹊大理工・<sup>2</sup>インドネシアイスラム大・<sup>3</sup>広島大) 〇後藤 七海<sup>1</sup>・サルマハミナチ<sup>2</sup>・阿部 穣里<sup>3</sup>・稲垣 昭子<sup>1</sup>",
      "Synthesis and photophysical properties of homoleptic and heteroleptic dinuclear iridium complexes bearing BINAP ligands          ",
      "(<sup>1</sup>Sekei Univ., <sup>2</sup>Islamic Univ. of Indonesia, <sup>3</sup>Hiroshima Univ.) 〇Nanami GOTO<sup>1</sup>, Salmahaminati<sup>2</sup>, Minori ABE<sup>3</sup>, Akiko INAGAKI<sup>1</sup>"
    ],
    "lab": "1PD-06",
    "pdf": "pdf/1PD-06.pdf",
    "pre": "tn/1PD-06.jpg",
    "reg": "74170",
    "sea": "Ir",
    "ses": "1PD",
    "con": "1PD-06 BINAPを含むヘテロレプティック二核イリジウム錯体の合成と光物性           (<sup>1</sup>成蹊大理工・<sup>2</sup>インドネシアイスラム大・<sup>3</sup>広島大) 〇後藤 七海<sup>1</sup>・サルマハミナチ<sup>2</sup>・阿部 穣里<sup>3</sup>・稲垣 昭子<sup>1</sup> Synthesis and photophysical properties of homoleptic and heteroleptic dinuclear iridium complexes bearing BINAP ligands           (<sup>1</sup>Sekei Univ., <sup>2</sup>Islamic Univ. of Indonesia, <sup>3</sup>Hiroshima Univ.) 〇Nanami GOTO<sup>1</sup>, Salmahaminati<sup>2</sup>, Minori ABE<sup>3</sup>, Akiko INAGAKI<sup>1</sup> Ir"
  },
  {
    "inf": [
      "環状(アミノ)(ロダ)シリレンおよびゲルミレンの合成検討",
      "(<sup>1</sup>埼玉大理工) ◎川西 絢菜<sup>1</sup>・高橋 慎太郎<sup>1</sup>・石井 昭彦<sup>1</sup>・中田 憲男<sup>1</sup>",
      "Synthesis of Cyclic(amino)(rhoda) Silylene and Germylene",
      "(<sup>1</sup>Saitama Univ.) ◎Ayana Kawanishi<sup>1</sup>, Shintaro Takahashi<sup>1</sup>, Akihiko Ishii<sup>1</sup>, Norio Nakata<sup>1</sup>"
    ],
    "lab": "1PD-07",
    "pdf": "pdf/1PD-07.pdf",
    "pre": "tn/1PD-07.jpg",
    "reg": "74222",
    "sea": "Ir, Rh",
    "ses": "1PD",
    "con": "1PD-07 環状(アミノ)(ロダ)シリレンおよびゲルミレンの合成検討 (<sup>1</sup>埼玉大理工) ◎川西 絢菜<sup>1</sup>・高橋 慎太郎<sup>1</sup>・石井 昭彦<sup>1</sup>・中田 憲男<sup>1</sup> Synthesis of Cyclic(amino)(rhoda) Silylene and Germylene (<sup>1</sup>Saitama Univ.) ◎Ayana Kawanishi<sup>1</sup>, Shintaro Takahashi<sup>1</sup>, Akihiko Ishii<sup>1</sup>, Norio Nakata<sup>1</sup> Ir, Rh"
  },
  {
    "inf": [
      "Pd3核反応場におけるアルキン二量化 ",
      "(<sup>1</sup>東工大物質理工・<sup>2</sup>防衛大応用化学) 〇坂東 慶亮<sup>1</sup>・重田 翼<sup>1</sup>・山本 浩二<sup>2</sup>・村橋 哲郎<sup>1</sup>",
      "Alkyne Dimerization at a Trinuclear Palladium Site",
      "(<sup>1</sup>Tokyo Institute of Technology, <sup>2</sup>National Defense Academy) 〇Keisuke BANDO<sup>1</sup>, Tsubasa OMODA<sup>1</sup>, Koji YAMAMOTO<sup>2</sup>, Tetsuro MURAHASHI<sup>1</sup>"
    ],
    "lab": "1PD-08",
    "pdf": "pdf/1PD-08.pdf",
    "pre": "tn/1PD-08.jpg",
    "reg": "74554",
    "sea": "Pd",
    "ses": "1PD",
    "con": "1PD-08 Pd3核反応場におけるアルキン二量化  (<sup>1</sup>東工大物質理工・<sup>2</sup>防衛大応用化学) 〇坂東 慶亮<sup>1</sup>・重田 翼<sup>1</sup>・山本 浩二<sup>2</sup>・村橋 哲郎<sup>1</sup> Alkyne Dimerization at a Trinuclear Palladium Site (<sup>1</sup>Tokyo Institute of Technology, <sup>2</sup>National Defense Academy) 〇Keisuke BANDO<sup>1</sup>, Tsubasa OMODA<sup>1</sup>, Koji YAMAMOTO<sup>2</sup>, Tetsuro MURAHASHI<sup>1</sup> Pd"
  },
  {
    "inf": [
      "チタントロポロナート錯体の合成とオレフィン重合触媒への応用",
      "(<sup>1</sup>近畿大院総理工・<sup>2</sup>長岡技科大院工・<sup>3</sup>近畿大理工) ◎加藤 颯真<sup>1</sup>・太田 圭<sup>3</sup>・戸田 智之<sup>2</sup>・松尾 司<sup>1,3</sup>",
      "Synthesis of Titanium Troplonate Complexes and Their Application as Olefin Polymerization Catalysts",
      "(<sup>1</sup>Grad. Sch. of Sci. and Technol., Kindai Univ, <sup>2</sup>Grad. Sch. of Eng., Nagaoka Univ. of Tech., <sup>3</sup>Fac. of Sci. and Eng., Kindai Univ.) ◎Soma Kato<sup>1</sup>, Kei Ota<sup>3</sup>, Tomoyuki Toda<sup>2</sup>, Tsukasa Matsuo<sup>1,3</sup>"
    ],
    "lab": "1PD-09",
    "pdf": "pdf/1PD-09.pdf",
    "pre": "tn/1PD-09.jpg",
    "reg": "74337",
    "sea": "Ti",
    "ses": "1PD",
    "con": "1PD-09 チタントロポロナート錯体の合成とオレフィン重合触媒への応用 (<sup>1</sup>近畿大院総理工・<sup>2</sup>長岡技科大院工・<sup>3</sup>近畿大理工) ◎加藤 颯真<sup>1</sup>・太田 圭<sup>3</sup>・戸田 智之<sup>2</sup>・松尾 司<sup>1,3</sup> Synthesis of Titanium Troplonate Complexes and Their Application as Olefin Polymerization Catalysts (<sup>1</sup>Grad. Sch. of Sci. and Technol., Kindai Univ, <sup>2</sup>Grad. Sch. of Eng., Nagaoka Univ. of Tech., <sup>3</sup>Fac. of Sci. and Eng., Kindai Univ.) ◎Soma Kato<sup>1</sup>, Kei Ota<sup>3</sup>, Tomoyuki Toda<sup>2</sup>, Tsukasa Matsuo<sup>1,3</sup> Ti"
  },
  {
    "inf": [
      "SegphosおよびBINAPを含む二核イリジウム錯体の合成と反応性",
      "(<sup>1</sup>成蹊大理工) 〇五十嵐 美咲<sup>1</sup>・稲垣 昭子<sup>1</sup>",
      "Synthesis and reactivity of dinuclear iridium complexes bearing Segphos and BINAP ligands",
      "(<sup>1</sup>Sekei Univ.) 〇Misaki IGARASHI<sup>1</sup>, Akiko INAGAKI<sup>1</sup>"
    ],
    "lab": "1PD-10",
    "pdf": "pdf/1PD-10.pdf",
    "pre": "tn/1PD-10.jpg",
    "reg": "74265",
    "sea": "Ir",
    "ses": "1PD",
    "con": "1PD-10 SegphosおよびBINAPを含む二核イリジウム錯体の合成と反応性 (<sup>1</sup>成蹊大理工) 〇五十嵐 美咲<sup>1</sup>・稲垣 昭子<sup>1</sup> Synthesis and reactivity of dinuclear iridium complexes bearing Segphos and BINAP ligands (<sup>1</sup>Sekei Univ.) 〇Misaki IGARASHI<sup>1</sup>, Akiko INAGAKI<sup>1</sup> Ir"
  },
  {
    "inf": [
      "{Mo<sub>132</sub>}球状クラスターへのゲスト閉じ込め機能",
      "(<sup>1</sup>北大院環境・<sup>2</sup>北大院地球環境) ◎中宿 朱里<sup>1</sup>・七分 勇勝<sup>1,2</sup>・小西 克明<sup>1,2</sup>",
      "Organic-Guest Confinement within {Mo<sub>132</sub>} Spherical-Cage Cluster",
      "(<sup>1</sup>Grad. School of Env. Sci. Hokkaido Univ., <sup>2</sup>Fac. of Env. Earth Sci. Hokkaido Univ.) ◎Akari NAKASHUKU<sup>1</sup>, Yukatsu SHICHIBU<sup>1,2</sup>, Katsuaki KONISHI <sup>1,2</sup>"
    ],
    "lab": "1PD-11",
    "pdf": "pdf/1PD-11.pdf",
    "pre": "tn/1PD-11.jpg",
    "reg": "74370",
    "sea": "Mo",
    "ses": "1PD",
    "con": "1PD-11 {Mo<sub>132</sub>}球状クラスターへのゲスト閉じ込め機能 (<sup>1</sup>北大院環境・<sup>2</sup>北大院地球環境) ◎中宿 朱里<sup>1</sup>・七分 勇勝<sup>1,2</sup>・小西 克明<sup>1,2</sup> Organic-Guest Confinement within {Mo<sub>132</sub>} Spherical-Cage Cluster (<sup>1</sup>Grad. School of Env. Sci. Hokkaido Univ., <sup>2</sup>Fac. of Env. Earth Sci. Hokkaido Univ.) ◎Akari NAKASHUKU<sup>1</sup>, Yukatsu SHICHIBU<sup>1,2</sup>, Katsuaki KONISHI <sup>1,2</sup> Mo"
  },
  {
    "inf": [
      "(MeCN)GaCl<sub>3</sub>とジルコナシクロペンタジエン誘導体との反応と5,10-ジガラシクロデカテトラエン誘導体とAlCl<sub>3</sub>との反応   ",
      "(<sup>1</sup>群馬大院理工) 〇永石 剛<sup>1</sup>・池田 将吉<sup>1</sup>・小林 史奈<sup>1</sup>・村岡 貴子<sup>1</sup>",
      "Reaction of (MeCN)GaCl<sub>3</sub> with zirconacyclopentadiene derivative and reaction of 5,10-digallacyclodecatetraene derivative with AlCl<sub>3</sub>",
      "(<sup>1</sup>Gunma Univ.) 〇Go NAGAISHI<sup>1</sup>, Masayoshi IKEDA<sup>1</sup>, Humina KOBAYASHI<sup>1</sup>, Takako MURAOKA<sup>1</sup>"
    ],
    "lab": "1PD-12",
    "pdf": "pdf/1PD-12.pdf",
    "pre": "tn/1PD-12.jpg",
    "reg": "74419",
    "sea": "Ga, Al, Zr",
    "ses": "1PD",
    "con": "1PD-12 (MeCN)GaCl<sub>3</sub>とジルコナシクロペンタジエン誘導体との反応と5,10-ジガラシクロデカテトラエン誘導体とAlCl<sub>3</sub>との反応    (<sup>1</sup>群馬大院理工) 〇永石 剛<sup>1</sup>・池田 将吉<sup>1</sup>・小林 史奈<sup>1</sup>・村岡 貴子<sup>1</sup> Reaction of (MeCN)GaCl<sub>3</sub> with zirconacyclopentadiene derivative and reaction of 5,10-digallacyclodecatetraene derivative with AlCl<sub>3</sub> (<sup>1</sup>Gunma Univ.) 〇Go NAGAISHI<sup>1</sup>, Masayoshi IKEDA<sup>1</sup>, Humina KOBAYASHI<sup>1</sup>, Takako MURAOKA<sup>1</sup> Ga, Al, Zr"
  },
  {
    "inf": [
      "ビスシクロオクタテトラエンニッケル4核錯体とアルキンの反応",
      "(<sup>1</sup>東工大物質理工 ・<sup>2</sup>防衛大応用科学) 〇根本 悠史<sup>1</sup>・酒井 元気<sup>1</sup>・山本 浩二<sup>2</sup>・重田 翼<sup>1</sup>・村橋 哲郎<sup>1</sup>",
      "Reaction of  Bis-cyclooctatetraene Tetranuclear Nickel Clusters with Alkynes",
      "(<sup>1</sup>Tokyo Tech, <sup>2</sup>National Defense Academy) 〇Yuji NEMOTO<sup>1</sup>, Genki SAKAI<sup>1</sup>, Koji YAMAMOTO<sup>2</sup>, Tsubasa OMODA<sup>1</sup>, Tetsuro MURAHASHI<sup>1</sup>"
    ],
    "lab": "1PD-13",
    "pdf": "pdf/1PD-13.pdf",
    "pre": "tn/1PD-13.jpg",
    "reg": "74572",
    "sea": "Ni",
    "ses": "1PD",
    "con": "1PD-13 ビスシクロオクタテトラエンニッケル4核錯体とアルキンの反応 (<sup>1</sup>東工大物質理工 ・<sup>2</sup>防衛大応用科学) 〇根本 悠史<sup>1</sup>・酒井 元気<sup>1</sup>・山本 浩二<sup>2</sup>・重田 翼<sup>1</sup>・村橋 哲郎<sup>1</sup> Reaction of  Bis-cyclooctatetraene Tetranuclear Nickel Clusters with Alkynes (<sup>1</sup>Tokyo Tech, <sup>2</sup>National Defense Academy) 〇Yuji NEMOTO<sup>1</sup>, Genki SAKAI<sup>1</sup>, Koji YAMAMOTO<sup>2</sup>, Tsubasa OMODA<sup>1</sup>, Tetsuro MURAHASHI<sup>1</sup> Ni"
  },
  {
    "inf": [
      "α-ジイミン配位子を有するモリブデンビス（イミド）錯体の合成と酸化還元特性",
      "(<sup>1</sup>阪大基礎工・<sup>2</sup>阪大院基礎工・<sup>3</sup>阪大院工) ◎上田 瑛太郎<sup>1</sup>・草本 哲郎<sup>2</sup>・劒 隼人<sup>3</sup>",
      "Synthesis and Redox Properties of α-Diimine-ligated Molybdenum Bis(imido) Complexes",
      "(<sup>1</sup>School of Engineering Science, Osaka University, <sup>2</sup>Graduate School of Engineering Science, Osaka University, <sup>3</sup>Graduate School of Engineering, Osaka University) ◎Eitaro UEDA<sup>1</sup>, Tetsuro KUSAMOTO<sup>2</sup>, Hayato TSURUGI<sup>3</sup>"
    ],
    "lab": "1PD-14",
    "pdf": "pdf/1PD-14.pdf",
    "pre": "tn/1PD-14.jpg",
    "reg": "74381",
    "sea": "Mo",
    "ses": "1PD",
    "con": "1PD-14 α-ジイミン配位子を有するモリブデンビス（イミド）錯体の合成と酸化還元特性 (<sup>1</sup>阪大基礎工・<sup>2</sup>阪大院基礎工・<sup>3</sup>阪大院工) ◎上田 瑛太郎<sup>1</sup>・草本 哲郎<sup>2</sup>・劒 隼人<sup>3</sup> Synthesis and Redox Properties of α-Diimine-ligated Molybdenum Bis(imido) Complexes (<sup>1</sup>School of Engineering Science, Osaka University, <sup>2</sup>Graduate School of Engineering Science, Osaka University, <sup>3</sup>Graduate School of Engineering, Osaka University) ◎Eitaro UEDA<sup>1</sup>, Tetsuro KUSAMOTO<sup>2</sup>, Hayato TSURUGI<sup>3</sup> Mo"
  },
  {
    "inf": [
      "再構成ミオグロビンを用いたアルドキシム脱水活性を有する人工金属酵素の開発",
      "(<sup>1</sup>阪大院工) ◎阿部 美笛<sup>1</sup>・加藤 俊介<sup>1</sup>・林 高史<sup>1</sup>",
      "Artificial Metalloenzyme with Aldoxime Dehydration Activity Using Reconstituted Myoglobin",
      "(<sup>1</sup>Osaka Univ.) ◎Miteki ABE<sup>1</sup>, Shunsuke KATO<sup>1</sup>, Takashi HAYASHI<sup>1</sup>"
    ],
    "lab": "1PE-01",
    "pdf": "pdf/1PE-01.pdf",
    "pre": "tn/1PE-01.jpg",
    "reg": "74114",
    "sea": "Fe",
    "ses": "1PE",
    "con": "1PE-01 再構成ミオグロビンを用いたアルドキシム脱水活性を有する人工金属酵素の開発 (<sup>1</sup>阪大院工) ◎阿部 美笛<sup>1</sup>・加藤 俊介<sup>1</sup>・林 高史<sup>1</sup> Artificial Metalloenzyme with Aldoxime Dehydration Activity Using Reconstituted Myoglobin (<sup>1</sup>Osaka Univ.) ◎Miteki ABE<sup>1</sup>, Shunsuke KATO<sup>1</sup>, Takashi HAYASHI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Gold(III)-mediated structural induction of thioguanine-modified DNA three-way junction motifs",
      "(<sup>1</sup>Grad. Sch. of Sci., The Univ. of Tokyo, <sup>2</sup>RIST, Tokyo Univ. of Science) 〇Yusuke TAKEZAWA<sup>1</sup>, Silpa Chandran RAJASREE<sup>1</sup>, Mitsuhiko SHIONOYA<sup>1,2</sup>"
    ],
    "lab": "1PE-02",
    "pdf": "pdf/1PE-02.pdf",
    "pre": "tn/1PE-02.jpg",
    "reg": "74015",
    "sea": "Au",
    "ses": "1PE",
    "con": "1PE-02 Gold(III)-mediated structural induction of thioguanine-modified DNA three-way junction motifs (<sup>1</sup>Grad. Sch. of Sci., The Univ. of Tokyo, <sup>2</sup>RIST, Tokyo Univ. of Science) 〇Yusuke TAKEZAWA<sup>1</sup>, Silpa Chandran RAJASREE<sup>1</sup>, Mitsuhiko SHIONOYA<sup>1,2</sup> Au"
  },
  {
    "inf": [
      "ビス(イミノ)ピロール部位を有する大環状配位子を用いた二核鉄錯体の合成と反応",
      "(<sup>1</sup>阪大院理) ◎平田 愛弥<sup>1</sup>・山中 慶太<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup>",
      "Synthesis and Reactions of Dinuclear Iron Complexes with a Macrocyclic Ligand Bearing Bis(imino)pyrrole Moieties",
      "(<sup>1</sup>Osaka Univ.) ◎Ami HIRATA<sup>1</sup>, Keita YAMANAKA<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup>"
    ],
    "lab": "1PE-03",
    "pdf": "pdf/1PE-03.pdf",
    "pre": "tn/1PE-03.jpg",
    "reg": "74143",
    "sea": "Fe",
    "ses": "1PE",
    "con": "1PE-03 ビス(イミノ)ピロール部位を有する大環状配位子を用いた二核鉄錯体の合成と反応 (<sup>1</sup>阪大院理) ◎平田 愛弥<sup>1</sup>・山中 慶太<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup> Synthesis and Reactions of Dinuclear Iron Complexes with a Macrocyclic Ligand Bearing Bis(imino)pyrrole Moieties (<sup>1</sup>Osaka Univ.) ◎Ami HIRATA<sup>1</sup>, Keita YAMANAKA<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Relative Stability and Electronic Structures during S<sub>1</sub> to S<sub>2</sub> Transitions of the CaMn<sub>4</sub>O<sub>5</sub> Cluster in Photosystem II by CC and DFT Calculations",
      "(<sup>1</sup>SANKEN, Osaka Univ., <sup>2</sup>CCS, Univ. of Tsukuba, <sup>3</sup>R-CCS, RIKEN, <sup>4</sup>QIQB, Osaka Univ.) 〇Koichi MIYAGAWA<sup>1</sup>, Mitsuo SHOJI<sup>2</sup>, Takashi KAWAKAMI<sup>3</sup>, Kizashi YAMAGUCHI<sup>1,3,4</sup>, Takahito NAKAJIMA<sup>3</sup>"
    ],
    "lab": "1PE-04",
    "pdf": "pdf/1PE-04.pdf",
    "pre": "tn/1PE-04.jpg",
    "reg": "74262",
    "sea": "Ca, Mn",
    "ses": "1PE",
    "con": "1PE-04 Relative Stability and Electronic Structures during S<sub>1</sub> to S<sub>2</sub> Transitions of the CaMn<sub>4</sub>O<sub>5</sub> Cluster in Photosystem II by CC and DFT Calculations (<sup>1</sup>SANKEN, Osaka Univ., <sup>2</sup>CCS, Univ. of Tsukuba, <sup>3</sup>R-CCS, RIKEN, <sup>4</sup>QIQB, Osaka Univ.) 〇Koichi MIYAGAWA<sup>1</sup>, Mitsuo SHOJI<sup>2</sup>, Takashi KAWAKAMI<sup>3</sup>, Kizashi YAMAGUCHI<sup>1,3,4</sup>, Takahito NAKAJIMA<sup>3</sup> Ca, Mn"
  },
  {
    "inf": [
      "緑膿菌のヘム獲得機構を利用した高分子修飾ヘムの細胞内送達",
      "(<sup>1</sup>名大院理) ◎松井 弘季<sup>1</sup>・愛場 雄一郎<sup>1</sup>・有安 真也<sup>1</sup>・荘司 長三<sup>1</sup>",
      "Intracellular delivery of heme modified with macromolecule via the heme acquisition system (Has) of _Pseudomonas aeruginosa_",
      "(<sup>1</sup>Nagoya Univ.) ◎Hiroki MATSUI<sup>1</sup>, Yuichiro AIBA<sup>1</sup>, Shinya ARIYASU<sup>1</sup>, Osami SHOJI<sup>1</sup>"
    ],
    "lab": "1PE-05",
    "pdf": "pdf/1PE-05.pdf",
    "pre": "tn/1PE-05.jpg",
    "reg": "74316",
    "sea": "Fe",
    "ses": "1PE",
    "con": "1PE-05 緑膿菌のヘム獲得機構を利用した高分子修飾ヘムの細胞内送達 (<sup>1</sup>名大院理) ◎松井 弘季<sup>1</sup>・愛場 雄一郎<sup>1</sup>・有安 真也<sup>1</sup>・荘司 長三<sup>1</sup> Intracellular delivery of heme modified with macromolecule via the heme acquisition system (Has) of _Pseudomonas aeruginosa_ (<sup>1</sup>Nagoya Univ.) ◎Hiroki MATSUI<sup>1</sup>, Yuichiro AIBA<sup>1</sup>, Shinya ARIYASU<sup>1</sup>, Osami SHOJI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Tetranuclear Copper Complexes Enhances ROS Generation in Biological Cell : Acceleration of DNA Double Strand Breaks via Reductive O<sub>2</sub>-Activation and Cancer-Cell-Selective Cytotoxicity",
      "(<sup>1</sup>Doshisha Univ.) 〇Zelda FERY<sup>1</sup>, Takuto Tokunaga<sup>1</sup>, Machi Hata<sup>1</sup>, Hiroaki Kitagishi<sup>1</sup>, Masahito Kodera<sup>1</sup>"
    ],
    "lab": "1PE-06",
    "pdf": "pdf/1PE-06.pdf",
    "pre": "tn/1PE-06.jpg",
    "reg": "74347",
    "sea": "Cu",
    "ses": "1PE",
    "con": "1PE-06 Tetranuclear Copper Complexes Enhances ROS Generation in Biological Cell : Acceleration of DNA Double Strand Breaks via Reductive O<sub>2</sub>-Activation and Cancer-Cell-Selective Cytotoxicity (<sup>1</sup>Doshisha Univ.) 〇Zelda FERY<sup>1</sup>, Takuto Tokunaga<sup>1</sup>, Machi Hata<sup>1</sup>, Hiroaki Kitagishi<sup>1</sup>, Masahito Kodera<sup>1</sup> Cu"
  },
  {
    "inf": [
      "ビタミン B<sub>12</sub>構造改変錯体と WO<sub>3</sub>による豊富な電子源を用いた可視光駆動型物質変換反応",
      "(<sup>1</sup>九大院工・<sup>2</sup>阪大産研) ◎笹倉 大史<sup>1</sup>・七條 慶太<sup>2</sup>・星野 友<sup>1</sup>・嶌越 恒<sup>1</sup>",
      "Visible light driven molecular transformation using abundant electron source by structure modified B<sub>12</sub> complex and WO<sub>3</sub>",
      "(<sup>1</sup>Kyushu Univ., <sup>2</sup>SANKEN) ◎Taishi SASAKURA<sup>1</sup>, Keita SHICHIJO<sup>2</sup>, Yu HOSHINO<sup>1</sup>, Hisashi SHIMAKOSHI<sup>1</sup>"
    ],
    "lab": "1PE-07",
    "pdf": "pdf/1PE-07.pdf",
    "pre": "tn/1PE-07.jpg",
    "reg": "74364",
    "sea": "Co",
    "ses": "1PE",
    "con": "1PE-07 ビタミン B<sub>12</sub>構造改変錯体と WO<sub>3</sub>による豊富な電子源を用いた可視光駆動型物質変換反応 (<sup>1</sup>九大院工・<sup>2</sup>阪大産研) ◎笹倉 大史<sup>1</sup>・七條 慶太<sup>2</sup>・星野 友<sup>1</sup>・嶌越 恒<sup>1</sup> Visible light driven molecular transformation using abundant electron source by structure modified B<sub>12</sub> complex and WO<sub>3</sub> (<sup>1</sup>Kyushu Univ., <sup>2</sup>SANKEN) ◎Taishi SASAKURA<sup>1</sup>, Keita SHICHIJO<sup>2</sup>, Yu HOSHINO<sup>1</sup>, Hisashi SHIMAKOSHI<sup>1</sup> Co"
  },
  {
    "inf": [
      "ポルフィリンDNA標的を持つ_p_-cresol-2,6-amide-tether-tacn-porphyrin配位子とその二核銅/亜鉛錯体の合成とがん細胞選択的毒性",
      "(<sup>1</sup>同志社大大学院理工) 〇山本 莉子<sup>1</sup>・畑 真知<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup>",
      "Synthesis and cancer-cell-selective cytotoxicity of dicopper/zinc complex with _p_-cresol-2,6-amide-tether-tacn-porphyrin ligand having a porphyrin DNA target",
      "(<sup>1</sup>Department of Science and Engineering, Doshisha Univ.) 〇Riko YAMAMOTO<sup>1</sup>, Machi HATA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masato KODERA<sup>1</sup>"
    ],
    "lab": "1PE-08",
    "pdf": "pdf/1PE-08.pdf",
    "pre": "tn/1PE-08.jpg",
    "reg": "74437",
    "sea": "Cu, Zn",
    "ses": "1PE",
    "con": "1PE-08 ポルフィリンDNA標的を持つ_p_-cresol-2,6-amide-tether-tacn-porphyrin配位子とその二核銅/亜鉛錯体の合成とがん細胞選択的毒性 (<sup>1</sup>同志社大大学院理工) 〇山本 莉子<sup>1</sup>・畑 真知<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup> Synthesis and cancer-cell-selective cytotoxicity of dicopper/zinc complex with _p_-cresol-2,6-amide-tether-tacn-porphyrin ligand having a porphyrin DNA target (<sup>1</sup>Department of Science and Engineering, Doshisha Univ.) 〇Riko YAMAMOTO<sup>1</sup>, Machi HATA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masato KODERA<sup>1</sup> Cu, Zn"
  },
  {
    "inf": [
      "金属配位の最適化と金属中心近傍への変異導入による人工金属酵素の機能向上",
      "(<sup>1</sup>阪公大院農) ◎森川 才翔<sup>1</sup>・松本 隆聖<sup>1</sup>・森田 能次<sup>1</sup>・藤枝 伸宇<sup>1</sup>",
      "Improving the activity of artificial metalloenzymes by optimizing metal coordination and introducing mutations near the metal center",
      "(<sup>1</sup>Graduate School of Agriculture, Osaka Metropolitan University) ◎Saito MORIKAWA<sup>1</sup>, Ryusei MATSUMOTO<sup>1</sup>, Yoshitsugu MORITA<sup>1</sup>, Nobutaka FUJIEDA<sup>1</sup>"
    ],
    "lab": "1PE-09",
    "pdf": "pdf/1PE-09.pdf",
    "pre": "tn/1PE-09.jpg",
    "reg": "74405",
    "sea": "Cu, Zn",
    "ses": "1PE",
    "con": "1PE-09 金属配位の最適化と金属中心近傍への変異導入による人工金属酵素の機能向上 (<sup>1</sup>阪公大院農) ◎森川 才翔<sup>1</sup>・松本 隆聖<sup>1</sup>・森田 能次<sup>1</sup>・藤枝 伸宇<sup>1</sup> Improving the activity of artificial metalloenzymes by optimizing metal coordination and introducing mutations near the metal center (<sup>1</sup>Graduate School of Agriculture, Osaka Metropolitan University) ◎Saito MORIKAWA<sup>1</sup>, Ryusei MATSUMOTO<sup>1</sup>, Yoshitsugu MORITA<sup>1</sup>, Nobutaka FUJIEDA<sup>1</sup> Cu, Zn"
  },
  {
    "inf": [
      "ヘム獲得機構Hasを用いた緑膿菌の超音波力学的殺菌手法の開発",
      "(<sup>1</sup>名大院理) 〇岩上 奈都乃<sup>1</sup>・有安 真也<sup>1</sup>・愛場 雄一郎<sup>1</sup>・荘司 長三<sup>1</sup>",
      "Sonodynamic Therapy of _Pseudomonas aeruginosa_ by Exploiting Heme Acquisition System Has",
      "(<sup>1</sup>Nagoya Univ.) 〇Natsuno IWAKAMI<sup>1</sup>, Shinya ARIYASU<sup>1</sup>, Yuichiro AIBA<sup>1</sup>, Osami SHOJI<sup>1</sup>"
    ],
    "lab": "1PE-10",
    "pdf": "pdf/1PE-10.pdf",
    "pre": "tn/1PE-10.jpg",
    "reg": "74557",
    "sea": "Ga, Cr, Mn, Fe, Co",
    "ses": "1PE",
    "con": "1PE-10 ヘム獲得機構Hasを用いた緑膿菌の超音波力学的殺菌手法の開発 (<sup>1</sup>名大院理) 〇岩上 奈都乃<sup>1</sup>・有安 真也<sup>1</sup>・愛場 雄一郎<sup>1</sup>・荘司 長三<sup>1</sup> Sonodynamic Therapy of _Pseudomonas aeruginosa_ by Exploiting Heme Acquisition System Has (<sup>1</sup>Nagoya Univ.) 〇Natsuno IWAKAMI<sup>1</sup>, Shinya ARIYASU<sup>1</sup>, Yuichiro AIBA<sup>1</sup>, Osami SHOJI<sup>1</sup> Ga, Cr, Mn, Fe, Co"
  },
  {
    "inf": [
      " _p_-cresol-2,6-amide-tether-permethylcyclen配位子とその二核銅錯体の合成とがん細胞選択性",
      "(<sup>1</sup>同志社大大学院理工) 〇藤岡 賢志郎<sup>1</sup>・畑 真知<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup>",
      "Synthesis and cancer-cell selective cytotoxicity of a dicopper complex with _p_-creasol-2,6-amide-tether-permethylcyclen ligand",
      "(<sup>1</sup>Department of Science and Engineering, Doshisha University) 〇Kenshiro FUJIOKA<sup>1</sup>, Machi HATA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masahito KODERA<sup>1</sup>"
    ],
    "lab": "1PE-11",
    "pdf": "pdf/1PE-11.pdf",
    "pre": "tn/1PE-11.jpg",
    "reg": "74448",
    "sea": "Cu",
    "ses": "1PE",
    "con": "1PE-11  _p_-cresol-2,6-amide-tether-permethylcyclen配位子とその二核銅錯体の合成とがん細胞選択性 (<sup>1</sup>同志社大大学院理工) 〇藤岡 賢志郎<sup>1</sup>・畑 真知<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup> Synthesis and cancer-cell selective cytotoxicity of a dicopper complex with _p_-creasol-2,6-amide-tether-permethylcyclen ligand (<sup>1</sup>Department of Science and Engineering, Doshisha University) 〇Kenshiro FUJIOKA<sup>1</sup>, Machi HATA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masahito KODERA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "Photophysical Properties and CO<sub>2</sub> Photoreduction of Ruthenium(II) Complexes with Planar Boron Ligand",
      "(<sup>1</sup>Graduate School of Engineering, Nagasaki University, <sup>2</sup>Graduate School of Integrated Science and Technology, Nagasaki University) ◎Takuya Yokoo<sup>1</sup>, Eri Sakuda<sup>1,2</sup>, Kenichiro Omoto<sup>1,2</sup>, Yasuhiro Arikawa<sup>1,2</sup>, Keisuke Umakoshi<sup>1,2</sup>"
    ],
    "lab": "1PF-01",
    "pdf": "pdf/1PF-01.pdf",
    "pre": "tn/1PF-01.jpg",
    "reg": "74061",
    "sea": "Ru",
    "ses": "1PF",
    "con": "1PF-01 Photophysical Properties and CO<sub>2</sub> Photoreduction of Ruthenium(II) Complexes with Planar Boron Ligand (<sup>1</sup>Graduate School of Engineering, Nagasaki University, <sup>2</sup>Graduate School of Integrated Science and Technology, Nagasaki University) ◎Takuya Yokoo<sup>1</sup>, Eri Sakuda<sup>1,2</sup>, Kenichiro Omoto<sup>1,2</sup>, Yasuhiro Arikawa<sup>1,2</sup>, Keisuke Umakoshi<sup>1,2</sup> Ru"
  },
  {
    "inf": [
      "Electrochemical Reduction of CO<SUB>2</SUB> Catalyzed by Dirhodium(II) Complex Supported by A Macrocyclic Ligand",
      "(<sup>1</sup>Tokyo Institute of Technology, School of Science) ◎YAN Liping<sup></sup>, MORIMOTO Yuma<sup></sup>, YAMASHITA Makoto<sup></sup>"
    ],
    "lab": "1PF-02",
    "pdf": "pdf/1PF-02.pdf",
    "pre": "tn/1PF-02.jpg",
    "reg": "74407",
    "sea": "Rh",
    "ses": "1PF",
    "con": "1PF-02 Electrochemical Reduction of CO<SUB>2</SUB> Catalyzed by Dirhodium(II) Complex Supported by A Macrocyclic Ligand (<sup>1</sup>Tokyo Institute of Technology, School of Science) ◎YAN Liping<sup></sup>, MORIMOTO Yuma<sup></sup>, YAMASHITA Makoto<sup></sup> Rh"
  },
  {
    "inf": [
      "有機金属錯体と多孔性担体を用いた新規白金-テルビウム合金ナノ粒子の調製",
      "(<sup>1</sup>名大院理・<sup>2</sup>名大物国セ) 〇秋田 裕太郎<sup>1</sup>・森山 拓海<sup>1</sup>・邨次 智<sup>1</sup>・唯 美津木<sup>1, 2</sup>",
      "Preparation of Platinum-Terbium Alloy Nanoparticles using Organometallic Complex Precursors and Porous Supports",
      "(<sup>1</sup>Grad. Sch. Sci. Nagoya Univ., <sup>2</sup>RCMS, Nagoya Univ.) 〇Yutaro AKITA<sup>1</sup>, Takumi MORIYAMA<sup>1</sup>, Satoshi MURATSUGU<sup>1</sup>, Mizuki TADA<sup>1, 2</sup>"
    ],
    "lab": "1PF-03",
    "pdf": "pdf/1PF-03.pdf",
    "pre": "tn/1PF-03.jpg",
    "reg": "74093",
    "sea": "Pt, Tb",
    "ses": "1PF",
    "con": "1PF-03 有機金属錯体と多孔性担体を用いた新規白金-テルビウム合金ナノ粒子の調製 (<sup>1</sup>名大院理・<sup>2</sup>名大物国セ) 〇秋田 裕太郎<sup>1</sup>・森山 拓海<sup>1</sup>・邨次 智<sup>1</sup>・唯 美津木<sup>1, 2</sup> Preparation of Platinum-Terbium Alloy Nanoparticles using Organometallic Complex Precursors and Porous Supports (<sup>1</sup>Grad. Sch. Sci. Nagoya Univ., <sup>2</sup>RCMS, Nagoya Univ.) 〇Yutaro AKITA<sup>1</sup>, Takumi MORIYAMA<sup>1</sup>, Satoshi MURATSUGU<sup>1</sup>, Mizuki TADA<sup>1, 2</sup> Pt, Tb"
  },
  {
    "inf": [
      "Theoretical Study on the Excited State Deactivation Pathways of _trans_-Bis(iminoazolate)platinum(II) Complexes ",
      "(<sup>1</sup>Graduate School of Engineering Science, Osaka University) ◎Shufang HUANG<sup>1</sup>, Soichiro KAWAMORITA<sup>1</sup>, Shuichi SUZUKI<sup>1</sup>, Takeshi NAOTA<sup>1</sup>"
    ],
    "lab": "1PF-04",
    "pdf": "pdf/1PF-04.pdf",
    "pre": "tn/1PF-04.jpg",
    "reg": "74409",
    "sea": "Pt, Restriction to conical intersection, Emission",
    "ses": "1PF",
    "con": "1PF-04 Theoretical Study on the Excited State Deactivation Pathways of _trans_-Bis(iminoazolate)platinum(II) Complexes  (<sup>1</sup>Graduate School of Engineering Science, Osaka University) ◎Shufang HUANG<sup>1</sup>, Soichiro KAWAMORITA<sup>1</sup>, Shuichi SUZUKI<sup>1</sup>, Takeshi NAOTA<sup>1</sup> Pt, Restriction to conical intersection, Emission"
  },
  {
    "inf": [
      "二価金属イオン含有配位高分子におけるゲスト蒸気下でのイオン伝導度のカチオン種依存性",
      "(<sup>1</sup>東理大院理) 〇谷口 香<sup>1</sup>・貞清 正彰<sup>1</sup>",
      "Cation Dependence of Ionic Conductivity in Divalent-Ion-Containing Metal–Organic Frameworks under Guest Vapors",
      "(<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Kaori TANIGUCHI<sup>1</sup>, Masaaki SADAKIYO<sup>1</sup>"
    ],
    "lab": "1PF-05",
    "pdf": "pdf/1PF-05.pdf",
    "pre": "tn/1PF-05.jpg",
    "reg": "74229",
    "sea": "Cr, Ca, Zn",
    "ses": "1PF",
    "con": "1PF-05 二価金属イオン含有配位高分子におけるゲスト蒸気下でのイオン伝導度のカチオン種依存性 (<sup>1</sup>東理大院理) 〇谷口 香<sup>1</sup>・貞清 正彰<sup>1</sup> Cation Dependence of Ionic Conductivity in Divalent-Ion-Containing Metal–Organic Frameworks under Guest Vapors (<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Kaori TANIGUCHI<sup>1</sup>, Masaaki SADAKIYO<sup>1</sup> Cr, Ca, Zn"
  },
  {
    "inf": [
      "Microscopic Studies of Gaseous Molecule-Induced Luminescence Change in Luminescent Lanthanide Coordination Polymer Crystals",
      "(<sup>1</sup>IIS, The Univ. of Tokyo, <sup>2</sup>Faculty of Engineering, Hokkaido Univ., <sup>3</sup>WPI-ICReDD, Hokkaido Univ.) ◎Xiao MA<sup>1</sup>, Joe HAYASHI<sup>2</sup>, Yuichi KITAGAWA<sup>2,3</sup>, Yasuchika HASEGAWA<sup>2,3</sup>, Kazuyuki ISHII<sup>1</sup>"
    ],
    "lab": "1PF-06",
    "pdf": "pdf/1PF-06.pdf",
    "pre": "tn/1PF-06.jpg",
    "reg": "74576",
    "sea": "Eu, Tb",
    "ses": "1PF",
    "con": "1PF-06 Microscopic Studies of Gaseous Molecule-Induced Luminescence Change in Luminescent Lanthanide Coordination Polymer Crystals (<sup>1</sup>IIS, The Univ. of Tokyo, <sup>2</sup>Faculty of Engineering, Hokkaido Univ., <sup>3</sup>WPI-ICReDD, Hokkaido Univ.) ◎Xiao MA<sup>1</sup>, Joe HAYASHI<sup>2</sup>, Yuichi KITAGAWA<sup>2,3</sup>, Yasuchika HASEGAWA<sup>2,3</sup>, Kazuyuki ISHII<sup>1</sup> Eu, Tb"
  },
  {
    "inf": [
      "配位子内の二面角変化が **_Pd_**<sub>3<em>n</em></sub>L<sub>2<em>n</em></sub> (_n_ = 2–4) かご形錯体の歪みに与える影響",
      "(<sup>1</sup>東大院総合文化) ◎竹内 啓介<sup>1</sup>・阿部 司<sup>1</sup>・平岡 秀一<sup>1</sup>",
      "Effect of dihedral angles in ligands on the strain of **_Pd_**<sub>3<em>n</em></sub>L<sub>2<em>n</em></sub> (_n_ = 2–4) cage complexes",
      "(<sup>1</sup>The Univ. of Tokyo) ◎Keisuke TAKEUCHI<sup>1</sup>, Tsukasa ABE<sup>1</sup>, Shuichi HIRAOKA<sup>1</sup>"
    ],
    "lab": "1PF-07",
    "pdf": "pdf/1PF-07.pdf",
    "pre": "tn/1PF-07.jpg",
    "reg": "74010",
    "sea": "Pd",
    "ses": "1PF",
    "con": "1PF-07 配位子内の二面角変化が **_Pd_**<sub>3<em>n</em></sub>L<sub>2<em>n</em></sub> (_n_ = 2–4) かご形錯体の歪みに与える影響 (<sup>1</sup>東大院総合文化) ◎竹内 啓介<sup>1</sup>・阿部 司<sup>1</sup>・平岡 秀一<sup>1</sup> Effect of dihedral angles in ligands on the strain of **_Pd_**<sub>3<em>n</em></sub>L<sub>2<em>n</em></sub> (_n_ = 2–4) cage complexes (<sup>1</sup>The Univ. of Tokyo) ◎Keisuke TAKEUCHI<sup>1</sup>, Tsukasa ABE<sup>1</sup>, Shuichi HIRAOKA<sup>1</sup> Pd"
  },
  {
    "inf": [
      "Fe(III)錯体によるメタノールのホルムアルデヒドへの酸化反応",
      "(<sup>1</sup>東理大院理) 〇鈴木 颯真<sup>1</sup>・中根 大輔<sup>1</sup>・秋津 貴城<sup>1</sup>",
      "Oxidation of methanol to formaldehyde by Fe(III) complexes",
      "(<sup>1</sup>Department of Chemistry, Graduate School of Science, Tokyo University of Science) 〇Soma SUZUKI<sup>1</sup>, Daisuke NAKANE<sup>1</sup>, Takashiro AKITSU<sup>1</sup>"
    ],
    "lab": "1PF-08",
    "pdf": "pdf/1PF-08.pdf",
    "pre": "tn/1PF-08.jpg",
    "reg": "74124",
    "sea": "Fe",
    "ses": "1PF",
    "con": "1PF-08 Fe(III)錯体によるメタノールのホルムアルデヒドへの酸化反応 (<sup>1</sup>東理大院理) 〇鈴木 颯真<sup>1</sup>・中根 大輔<sup>1</sup>・秋津 貴城<sup>1</sup> Oxidation of methanol to formaldehyde by Fe(III) complexes (<sup>1</sup>Department of Chemistry, Graduate School of Science, Tokyo University of Science) 〇Soma SUZUKI<sup>1</sup>, Daisuke NAKANE<sup>1</sup>, Takashiro AKITSU<sup>1</sup> Fe"
  },
  {
    "inf": [
      "金属有機構造体薄膜のソルバト/ベイポクロミズム特性を用いた水中のエタノール濃度検出センサー",
      "(<sup>1</sup>大阪公大院工・<sup>2</sup>九州大工) ◎土岐 雄人<sup>1</sup>・岡田 健司<sup>1</sup>・深津 亜里紗<sup>1</sup>・辻 雄太<sup>2</sup>・高橋 雅英<sup>1</sup>",
      "Sensor Detecting the Ethanol Content in Water by Solvato/Vapochromism of Metal–Organic Framework Thin Films",
      "(<sup>1</sup>Osaka Metropolitan Univ., <sup>2</sup>Kyusyu Univ.) ◎Yuto Toki<sup>1</sup>, Kenji Okada<sup>1</sup>, Arisa Fukatsu<sup>1</sup>, Yuta Tsuji<sup>2</sup>, Masahide Takahashi<sup>1</sup>"
    ],
    "lab": "1PF-09",
    "pdf": "pdf/1PF-09.pdf",
    "pre": "tn/1PF-09.jpg",
    "reg": "74033",
    "sea": "Cu",
    "ses": "1PF",
    "con": "1PF-09 金属有機構造体薄膜のソルバト/ベイポクロミズム特性を用いた水中のエタノール濃度検出センサー (<sup>1</sup>大阪公大院工・<sup>2</sup>九州大工) ◎土岐 雄人<sup>1</sup>・岡田 健司<sup>1</sup>・深津 亜里紗<sup>1</sup>・辻 雄太<sup>2</sup>・高橋 雅英<sup>1</sup> Sensor Detecting the Ethanol Content in Water by Solvato/Vapochromism of Metal–Organic Framework Thin Films (<sup>1</sup>Osaka Metropolitan Univ., <sup>2</sup>Kyusyu Univ.) ◎Yuto Toki<sup>1</sup>, Kenji Okada<sup>1</sup>, Arisa Fukatsu<sup>1</sup>, Yuta Tsuji<sup>2</sup>, Masahide Takahashi<sup>1</sup> Cu"
  },
  {
    "inf": [
      "テオフィリンパラジウム錯体を触媒として用いた薗頭カップリング反応",
      "(<sup>1</sup>神奈川大化学生命) 〇貝掛 勝也<sup>1</sup>・新郷 明日真<sup>1</sup>・三浦 拓己<sup>1</sup>・金 仁華<sup>1</sup>",
      "Sonogashira coupling reaction catalyzed by a complex of palladium-bistheophyllines under mild green conditions",
      "(<sup>1</sup>Kanagawa Univ.) 〇Katsuya KAIKAKE<sup>1</sup>, Asuma SHINGO<sup>1</sup>, Takumi MIURA<sup>1</sup>, Ren-Hua JIN<sup>1</sup>"
    ],
    "lab": "1PF-10",
    "pdf": "pdf/1PF-10.pdf",
    "pre": "tn/1PF-10.jpg",
    "reg": "74032",
    "sea": "Pd",
    "ses": "1PF",
    "con": "1PF-10 テオフィリンパラジウム錯体を触媒として用いた薗頭カップリング反応 (<sup>1</sup>神奈川大化学生命) 〇貝掛 勝也<sup>1</sup>・新郷 明日真<sup>1</sup>・三浦 拓己<sup>1</sup>・金 仁華<sup>1</sup> Sonogashira coupling reaction catalyzed by a complex of palladium-bistheophyllines under mild green conditions (<sup>1</sup>Kanagawa Univ.) 〇Katsuya KAIKAKE<sup>1</sup>, Asuma SHINGO<sup>1</sup>, Takumi MIURA<sup>1</sup>, Ren-Hua JIN<sup>1</sup> Pd"
  },
  {
    "inf": [
      "亜鉛空気二次電池の実用化に向けた炭素腐食を抑制する低過電圧OER電極",
      "(<sup>1</sup>山形大院理工・<sup>2</sup>東北大WPI-AIMR) ◎高木 裕暉<sup>1</sup>・石橋 孝介<sup>2</sup>・藪 浩<sup>2</sup>・石崎 学<sup>1</sup>・栗原 正人<sup>1</sup>",
      "Low-Overpotential OER Electrode Suppressing Carbon Corrosion to Realize Rechargeable Zinc-Air Batteries",
      "(<sup>1</sup>Yamagata Univ., <sup>2</sup>Tohoku Univ. WPI-AIMR) ◎Yuki Takaki<sup>1</sup>, Kosuke Ishibashi<sup>2</sup>, Hiroshi Yabu<sup>2</sup>, Manabu Ishizaki<sup>1</sup>, Masato Kurihara<sup>1</sup>"
    ],
    "lab": "1PF-11",
    "pdf": "pdf/1PF-11.pdf",
    "pre": "tn/1PF-11.jpg",
    "reg": "74054",
    "sea": "Fe, Ni",
    "ses": "1PF",
    "con": "1PF-11 亜鉛空気二次電池の実用化に向けた炭素腐食を抑制する低過電圧OER電極 (<sup>1</sup>山形大院理工・<sup>2</sup>東北大WPI-AIMR) ◎高木 裕暉<sup>1</sup>・石橋 孝介<sup>2</sup>・藪 浩<sup>2</sup>・石崎 学<sup>1</sup>・栗原 正人<sup>1</sup> Low-Overpotential OER Electrode Suppressing Carbon Corrosion to Realize Rechargeable Zinc-Air Batteries (<sup>1</sup>Yamagata Univ., <sup>2</sup>Tohoku Univ. WPI-AIMR) ◎Yuki Takaki<sup>1</sup>, Kosuke Ishibashi<sup>2</sup>, Hiroshi Yabu<sup>2</sup>, Manabu Ishizaki<sup>1</sup>, Masato Kurihara<sup>1</sup> Fe, Ni"
  },
  {
    "inf": [
      "弾性・電気伝導性・磁性を示す結晶の構築と物性評価",
      "(<sup>1</sup>奈良女大院・<sup>2</sup>日大文理) ◎渡邉 千遥<sup>1</sup>・堀井 洋司<sup>1</sup>・野口 真理子<sup>2</sup>・梶原 孝志<sup>1</sup>",
      "Construction and characterization of crystals exhibiting elasticity, electrical conductivity, and magnetism",
      "(<sup>1</sup>Nara Woman's University, <sup>2</sup>Nihon University) ◎Chiharu WATANABE<sup>1</sup>, Yoji HORII<sup>1</sup>, Mariko NOGUCHI<sup>2</sup>, Takashi KAJIWARA<sup>1</sup>"
    ],
    "lab": "1PF-12",
    "pdf": "pdf/1PF-12.pdf",
    "pre": "tn/1PF-12.jpg",
    "reg": "74058",
    "sea": "Cu",
    "ses": "1PF",
    "con": "1PF-12 弾性・電気伝導性・磁性を示す結晶の構築と物性評価 (<sup>1</sup>奈良女大院・<sup>2</sup>日大文理) ◎渡邉 千遥<sup>1</sup>・堀井 洋司<sup>1</sup>・野口 真理子<sup>2</sup>・梶原 孝志<sup>1</sup> Construction and characterization of crystals exhibiting elasticity, electrical conductivity, and magnetism (<sup>1</sup>Nara Woman's University, <sup>2</sup>Nihon University) ◎Chiharu WATANABE<sup>1</sup>, Yoji HORII<sup>1</sup>, Mariko NOGUCHI<sup>2</sup>, Takashi KAJIWARA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "フェノレート配位を有するFe(Ⅲ)錯体によるメタノール酸化能の電気化学的評価及びFe(III)錯体修飾電極の作製",
      "(<sup>1</sup>東理大院理) 〇高島 紘史<sup>1</sup>・中根 大輔<sup>1</sup>・秋津 貴城<sup>1</sup>",
      "Electrochemical evaluation of methanol oxidation catalyzed by Fe(III) complexes with phenolato coordination and preparation of the Fe(III) complex-modified electrodes.",
      "(<sup>1</sup>東京理科大学大学院理学研究科) 〇Hiroshi TAKASHIMA<sup>1</sup>, Daisuke NAKANE<sup>1</sup>, Takashiro AKITSU<sup>1</sup>"
    ],
    "lab": "1PF-13",
    "pdf": "pdf/1PF-13.pdf",
    "pre": "tn/1PF-13.jpg",
    "reg": "74185",
    "sea": "Fe",
    "ses": "1PF",
    "con": "1PF-13 フェノレート配位を有するFe(Ⅲ)錯体によるメタノール酸化能の電気化学的評価及びFe(III)錯体修飾電極の作製 (<sup>1</sup>東理大院理) 〇高島 紘史<sup>1</sup>・中根 大輔<sup>1</sup>・秋津 貴城<sup>1</sup> Electrochemical evaluation of methanol oxidation catalyzed by Fe(III) complexes with phenolato coordination and preparation of the Fe(III) complex-modified electrodes. (<sup>1</sup>東京理科大学大学院理学研究科) 〇Hiroshi TAKASHIMA<sup>1</sup>, Daisuke NAKANE<sup>1</sup>, Takashiro AKITSU<sup>1</sup> Fe"
  },
  {
    "inf": [
      "等温滴定熱測定によるMOF細孔への高分子吸着の熱力学的解析",
      "(<sup>1</sup>東大院工) ◎河野 悠生<sup>1</sup>・細野 暢彦<sup>1</sup>・植村 卓史<sup>1</sup>",
      "Thermodynamics of Polymer Insertion into MOF Nanopores: An Isothermal Titration Calorimetric Study",
      "(<sup>1</sup>Grad. Sch. of Eng, Tokyo Univ.) ◎Yu KONO<sup>1</sup>, Nobuhiko HOSONO<sup>1</sup>, Takashi UEMURA<sup>1</sup>"
    ],
    "lab": "1PF-14",
    "pdf": "pdf/1PF-14.pdf",
    "pre": "tn/1PF-14.jpg",
    "reg": "74099",
    "sea": "Zn",
    "ses": "1PF",
    "con": "1PF-14 等温滴定熱測定によるMOF細孔への高分子吸着の熱力学的解析 (<sup>1</sup>東大院工) ◎河野 悠生<sup>1</sup>・細野 暢彦<sup>1</sup>・植村 卓史<sup>1</sup> Thermodynamics of Polymer Insertion into MOF Nanopores: An Isothermal Titration Calorimetric Study (<sup>1</sup>Grad. Sch. of Eng, Tokyo Univ.) ◎Yu KONO<sup>1</sup>, Nobuhiko HOSONO<sup>1</sup>, Takashi UEMURA<sup>1</sup> Zn"
  },
  {
    "inf": [
      "ルテニウム-ペプチド錯体触媒によるミセル水溶液における光化学的CO<sub>2</sub>還元反応",
      "(<sup>1</sup>関西大院理工) 〇門司 泰征<sup>1</sup>・林 陸斗<sup>1</sup>・大塚 みなみ<sup>1</sup>・横田 朱音<sup>1</sup>・石田 斉<sup>1</sup>",
      "Photocatalytic CO<sub>2</sub> Reduction by Ruthenium-Peptide Complexes in Aqueous Micellar Solutions",
      "(<sup>1</sup>Kansai Univ.) 〇Taisei MONJI<sup>1</sup>, Rikuto HAYASHI<sup>1</sup>, Minami OTSUKA<sup>1</sup>, Akane YOKOTA<sup>1</sup>, Hitoshi ISHIDA<sup>1</sup>"
    ],
    "lab": "1PF-15",
    "pdf": "pdf/1PF-15.pdf",
    "pre": "tn/1PF-15.jpg",
    "reg": "74245",
    "sea": "Ru",
    "ses": "1PF",
    "con": "1PF-15 ルテニウム-ペプチド錯体触媒によるミセル水溶液における光化学的CO<sub>2</sub>還元反応 (<sup>1</sup>関西大院理工) 〇門司 泰征<sup>1</sup>・林 陸斗<sup>1</sup>・大塚 みなみ<sup>1</sup>・横田 朱音<sup>1</sup>・石田 斉<sup>1</sup> Photocatalytic CO<sub>2</sub> Reduction by Ruthenium-Peptide Complexes in Aqueous Micellar Solutions (<sup>1</sup>Kansai Univ.) 〇Taisei MONJI<sup>1</sup>, Rikuto HAYASHI<sup>1</sup>, Minami OTSUKA<sup>1</sup>, Akane YOKOTA<sup>1</sup>, Hitoshi ISHIDA<sup>1</sup> Ru"
  },
  {
    "inf": [
      "非対称なNHC金属錯体を用いた発光性結晶分子ローターの開発",
      "(<sup>1</sup>北大院総化・<sup>2</sup>金沢大ナノマリ・<sup>3</sup>北大院工・<sup>4</sup>北大WPI-ICReDD) ◎藤澤 優輔<sup>1</sup>・安藤 廉平<sup>1</sup>・水野 元博<sup>2</sup>・伊藤 肇<sup>3,4</sup>・陳 旻究<sup>4</sup>",
      "Development of luminescent crystalline molecular rotors using asymmetric NHC metal complexes",
      "(<sup>1</sup>Grad. Sch. of Chem. Sci. and Eng., Hokkaido Univ., <sup>2</sup>NanoMaRi. Res. Inst., Kanazawa Univ., <sup>3</sup>Grad. Sch. of Eng., Hokkaido Univ., <sup>4</sup>WPI-ICReDD, Hokkaido Univ.) ◎Yusuke FUJISAWA<sup>1</sup>, Rempei ANDO<sup>1</sup>, Motohiro MIZUNO<sup>2</sup>, Hajime ITO<sup>3,4</sup>, Mingoo JIN<sup>4</sup>"
    ],
    "lab": "1PF-16",
    "pdf": "pdf/1PF-16.pdf",
    "pre": "tn/1PF-16.jpg",
    "reg": "74108",
    "sea": "Au, Ag, Cu",
    "ses": "1PF",
    "con": "1PF-16 非対称なNHC金属錯体を用いた発光性結晶分子ローターの開発 (<sup>1</sup>北大院総化・<sup>2</sup>金沢大ナノマリ・<sup>3</sup>北大院工・<sup>4</sup>北大WPI-ICReDD) ◎藤澤 優輔<sup>1</sup>・安藤 廉平<sup>1</sup>・水野 元博<sup>2</sup>・伊藤 肇<sup>3,4</sup>・陳 旻究<sup>4</sup> Development of luminescent crystalline molecular rotors using asymmetric NHC metal complexes (<sup>1</sup>Grad. Sch. of Chem. Sci. and Eng., Hokkaido Univ., <sup>2</sup>NanoMaRi. Res. Inst., Kanazawa Univ., <sup>3</sup>Grad. Sch. of Eng., Hokkaido Univ., <sup>4</sup>WPI-ICReDD, Hokkaido Univ.) ◎Yusuke FUJISAWA<sup>1</sup>, Rempei ANDO<sup>1</sup>, Motohiro MIZUNO<sup>2</sup>, Hajime ITO<sup>3,4</sup>, Mingoo JIN<sup>4</sup> Au, Ag, Cu"
  },
  {
    "inf": [
      "カチオン性白金架橋芳香環チューブ:色素分子の選択的捕捉と発光特性",
      "(<sup>1</sup>東工大 化生研) ◎互井 孔貴<sup>1</sup>・田中 裕也<sup>1</sup>・吉沢 道人<sup>1</sup>",
      "A cationic Pt-linked polyaromatic tube: selective dye binding and emission properties.",
      "(<sup>1</sup>Lab. for Chem. & Life Sci., Tokyo Tech) ◎Koki TAGAI<sup>1</sup>, Yuya TANAKA<sup>1</sup>, Michito YOSHIZAWA<sup>1</sup>"
    ],
    "lab": "1PF-17",
    "pdf": "pdf/1PF-17.pdf",
    "pre": "tn/1PF-17.jpg",
    "reg": "74184",
    "sea": "Pt",
    "ses": "1PF",
    "con": "1PF-17 カチオン性白金架橋芳香環チューブ:色素分子の選択的捕捉と発光特性 (<sup>1</sup>東工大 化生研) ◎互井 孔貴<sup>1</sup>・田中 裕也<sup>1</sup>・吉沢 道人<sup>1</sup> A cationic Pt-linked polyaromatic tube: selective dye binding and emission properties. (<sup>1</sup>Lab. for Chem. & Life Sci., Tokyo Tech) ◎Koki TAGAI<sup>1</sup>, Yuya TANAKA<sup>1</sup>, Michito YOSHIZAWA<sup>1</sup> Pt"
  },
  {
    "inf": [
      "遷移金属錯体を用いた還元反応場の構築",
      "(<sup>1</sup>名工大院工・<sup>2</sup>愛工大工) 〇平澤 怜実<sup>1</sup>・原 善邦<sup>1</sup>・猪股 智彦<sup>1</sup>・増田 秀樹<sup>2</sup>・小澤 智宏<sup>1</sup>",
      "Construction of a reaction field for reduction using transition metal complexes",
      "(<sup>1</sup>Graduate School of Engineering, Nagoya Institute of Technology, <sup>2</sup>Aichi Institute of Technology) 〇Satomi HIRASAWA<sup>1</sup>, Yoshikuni HARA<sup>1</sup>, Tomohiko INOMATA<sup>1</sup>, Hideki MASUDA<sup>2</sup>, Tomohiro OZAWA<sup>1</sup>"
    ],
    "lab": "1PF-18",
    "pdf": "pdf/1PF-18.pdf",
    "pre": "tn/1PF-18.jpg",
    "reg": "74280",
    "sea": "Ni",
    "ses": "1PF",
    "con": "1PF-18 遷移金属錯体を用いた還元反応場の構築 (<sup>1</sup>名工大院工・<sup>2</sup>愛工大工) 〇平澤 怜実<sup>1</sup>・原 善邦<sup>1</sup>・猪股 智彦<sup>1</sup>・増田 秀樹<sup>2</sup>・小澤 智宏<sup>1</sup> Construction of a reaction field for reduction using transition metal complexes (<sup>1</sup>Graduate School of Engineering, Nagoya Institute of Technology, <sup>2</sup>Aichi Institute of Technology) 〇Satomi HIRASAWA<sup>1</sup>, Yoshikuni HARA<sup>1</sup>, Tomohiko INOMATA<sup>1</sup>, Hideki MASUDA<sup>2</sup>, Tomohiro OZAWA<sup>1</sup> Ni"
  },
  {
    "inf": [
      "カチオン性Zr有機金属多面体のポリ酸との集積化と光増感能",
      "(<sup>1</sup>九大院理) ◎末田 悠太<sup>1</sup>・ルウェ バンジャマン<sup>1</sup>・大場 正昭<sup>1</sup>",
      "Cationic Zr-based Coordination Cages as Photosensitizers for Polyoxometalate-based Catalysis",
      "(<sup>1</sup>Graduate School of Science, Kyushu University) ◎Yuta Sueda<sup>1</sup>, Benjamin Le Ouay<sup>1</sup>, Masaaki Ohba<sup>1</sup>"
    ],
    "lab": "1PF-19",
    "pdf": "pdf/1PF-19.pdf",
    "pre": "tn/1PF-19.jpg",
    "reg": "74218",
    "sea": "Zr, W",
    "ses": "1PF",
    "con": "1PF-19 カチオン性Zr有機金属多面体のポリ酸との集積化と光増感能 (<sup>1</sup>九大院理) ◎末田 悠太<sup>1</sup>・ルウェ バンジャマン<sup>1</sup>・大場 正昭<sup>1</sup> Cationic Zr-based Coordination Cages as Photosensitizers for Polyoxometalate-based Catalysis (<sup>1</sup>Graduate School of Science, Kyushu University) ◎Yuta Sueda<sup>1</sup>, Benjamin Le Ouay<sup>1</sup>, Masaaki Ohba<sup>1</sup> Zr, W"
  },
  {
    "inf": [
      "フラーレン内包多孔性亜鉛ポルフィリン錯体の光水素生成評価",
      "(<sup>1</sup>岡山理大理・<sup>2</sup>岡山理大工・<sup>3</sup>島根大院自然科学) 〇満身 稔<sup>1</sup>・高井翔生<sup>1</sup>・大城実之<sup>1</sup>・草野圭弘<sup>2</sup>・矢野なつみ<sup>3</sup>・片岡祐介<sup>3</sup>",
      "Evaluation of Photocatalytic Hydrogen Production of Fullerene-Encapsulated Porous Zinc Porphyrin",
      "(<sup>1</sup>Fac. of Sci., Okayama Univ. of Sci., <sup>2</sup>Fac. of Eng., Okayama Univ. of Sci., <sup>3</sup>Grad. Sch. of Nat. Sci. and Technol., Shimane Univ.) 〇Minoru MITSUMI<sup>1</sup>, Shoki TAKAI<sup>1</sup>, Mitsuyuki OSHIRO<sup>1</sup>, Yoshihiro KUSANO<sup>2</sup>, Natsumi YANO<sup>3</sup>, Yusuke KATAOKA<sup>3</sup>"
    ],
    "lab": "1PF-20",
    "pdf": "pdf/1PF-20.pdf",
    "pre": "tn/1PF-20.jpg",
    "reg": "74312",
    "sea": "Zn",
    "ses": "1PF",
    "con": "1PF-20 フラーレン内包多孔性亜鉛ポルフィリン錯体の光水素生成評価 (<sup>1</sup>岡山理大理・<sup>2</sup>岡山理大工・<sup>3</sup>島根大院自然科学) 〇満身 稔<sup>1</sup>・高井翔生<sup>1</sup>・大城実之<sup>1</sup>・草野圭弘<sup>2</sup>・矢野なつみ<sup>3</sup>・片岡祐介<sup>3</sup> Evaluation of Photocatalytic Hydrogen Production of Fullerene-Encapsulated Porous Zinc Porphyrin (<sup>1</sup>Fac. of Sci., Okayama Univ. of Sci., <sup>2</sup>Fac. of Eng., Okayama Univ. of Sci., <sup>3</sup>Grad. Sch. of Nat. Sci. and Technol., Shimane Univ.) 〇Minoru MITSUMI<sup>1</sup>, Shoki TAKAI<sup>1</sup>, Mitsuyuki OSHIRO<sup>1</sup>, Yoshihiro KUSANO<sup>2</sup>, Natsumi YANO<sup>3</sup>, Yusuke KATAOKA<sup>3</sup> Zn"
  },
  {
    "inf": [
      "四価金属イオンを包接した配位高分子の室温におけるゲスト誘起超イオン伝導性",
      "(<sup>1</sup>東理大院理) ◎蒲谷 弥希<sup>1</sup>・貞清 正彰<sup>1</sup>",
      "Guest-Induced Superionic Conduction in a Metal–Organic Framework Including Tetravalent Ions in the Pores at Room Temperature",
      "(<sup>1</sup>Graduate School of Science, Tokyo University of Science) ◎Mitsuki KABAYA<sup>1</sup>, Masaaki SADAKIYO<sup>1</sup>"
    ],
    "lab": "1PF-21",
    "pdf": "pdf/1PF-21.pdf",
    "pre": "tn/1PF-21.jpg",
    "reg": "74293",
    "sea": "Zr, Hf",
    "ses": "1PF",
    "con": "1PF-21 四価金属イオンを包接した配位高分子の室温におけるゲスト誘起超イオン伝導性 (<sup>1</sup>東理大院理) ◎蒲谷 弥希<sup>1</sup>・貞清 正彰<sup>1</sup> Guest-Induced Superionic Conduction in a Metal–Organic Framework Including Tetravalent Ions in the Pores at Room Temperature (<sup>1</sup>Graduate School of Science, Tokyo University of Science) ◎Mitsuki KABAYA<sup>1</sup>, Masaaki SADAKIYO<sup>1</sup> Zr, Hf"
  },
  {
    "inf": [
      "溶液中におけるEu(III)錯体の励起状態ダイナミクスに対する金属イオン添加の影響",
      "(<sup>1</sup>北大院総化・<sup>2</sup>北大院工・<sup>3</sup>北大WPI-ICReDD) ◎井下 太地<sup>1</sup>・ワン メンフィ<sup>2,3</sup>・北川 裕一<sup>2,3</sup>・長谷川 靖哉<sup>2,3</sup>",
      "The influence of metal ions on the excited-state dynamics of Eu(III) complexes in solution",
      "(<sup>1</sup>Graduate School of Chemical Sciences and Engineering, Hokkaido University, <sup>2</sup>Faculty of Engineering, Hokkaido University, <sup>3</sup>WPI-ICReDD, Hokkaido University) ◎Taichi INOSHITA<sup>1</sup>, Mengfei WANG<sup>2,3</sup>, Yuichi KITAGAWA<sup>2,3</sup>, Yasuchika HASEGAWA<sup>2,3</sup>"
    ],
    "lab": "1PF-22",
    "pdf": "pdf/1PF-22.pdf",
    "pre": "tn/1PF-22.jpg",
    "reg": "74308",
    "sea": "Eu",
    "ses": "1PF",
    "con": "1PF-22 溶液中におけるEu(III)錯体の励起状態ダイナミクスに対する金属イオン添加の影響 (<sup>1</sup>北大院総化・<sup>2</sup>北大院工・<sup>3</sup>北大WPI-ICReDD) ◎井下 太地<sup>1</sup>・ワン メンフィ<sup>2,3</sup>・北川 裕一<sup>2,3</sup>・長谷川 靖哉<sup>2,3</sup> The influence of metal ions on the excited-state dynamics of Eu(III) complexes in solution (<sup>1</sup>Graduate School of Chemical Sciences and Engineering, Hokkaido University, <sup>2</sup>Faculty of Engineering, Hokkaido University, <sup>3</sup>WPI-ICReDD, Hokkaido University) ◎Taichi INOSHITA<sup>1</sup>, Mengfei WANG<sup>2,3</sup>, Yuichi KITAGAWA<sup>2,3</sup>, Yasuchika HASEGAWA<sup>2,3</sup> Eu"
  },
  {
    "inf": [
      "超分子反応場を有するAu<sub>25</sub>ナノクラスターによるアルキン酸の触媒的環化反応",
      "(<sup>1</sup>京大院工・<sup>2</sup>京大化研) 〇上田 恭輔<sup>1,2</sup>・中村 正治<sup>1,2</sup>・磯崎 勝弘<sup>1,2</sup>",
      "Cyclization of Alkynoic Acids Catalyzed by Au<sub>25</sub> Nanoclusters Bearing Supramolecular Reaction Field",
      "(<sup>1</sup>Graduate School of Engineering, Kyoto University, <sup>2</sup>Institute for Chemical Research, Kyoto University) 〇Kyosuke UEDA<sup>1,2</sup>, Masaharu NAKAMURA<sup>1,2</sup>, Katsuhiro ISOZAKI<sup>1,2</sup>"
    ],
    "lab": "1PF-23",
    "pdf": "pdf/1PF-23.pdf",
    "pre": "tn/1PF-23.jpg",
    "reg": "74371",
    "sea": "Au",
    "ses": "1PF",
    "con": "1PF-23 超分子反応場を有するAu<sub>25</sub>ナノクラスターによるアルキン酸の触媒的環化反応 (<sup>1</sup>京大院工・<sup>2</sup>京大化研) 〇上田 恭輔<sup>1,2</sup>・中村 正治<sup>1,2</sup>・磯崎 勝弘<sup>1,2</sup> Cyclization of Alkynoic Acids Catalyzed by Au<sub>25</sub> Nanoclusters Bearing Supramolecular Reaction Field (<sup>1</sup>Graduate School of Engineering, Kyoto University, <sup>2</sup>Institute for Chemical Research, Kyoto University) 〇Kyosuke UEDA<sup>1,2</sup>, Masaharu NAKAMURA<sup>1,2</sup>, Katsuhiro ISOZAKI<sup>1,2</sup> Au"
  },
  {
    "inf": [
      "チオラート保護銅ナノクラスターの連結構造体化と還元触媒への応用",
      "(<sup>1</sup>東理大院・<sup>2</sup>東理大・<sup>3</sup>東北大多元研) ◎富岡 里菜<sup>1</sup>・酒井 仁<sup>1</sup>・大岩 一毅<sup>1</sup>・中谷 利毅<sup>1</sup>・近藤 歩<sup>2</sup>・新堀 佳紀<sup>1</sup>・Saikat DAS<sup>1</sup>・川脇 徳久<sup>1</sup>・根岸 雄一<sup>1,3</sup>",
      "Assembly of Thiolate-Protected Copper Nanoclusters and the application as reduction catalysts",
      "(<sup>1</sup>Graduate School of Science, Tokyo Univ. of Science, <sup>2</sup>Tokyo Univ. of Science, <sup>3</sup>IMRAM, Tohoku Univ.) ◎Rina TOMIOKA<sup>1</sup>, Jin SAKAI<sup>1</sup>, Kazutaka OIWA<sup>1</sup>, Riki NAKATANI<sup>1</sup>, Ayumu KONDO<sup>2</sup>, Yoshiki NIIHORI<sup>1</sup>, Saikat DAS<sup>1</sup>, Tokuhisa KAWAWAKI<sup>1</sup>, Yuichi NEGISHI<sup>1,3</sup>"
    ],
    "lab": "1PF-24",
    "pdf": "pdf/1PF-24.pdf",
    "pre": "tn/1PF-24.jpg",
    "reg": "74333",
    "sea": "Cu",
    "ses": "1PF",
    "con": "1PF-24 チオラート保護銅ナノクラスターの連結構造体化と還元触媒への応用 (<sup>1</sup>東理大院・<sup>2</sup>東理大・<sup>3</sup>東北大多元研) ◎富岡 里菜<sup>1</sup>・酒井 仁<sup>1</sup>・大岩 一毅<sup>1</sup>・中谷 利毅<sup>1</sup>・近藤 歩<sup>2</sup>・新堀 佳紀<sup>1</sup>・Saikat DAS<sup>1</sup>・川脇 徳久<sup>1</sup>・根岸 雄一<sup>1,3</sup> Assembly of Thiolate-Protected Copper Nanoclusters and the application as reduction catalysts (<sup>1</sup>Graduate School of Science, Tokyo Univ. of Science, <sup>2</sup>Tokyo Univ. of Science, <sup>3</sup>IMRAM, Tohoku Univ.) ◎Rina TOMIOKA<sup>1</sup>, Jin SAKAI<sup>1</sup>, Kazutaka OIWA<sup>1</sup>, Riki NAKATANI<sup>1</sup>, Ayumu KONDO<sup>2</sup>, Yoshiki NIIHORI<sup>1</sup>, Saikat DAS<sup>1</sup>, Tokuhisa KAWAWAKI<sup>1</sup>, Yuichi NEGISHI<sup>1,3</sup> Cu"
  },
  {
    "inf": [
      "光化学的CO<sub>2</sub> 還元触媒を目指した金属ポルフィリンダイマーの合成と性質",
      "(<sup>1</sup>岡山理大理・<sup>2</sup>岡山理大院理・<sup>3</sup>阪公大院工・<sup>4</sup>阪公大人工光合成セ) 坪田 悠希<sup>1</sup>・浦本 大成<sup>2</sup>・〇田中 曹<sup>1</sup>・中村 真輔<sup>3</sup>・中薗 孝志<sup>4</sup>・山田 裕介<sup>3,4</sup>・満身 稔<sup>1</sup>",
      "Synthesis and properties of metal porphyrin dimers for photochemical catalytic reduction of CO<sub>2</sub>",
      "(<sup>1</sup>Fac. of Sci., Okayama Univ. of Sci., <sup>2</sup>Grad. Sch. of Sci., Okayama Univ. of Sci., <sup>3</sup>Grad. Sch. of Eng., Osaka Metropolitan Univ., <sup>4</sup>ReCAP, Osaka Metropolitan Univ.) Yuuki TUBOTA<sup>1</sup>, Taisei URAMOTO<sup>2</sup>, 〇Tsukasa TANAKA<sup>1</sup>, Shinsuke NAKAMURA<sup>3</sup>, Takashi NAKAZONO<sup>4</sup>, Yusuke YAMADA<sup>3,4</sup>, Minoru MITSUMI<sup>1</sup>"
    ],
    "lab": "1PF-25",
    "pdf": "pdf/1PF-25.pdf",
    "pre": "tn/1PF-25.jpg",
    "reg": "74321",
    "sea": "Co, Fe, Zn",
    "ses": "1PF",
    "con": "1PF-25 光化学的CO<sub>2</sub> 還元触媒を目指した金属ポルフィリンダイマーの合成と性質 (<sup>1</sup>岡山理大理・<sup>2</sup>岡山理大院理・<sup>3</sup>阪公大院工・<sup>4</sup>阪公大人工光合成セ) 坪田 悠希<sup>1</sup>・浦本 大成<sup>2</sup>・〇田中 曹<sup>1</sup>・中村 真輔<sup>3</sup>・中薗 孝志<sup>4</sup>・山田 裕介<sup>3,4</sup>・満身 稔<sup>1</sup> Synthesis and properties of metal porphyrin dimers for photochemical catalytic reduction of CO<sub>2</sub> (<sup>1</sup>Fac. of Sci., Okayama Univ. of Sci., <sup>2</sup>Grad. Sch. of Sci., Okayama Univ. of Sci., <sup>3</sup>Grad. Sch. of Eng., Osaka Metropolitan Univ., <sup>4</sup>ReCAP, Osaka Metropolitan Univ.) Yuuki TUBOTA<sup>1</sup>, Taisei URAMOTO<sup>2</sup>, 〇Tsukasa TANAKA<sup>1</sup>, Shinsuke NAKAMURA<sup>3</sup>, Takashi NAKAZONO<sup>4</sup>, Yusuke YAMADA<sup>3,4</sup>, Minoru MITSUMI<sup>1</sup> Co, Fe, Zn"
  },
  {
    "inf": [
      "結晶内分子回転によって発光強度を増幅できる大環状NHC銅(I)錯体",
      "(<sup>1</sup>北大院総化・<sup>2</sup>北大院工・<sup>3</sup>北大WPI-ICReDD) ◎富田 龍ノ介<sup>1</sup>・安藤 廉平<sup>1</sup>・伊藤 肇<sup>2,3</sup>・陳 旻究<sup>3</sup>",
      "Molecular rotation-induced emission enhancement of NHC Cu(I) macrocyclic complex in crystalline media",
      "(<sup>1</sup>Graduate School of Chemical Sciences and Engineering, Hokkaido University, <sup>2</sup>Graduate School of Engineering, Hokkaido University, <sup>3</sup>WPI-ICReDD, Hokkaido University) ◎Ryunosuke TOMITA<sup>1</sup>, Rempei ANDO<sup>1</sup>, Hajime ITO<sup>2,3</sup>, Mingoo JIN<sup>3</sup>"
    ],
    "lab": "1PF-26",
    "pdf": "pdf/1PF-26.pdf",
    "pre": "tn/1PF-26.jpg",
    "reg": "74346",
    "sea": "Cu",
    "ses": "1PF",
    "con": "1PF-26 結晶内分子回転によって発光強度を増幅できる大環状NHC銅(I)錯体 (<sup>1</sup>北大院総化・<sup>2</sup>北大院工・<sup>3</sup>北大WPI-ICReDD) ◎富田 龍ノ介<sup>1</sup>・安藤 廉平<sup>1</sup>・伊藤 肇<sup>2,3</sup>・陳 旻究<sup>3</sup> Molecular rotation-induced emission enhancement of NHC Cu(I) macrocyclic complex in crystalline media (<sup>1</sup>Graduate School of Chemical Sciences and Engineering, Hokkaido University, <sup>2</sup>Graduate School of Engineering, Hokkaido University, <sup>3</sup>WPI-ICReDD, Hokkaido University) ◎Ryunosuke TOMITA<sup>1</sup>, Rempei ANDO<sup>1</sup>, Hajime ITO<sup>2,3</sup>, Mingoo JIN<sup>3</sup> Cu"
  },
  {
    "inf": [
      "金属–有機構造体のガラス化挙動と誘電特性",
      "(<sup>1</sup>京大院理・<sup>2</sup>京大院工) ◎井上悠人<sup>1</sup>・西口大智<sup>2</sup>・堀毛悟史<sup>1</sup>",
      "Vitrification behavior and dielectric properties of metal–organic frameworks",
      "(<sup>1</sup>Graduate School of Science, Kyoto University, <sup>2</sup>Graduate School of Engineering, Kyoto University) ◎Haruto Inoue<sup>1</sup>, Taichi Nishiguchi<sup>2</sup>, Satoshi Horike<sup>1</sup>"
    ],
    "lab": "1PF-27",
    "pdf": "pdf/1PF-27.pdf",
    "pre": "tn/1PF-27.jpg",
    "reg": "74387",
    "sea": "Li, K",
    "ses": "1PF",
    "con": "1PF-27 金属–有機構造体のガラス化挙動と誘電特性 (<sup>1</sup>京大院理・<sup>2</sup>京大院工) ◎井上悠人<sup>1</sup>・西口大智<sup>2</sup>・堀毛悟史<sup>1</sup> Vitrification behavior and dielectric properties of metal–organic frameworks (<sup>1</sup>Graduate School of Science, Kyoto University, <sup>2</sup>Graduate School of Engineering, Kyoto University) ◎Haruto Inoue<sup>1</sup>, Taichi Nishiguchi<sup>2</sup>, Satoshi Horike<sup>1</sup> Li, K"
  },
  {
    "inf": [
      "ホスフィン配位金クラスターによる光誘起型アンモニアボラン分解反応の解析          ",
      "(<sup>1</sup>北大院環境・<sup>2</sup>北大地球環境・<sup>3</sup>北大触媒研) 〇厳 韶璟<sup>1</sup>・中島 朋隆<sup>1</sup>・七分 勇勝<sup>1,2</sup>・大須賀 遼太<sup>3</sup>・中島 清隆<sup>3</sup>・小西 克明<sup>1,2</sup>",
      "Photo-induced Dehydrogenation of Ammonia Borane by Phosphine-ligated          gold clusters.",
      "(<sup>1</sup>Grad. Sch. of Env. Sci., Hokkaido Univ.,, <sup>2</sup>Fac. of Env. Earth Sci., Hokkaido Univ.,, <sup>3</sup>Ins. for Cat., Hokkaido Univ., ) 〇Shaojing YAN<sup>1</sup>, Tomotaka Nakajima<sup>1</sup>, Yukatsu Shichibu<sup>1,2</sup>, Ryota Osuka<sup>3</sup>, Kiyotaka Nakajima<sup>3</sup>, Katsuaki Konishi<sup>1,2</sup>"
    ],
    "lab": "1PF-28",
    "pdf": "pdf/1PF-28.pdf",
    "pre": "tn/1PF-28.jpg",
    "reg": "74412",
    "sea": "Au",
    "ses": "1PF",
    "con": "1PF-28 ホスフィン配位金クラスターによる光誘起型アンモニアボラン分解反応の解析           (<sup>1</sup>北大院環境・<sup>2</sup>北大地球環境・<sup>3</sup>北大触媒研) 〇厳 韶璟<sup>1</sup>・中島 朋隆<sup>1</sup>・七分 勇勝<sup>1,2</sup>・大須賀 遼太<sup>3</sup>・中島 清隆<sup>3</sup>・小西 克明<sup>1,2</sup> Photo-induced Dehydrogenation of Ammonia Borane by Phosphine-ligated          gold clusters. (<sup>1</sup>Grad. Sch. of Env. Sci., Hokkaido Univ.,, <sup>2</sup>Fac. of Env. Earth Sci., Hokkaido Univ.,, <sup>3</sup>Ins. for Cat., Hokkaido Univ., ) 〇Shaojing YAN<sup>1</sup>, Tomotaka Nakajima<sup>1</sup>, Yukatsu Shichibu<sup>1,2</sup>, Ryota Osuka<sup>3</sup>, Kiyotaka Nakajima<sup>3</sup>, Katsuaki Konishi<sup>1,2</sup> Au"
  },
  {
    "inf": [
      "長鎖アルキル基を導入した含硫黄二次元鉛半導体配位高分子の合成と相転移挙動の評価",
      "(<sup>1</sup>関学大理・<sup>2</sup>阪大院工) ◎高村駿也<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯昭紀<sup>2</sup>・田中大輔<sup>1</sup>",
      "Synthesis and Phase Transition of Two-Dimensional Lead(II) Coordination Polymers with Long Alkyl Chain",
      "(<sup>1</sup>Kwansei Gakuin University, <sup>2</sup>Osaka University) ◎Shunya TAKAMURA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "1PF-29",
    "pdf": "pdf/1PF-29.pdf",
    "pre": "tn/1PF-29.jpg",
    "reg": "74401",
    "sea": "Pb",
    "ses": "1PF",
    "con": "1PF-29 長鎖アルキル基を導入した含硫黄二次元鉛半導体配位高分子の合成と相転移挙動の評価 (<sup>1</sup>関学大理・<sup>2</sup>阪大院工) ◎高村駿也<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯昭紀<sup>2</sup>・田中大輔<sup>1</sup> Synthesis and Phase Transition of Two-Dimensional Lead(II) Coordination Polymers with Long Alkyl Chain (<sup>1</sup>Kwansei Gakuin University, <sup>2</sup>Osaka University) ◎Shunya TAKAMURA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Daisuke TANAKA<sup>1</sup> Pb"
  },
  {
    "inf": [
      "電子貯蔵部位を修飾した新規白金錯体の合成と光水素生成触媒機能評価",
      "(<sup>1</sup>九大理化) 〇井上 眞子<sup>1</sup>・國久保 透真<sup>1</sup>・山内 幸正<sup>1</sup>・酒井 健<sup>1</sup>",
      "Synthesis and Photocatalytic Properties ofa New Pt(II)-Based complex Tethered to Electron Reservoir Moieties",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Mako INOUE<sup>1</sup>, Toma KUNIKUBO<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "1PF-30",
    "pdf": "pdf/1PF-30.pdf",
    "pre": "tn/1PF-30.jpg",
    "reg": "74498",
    "sea": "Pt",
    "ses": "1PF",
    "con": "1PF-30 電子貯蔵部位を修飾した新規白金錯体の合成と光水素生成触媒機能評価 (<sup>1</sup>九大理化) 〇井上 眞子<sup>1</sup>・國久保 透真<sup>1</sup>・山内 幸正<sup>1</sup>・酒井 健<sup>1</sup> Synthesis and Photocatalytic Properties ofa New Pt(II)-Based complex Tethered to Electron Reservoir Moieties (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Mako INOUE<sup>1</sup>, Toma KUNIKUBO<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Pt"
  },
  {
    "inf": [
      "銅(I)錯体をクロモフォアとした可視光感光性光酸発生剤の開発",
      "(<sup>1</sup>阪公大院工) ◎井上 優希<sup>1</sup>・小玉 晋太朗<sup>1</sup>・鈴木 直弥<sup>1</sup>・前田 壮志<sup>1</sup>・八木 繁幸<sup>1</sup>",
      "Development of Visible-Light-Sensitive Photoacid Generators Using Copper(I) Complexes as Chromophores",
      "(<sup>1</sup>Osaka Metropolitan Univ.) ◎Yuki Inoue<sup>1</sup>, Shintaro Kodama<sup>1</sup>, Naoya Suzuki<sup>1</sup>, Takeshi Maeda<sup>1</sup>, Shigeyuki Yagi<sup>1</sup>"
    ],
    "lab": "1PF-31",
    "pdf": "pdf/1PF-31.pdf",
    "pre": "tn/1PF-31.jpg",
    "reg": "74420",
    "sea": "Cu",
    "ses": "1PF",
    "con": "1PF-31 銅(I)錯体をクロモフォアとした可視光感光性光酸発生剤の開発 (<sup>1</sup>阪公大院工) ◎井上 優希<sup>1</sup>・小玉 晋太朗<sup>1</sup>・鈴木 直弥<sup>1</sup>・前田 壮志<sup>1</sup>・八木 繁幸<sup>1</sup> Development of Visible-Light-Sensitive Photoacid Generators Using Copper(I) Complexes as Chromophores (<sup>1</sup>Osaka Metropolitan Univ.) ◎Yuki Inoue<sup>1</sup>, Shintaro Kodama<sup>1</sup>, Naoya Suzuki<sup>1</sup>, Takeshi Maeda<sup>1</sup>, Shigeyuki Yagi<sup>1</sup> Cu"
  },
  {
    "inf": [
      "希土類錯体を用いた有機EL素子の作製および特性評価",
      "(<sup>1</sup>近大理工) ◎大川 新<sup>1</sup>・松井 久宜<sup>1</sup>・中井 英隆<sup>1</sup>・鬼頭 宏任<sup>1</sup>・田中 仙君<sup>1</sup>・大久保 貴志<sup>1</sup>",
      "Fabrication and characterization of organic electroluminescence devices using rare earth complexes",
      "(<sup>1</sup>KINDAI Univ.) ◎Arata Okawa<sup>1</sup>, Hisaki Matsui<sup>1</sup>, Hidetaka Nakai<sup>1</sup>, Hirotaka Kitou<sup>1</sup>, Senku Tanaka<sup>1</sup>, Takashi Okubo<sup>1</sup>"
    ],
    "lab": "1PF-32",
    "pdf": "pdf/1PF-32.pdf",
    "pre": "tn/1PF-32.jpg",
    "reg": "74422",
    "sea": "Sm, Tb, Dy",
    "ses": "1PF",
    "con": "1PF-32 希土類錯体を用いた有機EL素子の作製および特性評価 (<sup>1</sup>近大理工) ◎大川 新<sup>1</sup>・松井 久宜<sup>1</sup>・中井 英隆<sup>1</sup>・鬼頭 宏任<sup>1</sup>・田中 仙君<sup>1</sup>・大久保 貴志<sup>1</sup> Fabrication and characterization of organic electroluminescence devices using rare earth complexes (<sup>1</sup>KINDAI Univ.) ◎Arata Okawa<sup>1</sup>, Hisaki Matsui<sup>1</sup>, Hidetaka Nakai<sup>1</sup>, Hirotaka Kitou<sup>1</sup>, Senku Tanaka<sup>1</sup>, Takashi Okubo<sup>1</sup> Sm, Tb, Dy"
  },
  {
    "inf": [
      "トリス(オキサゾリニル)ボレート配位子を用いた固定化鉄錯体触媒の開発",
      "(<sup>1</sup>神奈川大工) 〇川口 直輝<sup>1</sup>・矢田 夏希<sup>1</sup>・藤田 彩音<sup>1</sup>・高村 宏輔<sup>1</sup>・岡村 将也<sup>1</sup>・引地 史郎<sup>1</sup>",
      "Development of novel immobilized metal complex catalysts with a tris(oxazolinyl)borate ligand",
      "(<sup>1</sup>Kanagawa Univ.) 〇Naoki KAWAGUCH<sup>1</sup>, Nathuki YATA<sup>1</sup>, Ayane HUZITA<sup>1</sup>, Kosuke TAKAMURA<sup>1</sup>, Masaya OKAMURA<sup>1</sup>, Shiro HIKICHI<sup>1</sup>"
    ],
    "lab": "1PF-33",
    "pdf": "pdf/1PF-33.pdf",
    "pre": "tn/1PF-33.jpg",
    "reg": "74530",
    "sea": "Fe",
    "ses": "1PF",
    "con": "1PF-33 トリス(オキサゾリニル)ボレート配位子を用いた固定化鉄錯体触媒の開発 (<sup>1</sup>神奈川大工) 〇川口 直輝<sup>1</sup>・矢田 夏希<sup>1</sup>・藤田 彩音<sup>1</sup>・高村 宏輔<sup>1</sup>・岡村 将也<sup>1</sup>・引地 史郎<sup>1</sup> Development of novel immobilized metal complex catalysts with a tris(oxazolinyl)borate ligand (<sup>1</sup>Kanagawa Univ.) 〇Naoki KAWAGUCH<sup>1</sup>, Nathuki YATA<sup>1</sup>, Ayane HUZITA<sup>1</sup>, Kosuke TAKAMURA<sup>1</sup>, Masaya OKAMURA<sup>1</sup>, Shiro HIKICHI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "赤血球ゴーストの細胞骨格を利用した光水素生成システムの構築",
      "(<sup>1</sup>立命館大院生命科) ◎坂本 大芽<sup>1</sup>・越山 友美<sup>1</sup>",
      "Photocatalytic hydrogen evolution system using the cytoskeleton of red blood cell ghosts ",
      "(<sup>1</sup>Ritsumeikan Univ. Grad. Sch. Life Sci.) ◎Taiga SAKAMOTO<sup>1</sup>, Tomomi KOSHIYAMA<sup>1</sup>"
    ],
    "lab": "1PF-34",
    "pdf": "pdf/1PF-34.pdf",
    "pre": "tn/1PF-34.jpg",
    "reg": "74457",
    "sea": "Pt, Ru",
    "ses": "1PF",
    "con": "1PF-34 赤血球ゴーストの細胞骨格を利用した光水素生成システムの構築 (<sup>1</sup>立命館大院生命科) ◎坂本 大芽<sup>1</sup>・越山 友美<sup>1</sup> Photocatalytic hydrogen evolution system using the cytoskeleton of red blood cell ghosts  (<sup>1</sup>Ritsumeikan Univ. Grad. Sch. Life Sci.) ◎Taiga SAKAMOTO<sup>1</sup>, Tomomi KOSHIYAMA<sup>1</sup> Pt, Ru"
  },
  {
    "inf": [
      "金ナノクラスター触媒によるアミンの光酸化アルキニル化反応 : _in-situ_  配位子交換による活性種の発生",
      "(<sup>1</sup>京大化研・<sup>2</sup>京大院工) ◎井芹 建太<sup></sup>・中村 正治<sup></sup>・磯﨑 勝弘<sup></sup>",
      "Photooxidative Alkynylation of Amines Enabled by _in-situ_ Ligand Exchange of Gold Nanocluster Catalysts",
      "(<sup>1</sup>Institute for Chemical Research, Kyoto University, <sup>2</sup>Graduate School of Engineering, Kyoto University) ◎Kenta ISERI<sup></sup>, Masaharu NAKAMURA<sup></sup>, Katsuhiro ISOZAKI<sup></sup>"
    ],
    "lab": "1PF-35",
    "pdf": "pdf/1PF-35.pdf",
    "pre": "tn/1PF-35.jpg",
    "reg": "74469",
    "sea": "Au",
    "ses": "1PF",
    "con": "1PF-35 金ナノクラスター触媒によるアミンの光酸化アルキニル化反応 : _in-situ_  配位子交換による活性種の発生 (<sup>1</sup>京大化研・<sup>2</sup>京大院工) ◎井芹 建太<sup></sup>・中村 正治<sup></sup>・磯﨑 勝弘<sup></sup> Photooxidative Alkynylation of Amines Enabled by _in-situ_ Ligand Exchange of Gold Nanocluster Catalysts (<sup>1</sup>Institute for Chemical Research, Kyoto University, <sup>2</sup>Graduate School of Engineering, Kyoto University) ◎Kenta ISERI<sup></sup>, Masaharu NAKAMURA<sup></sup>, Katsuhiro ISOZAKI<sup></sup> Au"
  },
  {
    "inf": [
      "アルカリ光水素生成を駆動するCo-NHC錯体触媒の電子状態制御",
      "(<sup>1</sup>九大理化) 〇河村 佳央理<sup>1</sup>・山内 幸正<sup>1</sup>・酒井 健<sup>1</sup>",
      "Controlling the Electronic State of Co-NHC Catalysts Accelerating Photochemical Hydrogen Evolution from Alkaline Water",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Kaori KAWAMURA<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "1PF-36",
    "pdf": "pdf/1PF-36.pdf",
    "pre": "tn/1PF-36.jpg",
    "reg": "74260",
    "sea": "Co",
    "ses": "1PF",
    "con": "1PF-36 アルカリ光水素生成を駆動するCo-NHC錯体触媒の電子状態制御 (<sup>1</sup>九大理化) 〇河村 佳央理<sup>1</sup>・山内 幸正<sup>1</sup>・酒井 健<sup>1</sup> Controlling the Electronic State of Co-NHC Catalysts Accelerating Photochemical Hydrogen Evolution from Alkaline Water (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Kaori KAWAMURA<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Co"
  },
  {
    "inf": [
      "エチレングリコール鎖を導入した環状三核金(I)錯体の液晶性と発光挙動",
      "(<sup>1</sup>立命館大生命) ◎山岡 柊友<sup>1</sup>・松本 浩輔<sup>1</sup>・堤 治<sup>1</sup>",
      "Liquid Crystallinity and Luminescent Properties of Cyclic Trinuclear Gold(I) Complexes with Ethylene Glycol Chains",
      "(<sup>1</sup>Department of Applied Chemistry, Ritsumeikan Univ.) ◎Shusuke YAMAOKA<sup>1</sup>, Kohsuke MATSUMOTO<sup>1</sup>, Osamu TSUTSUMI<sup>1</sup>"
    ],
    "lab": "1PF-37",
    "pdf": "pdf/1PF-37.pdf",
    "pre": "tn/1PF-37.jpg",
    "reg": "74478",
    "sea": "Au",
    "ses": "1PF",
    "con": "1PF-37 エチレングリコール鎖を導入した環状三核金(I)錯体の液晶性と発光挙動 (<sup>1</sup>立命館大生命) ◎山岡 柊友<sup>1</sup>・松本 浩輔<sup>1</sup>・堤 治<sup>1</sup> Liquid Crystallinity and Luminescent Properties of Cyclic Trinuclear Gold(I) Complexes with Ethylene Glycol Chains (<sup>1</sup>Department of Applied Chemistry, Ritsumeikan Univ.) ◎Shusuke YAMAOKA<sup>1</sup>, Kohsuke MATSUMOTO<sup>1</sup>, Osamu TSUTSUMI<sup>1</sup> Au"
  },
  {
    "inf": [
      "濃度依存型原子価互変異性化の発見とその駆動機構",
      "(<sup>1</sup>中大院理工・<sup>2</sup>中大理工) ◎古山 雄貴<sup>1</sup>・張 浩徹<sup>2</sup>",
      "Concentration-Dependent Valence Tautomerism Phenomena and Its Mechanism",
      "(<sup>1</sup>Graduate School of Science and Engineering, Chuo Univ., <sup>2</sup>Faculty of Science and Engineering, Chuo Univ. ) ◎Yuki KOYAMA<sup>1</sup>, Ho-Chol CHANG<sup>2</sup>"
    ],
    "lab": "1PF-38",
    "pdf": "pdf/1PF-38.pdf",
    "pre": "tn/1PF-38.jpg",
    "reg": "74549",
    "sea": "Co",
    "ses": "1PF",
    "con": "1PF-38 濃度依存型原子価互変異性化の発見とその駆動機構 (<sup>1</sup>中大院理工・<sup>2</sup>中大理工) ◎古山 雄貴<sup>1</sup>・張 浩徹<sup>2</sup> Concentration-Dependent Valence Tautomerism Phenomena and Its Mechanism (<sup>1</sup>Graduate School of Science and Engineering, Chuo Univ., <sup>2</sup>Faculty of Science and Engineering, Chuo Univ. ) ◎Yuki KOYAMA<sup>1</sup>, Ho-Chol CHANG<sup>2</sup> Co"
  },
  {
    "inf": [
      "キラル-N-ヘテロサイクリックカルベン配位子を修飾したセリア系複合酸化物触媒の調製",
      "(<sup>1</sup>名大院理・<sup>2</sup>名大物国セ) 〇西村 望巳<sup>1</sup>・Chaoqi CHEN<sup>1</sup>・池本 悟<sup>1</sup>・邨次 智<sup>1</sup>・唯 美津木<sup>1, 2</sup>",
      "Preparation of a Cr and Rh-incorporated ceria catalyst modified with chiral-N-heterocyclic carbene ligands",
      "(<sup>1</sup>Grad. Sch. Sci. Nagoya Univ., <sup>2</sup>RCMS. Nagoya Univ.) 〇Nozomi NISHIMURA<sup>1</sup>, Chaoqi CHEN<sup>1</sup>, Satoru IKEMOTO<sup>1</sup>, Satoshi MURATSUGU<sup>1</sup>, Mizuki TADA<sup>1, 2</sup>"
    ],
    "lab": "1PF-39",
    "pdf": "pdf/1PF-39.pdf",
    "pre": "tn/1PF-39.jpg",
    "reg": "74095",
    "sea": "Rh, Ce",
    "ses": "1PF",
    "con": "1PF-39 キラル-N-ヘテロサイクリックカルベン配位子を修飾したセリア系複合酸化物触媒の調製 (<sup>1</sup>名大院理・<sup>2</sup>名大物国セ) 〇西村 望巳<sup>1</sup>・Chaoqi CHEN<sup>1</sup>・池本 悟<sup>1</sup>・邨次 智<sup>1</sup>・唯 美津木<sup>1, 2</sup> Preparation of a Cr and Rh-incorporated ceria catalyst modified with chiral-N-heterocyclic carbene ligands (<sup>1</sup>Grad. Sch. Sci. Nagoya Univ., <sup>2</sup>RCMS. Nagoya Univ.) 〇Nozomi NISHIMURA<sup>1</sup>, Chaoqi CHEN<sup>1</sup>, Satoru IKEMOTO<sup>1</sup>, Satoshi MURATSUGU<sup>1</sup>, Mizuki TADA<sup>1, 2</sup> Rh, Ce"
  },
  {
    "inf": [
      "二重発光特性を示す四核亜鉛クラスターの開発:分子間ハロゲン相互作用により促進された効率的な燐光",
      "(<sup>1</sup>東理大理) ◎髙津 悠太<sup>1</sup>・小林 文也<sup>1</sup>・田所 誠<sup>1</sup>",
      "Dual Emission with Efficient Phosphorescence Promoted by Intermolecular Halogen-Interactions in Luminescent Tetranuclear Zinc(II) Clusters",
      "(<sup>1</sup>Tokyo Univ. of Sci.) ◎Yuta TAKATSU<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup>"
    ],
    "lab": "1PF-40",
    "pdf": "pdf/1PF-40.pdf",
    "pre": "tn/1PF-40.jpg",
    "reg": "74583",
    "sea": "Zn",
    "ses": "1PF",
    "con": "1PF-40 二重発光特性を示す四核亜鉛クラスターの開発:分子間ハロゲン相互作用により促進された効率的な燐光 (<sup>1</sup>東理大理) ◎髙津 悠太<sup>1</sup>・小林 文也<sup>1</sup>・田所 誠<sup>1</sup> Dual Emission with Efficient Phosphorescence Promoted by Intermolecular Halogen-Interactions in Luminescent Tetranuclear Zinc(II) Clusters (<sup>1</sup>Tokyo Univ. of Sci.) ◎Yuta TAKATSU<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup> Zn"
  },
  {
    "inf": [
      "銅ポルフィリン錯体の電解重合を用いた導電性を有するポリマー型CO<sub>2</sub>還元触媒の開発",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) ◎勝平 千里<sup>1</sup>・松﨑 拓実<sup>1</sup>・グー ジーラン<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup>",
      "Development of Polymer-type CO<sub>2</sub> Reduction Catalyst with Conductivity Using Electrochemical polymerization of Copper Porphyrin Complexes",
      "(<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>School of Science, Tokyo Institute of Technology) ◎Senri KATSUHIRA<sup>1</sup>, Takumi MATSUZAKI <sup>1</sup>, Zi Lang GOO<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "1PF-41",
    "pdf": "pdf/1PF-41.pdf",
    "pre": "tn/1PF-41.jpg",
    "reg": "74600",
    "sea": "Cu",
    "ses": "1PF",
    "con": "1PF-41 銅ポルフィリン錯体の電解重合を用いた導電性を有するポリマー型CO<sub>2</sub>還元触媒の開発 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) ◎勝平 千里<sup>1</sup>・松﨑 拓実<sup>1</sup>・グー ジーラン<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup> Development of Polymer-type CO<sub>2</sub> Reduction Catalyst with Conductivity Using Electrochemical polymerization of Copper Porphyrin Complexes (<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>School of Science, Tokyo Institute of Technology) ◎Senri KATSUHIRA<sup>1</sup>, Takumi MATSUZAKI <sup>1</sup>, Zi Lang GOO<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "Lewis-acid induced [2]-catenane formation from Pd<sub>4</sub>L<sub>8</sub> interlocked cages binding Cl<sup>–</sup> anions",
      "(<sup>1</sup>Univ. of Tokyo) 〇Tsukasa ABE<sup>1</sup>, Yutong ZHANG<sup>1</sup>, Shuichi HIRAOKA<sup>1</sup>"
    ],
    "lab": "3Aa-01",
    "pdf": "pdf/3Aa-01.pdf",
    "pre": "tn/3Aa-01.jpg",
    "reg": "74107",
    "sea": "Pd",
    "ses": "3Aa",
    "con": "3Aa-01 Lewis-acid induced [2]-catenane formation from Pd<sub>4</sub>L<sub>8</sub> interlocked cages binding Cl<sup>–</sup> anions (<sup>1</sup>Univ. of Tokyo) 〇Tsukasa ABE<sup>1</sup>, Yutong ZHANG<sup>1</sup>, Shuichi HIRAOKA<sup>1</sup> Pd"
  },
  {
    "inf": [
      "Propeller helicity of imidazole-based Tb complexes with hemiaminal-ether structure",
      "(<sup>1</sup>Toho Univ., <sup>2</sup>Tohoku Univ., <sup>3</sup>Osaka Univ.) 〇Chihiro Kachi-Terajima<sup>1</sup>, Shinnosuke Yokoyama<sup>1</sup>, Hirotaka Masuko<sup>1</sup>, Shinya Takaishi<sup>2</sup>, Yasutaka Kitagawa<sup>3</sup>"
    ],
    "lab": "3Aa-02",
    "pdf": "pdf/3Aa-02.pdf",
    "pre": "tn/3Aa-02.jpg",
    "reg": "74451",
    "sea": "Tb",
    "ses": "3Aa",
    "con": "3Aa-02 Propeller helicity of imidazole-based Tb complexes with hemiaminal-ether structure (<sup>1</sup>Toho Univ., <sup>2</sup>Tohoku Univ., <sup>3</sup>Osaka Univ.) 〇Chihiro Kachi-Terajima<sup>1</sup>, Shinnosuke Yokoyama<sup>1</sup>, Hirotaka Masuko<sup>1</sup>, Shinya Takaishi<sup>2</sup>, Yasutaka Kitagawa<sup>3</sup> Tb"
  },
  {
    "inf": [
      "Formation of chiral cyclic array of metal ions using flexible tripeptides and its stimulus-responsive property",
      "(<sup>1</sup>Ochanomizu University) 〇Ryosuke Miyake<sup>1</sup>, Aika Kanazawa<sup>1</sup>, Shoko Tanaka<sup>1</sup>"
    ],
    "lab": "3Aa-03",
    "pdf": "pdf/3Aa-03.pdf",
    "pre": "tn/3Aa-03.jpg",
    "reg": "74565",
    "sea": "Ni, Cu",
    "ses": "3Aa",
    "con": "3Aa-03 Formation of chiral cyclic array of metal ions using flexible tripeptides and its stimulus-responsive property (<sup>1</sup>Ochanomizu University) 〇Ryosuke Miyake<sup>1</sup>, Aika Kanazawa<sup>1</sup>, Shoko Tanaka<sup>1</sup> Ni, Cu"
  },
  {
    "inf": [
      "ホスホン酸ピリジンアームを持つ N<sub>2</sub>O<sub>2</sub> 及び N<sub>4</sub> 型12員環配位子とランタノイドとの反応性",
      "(<sup>1</sup>阪大院理・<sup>2</sup>阪大コアファシリティ機構・<sup>3</sup>関西大院理・<sup>4</sup>阪大放射線機構) 〇浜崎 健太<sup>1</sup>・馬場 一彰<sup>1</sup>・永田 光知郎<sup>2</sup>・矢島 辰雄<sup>3</sup>・吉村 崇<sup>4</sup>",
      "Reaction of Lanthanides with the Twelve-Membered N<sub>2</sub>O<sub>2</sub> and N<sub>4</sub> Macrocyclic Ligands Having Phosphonic Pyridine Arms",
      "(<sup>1</sup>Graduate School of Science, Osaka Univ., <sup>2</sup>Core Facility Center, Osaka Univ., <sup>3</sup>Graduate School of Science and Engineering, Kansai Univ., <sup>4</sup>Institute for Radiation Sciences, Osaka Univ.) 〇Kenta HAMASAKI<sup>1</sup>, Kazuaki BABA<sup>1</sup>, Kojiro NAGATA<sup>2</sup>, Tatsuo YAJIMA<sup>3</sup>, Takashi YOSHIMURA<sup>4</sup>"
    ],
    "lab": "3Aa-04",
    "pdf": "pdf/3Aa-04.pdf",
    "pre": "tn/3Aa-04.jpg",
    "reg": "74360",
    "sea": "La, Ce, Pr, Nd, Sm, Eu, Gd, Tb, Dy, Ho, Er, Tm, Yb, Lu",
    "ses": "3Aa",
    "con": "3Aa-04 ホスホン酸ピリジンアームを持つ N<sub>2</sub>O<sub>2</sub> 及び N<sub>4</sub> 型12員環配位子とランタノイドとの反応性 (<sup>1</sup>阪大院理・<sup>2</sup>阪大コアファシリティ機構・<sup>3</sup>関西大院理・<sup>4</sup>阪大放射線機構) 〇浜崎 健太<sup>1</sup>・馬場 一彰<sup>1</sup>・永田 光知郎<sup>2</sup>・矢島 辰雄<sup>3</sup>・吉村 崇<sup>4</sup> Reaction of Lanthanides with the Twelve-Membered N<sub>2</sub>O<sub>2</sub> and N<sub>4</sub> Macrocyclic Ligands Having Phosphonic Pyridine Arms (<sup>1</sup>Graduate School of Science, Osaka Univ., <sup>2</sup>Core Facility Center, Osaka Univ., <sup>3</sup>Graduate School of Science and Engineering, Kansai Univ., <sup>4</sup>Institute for Radiation Sciences, Osaka Univ.) 〇Kenta HAMASAKI<sup>1</sup>, Kazuaki BABA<sup>1</sup>, Kojiro NAGATA<sup>2</sup>, Tatsuo YAJIMA<sup>3</sup>, Takashi YOSHIMURA<sup>4</sup> La, Ce, Pr, Nd, Sm, Eu, Gd, Tb, Dy, Ho, Er, Tm, Yb, Lu"
  },
  {
    "inf": [
      "Synthesis and characterization of an organic-inorganic hybrid hexa-vacant lacunary polyoxometalates",
      "(<sup>1</sup>Hiroshima University, Graduate School of Advanced Science and Engineering) 〇Shumpei Take<sup>1</sup>, Takuo Minato<sup>1</sup>, Masahiro Sadakane<sup>1</sup>"
    ],
    "lab": "3Aa-05",
    "pdf": "pdf/3Aa-05.pdf",
    "pre": "tn/3Aa-05.jpg",
    "reg": "74578",
    "sea": "P,W",
    "ses": "3Aa",
    "con": "3Aa-05 Synthesis and characterization of an organic-inorganic hybrid hexa-vacant lacunary polyoxometalates (<sup>1</sup>Hiroshima University, Graduate School of Advanced Science and Engineering) 〇Shumpei Take<sup>1</sup>, Takuo Minato<sup>1</sup>, Masahiro Sadakane<sup>1</sup> P,W"
  },
  {
    "inf": [
      "Synthesis of a Gold–Silver Alloy Nanocluster within a Ring-Shaped Polyoxometalate and Its Photocatalytic Property",
      "(<sup>1</sup>The University of Tokyo, <sup>2</sup>Tokyo Metropolitan University) 〇Minori KAMACHI<sup>1</sup>, Kentaro YONESATO<sup>1</sup>, Takashi OKAZAKI<sup>1</sup>, Daiki YANAI<sup>1</sup>, Soichi KIKKAWA<sup>2</sup>, Seiji YAMAZOE<sup>2</sup>, Ryo ISHIKAWA<sup>1</sup>, Naoya SHIBATA<sup>1</sup>, Yuichi IKUHARA<sup>1</sup>, Kosuke SUZUKI<sup>1</sup>, Kazuya YAMAGUCHI<sup>1</sup>"
    ],
    "lab": "3Aa-06",
    "pdf": "pdf/3Aa-06.pdf",
    "pre": "tn/3Aa-06.jpg",
    "reg": "74017",
    "sea": "W, Ag, Au",
    "ses": "3Aa",
    "con": "3Aa-06 Synthesis of a Gold–Silver Alloy Nanocluster within a Ring-Shaped Polyoxometalate and Its Photocatalytic Property (<sup>1</sup>The University of Tokyo, <sup>2</sup>Tokyo Metropolitan University) 〇Minori KAMACHI<sup>1</sup>, Kentaro YONESATO<sup>1</sup>, Takashi OKAZAKI<sup>1</sup>, Daiki YANAI<sup>1</sup>, Soichi KIKKAWA<sup>2</sup>, Seiji YAMAZOE<sup>2</sup>, Ryo ISHIKAWA<sup>1</sup>, Naoya SHIBATA<sup>1</sup>, Yuichi IKUHARA<sup>1</sup>, Kosuke SUZUKI<sup>1</sup>, Kazuya YAMAGUCHI<sup>1</sup> W, Ag, Au"
  },
  {
    "inf": [
      "パラジウムおよび白金を含むケギン型ポリオキソタングステートを助触媒とした可視光照射下での水からの水素生成",
      "(<sup>1</sup>静大院理) 〇平 智輝<sup>1</sup>・石垣 秋斗<sup>1</sup>・嵩井 陵太<sup>1</sup>・加藤 知香<sup>1</sup>",
      "Hydrogen production from water under visible-light irradiation using palladium and platinum-containing Keggin-type polyoxotungstate as a cocatalysts ",
      "(<sup>1</sup>Shizuoka Univ.) 〇Tomoki TAIRA<sup>1</sup>, Syuto ISHIGAKI<sup>1</sup>, Ryota KASAI<sup>1</sup>, Chika KATO<sup>1</sup>"
    ],
    "lab": "3Aa-07",
    "pdf": "pdf/3Aa-07.pdf",
    "pre": "tn/3Aa-07.jpg",
    "reg": "74122",
    "sea": "W, Pt, Pd",
    "ses": "3Aa",
    "con": "3Aa-07 パラジウムおよび白金を含むケギン型ポリオキソタングステートを助触媒とした可視光照射下での水からの水素生成 (<sup>1</sup>静大院理) 〇平 智輝<sup>1</sup>・石垣 秋斗<sup>1</sup>・嵩井 陵太<sup>1</sup>・加藤 知香<sup>1</sup> Hydrogen production from water under visible-light irradiation using palladium and platinum-containing Keggin-type polyoxotungstate as a cocatalysts  (<sup>1</sup>Shizuoka Univ.) 〇Tomoki TAIRA<sup>1</sup>, Syuto ISHIGAKI<sup>1</sup>, Ryota KASAI<sup>1</sup>, Chika KATO<sup>1</sup> W, Pt, Pd"
  },
  {
    "inf": [
      "ナフタレン型配列を持つ十核銅クラスターの合成および性質",
      "(<sup>1</sup>東北大院理) 〇関 優月<sup>1</sup>・小室 貴士<sup>1</sup>・橋本 久子<sup>1</sup>",
      "Decacopper Cluster with a \"Naphthalene-like\" Arrangement: Synthesis and Properties",
      "(<sup>1</sup>Tohoku Univ.) 〇Yuzuki SEKI<sup>1</sup>, Takashi KOMURO<sup>1</sup>, Hisako HASHIMOTO<sup>1</sup>"
    ],
    "lab": "3Aa-09",
    "pdf": "pdf/3Aa-09.pdf",
    "pre": "tn/3Aa-09.jpg",
    "reg": "74081",
    "sea": "Cu",
    "ses": "3Aa",
    "con": "3Aa-09 ナフタレン型配列を持つ十核銅クラスターの合成および性質 (<sup>1</sup>東北大院理) 〇関 優月<sup>1</sup>・小室 貴士<sup>1</sup>・橋本 久子<sup>1</sup> Decacopper Cluster with a \"Naphthalene-like\" Arrangement: Synthesis and Properties (<sup>1</sup>Tohoku Univ.) 〇Yuzuki SEKI<sup>1</sup>, Takashi KOMURO<sup>1</sup>, Hisako HASHIMOTO<sup>1</sup> Cu"
  },
  {
    "inf": [
      "Syntheses and Structure of Silver nanoclusters with mix ligands of thiourea and _tert_-butylthiolate",
      "(<sup>1</sup>Faculty of Science and Engineering, Kindai University, <sup>2</sup>Research Institute of Science and Technology, Kindai University) 〇Zi Lang GOO<sup>1</sup>, Fumitaka TAKEIRI<sup>1</sup>, Masahiko MAEKAWA<sup>2</sup>, Takayoshi KURODA-SOWA<sup>1</sup>, Kunihisa SUGIMOTO<sup>1</sup>"
    ],
    "lab": "3Aa-10",
    "pdf": "pdf/3Aa-10.pdf",
    "pre": "tn/3Aa-10.jpg",
    "reg": "74186",
    "sea": "Ag",
    "ses": "3Aa",
    "con": "3Aa-10 Syntheses and Structure of Silver nanoclusters with mix ligands of thiourea and _tert_-butylthiolate (<sup>1</sup>Faculty of Science and Engineering, Kindai University, <sup>2</sup>Research Institute of Science and Technology, Kindai University) 〇Zi Lang GOO<sup>1</sup>, Fumitaka TAKEIRI<sup>1</sup>, Masahiko MAEKAWA<sup>2</sup>, Takayoshi KURODA-SOWA<sup>1</sup>, Kunihisa SUGIMOTO<sup>1</sup> Ag"
  },
  {
    "inf": [
      "Synthesis of Lacunary Polyoxomolybdates in Organic Solvents",
      "(<sup>1</sup>School of Engineering, The University of Tokyo) 〇Atsuhiro Jimbo<sup>1</sup>, Chifeng Li<sup>1</sup>, Kentaro Yonesato<sup>1</sup>, Kosuke Suzuki<sup>1</sup>, Kazuya Yamaguchi<sup>1</sup>"
    ],
    "lab": "3Aa-11",
    "pdf": "pdf/3Aa-11.pdf",
    "pre": "tn/3Aa-11.jpg",
    "reg": "74255",
    "sea": "Mo",
    "ses": "3Aa",
    "con": "3Aa-11 Synthesis of Lacunary Polyoxomolybdates in Organic Solvents (<sup>1</sup>School of Engineering, The University of Tokyo) 〇Atsuhiro Jimbo<sup>1</sup>, Chifeng Li<sup>1</sup>, Kentaro Yonesato<sup>1</sup>, Kosuke Suzuki<sup>1</sup>, Kazuya Yamaguchi<sup>1</sup> Mo"
  },
  {
    "inf": [
      "Water sorption and proton conductivity of porous crystals formed by cyclic polyoxometalate",
      "(<sup>1</sup>Wakayama Univ., <sup>2</sup>Tokyo Univ.) 〇Yuu YAMAZAKI<sup>1</sup>, Masato HASHIMOTO<sup>1</sup>, Tsukasa IWANO<sup>2</sup>, Naoki OGIWARA<sup>2</sup>, Sayaka UCHIDA<sup>2</sup>"
    ],
    "lab": "3Aa-12",
    "pdf": "pdf/3Aa-12.pdf",
    "pre": "tn/3Aa-12.jpg",
    "reg": "74520",
    "sea": "W",
    "ses": "3Aa",
    "con": "3Aa-12 Water sorption and proton conductivity of porous crystals formed by cyclic polyoxometalate (<sup>1</sup>Wakayama Univ., <sup>2</sup>Tokyo Univ.) 〇Yuu YAMAZAKI<sup>1</sup>, Masato HASHIMOTO<sup>1</sup>, Tsukasa IWANO<sup>2</sup>, Naoki OGIWARA<sup>2</sup>, Sayaka UCHIDA<sup>2</sup> W"
  },
  {
    "inf": [
      "ビピリジンの配位したRu4核ポリオキソメタレートの合成とπ-π相互作用を利用した3次元ネットワーク構造",
      "(<sup>1</sup>広島大・<sup>2</sup>Constructor University Bremen) 〇山西 瑛斗<sup>1</sup>・Sugiarto<sup>1</sup>・定金 正洋<sup>1</sup>・Anusree Sundar<sup>2</sup>・Ulrich Kortz<sup>2</sup>",
      "Preparation of 3D network structure of [{Ru<sub>4</sub>O<sub>4</sub>(OH)<sub>2</sub>(H<sub>2</sub>O)<sub>4</sub>}(γ-SiW<sub>10</sub>O<sub>36</sub>)<sub>2</sub>] connected by pi-pi interacation",
      "(<sup>1</sup>Hiroshima University, <sup>2</sup>Constructor University Bremen) 〇Eito Yamanishi<sup>1</sup>, Sugiarto<sup>1</sup>, Masahiro Sadakane<sup>1</sup>, Anusree Sundar<sup>2</sup>, Ulrich Kortz<sup>2</sup>"
    ],
    "lab": "3Aa-13",
    "pdf": "pdf/3Aa-13.pdf",
    "pre": "tn/3Aa-13.jpg",
    "reg": "74562",
    "sea": "W,Si,Ru",
    "ses": "3Aa",
    "con": "3Aa-13 ビピリジンの配位したRu4核ポリオキソメタレートの合成とπ-π相互作用を利用した3次元ネットワーク構造 (<sup>1</sup>広島大・<sup>2</sup>Constructor University Bremen) 〇山西 瑛斗<sup>1</sup>・Sugiarto<sup>1</sup>・定金 正洋<sup>1</sup>・Anusree Sundar<sup>2</sup>・Ulrich Kortz<sup>2</sup> Preparation of 3D network structure of [{Ru<sub>4</sub>O<sub>4</sub>(OH)<sub>2</sub>(H<sub>2</sub>O)<sub>4</sub>}(γ-SiW<sub>10</sub>O<sub>36</sub>)<sub>2</sub>] connected by pi-pi interacation (<sup>1</sup>Hiroshima University, <sup>2</sup>Constructor University Bremen) 〇Eito Yamanishi<sup>1</sup>, Sugiarto<sup>1</sup>, Masahiro Sadakane<sup>1</sup>, Anusree Sundar<sup>2</sup>, Ulrich Kortz<sup>2</sup> W,Si,Ru"
  },
  {
    "inf": [
      "Trimethylammonium Polyoxomolybdates formed from Trimethylammonium Monomolybdate to Molybdenum Oxide by Solid-State Heating and Acid addition in aqueous solution",
      "(<sup>1</sup>Hiroshima Univ.) 〇Rie ISHIDA<sup>1</sup>, Ndaru Candra Sukmana <sup>1</sup>, Sugiarto<sup>1</sup>, Takuo MINATO<sup>1</sup>, Masahiro SADAKANE<sup>1</sup>"
    ],
    "lab": "3Aa-14",
    "pdf": "pdf/3Aa-14.pdf",
    "pre": "tn/3Aa-14.jpg",
    "reg": "74584",
    "sea": "Mo",
    "ses": "3Aa",
    "con": "3Aa-14 Trimethylammonium Polyoxomolybdates formed from Trimethylammonium Monomolybdate to Molybdenum Oxide by Solid-State Heating and Acid addition in aqueous solution (<sup>1</sup>Hiroshima Univ.) 〇Rie ISHIDA<sup>1</sup>, Ndaru Candra Sukmana <sup>1</sup>, Sugiarto<sup>1</sup>, Takuo MINATO<sup>1</sup>, Masahiro SADAKANE<sup>1</sup> Mo"
  },
  {
    "inf": [
      "コバルト十三核構造を有するポリオキソバナデートの合成と触媒特性",
      "(<sup>1</sup>金沢大院自然・<sup>2</sup>金沢大国際基幹教育院) 〇吉田 一心<sup>1</sup>・菊川 雄司<sup>1</sup>・三橋 了爾<sup>2</sup>・林 宜仁<sup>1</sup>",
      "Synthesis and catalytic property of a tridecacobalt-core containing polyoxovanadate",
      "(<sup>1</sup>Graduate school of Natural science, Kanazawa University, <sup>2</sup>Institute of Liberal Arts and Science, Kanazawa University) 〇Isshin Yoshida<sup>1</sup>, Yuji Kikukawa<sup>1</sup>, Ryoji Mitsuhashi<sup>2</sup>, Yoshihito Hayashi<sup>1</sup>"
    ],
    "lab": "3Aa-15",
    "pdf": "pdf/3Aa-15.pdf",
    "pre": "tn/3Aa-15.jpg",
    "reg": "74334",
    "sea": "Co, V",
    "ses": "3Aa",
    "con": "3Aa-15 コバルト十三核構造を有するポリオキソバナデートの合成と触媒特性 (<sup>1</sup>金沢大院自然・<sup>2</sup>金沢大国際基幹教育院) 〇吉田 一心<sup>1</sup>・菊川 雄司<sup>1</sup>・三橋 了爾<sup>2</sup>・林 宜仁<sup>1</sup> Synthesis and catalytic property of a tridecacobalt-core containing polyoxovanadate (<sup>1</sup>Graduate school of Natural science, Kanazawa University, <sup>2</sup>Institute of Liberal Arts and Science, Kanazawa University) 〇Isshin Yoshida<sup>1</sup>, Yuji Kikukawa<sup>1</sup>, Ryoji Mitsuhashi<sup>2</sup>, Yoshihito Hayashi<sup>1</sup> Co, V"
  },
  {
    "inf": [
      "ルテニウムチオラート錯体の合成と分子状酸素による光化学的二酸素化反応",
      "(<sup>1</sup>関大化学生命工学・<sup>2</sup>奈良先端大院・<sup>3</sup>九州大院理・<sup>4</sup>横浜市大院生命ナノ) 〇中井 美早紀<sup>1</sup>・高橋 鈴乃<sup>2</sup>・塘中 野乃花<sup>1</sup>・矢島 辰雄<sup>1</sup>・宮田 潔志<sup>3</sup>・山下 晃一<sup>4</sup>・石田 斉<sup>1</sup>",
      "Synthesis of ruthenium thiolate complex and photochemical dioxygenation reaction with molecular oxygen",
      "(<sup>1</sup>Kansai Univ., <sup>2</sup>NAIST, <sup>3</sup>Kyusyu Univ., <sup>4</sup>Yokohama City Univ.) 〇Misaki Nakai<sup>1</sup>, Suzuno TAKAHASHI<sup>2</sup>, Nonoka TOMONAKA<sup>1</sup>, Tatsuo YAJIMA<sup>1</sup>, Kiyoshi MIYATA<sup>3</sup>, Koichi YAMASHITA<sup>4</sup>, Hitoshi ISHIDA<sup>1</sup>"
    ],
    "lab": "3Ab-01",
    "pdf": "pdf/3Ab-01.pdf",
    "pre": "tn/3Ab-01.jpg",
    "reg": "74272",
    "sea": "Ru",
    "ses": "3Ab",
    "con": "3Ab-01 ルテニウムチオラート錯体の合成と分子状酸素による光化学的二酸素化反応 (<sup>1</sup>関大化学生命工学・<sup>2</sup>奈良先端大院・<sup>3</sup>九州大院理・<sup>4</sup>横浜市大院生命ナノ) 〇中井 美早紀<sup>1</sup>・高橋 鈴乃<sup>2</sup>・塘中 野乃花<sup>1</sup>・矢島 辰雄<sup>1</sup>・宮田 潔志<sup>3</sup>・山下 晃一<sup>4</sup>・石田 斉<sup>1</sup> Synthesis of ruthenium thiolate complex and photochemical dioxygenation reaction with molecular oxygen (<sup>1</sup>Kansai Univ., <sup>2</sup>NAIST, <sup>3</sup>Kyusyu Univ., <sup>4</sup>Yokohama City Univ.) 〇Misaki Nakai<sup>1</sup>, Suzuno TAKAHASHI<sup>2</sup>, Nonoka TOMONAKA<sup>1</sup>, Tatsuo YAJIMA<sup>1</sup>, Kiyoshi MIYATA<sup>3</sup>, Koichi YAMASHITA<sup>4</sup>, Hitoshi ISHIDA<sup>1</sup> Ru"
  },
  {
    "inf": [
      "_N_-ヘテロ環状カルベン(NHC)を配位子に有するRu<sup>IV</sup>-ヒドロキソ錯体による水溶液中での基質酸化反応",
      "(<sup>1</sup>筑波大院数物) 〇竹下 祥太朗<sup>1</sup>・石塚 智也<sup>1</sup>・永原 彩瑚<sup>1</sup>・小谷 弘明<sup>1</sup>・小島 隆彦<sup>1</sup>",
      "Substrate Oxidation by Ru<sup>IV</sup>-Hydroxo Complexes Having _N_-Heterocyclic Carbene (NHC) Ligands in aqueous solution",
      "(<sup>1</sup>Graduate School of Pure and Applied Sciences, University of Tsukuba) 〇Shotaro Takeshita<sup>1</sup>, Tomoya Ishizuka<sup>1</sup>, Ayako Nagahara<sup>1</sup>, Hiroaki Kotani<sup>1</sup>, Takahiko Kojima<sup>1</sup>"
    ],
    "lab": "3Ab-02",
    "pdf": "pdf/3Ab-02.pdf",
    "pre": "tn/3Ab-02.jpg",
    "reg": "74049",
    "sea": "Ru",
    "ses": "3Ab",
    "con": "3Ab-02 _N_-ヘテロ環状カルベン(NHC)を配位子に有するRu<sup>IV</sup>-ヒドロキソ錯体による水溶液中での基質酸化反応 (<sup>1</sup>筑波大院数物) 〇竹下 祥太朗<sup>1</sup>・石塚 智也<sup>1</sup>・永原 彩瑚<sup>1</sup>・小谷 弘明<sup>1</sup>・小島 隆彦<sup>1</sup> Substrate Oxidation by Ru<sup>IV</sup>-Hydroxo Complexes Having _N_-Heterocyclic Carbene (NHC) Ligands in aqueous solution (<sup>1</sup>Graduate School of Pure and Applied Sciences, University of Tsukuba) 〇Shotaro Takeshita<sup>1</sup>, Tomoya Ishizuka<sup>1</sup>, Ayako Nagahara<sup>1</sup>, Hiroaki Kotani<sup>1</sup>, Takahiko Kojima<sup>1</sup> Ru"
  },
  {
    "inf": [
      "Pyrazine-Bridged Dinuclear and Tetranuclear Ruthenium(II) Complexes",
      "(<sup>1</sup>Fac. of Sci. and Tech. Sophia Univ.) 〇Tomoyo Misawa-Suzuki<sup>1</sup>, Kaito Nakayama<sup>1</sup>, Hirotaka Nagao<sup>1</sup>"
    ],
    "lab": "3Ab-03",
    "pdf": "pdf/3Ab-03.pdf",
    "pre": "tn/3Ab-03.jpg",
    "reg": "74109",
    "sea": "Ru",
    "ses": "3Ab",
    "con": "3Ab-03 Pyrazine-Bridged Dinuclear and Tetranuclear Ruthenium(II) Complexes (<sup>1</sup>Fac. of Sci. and Tech. Sophia Univ.) 〇Tomoyo Misawa-Suzuki<sup>1</sup>, Kaito Nakayama<sup>1</sup>, Hirotaka Nagao<sup>1</sup> Ru"
  },
  {
    "inf": [
      "ホスフィン系配位子を導入した新規混合原子価ルテニウム三核錯体の合成と多段階酸化還元挙動",
      "(<sup>1</sup>兵庫県立大院理) 〇鎌田 知希<sup>1</sup>・森野 喬<sup>1</sup>・小澤 芳樹<sup>1</sup>・阿部 正明<sup>1</sup>",
      "Synthesis and multistep redox behavior of new mixed-valent triruthenium complexes coordinated by phosphine derivatives",
      "(<sup>1</sup>Graduate School of Science, University of Hyogo) 〇Tomoki KAMADA<sup>1</sup>, Takashi MORINO<sup>1</sup>, Yoshiki OZAWA<sup>1</sup>, Masaaki ABE<sup>1</sup>"
    ],
    "lab": "3Ab-04",
    "pdf": "pdf/3Ab-04.pdf",
    "pre": "tn/3Ab-04.jpg",
    "reg": "74373",
    "sea": "Ru",
    "ses": "3Ab",
    "con": "3Ab-04 ホスフィン系配位子を導入した新規混合原子価ルテニウム三核錯体の合成と多段階酸化還元挙動 (<sup>1</sup>兵庫県立大院理) 〇鎌田 知希<sup>1</sup>・森野 喬<sup>1</sup>・小澤 芳樹<sup>1</sup>・阿部 正明<sup>1</sup> Synthesis and multistep redox behavior of new mixed-valent triruthenium complexes coordinated by phosphine derivatives (<sup>1</sup>Graduate School of Science, University of Hyogo) 〇Tomoki KAMADA<sup>1</sup>, Takashi MORINO<sup>1</sup>, Yoshiki OZAWA<sup>1</sup>, Masaaki ABE<sup>1</sup> Ru"
  },
  {
    "inf": [
      "亜硫酸イオンの段階的還元および硫化水素の発生",
      "(<sup>1</sup>長大院工・<sup>2</sup>九大先導研・<sup>3</sup>京大福井セ) 〇山田 基貴<sup>1</sup>・有川 康弘<sup>1</sup>・鶴田 裕介<sup>2</sup>・中村 泰司<sup>3</sup>・尾本 賢一郎<sup>1</sup>・作田 絵里<sup>1</sup>・吉澤 一成<sup>3</sup>・馬越 啓介<sup>1</sup>",
      "Stepwise Reduction of Sulfite, Leading to Hydrogen Sulfide",
      "(<sup>1</sup>Graduate School of Engineering, Nagasaki University, <sup>2</sup>Institute for Materials and Engineering, Kyushu University, <sup>3</sup>Fukui Institute for Fundamental Chemistry, Kyoto University) 〇Motoki Yamada<sup>1</sup>, Yasuhiro Arikawa<sup>1</sup>, Yusuke Tsuruta<sup>2</sup>, Taiji Nakamura<sup>3</sup>, Kenichiro Omoto<sup>1</sup>, Eri Sakuda<sup>1</sup>, Kazunari Yoshizawa<sup>3</sup>, Keisuke Umakoshi<sup>1</sup>"
    ],
    "lab": "3Ab-05",
    "pdf": "pdf/3Ab-05.pdf",
    "pre": "tn/3Ab-05.jpg",
    "reg": "74085",
    "sea": "Ru",
    "ses": "3Ab",
    "con": "3Ab-05 亜硫酸イオンの段階的還元および硫化水素の発生 (<sup>1</sup>長大院工・<sup>2</sup>九大先導研・<sup>3</sup>京大福井セ) 〇山田 基貴<sup>1</sup>・有川 康弘<sup>1</sup>・鶴田 裕介<sup>2</sup>・中村 泰司<sup>3</sup>・尾本 賢一郎<sup>1</sup>・作田 絵里<sup>1</sup>・吉澤 一成<sup>3</sup>・馬越 啓介<sup>1</sup> Stepwise Reduction of Sulfite, Leading to Hydrogen Sulfide (<sup>1</sup>Graduate School of Engineering, Nagasaki University, <sup>2</sup>Institute for Materials and Engineering, Kyushu University, <sup>3</sup>Fukui Institute for Fundamental Chemistry, Kyoto University) 〇Motoki Yamada<sup>1</sup>, Yasuhiro Arikawa<sup>1</sup>, Yusuke Tsuruta<sup>2</sup>, Taiji Nakamura<sup>3</sup>, Kenichiro Omoto<sup>1</sup>, Eri Sakuda<sup>1</sup>, Kazunari Yoshizawa<sup>3</sup>, Keisuke Umakoshi<sup>1</sup> Ru"
  },
  {
    "inf": [
      "二核ルテニウム錯体を用いた一酸化窒素を発生させる亜硝酸イオン還元サイクルの開発",
      "(<sup>1</sup>長崎大院工) 〇吉田 真太朗<sup>1</sup>・有川 康弘<sup>1</sup>・尾本 賢一郎<sup>1</sup>・作田 絵里<sup>1</sup>・馬越 啓介<sup>1</sup>",
      "Development of Nitrite Reduction Cycle on a Dinuclear Ruthenium Complex Producing Nitric Oxide",
      "(<sup>1</sup>Graduate School of Engineering, Nagasaki University) 〇Shintaro Yoshida<sup>1</sup>, Yasuhiro Arikawa<sup>1</sup>, Kenichiro Omoto<sup>1</sup>, Eri Sakuda<sup>1</sup>, Keisuke Umakoshi<sup>1</sup>"
    ],
    "lab": "3Ab-06",
    "pdf": "pdf/3Ab-06.pdf",
    "pre": "tn/3Ab-06.jpg",
    "reg": "74131",
    "sea": "Ru, Co",
    "ses": "3Ab",
    "con": "3Ab-06 二核ルテニウム錯体を用いた一酸化窒素を発生させる亜硝酸イオン還元サイクルの開発 (<sup>1</sup>長崎大院工) 〇吉田 真太朗<sup>1</sup>・有川 康弘<sup>1</sup>・尾本 賢一郎<sup>1</sup>・作田 絵里<sup>1</sup>・馬越 啓介<sup>1</sup> Development of Nitrite Reduction Cycle on a Dinuclear Ruthenium Complex Producing Nitric Oxide (<sup>1</sup>Graduate School of Engineering, Nagasaki University) 〇Shintaro Yoshida<sup>1</sup>, Yasuhiro Arikawa<sup>1</sup>, Kenichiro Omoto<sup>1</sup>, Eri Sakuda<sup>1</sup>, Keisuke Umakoshi<sup>1</sup> Ru, Co"
  },
  {
    "inf": [
      "N3型配位子を有するCu(II)錯体の合成とN<sub>2</sub>O還元挙動",
      "(<sup>1</sup>名工大院工・<sup>2</sup>愛工大) 〇馬場 風花<sup>1</sup>・猪股 智彦<sup>1</sup>・増田 秀樹<sup>2</sup>・小澤 智宏<sup>1</sup>",
      "Synthesis and N<sub>2</sub>O reduction behavior using Cu(II) complex with an N3-type ligand",
      "(<sup>1</sup>Graduate School of Engineering, Nagoya Institute of Technology, <sup>2</sup>Aichi Institute of Technology) 〇Fuka BABA<sup>1</sup>, Tomohiko INOMATA<sup>1</sup>, Hideki MASUDA<sup>2</sup>, Tomohiro OZAWA<sup>1</sup>"
    ],
    "lab": "3Ab-09",
    "pdf": "pdf/3Ab-09.pdf",
    "pre": "tn/3Ab-09.jpg",
    "reg": "74445",
    "sea": "Cu",
    "ses": "3Ab",
    "con": "3Ab-09 N3型配位子を有するCu(II)錯体の合成とN<sub>2</sub>O還元挙動 (<sup>1</sup>名工大院工・<sup>2</sup>愛工大) 〇馬場 風花<sup>1</sup>・猪股 智彦<sup>1</sup>・増田 秀樹<sup>2</sup>・小澤 智宏<sup>1</sup> Synthesis and N<sub>2</sub>O reduction behavior using Cu(II) complex with an N3-type ligand (<sup>1</sup>Graduate School of Engineering, Nagoya Institute of Technology, <sup>2</sup>Aichi Institute of Technology) 〇Fuka BABA<sup>1</sup>, Tomohiko INOMATA<sup>1</sup>, Hideki MASUDA<sup>2</sup>, Tomohiro OZAWA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "Unusual platinum(III) valence state having the iodide-bridged three-center four-electron bonding",
      "(<sup>1</sup>Chitose Institute of Science and Technology, <sup>2</sup>Tohoku University) 〇Masanori Wakizaka<sup>1</sup>, Masahiro Yamashita<sup>2</sup>"
    ],
    "lab": "3Ab-10",
    "pdf": "pdf/3Ab-10.pdf",
    "pre": "tn/3Ab-10.jpg",
    "reg": "74004",
    "sea": "Pt",
    "ses": "3Ab",
    "con": "3Ab-10 Unusual platinum(III) valence state having the iodide-bridged three-center four-electron bonding (<sup>1</sup>Chitose Institute of Science and Technology, <sup>2</sup>Tohoku University) 〇Masanori Wakizaka<sup>1</sup>, Masahiro Yamashita<sup>2</sup> Pt"
  },
  {
    "inf": [
      "Tuning of Flexible Electronic States in Cyanide-bridged Metal Complexes through Chemical Modification",
      "(<sup>1</sup>Kumamoto Univ., <sup>2</sup>Osaka Univ.) 〇Yoshihiro Sekine<sup>1</sup>, Ren Inoue<sup>2</sup>, Yasutaka Kitagawa<sup>2</sup>, Shinya Hayami<sup>1</sup>"
    ],
    "lab": "3Ab-11",
    "pdf": "pdf/3Ab-11.pdf",
    "pre": "tn/3Ab-11.jpg",
    "reg": "74574",
    "sea": "Co, Fe",
    "ses": "3Ab",
    "con": "3Ab-11 Tuning of Flexible Electronic States in Cyanide-bridged Metal Complexes through Chemical Modification (<sup>1</sup>Kumamoto Univ., <sup>2</sup>Osaka Univ.) 〇Yoshihiro Sekine<sup>1</sup>, Ren Inoue<sup>2</sup>, Yasutaka Kitagawa<sup>2</sup>, Shinya Hayami<sup>1</sup> Co, Fe"
  },
  {
    "inf": [
      "Development of an Fe<sup>II</sup> Complex Exhibiting Intermolecular Proton Transfer Coupled Spin Transition",
      "(<sup>1</sup>Kyushu Univ., <sup>2</sup>Tohoku Univ.) 〇Tianchi Ji<sup>1</sup>, Takumi Nakanishi <sup>2</sup>, Shuqi Wu<sup>1</sup>, Shengqun Su<sup>1</sup>, Osamu Sato <sup>1</sup>"
    ],
    "lab": "3Ab-12",
    "pdf": "pdf/3Ab-12.pdf",
    "pre": "tn/3Ab-12.jpg",
    "reg": "74152",
    "sea": "Fe",
    "ses": "3Ab",
    "con": "3Ab-12 Development of an Fe<sup>II</sup> Complex Exhibiting Intermolecular Proton Transfer Coupled Spin Transition (<sup>1</sup>Kyushu Univ., <sup>2</sup>Tohoku Univ.) 〇Tianchi Ji<sup>1</sup>, Takumi Nakanishi <sup>2</sup>, Shuqi Wu<sup>1</sup>, Shengqun Su<sup>1</sup>, Osamu Sato <sup>1</sup> Fe"
  },
  {
    "inf": [
      "All-optical Control of Polarization Current Direction in a Polar Cyanide-Bridged Complex          ",
      "(<sup>1</sup>Kyushu Univ.) 〇Yubo Huang<sup></sup>, Shengqun Su<sup></sup>, Shuqi Wu<sup></sup>, Osamu Sato<sup></sup>"
    ],
    "lab": "3Ab-13",
    "pdf": "pdf/3Ab-13.pdf",
    "pre": "tn/3Ab-13.jpg",
    "reg": "74283",
    "sea": "Fe, Co",
    "ses": "3Ab",
    "con": "3Ab-13 All-optical Control of Polarization Current Direction in a Polar Cyanide-Bridged Complex           (<sup>1</sup>Kyushu Univ.) 〇Yubo Huang<sup></sup>, Shengqun Su<sup></sup>, Shuqi Wu<sup></sup>, Osamu Sato<sup></sup> Fe, Co"
  },
  {
    "inf": [
      "トリフルオロメチル基を有する新規基底三重項ビラジカル配位子の開発および希土類イオンを用いた単鎖磁石への応用",
      "(<sup>1</sup>電通大) 〇芳賀 凪斗<sup>1</sup>・石田 尚行<sup>1</sup>",
      "Synthesis of a New Ground Triplet Biradical Ligand Having a Trifluoromethyl Group and Application to Single-Chain Magnet with Rare-Earth Ions",
      "(<sup>1</sup>The University of Electro-Communications) 〇Nagito HAGA<sup>1</sup>, Takayuki ISHIDA<sup>1</sup>"
    ],
    "lab": "3Ab-14",
    "pdf": "pdf/3Ab-14.pdf",
    "pre": "tn/3Ab-14.jpg",
    "reg": "74205",
    "sea": "Gd",
    "ses": "3Ab",
    "con": "3Ab-14 トリフルオロメチル基を有する新規基底三重項ビラジカル配位子の開発および希土類イオンを用いた単鎖磁石への応用 (<sup>1</sup>電通大) 〇芳賀 凪斗<sup>1</sup>・石田 尚行<sup>1</sup> Synthesis of a New Ground Triplet Biradical Ligand Having a Trifluoromethyl Group and Application to Single-Chain Magnet with Rare-Earth Ions (<sup>1</sup>The University of Electro-Communications) 〇Nagito HAGA<sup>1</sup>, Takayuki ISHIDA<sup>1</sup> Gd"
  },
  {
    "inf": [
      "銅(II)やニッケル(II)のニトロキシド錯体における急峻なスピン転移のための配位子の提案",
      "(<sup>1</sup>電通大基盤理工) 〇三井 允嵩<sup>1</sup>・飯田 大智<sup>1</sup>・石田 尚行<sup>1</sup>",
      "Substituent effects of 3d-2p exchange coupling in copper(II) and nickel(II) nitroxide complexes and ligands proposed for abrupt spin transition ",
      "(<sup>1</sup>The University of Electro-Communications) 〇Masataka Mitsui<sup>1</sup>, Daichi Iida<sup>1</sup>, Takayuki Ishida<sup>1</sup>"
    ],
    "lab": "3Ab-15",
    "pdf": "pdf/3Ab-15.pdf",
    "pre": "tn/3Ab-15.jpg",
    "reg": "74378",
    "sea": "Cu, Ni",
    "ses": "3Ab",
    "con": "3Ab-15 銅(II)やニッケル(II)のニトロキシド錯体における急峻なスピン転移のための配位子の提案 (<sup>1</sup>電通大基盤理工) 〇三井 允嵩<sup>1</sup>・飯田 大智<sup>1</sup>・石田 尚行<sup>1</sup> Substituent effects of 3d-2p exchange coupling in copper(II) and nickel(II) nitroxide complexes and ligands proposed for abrupt spin transition  (<sup>1</sup>The University of Electro-Communications) 〇Masataka Mitsui<sup>1</sup>, Daichi Iida<sup>1</sup>, Takayuki Ishida<sup>1</sup> Cu, Ni"
  },
  {
    "inf": [
      "Flexible Crystals Developed with Organic-Inorganic Metal Halide Hybrids",
      "(<sup>1</sup>Kanagawa University) 〇Sotaro Kusumoto<sup>1</sup>, Yoshihiro Koide<sup>1</sup>"
    ],
    "lab": "3Ac-01",
    "pdf": "pdf/3Ac-01.pdf",
    "pre": "tn/3Ac-01.jpg",
    "reg": "74271",
    "sea": "Sn, Cu",
    "ses": "3Ac",
    "con": "3Ac-01 Flexible Crystals Developed with Organic-Inorganic Metal Halide Hybrids (<sup>1</sup>Kanagawa University) 〇Sotaro Kusumoto<sup>1</sup>, Yoshihiro Koide<sup>1</sup> Sn, Cu"
  },
  {
    "inf": [
      "Group 12 Metal Complexes of Enolate Derivatives of 2-Acylmethyl-4,4-dimethyl-2-oxazolines and Related Ligands",
      "(<sup>1</sup>Department of Chemistry & Biology,, <sup>2</sup>X-ray Crystallography Laboratory,) 〇Robert A. Gossage<sup>1</sup>, M. C. Hill<sup>1</sup>, A. J. Lough<sup>2</sup>"
    ],
    "lab": "3Ac-02",
    "pdf": "pdf/3Ac-02.pdf",
    "pre": "tn/3Ac-02.jpg",
    "reg": "74335",
    "sea": "Zn, Cd, Hg",
    "ses": "3Ac",
    "con": "3Ac-02 Group 12 Metal Complexes of Enolate Derivatives of 2-Acylmethyl-4,4-dimethyl-2-oxazolines and Related Ligands (<sup>1</sup>Department of Chemistry & Biology,, <sup>2</sup>X-ray Crystallography Laboratory,) 〇Robert A. Gossage<sup>1</sup>, M. C. Hill<sup>1</sup>, A. J. Lough<sup>2</sup> Zn, Cd, Hg"
  },
  {
    "inf": [
      "含硫黄一次元半導体配位高分子の合成および結晶構造変換挙動の評価",
      "(<sup>1</sup>関学大理・<sup>2</sup>阪大院工・<sup>3</sup>阪大蛋白研・<sup>4</sup>日本電子 YOKOGUSHI 協働研究所) 〇小倉 早織<sup>1</sup>・秋吉 亮平<sup>1</sup>・佐伯 昭紀<sup>2</sup>・中根 崇智<sup>3,4</sup>・川本 晃⼤<sup>3,4</sup>・栗栖 源嗣<sup>3,4</sup>・田中 大輔<sup>1</sup>",
      "Synthesis of Sulfur-Containing 1D Semiconductive Coordination Polymers and Elucidation of Their Structure Transformation Behavior",
      "(<sup>1</sup>Kwansei Gakuin Univ., <sup>2</sup>Osaka Univ., <sup>3</sup>Institute for Protein Research, Osaka Univ., <sup>4</sup>JEOL YOKOGUSHI Research Alliance Laboratories) 〇Saori OGURA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Takanori NAKANE<sup>3,4</sup>, Akihiro KAWAMOTO<sup>3,4</sup>, Genji KURISU<sup>3,4</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "3Ac-03",
    "pdf": "pdf/3Ac-03.pdf",
    "pre": "tn/3Ac-03.jpg",
    "reg": "74066",
    "sea": "Cd, Co, Zn",
    "ses": "3Ac",
    "con": "3Ac-03 含硫黄一次元半導体配位高分子の合成および結晶構造変換挙動の評価 (<sup>1</sup>関学大理・<sup>2</sup>阪大院工・<sup>3</sup>阪大蛋白研・<sup>4</sup>日本電子 YOKOGUSHI 協働研究所) 〇小倉 早織<sup>1</sup>・秋吉 亮平<sup>1</sup>・佐伯 昭紀<sup>2</sup>・中根 崇智<sup>3,4</sup>・川本 晃⼤<sup>3,4</sup>・栗栖 源嗣<sup>3,4</sup>・田中 大輔<sup>1</sup> Synthesis of Sulfur-Containing 1D Semiconductive Coordination Polymers and Elucidation of Their Structure Transformation Behavior (<sup>1</sup>Kwansei Gakuin Univ., <sup>2</sup>Osaka Univ., <sup>3</sup>Institute for Protein Research, Osaka Univ., <sup>4</sup>JEOL YOKOGUSHI Research Alliance Laboratories) 〇Saori OGURA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Takanori NAKANE<sup>3,4</sup>, Akihiro KAWAMOTO<sup>3,4</sup>, Genji KURISU<sup>3,4</sup>, Daisuke TANAKA<sup>1</sup> Cd, Co, Zn"
  },
  {
    "inf": [
      "Proton-electron Mixed-Conducting Cation Radical Salt Formed with Protonated Paddlewheel-type Pt-dimer Complexes",
      "(<sup>1</sup>Kyoto Univ.) 〇Penghao Wang<sup>1</sup>, Yukihiro Yoshida<sup>1</sup>, Soichiro Yasaka<sup>1</sup>, Mitsuhiko Maesato<sup>1</sup>, Hiroshi Kitagawa<sup>1</sup>"
    ],
    "lab": "3Ac-04",
    "pdf": "pdf/3Ac-04.pdf",
    "pre": "tn/3Ac-04.jpg",
    "reg": "74191",
    "sea": "Pt",
    "ses": "3Ac",
    "con": "3Ac-04 Proton-electron Mixed-Conducting Cation Radical Salt Formed with Protonated Paddlewheel-type Pt-dimer Complexes (<sup>1</sup>Kyoto Univ.) 〇Penghao Wang<sup>1</sup>, Yukihiro Yoshida<sup>1</sup>, Soichiro Yasaka<sup>1</sup>, Mitsuhiko Maesato<sup>1</sup>, Hiroshi Kitagawa<sup>1</sup> Pt"
  },
  {
    "inf": [
      "A melting three-dimensional copper cyanide",
      "(<sup>1</sup>Kyushu Univ.) 〇Yuudai IWAI<sup>1</sup>, Ryo OHTANI<sup>1</sup>, Masaaki OHBA<sup>1</sup>"
    ],
    "lab": "3Ac-05",
    "pdf": "pdf/3Ac-05.pdf",
    "pre": "tn/3Ac-05.jpg",
    "reg": "74053",
    "sea": "K, Cd, Cu",
    "ses": "3Ac",
    "con": "3Ac-05 A melting three-dimensional copper cyanide (<sup>1</sup>Kyushu Univ.) 〇Yuudai IWAI<sup>1</sup>, Ryo OHTANI<sup>1</sup>, Masaaki OHBA<sup>1</sup> K, Cd, Cu"
  },
  {
    "inf": [
      "A glassy membrane fabricated from an ionic liquid-like soft coordination polymer for gas separation",
      "(<sup>1</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Xin Zheng<sup>1</sup>, Shin-ichiro Noro<sup>1</sup>"
    ],
    "lab": "3Ac-06",
    "pdf": "pdf/3Ac-06.pdf",
    "pre": "tn/3Ac-06.jpg",
    "reg": "74533",
    "sea": "Zn",
    "ses": "3Ac",
    "con": "3Ac-06 A glassy membrane fabricated from an ionic liquid-like soft coordination polymer for gas separation (<sup>1</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Xin Zheng<sup>1</sup>, Shin-ichiro Noro<sup>1</sup> Zn"
  },
  {
    "inf": [
      "含硫黄一次元配位高分子ガラスの合成と半導体特性の評価",
      "(<sup>1</sup>関学院理・<sup>2</sup>阪大院工・<sup>3</sup>近大理工) 〇北野 奏葉<sup>1</sup>・秋吉 亮平<sup>1</sup>・佐伯 昭紀<sup>2</sup>・髙橋 直大<sup>3</sup>・大久保 貴志<sup>3</sup>・田中 大輔<sup>1</sup>",
      "Synthesis of Sulfur Containing 1D Coordination Polymer Glasses and Evaluation of Semiconductor Properties",
      "(<sup>1</sup>Kwansei Gakuin Univ., <sup>2</sup>Osaka Univ., <sup>3</sup>Kindai Univ.) 〇Kanaha KITANO<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Naohiro TAKAHASHI<sup>3</sup>, Takashi OKUBO<sup>3</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "3Ac-07",
    "pdf": "pdf/3Ac-07.pdf",
    "pre": "tn/3Ac-07.jpg",
    "reg": "74129",
    "sea": "Cu",
    "ses": "3Ac",
    "con": "3Ac-07 含硫黄一次元配位高分子ガラスの合成と半導体特性の評価 (<sup>1</sup>関学院理・<sup>2</sup>阪大院工・<sup>3</sup>近大理工) 〇北野 奏葉<sup>1</sup>・秋吉 亮平<sup>1</sup>・佐伯 昭紀<sup>2</sup>・髙橋 直大<sup>3</sup>・大久保 貴志<sup>3</sup>・田中 大輔<sup>1</sup> Synthesis of Sulfur Containing 1D Coordination Polymer Glasses and Evaluation of Semiconductor Properties (<sup>1</sup>Kwansei Gakuin Univ., <sup>2</sup>Osaka Univ., <sup>3</sup>Kindai Univ.) 〇Kanaha KITANO<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Naohiro TAKAHASHI<sup>3</sup>, Takashi OKUBO<sup>3</sup>, Daisuke TANAKA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "All-Inorganic Porous Ionic Crystals Based on Al<sub>13</sub>-oxo Clusters and POMs for Oxidation Catalysis",
      "(<sup>1</sup>University of Tokyo) 〇Tateno Atsunobu<sup></sup>, Zhou Wei<sup></sup>, Naoki Ogiwara<sup></sup>, Sayaka Uchida<sup></sup>"
    ],
    "lab": "3Ac-09",
    "pdf": "pdf/3Ac-09.pdf",
    "pre": "tn/3Ac-09.jpg",
    "reg": "74386",
    "sea": "Al,Mo",
    "ses": "3Ac",
    "con": "3Ac-09 All-Inorganic Porous Ionic Crystals Based on Al<sub>13</sub>-oxo Clusters and POMs for Oxidation Catalysis (<sup>1</sup>University of Tokyo) 〇Tateno Atsunobu<sup></sup>, Zhou Wei<sup></sup>, Naoki Ogiwara<sup></sup>, Sayaka Uchida<sup></sup> Al,Mo"
  },
  {
    "inf": [
      "Self-expansion strategy of metal complex skeletons",
      "(<sup>1</sup>Grad. Sch. Eng, UTokyo) 〇Ami Nishijima<sup>1</sup>, Yuto Osugi<sup>1</sup>, Takashi Uemura<sup>1</sup>"
    ],
    "lab": "3Ac-10",
    "pdf": "pdf/3Ac-10.pdf",
    "pre": "tn/3Ac-10.jpg",
    "reg": "74137",
    "sea": "Rh, Zr, Al",
    "ses": "3Ac",
    "con": "3Ac-10 Self-expansion strategy of metal complex skeletons (<sup>1</sup>Grad. Sch. Eng, UTokyo) 〇Ami Nishijima<sup>1</sup>, Yuto Osugi<sup>1</sup>, Takashi Uemura<sup>1</sup> Rh, Zr, Al"
  },
  {
    "inf": [
      "Photocatalytic H<sub>2</sub> evolution using a novel UiO<sub>bpy</sub>67-PtRu MOFs under visible light ",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Qingen ZHENG<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "3Ac-11",
    "pdf": "pdf/3Ac-11.pdf",
    "pre": "tn/3Ac-11.jpg",
    "reg": "74327",
    "sea": "Ru, Pt",
    "ses": "3Ac",
    "con": "3Ac-11 Photocatalytic H<sub>2</sub> evolution using a novel UiO<sub>bpy</sub>67-PtRu MOFs under visible light  (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Qingen ZHENG<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Ru, Pt"
  },
  {
    "inf": [
      "Conversion of CO<sub>2</sub> into Carbonate-based Metal-Organic Frameworks with Controlled Decarbonation Reactivity",
      "(<sup>1</sup>Graduate School of Science, Kyoto Univ., <sup>2</sup>PPSM, CNRS, ENS-PS, Univ. Paris-Saclay, <sup>3</sup>iCeMS, Institute for Advanced Study, Kyoto Univ., <sup>4</sup>School of Molecular Science and Engineering, VISTEC) 〇Kentaro KADOTA<sup>1</sup>, Ayoub TRAVERSON<sup>2,3</sup>, Satoshi HORIKE<sup>1,3,4</sup>"
    ],
    "lab": "3Ac-12",
    "pdf": "pdf/3Ac-12.pdf",
    "pre": "tn/3Ac-12.jpg",
    "reg": "74286",
    "sea": "Cu2+",
    "ses": "3Ac",
    "con": "3Ac-12 Conversion of CO<sub>2</sub> into Carbonate-based Metal-Organic Frameworks with Controlled Decarbonation Reactivity (<sup>1</sup>Graduate School of Science, Kyoto Univ., <sup>2</sup>PPSM, CNRS, ENS-PS, Univ. Paris-Saclay, <sup>3</sup>iCeMS, Institute for Advanced Study, Kyoto Univ., <sup>4</sup>School of Molecular Science and Engineering, VISTEC) 〇Kentaro KADOTA<sup>1</sup>, Ayoub TRAVERSON<sup>2,3</sup>, Satoshi HORIKE<sup>1,3,4</sup> Cu2+"
  },
  {
    "inf": [
      "Microstructural Effects on Proton Conductivity in a Zn-Oxalate Coordination Polymer",
      "(<sup>1</sup>Graduate School of Engineering, Kyoto Uni., <sup>2</sup>Graduate School of Science, Kyoto Uni., <sup>3</sup>School of Molecular Science and Engineering, VISTEC, <sup>4</sup>IAS-iCeMS, Kyoto Uni.) 〇Ellan Berdichevsky<sup>1</sup>, Satoshi Horike<sup>2,3,4</sup>"
    ],
    "lab": "3Ac-13",
    "pdf": "pdf/3Ac-13.pdf",
    "pre": "tn/3Ac-13.jpg",
    "reg": "74459",
    "sea": "Zn",
    "ses": "3Ac",
    "con": "3Ac-13 Microstructural Effects on Proton Conductivity in a Zn-Oxalate Coordination Polymer (<sup>1</sup>Graduate School of Engineering, Kyoto Uni., <sup>2</sup>Graduate School of Science, Kyoto Uni., <sup>3</sup>School of Molecular Science and Engineering, VISTEC, <sup>4</sup>IAS-iCeMS, Kyoto Uni.) 〇Ellan Berdichevsky<sup>1</sup>, Satoshi Horike<sup>2,3,4</sup> Zn"
  },
  {
    "inf": [
      "異種カウンターカチオンの組み合わせによる1,2-ジチオシュウ酸を架橋配位子とする配位高分子の結晶構造制御",
      "(<sup>1</sup>阪公大院工・<sup>2</sup>阪公大院理・<sup>3</sup>阪公大人工光合成セ) 〇中本 滝人<sup>1</sup>・田中 里香<sup>2</sup>・中薗 孝志<sup>3</sup>・山田 裕介<sup>1,3</sup>",
      "Crystal-Structure Control of Coordination Polymers Possessing 1,2-Dithiooxalato as a Bridging Ligand by the Combination of Counter Cations                    ",
      "(<sup>1</sup>Graduate School of Engineering,Osaka Metropolitan University, <sup>2</sup>Graduate School of Science,Osaka Metropolitan University, <sup>3</sup>Research Center for Artificial Photosynthesis, Osaka Metropolitan Univ.) 〇Takito NAKAMOTO<sup>1</sup>, Rika TANAKA<sup>2</sup>, Takashi NAKAZONO<sup>3</sup>, Yusuke YAMADA<sup>1,3</sup>"
    ],
    "lab": "3Ac-14",
    "pdf": "pdf/3Ac-14.pdf",
    "pre": "tn/3Ac-14.jpg",
    "reg": "74300",
    "sea": "Co",
    "ses": "3Ac",
    "con": "3Ac-14 異種カウンターカチオンの組み合わせによる1,2-ジチオシュウ酸を架橋配位子とする配位高分子の結晶構造制御 (<sup>1</sup>阪公大院工・<sup>2</sup>阪公大院理・<sup>3</sup>阪公大人工光合成セ) 〇中本 滝人<sup>1</sup>・田中 里香<sup>2</sup>・中薗 孝志<sup>3</sup>・山田 裕介<sup>1,3</sup> Crystal-Structure Control of Coordination Polymers Possessing 1,2-Dithiooxalato as a Bridging Ligand by the Combination of Counter Cations                     (<sup>1</sup>Graduate School of Engineering,Osaka Metropolitan University, <sup>2</sup>Graduate School of Science,Osaka Metropolitan University, <sup>3</sup>Research Center for Artificial Photosynthesis, Osaka Metropolitan Univ.) 〇Takito NAKAMOTO<sup>1</sup>, Rika TANAKA<sup>2</sup>, Takashi NAKAZONO<sup>3</sup>, Yusuke YAMADA<sup>1,3</sup> Co"
  },
  {
    "inf": [
      "Magnetic and Thermodynamic Control of Coordination Network Crystallization Reactions",
      "(<sup>1</sup>Tokyo Tech, <sup>2</sup>ENEOS Corp) 〇Qiao JIANG<sup>1</sup>, Hiroaki SUZUKI<sup>1</sup>, Yuki WADA<sup>1</sup>, Takaya MATSUMOTO<sup>1,2</sup>, Pavel M. USOV<sup>1</sup>, Masaki KAWANO<sup>1</sup>"
    ],
    "lab": "3Ac-15",
    "pdf": "pdf/3Ac-15.pdf",
    "pre": "tn/3Ac-15.jpg",
    "reg": "74317",
    "sea": "Cd",
    "ses": "3Ac",
    "con": "3Ac-15 Magnetic and Thermodynamic Control of Coordination Network Crystallization Reactions (<sup>1</sup>Tokyo Tech, <sup>2</sup>ENEOS Corp) 〇Qiao JIANG<sup>1</sup>, Hiroaki SUZUKI<sup>1</sup>, Yuki WADA<sup>1</sup>, Takaya MATSUMOTO<sup>1,2</sup>, Pavel M. USOV<sup>1</sup>, Masaki KAWANO<sup>1</sup> Cd"
  },
  {
    "inf": [
      "5 核金属錯体骨格への金属イオンの精密配置とその物性評価",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院理 ) 〇坂本 雅也<sup>1</sup>・友田 美紗<sup>1</sup>・Zi Lang GOO<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1, 2</sup>・正岡 重行<sup>1</sup>",
      "Precise Arrangement of Metal Ions in a Pentanuclear Scaffold and Evaluation of Their Properties",
      "(<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>School of Science, Tokyo Institute of Technology) 〇Masaya SAKAMOTO<sup>1</sup>, Misa TOMODA<sup>1</sup>, Zi Lang GOO<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1, 2</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "3Ad-02",
    "pdf": "pdf/3Ad-02.pdf",
    "pre": "tn/3Ad-02.jpg",
    "reg": "74423",
    "sea": "Ru, Os, Cu",
    "ses": "3Ad",
    "con": "3Ad-02 5 核金属錯体骨格への金属イオンの精密配置とその物性評価 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院理 ) 〇坂本 雅也<sup>1</sup>・友田 美紗<sup>1</sup>・Zi Lang GOO<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1, 2</sup>・正岡 重行<sup>1</sup> Precise Arrangement of Metal Ions in a Pentanuclear Scaffold and Evaluation of Their Properties (<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>School of Science, Tokyo Institute of Technology) 〇Masaya SAKAMOTO<sup>1</sup>, Misa TOMODA<sup>1</sup>, Zi Lang GOO<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1, 2</sup>, Shigeyuki MASAOKA<sup>1</sup> Ru, Os, Cu"
  },
  {
    "inf": [
      "A theoretical investigation into water oxidation by multi-metal alloyed pentanuclear complexes          ",
      "(<sup>1</sup>Nagoya Univ., <sup>2</sup>ITbM, <sup>3</sup>Tokyo Tech, <sup>4</sup>Osaka Univ.) ★Vic Austen<sup>1</sup>, Quan Manh Phung<sup>1,2</sup>, Takeshi Yanai<sup>1,2</sup>, Mio Kondo<sup>3</sup>, Shigeyuki Masaoka<sup>4</sup>"
    ],
    "lab": "3Ad-03",
    "pdf": "pdf/3Ad-03.pdf",
    "pre": "tn/3Ad-03.jpg",
    "reg": "74350",
    "sea": "Fe, Mn",
    "ses": "3Ad",
    "con": "3Ad-03 A theoretical investigation into water oxidation by multi-metal alloyed pentanuclear complexes           (<sup>1</sup>Nagoya Univ., <sup>2</sup>ITbM, <sup>3</sup>Tokyo Tech, <sup>4</sup>Osaka Univ.) ★Vic Austen<sup>1</sup>, Quan Manh Phung<sup>1,2</sup>, Takeshi Yanai<sup>1,2</sup>, Mio Kondo<sup>3</sup>, Shigeyuki Masaoka<sup>4</sup> Fe, Mn"
  },
  {
    "inf": [
      "嵩高いホスフィン配位子で保護された四面体型Ni<sub>4</sub>クラスター錯体の合成、同定および触媒活性",
      "(<sup>1</sup>京大化研) 〇角南 康平<sup>1</sup>・檜垣 達也<sup>1</sup>・大木 靖弘<sup>1</sup>",
      "Synthesis, Characterization and Catalytic Activity of Tetrahedral Ni<sub>4</sub> Cluster Protected by Bulky Phosphines",
      "(<sup>1</sup>ICR, Kyoto U.) 〇Kohei SUNAMI<sup>1</sup>, Tatsuya HIGAKI<sup>1</sup>, Yasuhiro OHKI<sup>1</sup>"
    ],
    "lab": "3Ad-04",
    "pdf": "pdf/3Ad-04.pdf",
    "pre": "tn/3Ad-04.jpg",
    "reg": "74163",
    "sea": "Ni",
    "ses": "3Ad",
    "con": "3Ad-04 嵩高いホスフィン配位子で保護された四面体型Ni<sub>4</sub>クラスター錯体の合成、同定および触媒活性 (<sup>1</sup>京大化研) 〇角南 康平<sup>1</sup>・檜垣 達也<sup>1</sup>・大木 靖弘<sup>1</sup> Synthesis, Characterization and Catalytic Activity of Tetrahedral Ni<sub>4</sub> Cluster Protected by Bulky Phosphines (<sup>1</sup>ICR, Kyoto U.) 〇Kohei SUNAMI<sup>1</sup>, Tatsuya HIGAKI<sup>1</sup>, Yasuhiro OHKI<sup>1</sup> Ni"
  },
  {
    "inf": [
      "Connecting Gold Nanoclusters via Complex Formation",
      "(<sup>1</sup>Graduate School of Science, Tokyo Univ. of Science, <sup>2</sup>Institute of Multidisciplinary Research for Advanced Materials, Tohoku Univ.) 〇Taiga KOSAKA<sup>1</sup>, Yoshiki NIIHORI<sup>1</sup>, Yuichi NEGISHI<sup>1,2</sup>"
    ],
    "lab": "3Ad-05",
    "pdf": "pdf/3Ad-05.pdf",
    "pre": "tn/3Ad-05.jpg",
    "reg": "74160",
    "sea": "Au, Fe",
    "ses": "3Ad",
    "con": "3Ad-05 Connecting Gold Nanoclusters via Complex Formation (<sup>1</sup>Graduate School of Science, Tokyo Univ. of Science, <sup>2</sup>Institute of Multidisciplinary Research for Advanced Materials, Tohoku Univ.) 〇Taiga KOSAKA<sup>1</sup>, Yoshiki NIIHORI<sup>1</sup>, Yuichi NEGISHI<sup>1,2</sup> Au, Fe"
  },
  {
    "inf": [
      "Molecular-Scale Gold Nanoring with Bonding Interactions",
      "(<sup>1</sup>The Univ. of Tokyo) 〇Takanori IWASAKI<sup>1</sup>, Toshiyuki OI<sup>1</sup>, Kyoko NOZAKI<sup>1</sup>"
    ],
    "lab": "3Ad-06",
    "pdf": "pdf/3Ad-06.pdf",
    "pre": "tn/3Ad-06.jpg",
    "reg": "74018",
    "sea": "Au",
    "ses": "3Ad",
    "con": "3Ad-06 Molecular-Scale Gold Nanoring with Bonding Interactions (<sup>1</sup>The Univ. of Tokyo) 〇Takanori IWASAKI<sup>1</sup>, Toshiyuki OI<sup>1</sup>, Kyoko NOZAKI<sup>1</sup> Au"
  },
  {
    "inf": [
      "Chemical etching and synthetic modification of <i>C</i>-centered hexagold(I) clusters protected by chiral <i>N</i>-heterocyclic carbenes",
      "(<sup>1</sup>Tokyo Univ. of Science, <sup>2</sup>Institute for Molecular Science, <sup>3</sup>The Univ. of Tokyo) XiaoLi PEI<sup>1</sup>, Pei ZHAO<sup>2</sup>, 〇Hitoshi UBE<sup>1</sup>, Zhen LEI<sup>3</sup>, Masahiro EHARA<sup>2</sup>, Mitsuhiko SHIONOYA<sup>1</sup>"
    ],
    "lab": "3Ad-07",
    "pdf": "pdf/3Ad-07.pdf",
    "pre": "tn/3Ad-07.jpg",
    "reg": "74601",
    "sea": "Au",
    "ses": "3Ad",
    "con": "3Ad-07 Chemical etching and synthetic modification of <i>C</i>-centered hexagold(I) clusters protected by chiral <i>N</i>-heterocyclic carbenes (<sup>1</sup>Tokyo Univ. of Science, <sup>2</sup>Institute for Molecular Science, <sup>3</sup>The Univ. of Tokyo) XiaoLi PEI<sup>1</sup>, Pei ZHAO<sup>2</sup>, 〇Hitoshi UBE<sup>1</sup>, Zhen LEI<sup>3</sup>, Masahiro EHARA<sup>2</sup>, Mitsuhiko SHIONOYA<sup>1</sup> Au"
  },
  {
    "inf": [
      "Band-filling Control of Tetrathiafulvalene-based Covalent Organic Framework",
      "(<sup>1</sup>Kyoto Univ.) 〇Xinyu Li<sup>1</sup>, Yukihiro Yoshida<sup>1</sup>, Soichiro Yasaka<sup>1</sup>, Mitsuhiko Maesato<sup>1</sup>, Hiroshi Kitagawa<sup>1</sup>"
    ],
    "lab": "3B-02",
    "pdf": "pdf/3B-02.pdf",
    "pre": "tn/3B-02.jpg",
    "reg": "74190",
    "sea": "NONE",
    "ses": "3B",
    "con": "3B-02 Band-filling Control of Tetrathiafulvalene-based Covalent Organic Framework (<sup>1</sup>Kyoto Univ.) 〇Xinyu Li<sup>1</sup>, Yukihiro Yoshida<sup>1</sup>, Soichiro Yasaka<sup>1</sup>, Mitsuhiko Maesato<sup>1</sup>, Hiroshi Kitagawa<sup>1</sup> NONE"
  },
  {
    "inf": [
      "Intra-lattice Hydrogen Bonds-related Charge Manipulations Associated with Guest Removal in Charge Transferred Layered Metal-Organic Frameworks",
      "(<sup>1</sup>Institute for Materials Research, Tohoku University) ★Ke JI<sup>1</sup>, Chisa ITOH<sup>1</sup>, Haruka YOSHINO<sup>1</sup>, Wataru KOSAKA<sup>1</sup>, Hitoshi MIYASAKA<sup>1</sup>"
    ],
    "lab": "3B-03",
    "pdf": "pdf/3B-03.pdf",
    "pre": "tn/3B-03.jpg",
    "reg": "74547",
    "sea": "hydrogen bond",
    "ses": "3B",
    "con": "3B-03 Intra-lattice Hydrogen Bonds-related Charge Manipulations Associated with Guest Removal in Charge Transferred Layered Metal-Organic Frameworks (<sup>1</sup>Institute for Materials Research, Tohoku University) ★Ke JI<sup>1</sup>, Chisa ITOH<sup>1</sup>, Haruka YOSHINO<sup>1</sup>, Wataru KOSAKA<sup>1</sup>, Hitoshi MIYASAKA<sup>1</sup> hydrogen bond"
  },
  {
    "inf": [
      "Terpyridine-based cobalt(II) complexes exhibiting spin state changes in the solid state and optical changes in solution",
      "(<sup>1</sup>Graduate School of Science, Josai University) 〇Manabu NAKAYA<sup>1</sup>, Naoki IZUMIYAMA<sup>1</sup>, Hayato KIKUCHI<sup>1</sup>"
    ],
    "lab": "3B-04",
    "pdf": "pdf/3B-04.pdf",
    "pre": "tn/3B-04.jpg",
    "reg": "74447",
    "sea": "Co",
    "ses": "3B",
    "con": "3B-04 Terpyridine-based cobalt(II) complexes exhibiting spin state changes in the solid state and optical changes in solution (<sup>1</sup>Graduate School of Science, Josai University) 〇Manabu NAKAYA<sup>1</sup>, Naoki IZUMIYAMA<sup>1</sup>, Hayato KIKUCHI<sup>1</sup> Co"
  },
  {
    "inf": [
      "Triptycene-based 2.5D Metal-Organic Frameworks: Protonated SBU and hydrogen bonding connected 1D Antiferromagnetism",
      "(<sup>1</sup>Kumamoto Univ., <sup>2</sup>Nagoya Univ.) 〇Zhongyue Zhang<sup>1</sup>, Qi Chen<sup>2</sup>, Yuya Akasaki<sup>1</sup>, Yoshihiro Sekine<sup>1</sup>, Shinya Hayami<sup>1</sup>, Kunio Awaga<sup>2</sup>"
    ],
    "lab": "3B-05",
    "pdf": "pdf/3B-05.pdf",
    "pre": "tn/3B-05.jpg",
    "reg": "74128",
    "sea": "Cu",
    "ses": "3B",
    "con": "3B-05 Triptycene-based 2.5D Metal-Organic Frameworks: Protonated SBU and hydrogen bonding connected 1D Antiferromagnetism (<sup>1</sup>Kumamoto Univ., <sup>2</sup>Nagoya Univ.) 〇Zhongyue Zhang<sup>1</sup>, Qi Chen<sup>2</sup>, Yuya Akasaki<sup>1</sup>, Yoshihiro Sekine<sup>1</sup>, Shinya Hayami<sup>1</sup>, Kunio Awaga<sup>2</sup> Cu"
  },
  {
    "inf": [
      "Assembly of Smallest Prussian Blue Analogs Using Chiral Hydrogen Bond Donors",
      "(<sup>1</sup>Kumamoto Univ.) 〇Riku FUKUSHIMA<sup>1</sup>, Zhongyue ZHANG<sup>1</sup>, Yoshihiro SEKINE<sup>1</sup>, Shinya HAYAMI<sup>1</sup>"
    ],
    "lab": "3B-06",
    "pdf": "pdf/3B-06.pdf",
    "pre": "tn/3B-06.jpg",
    "reg": "74597",
    "sea": "Co, Fe",
    "ses": "3B",
    "con": "3B-06 Assembly of Smallest Prussian Blue Analogs Using Chiral Hydrogen Bond Donors (<sup>1</sup>Kumamoto Univ.) 〇Riku FUKUSHIMA<sup>1</sup>, Zhongyue ZHANG<sup>1</sup>, Yoshihiro SEKINE<sup>1</sup>, Shinya HAYAMI<sup>1</sup> Co, Fe"
  },
  {
    "inf": [
      "フタロシアニンおよびポルフィリンをベースとした有機弾性結晶の構築と機能化",
      "(<sup>1</sup>奈良女大院理・<sup>2</sup>JASRI) 〇堀井 洋司<sup>1</sup>・渡邉 千遥<sup>1</sup>・加藤 日菜子<sup>1</sup>・佐々木 俊之<sup>2</sup>・一柳 光平<sup>2</sup>・梶原 孝志<sup>1</sup>",
      "Construction and functionalization of organic elastic crystals based on phthalocyanines and porphyrins",
      "(<sup>1</sup>Nara Women's Univ., <sup>2</sup>JASRI) 〇Yoji HORII<sup>1</sup>, Chiharu WATANABE<sup>1</sup>, Hinako KATO<sup>1</sup>, Toshiyuki SASAKI<sup>2</sup>, Kohei ICHIYANAGI<sup>2</sup>, Takashi KAJIWARA<sup>1</sup>"
    ],
    "lab": "3B-07",
    "pdf": "pdf/3B-07.pdf",
    "pre": "tn/3B-07.jpg",
    "reg": "74225",
    "sea": "Cu, Ni",
    "ses": "3B",
    "con": "3B-07 フタロシアニンおよびポルフィリンをベースとした有機弾性結晶の構築と機能化 (<sup>1</sup>奈良女大院理・<sup>2</sup>JASRI) 〇堀井 洋司<sup>1</sup>・渡邉 千遥<sup>1</sup>・加藤 日菜子<sup>1</sup>・佐々木 俊之<sup>2</sup>・一柳 光平<sup>2</sup>・梶原 孝志<sup>1</sup> Construction and functionalization of organic elastic crystals based on phthalocyanines and porphyrins (<sup>1</sup>Nara Women's Univ., <sup>2</sup>JASRI) 〇Yoji HORII<sup>1</sup>, Chiharu WATANABE<sup>1</sup>, Hinako KATO<sup>1</sup>, Toshiyuki SASAKI<sup>2</sup>, Kohei ICHIYANAGI<sup>2</sup>, Takashi KAJIWARA<sup>1</sup> Cu, Ni"
  },
  {
    "inf": [
      "Anion-Driven Enhancement of CO<SUB>2</SUB> Electrochemical Reduction by a Novel Pentanuclear Iron-Based Covalent Organic Framework.",
      "(<sup>1</sup>Osaka Univ., <sup>2</sup>IISER Pune INDIA, <sup>3</sup>Tokyo Institute of Technology) 〇Chitvan Jain<sup>1,2</sup>, Pragalbh Shekhar<sup>2</sup>, Akira Yoneda<sup>1</sup>, Rinku Kushwaha<sup>2</sup>, Tetsuya Kambe<sup>1</sup>, Mio Kondo<sup>1,3</sup>, Ramanathan Vaidhyanathan<sup>2</sup>, Shigeyuki Masaoka<sup>1</sup>"
    ],
    "lab": "3C-02",
    "pdf": "pdf/3C-02.pdf",
    "pre": "tn/3C-02.jpg",
    "reg": "74332",
    "sea": "Fe",
    "ses": "3C",
    "con": "3C-02 Anion-Driven Enhancement of CO<SUB>2</SUB> Electrochemical Reduction by a Novel Pentanuclear Iron-Based Covalent Organic Framework. (<sup>1</sup>Osaka Univ., <sup>2</sup>IISER Pune INDIA, <sup>3</sup>Tokyo Institute of Technology) 〇Chitvan Jain<sup>1,2</sup>, Pragalbh Shekhar<sup>2</sup>, Akira Yoneda<sup>1</sup>, Rinku Kushwaha<sup>2</sup>, Tetsuya Kambe<sup>1</sup>, Mio Kondo<sup>1,3</sup>, Ramanathan Vaidhyanathan<sup>2</sup>, Shigeyuki Masaoka<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Systematic synthesis of hydrogen-production photoredox cascade catalyst to elucidate the dominant factor of photocatalytic activity",
      "(<sup>1</sup>Hokkaido University) 〇Atsushi KOBAYASHI<sup>1</sup>"
    ],
    "lab": "3C-03",
    "pdf": "pdf/3C-03.pdf",
    "pre": "tn/3C-03.jpg",
    "reg": "74396",
    "sea": "Ru",
    "ses": "3C",
    "con": "3C-03 Systematic synthesis of hydrogen-production photoredox cascade catalyst to elucidate the dominant factor of photocatalytic activity (<sup>1</sup>Hokkaido University) 〇Atsushi KOBAYASHI<sup>1</sup> Ru"
  },
  {
    "inf": [
      "Determining the Turnover Frequency of a Co-NHC Complex in Homogeneous Electrocatalysis of Hydrogen Evolution from Neutral Water",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ. ) 〇Masanori KAN<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "3C-04",
    "pdf": "pdf/3C-04.pdf",
    "pre": "tn/3C-04.jpg",
    "reg": "74285",
    "sea": "Co",
    "ses": "3C",
    "con": "3C-04 Determining the Turnover Frequency of a Co-NHC Complex in Homogeneous Electrocatalysis of Hydrogen Evolution from Neutral Water (<sup>1</sup>Dept. Chem. Kyushu Univ. ) 〇Masanori KAN<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Co"
  },
  {
    "inf": [
      "Development of Mesoporous Aluminosilicate Thin Films on ITO Electrodes and Immobilization of a Cationic Ru-water Oxidation Catalyst",
      "(<sup>1</sup>Kanagawa Univ.) 〇Masaya Okamura<sup>1</sup>, Shunpei Harada<sup>1</sup>, Ayano Yamada<sup>1</sup>, Narumi Nakano<sup>1</sup>, Shiro Hikichi<sup>1</sup>"
    ],
    "lab": "3C-05",
    "pdf": "pdf/3C-05.pdf",
    "pre": "tn/3C-05.jpg",
    "reg": "74284",
    "sea": "Ru",
    "ses": "3C",
    "con": "3C-05 Development of Mesoporous Aluminosilicate Thin Films on ITO Electrodes and Immobilization of a Cationic Ru-water Oxidation Catalyst (<sup>1</sup>Kanagawa Univ.) 〇Masaya Okamura<sup>1</sup>, Shunpei Harada<sup>1</sup>, Ayano Yamada<sup>1</sup>, Narumi Nakano<sup>1</sup>, Shiro Hikichi<sup>1</sup> Ru"
  },
  {
    "inf": [
      "ポルフィリン環置換基の電子吸引性効果によるヘム酸化触媒反応の制御機構の解明",
      "(<sup>1</sup>奈良女子大院・化学生物環境) 〇姜 璐璐<sup>1</sup>・本田 裕樹<sup>1</sup>・藤井 浩<sup>1</sup>",
      "Mechanism of catalytic oxygenation reaction by electron-withdrawing effects of porphyrin substituents and its control mechanism",
      "(<sup>1</sup>Department of Chemistry, Biology, and Environmental Science, Nara Women's University) 〇Lulu JIANG<sup>1</sup>, Yuki HONDA<sup>1</sup>, Hiroshi FUJII<sup>1</sup>"
    ],
    "lab": "3C-06",
    "pdf": "pdf/3C-06.pdf",
    "pre": "tn/3C-06.jpg",
    "reg": "74091",
    "sea": "Fe",
    "ses": "3C",
    "con": "3C-06 ポルフィリン環置換基の電子吸引性効果によるヘム酸化触媒反応の制御機構の解明 (<sup>1</sup>奈良女子大院・化学生物環境) 〇姜 璐璐<sup>1</sup>・本田 裕樹<sup>1</sup>・藤井 浩<sup>1</sup> Mechanism of catalytic oxygenation reaction by electron-withdrawing effects of porphyrin substituents and its control mechanism (<sup>1</sup>Department of Chemistry, Biology, and Environmental Science, Nara Women's University) 〇Lulu JIANG<sup>1</sup>, Yuki HONDA<sup>1</sup>, Hiroshi FUJII<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Water Oxidation Reactions Catalyzed by Molecular Co and Ru based Complexes in Strongly Alkaline Condition",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Atsuki SHIBUYA<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "3C-07",
    "pdf": "pdf/3C-07.pdf",
    "pre": "tn/3C-07.jpg",
    "reg": "74528",
    "sea": "Co, Ru",
    "ses": "3C",
    "con": "3C-07 Water Oxidation Reactions Catalyzed by Molecular Co and Ru based Complexes in Strongly Alkaline Condition (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Atsuki SHIBUYA<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Co, Ru"
  },
  {
    "inf": [
      "ポリエステルからナイロンへの直接変換:Ni触媒によるポリ(エチレンアジぺート)からナイロン66 への直接アミド化",
      "(<sup>1</sup>東京農工大院工) 〇小林 夏実<sup>1</sup>・小峰 伸之<sup>1</sup>・平野 雅文<sup>1</sup>",
      "Direct Transformation from Polyester to Nylon: Ni-Catalyzed Direct Amidation of Poly(ethylene adipate) to Nylon 66.",
      "(<sup>1</sup>Tokyo University of Agriculture and Technology) 〇Natsumi Kobayashi<sup>1</sup>, Nobuyuki Komine<sup>1</sup>, Masafumi Hirano<sup>1</sup>"
    ],
    "lab": "3C-09",
    "pdf": "pdf/3C-09.pdf",
    "pre": "tn/3C-09.jpg",
    "reg": "74097",
    "sea": "Ni",
    "ses": "3C",
    "con": "3C-09 ポリエステルからナイロンへの直接変換:Ni触媒によるポリ(エチレンアジぺート)からナイロン66 への直接アミド化 (<sup>1</sup>東京農工大院工) 〇小林 夏実<sup>1</sup>・小峰 伸之<sup>1</sup>・平野 雅文<sup>1</sup> Direct Transformation from Polyester to Nylon: Ni-Catalyzed Direct Amidation of Poly(ethylene adipate) to Nylon 66. (<sup>1</sup>Tokyo University of Agriculture and Technology) 〇Natsumi Kobayashi<sup>1</sup>, Nobuyuki Komine<sup>1</sup>, Masafumi Hirano<sup>1</sup> Ni"
  },
  {
    "inf": [
      "新規1,3-ジケトナトラトランタン(III)錯体によるポリブチレンスクシネートおよびポリエチレンテレフタラートの触媒分解",
      "(<sup>1</sup>東農工大院工) 〇豊田 美貴<sup>1</sup>・安倍 亮汰<sup>1</sup>・小峰 伸之<sup>1</sup>・平野 雅文<sup>1</sup>",
      "Catalytic Depolymerization of Poly(butylene succinate) and Poly(ethylene terephthalate) by Novel 1,3-Diketonatolanthanum(III) Complexes",
      "(<sup>1</sup>Tokyo University of Agriculture and Technology) 〇Miki Toyoda<sup>1</sup>, Ryota Abe<sup>1</sup>, Nobuyuki Komine<sup>1</sup>, Masafumi Hirano<sup>1</sup>"
    ],
    "lab": "3C-10",
    "pdf": "pdf/3C-10.pdf",
    "pre": "tn/3C-10.jpg",
    "reg": "74303",
    "sea": "La",
    "ses": "3C",
    "con": "3C-10 新規1,3-ジケトナトラトランタン(III)錯体によるポリブチレンスクシネートおよびポリエチレンテレフタラートの触媒分解 (<sup>1</sup>東農工大院工) 〇豊田 美貴<sup>1</sup>・安倍 亮汰<sup>1</sup>・小峰 伸之<sup>1</sup>・平野 雅文<sup>1</sup> Catalytic Depolymerization of Poly(butylene succinate) and Poly(ethylene terephthalate) by Novel 1,3-Diketonatolanthanum(III) Complexes (<sup>1</sup>Tokyo University of Agriculture and Technology) 〇Miki Toyoda<sup>1</sup>, Ryota Abe<sup>1</sup>, Nobuyuki Komine<sup>1</sup>, Masafumi Hirano<sup>1</sup> La"
  },
  {
    "inf": [
      "Cross-Coupling of Allylic Ethers with Organoboron Reagents Through Combined Catalysis by Nickel and Pyrimidine",
      "(<sup>1</sup>The Univ. of Tokyo, Engineering) ★Thakun Chen<sup>1</sup>, Iwasaki Takanori<sup>1</sup>, Kyoko Nozaki<sup>1</sup>"
    ],
    "lab": "3C-11",
    "pdf": "pdf/3C-11.pdf",
    "pre": "tn/3C-11.jpg",
    "reg": "74468",
    "sea": "Ni",
    "ses": "3C",
    "con": "3C-11 Cross-Coupling of Allylic Ethers with Organoboron Reagents Through Combined Catalysis by Nickel and Pyrimidine (<sup>1</sup>The Univ. of Tokyo, Engineering) ★Thakun Chen<sup>1</sup>, Iwasaki Takanori<sup>1</sup>, Kyoko Nozaki<sup>1</sup> Ni"
  },
  {
    "inf": [
      "Reductive Cyclopropanation Using Electrons from Hydrogen",
      "(<sup>1</sup>Grad. Sch. of Eng., Kyushu Univ., <sup>2</sup>I2CNER, <sup>3</sup>sMol, <sup>4</sup>Fac. of Sci. and Eng., Kindai Univ.) 〇Takeshi YATABE<sup>1,2,3</sup>, Keishi MIYAZAWA<sup>1,2</sup>, Hidetaka NAKAI<sup>4</sup>, Seiji OGO<sup>1,2,3</sup>"
    ],
    "lab": "3C-12",
    "pdf": "pdf/3C-12.pdf",
    "pre": "tn/3C-12.jpg",
    "reg": "74343",
    "sea": "Ir",
    "ses": "3C",
    "con": "3C-12 Reductive Cyclopropanation Using Electrons from Hydrogen (<sup>1</sup>Grad. Sch. of Eng., Kyushu Univ., <sup>2</sup>I2CNER, <sup>3</sup>sMol, <sup>4</sup>Fac. of Sci. and Eng., Kindai Univ.) 〇Takeshi YATABE<sup>1,2,3</sup>, Keishi MIYAZAWA<sup>1,2</sup>, Hidetaka NAKAI<sup>4</sup>, Seiji OGO<sup>1,2,3</sup> Ir"
  },
  {
    "inf": [
      "第二配位圏に水素結合部位を有するルテニウム(V)-イミド錯体による水中でのアルケンのアジリジン化反応  ",
      "(<sup>1</sup>筑波大院数物) 〇小川 知里<sup>1</sup>・石塚 智也<sup>1</sup>・小谷 弘明<sup>1</sup>・小島 隆彦<sup>1</sup>",
      "Aziridination of alkenes in water by a ruthenium(V)-imido complex bearing hydrogen-bonding sites in the secondary coordination sphere",
      "(<sup>1</sup>Grad. School of Pure and Applied Sciences, Univ. of Tsukuba) 〇Chisato OGAWA<sup>1</sup>, Tomoya ISHIZUKA<sup>1</sup>, Hiroaki KOTANI<sup>1</sup>, Takahiko KOJIMA<sup>1</sup>"
    ],
    "lab": "3C-13",
    "pdf": "pdf/3C-13.pdf",
    "pre": "tn/3C-13.jpg",
    "reg": "74025",
    "sea": "Ru",
    "ses": "3C",
    "con": "3C-13 第二配位圏に水素結合部位を有するルテニウム(V)-イミド錯体による水中でのアルケンのアジリジン化反応   (<sup>1</sup>筑波大院数物) 〇小川 知里<sup>1</sup>・石塚 智也<sup>1</sup>・小谷 弘明<sup>1</sup>・小島 隆彦<sup>1</sup> Aziridination of alkenes in water by a ruthenium(V)-imido complex bearing hydrogen-bonding sites in the secondary coordination sphere (<sup>1</sup>Grad. School of Pure and Applied Sciences, Univ. of Tsukuba) 〇Chisato OGAWA<sup>1</sup>, Tomoya ISHIZUKA<sup>1</sup>, Hiroaki KOTANI<sup>1</sup>, Takahiko KOJIMA<sup>1</sup> Ru"
  },
  {
    "inf": [
      "ベンジリデン配位子上にカルコゲン元素を有するHoveyda-Grubbs型錯体の反応性",
      "(<sup>1</sup>奈良先端大・物質創成) 〇光定 誠修<sup>1</sup>・衣川 翼<sup>1</sup>・廣田 俊<sup>1</sup>・松尾 貴史<sup>1</sup>",
      "Reactivities of Hoveyda-Grubbs-type complexes with a chalcogen atom in the benzylidene ligand",
      "(<sup>1</sup>Div. Mater. Sci. Nara Institute of Science and Technology) 〇Seishu Mitsusada<sup>1</sup>, Tsubasa Kinugawa<sup>1</sup>, Shun Hirota<sup>1</sup>, Takashi Matsuo<sup>1</sup>"
    ],
    "lab": "3C-14",
    "pdf": "pdf/3C-14.pdf",
    "pre": "tn/3C-14.jpg",
    "reg": "74051",
    "sea": "Ru",
    "ses": "3C",
    "con": "3C-14 ベンジリデン配位子上にカルコゲン元素を有するHoveyda-Grubbs型錯体の反応性 (<sup>1</sup>奈良先端大・物質創成) 〇光定 誠修<sup>1</sup>・衣川 翼<sup>1</sup>・廣田 俊<sup>1</sup>・松尾 貴史<sup>1</sup> Reactivities of Hoveyda-Grubbs-type complexes with a chalcogen atom in the benzylidene ligand (<sup>1</sup>Div. Mater. Sci. Nara Institute of Science and Technology) 〇Seishu Mitsusada<sup>1</sup>, Tsubasa Kinugawa<sup>1</sup>, Shun Hirota<sup>1</sup>, Takashi Matsuo<sup>1</sup> Ru"
  },
  {
    "inf": [
      "Multimetal-Catalyzed One-Stop Chain Transfer Oligomerization of Ethylene/Propylene for Synthetic Lubricants",
      "(<sup>1</sup>ENEOS, <sup>2</sup>TEIKYO University of Science, <sup>3</sup>Institute of Molecular Science) 〇Fuyuki AIDA<sup>1</sup>, Hikaru TAKAYA<sup>2,3</sup>"
    ],
    "lab": "3C-15",
    "pdf": "pdf/3C-15.pdf",
    "pre": "tn/3C-15.jpg",
    "reg": "74024",
    "sea": "Fe, Zn, Ni",
    "ses": "3C",
    "con": "3C-15 Multimetal-Catalyzed One-Stop Chain Transfer Oligomerization of Ethylene/Propylene for Synthetic Lubricants (<sup>1</sup>ENEOS, <sup>2</sup>TEIKYO University of Science, <sup>3</sup>Institute of Molecular Science) 〇Fuyuki AIDA<sup>1</sup>, Hikaru TAKAYA<sup>2,3</sup> Fe, Zn, Ni"
  },
  {
    "inf": [
      "Mechanistic study of Zinc(II)-promoted isomerization reactions of cyclometalated iridium(III) complexes",
      "(<sup>1</sup>Faculty of Pharmaceutical Science, Tokyo University of Science, <sup>2</sup>Graduate School of Science, Nagoya University, <sup>3</sup>Interdisciplinary Graduate School of Medicine and Engineering, University of Yamanashi, <sup>4</sup>Research Institute for Science and Technology, Tokyo University of Science) 〇Toshifumi Tojo<sup></sup>, Surajit Haldar<sup></sup>, Koki Nakamura<sup></sup>, Yasuyuki Yamada<sup></sup>, Hajime Sato<sup></sup>, Shin Aoki<sup></sup>"
    ],
    "lab": "3D-02",
    "pdf": "pdf/3D-02.pdf",
    "pre": "tn/3D-02.jpg",
    "reg": "74261",
    "sea": "Ir",
    "ses": "3D",
    "con": "3D-02 Mechanistic study of Zinc(II)-promoted isomerization reactions of cyclometalated iridium(III) complexes (<sup>1</sup>Faculty of Pharmaceutical Science, Tokyo University of Science, <sup>2</sup>Graduate School of Science, Nagoya University, <sup>3</sup>Interdisciplinary Graduate School of Medicine and Engineering, University of Yamanashi, <sup>4</sup>Research Institute for Science and Technology, Tokyo University of Science) 〇Toshifumi Tojo<sup></sup>, Surajit Haldar<sup></sup>, Koki Nakamura<sup></sup>, Yasuyuki Yamada<sup></sup>, Hajime Sato<sup></sup>, Shin Aoki<sup></sup> Ir"
  },
  {
    "inf": [
      "アルキルチタン錯体の脱プロトン化能に対する可視光の反応促進効果",
      "(<sup>1</sup>阪大院基礎工・<sup>2</sup>阪大院工) 〇黒田 悠<sup>1</sup>・草本 哲郎<sup>1</sup>・劒 隼人<sup>2</sup>",
      "Effect of Visible Light Irradiation on the Deprotonation Reactivity of Alkyltitanium Complexes",
      "(<sup>1</sup>Graduate School of Engineering Science, Osaka University, <sup>2</sup>Graduate School of Engineering, Osaka University) 〇Yu KURODA<sup>1</sup>, Tetsuro KUSAMOTO<sup>1</sup>, Hayato TSURUGI<sup>2</sup>"
    ],
    "lab": "3D-03",
    "pdf": "pdf/3D-03.pdf",
    "pre": "tn/3D-03.jpg",
    "reg": "74380",
    "sea": "Ti",
    "ses": "3D",
    "con": "3D-03 アルキルチタン錯体の脱プロトン化能に対する可視光の反応促進効果 (<sup>1</sup>阪大院基礎工・<sup>2</sup>阪大院工) 〇黒田 悠<sup>1</sup>・草本 哲郎<sup>1</sup>・劒 隼人<sup>2</sup> Effect of Visible Light Irradiation on the Deprotonation Reactivity of Alkyltitanium Complexes (<sup>1</sup>Graduate School of Engineering Science, Osaka University, <sup>2</sup>Graduate School of Engineering, Osaka University) 〇Yu KURODA<sup>1</sup>, Tetsuro KUSAMOTO<sup>1</sup>, Hayato TSURUGI<sup>2</sup> Ti"
  },
  {
    "inf": [
      "Pt(0) および Pd(0) アニオンの合成と反応性",
      "(<sup>1</sup>阪公大院理) 〇宮崎 十志<sup>1</sup>・亀尾 肇<sup>1</sup>・松坂 裕之<sup>1</sup>",
      "Synthesis and Reactivity of Pt(0) and Pd(0) anions",
      "(<sup>1</sup>Osaka Metropolitan Univ.) 〇Tokoro MIYAZAKI<sup>1</sup>, Hajime KAMEO<sup>1</sup>, Hiroyuki MATSUZAKA<sup>1</sup>"
    ],
    "lab": "3D-04",
    "pdf": "pdf/3D-04.pdf",
    "pre": "tn/3D-04.jpg",
    "reg": "74494",
    "sea": "Pt, Pd",
    "ses": "3D",
    "con": "3D-04 Pt(0) および Pd(0) アニオンの合成と反応性 (<sup>1</sup>阪公大院理) 〇宮崎 十志<sup>1</sup>・亀尾 肇<sup>1</sup>・松坂 裕之<sup>1</sup> Synthesis and Reactivity of Pt(0) and Pd(0) anions (<sup>1</sup>Osaka Metropolitan Univ.) 〇Tokoro MIYAZAKI<sup>1</sup>, Hajime KAMEO<sup>1</sup>, Hiroyuki MATSUZAKA<sup>1</sup> Pt, Pd"
  },
  {
    "inf": [
      "ビフェニルホスフィンから誘導されるシクロメタレート錯体のアルキン挿入と環化異性化反応",
      "(<sup>1</sup>中大院理工・<sup>2</sup>京工繊大院工芸) 〇新谷 健太郎<sup>1</sup>・互井 孔貴<sup>1</sup>・半田 彩恵<sup>1</sup>・岩本 貴寛<sup>2</sup>・石井 洋一<sup>1</sup>",
      "Alkyne Insertion and Cycloisomerization of Cyclometalated Complexes Derived from Biphenylphosphine",
      "(<sup>1</sup>Chuo Univ., <sup>2</sup>Kyoto Institute of Technology) 〇Kentaro SHINYA<sup>1</sup>, Koki TAGAI<sup>1</sup>, Sae HANDA<sup>1</sup>, Takahiro IWAMOTO<sup>2</sup>, Youichi ISHII<sup>1</sup>"
    ],
    "lab": "3D-05",
    "pdf": "pdf/3D-05.pdf",
    "pre": "tn/3D-05.jpg",
    "reg": "74150",
    "sea": "Rh, Ir, Ru",
    "ses": "3D",
    "con": "3D-05 ビフェニルホスフィンから誘導されるシクロメタレート錯体のアルキン挿入と環化異性化反応 (<sup>1</sup>中大院理工・<sup>2</sup>京工繊大院工芸) 〇新谷 健太郎<sup>1</sup>・互井 孔貴<sup>1</sup>・半田 彩恵<sup>1</sup>・岩本 貴寛<sup>2</sup>・石井 洋一<sup>1</sup> Alkyne Insertion and Cycloisomerization of Cyclometalated Complexes Derived from Biphenylphosphine (<sup>1</sup>Chuo Univ., <sup>2</sup>Kyoto Institute of Technology) 〇Kentaro SHINYA<sup>1</sup>, Koki TAGAI<sup>1</sup>, Sae HANDA<sup>1</sup>, Takahiro IWAMOTO<sup>2</sup>, Youichi ISHII<sup>1</sup> Rh, Ir, Ru"
  },
  {
    "inf": [
      "ルテニウム–dppm錯体のRu–P結合への位置選択的アルキン挿入反応",
      "(<sup>1</sup>中央大学・<sup>2</sup>理研CSRS・<sup>3</sup>京都工芸繊維大学) 〇堀之内 陽樹<sup>1</sup>・木村 祐介<sup>1</sup>・池田 洋輔<sup>1</sup>・武藤 雄一郎<sup>2</sup>・岩本 貴寛<sup>3</sup>・石井 洋一<sup>1</sup>",
      "Regioselective Insertion of an Alkyne into the Ru–P Coordination Bond in a Ru–dppm Complex",
      "(<sup>1</sup>Chuo University, <sup>2</sup>RIKEN CSRS, <sup>3</sup>Kyoto Institute of Technology) 〇Haruki HORINOUCHI<sup>1</sup>, Yusuke KIMURA<sup>1</sup>, Yousuke IKEDA<sup>1</sup>, Yuichiro MUTOH<sup>2</sup>, Takahiro IWAMOTO<sup>3</sup>, Youichi ISHII<sup>1</sup>"
    ],
    "lab": "3D-06",
    "pdf": "pdf/3D-06.pdf",
    "pre": "tn/3D-06.jpg",
    "reg": "74149",
    "sea": "Ru",
    "ses": "3D",
    "con": "3D-06 ルテニウム–dppm錯体のRu–P結合への位置選択的アルキン挿入反応 (<sup>1</sup>中央大学・<sup>2</sup>理研CSRS・<sup>3</sup>京都工芸繊維大学) 〇堀之内 陽樹<sup>1</sup>・木村 祐介<sup>1</sup>・池田 洋輔<sup>1</sup>・武藤 雄一郎<sup>2</sup>・岩本 貴寛<sup>3</sup>・石井 洋一<sup>1</sup> Regioselective Insertion of an Alkyne into the Ru–P Coordination Bond in a Ru–dppm Complex (<sup>1</sup>Chuo University, <sup>2</sup>RIKEN CSRS, <sup>3</sup>Kyoto Institute of Technology) 〇Haruki HORINOUCHI<sup>1</sup>, Yusuke KIMURA<sup>1</sup>, Yousuke IKEDA<sup>1</sup>, Yuichiro MUTOH<sup>2</sup>, Takahiro IWAMOTO<sup>3</sup>, Youichi ISHII<sup>1</sup> Ru"
  },
  {
    "inf": [
      "Ru触媒による1,5-ジシリルヘキサトリエン誘導体の合成および位置選択的プロト脱シリル化/檜山クロスカップリング反応による直鎖状共役トリエンの生成",
      "(<sup>1</sup>東農工大院工) 〇坂元 風舞<sup>1</sup>・清田 小織<sup>1</sup>・平野 雅文<sup>1</sup>",
      "Ru-Catalyzed Synthesis of 1,5-Disilylhexatrienes and Regioselective Proto-desilylation/Hiyama Cross-Coupling Reaction Giving Linear Conjugated Trienes.",
      "(<sup>1</sup>Tokyo University of Agriculture and Technology) 〇Fuma Sakamoto<sup>1</sup>, Sayori Kiyota<sup>1</sup>, Masafumi Hirano<sup>1</sup>"
    ],
    "lab": "3D-07",
    "pdf": "pdf/3D-07.pdf",
    "pre": "tn/3D-07.jpg",
    "reg": "74034",
    "sea": "Ru, Pd, Si",
    "ses": "3D",
    "con": "3D-07 Ru触媒による1,5-ジシリルヘキサトリエン誘導体の合成および位置選択的プロト脱シリル化/檜山クロスカップリング反応による直鎖状共役トリエンの生成 (<sup>1</sup>東農工大院工) 〇坂元 風舞<sup>1</sup>・清田 小織<sup>1</sup>・平野 雅文<sup>1</sup> Ru-Catalyzed Synthesis of 1,5-Disilylhexatrienes and Regioselective Proto-desilylation/Hiyama Cross-Coupling Reaction Giving Linear Conjugated Trienes. (<sup>1</sup>Tokyo University of Agriculture and Technology) 〇Fuma Sakamoto<sup>1</sup>, Sayori Kiyota<sup>1</sup>, Masafumi Hirano<sup>1</sup> Ru, Pd, Si"
  },
  {
    "inf": [
      "Synthesis and reactivity of novel cobaltocene derivatives bearing pyridyl group toward proton-coupled electron transfer for nitrogen fixation",
      "(<sup>1</sup>Graduate School of Engineering, The University of Tokyo) 〇Hiroki OTSUKA<sup>1</sup>, Kazuya ARASHIBA<sup>1</sup>, Yoshiaki NISHIBAYASHI<sup>1</sup>"
    ],
    "lab": "3D-09",
    "pdf": "pdf/3D-09.pdf",
    "pre": "tn/3D-09.jpg",
    "reg": "74086",
    "sea": "Co, Mo",
    "ses": "3D",
    "con": "3D-09 Synthesis and reactivity of novel cobaltocene derivatives bearing pyridyl group toward proton-coupled electron transfer for nitrogen fixation (<sup>1</sup>Graduate School of Engineering, The University of Tokyo) 〇Hiroki OTSUKA<sup>1</sup>, Kazuya ARASHIBA<sup>1</sup>, Yoshiaki NISHIBAYASHI<sup>1</sup> Co, Mo"
  },
  {
    "inf": [
      "モリブデン錯体を用いた窒素ガスからイソシアネートへの触媒的変換反応",
      "(<sup>1</sup>東大院工) 〇杉山 敬太<sup>1</sup>・杉野目 駿<sup>1</sup>・西林 仁昭<sup>1</sup>",
      "Direct Conversion of Dinitrogen to Isocyanate Catalyzed by Molybdenum Complexes",
      "(<sup>1</sup>School of Engineering, The University of Tokyo) 〇Keita Sugiyama<sup>1</sup>, Shun Suginome<sup>1</sup>, Yoshiaki Nishibayashi<sup>1</sup>"
    ],
    "lab": "3D-10",
    "pdf": "pdf/3D-10.pdf",
    "pre": "tn/3D-10.jpg",
    "reg": "74344",
    "sea": "Mo",
    "ses": "3D",
    "con": "3D-10 モリブデン錯体を用いた窒素ガスからイソシアネートへの触媒的変換反応 (<sup>1</sup>東大院工) 〇杉山 敬太<sup>1</sup>・杉野目 駿<sup>1</sup>・西林 仁昭<sup>1</sup> Direct Conversion of Dinitrogen to Isocyanate Catalyzed by Molybdenum Complexes (<sup>1</sup>School of Engineering, The University of Tokyo) 〇Keita Sugiyama<sup>1</sup>, Shun Suginome<sup>1</sup>, Yoshiaki Nishibayashi<sup>1</sup> Mo"
  },
  {
    "inf": [
      "MOF担持モリブデンオキソ錯体による再利用可能な窒素固定触媒の開発",
      "(<sup>1</sup>東大院工・<sup>2</sup>京都大学・<sup>3</sup>大同大学) 〇亀田 義勝<sup>1</sup>・杉野目 駿<sup>1</sup>・中村 泰司<sup>2</sup>・田中 宏昌<sup>3</sup>・吉澤 一成<sup>2</sup>・西林 仁昭<sup>1</sup>",
      "Reusable Nitrogen Fixation Catalysts with MOF-Supported Molybdenum-Oxo Complexes",
      "(<sup>1</sup>UTokyo-Eng, <sup>2</sup>Kyoto University, <sup>3</sup>Daido University) 〇Yoshikatsu KAMEDA<sup>1</sup>, Shun SUGINOME<sup>1</sup>, Taiji NAKAMURA<sup>2</sup>, Hiromasa TANAKA<sup>3</sup>, Kazunari YOSHIZAWA<sup>2</sup>, Yoshiaki NISHIBAYASHI<sup>1</sup>"
    ],
    "lab": "3D-11",
    "pdf": "pdf/3D-11.pdf",
    "pre": "tn/3D-11.jpg",
    "reg": "74208",
    "sea": "Mo, Zr",
    "ses": "3D",
    "con": "3D-11 MOF担持モリブデンオキソ錯体による再利用可能な窒素固定触媒の開発 (<sup>1</sup>東大院工・<sup>2</sup>京都大学・<sup>3</sup>大同大学) 〇亀田 義勝<sup>1</sup>・杉野目 駿<sup>1</sup>・中村 泰司<sup>2</sup>・田中 宏昌<sup>3</sup>・吉澤 一成<sup>2</sup>・西林 仁昭<sup>1</sup> Reusable Nitrogen Fixation Catalysts with MOF-Supported Molybdenum-Oxo Complexes (<sup>1</sup>UTokyo-Eng, <sup>2</sup>Kyoto University, <sup>3</sup>Daido University) 〇Yoshikatsu KAMEDA<sup>1</sup>, Shun SUGINOME<sup>1</sup>, Taiji NAKAMURA<sup>2</sup>, Hiromasa TANAKA<sup>3</sup>, Kazunari YOSHIZAWA<sup>2</sup>, Yoshiaki NISHIBAYASHI<sup>1</sup> Mo, Zr"
  },
  {
    "inf": [
      "芳香環による準安定化を利用した鉄(I)およびコバルト(I)アミド錯体の合成と反応",
      "(<sup>1</sup>阪大院理) 〇田仲 航馬<sup>1</sup>・大塚 信之介<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup>",
      "Synthesis and Reactions of Fe(I) and Co(I) Amides Semi-Stabilized by Aromatic Rings",
      "(<sup>1</sup>Osaka Univ.) 〇Kazuma TANAKA<sup>1</sup>, Shinnosuke OTSUKA<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup>"
    ],
    "lab": "3D-12",
    "pdf": "pdf/3D-12.pdf",
    "pre": "tn/3D-12.jpg",
    "reg": "74141",
    "sea": "Fe, Co",
    "ses": "3D",
    "con": "3D-12 芳香環による準安定化を利用した鉄(I)およびコバルト(I)アミド錯体の合成と反応 (<sup>1</sup>阪大院理) 〇田仲 航馬<sup>1</sup>・大塚 信之介<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup> Synthesis and Reactions of Fe(I) and Co(I) Amides Semi-Stabilized by Aromatic Rings (<sup>1</sup>Osaka Univ.) 〇Kazuma TANAKA<sup>1</sup>, Shinnosuke OTSUKA<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup> Fe, Co"
  },
  {
    "inf": [
      "Ni(0)触媒を用いたプロパルギル位置換反応におけるアレニルニッケル鍵中間体錯体の捕捉とその反応性",
      "(<sup>1</sup>阪公大院理・<sup>2</sup>阪府大院理) 〇高山 晃<sup>1</sup>・宮﨑 祐輔<sup>2</sup>・道上 健一<sup>1,2</sup>・植田 光洋<sup>1,2</sup>・大橋 理人<sup>1,2</sup>",
      "Isolation and Reactivity of Allenylnickel(II) Key Intermediate Complexes in Nickel(0)-Catalyzed Propargylic Substitution Reactions",
      "(<sup>1</sup>Graduate School of Science, Osaka Metropolitan University, <sup>2</sup>Graduate School of Science, Osaka Prefecture University) 〇Hikaru TAKAYAMA<sup>1</sup>, Yusuke MIYAZAKI<sup>2</sup>, Kenichi MICHIGAMI<sup>1,2</sup>, Mitsuhiro UEDA<sup>1,2</sup>, Masato OHASHI<sup>1,2</sup>"
    ],
    "lab": "3D-13",
    "pdf": "pdf/3D-13.pdf",
    "pre": "tn/3D-13.jpg",
    "reg": "74395",
    "sea": "Ni",
    "ses": "3D",
    "con": "3D-13 Ni(0)触媒を用いたプロパルギル位置換反応におけるアレニルニッケル鍵中間体錯体の捕捉とその反応性 (<sup>1</sup>阪公大院理・<sup>2</sup>阪府大院理) 〇高山 晃<sup>1</sup>・宮﨑 祐輔<sup>2</sup>・道上 健一<sup>1,2</sup>・植田 光洋<sup>1,2</sup>・大橋 理人<sup>1,2</sup> Isolation and Reactivity of Allenylnickel(II) Key Intermediate Complexes in Nickel(0)-Catalyzed Propargylic Substitution Reactions (<sup>1</sup>Graduate School of Science, Osaka Metropolitan University, <sup>2</sup>Graduate School of Science, Osaka Prefecture University) 〇Hikaru TAKAYAMA<sup>1</sup>, Yusuke MIYAZAKI<sup>2</sup>, Kenichi MICHIGAMI<sup>1,2</sup>, Mitsuhiro UEDA<sup>1,2</sup>, Masato OHASHI<sup>1,2</sup> Ni"
  },
  {
    "inf": [
      "ビス(フェノラト)チタン錯体の合成と構造と1-オクテンに対する触媒能",
      "(<sup>1</sup>長岡技科大院工) 〇成 宇<sup>1</sup>・戸田 智之<sup>1</sup>・竹中 克彦<sup>1</sup>",
      "Synthesis, structure of bis(phenolato)titanium complexes and  catalytic activity for 1-octene",
      "(<sup>1</sup>Dept. of Mat. Sci. and Bioeng., Nagaoka Univ. of Tech.) 〇Yu Cheng<sup>1</sup>, Tomoyuki Toda<sup>1</sup>, Katsuhiko Takenaka<sup>1</sup>"
    ],
    "lab": "3D-14",
    "pdf": "pdf/3D-14.pdf",
    "pre": "tn/3D-14.jpg",
    "reg": "74136",
    "sea": "Ti",
    "ses": "3D",
    "con": "3D-14 ビス(フェノラト)チタン錯体の合成と構造と1-オクテンに対する触媒能 (<sup>1</sup>長岡技科大院工) 〇成 宇<sup>1</sup>・戸田 智之<sup>1</sup>・竹中 克彦<sup>1</sup> Synthesis, structure of bis(phenolato)titanium complexes and  catalytic activity for 1-octene (<sup>1</sup>Dept. of Mat. Sci. and Bioeng., Nagaoka Univ. of Tech.) 〇Yu Cheng<sup>1</sup>, Tomoyuki Toda<sup>1</sup>, Katsuhiko Takenaka<sup>1</sup> Ti"
  },
  {
    "inf": [
      "ピンサー型カルボジホスホラン白金触媒による協働的Si-H活性化を鍵としたカルボニル化合物の変換反応",
      "(<sup>1</sup>広島大学大学院先進理工系科学研究科) 〇木全 孟<sup>1</sup>・久保 和幸<sup>1</sup>・Shang Rong<sup>1</sup>・久米 昌子<sup>1</sup>・水田 勉<sup>1</sup>",
      "Reactions of carbonyl compounds catalyzed by a pincer-type carbodiphosphorane-platinum(II) complex via cooperative activation of an Si-H bond",
      "(<sup>1</sup>Graduate School of Advanced Science and Engineering,Hiroshima University) 〇Hajime Kimata<sup>1</sup>, Kazuyuki Kubo<sup>1</sup>, Shang Rong<sup>1</sup>, Shoko Kume<sup>1</sup>, Tsutomu Mizuta<sup>1</sup>"
    ],
    "lab": "3D-15",
    "pdf": "pdf/3D-15.pdf",
    "pre": "tn/3D-15.jpg",
    "reg": "74059",
    "sea": "Pt",
    "ses": "3D",
    "con": "3D-15 ピンサー型カルボジホスホラン白金触媒による協働的Si-H活性化を鍵としたカルボニル化合物の変換反応 (<sup>1</sup>広島大学大学院先進理工系科学研究科) 〇木全 孟<sup>1</sup>・久保 和幸<sup>1</sup>・Shang Rong<sup>1</sup>・久米 昌子<sup>1</sup>・水田 勉<sup>1</sup> Reactions of carbonyl compounds catalyzed by a pincer-type carbodiphosphorane-platinum(II) complex via cooperative activation of an Si-H bond (<sup>1</sup>Graduate School of Advanced Science and Engineering,Hiroshima University) 〇Hajime Kimata<sup>1</sup>, Kazuyuki Kubo<sup>1</sup>, Shang Rong<sup>1</sup>, Shoko Kume<sup>1</sup>, Tsutomu Mizuta<sup>1</sup> Pt"
  },
  {
    "inf": [
      "Enantioselective control of a copper-artificial metalloenzyme by chemical modification with thiopyridine",
      "(<sup>1</sup>Graduate School of Agriculture, Osaka Metropolitan University) 〇Yoshitsugu Morita<sup>1</sup>, Hiroki Kubo<sup>1</sup>, Ryusei Matsumoto<sup>1</sup>, Nobutaka Fujieda<sup>1</sup>"
    ],
    "lab": "3E-02",
    "pdf": "pdf/3E-02.pdf",
    "pre": "tn/3E-02.jpg",
    "reg": "74384",
    "sea": "Cu",
    "ses": "3E",
    "con": "3E-02 Enantioselective control of a copper-artificial metalloenzyme by chemical modification with thiopyridine (<sup>1</sup>Graduate School of Agriculture, Osaka Metropolitan University) 〇Yoshitsugu Morita<sup>1</sup>, Hiroki Kubo<sup>1</sup>, Ryusei Matsumoto<sup>1</sup>, Nobutaka Fujieda<sup>1</sup> Cu"
  },
  {
    "inf": [
      "アルボマイシン生合成における硫黄挿入酵素の同定",
      "(<sup>1</sup>東大院薬・<sup>2</sup>テキサス大) 〇牛丸 理一郎<sup>1,2</sup>・森 貴裕<sup>1</sup>・Ziyang Zhang<sup>2</sup>・Hung-wen Liu<sup>2</sup>・阿部 郁朗<sup>1</sup>",
      "Identification of a sulfur insertion enzyme during albomycin biosynthesis",
      "(<sup>1</sup>Grad. Sch. Pharm. Sci., Tokyo Univ., <sup>2</sup>Dept. Chem., U. Texas at Austin) 〇Richiro Ushimaru<sup>1,2</sup>, Takahiro Mori<sup>1</sup>, Ziyang Zhang<sup>2</sup>, Hung-wen Liu<sup>2</sup>, Ikuro Abe<sup>1</sup>"
    ],
    "lab": "3E-03",
    "pdf": "pdf/3E-03.pdf",
    "pre": "tn/3E-03.jpg",
    "reg": "74162",
    "sea": "Fe",
    "ses": "3E",
    "con": "3E-03 アルボマイシン生合成における硫黄挿入酵素の同定 (<sup>1</sup>東大院薬・<sup>2</sup>テキサス大) 〇牛丸 理一郎<sup>1,2</sup>・森 貴裕<sup>1</sup>・Ziyang Zhang<sup>2</sup>・Hung-wen Liu<sup>2</sup>・阿部 郁朗<sup>1</sup> Identification of a sulfur insertion enzyme during albomycin biosynthesis (<sup>1</sup>Grad. Sch. Pharm. Sci., Tokyo Univ., <sup>2</sup>Dept. Chem., U. Texas at Austin) 〇Richiro Ushimaru<sup>1,2</sup>, Takahiro Mori<sup>1</sup>, Ziyang Zhang<sup>2</sup>, Hung-wen Liu<sup>2</sup>, Ikuro Abe<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Reconstituted myoglobin with an artificial cofactor with a highly positive redox potential for olefin cyclopropanation",
      "(<sup>1</sup>Osaka Univ.) 〇Koji Oohora<sup>1</sup>, Yoshiyuki Kagawa<sup>1</sup>, Takashi Hayashi<sup>1</sup>"
    ],
    "lab": "3E-04",
    "pdf": "pdf/3E-04.pdf",
    "pre": "tn/3E-04.jpg",
    "reg": "74473",
    "sea": "Fe",
    "ses": "3E",
    "con": "3E-04 Reconstituted myoglobin with an artificial cofactor with a highly positive redox potential for olefin cyclopropanation (<sup>1</sup>Osaka Univ.) 〇Koji Oohora<sup>1</sup>, Yoshiyuki Kagawa<sup>1</sup>, Takashi Hayashi<sup>1</sup> Fe"
  },
  {
    "inf": [
      "籠型配位子内に構築した鉄硫黄クラスターの構造と性質",
      "(<sup>1</sup>阪大院理 ) 〇長松 幸輝<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup>",
      "Structures and Properties of Iron–Sulfur Clusters Encapsulated in a Cage-Type Ligand",
      "(<sup>1</sup>Osaka Univ.) 〇Koki NAGAMATSU<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup>"
    ],
    "lab": "3E-05",
    "pdf": "pdf/3E-05.pdf",
    "pre": "tn/3E-05.jpg",
    "reg": "74140",
    "sea": "Fe",
    "ses": "3E",
    "con": "3E-05 籠型配位子内に構築した鉄硫黄クラスターの構造と性質 (<sup>1</sup>阪大院理 ) 〇長松 幸輝<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup> Structures and Properties of Iron–Sulfur Clusters Encapsulated in a Cage-Type Ligand (<sup>1</sup>Osaka Univ.) 〇Koki NAGAMATSU<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Dramatic enhancement of cytochronme c catalytic activity associated with a Rh coordination cage",
      "(<sup>1</sup>Kyushu University) 〇Benjamin Le Ouay<sup>1</sup>, Yuri Kanzaki<sup>1</sup>, Purna Boruah<sup>1</sup>, Ryo Ohtani<sup>1</sup>, Masaaki Ohba<sup>1</sup>"
    ],
    "lab": "3E-06",
    "pdf": "pdf/3E-06.pdf",
    "pre": "tn/3E-06.jpg",
    "reg": "74259",
    "sea": "Fe, Rh",
    "ses": "3E",
    "con": "3E-06 Dramatic enhancement of cytochronme c catalytic activity associated with a Rh coordination cage (<sup>1</sup>Kyushu University) 〇Benjamin Le Ouay<sup>1</sup>, Yuri Kanzaki<sup>1</sup>, Purna Boruah<sup>1</sup>, Ryo Ohtani<sup>1</sup>, Masaaki Ohba<sup>1</sup> Fe, Rh"
  },
  {
    "inf": [
      "Discovery of Novel Aldoxime Dehydratase Enzymes for Radical Ring-opening Reaction of Cyclobutanone Oximes ",
      "(<sup>1</sup>Osaka Univ.) 〇Shunsuke Kato<sup>1</sup>, Haruka Nishiwaki<sup>1</sup>, Keiji Endo<sup>1</sup>, Takashi Hayashi<sup>1</sup>"
    ],
    "lab": "3E-07",
    "pdf": "pdf/3E-07.pdf",
    "pre": "tn/3E-07.jpg",
    "reg": "74057",
    "sea": "Fe",
    "ses": "3E",
    "con": "3E-07 Discovery of Novel Aldoxime Dehydratase Enzymes for Radical Ring-opening Reaction of Cyclobutanone Oximes  (<sup>1</sup>Osaka Univ.) 〇Shunsuke Kato<sup>1</sup>, Haruka Nishiwaki<sup>1</sup>, Keiji Endo<sup>1</sup>, Takashi Hayashi<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Photo-duet Synthesis of Various Amide Utilizing Dual Function of B<sub>12</sub> Derivative as Catalyst and Photosensitizer",
      "(<sup>1</sup>Kyushu Univ., <sup>2</sup>Osaka Univ.) 〇Kaito SASAKI<sup>1</sup>, Keita SHICHIJO<sup>2</sup>, Mamoru FUJITSUKA<sup>2</sup>, Hisashi SHIMAKOSHI<sup>1</sup>"
    ],
    "lab": "3E-09",
    "pdf": "pdf/3E-09.pdf",
    "pre": "tn/3E-09.jpg",
    "reg": "74305",
    "sea": "Co",
    "ses": "3E",
    "con": "3E-09 Photo-duet Synthesis of Various Amide Utilizing Dual Function of B<sub>12</sub> Derivative as Catalyst and Photosensitizer (<sup>1</sup>Kyushu Univ., <sup>2</sup>Osaka Univ.) 〇Kaito SASAKI<sup>1</sup>, Keita SHICHIJO<sup>2</sup>, Mamoru FUJITSUKA<sup>2</sup>, Hisashi SHIMAKOSHI<sup>1</sup> Co"
  },
  {
    "inf": [
      "Copper stress to folding progress: Metal-responsive promotion of oxidative protein folding by ligand-tethering disulfide compounds",
      "(<sup>1</sup>Tokyo Univ. of Agri. and Tech., <sup>2</sup>KISTEC) 〇Keita MORI<sup>1</sup>, Takahiro MURAOKA<sup>1,2</sup>"
    ],
    "lab": "3E-10",
    "pdf": "pdf/3E-10.pdf",
    "pre": "tn/3E-10.jpg",
    "reg": "74413",
    "sea": "Cu",
    "ses": "3E",
    "con": "3E-10 Copper stress to folding progress: Metal-responsive promotion of oxidative protein folding by ligand-tethering disulfide compounds (<sup>1</sup>Tokyo Univ. of Agri. and Tech., <sup>2</sup>KISTEC) 〇Keita MORI<sup>1</sup>, Takahiro MURAOKA<sup>1,2</sup> Cu"
  },
  {
    "inf": [
      "ルテニウム(II) トリスーキレート型ポリピリジル錯体の暗所下における抗がん活性",
      "(<sup>1</sup>関西大化学生命工・<sup>2</sup>東北大学際研・<sup>3</sup>大阪医薬大薬) 〇石田 斉<sup>1</sup>・原 愛美<sup>1</sup>・小柳恵理<sup>2</sup>・佐藤伸一<sup>2</sup>・平田佳之<sup>3</sup>",
      "Anti-Cancer Activity of Ruthenium(II) Tris-Chelate Polypyridyl Complexes under Dark Conditions",
      "(<sup>1</sup>Faculty of Chemistry, Materials and Bioengineering, Kansai University, <sup>2</sup>Frontier Research Institute for Interdisciplinary Sciences, Tohoku University, <sup>3</sup>Faculty of Pharmacy, Osaka Medical and Pharmaceutical University) 〇Hitoshi ISHIDA<sup>1</sup>, Manami HARA<sup>1</sup>, Eri KOYANAGI<sup>2</sup>, Shinichi SATO<sup>2</sup>, Yoshiyuki HIRATA<sup>3</sup>"
    ],
    "lab": "3E-11",
    "pdf": "pdf/3E-11.pdf",
    "pre": "tn/3E-11.jpg",
    "reg": "74011",
    "sea": "Ru",
    "ses": "3E",
    "con": "3E-11 ルテニウム(II) トリスーキレート型ポリピリジル錯体の暗所下における抗がん活性 (<sup>1</sup>関西大化学生命工・<sup>2</sup>東北大学際研・<sup>3</sup>大阪医薬大薬) 〇石田 斉<sup>1</sup>・原 愛美<sup>1</sup>・小柳恵理<sup>2</sup>・佐藤伸一<sup>2</sup>・平田佳之<sup>3</sup> Anti-Cancer Activity of Ruthenium(II) Tris-Chelate Polypyridyl Complexes under Dark Conditions (<sup>1</sup>Faculty of Chemistry, Materials and Bioengineering, Kansai University, <sup>2</sup>Frontier Research Institute for Interdisciplinary Sciences, Tohoku University, <sup>3</sup>Faculty of Pharmacy, Osaka Medical and Pharmaceutical University) 〇Hitoshi ISHIDA<sup>1</sup>, Manami HARA<sup>1</sup>, Eri KOYANAGI<sup>2</sup>, Shinichi SATO<sup>2</sup>, Yoshiyuki HIRATA<sup>3</sup> Ru"
  },
  {
    "inf": [
      "透明メソポーラスFeNiO<sub>x</sub>薄膜の配位子制御合成と高効率酸素発生反応",
      "(<sup>1</sup>新潟大学) 黄 昕陽<sup>1</sup>・デブラジ チャンドラ<sup>1</sup>・坪ノ内 優太<sup>1</sup>・ザキ ザハラン<sup>1</sup>・〇八木 政行<sup>1</sup>",
      "Ligand-assisted fabrication of transparent mesoporous FeNiO<sub>x</sub> films for efficient electrocatalytic water oxidation",
      "(<sup>1</sup>Niigata University) Xinyang Huang<sup>1</sup>, Debraj Chandra<sup>1</sup>, Yuta Tsubonouchi<sup>1</sup>, Zaki N. Zahran<sup>1</sup>, 〇Masayuki Yagi<sup>1</sup>"
    ],
    "lab": "3Fa-01",
    "pdf": "pdf/3Fa-01.pdf",
    "pre": "tn/3Fa-01.jpg",
    "reg": "74127",
    "sea": "Ni, Fe",
    "ses": "3Fa",
    "con": "3Fa-01 透明メソポーラスFeNiO<sub>x</sub>薄膜の配位子制御合成と高効率酸素発生反応 (<sup>1</sup>新潟大学) 黄 昕陽<sup>1</sup>・デブラジ チャンドラ<sup>1</sup>・坪ノ内 優太<sup>1</sup>・ザキ ザハラン<sup>1</sup>・〇八木 政行<sup>1</sup> Ligand-assisted fabrication of transparent mesoporous FeNiO<sub>x</sub> films for efficient electrocatalytic water oxidation (<sup>1</sup>Niigata University) Xinyang Huang<sup>1</sup>, Debraj Chandra<sup>1</sup>, Yuta Tsubonouchi<sup>1</sup>, Zaki N. Zahran<sup>1</sup>, 〇Masayuki Yagi<sup>1</sup> Ni, Fe"
  },
  {
    "inf": [
      "Anion-exchangeable defective UiO-66 for nitrate removal in water",
      "(<sup>1</sup>Graduate School of Environmental Science, Hokkaido Univ., <sup>2</sup>Faculty of Environmental and Earth Science, Hokkaido Univ.) 〇Aditya Irfan Witono<sup>1</sup>, Xin Zheng<sup>1,2</sup>, Shin-ichiro Noro<sup>1,2</sup>"
    ],
    "lab": "3Fa-02",
    "pdf": "pdf/3Fa-02.pdf",
    "pre": "tn/3Fa-02.jpg",
    "reg": "74480",
    "sea": "Zr",
    "ses": "3Fa",
    "con": "3Fa-02 Anion-exchangeable defective UiO-66 for nitrate removal in water (<sup>1</sup>Graduate School of Environmental Science, Hokkaido Univ., <sup>2</sup>Faculty of Environmental and Earth Science, Hokkaido Univ.) 〇Aditya Irfan Witono<sup>1</sup>, Xin Zheng<sup>1,2</sup>, Shin-ichiro Noro<sup>1,2</sup> Zr"
  },
  {
    "inf": [
      "Highly selective adsorption of Cs<sup>+</sup> by giant inorganic capsules",
      "(<sup>1</sup>Grad. Sch. Arts and Sci., The Univ. of Tokyo) 〇Ken WANG<sup>1</sup>, Tsukasa IWANO<sup>1</sup>, Sayaka UCHIDA<sup>1</sup>"
    ],
    "lab": "3Fa-03",
    "pdf": "pdf/3Fa-03.pdf",
    "pre": "tn/3Fa-03.jpg",
    "reg": "74235",
    "sea": "Mo, Fe, W",
    "ses": "3Fa",
    "con": "3Fa-03 Highly selective adsorption of Cs<sup>+</sup> by giant inorganic capsules (<sup>1</sup>Grad. Sch. Arts and Sci., The Univ. of Tokyo) 〇Ken WANG<sup>1</sup>, Tsukasa IWANO<sup>1</sup>, Sayaka UCHIDA<sup>1</sup> Mo, Fe, W"
  },
  {
    "inf": [
      "Prussian blue analogue Cathode as a Selective Adsorbent for Ammonium Ions in Sodium-Rich Solutions",
      "(<sup>1</sup>National Institute of Advanced Industrial Science and Technology (AIST), Nanomaterials Research Institute) 〇Yuta Shudo<sup></sup>, Yutaka Sugiyama<sup></sup>, Tohru Kawamoto<sup></sup>, Hisashi Tanaka<sup></sup>"
    ],
    "lab": "3Fa-04",
    "pdf": "pdf/3Fa-04.pdf",
    "pre": "tn/3Fa-04.jpg",
    "reg": "74223",
    "sea": "Fe, Ni, Cu",
    "ses": "3Fa",
    "con": "3Fa-04 Prussian blue analogue Cathode as a Selective Adsorbent for Ammonium Ions in Sodium-Rich Solutions (<sup>1</sup>National Institute of Advanced Industrial Science and Technology (AIST), Nanomaterials Research Institute) 〇Yuta Shudo<sup></sup>, Yutaka Sugiyama<sup></sup>, Tohru Kawamoto<sup></sup>, Hisashi Tanaka<sup></sup> Fe, Ni, Cu"
  },
  {
    "inf": [
      "Separation of small hydrocarbon mixtures by selective adsorption into microporous metal-organic frameworks",
      "(<sup>1</sup>Tokyo Tech, <sup>2</sup>ENEOS Corporation) 〇Pavel M. Usov<sup>1</sup>, Joonsik Kim<sup>1</sup>, Tomoyuki Umeyama<sup>1</sup>, Yuki Wada<sup>1</sup>, Hiroyoshi Ohtsu<sup>1</sup>, Takaya Matsumoto<sup>1,2</sup>, Masaki Kawano<sup>1</sup>"
    ],
    "lab": "3Fa-05",
    "pdf": "pdf/3Fa-05.pdf",
    "pre": "tn/3Fa-05.jpg",
    "reg": "74529",
    "sea": "Cu",
    "ses": "3Fa",
    "con": "3Fa-05 Separation of small hydrocarbon mixtures by selective adsorption into microporous metal-organic frameworks (<sup>1</sup>Tokyo Tech, <sup>2</sup>ENEOS Corporation) 〇Pavel M. Usov<sup>1</sup>, Joonsik Kim<sup>1</sup>, Tomoyuki Umeyama<sup>1</sup>, Yuki Wada<sup>1</sup>, Hiroyoshi Ohtsu<sup>1</sup>, Takaya Matsumoto<sup>1,2</sup>, Masaki Kawano<sup>1</sup> Cu"
  },
  {
    "inf": [
      "Two-step Hydrogen Adsorption of the Ruthenium Dihydrogen Complex in the Solid State",
      "(<sup>1</sup>Department of Chemistry, Graduate School of Science, Tohoku University) 〇Shunya TANAKA<sup>1</sup>, Ryojun TOYODA<sup>1</sup>, Ryota SAKAMOTO<sup>1</sup>, Shinya TAKAISHI<sup>1</sup>"
    ],
    "lab": "3Fa-06",
    "pdf": "pdf/3Fa-06.pdf",
    "pre": "tn/3Fa-06.jpg",
    "reg": "74361",
    "sea": "Ru",
    "ses": "3Fa",
    "con": "3Fa-06 Two-step Hydrogen Adsorption of the Ruthenium Dihydrogen Complex in the Solid State (<sup>1</sup>Department of Chemistry, Graduate School of Science, Tohoku University) 〇Shunya TANAKA<sup>1</sup>, Ryojun TOYODA<sup>1</sup>, Ryota SAKAMOTO<sup>1</sup>, Shinya TAKAISHI<sup>1</sup> Ru"
  },
  {
    "inf": [
      "H<sub>2</sub>/D<sub>2</sub> Separation at Room Temperature using Solid-Dtate Dihydrogen Complexes",
      "(<sup>1</sup>Department of Chemistry, Graduate School of Science, Tohoku University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Shinya TAKAISHI<sup>1</sup>, Tamon YAMAUCHI<sup>1</sup>, Naoki KISHIMOTO<sup>1</sup>, Shin-ichiro NORO<sup>2</sup>"
    ],
    "lab": "3Fa-07",
    "pdf": "pdf/3Fa-07.pdf",
    "pre": "tn/3Fa-07.jpg",
    "reg": "74353",
    "sea": "Mn, Cu",
    "ses": "3Fa",
    "con": "3Fa-07 H<sub>2</sub>/D<sub>2</sub> Separation at Room Temperature using Solid-Dtate Dihydrogen Complexes (<sup>1</sup>Department of Chemistry, Graduate School of Science, Tohoku University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Shinya TAKAISHI<sup>1</sup>, Tamon YAMAUCHI<sup>1</sup>, Naoki KISHIMOTO<sup>1</sup>, Shin-ichiro NORO<sup>2</sup> Mn, Cu"
  },
  {
    "inf": [
      "Engineering Flexible Porous Coordination Polymers for Enhanced Gas Adsorption at Room Temperature",
      "(<sup>1</sup>iCeMS, Kyoto University) 〇Ken-ichi Otake<sup>1</sup>, Tao Jia<sup>1</sup>, Hirotoshi Sakamoto<sup>1</sup>, Susumu Kitagawa<sup>1</sup>"
    ],
    "lab": "3Fa-09",
    "pdf": "pdf/3Fa-09.pdf",
    "pre": "tn/3Fa-09.jpg",
    "reg": "74042",
    "sea": "Zn, Co",
    "ses": "3Fa",
    "con": "3Fa-09 Engineering Flexible Porous Coordination Polymers for Enhanced Gas Adsorption at Room Temperature (<sup>1</sup>iCeMS, Kyoto University) 〇Ken-ichi Otake<sup>1</sup>, Tao Jia<sup>1</sup>, Hirotoshi Sakamoto<sup>1</sup>, Susumu Kitagawa<sup>1</sup> Zn, Co"
  },
  {
    "inf": [
      "The effect of linker-substitution on the particle morphology, pore surface and water adsorption properties of MIL-101",
      "(<sup>1</sup>Niterra Co., Ltd., <sup>2</sup>Nagoya Univ.) 〇Masaki WADAGUCHI<sup>1,2</sup>, Shinpei KUSAKA<sup>2</sup>, Yuh HIJIKATA<sup>2</sup>, Hiroaki IGUCHI<sup>2</sup>, Hisashi KOZUKA<sup>1</sup>, Ryotaro MATSUDA<sup>2</sup>"
    ],
    "lab": "3Fa-10",
    "pdf": "pdf/3Fa-10.pdf",
    "pre": "tn/3Fa-10.jpg",
    "reg": "74043",
    "sea": "Cr",
    "ses": "3Fa",
    "con": "3Fa-10 The effect of linker-substitution on the particle morphology, pore surface and water adsorption properties of MIL-101 (<sup>1</sup>Niterra Co., Ltd., <sup>2</sup>Nagoya Univ.) 〇Masaki WADAGUCHI<sup>1,2</sup>, Shinpei KUSAKA<sup>2</sup>, Yuh HIJIKATA<sup>2</sup>, Hiroaki IGUCHI<sup>2</sup>, Hisashi KOZUKA<sup>1</sup>, Ryotaro MATSUDA<sup>2</sup> Cr"
  },
  {
    "inf": [
      "Control of CO<sub>2</sub>/N<sub>2</Sub> selectivity by stepwise fluorination of isoreticular ultramicroporous Zn-based metal-organic frameworks",
      "(<sup>1</sup>Graduate School of Science, Kyoto University, <sup>2</sup> Institute for Integrated Cell-Material Sciences (iCeMS), Kyoto University) 〇Tuo Di<sup>1</sup>, Yukihiro Yoshida<sup>1</sup>, Ken-ichi Otake<sup>2</sup>, Susumu Kitagawa<sup>2</sup>, Hiroshi Kitagawa<sup>1</sup>"
    ],
    "lab": "3Fa-11",
    "pdf": "pdf/3Fa-11.pdf",
    "pre": "tn/3Fa-11.jpg",
    "reg": "74192",
    "sea": "Zn",
    "ses": "3Fa",
    "con": "3Fa-11 Control of CO<sub>2</sub>/N<sub>2</Sub> selectivity by stepwise fluorination of isoreticular ultramicroporous Zn-based metal-organic frameworks (<sup>1</sup>Graduate School of Science, Kyoto University, <sup>2</sup> Institute for Integrated Cell-Material Sciences (iCeMS), Kyoto University) 〇Tuo Di<sup>1</sup>, Yukihiro Yoshida<sup>1</sup>, Ken-ichi Otake<sup>2</sup>, Susumu Kitagawa<sup>2</sup>, Hiroshi Kitagawa<sup>1</sup> Zn"
  },
  {
    "inf": [
      "液相または気相中の希薄過酸化水素に対する亜鉛を含むシアノ架橋配位高分子の吸脱着特性",
      "(<sup>1</sup>阪公大院工・<sup>2</sup>阪公大人工光合成セ・<sup>3</sup>大陽日酸) 〇八田 浩紀<sup>1</sup>・中薗 孝志<sup>2</sup>・和田 吉史<sup>3</sup>・村田 逸人<sup>3</sup>・清水 秀治<sup>3</sup>・山田 裕介<sup>1, 2</sup>",
      "Adsorption and desorption properties of cyano-bridged coordination polymers           for dilute hydrogen peroxide in liquid or gas phase",
      "(<sup>1</sup>Graduate School of Engineering, Osaka Metropolitan Univ., <sup>2</sup>Research Center for Artificial Photosynthesis, Osaka Metropolitan Univ., <sup>3</sup>Taiyo Nippon Sanso Corp.) 〇Hiroki HATTA<sup>1</sup>, Takashi NAKAZONO<sup>2</sup>, Yoshifumi WADA<sup>3</sup>, Hayato MURATA<sup>3</sup>, Hideharu SHIMIZU<sup>3</sup>, Yusuke YAMADA<sup>1, 2</sup>"
    ],
    "lab": "3Fa-12",
    "pdf": "pdf/3Fa-12.pdf",
    "pre": "tn/3Fa-12.jpg",
    "reg": "74055",
    "sea": "Zn, Fe, Co, Mn, W",
    "ses": "3Fa",
    "con": "3Fa-12 液相または気相中の希薄過酸化水素に対する亜鉛を含むシアノ架橋配位高分子の吸脱着特性 (<sup>1</sup>阪公大院工・<sup>2</sup>阪公大人工光合成セ・<sup>3</sup>大陽日酸) 〇八田 浩紀<sup>1</sup>・中薗 孝志<sup>2</sup>・和田 吉史<sup>3</sup>・村田 逸人<sup>3</sup>・清水 秀治<sup>3</sup>・山田 裕介<sup>1, 2</sup> Adsorption and desorption properties of cyano-bridged coordination polymers           for dilute hydrogen peroxide in liquid or gas phase (<sup>1</sup>Graduate School of Engineering, Osaka Metropolitan Univ., <sup>2</sup>Research Center for Artificial Photosynthesis, Osaka Metropolitan Univ., <sup>3</sup>Taiyo Nippon Sanso Corp.) 〇Hiroki HATTA<sup>1</sup>, Takashi NAKAZONO<sup>2</sup>, Yoshifumi WADA<sup>3</sup>, Hayato MURATA<sup>3</sup>, Hideharu SHIMIZU<sup>3</sup>, Yusuke YAMADA<sup>1, 2</sup> Zn, Fe, Co, Mn, W"
  },
  {
    "inf": [
      "Creation of Redox-Active Metal–Organic Framework nanofluids",
      "(<sup>1</sup>Grad. Sch. Sci., Univ. Tokyo) 〇Akihiro SUGUNO<sup>1</sup>, Genki HATAKEYAMA<sup>1</sup>, Kunyi LENG<sup>1</sup>, Teppei YAMADA<sup>1</sup>"
    ],
    "lab": "3Fa-13",
    "pdf": "pdf/3Fa-13.pdf",
    "pre": "tn/3Fa-13.jpg",
    "reg": "74161",
    "sea": "Fe",
    "ses": "3Fa",
    "con": "3Fa-13 Creation of Redox-Active Metal–Organic Framework nanofluids (<sup>1</sup>Grad. Sch. Sci., Univ. Tokyo) 〇Akihiro SUGUNO<sup>1</sup>, Genki HATAKEYAMA<sup>1</sup>, Kunyi LENG<sup>1</sup>, Teppei YAMADA<sup>1</sup> Fe"
  },
  {
    "inf": [
      "Sequential post-synthetic modifications of chemically robust metal-organic polyhedra",
      "(<sup>1</sup>iCeMS, Kyoto Univ., <sup>2</sup>Grad. Sch. Eng., Kyoto Univ.) 〇Tomoki TATEISHI<sup>1</sup>, Shun TOKUDA<sup>1,2</sup>, Shuhei FURUKAWA<sup>1,2</sup>"
    ],
    "lab": "3Fa-14",
    "pdf": "pdf/3Fa-14.pdf",
    "pre": "tn/3Fa-14.jpg",
    "reg": "74027",
    "sea": "Rh",
    "ses": "3Fa",
    "con": "3Fa-14 Sequential post-synthetic modifications of chemically robust metal-organic polyhedra (<sup>1</sup>iCeMS, Kyoto Univ., <sup>2</sup>Grad. Sch. Eng., Kyoto Univ.) 〇Tomoki TATEISHI<sup>1</sup>, Shun TOKUDA<sup>1,2</sup>, Shuhei FURUKAWA<sup>1,2</sup> Rh"
  },
  {
    "inf": [
      "Three-dimensional van der Waals open frameworks assembled from metal-organic polyhedra",
      "(<sup>1</sup>Kyoto Univ) Shun Tokuda<sup>1</sup>, 〇Shuhei Furukawa<sup>1</sup>"
    ],
    "lab": "3Fa-15",
    "pdf": "pdf/3Fa-15.pdf",
    "pre": "tn/3Fa-15.jpg",
    "reg": "74591",
    "sea": "Rh, Cu",
    "ses": "3Fa",
    "con": "3Fa-15 Three-dimensional van der Waals open frameworks assembled from metal-organic polyhedra (<sup>1</sup>Kyoto Univ) Shun Tokuda<sup>1</sup>, 〇Shuhei Furukawa<sup>1</sup> Rh, Cu"
  },
  {
    "inf": [
      "Gas detection of Eu(III)/Tb(III) coordination polymers with triple-stranded helical structure",
      "(<sup>1</sup>Grad. Sch. of Chem. Sci. Eng., Hokkaido Univ., <sup>2</sup>Fac. of Eng., Hokkaido Univ., <sup>3</sup>WPI- ICReDD, Hokkaido Univ.) 〇Joe HAYASHI<sup>1</sup>, Mengfei WANG<sup>2,3</sup>, Yuichi KITAGAWA<sup>2,3</sup>, Yasuchika HASEGAWA<sup>2,3</sup>"
    ],
    "lab": "3Fb-01",
    "pdf": "pdf/3Fb-01.pdf",
    "pre": "tn/3Fb-01.jpg",
    "reg": "74112",
    "sea": "Eu, Tb",
    "ses": "3Fb",
    "con": "3Fb-01 Gas detection of Eu(III)/Tb(III) coordination polymers with triple-stranded helical structure (<sup>1</sup>Grad. Sch. of Chem. Sci. Eng., Hokkaido Univ., <sup>2</sup>Fac. of Eng., Hokkaido Univ., <sup>3</sup>WPI- ICReDD, Hokkaido Univ.) 〇Joe HAYASHI<sup>1</sup>, Mengfei WANG<sup>2,3</sup>, Yuichi KITAGAWA<sup>2,3</sup>, Yasuchika HASEGAWA<sup>2,3</sup> Eu, Tb"
  },
  {
    "inf": [
      "Large magneto-chiral luminescence of tetrakis-type chiral Eu(III) complexes at room temperature",
      "(<sup>1</sup>Grad. Sch. Chem. Sci. Eng., Hokkaido Univ., <sup>2</sup>IMR, Tohoku Univ., <sup>3</sup>WPI-ICReDD, Hokkaido Univ., <sup>4</sup>Fac. Eng. Hokkaido Univ., <sup>5</sup>IIS,  UTokyo) 〇Kosuke ITAYA<sup>1</sup>, Shojiro KIMURA<sup>2</sup>, Mengfei WANG<sup>3,4</sup>, Kazuyuki ISHII<sup>5</sup>, Yasuchika HASEGAWA<sup>3,4</sup>, Yuichi KITAGAWA<sup>3,4</sup>"
    ],
    "lab": "3Fb-02",
    "pdf": "pdf/3Fb-02.pdf",
    "pre": "tn/3Fb-02.jpg",
    "reg": "74304",
    "sea": "Eu",
    "ses": "3Fb",
    "con": "3Fb-02 Large magneto-chiral luminescence of tetrakis-type chiral Eu(III) complexes at room temperature (<sup>1</sup>Grad. Sch. Chem. Sci. Eng., Hokkaido Univ., <sup>2</sup>IMR, Tohoku Univ., <sup>3</sup>WPI-ICReDD, Hokkaido Univ., <sup>4</sup>Fac. Eng. Hokkaido Univ., <sup>5</sup>IIS,  UTokyo) 〇Kosuke ITAYA<sup>1</sup>, Shojiro KIMURA<sup>2</sup>, Mengfei WANG<sup>3,4</sup>, Kazuyuki ISHII<sup>5</sup>, Yasuchika HASEGAWA<sup>3,4</sup>, Yuichi KITAGAWA<sup>3,4</sup> Eu"
  },
  {
    "inf": [
      "Effect of Alkyl Chain Length on the Thermal and Photophysical Properties of Liquid-Crystalline Trinuclear Gold(I) Complexes",
      "(<sup>1</sup>Department of Applied Chemistry, Ritsumeikan University, <sup>2</sup>Department of Chemistry, Indian Institute of Technology Hyderabad) 〇Abhilash SAHU<sup>1</sup>, Kohsuke MATSUMOTO<sup>1</sup>, Ganesan PRABUSANKAR<sup>2</sup>, Osamu TSUTSUMI<sup>1</sup>"
    ],
    "lab": "3Fb-03",
    "pdf": "pdf/3Fb-03.pdf",
    "pre": "tn/3Fb-03.jpg",
    "reg": "74110",
    "sea": "Au",
    "ses": "3Fb",
    "con": "3Fb-03 Effect of Alkyl Chain Length on the Thermal and Photophysical Properties of Liquid-Crystalline Trinuclear Gold(I) Complexes (<sup>1</sup>Department of Applied Chemistry, Ritsumeikan University, <sup>2</sup>Department of Chemistry, Indian Institute of Technology Hyderabad) 〇Abhilash SAHU<sup>1</sup>, Kohsuke MATSUMOTO<sup>1</sup>, Ganesan PRABUSANKAR<sup>2</sup>, Osamu TSUTSUMI<sup>1</sup> Au"
  },
  {
    "inf": [
      "Luminescent Properties of Liquid-Crystalline Gold(I) Complexes with Rod-Like Molecular Structures Containing Branched Alkyl Chains",
      "(<sup>1</sup>Department of Applied Chemistry, Ritsumeikan University.) 〇Renzaburo OTANI<sup>1</sup>, Kohsuke MATSUMOTO<sup>1</sup>, Osamu TSUTSUMI<sup>1</sup>"
    ],
    "lab": "3Fb-04",
    "pdf": "pdf/3Fb-04.pdf",
    "pre": "tn/3Fb-04.jpg",
    "reg": "74125",
    "sea": "Au",
    "ses": "3Fb",
    "con": "3Fb-04 Luminescent Properties of Liquid-Crystalline Gold(I) Complexes with Rod-Like Molecular Structures Containing Branched Alkyl Chains (<sup>1</sup>Department of Applied Chemistry, Ritsumeikan University.) 〇Renzaburo OTANI<sup>1</sup>, Kohsuke MATSUMOTO<sup>1</sup>, Osamu TSUTSUMI<sup>1</sup> Au"
  },
  {
    "inf": [
      "可視光応答光触媒を用いた三分子カップリング反応によるカルボニル化合物のクリーン合成",
      "(<sup>1</sup>九大院工) 〇中島 結衣<sup>1</sup>・星野 友<sup>1</sup>・嶌越 恒<sup>1</sup>",
      "Clean Synthesis of Carbonyl Compounds by Three-component Coupling Reaction Using Visible Light Responsive Photocatalyst",
      "(<sup>1</sup>Kyushu Univ.) 〇Yui NAKASHIMA<sup>1</sup>, Yu HOSHINO<sup>1</sup>, Hisashi SHIMAKOSHI<sup>1</sup>"
    ],
    "lab": "3Fb-05",
    "pdf": "pdf/3Fb-05.pdf",
    "pre": "tn/3Fb-05.jpg",
    "reg": "74210",
    "sea": "Zn",
    "ses": "3Fb",
    "con": "3Fb-05 可視光応答光触媒を用いた三分子カップリング反応によるカルボニル化合物のクリーン合成 (<sup>1</sup>九大院工) 〇中島 結衣<sup>1</sup>・星野 友<sup>1</sup>・嶌越 恒<sup>1</sup> Clean Synthesis of Carbonyl Compounds by Three-component Coupling Reaction Using Visible Light Responsive Photocatalyst (<sup>1</sup>Kyushu Univ.) 〇Yui NAKASHIMA<sup>1</sup>, Yu HOSHINO<sup>1</sup>, Hisashi SHIMAKOSHI<sup>1</sup> Zn"
  },
  {
    "inf": [
      "A Molecular-Based Photoelectrochemical Cell for Highly Efficient Solar-Driven CO<sub>2</sub> Reduction in Water",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ. ) 〇Yuki GOYA<sup>1</sup>, Ken SAKAI<sup>1</sup>, Hironobu OZAWA<sup>1</sup>"
    ],
    "lab": "3Fb-06",
    "pdf": "pdf/3Fb-06.pdf",
    "pre": "tn/3Fb-06.jpg",
    "reg": "74519",
    "sea": "Co, Ru",
    "ses": "3Fb",
    "con": "3Fb-06 A Molecular-Based Photoelectrochemical Cell for Highly Efficient Solar-Driven CO<sub>2</sub> Reduction in Water (<sup>1</sup>Dept. Chem. Kyushu Univ. ) 〇Yuki GOYA<sup>1</sup>, Ken SAKAI<sup>1</sup>, Hironobu OZAWA<sup>1</sup> Co, Ru"
  },
  {
    "inf": [
      "分光電気化学測定を用いたコバルトクロリンによる触媒的水の酸化における反応中間体の検出と反応機構推定",
      "(<sup>1</sup>阪公大院工・<sup>2</sup>阪公大人工光合成セ) 〇光田 凌<sup>1</sup>・中薗 孝志<sup>2</sup>・山田 裕介<sup>1,2</sup>",
      "Intermediates Detection in Water Oxidation with a Cobalt Chlorin by Spectro-Electrochemical Measurements to Clarify the Reaction Mechanism",
      "(<sup>1</sup>Graduate School of Engineering, Osaka Metropolitan University, <sup>2</sup>Research Center for Artificial Photosysnthesis, Osaka Metropolitan University) 〇Ryo MITSUDA<sup>1</sup>, Takashi NAKAZONO<sup>2</sup>, Yusuke YAMADA<sup>1,2</sup>"
    ],
    "lab": "3Fb-07",
    "pdf": "pdf/3Fb-07.pdf",
    "pre": "tn/3Fb-07.jpg",
    "reg": "74041",
    "sea": "Co",
    "ses": "3Fb",
    "con": "3Fb-07 分光電気化学測定を用いたコバルトクロリンによる触媒的水の酸化における反応中間体の検出と反応機構推定 (<sup>1</sup>阪公大院工・<sup>2</sup>阪公大人工光合成セ) 〇光田 凌<sup>1</sup>・中薗 孝志<sup>2</sup>・山田 裕介<sup>1,2</sup> Intermediates Detection in Water Oxidation with a Cobalt Chlorin by Spectro-Electrochemical Measurements to Clarify the Reaction Mechanism (<sup>1</sup>Graduate School of Engineering, Osaka Metropolitan University, <sup>2</sup>Research Center for Artificial Photosysnthesis, Osaka Metropolitan University) 〇Ryo MITSUDA<sup>1</sup>, Takashi NAKAZONO<sup>2</sup>, Yusuke YAMADA<sup>1,2</sup> Co"
  },
  {
    "inf": [
      "硫黄とハロゲンを配位元素とする鉛二価二次元配位高分子の合成と光半導体特性の評価",
      "(<sup>1</sup>関学大理・<sup>2</sup>阪大院工) 〇魚谷 朋生<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯昭紀<sup>2</sup>・田中大輔<sup>1</sup>",
      "Synthesis and Opto-Semiconductor Characterization of 2D Lead(II) Coordination Polymers Containing Sulfur and Halogen Coordination Atoms",
      "(<sup>1</sup>School of Science, Kwansei Gakuin University, <sup>2</sup>Osaka Univ) 〇Tomoki UOTANI<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "3Fb-09",
    "pdf": "pdf/3Fb-09.pdf",
    "pre": "tn/3Fb-09.jpg",
    "reg": "74047",
    "sea": "Pb",
    "ses": "3Fb",
    "con": "3Fb-09 硫黄とハロゲンを配位元素とする鉛二価二次元配位高分子の合成と光半導体特性の評価 (<sup>1</sup>関学大理・<sup>2</sup>阪大院工) 〇魚谷 朋生<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯昭紀<sup>2</sup>・田中大輔<sup>1</sup> Synthesis and Opto-Semiconductor Characterization of 2D Lead(II) Coordination Polymers Containing Sulfur and Halogen Coordination Atoms (<sup>1</sup>School of Science, Kwansei Gakuin University, <sup>2</sup>Osaka Univ) 〇Tomoki UOTANI<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Daisuke TANAKA<sup>1</sup> Pb"
  },
  {
    "inf": [
      "Heterogeneous Catalysis of Coordination Polymer Glass Membranes Involving Mononuclear Metal Complex Catalysts",
      "(<sup>1</sup>IAS-iCeMS, Kyoto Univ., <sup>2</sup>Graduate School of Engineering, Kyoto Univ., <sup>3</sup>Graduate School of Science, Kyoto Univ.) 〇Hiroyasu TABE<sup>1</sup>, Yuji NAMIKI<sup>2</sup>, Satoshi HORIKE<sup>1, 3</sup>"
    ],
    "lab": "3Fb-10",
    "pdf": "pdf/3Fb-10.pdf",
    "pre": "tn/3Fb-10.jpg",
    "reg": "74330",
    "sea": "Zn, Fe, Ir",
    "ses": "3Fb",
    "con": "3Fb-10 Heterogeneous Catalysis of Coordination Polymer Glass Membranes Involving Mononuclear Metal Complex Catalysts (<sup>1</sup>IAS-iCeMS, Kyoto Univ., <sup>2</sup>Graduate School of Engineering, Kyoto Univ., <sup>3</sup>Graduate School of Science, Kyoto Univ.) 〇Hiroyasu TABE<sup>1</sup>, Yuji NAMIKI<sup>2</sup>, Satoshi HORIKE<sup>1, 3</sup> Zn, Fe, Ir"
  },
  {
    "inf": [
      "Prussian Blue Analogue Glasses for Photoinduced CO<sub>2</sub> Conversion",
      "(<sup>1</sup>Graduate School of Science, Kyoto Univ., <sup>2</sup>IAS-iCeMS, Kyoto Univ., <sup>3</sup>VISTEC) 〇Kosasang Soracha<sup>1</sup>, Horike Satoshi<sup>1,2,3</sup>"
    ],
    "lab": "3Fb-11",
    "pdf": "pdf/3Fb-11.pdf",
    "pre": "tn/3Fb-11.jpg",
    "reg": "74540",
    "sea": "Co, Fe",
    "ses": "3Fb",
    "con": "3Fb-11 Prussian Blue Analogue Glasses for Photoinduced CO<sub>2</sub> Conversion (<sup>1</sup>Graduate School of Science, Kyoto Univ., <sup>2</sup>IAS-iCeMS, Kyoto Univ., <sup>3</sup>VISTEC) 〇Kosasang Soracha<sup>1</sup>, Horike Satoshi<sup>1,2,3</sup> Co, Fe"
  },
  {
    "inf": [
      "Cu含浸有機金属構造体(MOF)の電気化学的CO<sub>2</sub>還元活性",
      "(<sup>1</sup>東工大理・<sup>2</sup>ENEOS(株)) 〇金 詩淇<sup>1</sup>・張 望<sup>1</sup>・Pavel M. Usov<sup>1</sup>・松本 隆也<sup>1,2</sup>・河野 正規<sup>1</sup>",
      "Cu-Impregnated Metal-Organic Frameworks (MOFs)---Effect on CO<sub>2</sub> reduction",
      "(<sup>1</sup>Tokyo Tech, <sup>2</sup>ENEOS) 〇Shiqi Jin<sup>1</sup>, Wang Zhang<sup>1</sup>, Pavel M. Usov<sup>1</sup>, Takaya Matsumoto<sup>1,2</sup>, Masaki Kawano<sup>1</sup>"
    ],
    "lab": "3Fb-12",
    "pdf": "pdf/3Fb-12.pdf",
    "pre": "tn/3Fb-12.jpg",
    "reg": "74470",
    "sea": "Zr, Cu",
    "ses": "3Fb",
    "con": "3Fb-12 Cu含浸有機金属構造体(MOF)の電気化学的CO<sub>2</sub>還元活性 (<sup>1</sup>東工大理・<sup>2</sup>ENEOS(株)) 〇金 詩淇<sup>1</sup>・張 望<sup>1</sup>・Pavel M. Usov<sup>1</sup>・松本 隆也<sup>1,2</sup>・河野 正規<sup>1</sup> Cu-Impregnated Metal-Organic Frameworks (MOFs)---Effect on CO<sub>2</sub> reduction (<sup>1</sup>Tokyo Tech, <sup>2</sup>ENEOS) 〇Shiqi Jin<sup>1</sup>, Wang Zhang<sup>1</sup>, Pavel M. Usov<sup>1</sup>, Takaya Matsumoto<sup>1,2</sup>, Masaki Kawano<sup>1</sup> Zr, Cu"
  },
  {
    "inf": [
      "Electrochemical CO<sub>2</sub> reduction reaction using polyoxometalate-based Pd catalysts",
      "(<sup>1</sup>School of Engineering, The University of Tokyo) 〇Kimitake Kawakami<sup>1</sup>, Tomohiro Yabe<sup>1</sup>, Kosuke Suzuki<sup>1</sup>, Kazuya Yamaguchi<sup>1</sup>"
    ],
    "lab": "3Fb-13",
    "pdf": "pdf/3Fb-13.pdf",
    "pre": "tn/3Fb-13.jpg",
    "reg": "74080",
    "sea": "Pd, W, Ba",
    "ses": "3Fb",
    "con": "3Fb-13 Electrochemical CO<sub>2</sub> reduction reaction using polyoxometalate-based Pd catalysts (<sup>1</sup>School of Engineering, The University of Tokyo) 〇Kimitake Kawakami<sup>1</sup>, Tomohiro Yabe<sup>1</sup>, Kosuke Suzuki<sup>1</sup>, Kazuya Yamaguchi<sup>1</sup> Pd, W, Ba"
  },
  {
    "inf": [
      "ヘキサモリブデートのイミド化体の合成および対カチオン変換:電子状態の解析と光触媒能の評価",
      "(<sup>1</sup>東北大院理) 〇梶原尚樹<sup>1</sup>・長田浩一<sup>1</sup>・橋本久子<sup>1</sup>",
      "Imidization and counterion exchange of hexamolybdate : Analysis of electronic states and evaluation of photocatalytic activity",
      "(<sup>1</sup>Tohoku Univ.) 〇Masaki KAJIWARA<sup>1</sup>, Koichi NAGATA<sup>1</sup>, Hisako HASHIMOTO<sup>1</sup>"
    ],
    "lab": "3Fb-14",
    "pdf": "pdf/3Fb-14.pdf",
    "pre": "tn/3Fb-14.jpg",
    "reg": "74035",
    "sea": "Mo",
    "ses": "3Fb",
    "con": "3Fb-14 ヘキサモリブデートのイミド化体の合成および対カチオン変換:電子状態の解析と光触媒能の評価 (<sup>1</sup>東北大院理) 〇梶原尚樹<sup>1</sup>・長田浩一<sup>1</sup>・橋本久子<sup>1</sup> Imidization and counterion exchange of hexamolybdate : Analysis of electronic states and evaluation of photocatalytic activity (<sup>1</sup>Tohoku Univ.) 〇Masaki KAJIWARA<sup>1</sup>, Koichi NAGATA<sup>1</sup>, Hisako HASHIMOTO<sup>1</sup> Mo"
  },
  {
    "inf": [
      "Visualization of domain structure and piezoelectric energy harvesting in a ferroelectric metal–ligand cage",
      "(<sup>1</sup>Indian Institute of Science Education and Research, Pune, India, <sup>2</sup>King Abdullah University of Science and Technology, <sup>3</sup>Armament Research and Development Establishment, Pune,India, <sup>4</sup>Wroclaw University of Science and Technology, Wroclaw, Poland) 〇Neetu Prajesh<sup>1</sup>, Dipti R. Naphade<sup>2</sup>, Ashok Yadav<sup>1</sup>, Vikash Kushwaha<sup>1</sup>, Balu Praveenkumar<sup>3</sup>, Jan K. Zare˛ba<sup>4</sup>, Thomas D. Anthopoulos<sup>2</sup>, Ramamoorthy Boomishankar<sup>1</sup>"
    ],
    "lab": "3Fc-02",
    "pdf": "pdf/3Fc-02.pdf",
    "pre": "tn/3Fc-02.jpg",
    "reg": "74393",
    "sea": "Ni",
    "ses": "3Fc",
    "con": "3Fc-02 Visualization of domain structure and piezoelectric energy harvesting in a ferroelectric metal–ligand cage (<sup>1</sup>Indian Institute of Science Education and Research, Pune, India, <sup>2</sup>King Abdullah University of Science and Technology, <sup>3</sup>Armament Research and Development Establishment, Pune,India, <sup>4</sup>Wroclaw University of Science and Technology, Wroclaw, Poland) 〇Neetu Prajesh<sup>1</sup>, Dipti R. Naphade<sup>2</sup>, Ashok Yadav<sup>1</sup>, Vikash Kushwaha<sup>1</sup>, Balu Praveenkumar<sup>3</sup>, Jan K. Zare˛ba<sup>4</sup>, Thomas D. Anthopoulos<sup>2</sup>, Ramamoorthy Boomishankar<sup>1</sup> Ni"
  },
  {
    "inf": [
      "新規な水溶性コバルト(III)メタロクリプタンドの合成とゲストの取り込み・放出制御",
      "(<sup>1</sup>金沢大院自然・<sup>2</sup>金沢大NanoLSI) 〇山本 侑<sup>1</sup>・秋根 茂久<sup>1,2</sup>",
      "Synthesis of novel water-soluble cobalt(III) metallocryptands and control of guest uptake and release",
      "(<sup>1</sup>Grad. Sch. of Natl. Sci. and Tech., Kanazawa Univ., <sup>2</sup>NanoLSI, Kanazawa Univ.) 〇Yu YAMAMOTO<sup>1</sup>, Shigehisa AKINE<sup>1,2</sup>"
    ],
    "lab": "3Fc-03",
    "pdf": "pdf/3Fc-03.pdf",
    "pre": "tn/3Fc-03.jpg",
    "reg": "74263",
    "sea": "Co",
    "ses": "3Fc",
    "con": "3Fc-03 新規な水溶性コバルト(III)メタロクリプタンドの合成とゲストの取り込み・放出制御 (<sup>1</sup>金沢大院自然・<sup>2</sup>金沢大NanoLSI) 〇山本 侑<sup>1</sup>・秋根 茂久<sup>1,2</sup> Synthesis of novel water-soluble cobalt(III) metallocryptands and control of guest uptake and release (<sup>1</sup>Grad. Sch. of Natl. Sci. and Tech., Kanazawa Univ., <sup>2</sup>NanoLSI, Kanazawa Univ.) 〇Yu YAMAMOTO<sup>1</sup>, Shigehisa AKINE<sup>1,2</sup> Co"
  },
  {
    "inf": [
      "金属5核錯体に内包されたプロトンの動的挙動の開拓",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇青木 良太<sup>1</sup>・小杉 健斗<sup>1,2</sup>・伊豆 仁<sup>1</sup>・松井 千絢<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup>",
      "Development of Dynamic Behavior of Proton Confined in Pentanuclear Metal Complexes",
      "(<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>School of Science, Tokyo Institute of Technology) 〇Ryota AOKI<sup>1</sup>, Kento KOSUGI<sup>1,2</sup>, Hitoshi IZU<sup>1</sup>, Chihiro MATSUI<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "3Fc-04",
    "pdf": "pdf/3Fc-04.pdf",
    "pre": "tn/3Fc-04.jpg",
    "reg": "74417",
    "sea": "Ru,Zn",
    "ses": "3Fc",
    "con": "3Fc-04 金属5核錯体に内包されたプロトンの動的挙動の開拓 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇青木 良太<sup>1</sup>・小杉 健斗<sup>1,2</sup>・伊豆 仁<sup>1</sup>・松井 千絢<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup> Development of Dynamic Behavior of Proton Confined in Pentanuclear Metal Complexes (<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>School of Science, Tokyo Institute of Technology) 〇Ryota AOKI<sup>1</sup>, Kento KOSUGI<sup>1,2</sup>, Hitoshi IZU<sup>1</sup>, Chihiro MATSUI<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup> Ru,Zn"
  },
  {
    "inf": [
      "レドックス活性ピラジンジチオラート白金(Ⅱ)錯体の凝集相制御と外場応答性",
      "(<sup>1</sup>中大院理工・<sup>2</sup>中大理工) 〇田村 竜也<sup>1</sup>・今泉 暁<sup>1</sup>・本田 暁紀<sup>2</sup>・張 浩徹<sup>2</sup>",
      "Condensed Phase Control and External Stimuli Response of Redox-active Pyrazinedithiolate Platinum(II) complexes",
      "(<sup>1</sup>Graduate School of Science and Engineering, Chuo Univ., <sup>2</sup>Faculty of Science and Engineering, Chuo Univ.) 〇Tatsuya TAMURA<sup>1</sup>, Akira IMAIZUMI<sup>1</sup>, Akinori HONDA<sup>2</sup>, Ho-Chol CHANG<sup>2</sup>"
    ],
    "lab": "3Fc-05",
    "pdf": "pdf/3Fc-05.pdf",
    "pre": "tn/3Fc-05.jpg",
    "reg": "74550",
    "sea": "Pt",
    "ses": "3Fc",
    "con": "3Fc-05 レドックス活性ピラジンジチオラート白金(Ⅱ)錯体の凝集相制御と外場応答性 (<sup>1</sup>中大院理工・<sup>2</sup>中大理工) 〇田村 竜也<sup>1</sup>・今泉 暁<sup>1</sup>・本田 暁紀<sup>2</sup>・張 浩徹<sup>2</sup> Condensed Phase Control and External Stimuli Response of Redox-active Pyrazinedithiolate Platinum(II) complexes (<sup>1</sup>Graduate School of Science and Engineering, Chuo Univ., <sup>2</sup>Faculty of Science and Engineering, Chuo Univ.) 〇Tatsuya TAMURA<sup>1</sup>, Akira IMAIZUMI<sup>1</sup>, Akinori HONDA<sup>2</sup>, Ho-Chol CHANG<sup>2</sup> Pt"
  },
  {
    "inf": [
      "ピラジン誘導体を用いたルテニウム三核配位高分子薄膜の合成と エレクトロクロミズム",
      "(<sup>1</sup>兵庫県大院理) 〇星尾 隆徳<sup>1</sup>・下元 直樹<sup>1</sup>・小澤 芳樹<sup>1</sup>・阿部 正明<sup>1</sup>",
      "Synthesis and Electrochromic Properties of Coordination-Polymer Thin Films Prepared from Trinuclear Ruthenium Clusters and Pyrazine Derivatives",
      "(<sup>1</sup>Graduate School of Science, University of Hyogo) 〇Takanori HOSHIO<sup>1</sup>, Naoki SHIMOMOTO<sup>1</sup>, Yoshiki OZAWA<sup>1</sup>, Masaaki ABE<sup>1</sup>"
    ],
    "lab": "3Fc-06",
    "pdf": "pdf/3Fc-06.pdf",
    "pre": "tn/3Fc-06.jpg",
    "reg": "74418",
    "sea": "Ru",
    "ses": "3Fc",
    "con": "3Fc-06 ピラジン誘導体を用いたルテニウム三核配位高分子薄膜の合成と エレクトロクロミズム (<sup>1</sup>兵庫県大院理) 〇星尾 隆徳<sup>1</sup>・下元 直樹<sup>1</sup>・小澤 芳樹<sup>1</sup>・阿部 正明<sup>1</sup> Synthesis and Electrochromic Properties of Coordination-Polymer Thin Films Prepared from Trinuclear Ruthenium Clusters and Pyrazine Derivatives (<sup>1</sup>Graduate School of Science, University of Hyogo) 〇Takanori HOSHIO<sup>1</sup>, Naoki SHIMOMOTO<sup>1</sup>, Yoshiki OZAWA<sup>1</sup>, Masaaki ABE<sup>1</sup> Ru"
  },
  {
    "inf": [
      "ポリオキソメタレートとポリビニルアルコールを基盤とした結晶性プロトン伝導体の創成",
      "(<sup>1</sup>東大院総合文化) 〇山田 裕太<sup>1</sup>・岩野 司<sup>1</sup>・内田 さやか<sup>1</sup>",
      "Synthesis of crystalline proton conductors based on polyoxom and polyvinyl alcohols",
      "(<sup>1</sup>Grad. Sch. Arts and Sci., The Univ. of Tokyo) 〇Yuta Yamada<sup>1</sup>, Tsukasa Iwano<sup>1</sup>, Sayaka Uchida<sup>1</sup>"
    ],
    "lab": "3Fc-07",
    "pdf": "pdf/3Fc-07.pdf",
    "pre": "tn/3Fc-07.jpg",
    "reg": "74340",
    "sea": "Eu,W,P,",
    "ses": "3Fc",
    "con": "3Fc-07 ポリオキソメタレートとポリビニルアルコールを基盤とした結晶性プロトン伝導体の創成 (<sup>1</sup>東大院総合文化) 〇山田 裕太<sup>1</sup>・岩野 司<sup>1</sup>・内田 さやか<sup>1</sup> Synthesis of crystalline proton conductors based on polyoxom and polyvinyl alcohols (<sup>1</sup>Grad. Sch. Arts and Sci., The Univ. of Tokyo) 〇Yuta Yamada<sup>1</sup>, Tsukasa Iwano<sup>1</sup>, Sayaka Uchida<sup>1</sup> Eu,W,P,"
  },
  {
    "inf": [
      "Optical functionalities of cyanidometallate-based magnetic complexes",
      "(<sup>1</sup>Univ. Tokyo) 〇Koji NAKABAYASHI<sup>1</sup>, Kenta IMOTO<sup>1</sup>, Kazuki NAKAMURA<sup>1</sup>, Yuuki MINEO<sup>1</sup>, Tatsuya KONISHI<sup>1</sup>, Shin-ichi OHKOSHI<sup>1</sup>"
    ],
    "lab": "3Fc-09",
    "pdf": "pdf/3Fc-09.pdf",
    "pre": "tn/3Fc-09.jpg",
    "reg": "74453",
    "sea": "W, Co, Fe",
    "ses": "3Fc",
    "con": "3Fc-09 Optical functionalities of cyanidometallate-based magnetic complexes (<sup>1</sup>Univ. Tokyo) 〇Koji NAKABAYASHI<sup>1</sup>, Kenta IMOTO<sup>1</sup>, Kazuki NAKAMURA<sup>1</sup>, Yuuki MINEO<sup>1</sup>, Tatsuya KONISHI<sup>1</sup>, Shin-ichi OHKOSHI<sup>1</sup> W, Co, Fe"
  },
  {
    "inf": [
      "Slow Magnetic Relaxation in Spin Crossover Cobalt(II) Complexes",
      "(<sup>1</sup>Kumamoto Univ.) 〇Hikaru Zenno<sup>1</sup>, Zhang Zhongyue<sup>1</sup>, Yoshihiro Sekine<sup>1</sup>, Shinya Hayami<sup>1</sup>"
    ],
    "lab": "3Fc-10",
    "pdf": "pdf/3Fc-10.pdf",
    "pre": "tn/3Fc-10.jpg",
    "reg": "74555",
    "sea": "Co",
    "ses": "3Fc",
    "con": "3Fc-10 Slow Magnetic Relaxation in Spin Crossover Cobalt(II) Complexes (<sup>1</sup>Kumamoto Univ.) 〇Hikaru Zenno<sup>1</sup>, Zhang Zhongyue<sup>1</sup>, Yoshihiro Sekine<sup>1</sup>, Shinya Hayami<sup>1</sup> Co"
  },
  {
    "inf": [
      "Slow Magnetic Relaxation of Co(II) doped in diamagnetic dimethylglyoxime and salen matrix",
      "(<sup>1</sup>Tohoku University, <sup>2</sup>Jagiellonian University, <sup>3</sup>Chitose Institute of Science and Technology, <sup>4</sup>Tongji University) 〇Yukina Suzuki<sup>1</sup>, Miroslaw Arczynski<sup>2</sup>, Masanori Wakizaka<sup>3</sup>, Ryota Sakamoto<sup>1</sup>, Masahiro Yamashita<sup>1,4</sup>"
    ],
    "lab": "3Fc-11",
    "pdf": "pdf/3Fc-11.pdf",
    "pre": "tn/3Fc-11.jpg",
    "reg": "74236",
    "sea": "Co, Ni, Zn, Cu",
    "ses": "3Fc",
    "con": "3Fc-11 Slow Magnetic Relaxation of Co(II) doped in diamagnetic dimethylglyoxime and salen matrix (<sup>1</sup>Tohoku University, <sup>2</sup>Jagiellonian University, <sup>3</sup>Chitose Institute of Science and Technology, <sup>4</sup>Tongji University) 〇Yukina Suzuki<sup>1</sup>, Miroslaw Arczynski<sup>2</sup>, Masanori Wakizaka<sup>3</sup>, Ryota Sakamoto<sup>1</sup>, Masahiro Yamashita<sup>1,4</sup> Co, Ni, Zn, Cu"
  },
  {
    "inf": [
      "Spin-lattice and spin coherence phenomena of _S_=1/2 oxovanadium(IV)-substituted Keggin-type sulfotungstate",
      "(<sup>1</sup>Nihon Univ., <sup>2</sup>Institute for Molecular Science) 〇Toshiharu ISHIZAKI<sup>1</sup>, Miyu CHIBA<sup>1</sup>, Mizue ASADA<sup>2</sup>, Toshikazu NAKAMURA<sup>2</sup>, Tomoji OZEKI<sup>1</sup>"
    ],
    "lab": "3Fc-12",
    "pdf": "pdf/3Fc-12.pdf",
    "pre": "tn/3Fc-12.jpg",
    "reg": "74548",
    "sea": "V, W",
    "ses": "3Fc",
    "con": "3Fc-12 Spin-lattice and spin coherence phenomena of _S_=1/2 oxovanadium(IV)-substituted Keggin-type sulfotungstate (<sup>1</sup>Nihon Univ., <sup>2</sup>Institute for Molecular Science) 〇Toshiharu ISHIZAKI<sup>1</sup>, Miyu CHIBA<sup>1</sup>, Mizue ASADA<sup>2</sup>, Toshikazu NAKAMURA<sup>2</sup>, Tomoji OZEKI<sup>1</sup> V, W"
  },
  {
    "inf": [
      "Improvement of the guest uptake into crystalline sponge by reducing crystal size and extraction of the dataset by intensity correlation.",
      "(<sup>1</sup>Graduate School of Eng., Univ. of Tokyo, <sup>2</sup>IMS, <sup>3</sup>Inst. for Advanced Study, Univ. of Tokyo) 〇Satoshi Yoshida<sup>1</sup>, Sota Sato<sup>1,2</sup>, Makoto Fujita<sup>2,3</sup>"
    ],
    "lab": "3Fc-13",
    "pdf": "pdf/3Fc-13.pdf",
    "pre": "tn/3Fc-13.jpg",
    "reg": "74454",
    "sea": "Zn",
    "ses": "3Fc",
    "con": "3Fc-13 Improvement of the guest uptake into crystalline sponge by reducing crystal size and extraction of the dataset by intensity correlation. (<sup>1</sup>Graduate School of Eng., Univ. of Tokyo, <sup>2</sup>IMS, <sup>3</sup>Inst. for Advanced Study, Univ. of Tokyo) 〇Satoshi Yoshida<sup>1</sup>, Sota Sato<sup>1,2</sup>, Makoto Fujita<sup>2,3</sup> Zn"
  },
  {
    "inf": [
      "A Versatile MOF Platform with Ordered Water Networks for Guest structure elucidation",
      "(<sup>1</sup>Dept. Chem, Tokyo Tech) 〇YUki Wada<sup>1</sup>, Taichi Baba<sup>1</sup>, Yiying Zhu<sup>1</sup>, Yu Tagami<sup>1</sup>, Pavel M Usov<sup>1</sup>, Masaki Kawano<sup>1</sup>"
    ],
    "lab": "3Fc-14",
    "pdf": "pdf/3Fc-14.pdf",
    "pre": "tn/3Fc-14.jpg",
    "reg": "74521",
    "sea": "Co",
    "ses": "3Fc",
    "con": "3Fc-14 A Versatile MOF Platform with Ordered Water Networks for Guest structure elucidation (<sup>1</sup>Dept. Chem, Tokyo Tech) 〇YUki Wada<sup>1</sup>, Taichi Baba<sup>1</sup>, Yiying Zhu<sup>1</sup>, Yu Tagami<sup>1</sup>, Pavel M Usov<sup>1</sup>, Masaki Kawano<sup>1</sup> Co"
  },
  {
    "inf": [
      "The phase transition behavior of fatty acids in UiO-66",
      "(<sup>1</sup>Univ. Tokyo) 〇Rei YOSHII<sup>1</sup>, Genki HATAKEYAMA<sup>1</sup>, Kunyi LENG<sup>1</sup>, Teppei YAMADA<sup>1</sup>"
    ],
    "lab": "3Fc-15",
    "pdf": "pdf/3Fc-15.pdf",
    "pre": "tn/3Fc-15.jpg",
    "reg": "74256",
    "sea": "Zr",
    "ses": "3Fc",
    "con": "3Fc-15 The phase transition behavior of fatty acids in UiO-66 (<sup>1</sup>Univ. Tokyo) 〇Rei YOSHII<sup>1</sup>, Genki HATAKEYAMA<sup>1</sup>, Kunyi LENG<sup>1</sup>, Teppei YAMADA<sup>1</sup> Zr"
  },
  {
    "inf": [
      "混合タンパク質の共固定化による酵素/金属-有機多面体複合体の性能向上",
      "(<sup>1</sup>九大院理) 〇神崎 友理<sup>1</sup>・ルウェ バンジャマン<sup>1</sup>・大谷 亮<sup>1</sup>・大場 正昭<sup>1</sup>",
      "Enhancing Performances of Enzyme/Metal-Organic Polyhedra Composites by Mixed-Protein Co-Immobilization",
      "(<sup>1</sup>Department of Chemistry, Grad. School of Science, Kyushu Univ.) 〇Yuri KANZAKI<sup>1</sup>, Benjamin LE OUAY<sup>1</sup>, Ryo OHTANI<sup>1</sup>, Masaaki OHBA<sup>1</sup>"
    ],
    "lab": "3Fd-10",
    "pdf": "pdf/3Fd-10.pdf",
    "pre": "tn/3Fd-10.jpg",
    "reg": "74404",
    "sea": "Rh",
    "ses": "3Fd",
    "con": "3Fd-10 混合タンパク質の共固定化による酵素/金属-有機多面体複合体の性能向上 (<sup>1</sup>九大院理) 〇神崎 友理<sup>1</sup>・ルウェ バンジャマン<sup>1</sup>・大谷 亮<sup>1</sup>・大場 正昭<sup>1</sup> Enhancing Performances of Enzyme/Metal-Organic Polyhedra Composites by Mixed-Protein Co-Immobilization (<sup>1</sup>Department of Chemistry, Grad. School of Science, Kyushu Univ.) 〇Yuri KANZAKI<sup>1</sup>, Benjamin LE OUAY<sup>1</sup>, Ryo OHTANI<sup>1</sup>, Masaaki OHBA<sup>1</sup> Rh"
  },
  {
    "inf": [
      "Versatile Enzyme Immobilization in Crystals by Encapsulation in Spherical Coordination Cages",
      "(<sup>1</sup>Graduate School of Engineering, the University of Tokyo, <sup>2</sup>Institute for Molecular Science (IMS), <sup>3</sup>Institutes for Advanced Study, the University of Tokyo) 〇Hongkun Liu<sup>1</sup>, Takahiro Nakama<sup>1</sup>, Shingo Funami<sup>1</sup>, Makoto Fujita<sup>1,2,3</sup>"
    ],
    "lab": "3Fd-11",
    "pdf": "pdf/3Fd-11.pdf",
    "pre": "tn/3Fd-11.jpg",
    "reg": "74375",
    "sea": "Pd",
    "ses": "3Fd",
    "con": "3Fd-11 Versatile Enzyme Immobilization in Crystals by Encapsulation in Spherical Coordination Cages (<sup>1</sup>Graduate School of Engineering, the University of Tokyo, <sup>2</sup>Institute for Molecular Science (IMS), <sup>3</sup>Institutes for Advanced Study, the University of Tokyo) 〇Hongkun Liu<sup>1</sup>, Takahiro Nakama<sup>1</sup>, Shingo Funami<sup>1</sup>, Makoto Fujita<sup>1,2,3</sup> Pd"
  },
  {
    "inf": [
      "Isolation of unfolding proteins by unimolecular encapsulation in coordination cages",
      "(<sup>1</sup>Grad. School of Engineering, The Univ. of Tokyo, <sup>2</sup>Inst. for integrated Radiation and Nuclear Science, Kyoto Univ., <sup>3</sup>Inst. for Molecular Science, <sup>4</sup>UTIAS, The Univ. of Tokyo) 〇Risa Ebihara<sup>1</sup>, Takahiro Nakama<sup>1</sup>, Ken Morishima<sup>2</sup>, Masaaki Sugiyama<sup>2</sup>, Maho Yagi-Utsumi<sup>3</sup>, Makoto Fujita<sup>1,3,4</sup>"
    ],
    "lab": "3Fd-12",
    "pdf": "pdf/3Fd-12.pdf",
    "pre": "tn/3Fd-12.jpg",
    "reg": "74484",
    "sea": "Pd",
    "ses": "3Fd",
    "con": "3Fd-12 Isolation of unfolding proteins by unimolecular encapsulation in coordination cages (<sup>1</sup>Grad. School of Engineering, The Univ. of Tokyo, <sup>2</sup>Inst. for integrated Radiation and Nuclear Science, Kyoto Univ., <sup>3</sup>Inst. for Molecular Science, <sup>4</sup>UTIAS, The Univ. of Tokyo) 〇Risa Ebihara<sup>1</sup>, Takahiro Nakama<sup>1</sup>, Ken Morishima<sup>2</sup>, Masaaki Sugiyama<sup>2</sup>, Maho Yagi-Utsumi<sup>3</sup>, Makoto Fujita<sup>1,3,4</sup> Pd"
  },
  {
    "inf": [
      "Synthesis and properties of a D-penicillaminato 14-nuclear copper cluster with a central sulfide ion",
      "(<sup>1</sup>Osaka University, <sup>2</sup>Hyogo Prefectural Institute of Technology, <sup>3</sup>National Taiwan Normal University) 〇Nobuto YOSHINARI<sup>1</sup>, Momoka SHIHARA<sup>1</sup>, Masaki NOJIRI<sup>1</sup>, Po-Min CHUANG<sup>1</sup>, Masahiro KOUNO<sup>2</sup>, Hui-Ling SUNG<sup>3</sup>, Yasuhiro FUNAHASHI<sup>1</sup>"
    ],
    "lab": "3PA-01",
    "pdf": "pdf/3PA-01.pdf",
    "pre": "tn/3PA-01.jpg",
    "reg": "74564",
    "sea": "Cu",
    "ses": "3PA",
    "con": "3PA-01 Synthesis and properties of a D-penicillaminato 14-nuclear copper cluster with a central sulfide ion (<sup>1</sup>Osaka University, <sup>2</sup>Hyogo Prefectural Institute of Technology, <sup>3</sup>National Taiwan Normal University) 〇Nobuto YOSHINARI<sup>1</sup>, Momoka SHIHARA<sup>1</sup>, Masaki NOJIRI<sup>1</sup>, Po-Min CHUANG<sup>1</sup>, Masahiro KOUNO<sup>2</sup>, Hui-Ling SUNG<sup>3</sup>, Yasuhiro FUNAHASHI<sup>1</sup> Cu"
  },
  {
    "inf": [
      "3d金属元素イオン存在下でのシクロヘキサン-1,3-ジオン類の自発的反応",
      "(<sup>1</sup>日大理工) 〇細谷 遥佑<sup>1</sup>・社藤 夏海<sup>1</sup>・須川 晃資<sup>1</sup>・大月 穣<sup>1</sup>",
      "Spontaneous Reactions of Cyclohexane-1,3-Diones in the Presence of 3d Metal Ions",
      "(<sup>1</sup>Nihon Univ.) 〇Yosuke Hosoya<sup>1</sup>, Natsumi Shato<sup>1</sup>, Kosuke Sugawa<sup>1</sup>, Joe Otsuki<sup>1</sup>"
    ],
    "lab": "3PA-02",
    "pdf": "pdf/3PA-02.pdf",
    "pre": "tn/3PA-02.jpg",
    "reg": "74324",
    "sea": "Co, Cu",
    "ses": "3PA",
    "con": "3PA-02 3d金属元素イオン存在下でのシクロヘキサン-1,3-ジオン類の自発的反応 (<sup>1</sup>日大理工) 〇細谷 遥佑<sup>1</sup>・社藤 夏海<sup>1</sup>・須川 晃資<sup>1</sup>・大月 穣<sup>1</sup> Spontaneous Reactions of Cyclohexane-1,3-Diones in the Presence of 3d Metal Ions (<sup>1</sup>Nihon Univ.) 〇Yosuke Hosoya<sup>1</sup>, Natsumi Shato<sup>1</sup>, Kosuke Sugawa<sup>1</sup>, Joe Otsuki<sup>1</sup> Co, Cu"
  },
  {
    "inf": [
      "ビピリジンリンカー基で連結したイリジウム(Ⅲ)二核錯体の合成と光水素発生反応",
      "(<sup>1</sup>島根大院自然科学) 〇大槙 淳矢<sup>1</sup>・矢野 なつみ<sup>1</sup>・片岡 祐介<sup>1</sup>",
      "Synthesis and photo-hydrogen evolution reactions of the dinuclear iridium (Ⅲ) complexes connected with bipyridine linkers",
      "(<sup>1</sup>Shimane Univ.) 〇Junya OMAKI<sup>1</sup>, Natsumi YANO<sup>1</sup>, Yusuke KATAOKA<sup>1</sup>"
    ],
    "lab": "3PA-03",
    "pdf": "pdf/3PA-03.pdf",
    "pre": "tn/3PA-03.jpg",
    "reg": "74211",
    "sea": "Ir",
    "ses": "3PA",
    "con": "3PA-03 ビピリジンリンカー基で連結したイリジウム(Ⅲ)二核錯体の合成と光水素発生反応 (<sup>1</sup>島根大院自然科学) 〇大槙 淳矢<sup>1</sup>・矢野 なつみ<sup>1</sup>・片岡 祐介<sup>1</sup> Synthesis and photo-hydrogen evolution reactions of the dinuclear iridium (Ⅲ) complexes connected with bipyridine linkers (<sup>1</sup>Shimane Univ.) 〇Junya OMAKI<sup>1</sup>, Natsumi YANO<sup>1</sup>, Yusuke KATAOKA<sup>1</sup> Ir"
  },
  {
    "inf": [
      "発光性レニウム(I)カルボニル錯体とレニウム(III)六核クラスターからなる塩の発光挙動",
      "(<sup>1</sup>大阪大学大学院理学研究科・<sup>2</sup>大阪大学RIセンター) 〇長郷 一紀<sup>1</sup>・吉村 崇<sup>2</sup>",
      "Emission behavior of salts consisting of hexanuclear rhenium(III) clusters and rhenium(I) carbonyl complexes",
      "(<sup>1</sup>Graduate School of Science, Osaka Univ., <sup>2</sup>RI center, Osaka Univ.) 〇Kazuki NAGASATO<sup>1</sup>, Takashi YOSHIMURA<sup>2</sup>"
    ],
    "lab": "3PA-04",
    "pdf": "pdf/3PA-04.pdf",
    "pre": "tn/3PA-04.jpg",
    "reg": "74237",
    "sea": "Re",
    "ses": "3PA",
    "con": "3PA-04 発光性レニウム(I)カルボニル錯体とレニウム(III)六核クラスターからなる塩の発光挙動 (<sup>1</sup>大阪大学大学院理学研究科・<sup>2</sup>大阪大学RIセンター) 〇長郷 一紀<sup>1</sup>・吉村 崇<sup>2</sup> Emission behavior of salts consisting of hexanuclear rhenium(III) clusters and rhenium(I) carbonyl complexes (<sup>1</sup>Graduate School of Science, Osaka Univ., <sup>2</sup>RI center, Osaka Univ.) 〇Kazuki NAGASATO<sup>1</sup>, Takashi YOSHIMURA<sup>2</sup> Re"
  },
  {
    "inf": [
      "四面体型有機ケージMn(III)4核錯体の合成と物性",
      "(<sup>1</sup>筑波大院数物) 〇谷地中 亜海<sup>1</sup>・三原 のぞみ<sup>1</sup>・志賀 拓也<sup>1</sup>・二瓶 雅之<sup>1</sup>",
      "Synthesis and physical properties of a tetranuclear Mn(III) complex of a tetrahedral organic cage",
      "(<sup>1</sup>Degree Programs in Pure and Applied Sciences, Graduate School of Science and Technology, University of Tsukuba) 〇Ami YACHINAKA<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Masayuki NIHEI<sup>1</sup>"
    ],
    "lab": "3PA-05",
    "pdf": "pdf/3PA-05.pdf",
    "pre": "tn/3PA-05.jpg",
    "reg": "74239",
    "sea": "Mn",
    "ses": "3PA",
    "con": "3PA-05 四面体型有機ケージMn(III)4核錯体の合成と物性 (<sup>1</sup>筑波大院数物) 〇谷地中 亜海<sup>1</sup>・三原 のぞみ<sup>1</sup>・志賀 拓也<sup>1</sup>・二瓶 雅之<sup>1</sup> Synthesis and physical properties of a tetranuclear Mn(III) complex of a tetrahedral organic cage (<sup>1</sup>Degree Programs in Pure and Applied Sciences, Graduate School of Science and Technology, University of Tsukuba) 〇Ami YACHINAKA<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Masayuki NIHEI<sup>1</sup> Mn"
  },
  {
    "inf": [
      "キラルな単分子磁石の創成を目指した三脚型 Schiff 塩基配位子を含む Co<sup>II</sup>-Tb<sup>III</sup>-Co<sup>II</sup> 三核錯体の結晶化挙動の制御",
      "(<sup>1</sup>岡山大院環境生命自然・<sup>2</sup>兵庫県大院理・<sup>3</sup>岡山大院自然・<sup>4</sup>岡山大自然生命セ・<sup>5</sup>岡山大基礎研) 〇富田 大智<sup>1</sup>・高原 一真<sup>2</sup>・坂田 大夢<sup>3</sup>・砂月 幸成<sup>4</sup>・鈴木 孝義<sup>5</sup>",
      "Control of Crystallization Behavior of Co<sup>II</sup>-Tb<sup>III</sup>-Co<sup>II</sup> Trinuclear Complexes Containing Tripodal Schiff Base Ligands for Creation of Chiral Single Molecule Magnet",
      "(<sup>1</sup>Graduate School of Environmental, Life, Natural Science and Technology, Okayama Univ., <sup>2</sup>Graduate School of Science, University of Hyogo, <sup>3</sup>Graduate School of Natural Science and Technology, Okayama Univ., <sup>4</sup>Advanced Science Research Center, Okayama Univ., <sup>5</sup>RIIS, Okayama Univ.) 〇Daichi TOMITA<sup>1</sup>, Kazuma TAKAHARA<sup>2</sup>, Hiromu SAKATA<sup>3</sup>, Yukinari SUNATSUKI<sup>4</sup>, Takayoshi SUZUKI<sup>5</sup>"
    ],
    "lab": "3PA-06",
    "pdf": "pdf/3PA-06.pdf",
    "pre": "tn/3PA-06.jpg",
    "reg": "74249",
    "sea": "Co, Tb",
    "ses": "3PA",
    "con": "3PA-06 キラルな単分子磁石の創成を目指した三脚型 Schiff 塩基配位子を含む Co<sup>II</sup>-Tb<sup>III</sup>-Co<sup>II</sup> 三核錯体の結晶化挙動の制御 (<sup>1</sup>岡山大院環境生命自然・<sup>2</sup>兵庫県大院理・<sup>3</sup>岡山大院自然・<sup>4</sup>岡山大自然生命セ・<sup>5</sup>岡山大基礎研) 〇富田 大智<sup>1</sup>・高原 一真<sup>2</sup>・坂田 大夢<sup>3</sup>・砂月 幸成<sup>4</sup>・鈴木 孝義<sup>5</sup> Control of Crystallization Behavior of Co<sup>II</sup>-Tb<sup>III</sup>-Co<sup>II</sup> Trinuclear Complexes Containing Tripodal Schiff Base Ligands for Creation of Chiral Single Molecule Magnet (<sup>1</sup>Graduate School of Environmental, Life, Natural Science and Technology, Okayama Univ., <sup>2</sup>Graduate School of Science, University of Hyogo, <sup>3</sup>Graduate School of Natural Science and Technology, Okayama Univ., <sup>4</sup>Advanced Science Research Center, Okayama Univ., <sup>5</sup>RIIS, Okayama Univ.) 〇Daichi TOMITA<sup>1</sup>, Kazuma TAKAHARA<sup>2</sup>, Hiromu SAKATA<sup>3</sup>, Yukinari SUNATSUKI<sup>4</sup>, Takayoshi SUZUKI<sup>5</sup> Co, Tb"
  },
  {
    "inf": [
      "キャスト法によるSIFSIX-1-Cu MOF配向膜の構築",
      "(<sup>1</sup>東理大院理) 〇小山 玲欧<sup>1</sup>・佐藤 泰聖<sup>1</sup>・張 啓原<sup>1</sup>・原口 知之<sup>1</sup>",
      "Fabrication and Evaluation of Oriented Crystalline SIFSIX-1-Cu MOF Thin Film by Casting Method",
      "(<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Reo Koyama<sup>1</sup>, Taisei SATO<sup>1</sup>, Qiyuan ZHANG<sup>1</sup>, Tomoyuki HARAGUCHI<sup>1</sup>"
    ],
    "lab": "3PA-07",
    "pdf": "pdf/3PA-07.pdf",
    "pre": "tn/3PA-07.jpg",
    "reg": "74250",
    "sea": "Cu",
    "ses": "3PA",
    "con": "3PA-07 キャスト法によるSIFSIX-1-Cu MOF配向膜の構築 (<sup>1</sup>東理大院理) 〇小山 玲欧<sup>1</sup>・佐藤 泰聖<sup>1</sup>・張 啓原<sup>1</sup>・原口 知之<sup>1</sup> Fabrication and Evaluation of Oriented Crystalline SIFSIX-1-Cu MOF Thin Film by Casting Method (<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Reo Koyama<sup>1</sup>, Taisei SATO<sup>1</sup>, Qiyuan ZHANG<sup>1</sup>, Tomoyuki HARAGUCHI<sup>1</sup> Cu"
  },
  {
    "inf": [
      "2つのビスイミノピロール部位からなる環状配位子を有するルテニウム二核錯体の合成と反応",
      "(<sup>1</sup>上智大理工・<sup>2</sup>阪大院理) 〇安江 華鈴<sup>1</sup>・三澤 智世<sup>1</sup>・舩橋 靖博<sup>2</sup>・長尾 宏隆<sup>1</sup>",
      "Syntheses and Reactions of Diruthenium Complexes Bearing a Macrocyclic Ligand Consisting of Two Bis(imino)pyrrole Units",
      "(<sup>1</sup>Fac. of Sci. and Tech., Sophia Univ., <sup>2</sup>Osaka Univ.) 〇Karin YASUE<sup>1</sup>, Tomoyo MISAWA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>2</sup>, Hirotaka NAGAO<sup>1</sup>"
    ],
    "lab": "3PA-08",
    "pdf": "pdf/3PA-08.pdf",
    "pre": "tn/3PA-08.jpg",
    "reg": "74183",
    "sea": "Ru",
    "ses": "3PA",
    "con": "3PA-08 2つのビスイミノピロール部位からなる環状配位子を有するルテニウム二核錯体の合成と反応 (<sup>1</sup>上智大理工・<sup>2</sup>阪大院理) 〇安江 華鈴<sup>1</sup>・三澤 智世<sup>1</sup>・舩橋 靖博<sup>2</sup>・長尾 宏隆<sup>1</sup> Syntheses and Reactions of Diruthenium Complexes Bearing a Macrocyclic Ligand Consisting of Two Bis(imino)pyrrole Units (<sup>1</sup>Fac. of Sci. and Tech., Sophia Univ., <sup>2</sup>Osaka Univ.) 〇Karin YASUE<sup>1</sup>, Tomoyo MISAWA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>2</sup>, Hirotaka NAGAO<sup>1</sup> Ru"
  },
  {
    "inf": [
      "イリジウム、硫黄、ケイ素で構成される四員環メタラサイクルの合成、構造及び性質",
      "(<sup>1</sup>弘前大学大学院理工学研究科) 〇武田 元気<sup>1</sup>・太田 俊<sup>1</sup>・岡崎 雅明<sup>1</sup>",
      "Synthesis, Structure, and Properties of the Four-membered Metallacycle Composed by Iridium, Sulfur, and Silicon.",
      "(<sup>1</sup>Graduate School of Science and Technology, Hirosaki University.) 〇Genki TAKEDA<sup>1</sup>, Shun OHTA <sup>1</sup>, Masaaki OKAZAKI<sup>1</sup>"
    ],
    "lab": "3PA-09",
    "pdf": "pdf/3PA-09.pdf",
    "pre": "tn/3PA-09.jpg",
    "reg": "74264",
    "sea": "Ir",
    "ses": "3PA",
    "con": "3PA-09 イリジウム、硫黄、ケイ素で構成される四員環メタラサイクルの合成、構造及び性質 (<sup>1</sup>弘前大学大学院理工学研究科) 〇武田 元気<sup>1</sup>・太田 俊<sup>1</sup>・岡崎 雅明<sup>1</sup> Synthesis, Structure, and Properties of the Four-membered Metallacycle Composed by Iridium, Sulfur, and Silicon. (<sup>1</sup>Graduate School of Science and Technology, Hirosaki University.) 〇Genki TAKEDA<sup>1</sup>, Shun OHTA <sup>1</sup>, Masaaki OKAZAKI<sup>1</sup> Ir"
  },
  {
    "inf": [
      "COF-1配向膜のキャスト法による作製",
      "(<sup>1</sup>東京理科大学) 〇高野 浩一<sup>1</sup>・張 啓原<sup>1</sup>・原口 知之<sup>1</sup>",
      "Construction of COF-1 Oriented Thin Film by Casting Method",
      "(<sup>1</sup>Tokyo University of Science) 〇Takano KOUICHI<sup>1</sup>, Qiyuan ZHANG<sup>1</sup>, Tomoyuki HARAGUCHI<sup>1</sup>"
    ],
    "lab": "3PA-10",
    "pdf": "pdf/3PA-10.pdf",
    "pre": "tn/3PA-10.jpg",
    "reg": "74266",
    "sea": "Ag",
    "ses": "3PA",
    "con": "3PA-10 COF-1配向膜のキャスト法による作製 (<sup>1</sup>東京理科大学) 〇高野 浩一<sup>1</sup>・張 啓原<sup>1</sup>・原口 知之<sup>1</sup> Construction of COF-1 Oriented Thin Film by Casting Method (<sup>1</sup>Tokyo University of Science) 〇Takano KOUICHI<sup>1</sup>, Qiyuan ZHANG<sup>1</sup>, Tomoyuki HARAGUCHI<sup>1</sup> Ag"
  },
  {
    "inf": [
      "親水性官能基を有するビス(イミダゾリル亜鉛ポルフィリン)の合成と水中での動的配位超分子ポリマーの形成",
      "(<sup>1</sup>東理大院理) 〇池端 レン<sup>1</sup>・武重 レオナルド隼人<sup>1</sup>・佐竹 彰治<sup>1</sup>",
      "Synthesis of bis-(imidazolyl zinc porphyrin)s with hydrophilic functional groups and their formation of dynamic coordination supramolecular polymers in water                          ",
      "(<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Ren IKEBATA<sup>1</sup>, Leonardo Hayato TAKESHIGE<sup>1</sup>, Akiharu SATAKE<sup>1</sup>"
    ],
    "lab": "3PA-11",
    "pdf": "pdf/3PA-11.pdf",
    "pre": "tn/3PA-11.jpg",
    "reg": "74268",
    "sea": "Zn",
    "ses": "3PA",
    "con": "3PA-11 親水性官能基を有するビス(イミダゾリル亜鉛ポルフィリン)の合成と水中での動的配位超分子ポリマーの形成 (<sup>1</sup>東理大院理) 〇池端 レン<sup>1</sup>・武重 レオナルド隼人<sup>1</sup>・佐竹 彰治<sup>1</sup> Synthesis of bis-(imidazolyl zinc porphyrin)s with hydrophilic functional groups and their formation of dynamic coordination supramolecular polymers in water                           (<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Ren IKEBATA<sup>1</sup>, Leonardo Hayato TAKESHIGE<sup>1</sup>, Akiharu SATAKE<sup>1</sup> Zn"
  },
  {
    "inf": [
      "ペンタフルオロフェニル基を有する鉄(III)単核及び二核錯体の合成と共結晶化及び分子認識",
      "(<sup>1</sup>芝浦工大工) 〇権田 龍<sup>1</sup>・横溝 恵子<sup>1</sup>・塩本 知暉<sup>1</sup>・堀 顕子<sup>1</sup>",
      "Synthesis, Co-crystallization, and Molecular Recognition of Mononuclear and Dinuclear Iron(III) Complexes with Pentafluorophenyl Groups",
      "(<sup>1</sup>Shibaura Institute of Technology) 〇Ryu GONDA<sup>1</sup>, Keiko YOKOMIZO<sup>1</sup>, Kazuki SHIOMOTO<sup>1</sup>, Akiko HORI<sup>1</sup>"
    ],
    "lab": "3PA-12",
    "pdf": "pdf/3PA-12.pdf",
    "pre": "tn/3PA-12.jpg",
    "reg": "74270",
    "sea": "Fe",
    "ses": "3PA",
    "con": "3PA-12 ペンタフルオロフェニル基を有する鉄(III)単核及び二核錯体の合成と共結晶化及び分子認識 (<sup>1</sup>芝浦工大工) 〇権田 龍<sup>1</sup>・横溝 恵子<sup>1</sup>・塩本 知暉<sup>1</sup>・堀 顕子<sup>1</sup> Synthesis, Co-crystallization, and Molecular Recognition of Mononuclear and Dinuclear Iron(III) Complexes with Pentafluorophenyl Groups (<sup>1</sup>Shibaura Institute of Technology) 〇Ryu GONDA<sup>1</sup>, Keiko YOKOMIZO<sup>1</sup>, Kazuki SHIOMOTO<sup>1</sup>, Akiko HORI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "構造欠陥を導入したAl-MOFにおける固相条件下での格子再配列メカニズム",
      "(<sup>1</sup>甲南大学大学院・<sup>2</sup>甲南大学) 〇田中 進太郎<sup>1</sup>・髙嶋 洋平<sup>2</sup>・鶴岡 孝章<sup>2</sup>・赤松 謙祐<sup>2</sup>",
      "Mechanism of Solid-State Lattice Rearrangement in Defect-Engineered Al-MOFs",
      "(<sup>1</sup>Konan graduate school, <sup>2</sup>Konan Univ.) 〇Shintaro TANAKA<sup>1</sup>, Yohei TAKASHIMA<sup>2</sup>, Takaaki TSURUOKA<sup>2</sup>, Kensuke AKAMATSU<sup>2</sup>"
    ],
    "lab": "3PA-13",
    "pdf": "pdf/3PA-13.pdf",
    "pre": "tn/3PA-13.jpg",
    "reg": "74277",
    "sea": "Al",
    "ses": "3PA",
    "con": "3PA-13 構造欠陥を導入したAl-MOFにおける固相条件下での格子再配列メカニズム (<sup>1</sup>甲南大学大学院・<sup>2</sup>甲南大学) 〇田中 進太郎<sup>1</sup>・髙嶋 洋平<sup>2</sup>・鶴岡 孝章<sup>2</sup>・赤松 謙祐<sup>2</sup> Mechanism of Solid-State Lattice Rearrangement in Defect-Engineered Al-MOFs (<sup>1</sup>Konan graduate school, <sup>2</sup>Konan Univ.) 〇Shintaro TANAKA<sup>1</sup>, Yohei TAKASHIMA<sup>2</sup>, Takaaki TSURUOKA<sup>2</sup>, Kensuke AKAMATSU<sup>2</sup> Al"
  },
  {
    "inf": [
      "シクロメタレート型白金多核錯体の合成とクロミズム現象",
      "(<sup>1</sup>神奈川大理) 〇羽田 慎之介<sup>1</sup>・濱田 直樹<sup>1</sup>・山西 克典<sup>1</sup>・川本 達也<sup>1</sup>",
      "Synthesis of cyclometalated polynuclear platinum complexes and their chromism phenomena",
      "(<sup>1</sup>Kanagawa Univ.) 〇Shinnosuke HADA<sup>1</sup>, Naoki HAMADA<sup>1</sup>, Katsunori YAMANISHI<sup>1</sup>, Tatsuya KAWAMOTOT<sup>1</sup>"
    ],
    "lab": "3PA-14",
    "pdf": "pdf/3PA-14.pdf",
    "pre": "tn/3PA-14.jpg",
    "reg": "74287",
    "sea": "Pt",
    "ses": "3PA",
    "con": "3PA-14 シクロメタレート型白金多核錯体の合成とクロミズム現象 (<sup>1</sup>神奈川大理) 〇羽田 慎之介<sup>1</sup>・濱田 直樹<sup>1</sup>・山西 克典<sup>1</sup>・川本 達也<sup>1</sup> Synthesis of cyclometalated polynuclear platinum complexes and their chromism phenomena (<sup>1</sup>Kanagawa Univ.) 〇Shinnosuke HADA<sup>1</sup>, Naoki HAMADA<sup>1</sup>, Katsunori YAMANISHI<sup>1</sup>, Tatsuya KAWAMOTOT<sup>1</sup> Pt"
  },
  {
    "inf": [
      "2つのアジド基が結合した四核オキソモリブデン酸イオンの合成と結晶構造",
      "(<sup>1</sup>日大院総合基・<sup>2</sup>CROSS・<sup>3</sup>日大文理) 〇宮島 槙太郎<sup>1</sup>・杉山 晴紀<sup>2</sup>・石崎 聡晴<sup>3</sup>・尾関 智二<sup>3</sup>",
      "Synthesis and crystal structure of tetranuclear oxomolybdate with two azide Ligands",
      "(<sup>1</sup>Graduate School of Integrated Basic Sciences, Nihon Univ., <sup>2</sup>CROSS, <sup>3</sup>College of Humanities and Sciences, Nihon Univ.) 〇Shintaro MIYAZIMA<sup>1</sup>, Haruki SUGIYAMA<sup>2</sup>, Toshiharu ISHIZAKI<sup>3</sup>, Tomoji OZEKI<sup>3</sup>"
    ],
    "lab": "3PA-15",
    "pdf": "pdf/3PA-15.pdf",
    "pre": "tn/3PA-15.jpg",
    "reg": "74290",
    "sea": "Mo",
    "ses": "3PA",
    "con": "3PA-15 2つのアジド基が結合した四核オキソモリブデン酸イオンの合成と結晶構造 (<sup>1</sup>日大院総合基・<sup>2</sup>CROSS・<sup>3</sup>日大文理) 〇宮島 槙太郎<sup>1</sup>・杉山 晴紀<sup>2</sup>・石崎 聡晴<sup>3</sup>・尾関 智二<sup>3</sup> Synthesis and crystal structure of tetranuclear oxomolybdate with two azide Ligands (<sup>1</sup>Graduate School of Integrated Basic Sciences, Nihon Univ., <sup>2</sup>CROSS, <sup>3</sup>College of Humanities and Sciences, Nihon Univ.) 〇Shintaro MIYAZIMA<sup>1</sup>, Haruki SUGIYAMA<sup>2</sup>, Toshiharu ISHIZAKI<sup>3</sup>, Tomoji OZEKI<sup>3</sup> Mo"
  },
  {
    "inf": [
      "スピンクロスオーバー現象とサーモサリエント効果を示す鉄(II)錯体分子結晶のアルキル置換基効果",
      "(<sup>1</sup>岐阜大教育) 〇石原 智也<sup>1</sup>・飯尾 一真<sup>1</sup>・萩原 宏明<sup>1</sup>",
      "Alkyl-substituent effect on spin crossover phoenomenon and thermosalient effect in iron(II) molecular crystals",
      "(<sup>1</sup>Gifu Univ.) 〇Tomoya ISHIHARA<sup>1</sup>, Kazuma IIO<sup>1</sup>, Hiroaki HAGIWARA<sup>1</sup>"
    ],
    "lab": "3PA-16",
    "pdf": "pdf/3PA-16.pdf",
    "pre": "tn/3PA-16.jpg",
    "reg": "74298",
    "sea": "Fe",
    "ses": "3PA",
    "con": "3PA-16 スピンクロスオーバー現象とサーモサリエント効果を示す鉄(II)錯体分子結晶のアルキル置換基効果 (<sup>1</sup>岐阜大教育) 〇石原 智也<sup>1</sup>・飯尾 一真<sup>1</sup>・萩原 宏明<sup>1</sup> Alkyl-substituent effect on spin crossover phoenomenon and thermosalient effect in iron(II) molecular crystals (<sup>1</sup>Gifu Univ.) 〇Tomoya ISHIHARA<sup>1</sup>, Kazuma IIO<sup>1</sup>, Hiroaki HAGIWARA<sup>1</sup> Fe"
  },
  {
    "inf": [
      "エチルビス(2-ピリジルエチル)アミンを有するニトロシルルテニウム錯体上でのアセトニトリル配位子の反応",
      "(<sup>1</sup>上智大理工) 〇藤川 壮太<sup>1</sup>・三澤 智世<sup>1</sup>・長尾 宏隆<sup>1</sup>",
      "Synthesis of Nitrosylruthenium Complex Showing Redox Couples at Higher Potential Regions",
      "(<sup>1</sup>Fac. of Sci. and Tech., Sophia Univ.) 〇Sota Fujikawa<sup>1</sup>, Tomoyo Misawa<sup>1</sup>, Hirotaka Nagao<sup>1</sup>"
    ],
    "lab": "3PA-17",
    "pdf": "pdf/3PA-17.pdf",
    "pre": "tn/3PA-17.jpg",
    "reg": "74253",
    "sea": "Ru",
    "ses": "3PA",
    "con": "3PA-17 エチルビス(2-ピリジルエチル)アミンを有するニトロシルルテニウム錯体上でのアセトニトリル配位子の反応 (<sup>1</sup>上智大理工) 〇藤川 壮太<sup>1</sup>・三澤 智世<sup>1</sup>・長尾 宏隆<sup>1</sup> Synthesis of Nitrosylruthenium Complex Showing Redox Couples at Higher Potential Regions (<sup>1</sup>Fac. of Sci. and Tech., Sophia Univ.) 〇Sota Fujikawa<sup>1</sup>, Tomoyo Misawa<sup>1</sup>, Hirotaka Nagao<sup>1</sup> Ru"
  },
  {
    "inf": [
      "分子内超分子相互作用を有するイリジウム錯体の合成と発光特性",
      "(<sup>1</sup>島根大院自然科学) 〇池田 光<sup>1</sup>・矢野 なつみ<sup>1</sup>・片岡 祐介<sup>1</sup>",
      "Synthesis and photoluminescence properties of iridium complexes with intramolecular supramolecular interactions. ",
      "(<sup>1</sup>Shimane Univ.) 〇Kou IKEDA<sup>1</sup>, Natsumi YANO<sup>1</sup>, Yusuke KATAOKA<sup>1</sup>"
    ],
    "lab": "3PA-18",
    "pdf": "pdf/3PA-18.pdf",
    "pre": "tn/3PA-18.jpg",
    "reg": "74212",
    "sea": "Ir",
    "ses": "3PA",
    "con": "3PA-18 分子内超分子相互作用を有するイリジウム錯体の合成と発光特性 (<sup>1</sup>島根大院自然科学) 〇池田 光<sup>1</sup>・矢野 なつみ<sup>1</sup>・片岡 祐介<sup>1</sup> Synthesis and photoluminescence properties of iridium complexes with intramolecular supramolecular interactions.  (<sup>1</sup>Shimane Univ.) 〇Kou IKEDA<sup>1</sup>, Natsumi YANO<sup>1</sup>, Yusuke KATAOKA<sup>1</sup> Ir"
  },
  {
    "inf": [
      "直鎖三リン酸を含む新規ペルオキソポリオキソモリブデートの合成とキャラクタリゼーション",
      "(<sup>1</sup>和歌山大院システム工) 〇中村 悠人<sup>1</sup>・水野 雄樹<sup>1</sup>・橋本 正人<sup>1</sup>",
      "Synthesis and characterization of a novel peroxopolyoxomolybdate containing linear triphosphate",
      "(<sup>1</sup>Faculty of Systems Engineering, Graduate School of Wakayama Univ.) 〇Yuto Nakamura<sup>1</sup>, Yuki Mizuno<sup>1</sup>, Masato Hashimoto<sup>1</sup>"
    ],
    "lab": "3PA-19",
    "pdf": "pdf/3PA-19.pdf",
    "pre": "tn/3PA-19.jpg",
    "reg": "74292",
    "sea": "Mo",
    "ses": "3PA",
    "con": "3PA-19 直鎖三リン酸を含む新規ペルオキソポリオキソモリブデートの合成とキャラクタリゼーション (<sup>1</sup>和歌山大院システム工) 〇中村 悠人<sup>1</sup>・水野 雄樹<sup>1</sup>・橋本 正人<sup>1</sup> Synthesis and characterization of a novel peroxopolyoxomolybdate containing linear triphosphate (<sup>1</sup>Faculty of Systems Engineering, Graduate School of Wakayama Univ.) 〇Yuto Nakamura<sup>1</sup>, Yuki Mizuno<sup>1</sup>, Masato Hashimoto<sup>1</sup> Mo"
  },
  {
    "inf": [
      "白金(Ⅱ)錯体共存下でのクロム(V)カテコラト錯体の酸素化とクロム―白金混合八核錯体の生成",
      "(<sup>1</sup>富大院理工) 〇矢部 輝<sup>1</sup>・高森 敦志<sup>1</sup>・大津 英揮<sup>1</sup>・柘植 清志<sup>1</sup>",
      "Oxygenation of Chromium(V) Catecholato Complexes in the Presence of a Platinum(II) Complex Affording Chromium-Platinum Mixed-Metallic Octanuclear Complexes",
      "(<sup>1</sup>Univ. of Toyama) 〇Hikaru YABE<sup>1</sup>, Atsushi TAKAMORI<sup>1</sup>, Hideki OHTSU<sup>1</sup>, Kiyoshi TSUGE<sup>1</sup>"
    ],
    "lab": "3PA-20",
    "pdf": "pdf/3PA-20.pdf",
    "pre": "tn/3PA-20.jpg",
    "reg": "74302",
    "sea": "Cr, Pt",
    "ses": "3PA",
    "con": "3PA-20 白金(Ⅱ)錯体共存下でのクロム(V)カテコラト錯体の酸素化とクロム―白金混合八核錯体の生成 (<sup>1</sup>富大院理工) 〇矢部 輝<sup>1</sup>・高森 敦志<sup>1</sup>・大津 英揮<sup>1</sup>・柘植 清志<sup>1</sup> Oxygenation of Chromium(V) Catecholato Complexes in the Presence of a Platinum(II) Complex Affording Chromium-Platinum Mixed-Metallic Octanuclear Complexes (<sup>1</sup>Univ. of Toyama) 〇Hikaru YABE<sup>1</sup>, Atsushi TAKAMORI<sup>1</sup>, Hideki OHTSU<sup>1</sup>, Kiyoshi TSUGE<sup>1</sup> Cr, Pt"
  },
  {
    "inf": [
      "ベンゾイソキノリノン配位子を用いたパドルホイール型二核錯体の合成と構造",
      "(<sup>1</sup>名大院工) 〇高木 恋<sup>1</sup>・Jenny PIRILLO<sup>1</sup>・Liyuan QU<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1</sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup>",
      "Syntheses and Structures of Paddlewheel-Type Dinuclear Complexes with Benzoisoquinolinone Ligand",
      "(<sup>1</sup>Nagoya Univ.) 〇Ren TAKAKI<sup>1</sup>, Jenny PIRILLO<sup>1</sup>, Liyuan QU<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1</sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup>"
    ],
    "lab": "3PA-21",
    "pdf": "pdf/3PA-21.pdf",
    "pre": "tn/3PA-21.jpg",
    "reg": "74310",
    "sea": "Ru, Rh",
    "ses": "3PA",
    "con": "3PA-21 ベンゾイソキノリノン配位子を用いたパドルホイール型二核錯体の合成と構造 (<sup>1</sup>名大院工) 〇高木 恋<sup>1</sup>・Jenny PIRILLO<sup>1</sup>・Liyuan QU<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1</sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup> Syntheses and Structures of Paddlewheel-Type Dinuclear Complexes with Benzoisoquinolinone Ligand (<sup>1</sup>Nagoya Univ.) 〇Ren TAKAKI<sup>1</sup>, Jenny PIRILLO<sup>1</sup>, Liyuan QU<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1</sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup> Ru, Rh"
  },
  {
    "inf": [
      "フェナントロリン誘導体を用いたヨウ化ビスマス(III)錯体の合成および物性評価",
      "(<sup>1</sup>近大理工) 〇遠藤 友希<sup>1</sup>・髙橋 直大<sup>1</sup>・鬼頭 宏任<sup>1</sup>・田中 仙君<sup>1</sup>・大久保 貴志<sup>1</sup>",
      "Synthesis and characterization of bismuth iodide complexes (III) containing phenanthroline derivatives.",
      "(<sup>1</sup>Kindai Univ.) 〇Yuki ENDO<sup>1</sup>, Naohiro TAKAHASHI<sup>1</sup>, Hirotaka KITOH-NISHIOKA<sup>1</sup>,  Senku TANAKA<sup>1</sup>, Takashi OKUBO<sup>1</sup>"
    ],
    "lab": "3PA-22",
    "pdf": "pdf/3PA-22.pdf",
    "pre": "tn/3PA-22.jpg",
    "reg": "74313",
    "sea": "Bi",
    "ses": "3PA",
    "con": "3PA-22 フェナントロリン誘導体を用いたヨウ化ビスマス(III)錯体の合成および物性評価 (<sup>1</sup>近大理工) 〇遠藤 友希<sup>1</sup>・髙橋 直大<sup>1</sup>・鬼頭 宏任<sup>1</sup>・田中 仙君<sup>1</sup>・大久保 貴志<sup>1</sup> Synthesis and characterization of bismuth iodide complexes (III) containing phenanthroline derivatives. (<sup>1</sup>Kindai Univ.) 〇Yuki ENDO<sup>1</sup>, Naohiro TAKAHASHI<sup>1</sup>, Hirotaka KITOH-NISHIOKA<sup>1</sup>,  Senku TANAKA<sup>1</sup>, Takashi OKUBO<sup>1</sup> Bi"
  },
  {
    "inf": [
      "ジチオグリセロールと2,2'-ビピリジンをもつ白金(II)錯体の合成と性質",
      "(<sup>1</sup>阪大院理) 〇新谷 雄成<sup>1</sup>・吉成 信人<sup>1</sup>",
      "**Synthesis and property of a platinum(II) complex with dithioglycerol and 2,2'-bipyridine Ligands**",
      "(<sup>1</sup>Graduate School of Science, Osaka Univ.) 〇Yusei SHINTANI<sup>1</sup>, Nobuto YOSHINARI<sup>1</sup>"
    ],
    "lab": "3PA-23",
    "pdf": "pdf/3PA-23.pdf",
    "pre": "tn/3PA-23.jpg",
    "reg": "74314",
    "sea": "Pt, Ag",
    "ses": "3PA",
    "con": "3PA-23 ジチオグリセロールと2,2'-ビピリジンをもつ白金(II)錯体の合成と性質 (<sup>1</sup>阪大院理) 〇新谷 雄成<sup>1</sup>・吉成 信人<sup>1</sup> **Synthesis and property of a platinum(II) complex with dithioglycerol and 2,2'-bipyridine Ligands** (<sup>1</sup>Graduate School of Science, Osaka Univ.) 〇Yusei SHINTANI<sup>1</sup>, Nobuto YOSHINARI<sup>1</sup> Pt, Ag"
  },
  {
    "inf": [
      "Pをヘテロ原子とする新規サンドイッチ型ペルオキソタングステートの合成及びキャラクタリゼーション",
      "(<sup>1</sup>和歌山大院システム工) 〇大西 正剛<sup>1</sup>・橋本 正人<sup>1</sup>",
      "Synthesis and characterization of a novel sandwich-type peroxotungstate with P as a heteroatom",
      "(<sup>1</sup>Faculty of Systems Engineering, Graduate School of Wakayama Univ.) 〇Masatake Onishi<sup>1</sup>, Masato Hashimoto<sup>1</sup>"
    ],
    "lab": "3PA-24",
    "pdf": "pdf/3PA-24.pdf",
    "pre": "tn/3PA-24.jpg",
    "reg": "74307",
    "sea": "W",
    "ses": "3PA",
    "con": "3PA-24 Pをヘテロ原子とする新規サンドイッチ型ペルオキソタングステートの合成及びキャラクタリゼーション (<sup>1</sup>和歌山大院システム工) 〇大西 正剛<sup>1</sup>・橋本 正人<sup>1</sup> Synthesis and characterization of a novel sandwich-type peroxotungstate with P as a heteroatom (<sup>1</sup>Faculty of Systems Engineering, Graduate School of Wakayama Univ.) 〇Masatake Onishi<sup>1</sup>, Masato Hashimoto<sup>1</sup> W"
  },
  {
    "inf": [
      "テトラピラゾリルエテンを架橋配位子としたRu/RuおよびRu/Pd二核錯体の光物性",
      "(<sup>1</sup>東大院工) 〇川俣 壮慶<sup>1</sup>・武政 雄大<sup>1</sup>・岩﨑 孝紀<sup>1</sup>・野崎 京子<sup>1</sup>",
      "Photophysical properties of dinuclear Ru/Ru and Ru/Pd complexes with tetrapyrazolylethene as a bridging ligand",
      "(<sup>1</sup>Univ. of Tokyo, Grad. Sch. of Eng.) 〇Morinori Kawamata<sup>1</sup>, Yuta Takemasa<sup>1</sup>, Takanori Iwasaki<sup>1</sup>, Kyoko Nozaki<sup>1</sup>"
    ],
    "lab": "3PA-25",
    "pdf": "pdf/3PA-25.pdf",
    "pre": "tn/3PA-25.jpg",
    "reg": "74319",
    "sea": "Ru, Pd",
    "ses": "3PA",
    "con": "3PA-25 テトラピラゾリルエテンを架橋配位子としたRu/RuおよびRu/Pd二核錯体の光物性 (<sup>1</sup>東大院工) 〇川俣 壮慶<sup>1</sup>・武政 雄大<sup>1</sup>・岩﨑 孝紀<sup>1</sup>・野崎 京子<sup>1</sup> Photophysical properties of dinuclear Ru/Ru and Ru/Pd complexes with tetrapyrazolylethene as a bridging ligand (<sup>1</sup>Univ. of Tokyo, Grad. Sch. of Eng.) 〇Morinori Kawamata<sup>1</sup>, Yuta Takemasa<sup>1</sup>, Takanori Iwasaki<sup>1</sup>, Kyoko Nozaki<sup>1</sup> Ru, Pd"
  },
  {
    "inf": [
      "ピリジルアンカーを導入した新規Ru(bda)型酸素生成触媒の合成とこれを用いた分子性TiO<sub>2</sub>フォトアノードの機能評価",
      "(<sup>1</sup>九大理化) 〇ケン キン<sup>1</sup>・酒井 健<sup>1</sup>・小澤 弘宜<sup>1</sup>",
      "Photocatalytic Performance of Molecular-Based TiO<sub>2</sub> Photoanode Using a Novel Ru(bda) Type Water Oxidation Catalyst with Pyridyl Anchor",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Xin YAN<sup>1</sup>, Ken SAKAI<sup>1</sup>, Hironobu OZAWA<sup>1</sup>"
    ],
    "lab": "3PA-26",
    "pdf": "pdf/3PA-26.pdf",
    "pre": "tn/3PA-26.jpg",
    "reg": "74320",
    "sea": "Ru",
    "ses": "3PA",
    "con": "3PA-26 ピリジルアンカーを導入した新規Ru(bda)型酸素生成触媒の合成とこれを用いた分子性TiO<sub>2</sub>フォトアノードの機能評価 (<sup>1</sup>九大理化) 〇ケン キン<sup>1</sup>・酒井 健<sup>1</sup>・小澤 弘宜<sup>1</sup> Photocatalytic Performance of Molecular-Based TiO<sub>2</sub> Photoanode Using a Novel Ru(bda) Type Water Oxidation Catalyst with Pyridyl Anchor (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Xin YAN<sup>1</sup>, Ken SAKAI<sup>1</sup>, Hironobu OZAWA<sup>1</sup> Ru"
  },
  {
    "inf": [
      "構造変換反応を利用した階層型MOFの合理的合成",
      "(<sup>1</sup>甲南大学大学院・<sup>2</sup>甲南大学) 〇寺元  玲音<sup>1</sup>・髙嶋  洋平<sup>2</sup>・鶴岡 孝章<sup>2</sup>・赤松  謙祐<sup>2</sup>",
      "Rational synthesis of hierarchical metal―organic framework using structural transformation           reaction          ",
      "(<sup>1</sup>Konan graduate school., <sup>2</sup>Konan Univ.) 〇Reon Teramoto<sup>1</sup>, Yohei Takashima<sup>2</sup>, Takaaki Tsuruoka<sup>2</sup>, Kensuke Akamatsu<sup>2</sup>"
    ],
    "lab": "3PA-27",
    "pdf": "pdf/3PA-27.pdf",
    "pre": "tn/3PA-27.jpg",
    "reg": "74278",
    "sea": "Al",
    "ses": "3PA",
    "con": "3PA-27 構造変換反応を利用した階層型MOFの合理的合成 (<sup>1</sup>甲南大学大学院・<sup>2</sup>甲南大学) 〇寺元  玲音<sup>1</sup>・髙嶋  洋平<sup>2</sup>・鶴岡 孝章<sup>2</sup>・赤松  謙祐<sup>2</sup> Rational synthesis of hierarchical metal―organic framework using structural transformation           reaction           (<sup>1</sup>Konan graduate school., <sup>2</sup>Konan Univ.) 〇Reon Teramoto<sup>1</sup>, Yohei Takashima<sup>2</sup>, Takaaki Tsuruoka<sup>2</sup>, Kensuke Akamatsu<sup>2</sup> Al"
  },
  {
    "inf": [
      "温度変化により伸縮するNi(II)およびCu(II)錯体分子結晶の合成および構造と機械特性",
      "(<sup>1</sup>岐阜大教育) 〇國松 遼<sup>1</sup>・春田 実紀<sup>1</sup>・川瀬 雅子<sup>1</sup>・萩原 宏明<sup>1</sup>",
      "Syntheses, structures, and mechanical properties of Ni(II) and Cu(II) molecular crystals exhibiting thermally-induced expansion and contraction",
      "(<sup>1</sup>Gifu univ.) 〇Ryo KUNIMATSU<sup>1</sup>, Miki HARUTA<sup>1</sup>, Masako KAWASE<sup>1</sup>, Hiroaki HAGIWARA<sup>1</sup>"
    ],
    "lab": "3PA-28",
    "pdf": "pdf/3PA-28.pdf",
    "pre": "tn/3PA-28.jpg",
    "reg": "74299",
    "sea": "Ni, Cu",
    "ses": "3PA",
    "con": "3PA-28 温度変化により伸縮するNi(II)およびCu(II)錯体分子結晶の合成および構造と機械特性 (<sup>1</sup>岐阜大教育) 〇國松 遼<sup>1</sup>・春田 実紀<sup>1</sup>・川瀬 雅子<sup>1</sup>・萩原 宏明<sup>1</sup> Syntheses, structures, and mechanical properties of Ni(II) and Cu(II) molecular crystals exhibiting thermally-induced expansion and contraction (<sup>1</sup>Gifu univ.) 〇Ryo KUNIMATSU<sup>1</sup>, Miki HARUTA<sup>1</sup>, Masako KAWASE<sup>1</sup>, Hiroaki HAGIWARA<sup>1</sup> Ni, Cu"
  },
  {
    "inf": [
      "シリレン架橋パラジウム6核クラスターへのチオラート導入",
      "(<sup>1</sup>東大院工・<sup>2</sup>東大生研) 〇須田 鉄郎<sup>1,2</sup>",
      "Development of hexanuclear palladium cluster supported by both silylene and thiolate ligands",
      "(<sup>1</sup>Department of Applied Chemistry, The University of Tokyo, <sup>2</sup>Institute of Industrial Science, The University of Tokyo) 〇Tetsuro Suda<sup>1,2</sup>"
    ],
    "lab": "3PA-29",
    "pdf": "pdf/3PA-29.pdf",
    "pre": "tn/3PA-29.jpg",
    "reg": "74328",
    "sea": "Pd",
    "ses": "3PA",
    "con": "3PA-29 シリレン架橋パラジウム6核クラスターへのチオラート導入 (<sup>1</sup>東大院工・<sup>2</sup>東大生研) 〇須田 鉄郎<sup>1,2</sup> Development of hexanuclear palladium cluster supported by both silylene and thiolate ligands (<sup>1</sup>Department of Applied Chemistry, The University of Tokyo, <sup>2</sup>Institute of Industrial Science, The University of Tokyo) 〇Tetsuro Suda<sup>1,2</sup> Pd"
  },
  {
    "inf": [
      "M(II) - Ln(III) 異種金属多核錯体の合成と性質",
      "(<sup>1</sup>福岡大理) 〇後藤 里帆<sup></sup>・三島 章雄<sup></sup>・濱口 智彦<sup></sup>・石川 立太<sup></sup>・川田 知<sup></sup>",
      "Syntheses and characterization of M(II) - Ln(III) heteromultinuclear complexes",
      "(<sup>1</sup>Fukuoka Univ.) 〇Riho GOTO<sup></sup>, Akio MISHIMA<sup></sup>, Tomohiko HAMAGUCHI<sup></sup>, Ryuta ISHIKAWA<sup></sup>, Satoshi KAWATA<sup></sup>"
    ],
    "lab": "3PA-30",
    "pdf": "pdf/3PA-30.pdf",
    "pre": "tn/3PA-30.jpg",
    "reg": "74345",
    "sea": "Cu,Ni,Zn",
    "ses": "3PA",
    "con": "3PA-30 M(II) - Ln(III) 異種金属多核錯体の合成と性質 (<sup>1</sup>福岡大理) 〇後藤 里帆<sup></sup>・三島 章雄<sup></sup>・濱口 智彦<sup></sup>・石川 立太<sup></sup>・川田 知<sup></sup> Syntheses and characterization of M(II) - Ln(III) heteromultinuclear complexes (<sup>1</sup>Fukuoka Univ.) 〇Riho GOTO<sup></sup>, Akio MISHIMA<sup></sup>, Tomohiko HAMAGUCHI<sup></sup>, Ryuta ISHIKAWA<sup></sup>, Satoshi KAWATA<sup></sup> Cu,Ni,Zn"
  },
  {
    "inf": [
      "新規ペルオキソイソポリタングステートの合成およびキャラクタリゼーション",
      "(<sup>1</sup>和歌山大院システム工) 〇池端 祐人<sup>1</sup>・橋本 正人<sup>1</sup>",
      "Synthesis and characterization of a novel peroxoisopolytungstate",
      "(<sup>1</sup>Faculty of Systems Engineering, Graduate School of Wakayama Univ.) 〇Yuto Ikebata<sup>1</sup>, Masato Hashimoto<sup>1</sup>"
    ],
    "lab": "3PA-31",
    "pdf": "pdf/3PA-31.pdf",
    "pre": "tn/3PA-31.jpg",
    "reg": "74318",
    "sea": "W",
    "ses": "3PA",
    "con": "3PA-31 新規ペルオキソイソポリタングステートの合成およびキャラクタリゼーション (<sup>1</sup>和歌山大院システム工) 〇池端 祐人<sup>1</sup>・橋本 正人<sup>1</sup> Synthesis and characterization of a novel peroxoisopolytungstate (<sup>1</sup>Faculty of Systems Engineering, Graduate School of Wakayama Univ.) 〇Yuto Ikebata<sup>1</sup>, Masato Hashimoto<sup>1</sup> W"
  },
  {
    "inf": [
      "頂点での錯形成反応が可能な立方体型亜鉛ポルフィリンケージ分子の合成と分光学的性質",
      "(<sup>1</sup>筑波大院数物) 〇吉武 輝<sup>1</sup>・三原 のぞみ<sup>1</sup>・志賀 拓也<sup>1</sup>・二瓶 雅之<sup>1</sup>",
      "Synthesis and spectroscopic properties of a cubic Zn-porphyrin cage with vertices capable of metal-complexation",
      "(<sup>1</sup>Degree Programs in Pure and Applied Sciences, Graduate School of Science and Technology, University of Tsukuba) 〇Hikaru YOSHITAKE<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Masayuki NIHEI<sup>1</sup>"
    ],
    "lab": "3PA-32",
    "pdf": "pdf/3PA-32.pdf",
    "pre": "tn/3PA-32.jpg",
    "reg": "74349",
    "sea": "Zn",
    "ses": "3PA",
    "con": "3PA-32 頂点での錯形成反応が可能な立方体型亜鉛ポルフィリンケージ分子の合成と分光学的性質 (<sup>1</sup>筑波大院数物) 〇吉武 輝<sup>1</sup>・三原 のぞみ<sup>1</sup>・志賀 拓也<sup>1</sup>・二瓶 雅之<sup>1</sup> Synthesis and spectroscopic properties of a cubic Zn-porphyrin cage with vertices capable of metal-complexation (<sup>1</sup>Degree Programs in Pure and Applied Sciences, Graduate School of Science and Technology, University of Tsukuba) 〇Hikaru YOSHITAKE<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Masayuki NIHEI<sup>1</sup> Zn"
  },
  {
    "inf": [
      "ニッケルイオンドープ高分子薄膜内でのNi-MOF-74直接合成",
      "(<sup>1</sup>甲南大FIRST) 〇河内 光雅<sup>1</sup>・髙嶋 洋平<sup>1</sup>・赤松 謙祐<sup>1</sup>・鶴岡 孝章<sup>1</sup>",
      "Direct synthesis of Ni-MOF-74 in nickel ion-doped polymer thin film",
      "(<sup>1</sup>Konan Univ.) 〇Kouga Kawauchi<sup>1</sup>, Yohei Takashima<sup>1</sup>, Kensuke Akamatsu<sup>1</sup>, Takaaki Tsuruoka<sup>1</sup>"
    ],
    "lab": "3PA-33",
    "pdf": "pdf/3PA-33.pdf",
    "pre": "tn/3PA-33.jpg",
    "reg": "74356",
    "sea": "Ni",
    "ses": "3PA",
    "con": "3PA-33 ニッケルイオンドープ高分子薄膜内でのNi-MOF-74直接合成 (<sup>1</sup>甲南大FIRST) 〇河内 光雅<sup>1</sup>・髙嶋 洋平<sup>1</sup>・赤松 謙祐<sup>1</sup>・鶴岡 孝章<sup>1</sup> Direct synthesis of Ni-MOF-74 in nickel ion-doped polymer thin film (<sup>1</sup>Konan Univ.) 〇Kouga Kawauchi<sup>1</sup>, Yohei Takashima<sup>1</sup>, Kensuke Akamatsu<sup>1</sup>, Takaaki Tsuruoka<sup>1</sup> Ni"
  },
  {
    "inf": [
      "新規な3座シッフ塩基配位子Hqap<sup>X</sup>による鉄(II)錯体におけるSCO特性及び吸脱着特性",
      "(<sup>1</sup>近畿大理工・<sup>2</sup>近畿大理工総研) 〇前田 仁優<sup>1</sup>・GOO Zi LANG<sup>1</sup>・竹入 文隆<sup>1</sup>・前川 雅彦<sup>2</sup>・杉本 邦久<sup>1</sup>・黒田 孝義<sup>1</sup>",
      "SCO Properties in Iron(II) Complexes with a Novel Tridentate Schiff Base Ligand Hqap<sup>X</sup> and adsorption/desorption characteristics         ",
      "(<sup>1</sup>Fac. of Sci. and Eng., Kindai Univ., <sup>2</sup>Res. Inst. for Sci. and Tech., Kindai Univ.) 〇Niya Maeda<sup>1</sup>, Zi Lang GOO<sup>1</sup>, Humitaka TAKEIRI<sup>1</sup>, Masahiko MAEKAWA<sup>2</sup>, Kunihisa SUGIMOTO<sup>1</sup>, Takayoshi KURODA-SOWA<sup>1</sup>"
    ],
    "lab": "3PA-34",
    "pdf": "pdf/3PA-34.pdf",
    "pre": "tn/3PA-34.jpg",
    "reg": "74357",
    "sea": "Fe",
    "ses": "3PA",
    "con": "3PA-34 新規な3座シッフ塩基配位子Hqap<sup>X</sup>による鉄(II)錯体におけるSCO特性及び吸脱着特性 (<sup>1</sup>近畿大理工・<sup>2</sup>近畿大理工総研) 〇前田 仁優<sup>1</sup>・GOO Zi LANG<sup>1</sup>・竹入 文隆<sup>1</sup>・前川 雅彦<sup>2</sup>・杉本 邦久<sup>1</sup>・黒田 孝義<sup>1</sup> SCO Properties in Iron(II) Complexes with a Novel Tridentate Schiff Base Ligand Hqap<sup>X</sup> and adsorption/desorption characteristics          (<sup>1</sup>Fac. of Sci. and Eng., Kindai Univ., <sup>2</sup>Res. Inst. for Sci. and Tech., Kindai Univ.) 〇Niya Maeda<sup>1</sup>, Zi Lang GOO<sup>1</sup>, Humitaka TAKEIRI<sup>1</sup>, Masahiko MAEKAWA<sup>2</sup>, Kunihisa SUGIMOTO<sup>1</sup>, Takayoshi KURODA-SOWA<sup>1</sup> Fe"
  },
  {
    "inf": [
      "配位子場逆転現象を示す銅(III)錯体の酸化還元挙動に関する研究",
      "(<sup>1</sup>山東理工) 〇竹山 知志<sup>1</sup>・太田 雄大<sup>1</sup>",
      "Experimental and Theoretical Investigation of Redox behavior of Cu(III) Complexes with Ligand Filed Inversion",
      "(<sup>1</sup>Sanyo-Onoda City Univ.) 〇Tomoyuki TAKEYAMA<sup>1</sup>, Takehiro Ohta<sup>1</sup>"
    ],
    "lab": "3PA-35",
    "pdf": "pdf/3PA-35.pdf",
    "pre": "tn/3PA-35.jpg",
    "reg": "74365",
    "sea": "Cu",
    "ses": "3PA",
    "con": "3PA-35 配位子場逆転現象を示す銅(III)錯体の酸化還元挙動に関する研究 (<sup>1</sup>山東理工) 〇竹山 知志<sup>1</sup>・太田 雄大<sup>1</sup> Experimental and Theoretical Investigation of Redox behavior of Cu(III) Complexes with Ligand Filed Inversion (<sup>1</sup>Sanyo-Onoda City Univ.) 〇Tomoyuki TAKEYAMA<sup>1</sup>, Takehiro Ohta<sup>1</sup> Cu"
  },
  {
    "inf": [
      "鉄-アニル酸系錯体をホスト層とする層間化合物の合成と物性",
      "(<sup>1</sup>福岡大理) 〇白倉 丈<sup>1</sup>・三島 章雄<sup>1</sup>・濱口 智彦<sup>1</sup>・石川 立太<sup>1</sup>・川田 知<sup>1</sup>",
      "Synthesis and properties of intercalation compounds with Iron-Anilate complexes as host layers",
      "(<sup>1</sup>Fukuoka University, Department of Chemistry) 〇Jo Shirakura<sup>1</sup>, Akio Mishima<sup>1</sup>, Tomohiko Hamaguchi<sup>1</sup>, Ryuta Ishikawa<sup>1</sup>, Satoshi Kawata<sup>1</sup>"
    ],
    "lab": "3PA-36",
    "pdf": "pdf/3PA-36.pdf",
    "pre": "tn/3PA-36.jpg",
    "reg": "74366",
    "sea": "Fe",
    "ses": "3PA",
    "con": "3PA-36 鉄-アニル酸系錯体をホスト層とする層間化合物の合成と物性 (<sup>1</sup>福岡大理) 〇白倉 丈<sup>1</sup>・三島 章雄<sup>1</sup>・濱口 智彦<sup>1</sup>・石川 立太<sup>1</sup>・川田 知<sup>1</sup> Synthesis and properties of intercalation compounds with Iron-Anilate complexes as host layers (<sup>1</sup>Fukuoka University, Department of Chemistry) 〇Jo Shirakura<sup>1</sup>, Akio Mishima<sup>1</sup>, Tomohiko Hamaguchi<sup>1</sup>, Ryuta Ishikawa<sup>1</sup>, Satoshi Kawata<sup>1</sup> Fe"
  },
  {
    "inf": [
      "イミダゾール部位を有するノンイノセント型ニッケル錯体の合成",
      "(<sup>1</sup>神奈川大理) 〇新海 翔<sup>1</sup>・井上 哲<sup>1</sup>・山西 克典<sup>1</sup>・川本 達也<sup>1</sup>",
      "Synthesis of non-innocent-type nickel complexes with imidazole moieties",
      "(<sup>1</sup>Kanagawa Univ) 〇Kakeru  SHINKAI<sup>1</sup>, Satoshi  INOUE<sup>1</sup>, Katsunori  YAMANISHI<sup>1</sup>, Tatuya  KAWAMOTO<sup>1</sup>"
    ],
    "lab": "3PA-37",
    "pdf": "pdf/3PA-37.pdf",
    "pre": "tn/3PA-37.jpg",
    "reg": "74289",
    "sea": "Ni",
    "ses": "3PA",
    "con": "3PA-37 イミダゾール部位を有するノンイノセント型ニッケル錯体の合成 (<sup>1</sup>神奈川大理) 〇新海 翔<sup>1</sup>・井上 哲<sup>1</sup>・山西 克典<sup>1</sup>・川本 達也<sup>1</sup> Synthesis of non-innocent-type nickel complexes with imidazole moieties (<sup>1</sup>Kanagawa Univ) 〇Kakeru  SHINKAI<sup>1</sup>, Satoshi  INOUE<sup>1</sup>, Katsunori  YAMANISHI<sup>1</sup>, Tatuya  KAWAMOTO<sup>1</sup> Ni"
  },
  {
    "inf": [
      "吸着溶媒に依存した特異な磁気特性を示す金属有機構造体の合成と構造解析",
      "(<sup>1</sup>島根大院自然科学) 〇松原 花波<sup>1</sup>・矢野なつみ<sup>1</sup>・半田 真<sup>1</sup>・片岡 祐介<sup>1</sup>",
      "Synthesis and structural analysis of metal-organic framework with solvenet dependent specific magnetic properties           ",
      "(<sup>1</sup>Shimane Univ.) 〇Kanami MATSUBARA<sup>1</sup>, Natsumi YANO<sup>1</sup>, Makoto HANDA<sup>1</sup>, Yusuke KATAOKA<sup>1</sup>"
    ],
    "lab": "3PA-38",
    "pdf": "pdf/3PA-38.pdf",
    "pre": "tn/3PA-38.jpg",
    "reg": "74213",
    "sea": "Co",
    "ses": "3PA",
    "con": "3PA-38 吸着溶媒に依存した特異な磁気特性を示す金属有機構造体の合成と構造解析 (<sup>1</sup>島根大院自然科学) 〇松原 花波<sup>1</sup>・矢野なつみ<sup>1</sup>・半田 真<sup>1</sup>・片岡 祐介<sup>1</sup> Synthesis and structural analysis of metal-organic framework with solvenet dependent specific magnetic properties            (<sup>1</sup>Shimane Univ.) 〇Kanami MATSUBARA<sup>1</sup>, Natsumi YANO<sup>1</sup>, Makoto HANDA<sup>1</sup>, Yusuke KATAOKA<sup>1</sup> Co"
  },
  {
    "inf": [
      "金属ポルフィリン錯体の自己集積により構築される超分子フレームワークの合成",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院工) 〇内田 夏鈴<sup>1</sup>・米田 暁<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup>",
      "Synthesis of Porphyrin-Based Supramolecular Frameworks Stabilized by Non-Covalent Interactions ",
      "(<sup>1</sup>Graduate School of Engineering, Osaka Univ., <sup>2</sup>Department of Chemistry, Tokyo Institute of Technology) 〇Karin UCHIDA<sup>1</sup>, Akira YONEDA<sup>1</sup>, Yutaka SAGA <sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "3PA-39",
    "pdf": "pdf/3PA-39.pdf",
    "pre": "tn/3PA-39.jpg",
    "reg": "74368",
    "sea": "Fe, Ru",
    "ses": "3PA",
    "con": "3PA-39 金属ポルフィリン錯体の自己集積により構築される超分子フレームワークの合成 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院工) 〇内田 夏鈴<sup>1</sup>・米田 暁<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup> Synthesis of Porphyrin-Based Supramolecular Frameworks Stabilized by Non-Covalent Interactions  (<sup>1</sup>Graduate School of Engineering, Osaka Univ., <sup>2</sup>Department of Chemistry, Tokyo Institute of Technology) 〇Karin UCHIDA<sup>1</sup>, Akira YONEDA<sup>1</sup>, Yutaka SAGA <sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup> Fe, Ru"
  },
  {
    "inf": [
      "12配位型のかご状配位子を用いた希土類単核錯体の合成と磁化緩和挙動",
      "(<sup>1</sup>奈良女大院) 〇中村 有稀<sup>1</sup>・堀井 彩可<sup>1</sup>・和田 寿沙美<sup>1</sup>・堀井 洋司<sup>1</sup>・梶原 孝志<sup>1</sup>",
      "Syntheses and slow magnetic relaxation of lanthanide complexes constructed with a dodecadentate cage-shaped ligand ",
      "(<sup>1</sup>Nara Women's Univ.) 〇Yuki NAKAMURA<sup>1</sup>, Ayaka HORII<sup>1</sup>, Hisami WADA<sup>1</sup>, Yoji HORII<sup>1</sup>, Takashi KAJIWARA<sup>1</sup>"
    ],
    "lab": "3PA-40",
    "pdf": "pdf/3PA-40.pdf",
    "pre": "tn/3PA-40.jpg",
    "reg": "74369",
    "sea": "Ce，Pr，Nd，Gd，Tb，Dy",
    "ses": "3PA",
    "con": "3PA-40 12配位型のかご状配位子を用いた希土類単核錯体の合成と磁化緩和挙動 (<sup>1</sup>奈良女大院) 〇中村 有稀<sup>1</sup>・堀井 彩可<sup>1</sup>・和田 寿沙美<sup>1</sup>・堀井 洋司<sup>1</sup>・梶原 孝志<sup>1</sup> Syntheses and slow magnetic relaxation of lanthanide complexes constructed with a dodecadentate cage-shaped ligand  (<sup>1</sup>Nara Women's Univ.) 〇Yuki NAKAMURA<sup>1</sup>, Ayaka HORII<sup>1</sup>, Hisami WADA<sup>1</sup>, Yoji HORII<sup>1</sup>, Takashi KAJIWARA<sup>1</sup> Ce，Pr，Nd，Gd，Tb，Dy"
  },
  {
    "inf": [
      "_o_-phnylendiamine誘導体を配位子として持つコバルト錯体の酸化還元挙動",
      "(<sup>1</sup>早大理工) 〇山口 正<sup>1</sup>・大塚頌太<sup>1</sup>・東谷一誠<sup>1</sup>",
      "Redox property of cobalt complex with two _o_-phenylendiamine derivative ligands",
      "(<sup>1</sup>Waseda Univ.) 〇Tadashi YAMAGUCHI<sup>1</sup>, Shota OHTSUKA<sup>1</sup>, Issei HIGASHIYA<sup>1</sup>"
    ],
    "lab": "3PA-41",
    "pdf": "pdf/3PA-41.pdf",
    "pre": "tn/3PA-41.jpg",
    "reg": "74372",
    "sea": "Ru",
    "ses": "3PA",
    "con": "3PA-41 _o_-phnylendiamine誘導体を配位子として持つコバルト錯体の酸化還元挙動 (<sup>1</sup>早大理工) 〇山口 正<sup>1</sup>・大塚頌太<sup>1</sup>・東谷一誠<sup>1</sup> Redox property of cobalt complex with two _o_-phenylendiamine derivative ligands (<sup>1</sup>Waseda Univ.) 〇Tadashi YAMAGUCHI<sup>1</sup>, Shota OHTSUKA<sup>1</sup>, Issei HIGASHIYA<sup>1</sup> Ru"
  },
  {
    "inf": [
      "DIYピペットロボットを利用したハイスループットMOF合成",
      "(<sup>1</sup>東北大院理・<sup>2</sup>筑波大院理工) 〇高石 慎也<sup>1</sup>・河本 浩明<sup>2</sup>",
      "High-Throughput MOF Synthesis Using a DIY Pipette Robot",
      "(<sup>1</sup>Department of Chemistry, Graduate School of Science, Tohoku University, <sup>2</sup>Graduate School of Science and Engineering, The University of Tsukuba) 〇Shinya TAKAISHI<sup>1</sup>, Hiroaki KAWAMOTO<sup>2</sup>"
    ],
    "lab": "3PA-42",
    "pdf": "pdf/3PA-42.pdf",
    "pre": "tn/3PA-42.jpg",
    "reg": "74374",
    "sea": "Fe, Ni",
    "ses": "3PA",
    "con": "3PA-42 DIYピペットロボットを利用したハイスループットMOF合成 (<sup>1</sup>東北大院理・<sup>2</sup>筑波大院理工) 〇高石 慎也<sup>1</sup>・河本 浩明<sup>2</sup> High-Throughput MOF Synthesis Using a DIY Pipette Robot (<sup>1</sup>Department of Chemistry, Graduate School of Science, Tohoku University, <sup>2</sup>Graduate School of Science and Engineering, The University of Tsukuba) 〇Shinya TAKAISHI<sup>1</sup>, Hiroaki KAWAMOTO<sup>2</sup> Fe, Ni"
  },
  {
    "inf": [
      "強い電子的相互作用を有する異種金属多核錯体の合成および物性評価",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇長谷川 暉<sup>1</sup>・坂本 雅也<sup>1</sup>・友田 美紗<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup>",
      "Synthesis and properties of heterometallic multinuclear complexes with an intense electronic interaction among metal centers",
      "(<sup>1</sup>Osaka Univ., <sup>2</sup>Tokyo Tech.) 〇Akira HASEGAWA<sup>1</sup>, Masaya SAKAMOTO<sup>1</sup>, Misa TOMODA<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "3PA-43",
    "pdf": "pdf/3PA-43.pdf",
    "pre": "tn/3PA-43.jpg",
    "reg": "74402",
    "sea": "Ru, Cu, Zn, Mn",
    "ses": "3PA",
    "con": "3PA-43 強い電子的相互作用を有する異種金属多核錯体の合成および物性評価 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇長谷川 暉<sup>1</sup>・坂本 雅也<sup>1</sup>・友田 美紗<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup> Synthesis and properties of heterometallic multinuclear complexes with an intense electronic interaction among metal centers (<sup>1</sup>Osaka Univ., <sup>2</sup>Tokyo Tech.) 〇Akira HASEGAWA<sup>1</sup>, Masaya SAKAMOTO<sup>1</sup>, Misa TOMODA<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup> Ru, Cu, Zn, Mn"
  },
  {
    "inf": [
      "ポルフィリンケージ化合物の合成とその性質",
      "(<sup>1</sup>東工大院理・<sup>2</sup>阪大院工 ) 〇北田 大樹<sup>1</sup>・小杉 健斗<sup>1</sup>・正岡 重行<sup>2</sup>・近藤 美欧<sup>1</sup>",
      "Synthesis and physical properties of molecular cages constructed by porphyrin           complexes. ",
      "(<sup>1</sup>Tokyo Tech, <sup>2</sup>Osaka Univ.) 〇Masaki KITADA<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Shigeyuki MASAOKA<sup>2</sup>, Mio KONDO<sup>1</sup>"
    ],
    "lab": "3PA-44",
    "pdf": "pdf/3PA-44.pdf",
    "pre": "tn/3PA-44.jpg",
    "reg": "74403",
    "sea": "Zn,Fe",
    "ses": "3PA",
    "con": "3PA-44 ポルフィリンケージ化合物の合成とその性質 (<sup>1</sup>東工大院理・<sup>2</sup>阪大院工 ) 〇北田 大樹<sup>1</sup>・小杉 健斗<sup>1</sup>・正岡 重行<sup>2</sup>・近藤 美欧<sup>1</sup> Synthesis and physical properties of molecular cages constructed by porphyrin           complexes.  (<sup>1</sup>Tokyo Tech, <sup>2</sup>Osaka Univ.) 〇Masaki KITADA<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Shigeyuki MASAOKA<sup>2</sup>, Mio KONDO<sup>1</sup> Zn,Fe"
  },
  {
    "inf": [
      "イミノチオラトAu(I)四核錯体結晶の発光とその多形依存応答性",
      "(<sup>1</sup>兵庫県立大院理) 〇仙波 舜平<sup>1</sup>・中内 健司<sup>1</sup>・髙原 一真<sup>1</sup>・小澤 芳樹<sup>1</sup>・阿部 正明<sup>1</sup>",
      "Polymorphism-Dependent Crystalline-State Photoluminescence of a Tetranuclear Au(I) Complex with Iminothiolato Ligands",
      "(<sup>1</sup>Graduate School of Science, University of Hyogo) 〇 Shumpei Semba ★<sup>1</sup>, Kenji Nakauchi<sup>1</sup>, Kazuma Takahara<sup>1</sup>, Yoshiki Ozawa<sup>1</sup>, Masaaki Abe<sup>1</sup>"
    ],
    "lab": "3PA-45",
    "pdf": "pdf/3PA-45.pdf",
    "pre": "tn/3PA-45.jpg",
    "reg": "74410",
    "sea": "Au",
    "ses": "3PA",
    "con": "3PA-45 イミノチオラトAu(I)四核錯体結晶の発光とその多形依存応答性 (<sup>1</sup>兵庫県立大院理) 〇仙波 舜平<sup>1</sup>・中内 健司<sup>1</sup>・髙原 一真<sup>1</sup>・小澤 芳樹<sup>1</sup>・阿部 正明<sup>1</sup> Polymorphism-Dependent Crystalline-State Photoluminescence of a Tetranuclear Au(I) Complex with Iminothiolato Ligands (<sup>1</sup>Graduate School of Science, University of Hyogo) 〇 Shumpei Semba ★<sup>1</sup>, Kenji Nakauchi<sup>1</sup>, Kazuma Takahara<sup>1</sup>, Yoshiki Ozawa<sup>1</sup>, Masaaki Abe<sup>1</sup> Au"
  },
  {
    "inf": [
      "有機配位子を持つペルオキソモリブデートの合成",
      "(<sup>1</sup>和歌山大システム工) 〇田中 泰地<sup>1</sup>・橋本 正人<sup>1</sup>",
      "Synthesis of peroxopolyoxomolybdates having an organic ligand          ",
      "(<sup>1</sup>Faculty of Systems Engineering, Wakayama Univ.) 〇Taichi Tanaka<sup>1</sup>, Masato Hashimoto<sup>1</sup>"
    ],
    "lab": "3PA-46",
    "pdf": "pdf/3PA-46.pdf",
    "pre": "tn/3PA-46.jpg",
    "reg": "74322",
    "sea": "Mo",
    "ses": "3PA",
    "con": "3PA-46 有機配位子を持つペルオキソモリブデートの合成 (<sup>1</sup>和歌山大システム工) 〇田中 泰地<sup>1</sup>・橋本 正人<sup>1</sup> Synthesis of peroxopolyoxomolybdates having an organic ligand           (<sup>1</sup>Faculty of Systems Engineering, Wakayama Univ.) 〇Taichi Tanaka<sup>1</sup>, Masato Hashimoto<sup>1</sup> Mo"
  },
  {
    "inf": [
      "環状アミン配位子を有する二核銅錯体の合成と構造",
      "(<sup>1</sup>防衛大応化) 〇山本 浩二<sup>1</sup>・神山 亮平<sup>1</sup>・梅村 泰史<sup>1</sup>",
      "Synthesis of Dinuclear Copper Complexes with Cyclic Amine Ligands, and their Structures",
      "(<sup>1</sup>National Defense Academy) 〇Koji YAMAMOTO<sup>1</sup>, Ryohei KAMIYAMA<sup>1</sup>, Yasushi UMEMURA<sup>1</sup>"
    ],
    "lab": "3PA-47",
    "pdf": "pdf/3PA-47.pdf",
    "pre": "tn/3PA-47.jpg",
    "reg": "74425",
    "sea": "Cu",
    "ses": "3PA",
    "con": "3PA-47 環状アミン配位子を有する二核銅錯体の合成と構造 (<sup>1</sup>防衛大応化) 〇山本 浩二<sup>1</sup>・神山 亮平<sup>1</sup>・梅村 泰史<sup>1</sup> Synthesis of Dinuclear Copper Complexes with Cyclic Amine Ligands, and their Structures (<sup>1</sup>National Defense Academy) 〇Koji YAMAMOTO<sup>1</sup>, Ryohei KAMIYAMA<sup>1</sup>, Yasushi UMEMURA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "ZnLn-Re 三元金属MOFの合成と多重発光特性",
      "(<sup>1</sup>九大院理) 〇周 堯<sup>1</sup>・ルウェ バンジャマン<sup>1</sup>・大谷 亮<sup>1</sup>・大場 正昭<sup>1</sup>",
      "Synthesis and Multiple Emission Properties of ZnLn-Re Ternary Metallic MOFs",
      "(<sup>1</sup>Kyushu Univ.) 〇Yao Zhou<sup>1</sup>, Benjamin Le Ouay<sup>1</sup>, Ryo Ohtani<sup>1</sup>, Masaaki Ohba<sup>1</sup>"
    ],
    "lab": "3PA-48",
    "pdf": "pdf/3PA-48.pdf",
    "pre": "tn/3PA-48.jpg",
    "reg": "74428",
    "sea": "Re, Mn, Eu",
    "ses": "3PA",
    "con": "3PA-48 ZnLn-Re 三元金属MOFの合成と多重発光特性 (<sup>1</sup>九大院理) 〇周 堯<sup>1</sup>・ルウェ バンジャマン<sup>1</sup>・大谷 亮<sup>1</sup>・大場 正昭<sup>1</sup> Synthesis and Multiple Emission Properties of ZnLn-Re Ternary Metallic MOFs (<sup>1</sup>Kyushu Univ.) 〇Yao Zhou<sup>1</sup>, Benjamin Le Ouay<sup>1</sup>, Ryo Ohtani<sup>1</sup>, Masaaki Ohba<sup>1</sup> Re, Mn, Eu"
  },
  {
    "inf": [
      "一次元らせん型Mn(II)錯体の合成とキラル磁気特性",
      "(<sup>1</sup>筑波大院数物・<sup>2</sup>東京理科大理・<sup>3</sup>早稲田大先進理工) 〇山田 知英<sup>1</sup>・三原 のぞみ<sup>1</sup>・志賀 拓也<sup>1</sup>・石高 永進<sup>2</sup>・小内 貴祥<sup>2</sup>・伊藤 哲明<sup>2</sup>・石井 あゆみ<sup>3</sup>・二瓶 雅之<sup>1</sup>",
      "Synthesis and chiral-magnetic properties of helical one-dimensional Mn(II) complexes",
      "(<sup>1</sup>University of Tsukuba, <sup>2</sup>Tokyo University of Science, <sup>3</sup>Waseda University) 〇Tomohide YAMADA<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Eishin ISHITAKA<sup>2</sup>, Takayoshi KOUCHI<sup>2</sup>, Tetsuaki ITOU<sup>2</sup>, Ayumi ISHII<sup>3</sup>, Masayuki NIHEI<sup>1</sup>"
    ],
    "lab": "3PA-49",
    "pdf": "pdf/3PA-49.pdf",
    "pre": "tn/3PA-49.jpg",
    "reg": "74432",
    "sea": "Mn",
    "ses": "3PA",
    "con": "3PA-49 一次元らせん型Mn(II)錯体の合成とキラル磁気特性 (<sup>1</sup>筑波大院数物・<sup>2</sup>東京理科大理・<sup>3</sup>早稲田大先進理工) 〇山田 知英<sup>1</sup>・三原 のぞみ<sup>1</sup>・志賀 拓也<sup>1</sup>・石高 永進<sup>2</sup>・小内 貴祥<sup>2</sup>・伊藤 哲明<sup>2</sup>・石井 あゆみ<sup>3</sup>・二瓶 雅之<sup>1</sup> Synthesis and chiral-magnetic properties of helical one-dimensional Mn(II) complexes (<sup>1</sup>University of Tsukuba, <sup>2</sup>Tokyo University of Science, <sup>3</sup>Waseda University) 〇Tomohide YAMADA<sup>1</sup>, Nozomi MIHARA<sup>1</sup>, Takuya SHIGA<sup>1</sup>, Eishin ISHITAKA<sup>2</sup>, Takayoshi KOUCHI<sup>2</sup>, Tetsuaki ITOU<sup>2</sup>, Ayumi ISHII<sup>3</sup>, Masayuki NIHEI<sup>1</sup> Mn"
  },
  {
    "inf": [
      "合金サブナノ金クラスターの合成と特性",
      "(<sup>1</sup>北大院環境・<sup>2</sup>北大地球環境) 〇許嵐<sup>1</sup>・森田 空翔<sup>1</sup>・村田 千夏<sup>1</sup>・七分 勇勝<sup>1,2</sup>・小西 克明<sup>1,2</sup>",
      "Synthesis and Properties of Doped Sub-Nano Gold Cluster",
      "(<sup>1</sup>Grad. Sch. of Env. Sci, Hokkaido Univ, <sup>2</sup>Fac. of Env. Earth Sci, Hokkaido Univ) 〇Lan Xu<sup>1</sup>, Hiroto Morita<sup>1</sup>, Chinatsu Murata<sup>1</sup>, Yukatsu Shichibu<sup>1,2</sup>, Katsuki Konishi<sup>1,2</sup>"
    ],
    "lab": "3PA-50",
    "pdf": "pdf/3PA-50.pdf",
    "pre": "tn/3PA-50.jpg",
    "reg": "74434",
    "sea": "Au",
    "ses": "3PA",
    "con": "3PA-50 合金サブナノ金クラスターの合成と特性 (<sup>1</sup>北大院環境・<sup>2</sup>北大地球環境) 〇許嵐<sup>1</sup>・森田 空翔<sup>1</sup>・村田 千夏<sup>1</sup>・七分 勇勝<sup>1,2</sup>・小西 克明<sup>1,2</sup> Synthesis and Properties of Doped Sub-Nano Gold Cluster (<sup>1</sup>Grad. Sch. of Env. Sci, Hokkaido Univ, <sup>2</sup>Fac. of Env. Earth Sci, Hokkaido Univ) 〇Lan Xu<sup>1</sup>, Hiroto Morita<sup>1</sup>, Chinatsu Murata<sup>1</sup>, Yukatsu Shichibu<sup>1,2</sup>, Katsuki Konishi<sup>1,2</sup> Au"
  },
  {
    "inf": [
      "配位構造の異なる希土類錯体における遅い磁気緩和挙動",
      "(<sup>1</sup>熊大院先端) 〇平川 健太<sup>1</sup>・禅野 光<sup>1</sup>・張 中岳<sup>1</sup>・関根 良博<sup>1</sup>・速水 真也<sup>1</sup>",
      "Slow magnetic relaxation behavior in rare earth complexes with different coordination structures",
      "(<sup>1</sup>Kumamoto Univ.) 〇Kenta HIRAKAWA<sup>1</sup>, Hikaru ZENNO<sup>1</sup>, Zhongyue ZHANG<sup>1</sup>, Yoshihiro SEKINE<sup>1</sup>, Shinya HAYAMI<sup>1</sup>"
    ],
    "lab": "3PA-51",
    "pdf": "pdf/3PA-51.pdf",
    "pre": "tn/3PA-51.jpg",
    "reg": "74446",
    "sea": "Tb, Dy, W",
    "ses": "3PA",
    "con": "3PA-51 配位構造の異なる希土類錯体における遅い磁気緩和挙動 (<sup>1</sup>熊大院先端) 〇平川 健太<sup>1</sup>・禅野 光<sup>1</sup>・張 中岳<sup>1</sup>・関根 良博<sup>1</sup>・速水 真也<sup>1</sup> Slow magnetic relaxation behavior in rare earth complexes with different coordination structures (<sup>1</sup>Kumamoto Univ.) 〇Kenta HIRAKAWA<sup>1</sup>, Hikaru ZENNO<sup>1</sup>, Zhongyue ZHANG<sup>1</sup>, Yoshihiro SEKINE<sup>1</sup>, Shinya HAYAMI<sup>1</sup> Tb, Dy, W"
  },
  {
    "inf": [
      "Fmocアミノ基を有するアルキルチオラートにより保護されたPdAu<sub>24</sub>クラスターの合成",
      "(<sup>1</sup>京大院工・<sup>2</sup>京大化研) 〇竹内 創史<sup>1,2</sup>・齋藤 亮平<sup>1,2</sup>・中村 正治<sup>1,2</sup>・磯﨑 勝弘<sup>1,2</sup>",
      "Synthesis of PdAu<sub>24</sub> Nanocluster by Bottom-up Method",
      "(<sup>1</sup>Graduate School of Engineering, Kyoto University, <sup>2</sup>Institute for Chemical Research, Kyoto University) 〇Soshi Takeuchi<sup>1,2</sup>, Ryohei Saito<sup>1,2</sup>, Masaharu Nakamura<sup>1,2</sup>, Katsuhiro Isozaki<sup>1,2</sup>"
    ],
    "lab": "3PA-52",
    "pdf": "pdf/3PA-52.pdf",
    "pre": "tn/3PA-52.jpg",
    "reg": "74450",
    "sea": "Au, Pd",
    "ses": "3PA",
    "con": "3PA-52 Fmocアミノ基を有するアルキルチオラートにより保護されたPdAu<sub>24</sub>クラスターの合成 (<sup>1</sup>京大院工・<sup>2</sup>京大化研) 〇竹内 創史<sup>1,2</sup>・齋藤 亮平<sup>1,2</sup>・中村 正治<sup>1,2</sup>・磯﨑 勝弘<sup>1,2</sup> Synthesis of PdAu<sub>24</sub> Nanocluster by Bottom-up Method (<sup>1</sup>Graduate School of Engineering, Kyoto University, <sup>2</sup>Institute for Chemical Research, Kyoto University) 〇Soshi Takeuchi<sup>1,2</sup>, Ryohei Saito<sup>1,2</sup>, Masaharu Nakamura<sup>1,2</sup>, Katsuhiro Isozaki<sup>1,2</sup> Au, Pd"
  },
  {
    "inf": [
      "新規な光応答性分子性導体の開発を目指したジアリールエテン縮環ニッケルジチオレン錯体の合成",
      "(<sup>1</sup>立教大理) 〇若尾 海斗<sup>1</sup>・横森 創<sup>1</sup>・西村 涼<sup>1</sup>・森本 正和<sup>1</sup>・松下 信之<sup>1</sup>",
      "Synthesis of diarylethene-fused nickel-dithiolene complexes for the development of novel photoresponsive molecular conductors",
      "(<sup>1</sup>College of Science, Rikkyo University) 〇Kaito WAKAO<sup>1</sup>, So YOKOMORI<sup>1</sup>, Ryo NISHIMURA<sup>1</sup>, Masakazu MORIMOTO<sup>1</sup>, Nobuyuki MATSUSHITA<sup>1</sup>"
    ],
    "lab": "3PA-53",
    "pdf": "pdf/3PA-53.pdf",
    "pre": "tn/3PA-53.jpg",
    "reg": "74452",
    "sea": "Ni",
    "ses": "3PA",
    "con": "3PA-53 新規な光応答性分子性導体の開発を目指したジアリールエテン縮環ニッケルジチオレン錯体の合成 (<sup>1</sup>立教大理) 〇若尾 海斗<sup>1</sup>・横森 創<sup>1</sup>・西村 涼<sup>1</sup>・森本 正和<sup>1</sup>・松下 信之<sup>1</sup> Synthesis of diarylethene-fused nickel-dithiolene complexes for the development of novel photoresponsive molecular conductors (<sup>1</sup>College of Science, Rikkyo University) 〇Kaito WAKAO<sup>1</sup>, So YOKOMORI<sup>1</sup>, Ryo NISHIMURA<sup>1</sup>, Masakazu MORIMOTO<sup>1</sup>, Nobuyuki MATSUSHITA<sup>1</sup> Ni"
  },
  {
    "inf": [
      "三リン酸を含み配位子を持つ新規ペルオキソバナデートの合成検討",
      "(<sup>1</sup>和歌山大システム工) 〇川邊 翔太<sup>1</sup>・橋本 正人<sup>1</sup>",
      "Synthetic investigation of novel peroxovanadates containing triphosphate and ligands",
      "(<sup>1</sup>Faculty of Systems Engineering, Wakayama-Univ.) 〇Shota Kawabe<sup>1</sup>, Masato Hashimoto<sup>1</sup>"
    ],
    "lab": "3PA-54",
    "pdf": "pdf/3PA-54.pdf",
    "pre": "tn/3PA-54.jpg",
    "reg": "74325",
    "sea": "V",
    "ses": "3PA",
    "con": "3PA-54 三リン酸を含み配位子を持つ新規ペルオキソバナデートの合成検討 (<sup>1</sup>和歌山大システム工) 〇川邊 翔太<sup>1</sup>・橋本 正人<sup>1</sup> Synthetic investigation of novel peroxovanadates containing triphosphate and ligands (<sup>1</sup>Faculty of Systems Engineering, Wakayama-Univ.) 〇Shota Kawabe<sup>1</sup>, Masato Hashimoto<sup>1</sup> V"
  },
  {
    "inf": [
      "Ru(II)錯体のMeridional体からFacial体への光異性化に関する調査",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇三木 万里花<sup>1</sup>・坂本 雅也<sup>1</sup>・伊豆 仁<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup>",
      "Investigation of Meridional-Facial Photoisomerization in the Ruthenium(II) Complex",
      "(<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>School of Science, Tokyo Institute of Technology) 〇Marika MIKI<sup>1</sup>, Masaya SAKAMOTO<sup>1</sup>, Hitoshi IZU<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "3PA-55",
    "pdf": "pdf/3PA-55.pdf",
    "pre": "tn/3PA-55.jpg",
    "reg": "74463",
    "sea": "Ru, Zn",
    "ses": "3PA",
    "con": "3PA-55 Ru(II)錯体のMeridional体からFacial体への光異性化に関する調査 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇三木 万里花<sup>1</sup>・坂本 雅也<sup>1</sup>・伊豆 仁<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup> Investigation of Meridional-Facial Photoisomerization in the Ruthenium(II) Complex (<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>School of Science, Tokyo Institute of Technology) 〇Marika MIKI<sup>1</sup>, Masaya SAKAMOTO<sup>1</sup>, Hitoshi IZU<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup> Ru, Zn"
  },
  {
    "inf": [
      "リン酸イオンを7個内包する銀クラスターの合成と結晶構造",
      "(<sup>1</sup>日大院総合基・<sup>2</sup>日大文理) 〇松澤 一輝<sup>1</sup>・石崎 聡晴<sup>2</sup>・尾関 智二<sup>2</sup>",
      "Synthesis and crystal structure of a silver cluster encapsulating seven phosphate anions",
      "(<sup>1</sup>Graduate School of Integrated Basic Sciences, Nihon Univ., <sup>2</sup>College of Humanities and Sciences, Nihon Univ.) 〇Kazuki MATSUZAWA<sup>1</sup>, Toshiharu ISHIZAKI<sup>2</sup>, Tomoji OZEKI<sup>2</sup>"
    ],
    "lab": "3PA-56",
    "pdf": "pdf/3PA-56.pdf",
    "pre": "tn/3PA-56.jpg",
    "reg": "74467",
    "sea": "Ag",
    "ses": "3PA",
    "con": "3PA-56 リン酸イオンを7個内包する銀クラスターの合成と結晶構造 (<sup>1</sup>日大院総合基・<sup>2</sup>日大文理) 〇松澤 一輝<sup>1</sup>・石崎 聡晴<sup>2</sup>・尾関 智二<sup>2</sup> Synthesis and crystal structure of a silver cluster encapsulating seven phosphate anions (<sup>1</sup>Graduate School of Integrated Basic Sciences, Nihon Univ., <sup>2</sup>College of Humanities and Sciences, Nihon Univ.) 〇Kazuki MATSUZAWA<sup>1</sup>, Toshiharu ISHIZAKI<sup>2</sup>, Tomoji OZEKI<sup>2</sup> Ag"
  },
  {
    "inf": [
      "用いる有機溶剤に依存した陰イオン呈色活性を示すM<sub>2</sub>L<sub>4</sub>カプセルの合成",
      "(<sup>1</sup>静岡大理化) 〇深澤 結<sup>1</sup>・近藤 満<sup>1</sup>",
      "Synthesis of the M<sub>2</sub>L<sub>4</sub> capsule that shows anion detection property depending on the organic solvent used for the reaction",
      "(<sup>1</sup>Shizuoka Univ.) 〇Yui FUKASAWA<sup>1</sup>, Mitsuru KONDO<sup>1</sup>"
    ],
    "lab": "3PA-57",
    "pdf": "pdf/3PA-57.pdf",
    "pre": "tn/3PA-57.jpg",
    "reg": "74475",
    "sea": "Cu",
    "ses": "3PA",
    "con": "3PA-57 用いる有機溶剤に依存した陰イオン呈色活性を示すM<sub>2</sub>L<sub>4</sub>カプセルの合成 (<sup>1</sup>静岡大理化) 〇深澤 結<sup>1</sup>・近藤 満<sup>1</sup> Synthesis of the M<sub>2</sub>L<sub>4</sub> capsule that shows anion detection property depending on the organic solvent used for the reaction (<sup>1</sup>Shizuoka Univ.) 〇Yui FUKASAWA<sup>1</sup>, Mitsuru KONDO<sup>1</sup> Cu"
  },
  {
    "inf": [
      "BODIPYを光増部位として有するPd(II)錯体型ホストの構築と構造変換",
      "(<sup>1</sup>長崎大院総合生産科学・<sup>2</sup>長崎大院工・<sup>3</sup>東大院総合文化・<sup>4</sup>ドルトムント工科大) 〇吉岡 ちひろ<sup>1</sup>・髙木 皇遥<sup>2</sup>・作田 絵里<sup>1,2</sup>・尾本 賢一郎<sup>1,2</sup>・堀内 新之介<sup>3</sup>・有川 康弘<sup>1,2</sup>・Guido H. Clever<sup>4</sup>・馬越 啓介<sup>1,2</sup>",
      "Synthesis and structural transformation of supramolecular Pd<sup>II</sup> complexes with BODIPY as photosensitizer",
      "(<sup>1</sup>Graduate School of Integrated Science and Technology, Nagasaki Univ., <sup>2</sup>Graduate School of Engineering, Nagasaki Univ., <sup>3</sup>Graduate School of Arts and Sciences, The Univ. of Tokyo, <sup>4</sup>TU Dortmund Univ.) 〇Chihiro Yoshioka<sup>1</sup>, Koyo Takaki<sup>2</sup>, Eri Sakuda<sup>1,2</sup>, Kenichiro Omoto<sup>1,2</sup>, Shinnosuke Horiuchi<sup>3</sup>, Yasuhiro Arikawa<sup>1,2</sup>, Guido H. Clever<sup>4</sup>, Keisuke Umakoshi<sup>1,2</sup>"
    ],
    "lab": "3PA-58",
    "pdf": "pdf/3PA-58.pdf",
    "pre": "tn/3PA-58.jpg",
    "reg": "74477",
    "sea": "Pd",
    "ses": "3PA",
    "con": "3PA-58 BODIPYを光増部位として有するPd(II)錯体型ホストの構築と構造変換 (<sup>1</sup>長崎大院総合生産科学・<sup>2</sup>長崎大院工・<sup>3</sup>東大院総合文化・<sup>4</sup>ドルトムント工科大) 〇吉岡 ちひろ<sup>1</sup>・髙木 皇遥<sup>2</sup>・作田 絵里<sup>1,2</sup>・尾本 賢一郎<sup>1,2</sup>・堀内 新之介<sup>3</sup>・有川 康弘<sup>1,2</sup>・Guido H. Clever<sup>4</sup>・馬越 啓介<sup>1,2</sup> Synthesis and structural transformation of supramolecular Pd<sup>II</sup> complexes with BODIPY as photosensitizer (<sup>1</sup>Graduate School of Integrated Science and Technology, Nagasaki Univ., <sup>2</sup>Graduate School of Engineering, Nagasaki Univ., <sup>3</sup>Graduate School of Arts and Sciences, The Univ. of Tokyo, <sup>4</sup>TU Dortmund Univ.) 〇Chihiro Yoshioka<sup>1</sup>, Koyo Takaki<sup>2</sup>, Eri Sakuda<sup>1,2</sup>, Kenichiro Omoto<sup>1,2</sup>, Shinnosuke Horiuchi<sup>3</sup>, Yasuhiro Arikawa<sup>1,2</sup>, Guido H. Clever<sup>4</sup>, Keisuke Umakoshi<sup>1,2</sup> Pd"
  },
  {
    "inf": [
      "高密度にオープンメタルサイトを有するAg-MOFsの合成と解析",
      "(<sup>1</sup>北大院環境・<sup>2</sup>北大院地球環境) 〇増田 悠希<sup>1</sup>・齋藤 結大<sup>1,2</sup>・鄭 キン<sup>1,2</sup>・野呂真一郎<sup>1,2</sup>",
      "Synthesis and characterization of Ag-MOFs with highly arranged open metal sites",
      "(<sup>1</sup>Graduate School of Environmental Science, Hokkaido University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Yuki Masuda<sup>1</sup>, Yuki Saito<sup>1,2</sup>, Xin Zheng<sup>1,2</sup>, Shin-ichiro Noro<sup>1,2</sup>"
    ],
    "lab": "3PA-59",
    "pdf": "pdf/3PA-59.pdf",
    "pre": "tn/3PA-59.jpg",
    "reg": "74441",
    "sea": "Ag",
    "ses": "3PA",
    "con": "3PA-59 高密度にオープンメタルサイトを有するAg-MOFsの合成と解析 (<sup>1</sup>北大院環境・<sup>2</sup>北大院地球環境) 〇増田 悠希<sup>1</sup>・齋藤 結大<sup>1,2</sup>・鄭 キン<sup>1,2</sup>・野呂真一郎<sup>1,2</sup> Synthesis and characterization of Ag-MOFs with highly arranged open metal sites (<sup>1</sup>Graduate School of Environmental Science, Hokkaido University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Yuki Masuda<sup>1</sup>, Yuki Saito<sup>1,2</sup>, Xin Zheng<sup>1,2</sup>, Shin-ichiro Noro<sup>1,2</sup> Ag"
  },
  {
    "inf": [
      "二価対カチオンを用いた新奇ジチオオキサラト架橋鉄錯体の構造と磁性",
      "(<sup>1</sup>東理大院) 〇滝澤 力<sup>1</sup>・金友 拓哉<sup>1</sup>・榎本 真哉<sup>1</sup>",
      "Structure and magnetism of novel dithiooxalato-bridged iron complexes using divalent countercations",
      "(<sup>1</sup>Tokyo Univ. of Sci.) 〇Riki TAKIZAWA<sup>1</sup>, Takuya KANETOMO<sup>1</sup>, Masaya ENOMOTO <sup>1</sup>"
    ],
    "lab": "3PA-60",
    "pdf": "pdf/3PA-60.pdf",
    "pre": "tn/3PA-60.jpg",
    "reg": "74479",
    "sea": "Fe",
    "ses": "3PA",
    "con": "3PA-60 二価対カチオンを用いた新奇ジチオオキサラト架橋鉄錯体の構造と磁性 (<sup>1</sup>東理大院) 〇滝澤 力<sup>1</sup>・金友 拓哉<sup>1</sup>・榎本 真哉<sup>1</sup> Structure and magnetism of novel dithiooxalato-bridged iron complexes using divalent countercations (<sup>1</sup>Tokyo Univ. of Sci.) 〇Riki TAKIZAWA<sup>1</sup>, Takuya KANETOMO<sup>1</sup>, Masaya ENOMOTO <sup>1</sup> Fe"
  },
  {
    "inf": [
      "四角錐型構造を形成する Mn<sup>II</sup> 錯体の合成および発光・磁気特性",
      "(<sup>1</sup>阪大院基礎工・<sup>2</sup>JST 創発) 〇樋川 岳真<sup>1</sup>・松岡 亮太<sup>1</sup>・草本 哲郎<sup>1,2</sup>",
      "Synthesis of a Mn<sup>II</sup> complex with a square pyramidal coordination geometry and its photophysical and magnetic properties",
      "(<sup>1</sup>Osaka Univ., <sup>2</sup>JST FOREST) 〇Takema HIKAWA<sup>1</sup>, Ryota MATSUOKA<sup>1</sup>, Tetsuro KUSAMOTO<sup>1,2</sup>"
    ],
    "lab": "3PA-61",
    "pdf": "pdf/3PA-61.pdf",
    "pre": "tn/3PA-61.jpg",
    "reg": "74485",
    "sea": "Mn",
    "ses": "3PA",
    "con": "3PA-61 四角錐型構造を形成する Mn<sup>II</sup> 錯体の合成および発光・磁気特性 (<sup>1</sup>阪大院基礎工・<sup>2</sup>JST 創発) 〇樋川 岳真<sup>1</sup>・松岡 亮太<sup>1</sup>・草本 哲郎<sup>1,2</sup> Synthesis of a Mn<sup>II</sup> complex with a square pyramidal coordination geometry and its photophysical and magnetic properties (<sup>1</sup>Osaka Univ., <sup>2</sup>JST FOREST) 〇Takema HIKAWA<sup>1</sup>, Ryota MATSUOKA<sup>1</sup>, Tetsuro KUSAMOTO<sup>1,2</sup> Mn"
  },
  {
    "inf": [
      "有機薄膜太陽電池への応用を目指した白金-アセチリド錯体の合成と物性評価",
      "(<sup>1</sup>近大理工) 〇髙橋 直大<sup>1</sup>・西山 智貴<sup>1</sup>・鬼頭 宏任<sup>1</sup>・田中 仙君<sup>1</sup>・大久保 貴志<sup>1</sup>",
      "Synthesis and characterization of Pt-Acetylide complexes for application in organic solar cells.",
      "(<sup>1</sup>Kindai Univ.) 〇Naohiro TAKAHASHI<sup>1</sup>, Tomoki NISHIYAMA<sup>1</sup>, Hirotaka KITOH-NISHIOKA<sup>1</sup>, Senku TANAKA<sup>1</sup>, Takashi OKUBO<sup>1</sup>"
    ],
    "lab": "3PA-62",
    "pdf": "pdf/3PA-62.pdf",
    "pre": "tn/3PA-62.jpg",
    "reg": "74486",
    "sea": "Pt",
    "ses": "3PA",
    "con": "3PA-62 有機薄膜太陽電池への応用を目指した白金-アセチリド錯体の合成と物性評価 (<sup>1</sup>近大理工) 〇髙橋 直大<sup>1</sup>・西山 智貴<sup>1</sup>・鬼頭 宏任<sup>1</sup>・田中 仙君<sup>1</sup>・大久保 貴志<sup>1</sup> Synthesis and characterization of Pt-Acetylide complexes for application in organic solar cells. (<sup>1</sup>Kindai Univ.) 〇Naohiro TAKAHASHI<sup>1</sup>, Tomoki NISHIYAMA<sup>1</sup>, Hirotaka KITOH-NISHIOKA<sup>1</sup>, Senku TANAKA<sup>1</sup>, Takashi OKUBO<sup>1</sup> Pt"
  },
  {
    "inf": [
      "2つのアミドドナーと疎水ポケットを持つ多核銅錯体の合成と触媒活性評価",
      "(<sup>1</sup>同志社大学大学院理工) 〇林 佑希哉<sup>1</sup>・藤川 恭祐<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup>",
      "**Synthesis and catalytic activity evaluation of multicopper complexes with two amide donor and hydrophobic pocket**",
      "(<sup>1</sup>Department of Science and Engineering, Doshisha University) 〇Yukiya HAYASHI<sup>1</sup>, Kyosuke FUJUKAWA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masahito KODERA<sup>1</sup>"
    ],
    "lab": "3PA-63",
    "pdf": "pdf/3PA-63.pdf",
    "pre": "tn/3PA-63.jpg",
    "reg": "74506",
    "sea": "Cu",
    "ses": "3PA",
    "con": "3PA-63 2つのアミドドナーと疎水ポケットを持つ多核銅錯体の合成と触媒活性評価 (<sup>1</sup>同志社大学大学院理工) 〇林 佑希哉<sup>1</sup>・藤川 恭祐<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup> **Synthesis and catalytic activity evaluation of multicopper complexes with two amide donor and hydrophobic pocket** (<sup>1</sup>Department of Science and Engineering, Doshisha University) 〇Yukiya HAYASHI<sup>1</sup>, Kyosuke FUJUKAWA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masahito KODERA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "1,8-ナフチリジン-2-カルボン酸を架橋配位子とするパドルホイール型ルテニウム二核錯体の合成と結晶構造",
      "(<sup>1</sup>島根大院自然科学) 〇多田 希<sup>1</sup>・政森 直生<sup>1</sup>・矢野 なつみ<sup>1</sup>・半田 真<sup>1</sup>・片岡 祐介<sup>1</sup>",
      "Synthesis and crystal structure of paddlewheel-type diruthenium complexes with 1,8-naphthyridine-2-carboxylate ligands.",
      "(<sup>1</sup>Shimane Univ.) 〇Nozomi TADA<sup>1</sup>, Naoki MASAMORI<sup>1</sup>, Natsumi YANO<sup>1</sup>, Makoto HANDA<sup>1</sup>, Yusuke KATAOKA<sup>1</sup>"
    ],
    "lab": "3PA-64",
    "pdf": "pdf/3PA-64.pdf",
    "pre": "tn/3PA-64.jpg",
    "reg": "74214",
    "sea": "Ru",
    "ses": "3PA",
    "con": "3PA-64 1,8-ナフチリジン-2-カルボン酸を架橋配位子とするパドルホイール型ルテニウム二核錯体の合成と結晶構造 (<sup>1</sup>島根大院自然科学) 〇多田 希<sup>1</sup>・政森 直生<sup>1</sup>・矢野 なつみ<sup>1</sup>・半田 真<sup>1</sup>・片岡 祐介<sup>1</sup> Synthesis and crystal structure of paddlewheel-type diruthenium complexes with 1,8-naphthyridine-2-carboxylate ligands. (<sup>1</sup>Shimane Univ.) 〇Nozomi TADA<sup>1</sup>, Naoki MASAMORI<sup>1</sup>, Natsumi YANO<sup>1</sup>, Makoto HANDA<sup>1</sup>, Yusuke KATAOKA<sup>1</sup> Ru"
  },
  {
    "inf": [
      "酸化還元活性なフェニレンジアミド配位子を有する14族元素錯体の合成と性質",
      "(<sup>1</sup>大阪大学大学院工学研究科・<sup>2</sup>大阪大学産業科学研究所) 〇長谷川 源太<sup>1</sup>・伊東 忍<sup>2</sup>・杉本 秀樹<sup>1</sup>",
      "Synthesis and Properties of Group 14 Element Complexes with Redox-Active Phenylenediamido Ligand",
      "(<sup>1</sup>1.\\tGraduate School of Engineering, Osaka University, <sup>2</sup>2.\\tThe Institute of Scientific and Industrial Research, Osaka University) 〇Genta Hasegawa<sup>1</sup>, Shinobu Itoh<sup>2</sup>, Hideki Sugimoto<sup>1</sup>"
    ],
    "lab": "3PA-65",
    "pdf": "pdf/3PA-65.pdf",
    "pre": "tn/3PA-65.jpg",
    "reg": "74489",
    "sea": "Ge, Sn, Pb",
    "ses": "3PA",
    "con": "3PA-65 酸化還元活性なフェニレンジアミド配位子を有する14族元素錯体の合成と性質 (<sup>1</sup>大阪大学大学院工学研究科・<sup>2</sup>大阪大学産業科学研究所) 〇長谷川 源太<sup>1</sup>・伊東 忍<sup>2</sup>・杉本 秀樹<sup>1</sup> Synthesis and Properties of Group 14 Element Complexes with Redox-Active Phenylenediamido Ligand (<sup>1</sup>1.\\tGraduate School of Engineering, Osaka University, <sup>2</sup>2.\\tThe Institute of Scientific and Industrial Research, Osaka University) 〇Genta Hasegawa<sup>1</sup>, Shinobu Itoh<sup>2</sup>, Hideki Sugimoto<sup>1</sup> Ge, Sn, Pb"
  },
  {
    "inf": [
      "核酸塩基を有する発光性白金(II)錯体の合成と鋳型DNAオリゴマーによる集積化制御",
      "(<sup>1</sup>城西大院理・<sup>2</sup>青山学院大理工) 〇磯部 俊一<sup>1</sup>・藤井 駿<sup>1, 2</sup>・仲谷 学<sup>1</sup>",
      "Synthesis of luminescent platinum(II) complexes bearing nucleobases and control of the molecular assembly using template DNA oligomers",
      "(<sup>1</sup>Graduate School of Science, Josai University, <sup>2</sup>College of Science & Engineering, Aoyama Gakuin University) 〇Shunichi ISOBE<sup>1</sup>, Shun FUJII<sup>1, 2</sup>, Manabu NAKAYA<sup>1</sup>"
    ],
    "lab": "3PA-66",
    "pdf": "pdf/3PA-66.pdf",
    "pre": "tn/3PA-66.jpg",
    "reg": "74508",
    "sea": "Pt, Zn",
    "ses": "3PA",
    "con": "3PA-66 核酸塩基を有する発光性白金(II)錯体の合成と鋳型DNAオリゴマーによる集積化制御 (<sup>1</sup>城西大院理・<sup>2</sup>青山学院大理工) 〇磯部 俊一<sup>1</sup>・藤井 駿<sup>1, 2</sup>・仲谷 学<sup>1</sup> Synthesis of luminescent platinum(II) complexes bearing nucleobases and control of the molecular assembly using template DNA oligomers (<sup>1</sup>Graduate School of Science, Josai University, <sup>2</sup>College of Science & Engineering, Aoyama Gakuin University) 〇Shunichi ISOBE<sup>1</sup>, Shun FUJII<sup>1, 2</sup>, Manabu NAKAYA<sup>1</sup> Pt, Zn"
  },
  {
    "inf": [
      "二リン酸をヘテロ原子として組み込んだペルオキソポリオキソタングステートの合成法の最適化",
      "(<sup>1</sup>和歌山大システム工) 〇谷垣 研太<sup>1</sup>・植田 悠斗<sup>1</sup>・橋本 正人<sup>1</sup>",
      "Optimization of synthetic conditions of peroxopolytungstates involving a diphosphate as a heteroatom group",
      "(<sup>1</sup>Faculty of Systems Engineering, Wakayama Univ.) 〇Kenta Tanigaki<sup>1</sup>, Yuto Ueda<sup>1</sup>, Masato Hashimoto<sup>1</sup>"
    ],
    "lab": "3PA-67",
    "pdf": "pdf/3PA-67.pdf",
    "pre": "tn/3PA-67.jpg",
    "reg": "74510",
    "sea": "W",
    "ses": "3PA",
    "con": "3PA-67 二リン酸をヘテロ原子として組み込んだペルオキソポリオキソタングステートの合成法の最適化 (<sup>1</sup>和歌山大システム工) 〇谷垣 研太<sup>1</sup>・植田 悠斗<sup>1</sup>・橋本 正人<sup>1</sup> Optimization of synthetic conditions of peroxopolytungstates involving a diphosphate as a heteroatom group (<sup>1</sup>Faculty of Systems Engineering, Wakayama Univ.) 〇Kenta Tanigaki<sup>1</sup>, Yuto Ueda<sup>1</sup>, Masato Hashimoto<sup>1</sup> W"
  },
  {
    "inf": [
      "2,2'-ビ-1,8-ナフチリジルを配位子に有するルテニウム錯体の合成と性質",
      "(<sup>1</sup>静岡理工科大先端機器分析セ・<sup>2</sup>筑波大院数理物質・<sup>3</sup>京大iCeMS) 〇小泉 武昭<sup>1</sup>・桑原 純平<sup>2</sup>・神原 貴樹<sup>2</sup>・田中 晃二<sup>3</sup>",
      "Synthesis and chemical properties of 2,2'-bi-1,8-naphthyridyl-ligated ruthenium complexes",
      "(<sup>1</sup>Shizuoka Inst. Sci. Tech., <sup>2</sup>Univ. Tsukuba, <sup>3</sup>Kyoto Univ.) 〇Take-aki KOIZUMI<sup>1</sup>, Junpei KUWABARA<sup>2</sup>, Takaki KANBARA<sup>2</sup>, Koji TANAKA<sup>3</sup>"
    ],
    "lab": "3PA-68",
    "pdf": "pdf/3PA-68.pdf",
    "pre": "tn/3PA-68.jpg",
    "reg": "74476",
    "sea": "Ru",
    "ses": "3PA",
    "con": "3PA-68 2,2'-ビ-1,8-ナフチリジルを配位子に有するルテニウム錯体の合成と性質 (<sup>1</sup>静岡理工科大先端機器分析セ・<sup>2</sup>筑波大院数理物質・<sup>3</sup>京大iCeMS) 〇小泉 武昭<sup>1</sup>・桑原 純平<sup>2</sup>・神原 貴樹<sup>2</sup>・田中 晃二<sup>3</sup> Synthesis and chemical properties of 2,2'-bi-1,8-naphthyridyl-ligated ruthenium complexes (<sup>1</sup>Shizuoka Inst. Sci. Tech., <sup>2</sup>Univ. Tsukuba, <sup>3</sup>Kyoto Univ.) 〇Take-aki KOIZUMI<sup>1</sup>, Junpei KUWABARA<sup>2</sup>, Takaki KANBARA<sup>2</sup>, Koji TANAKA<sup>3</sup> Ru"
  },
  {
    "inf": [
      "発光性メカノクロミック配位高分子の合成と特性評価",
      "(<sup>1</sup>近大理工) 〇伊藤 杏美<sup>1</sup>・西山 智貴<sup>1</sup>・鬼頭 宏任<sup>1</sup>・田中 仙君<sup>1</sup>・大久保 貴志<sup>1</sup>",
      "Synthesis and Characterization of Luminescent Mechanochromic Coordination Polymers                    ",
      "(<sup>1</sup>Kindai Univ.) 〇Ami ITO<sup>1</sup>, Tomoki NISHIYAMA<sup>1</sup>, Hirotaka KITOH-NISHIOKA<sup>1</sup>, Senku TANAKA<sup>1</sup>, Takashi OKUBO<sup>1</sup>"
    ],
    "lab": "3PA-69",
    "pdf": "pdf/3PA-69.pdf",
    "pre": "tn/3PA-69.jpg",
    "reg": "74501",
    "sea": "Cu",
    "ses": "3PA",
    "con": "3PA-69 発光性メカノクロミック配位高分子の合成と特性評価 (<sup>1</sup>近大理工) 〇伊藤 杏美<sup>1</sup>・西山 智貴<sup>1</sup>・鬼頭 宏任<sup>1</sup>・田中 仙君<sup>1</sup>・大久保 貴志<sup>1</sup> Synthesis and Characterization of Luminescent Mechanochromic Coordination Polymers                     (<sup>1</sup>Kindai Univ.) 〇Ami ITO<sup>1</sup>, Tomoki NISHIYAMA<sup>1</sup>, Hirotaka KITOH-NISHIOKA<sup>1</sup>, Senku TANAKA<sup>1</sup>, Takashi OKUBO<sup>1</sup> Cu"
  },
  {
    "inf": [
      "ポリピリジル−ルテニウム(III), ―オスミウム(III)錯体を用いたC-H結合のフッ素化反応",
      "(<sup>1</sup>大阪大学大学院工学研究科・<sup>2</sup>大阪大学産業科学研究所) 〇小西池 直樹<sup></sup>・沼田 崚晟<sup></sup>・伊東 忍<sup></sup>・杉本 秀樹<sup></sup>",
      "C-H Fluorination by Polypyridyl -Ruthenium(III) and -Osmium(III) Complexes",
      "(<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>The Institute of Scientific and Industrial Research, Osaka University) 〇Naoki Konishiike\\t<sup></sup>, Ryosei Numata<sup></sup>, Shinobu Itoh<sup></sup>, Hideki Sugimoto<sup></sup>"
    ],
    "lab": "3PA-70",
    "pdf": "pdf/3PA-70.pdf",
    "pre": "tn/3PA-70.jpg",
    "reg": "74515",
    "sea": "Ru, Os",
    "ses": "3PA",
    "con": "3PA-70 ポリピリジル−ルテニウム(III), ―オスミウム(III)錯体を用いたC-H結合のフッ素化反応 (<sup>1</sup>大阪大学大学院工学研究科・<sup>2</sup>大阪大学産業科学研究所) 〇小西池 直樹<sup></sup>・沼田 崚晟<sup></sup>・伊東 忍<sup></sup>・杉本 秀樹<sup></sup> C-H Fluorination by Polypyridyl -Ruthenium(III) and -Osmium(III) Complexes (<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>The Institute of Scientific and Industrial Research, Osaka University) 〇Naoki Konishiike\\t<sup></sup>, Ryosei Numata<sup></sup>, Shinobu Itoh<sup></sup>, Hideki Sugimoto<sup></sup> Ru, Os"
  },
  {
    "inf": [
      "パドルホイール型二核錯体から構築されるケージ化合物の合成と性質",
      "(<sup>1</sup>東工大院理・<sup>2</sup>阪大院工) 〇安田 亘輝<sup>1</sup>・北田 大樹<sup>1</sup>・小杉  健斗<sup>1</sup>・奥田 佳那子<sup>2</sup>・正岡 重行<sup>2</sup>・近藤 美欧<sup>1</sup>",
      "Synthesis and Properties of Cage Compounds Constructed from Paddlewheel Dinuclear Complexes",
      "(<sup>1</sup>東京工業大学, <sup>2</sup>大阪大学) 〇Koki YASUDA<sup>1</sup>, Masaki KITADA<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Kanako OKUDA<sup>2</sup>, Shigeyuki MASAOKA<sup>2</sup>, Mio KONDO<sup>1</sup>"
    ],
    "lab": "3PA-71",
    "pdf": "pdf/3PA-71.pdf",
    "pre": "tn/3PA-71.jpg",
    "reg": "74518",
    "sea": "Cu, Rh",
    "ses": "3PA",
    "con": "3PA-71 パドルホイール型二核錯体から構築されるケージ化合物の合成と性質 (<sup>1</sup>東工大院理・<sup>2</sup>阪大院工) 〇安田 亘輝<sup>1</sup>・北田 大樹<sup>1</sup>・小杉  健斗<sup>1</sup>・奥田 佳那子<sup>2</sup>・正岡 重行<sup>2</sup>・近藤 美欧<sup>1</sup> Synthesis and Properties of Cage Compounds Constructed from Paddlewheel Dinuclear Complexes (<sup>1</sup>東京工業大学, <sup>2</sup>大阪大学) 〇Koki YASUDA<sup>1</sup>, Masaki KITADA<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Kanako OKUDA<sup>2</sup>, Shigeyuki MASAOKA<sup>2</sup>, Mio KONDO<sup>1</sup> Cu, Rh"
  },
  {
    "inf": [
      "ルイス塩基性置換基を有する新規シアノ架橋六核錯体の合成と特性評価",
      "(<sup>1</sup>熊大院先端) 〇中尾 亮介<sup>1</sup>・張 中岳<sup>1</sup>・関根 良博<sup>1</sup>・速水 真也<sup>1</sup>",
      "Synthesis and Characterization of Novel Cyano-bridged Hexanuclear Complexes with Lewis Basic Substituents",
      "(<sup>1</sup>Kumamoto Univ.) 〇Ryosuke Nakao<sup>1</sup>, Zhongyue ZHANG <sup>1</sup>, Yoshihiro SEKINE<sup>1</sup>, Shinya HAYAMI<sup>1</sup>"
    ],
    "lab": "3PA-72",
    "pdf": "pdf/3PA-72.pdf",
    "pre": "tn/3PA-72.jpg",
    "reg": "74522",
    "sea": "Co, Fe",
    "ses": "3PA",
    "con": "3PA-72 ルイス塩基性置換基を有する新規シアノ架橋六核錯体の合成と特性評価 (<sup>1</sup>熊大院先端) 〇中尾 亮介<sup>1</sup>・張 中岳<sup>1</sup>・関根 良博<sup>1</sup>・速水 真也<sup>1</sup> Synthesis and Characterization of Novel Cyano-bridged Hexanuclear Complexes with Lewis Basic Substituents (<sup>1</sup>Kumamoto Univ.) 〇Ryosuke Nakao<sup>1</sup>, Zhongyue ZHANG <sup>1</sup>, Yoshihiro SEKINE<sup>1</sup>, Shinya HAYAMI<sup>1</sup> Co, Fe"
  },
  {
    "inf": [
      "水溶性トリス(フェニルピリジナト)イリジウム誘導体の合成と光触媒機能",
      "(<sup>1</sup>九大理化) 〇野間 大暉<sup>1</sup>・山内 幸正<sup>1</sup>・酒井 健<sup>1</sup>",
      "Synthesis and Photocatalytic Property of Water-Soluble Tris(phenylpyridinato)iridium(III) Derivatives",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Taiki NOMA<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "3PA-73",
    "pdf": "pdf/3PA-73.pdf",
    "pre": "tn/3PA-73.jpg",
    "reg": "74532",
    "sea": "Ir",
    "ses": "3PA",
    "con": "3PA-73 水溶性トリス(フェニルピリジナト)イリジウム誘導体の合成と光触媒機能 (<sup>1</sup>九大理化) 〇野間 大暉<sup>1</sup>・山内 幸正<sup>1</sup>・酒井 健<sup>1</sup> Synthesis and Photocatalytic Property of Water-Soluble Tris(phenylpyridinato)iridium(III) Derivatives (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Taiki NOMA<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Ir"
  },
  {
    "inf": [
      "2-ピリジルメチレンアニリン誘導体の鉄(II)錯体における不完全SCO",
      "(<sup>1</sup>電通大基盤理工) 〇武士 新一郎<sup>1</sup>・渡辺 聡美<sup>1</sup>・餅田 直剛<sup>1</sup>・高野 莉奈<sup>1</sup>・石田 尚行<sup>1</sup>",
      "Incomplete SCO in iron(II) complexes of 2-pyridylmethyleneaniline derivatives",
      "(<sup>1</sup>The University of Electro-Communications) 〇Shin-ichiro Takeshi<sup>1</sup>, Satomi Watanabe<sup>1</sup>, Naotaka Mochida<sup>1</sup>, Rina Takano<sup>1</sup>, Takayuki Ishida<sup>1</sup>"
    ],
    "lab": "3PA-74",
    "pdf": "pdf/3PA-74.pdf",
    "pre": "tn/3PA-74.jpg",
    "reg": "74534",
    "sea": "Fe",
    "ses": "3PA",
    "con": "3PA-74 2-ピリジルメチレンアニリン誘導体の鉄(II)錯体における不完全SCO (<sup>1</sup>電通大基盤理工) 〇武士 新一郎<sup>1</sup>・渡辺 聡美<sup>1</sup>・餅田 直剛<sup>1</sup>・高野 莉奈<sup>1</sup>・石田 尚行<sup>1</sup> Incomplete SCO in iron(II) complexes of 2-pyridylmethyleneaniline derivatives (<sup>1</sup>The University of Electro-Communications) 〇Shin-ichiro Takeshi<sup>1</sup>, Satomi Watanabe<sup>1</sup>, Naotaka Mochida<sup>1</sup>, Rina Takano<sup>1</sup>, Takayuki Ishida<sup>1</sup> Fe"
  },
  {
    "inf": [
      "有機溶媒に可溶な欠損型ポリオキソメタレートを用いた新規{MnCe}多核構造の合成",
      "(<sup>1</sup>広大院先進理工) 〇富山 陽太<sup>1</sup>・湊 拓生<sup>1</sup>・定金 正洋<sup>1</sup>",
      "Synthesis of {MnCe} hetero-multinuclear metal oxo clusters utilizing organic solvent-soluble lacunary polyoxometalates",
      "(<sup>1</sup>Hiroshima University, Graduate School of Advanced Science and Engineering) 〇Yota Tomiyama<sup>1</sup>, Takuo Minato<sup>1</sup>, Masahiro Sadakane<sup>1</sup>"
    ],
    "lab": "3PA-75",
    "pdf": "pdf/3PA-75.pdf",
    "pre": "tn/3PA-75.jpg",
    "reg": "74535",
    "sea": "Mn, Ce",
    "ses": "3PA",
    "con": "3PA-75 有機溶媒に可溶な欠損型ポリオキソメタレートを用いた新規{MnCe}多核構造の合成 (<sup>1</sup>広大院先進理工) 〇富山 陽太<sup>1</sup>・湊 拓生<sup>1</sup>・定金 正洋<sup>1</sup> Synthesis of {MnCe} hetero-multinuclear metal oxo clusters utilizing organic solvent-soluble lacunary polyoxometalates (<sup>1</sup>Hiroshima University, Graduate School of Advanced Science and Engineering) 〇Yota Tomiyama<sup>1</sup>, Takuo Minato<sup>1</sup>, Masahiro Sadakane<sup>1</sup> Mn, Ce"
  },
  {
    "inf": [
      "Pd単核I価錯体の生成と反応性",
      "(<sup>1</sup>東工大物質理工・<sup>2</sup>防衛大応用化学) 〇井上 稜雅<sup>1</sup>・池田 周平<sup>1</sup>・竹内 さゆり<sup>1</sup>・山本 浩二<sup>2</sup>・重田 翼<sup>1</sup>・村橋 哲郎<sup>1</sup>",
      "Generation and Reactivity of Mononuclear Pd(I) Complex",
      "(<sup>1</sup>Tokyo Institute of Technology, <sup>2</sup>National Defense Academy) 〇Ryoga INOUE<sup>1</sup>, Shuhei IKEDA<sup>1</sup>, Sayuri TAKEUCHI<sup>1</sup>, Koji YAMAMOTO<sup>2</sup>, Tsubasa OMODA<sup>1</sup>, Tetsuro MURAHASHI<sup>1</sup>"
    ],
    "lab": "3PA-76",
    "pdf": "pdf/3PA-76.pdf",
    "pre": "tn/3PA-76.jpg",
    "reg": "74539",
    "sea": "Pd",
    "ses": "3PA",
    "con": "3PA-76 Pd単核I価錯体の生成と反応性 (<sup>1</sup>東工大物質理工・<sup>2</sup>防衛大応用化学) 〇井上 稜雅<sup>1</sup>・池田 周平<sup>1</sup>・竹内 さゆり<sup>1</sup>・山本 浩二<sup>2</sup>・重田 翼<sup>1</sup>・村橋 哲郎<sup>1</sup> Generation and Reactivity of Mononuclear Pd(I) Complex (<sup>1</sup>Tokyo Institute of Technology, <sup>2</sup>National Defense Academy) 〇Ryoga INOUE<sup>1</sup>, Shuhei IKEDA<sup>1</sup>, Sayuri TAKEUCHI<sup>1</sup>, Koji YAMAMOTO<sup>2</sup>, Tsubasa OMODA<sup>1</sup>, Tetsuro MURAHASHI<sup>1</sup> Pd"
  },
  {
    "inf": [
      "ダブルラリアート型Ni 錯体から構築される多孔質結晶に閉じ込められた水分子クラスターのプロトン伝導性",
      "(<sup>1</sup>東理大理) 〇深川慶衣<sup>1</sup>・及川大地<sup>1</sup>・小林文也<sup>1</sup>・田所誠<sup>1</sup>",
      "Proton Conductivity on Water Molecular Clusters Confined to Nano-Porous Crystal Composed of Double Lariat Nickel(II) Complexes",
      "(<sup>1</sup>Tokyo univ. of Science) 〇Kei FUKAGAWA<sup>1</sup>, Daichi OIKAWA<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup>"
    ],
    "lab": "3PA-77",
    "pdf": "pdf/3PA-77.pdf",
    "pre": "tn/3PA-77.jpg",
    "reg": "74541",
    "sea": "Ni",
    "ses": "3PA",
    "con": "3PA-77 ダブルラリアート型Ni 錯体から構築される多孔質結晶に閉じ込められた水分子クラスターのプロトン伝導性 (<sup>1</sup>東理大理) 〇深川慶衣<sup>1</sup>・及川大地<sup>1</sup>・小林文也<sup>1</sup>・田所誠<sup>1</sup> Proton Conductivity on Water Molecular Clusters Confined to Nano-Porous Crystal Composed of Double Lariat Nickel(II) Complexes (<sup>1</sup>Tokyo univ. of Science) 〇Kei FUKAGAWA<sup>1</sup>, Daichi OIKAWA<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup> Ni"
  },
  {
    "inf": [
      "二リン酸をヘテロ原子団とする希土類元素含有ポリオキソモリブデートの合成と構造解析",
      "(<sup>1</sup>和歌山大院システム工) 〇藏富 勇人<sup>1</sup>・橋本 正人<sup>1</sup>",
      "Synthesis and structural analysis of rare earth-containing peroxopolyoxomolybdates with diphosphate as a heteroatom group",
      "(<sup>1</sup>Graduate School of Systems Engineering, Wakayama Univ.) 〇Yuto Kuratomi<sup>1</sup>, Masato Hashimoto<sup>1</sup>"
    ],
    "lab": "3PA-78",
    "pdf": "pdf/3PA-78.pdf",
    "pre": "tn/3PA-78.jpg",
    "reg": "74544",
    "sea": "Mo",
    "ses": "3PA",
    "con": "3PA-78 二リン酸をヘテロ原子団とする希土類元素含有ポリオキソモリブデートの合成と構造解析 (<sup>1</sup>和歌山大院システム工) 〇藏富 勇人<sup>1</sup>・橋本 正人<sup>1</sup> Synthesis and structural analysis of rare earth-containing peroxopolyoxomolybdates with diphosphate as a heteroatom group (<sup>1</sup>Graduate School of Systems Engineering, Wakayama Univ.) 〇Yuto Kuratomi<sup>1</sup>, Masato Hashimoto<sup>1</sup> Mo"
  },
  {
    "inf": [
      "キラルジホスフィン配位金クラスターの合成と光学特性",
      "(<sup>1</sup>北大院環境・<sup>2</sup>北大院地球環境) 〇林 士琦<sup>1</sup>・鈴木 麟太郎<sup>1</sup>・小西 克明<sup>1,2</sup>・七分 勇勝<sup>1,2</sup>",
      "Synthesis and Optical Properties of Chiral Diphosphine-Coordinated Gold Clusters",
      "(<sup>1</sup>Grad. School of Env. Sci., Hokkaido Univ., <sup>2</sup>Fac. of Env. Earth Sci., Hokkaido Univ.) 〇Shiqi LIN<sup>1</sup>,  Rintaro SUZUKI<sup>1</sup>, Katsuaki KONISHI<sup>1,2</sup>, Yukatsu SHICHIBU<sup>1,2</sup>"
    ],
    "lab": "3PA-79",
    "pdf": "pdf/3PA-79.pdf",
    "pre": "tn/3PA-79.jpg",
    "reg": "74444",
    "sea": "Au",
    "ses": "3PA",
    "con": "3PA-79 キラルジホスフィン配位金クラスターの合成と光学特性 (<sup>1</sup>北大院環境・<sup>2</sup>北大院地球環境) 〇林 士琦<sup>1</sup>・鈴木 麟太郎<sup>1</sup>・小西 克明<sup>1,2</sup>・七分 勇勝<sup>1,2</sup> Synthesis and Optical Properties of Chiral Diphosphine-Coordinated Gold Clusters (<sup>1</sup>Grad. School of Env. Sci., Hokkaido Univ., <sup>2</sup>Fac. of Env. Earth Sci., Hokkaido Univ.) 〇Shiqi LIN<sup>1</sup>,  Rintaro SUZUKI<sup>1</sup>, Katsuaki KONISHI<sup>1,2</sup>, Yukatsu SHICHIBU<sup>1,2</sup> Au"
  },
  {
    "inf": [
      "柔軟なトリペプチド巨大環状錯体の構造制御要因に関する考察",
      "(<sup>1</sup>お茶大院理) 田中 頌子<sup>1</sup>・〇山口 麗奈<sup>1</sup>・三宅 亮介<sup>1</sup>",
      "Discussion of Factors Controlling the formation of Giant Cyclic Complexes of a Flexible Tripeptide",
      "(<sup>1</sup>Ochanomizu Univ.) Shoko TANAKA<sup>1</sup>, 〇Rena YAMAGUCHI<sup>1</sup>, Ryosuke Miyake<sup>1</sup>"
    ],
    "lab": "3PA-80",
    "pdf": "pdf/3PA-80.pdf",
    "pre": "tn/3PA-80.jpg",
    "reg": "74542",
    "sea": "Ni",
    "ses": "3PA",
    "con": "3PA-80 柔軟なトリペプチド巨大環状錯体の構造制御要因に関する考察 (<sup>1</sup>お茶大院理) 田中 頌子<sup>1</sup>・〇山口 麗奈<sup>1</sup>・三宅 亮介<sup>1</sup> Discussion of Factors Controlling the formation of Giant Cyclic Complexes of a Flexible Tripeptide (<sup>1</sup>Ochanomizu Univ.) Shoko TANAKA<sup>1</sup>, 〇Rena YAMAGUCHI<sup>1</sup>, Ryosuke Miyake<sup>1</sup> Ni"
  },
  {
    "inf": [
      "準1次元親水性ナノ結晶細孔中を透過するイオンの直流イオン伝導性",
      "(<sup>1</sup>東理大理) 〇松嶋 佳苗<sup>1</sup>・戸ヶ里 磨人<sup>1</sup>・小林 文也<sup>1</sup>・田所 誠<sup>1</sup>",
      "DC Ionic Conductivity in a Quasi-1-D Hydrophilic Nano-Porous Crystal",
      "(<sup>1</sup>Tokyo Univ, of Sci) 〇Kanae MATSUSHIMA<sup>1</sup>, Mahito TOGARI<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup>"
    ],
    "lab": "3PA-81",
    "pdf": "pdf/3PA-81.pdf",
    "pre": "tn/3PA-81.jpg",
    "reg": "74546",
    "sea": "Cr",
    "ses": "3PA",
    "con": "3PA-81 準1次元親水性ナノ結晶細孔中を透過するイオンの直流イオン伝導性 (<sup>1</sup>東理大理) 〇松嶋 佳苗<sup>1</sup>・戸ヶ里 磨人<sup>1</sup>・小林 文也<sup>1</sup>・田所 誠<sup>1</sup> DC Ionic Conductivity in a Quasi-1-D Hydrophilic Nano-Porous Crystal (<sup>1</sup>Tokyo Univ, of Sci) 〇Kanae MATSUSHIMA<sup>1</sup>, Mahito TOGARI<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup> Cr"
  },
  {
    "inf": [
      "アズレン部位を有するカゴメ型MOFの合成とガス吸着特性",
      "(<sup>1</sup>名大院工) 〇高原 哲平<sup>1</sup>・PIRILLO Jenny<sup>1</sup>・QU Liyuan<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1</sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup>",
      "Synthesis and Gas Adsorption Properties of Kagome-type MOFs with Azulene Moieties",
      "(<sup>1</sup>Nagoya Univ.) 〇Teppei TAKAHARA<sup>1</sup>, Jenny PIRILLO<sup>1</sup>, Liyuan QU<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1</sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup>"
    ],
    "lab": "3PA-82",
    "pdf": "pdf/3PA-82.pdf",
    "pre": "tn/3PA-82.jpg",
    "reg": "74552",
    "sea": "Cu",
    "ses": "3PA",
    "con": "3PA-82 アズレン部位を有するカゴメ型MOFの合成とガス吸着特性 (<sup>1</sup>名大院工) 〇高原 哲平<sup>1</sup>・PIRILLO Jenny<sup>1</sup>・QU Liyuan<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1</sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup> Synthesis and Gas Adsorption Properties of Kagome-type MOFs with Azulene Moieties (<sup>1</sup>Nagoya Univ.) 〇Teppei TAKAHARA<sup>1</sup>, Jenny PIRILLO<sup>1</sup>, Liyuan QU<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1</sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "水車型ルテニウム二核(II,III)錯体を前駆体とするカチオン性ソフトマテリアルの開発",
      "(<sup>1</sup>東北大理,金研) 〇伊藤 早亜努<sup>1</sup>・芳野 遼<sup>1</sup>・宮坂 等<sup>1</sup>",
      "Cationic Soft Materials Based on Dinuclear Ruthenium(II,III) Water Wheel Complexes as Precursors",
      "(<sup>1</sup>Institute for Materials Reserch,Tohoku Univ.) 〇Saado Itoh<sup>1</sup>, Haruka Yoshino<sup>1</sup>, Hitoshi Miyasaka<sup>1</sup>"
    ],
    "lab": "3PA-83",
    "pdf": "pdf/3PA-83.pdf",
    "pre": "tn/3PA-83.jpg",
    "reg": "74566",
    "sea": "Ru",
    "ses": "3PA",
    "con": "3PA-83 水車型ルテニウム二核(II,III)錯体を前駆体とするカチオン性ソフトマテリアルの開発 (<sup>1</sup>東北大理,金研) 〇伊藤 早亜努<sup>1</sup>・芳野 遼<sup>1</sup>・宮坂 等<sup>1</sup> Cationic Soft Materials Based on Dinuclear Ruthenium(II,III) Water Wheel Complexes as Precursors (<sup>1</sup>Institute for Materials Reserch,Tohoku Univ.) 〇Saado Itoh<sup>1</sup>, Haruka Yoshino<sup>1</sup>, Hitoshi Miyasaka<sup>1</sup> Ru"
  },
  {
    "inf": [
      "凝集有機発光特性を示すイミノフェノキシフェニルおよびイミノチオフェノキシフェニル白金(II)錯体の開発",
      "(<sup>1</sup>阪大院基礎工) 〇世古 開丸<sup>1</sup>・川守田 創一郎<sup>1</sup>・鈴木 修一<sup>1</sup>・直田 健<sup>1</sup>",
      "Aggregation-Induced Emission Enhancement of Iminophenoxy Pheyl and Iminothiophenoxy Phenyl Platinum (II) Complexes",
      "(<sup>1</sup>Grad. Sch. Eng. Sci., Osaka Univ.) 〇Kaimaru SEKO<sup>1</sup>, Soichiro KAWAMORITA<sup>1</sup>, Shuichi SUZUKI<sup>1</sup>, Takeshi NAOTA<sup>1</sup>"
    ],
    "lab": "3PA-84",
    "pdf": "pdf/3PA-84.pdf",
    "pre": "tn/3PA-84.jpg",
    "reg": "74580",
    "sea": "Pt",
    "ses": "3PA",
    "con": "3PA-84 凝集有機発光特性を示すイミノフェノキシフェニルおよびイミノチオフェノキシフェニル白金(II)錯体の開発 (<sup>1</sup>阪大院基礎工) 〇世古 開丸<sup>1</sup>・川守田 創一郎<sup>1</sup>・鈴木 修一<sup>1</sup>・直田 健<sup>1</sup> Aggregation-Induced Emission Enhancement of Iminophenoxy Pheyl and Iminothiophenoxy Phenyl Platinum (II) Complexes (<sup>1</sup>Grad. Sch. Eng. Sci., Osaka Univ.) 〇Kaimaru SEKO<sup>1</sup>, Soichiro KAWAMORITA<sup>1</sup>, Shuichi SUZUKI<sup>1</sup>, Takeshi NAOTA<sup>1</sup> Pt"
  },
  {
    "inf": [
      "cPenPh3Pを対カチオンに用いた鉄混合原子価錯体の積層様式と磁性の相関",
      "(<sup>1</sup>東理大院理) 〇河村 拓真<sup>1</sup>・金友 拓哉<sup>1</sup>・榎本 真哉<sup>1</sup>",
      "Correlation between stacking manner of magnetic layers and magnetism for an iron mixed valence complex with <sup>_c_</sup>PenPh<sub>3</sub>P as an intercalated cation",
      "(<sup>1</sup>Tokyo Univ. of Sci.) 〇Takuma Kawamura<sup>1</sup>, Takuya Kanetomo<sup>1</sup>, Masaya Enomoto<sup>1</sup>"
    ],
    "lab": "3PA-85",
    "pdf": "pdf/3PA-85.pdf",
    "pre": "tn/3PA-85.jpg",
    "reg": "74563",
    "sea": "Fe",
    "ses": "3PA",
    "con": "3PA-85 cPenPh3Pを対カチオンに用いた鉄混合原子価錯体の積層様式と磁性の相関 (<sup>1</sup>東理大院理) 〇河村 拓真<sup>1</sup>・金友 拓哉<sup>1</sup>・榎本 真哉<sup>1</sup> Correlation between stacking manner of magnetic layers and magnetism for an iron mixed valence complex with <sup>_c_</sup>PenPh<sub>3</sub>P as an intercalated cation (<sup>1</sup>Tokyo Univ. of Sci.) 〇Takuma Kawamura<sup>1</sup>, Takuya Kanetomo<sup>1</sup>, Masaya Enomoto<sup>1</sup> Fe"
  },
  {
    "inf": [
      "ゲート吸着と相転移特性を有する柔軟性配位高分子の合成",
      "(<sup>1</sup>北大院環境・<sup>2</sup>北大院地球環境) 〇湯谷 悠希<sup>1</sup>・鄭 キン<sup>1,2</sup>・齋藤 結大<sup>1,2</sup>・野呂 真一郎<sup>1,2</sup>",
      "Synthesis of a flexible coordination polymer with gated sorption and phase transition properties",
      "(<sup>1</sup>Graduate School of Environmental Science, Hokkaido University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Yuki Yutani<sup>1</sup>, Xin Zheng<sup>1,2</sup>, Yuki Saito<sup>1,2</sup>, Shin-ichiro Noro<sup>1,2</sup>"
    ],
    "lab": "3PA-86",
    "pdf": "pdf/3PA-86.pdf",
    "pre": "tn/3PA-86.jpg",
    "reg": "74449",
    "sea": "Cu",
    "ses": "3PA",
    "con": "3PA-86 ゲート吸着と相転移特性を有する柔軟性配位高分子の合成 (<sup>1</sup>北大院環境・<sup>2</sup>北大院地球環境) 〇湯谷 悠希<sup>1</sup>・鄭 キン<sup>1,2</sup>・齋藤 結大<sup>1,2</sup>・野呂 真一郎<sup>1,2</sup> Synthesis of a flexible coordination polymer with gated sorption and phase transition properties (<sup>1</sup>Graduate School of Environmental Science, Hokkaido University, <sup>2</sup>Faculty of Environmental Earth Science, Hokkaido University) 〇Yuki Yutani<sup>1</sup>, Xin Zheng<sup>1,2</sup>, Yuki Saito<sup>1,2</sup>, Shin-ichiro Noro<sup>1,2</sup> Cu"
  },
  {
    "inf": [
      "ベンズイミダゾール架橋配位子を用いた硝酸銀錯体の合成と構造",
      "(<sup>1</sup>静大理化) 〇渡邉 佳乃子<sup>1</sup>・近藤 満<sup>1</sup>",
      "Synthesis and Crystal Structures of Silver Nitrate Complex with Benzimidazole Bridging Ligand",
      "(<sup>1</sup>Shizuoka Univ) 〇Kanoko WATANABE<sup>1</sup>, Mitsuru KONDO<sup>1</sup>"
    ],
    "lab": "3PA-87",
    "pdf": "pdf/3PA-87.pdf",
    "pre": "tn/3PA-87.jpg",
    "reg": "74582",
    "sea": "Ag",
    "ses": "3PA",
    "con": "3PA-87 ベンズイミダゾール架橋配位子を用いた硝酸銀錯体の合成と構造 (<sup>1</sup>静大理化) 〇渡邉 佳乃子<sup>1</sup>・近藤 満<sup>1</sup> Synthesis and Crystal Structures of Silver Nitrate Complex with Benzimidazole Bridging Ligand (<sup>1</sup>Shizuoka Univ) 〇Kanoko WATANABE<sup>1</sup>, Mitsuru KONDO<sup>1</sup> Ag"
  },
  {
    "inf": [
      "NAD<sup>+</sup>モデル配位子を有するZn錯体の合成・性質と置換基効果",
      "(<sup>1</sup>富山大院理工) 𠮷本 楓希<sup>1</sup>・柘植 清志<sup>1</sup>・〇大津 英揮<sup>1</sup>",
      "Synthesis, Characterization, and Substituent Effect of Zn Complexes having NAD<sup>+</sup> Model Ligands",
      "(<sup>1</sup>Grad. School of Sci. and Eng., Univ. of Toyama) Fuki YOSHIMOTO<sup>1</sup>, Kiyoshi TSUGE<sup>1</sup>, 〇Hideki OHTSU<sup>1</sup>"
    ],
    "lab": "3PA-88",
    "pdf": "pdf/3PA-88.pdf",
    "pre": "tn/3PA-88.jpg",
    "reg": "74590",
    "sea": "Zn",
    "ses": "3PA",
    "con": "3PA-88 NAD<sup>+</sup>モデル配位子を有するZn錯体の合成・性質と置換基効果 (<sup>1</sup>富山大院理工) 𠮷本 楓希<sup>1</sup>・柘植 清志<sup>1</sup>・〇大津 英揮<sup>1</sup> Synthesis, Characterization, and Substituent Effect of Zn Complexes having NAD<sup>+</sup> Model Ligands (<sup>1</sup>Grad. School of Sci. and Eng., Univ. of Toyama) Fuki YOSHIMOTO<sup>1</sup>, Kiyoshi TSUGE<sup>1</sup>, 〇Hideki OHTSU<sup>1</sup> Zn"
  },
  {
    "inf": [
      "直鎖三リン酸含有ペルオキソバナデートの結晶性向上と新規合成法の検討",
      "(<sup>1</sup>和歌山大システム工) 〇岡 大輔<sup>1</sup>・橋本 正人<sup>1</sup>",
      "Improvement of crystal quality of a triperoxodivanadate containing linear triphosphate and investigation of a new synthetic method of a novel peroxotriphosphatovanadate",
      "(<sup>1</sup>Faculty of Systems Engineering, Wakayama Univ.) 〇Daisuke Oka<sup>1</sup>, Masato Hashimoto<sup>1</sup>"
    ],
    "lab": "3PA-89",
    "pdf": "pdf/3PA-89.pdf",
    "pre": "tn/3PA-89.jpg",
    "reg": "74561",
    "sea": "V",
    "ses": "3PA",
    "con": "3PA-89 直鎖三リン酸含有ペルオキソバナデートの結晶性向上と新規合成法の検討 (<sup>1</sup>和歌山大システム工) 〇岡 大輔<sup>1</sup>・橋本 正人<sup>1</sup> Improvement of crystal quality of a triperoxodivanadate containing linear triphosphate and investigation of a new synthetic method of a novel peroxotriphosphatovanadate (<sup>1</sup>Faculty of Systems Engineering, Wakayama Univ.) 〇Daisuke Oka<sup>1</sup>, Masato Hashimoto<sup>1</sup> V"
  },
  {
    "inf": [
      "環周辺のαおよびβ位にトリ(オキシエチレン)鎖を導入した両親媒性フタロシアニン錯体",
      "(<sup>1</sup>島根大院自然科学・<sup>2</sup>富山大教養・<sup>3</sup>岡山理大フロンティア理工学研・<sup>4</sup>関学大生命環境) 〇尾崎 真衣<sup>1</sup>・浦田 友寛<sup>1</sup>・中島 海<sup>1</sup>・杉森 保<sup>2</sup>・赤司 治夫<sup>3</sup>・御厨 正博<sup>4</sup>・半田 真<sup>1</sup>",
      "Amphiphilic metallophthalocyanines introduced with tri(oxyethylene) chains at non-peripheral α positions and peripheral β positions ",
      "(<sup>1</sup>Shimane Univ., <sup>2</sup>Univ. Toyama, <sup>3</sup>Okayama Univ. Sci., <sup>4</sup>Kansei Gakuin Univ.) 〇Mai OZAKI<sup>1</sup>, Tomohiro URATA<sup>1</sup>, Kai NAKASHIMA<sup>1</sup>, Tamotsu SUGIMORI<sup>2</sup>, Haruo AKASHI<sup>3</sup>, Masahiro MIKURIYA<sup>4</sup>, Makoto Handa<sup>1</sup>"
    ],
    "lab": "3PA-90",
    "pdf": "pdf/3PA-90.pdf",
    "pre": "tn/3PA-90.jpg",
    "reg": "74596",
    "sea": "Zn, Ni, Pd",
    "ses": "3PA",
    "con": "3PA-90 環周辺のαおよびβ位にトリ(オキシエチレン)鎖を導入した両親媒性フタロシアニン錯体 (<sup>1</sup>島根大院自然科学・<sup>2</sup>富山大教養・<sup>3</sup>岡山理大フロンティア理工学研・<sup>4</sup>関学大生命環境) 〇尾崎 真衣<sup>1</sup>・浦田 友寛<sup>1</sup>・中島 海<sup>1</sup>・杉森 保<sup>2</sup>・赤司 治夫<sup>3</sup>・御厨 正博<sup>4</sup>・半田 真<sup>1</sup> Amphiphilic metallophthalocyanines introduced with tri(oxyethylene) chains at non-peripheral α positions and peripheral β positions  (<sup>1</sup>Shimane Univ., <sup>2</sup>Univ. Toyama, <sup>3</sup>Okayama Univ. Sci., <sup>4</sup>Kansei Gakuin Univ.) 〇Mai OZAKI<sup>1</sup>, Tomohiro URATA<sup>1</sup>, Kai NAKASHIMA<sup>1</sup>, Tamotsu SUGIMORI<sup>2</sup>, Haruo AKASHI<sup>3</sup>, Masahiro MIKURIYA<sup>4</sup>, Makoto Handa<sup>1</sup> Zn, Ni, Pd"
  },
  {
    "inf": [
      "単一分子PEGオリゴマーとアルカリ金属塩の固体電解質を閉じ込めた水素結合型多孔質金属錯体結晶の構造とイオン伝導性",
      "(<sup>1</sup>東理大理) 〇南谷 翔太<sup>1</sup>・藤本 貫太<sup>1</sup>・塚本 翔也<sup>1</sup>・吉田 孟司<sup>1</sup>・小林 文也<sup>1</sup>・田所 誠<sup>1</sup>",
      "Crystal Structure and Ionic Conductivity on Solid-state Electrolyte of Alkali Metal Ions with Single-Molecular PEG Oligomer Confined to Nanoporous Framework Formed from Hydrogen-Bonded Metal Complexes",
      "(<sup>1</sup>Tokyo University of Science) 〇Shota MINAMITANI<sup>1</sup>, Kanta FUJIMOTO<sup>1</sup>, Shoya TSUKAMOTO<sup>1</sup>, Takeshi YOSHIDA<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup>"
    ],
    "lab": "3PA-91",
    "pdf": "pdf/3PA-91.pdf",
    "pre": "tn/3PA-91.jpg",
    "reg": "74589",
    "sea": "Rb, K, Ni",
    "ses": "3PA",
    "con": "3PA-91 単一分子PEGオリゴマーとアルカリ金属塩の固体電解質を閉じ込めた水素結合型多孔質金属錯体結晶の構造とイオン伝導性 (<sup>1</sup>東理大理) 〇南谷 翔太<sup>1</sup>・藤本 貫太<sup>1</sup>・塚本 翔也<sup>1</sup>・吉田 孟司<sup>1</sup>・小林 文也<sup>1</sup>・田所 誠<sup>1</sup> Crystal Structure and Ionic Conductivity on Solid-state Electrolyte of Alkali Metal Ions with Single-Molecular PEG Oligomer Confined to Nanoporous Framework Formed from Hydrogen-Bonded Metal Complexes (<sup>1</sup>Tokyo University of Science) 〇Shota MINAMITANI<sup>1</sup>, Kanta FUJIMOTO<sup>1</sup>, Shoya TSUKAMOTO<sup>1</sup>, Takeshi YOSHIDA<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup> Rb, K, Ni"
  },
  {
    "inf": [
      "配位子の置換基に依存した陰イオン性色素を有する金属錯体のアニオン呈色活性",
      "(<sup>1</sup>静岡大理) 〇暮林 響香<sup>1</sup>・近藤 満<sup>1</sup>・深澤 結<sup>1</sup>・石黒 樹那<sup>1</sup>・平林 未奈<sup>1</sup>",
      "The Anion-Coloration Effects by the Metal Complexes having Anionic Dyes Depending on the Substituent in the Ligand",
      "(<sup>1</sup>Shizuoka Univ.) 〇Kyoka KUREBAYASHI<sup>1</sup>, Mitsuru KONDO<sup>1</sup>, Yui FUKASAWA<sup>1</sup>, Juna ISHIGURO<sup>1</sup>, Mina HIRABAYASHI<sup>1</sup>"
    ],
    "lab": "3PA-92",
    "pdf": "pdf/3PA-92.pdf",
    "pre": "tn/3PA-92.jpg",
    "reg": "74587",
    "sea": "Cu",
    "ses": "3PA",
    "con": "3PA-92 配位子の置換基に依存した陰イオン性色素を有する金属錯体のアニオン呈色活性 (<sup>1</sup>静岡大理) 〇暮林 響香<sup>1</sup>・近藤 満<sup>1</sup>・深澤 結<sup>1</sup>・石黒 樹那<sup>1</sup>・平林 未奈<sup>1</sup> The Anion-Coloration Effects by the Metal Complexes having Anionic Dyes Depending on the Substituent in the Ligand (<sup>1</sup>Shizuoka Univ.) 〇Kyoka KUREBAYASHI<sup>1</sup>, Mitsuru KONDO<sup>1</sup>, Yui FUKASAWA<sup>1</sup>, Juna ISHIGURO<sup>1</sup>, Mina HIRABAYASHI<sup>1</sup> Cu"
  },
  {
    "inf": [
      "電子ドナー性ジヒドロインドロカルバゾール骨格を有するMOFの合成と構造",
      "(<sup>1</sup>名大院工) 〇LI Wenxin<sup>1</sup>・薄葉 純一<sup>1</sup>・Jenny PIRILLO<sup>1</sup>・QU Liyuan<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1</sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup>",
      "Syntheses and Structures of MOFs with Electron-Donating Dihydroindolocarbazole Moiety",
      "(<sup>1</sup>Nagoya Univ.) 〇LI Wenxin<sup>1</sup>, Junichi USUBA<sup>1</sup>, Jenny PIRILLO<sup>1</sup>, QU Liyuan<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1</sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup>"
    ],
    "lab": "3PA-93",
    "pdf": "pdf/3PA-93.pdf",
    "pre": "tn/3PA-93.jpg",
    "reg": "74573",
    "sea": "Mn, Nd",
    "ses": "3PA",
    "con": "3PA-93 電子ドナー性ジヒドロインドロカルバゾール骨格を有するMOFの合成と構造 (<sup>1</sup>名大院工) 〇LI Wenxin<sup>1</sup>・薄葉 純一<sup>1</sup>・Jenny PIRILLO<sup>1</sup>・QU Liyuan<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1</sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup> Syntheses and Structures of MOFs with Electron-Donating Dihydroindolocarbazole Moiety (<sup>1</sup>Nagoya Univ.) 〇LI Wenxin<sup>1</sup>, Junichi USUBA<sup>1</sup>, Jenny PIRILLO<sup>1</sup>, QU Liyuan<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1</sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup> Mn, Nd"
  },
  {
    "inf": [
      "ニトロキシドラジカル配位子がテルビウム錯体の磁気特性に及ぼす影響に関する理論研究",
      "(<sup>1</sup>阪大院基礎工・<sup>2</sup>QIQB・<sup>3</sup>RCSEC・<sup>4</sup>ICS-OTRI・<sup>5</sup>電通大院工・<sup>6</sup>OTRI-Spin) 〇高 海斗<sup>1</sup>・井上 廉<sup>1</sup>・益田 晃希<sup>1</sup>・多田 幸平<sup>1</sup>・岸 亮平<sup>1,2,3,4</sup>・石田 尚行<sup>5</sup>・北河 康隆<sup>1,2,3,4,6</sup>",
      "Theoretical study of effect of nitrite radical ligand on magnetic properties of Terbium(III) complexes",
      "(<sup>1</sup>Graduate School of Engineering Science, Osaka Univ., <sup>2</sup>QIQB, Osaka Univ., <sup>3</sup>RCSEC, Osaka Univ., <sup>4</sup>ICS-OTRI Osaka Univ., <sup>5</sup>Graduate School of Informatics and Engineering, The Univ. of Electro-Communication, <sup>6</sup>OTRI-Spin, Osaka Univ.) 〇Kaito TAKA<sup>1</sup>, Ren INOUE<sup>1</sup>, Koki MASUDA<sup>1</sup>, Kohei TADA<sup>1</sup>, Ryohei KISHI<sup>1,2,3,4</sup>, Takayuki ISHIDA<sup>5</sup>, Yasutaka KITAGAWA<sup>1,2,3,4,6</sup>"
    ],
    "lab": "3PB-01",
    "pdf": "pdf/3PB-01.pdf",
    "pre": "tn/3PB-01.jpg",
    "reg": "74105",
    "sea": "Tb",
    "ses": "3PB",
    "con": "3PB-01 ニトロキシドラジカル配位子がテルビウム錯体の磁気特性に及ぼす影響に関する理論研究 (<sup>1</sup>阪大院基礎工・<sup>2</sup>QIQB・<sup>3</sup>RCSEC・<sup>4</sup>ICS-OTRI・<sup>5</sup>電通大院工・<sup>6</sup>OTRI-Spin) 〇高 海斗<sup>1</sup>・井上 廉<sup>1</sup>・益田 晃希<sup>1</sup>・多田 幸平<sup>1</sup>・岸 亮平<sup>1,2,3,4</sup>・石田 尚行<sup>5</sup>・北河 康隆<sup>1,2,3,4,6</sup> Theoretical study of effect of nitrite radical ligand on magnetic properties of Terbium(III) complexes (<sup>1</sup>Graduate School of Engineering Science, Osaka Univ., <sup>2</sup>QIQB, Osaka Univ., <sup>3</sup>RCSEC, Osaka Univ., <sup>4</sup>ICS-OTRI Osaka Univ., <sup>5</sup>Graduate School of Informatics and Engineering, The Univ. of Electro-Communication, <sup>6</sup>OTRI-Spin, Osaka Univ.) 〇Kaito TAKA<sup>1</sup>, Ren INOUE<sup>1</sup>, Koki MASUDA<sup>1</sup>, Kohei TADA<sup>1</sup>, Ryohei KISHI<sup>1,2,3,4</sup>, Takayuki ISHIDA<sup>5</sup>, Yasutaka KITAGAWA<sup>1,2,3,4,6</sup> Tb"
  },
  {
    "inf": [
      "シアノ架橋Ni(II)-M(III)一次元鎖状錯体の合成と性質",
      "(<sup>1</sup>福岡大理) 〇有本 陽菜<sup>1</sup>・三島 章雄<sup>1</sup>・濱口 智彦<sup>1</sup>・川田 知<sup>1</sup>・石川 立太<sup>1</sup>",
      "Syntheses and Properties of cyano-bridged Ni<sup>II</sup>–M<sup>III</sup> one-dimensional coordination polymer",
      "(<sup>1</sup>Fukuoka Univ.) 〇Hina ARIMOTO<sup>1</sup>, Akio MISHIMA<sup>1</sup>, Tomohiko HAMAGUCHI<sup>1</sup>, Satoshi KAWATA<sup>1</sup>, Ryuta ISHIKAWA<sup>1</sup>"
    ],
    "lab": "3PB-02",
    "pdf": "pdf/3PB-02.pdf",
    "pre": "tn/3PB-02.jpg",
    "reg": "74406",
    "sea": "Ni, Fe, Co, Cr",
    "ses": "3PB",
    "con": "3PB-02 シアノ架橋Ni(II)-M(III)一次元鎖状錯体の合成と性質 (<sup>1</sup>福岡大理) 〇有本 陽菜<sup>1</sup>・三島 章雄<sup>1</sup>・濱口 智彦<sup>1</sup>・川田 知<sup>1</sup>・石川 立太<sup>1</sup> Syntheses and Properties of cyano-bridged Ni<sup>II</sup>–M<sup>III</sup> one-dimensional coordination polymer (<sup>1</sup>Fukuoka Univ.) 〇Hina ARIMOTO<sup>1</sup>, Akio MISHIMA<sup>1</sup>, Tomohiko HAMAGUCHI<sup>1</sup>, Satoshi KAWATA<sup>1</sup>, Ryuta ISHIKAWA<sup>1</sup> Ni, Fe, Co, Cr"
  },
  {
    "inf": [
      "_p_-ジメチルアミノフェノラート配位子を有するコバルト錯体の原子価異性",
      "(<sup>1</sup>茨大院 理工) 〇金城 星彦<sup>1</sup>・島崎 優一<sup>1</sup>",
      "Valence isomerization of Co complexes with a _p_-dimethylaminophenolate ligand",
      "(<sup>1</sup>Graduate School of Science and Engineering Ibaraki University) 〇Hoshihiko KANESHIRO<sup>1</sup>, Yuichi SHIMAZAKI<sup>1</sup>"
    ],
    "lab": "3PB-03",
    "pdf": "pdf/3PB-03.pdf",
    "pre": "tn/3PB-03.jpg",
    "reg": "74045",
    "sea": "Co",
    "ses": "3PB",
    "con": "3PB-03 _p_-ジメチルアミノフェノラート配位子を有するコバルト錯体の原子価異性 (<sup>1</sup>茨大院 理工) 〇金城 星彦<sup>1</sup>・島崎 優一<sup>1</sup> Valence isomerization of Co complexes with a _p_-dimethylaminophenolate ligand (<sup>1</sup>Graduate School of Science and Engineering Ibaraki University) 〇Hoshihiko KANESHIRO<sup>1</sup>, Yuichi SHIMAZAKI<sup>1</sup> Co"
  },
  {
    "inf": [
      "ルテニウム6価ジオキソポルフィリン錯体とプロトンとの反応解析",
      "(<sup>1</sup>奈良女大院理) 〇森 有美<sup>1</sup>・本田 裕樹<sup>1</sup>・藤井 浩<sup>1</sup>",
      "Reaction of Dioxo-Ruthenium(Ⅵ) Porphyrin Complex with Proton",
      "(<sup>1</sup>Department of Chemistry, Biology, and Environmental Science, Nara Women's University) 〇Arimi MORI<sup>1</sup>, Yuki HONDA<sup>1</sup>, Hiroshi FUJII<sup>1</sup>"
    ],
    "lab": "3PB-04",
    "pdf": "pdf/3PB-04.pdf",
    "pre": "tn/3PB-04.jpg",
    "reg": "74082",
    "sea": "Ru",
    "ses": "3PB",
    "con": "3PB-04 ルテニウム6価ジオキソポルフィリン錯体とプロトンとの反応解析 (<sup>1</sup>奈良女大院理) 〇森 有美<sup>1</sup>・本田 裕樹<sup>1</sup>・藤井 浩<sup>1</sup> Reaction of Dioxo-Ruthenium(Ⅵ) Porphyrin Complex with Proton (<sup>1</sup>Department of Chemistry, Biology, and Environmental Science, Nara Women's University) 〇Arimi MORI<sup>1</sup>, Yuki HONDA<sup>1</sup>, Hiroshi FUJII<sup>1</sup> Ru"
  },
  {
    "inf": [
      "水素結合型金属錯体ダイマーにおける水素結合ペアの交換反応",
      "(<sup>1</sup>東理大理) 〇丸山 大地<sup>1</sup>・四十物 志穂<sup>1</sup>・小林 文也<sup>1</sup>・田所 誠<sup>1</sup>",
      "Exchange Reaction to Hydrogen-bonding pairs in Hydrogen-bonded Dimers between Biimidazolate Metal Complexes",
      "(<sup>1</sup>Tokyo Univ. of Sci.) 〇Daichi Maruyama<sup>1</sup>, Shiho AIMONO<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup>"
    ],
    "lab": "3PB-05",
    "pdf": "pdf/3PB-05.pdf",
    "pre": "tn/3PB-05.jpg",
    "reg": "74500",
    "sea": "Re, Os, Ru",
    "ses": "3PB",
    "con": "3PB-05 水素結合型金属錯体ダイマーにおける水素結合ペアの交換反応 (<sup>1</sup>東理大理) 〇丸山 大地<sup>1</sup>・四十物 志穂<sup>1</sup>・小林 文也<sup>1</sup>・田所 誠<sup>1</sup> Exchange Reaction to Hydrogen-bonding pairs in Hydrogen-bonded Dimers between Biimidazolate Metal Complexes (<sup>1</sup>Tokyo Univ. of Sci.) 〇Daichi Maruyama<sup>1</sup>, Shiho AIMONO<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup> Re, Os, Ru"
  },
  {
    "inf": [
      "密度汎関数法の汎関数が磁気異方性の計算に与える影響に関する理論研究",
      "(<sup>1</sup>阪大院基礎工・<sup>2</sup>阪大QIQB・<sup>3</sup>阪大RCSEC・<sup>4</sup>阪大ICS-OTRI・<sup>5</sup>阪大OTRI-Spin) 〇井上 廉<sup>1</sup>・高 海斗<sup>1</sup>・益田 晃希<sup>1</sup>・多田 幸平<sup>1</sup>・岸 亮平<sup>1,2,3,4</sup>・北河 康隆<sup>1,2,3,4,5</sup>",
      "Theoretical Study on the Influence of the Functional of DFT on the Calculation of  Magnetic Anisotropy",
      "(<sup>1</sup>Graduate School of Engineering Science, Osaka Univ., <sup>2</sup>QIQB, Osaka Univ., <sup>3</sup>RCSEC, Osaka Univ., <sup>4</sup>ICS-OTRI, Osaka Univ., <sup>5</sup>OTRI-Spin, Osaka Univ.) 〇Ren INOUE<sup>1</sup>, Kaito TAKA<sup>1</sup>, Koki MASUDA<sup>1</sup>, Kohei TADA<sup>1</sup>, Ryohei KISHI<sup>1,2,3,4</sup>, Yasutaka KITAGAWA<sup>1,2,3,4,5</sup>"
    ],
    "lab": "3PB-06",
    "pdf": "pdf/3PB-06.pdf",
    "pre": "tn/3PB-06.jpg",
    "reg": "74121",
    "sea": "Dy",
    "ses": "3PB",
    "con": "3PB-06 密度汎関数法の汎関数が磁気異方性の計算に与える影響に関する理論研究 (<sup>1</sup>阪大院基礎工・<sup>2</sup>阪大QIQB・<sup>3</sup>阪大RCSEC・<sup>4</sup>阪大ICS-OTRI・<sup>5</sup>阪大OTRI-Spin) 〇井上 廉<sup>1</sup>・高 海斗<sup>1</sup>・益田 晃希<sup>1</sup>・多田 幸平<sup>1</sup>・岸 亮平<sup>1,2,3,4</sup>・北河 康隆<sup>1,2,3,4,5</sup> Theoretical Study on the Influence of the Functional of DFT on the Calculation of  Magnetic Anisotropy (<sup>1</sup>Graduate School of Engineering Science, Osaka Univ., <sup>2</sup>QIQB, Osaka Univ., <sup>3</sup>RCSEC, Osaka Univ., <sup>4</sup>ICS-OTRI, Osaka Univ., <sup>5</sup>OTRI-Spin, Osaka Univ.) 〇Ren INOUE<sup>1</sup>, Kaito TAKA<sup>1</sup>, Koki MASUDA<sup>1</sup>, Kohei TADA<sup>1</sup>, Ryohei KISHI<sup>1,2,3,4</sup>, Yasutaka KITAGAWA<sup>1,2,3,4,5</sup> Dy"
  },
  {
    "inf": [
      "γ-シクロデキストリンを用いたNi(II)錯体の構造制御",
      "(<sup>1</sup>福岡大理) 〇高濱陸矢<sup>1</sup>・三島章雄<sup>1</sup>・濱口智彦<sup>1</sup>・石川立太<sup>1</sup>・川田知<sup>1</sup>",
      "Controlling the structure of nickel complexes through the using of γ-cyclodextrin",
      "(<sup>1</sup>Fukuoka Univ) 〇Rikuya Takahama<sup>1</sup>, Akio Mishima<sup>1</sup>, Tomohiko Hamaguchi<sup>1</sup>, Ryuta Ishikawa<sup>1</sup>, Satoshi Kawata<sup>1</sup>"
    ],
    "lab": "3PB-07",
    "pdf": "pdf/3PB-07.pdf",
    "pre": "tn/3PB-07.jpg",
    "reg": "74504",
    "sea": "Ni, Cu",
    "ses": "3PB",
    "con": "3PB-07 γ-シクロデキストリンを用いたNi(II)錯体の構造制御 (<sup>1</sup>福岡大理) 〇高濱陸矢<sup>1</sup>・三島章雄<sup>1</sup>・濱口智彦<sup>1</sup>・石川立太<sup>1</sup>・川田知<sup>1</sup> Controlling the structure of nickel complexes through the using of γ-cyclodextrin (<sup>1</sup>Fukuoka Univ) 〇Rikuya Takahama<sup>1</sup>, Akio Mishima<sup>1</sup>, Tomohiko Hamaguchi<sup>1</sup>, Ryuta Ishikawa<sup>1</sup>, Satoshi Kawata<sup>1</sup> Ni, Cu"
  },
  {
    "inf": [
      "金属/有機複合ヒドリドを含むRu(Ⅱ)錯体における幾何異性体間の電子状態及び反応性比較",
      "(<sup>1</sup>福島大院理工・<sup>2</sup>福島大水素研) 〇森原 麻斗<sup>1</sup>・高瀬 つぎ子<sup>1</sup>・大山 大<sup>1,2</sup>",
      "Comparison of electronic states and reactivities between geometrical isomers in Ru(II) complexes with metal and organic hydrides",
      "(<sup>1</sup>Fukushima Univ., <sup>2</sup>HERI) 〇Asato MORIHARA<sup>1</sup>, Tsugiko TAKASE<sup>1</sup>, Dai OYAMA<sup>1,2</sup>"
    ],
    "lab": "3PB-08",
    "pdf": "pdf/3PB-08.pdf",
    "pre": "tn/3PB-08.jpg",
    "reg": "74227",
    "sea": "Ru",
    "ses": "3PB",
    "con": "3PB-08 金属/有機複合ヒドリドを含むRu(Ⅱ)錯体における幾何異性体間の電子状態及び反応性比較 (<sup>1</sup>福島大院理工・<sup>2</sup>福島大水素研) 〇森原 麻斗<sup>1</sup>・高瀬 つぎ子<sup>1</sup>・大山 大<sup>1,2</sup> Comparison of electronic states and reactivities between geometrical isomers in Ru(II) complexes with metal and organic hydrides (<sup>1</sup>Fukushima Univ., <sup>2</sup>HERI) 〇Asato MORIHARA<sup>1</sup>, Tsugiko TAKASE<sup>1</sup>, Dai OYAMA<sup>1,2</sup> Ru"
  },
  {
    "inf": [
      "Heterometallic interaction emerges from Tb-L<sub>3</sub> resonant inelastic X-ray scattering in the Tb−Pt complex",
      "(<sup>1</sup>Wakayama Univ., <sup>2</sup>UEC, <sup>3</sup>Riken, <sup>4</sup>Tohoku Univ.) 〇Takefumi YOSHIDA<sup>1, 2, 3</sup>, Yasuhiro IWASAWA<sup>2, 3</sup>, Masahiro YAMASHITA<sup>4</sup>"
    ],
    "lab": "3PB-09",
    "pdf": "pdf/3PB-09.pdf",
    "pre": "tn/3PB-09.jpg",
    "reg": "74400",
    "sea": "Pt, Tb",
    "ses": "3PB",
    "con": "3PB-09 Heterometallic interaction emerges from Tb-L<sub>3</sub> resonant inelastic X-ray scattering in the Tb−Pt complex (<sup>1</sup>Wakayama Univ., <sup>2</sup>UEC, <sup>3</sup>Riken, <sup>4</sup>Tohoku Univ.) 〇Takefumi YOSHIDA<sup>1, 2, 3</sup>, Yasuhiro IWASAWA<sup>2, 3</sup>, Masahiro YAMASHITA<sup>4</sup> Pt, Tb"
  },
  {
    "inf": [
      "銅(II)-ラジカル金属配位子による希土類錯体の合成",
      "(<sup>1</sup>東理大院理) 〇落合 一稀<sup>1</sup>・金友 拓哉<sup>1</sup>・榎本 真哉<sup>1</sup>",
      "Synthesis of Lanthanide Complexes with Cu(II)-Radical Metalloligands ",
      "(<sup>1</sup>Tokyo Univ. of Sci) 〇Kazuki OCHIAI<sup>1</sup>, Takuya KANETOMO<sup>1</sup>, Masaya ENOMOTO<sup>1</sup>"
    ],
    "lab": "3PB-10",
    "pdf": "pdf/3PB-10.pdf",
    "pre": "tn/3PB-10.jpg",
    "reg": "74509",
    "sea": "Cu",
    "ses": "3PB",
    "con": "3PB-10 銅(II)-ラジカル金属配位子による希土類錯体の合成 (<sup>1</sup>東理大院理) 〇落合 一稀<sup>1</sup>・金友 拓哉<sup>1</sup>・榎本 真哉<sup>1</sup> Synthesis of Lanthanide Complexes with Cu(II)-Radical Metalloligands  (<sup>1</sup>Tokyo Univ. of Sci) 〇Kazuki OCHIAI<sup>1</sup>, Takuya KANETOMO<sup>1</sup>, Masaya ENOMOTO<sup>1</sup> Cu"
  },
  {
    "inf": [
      "単分子磁石の設計に向けたDy錯体の置換基効果についての理論研究",
      "(<sup>1</sup>阪大院基礎工・<sup>2</sup>阪大QIQB・<sup>3</sup>阪大RCSEC・<sup>4</sup>阪大ICS-OTRI・<sup>5</sup>阪大OTRI-Spin) 〇益田 晃希<sup>1</sup>・井上 廉<sup>1</sup>・高海斗<sup>1</sup>・多田幸平<sup>1</sup>・岸亮平<sup>1, 2, 3, 4</sup>・北河康隆<sup>1, 2, 3, 4, 5</sup>",
      "Theoretical study on substituent effect in Dy complexes for design of single molecule magnets",
      "(<sup>1</sup>Graduate School of Engineering Science, Osaka University, <sup>2</sup>QIQB, Osaka University, <sup>3</sup>RCSEC, Osaka University, <sup>4</sup>ICS-OTRI, Osaka University, <sup>5</sup>OTRI-Spin, Osaka University) 〇Koki Masuda<sup>1</sup>, Ren Inoue<sup>1</sup>, Kaito Taka<sup>1</sup>, Kohei Tada<sup>1</sup>, Ryohei Kishi<sup>1, 2, 3, 4</sup>, Yasutaka Kitagawa<sup>1, 2, 3, 4, 5</sup>"
    ],
    "lab": "3PB-11",
    "pdf": "pdf/3PB-11.pdf",
    "pre": "tn/3PB-11.jpg",
    "reg": "74315",
    "sea": "Dy",
    "ses": "3PB",
    "con": "3PB-11 単分子磁石の設計に向けたDy錯体の置換基効果についての理論研究 (<sup>1</sup>阪大院基礎工・<sup>2</sup>阪大QIQB・<sup>3</sup>阪大RCSEC・<sup>4</sup>阪大ICS-OTRI・<sup>5</sup>阪大OTRI-Spin) 〇益田 晃希<sup>1</sup>・井上 廉<sup>1</sup>・高海斗<sup>1</sup>・多田幸平<sup>1</sup>・岸亮平<sup>1, 2, 3, 4</sup>・北河康隆<sup>1, 2, 3, 4, 5</sup> Theoretical study on substituent effect in Dy complexes for design of single molecule magnets (<sup>1</sup>Graduate School of Engineering Science, Osaka University, <sup>2</sup>QIQB, Osaka University, <sup>3</sup>RCSEC, Osaka University, <sup>4</sup>ICS-OTRI, Osaka University, <sup>5</sup>OTRI-Spin, Osaka University) 〇Koki Masuda<sup>1</sup>, Ren Inoue<sup>1</sup>, Kaito Taka<sup>1</sup>, Kohei Tada<sup>1</sup>, Ryohei Kishi<sup>1, 2, 3, 4</sup>, Yasutaka Kitagawa<sup>1, 2, 3, 4, 5</sup> Dy"
  },
  {
    "inf": [
      "Spirobipyridine Ligands for Substrate Recognition through Noncovalent Interactions",
      "(<sup>1</sup>RIKEN CSRS) 〇Sobi ASAKO<sup>1</sup>, Yushu JIN<sup>1</sup>, Boobalan RAMADOSS<sup>1</sup>, Pinaki Bhusan DE<sup>1</sup>, Jayakumar SEKAR<sup>1</sup>, Laurean ILIES<sup>1</sup>"
    ],
    "lab": "3PC-01",
    "pdf": "pdf/3PC-01.pdf",
    "pre": "tn/3PC-01.jpg",
    "reg": "74103",
    "sea": "Ir",
    "ses": "3PC",
    "con": "3PC-01 Spirobipyridine Ligands for Substrate Recognition through Noncovalent Interactions (<sup>1</sup>RIKEN CSRS) 〇Sobi ASAKO<sup>1</sup>, Yushu JIN<sup>1</sup>, Boobalan RAMADOSS<sup>1</sup>, Pinaki Bhusan DE<sup>1</sup>, Jayakumar SEKAR<sup>1</sup>, Laurean ILIES<sup>1</sup> Ir"
  },
  {
    "inf": [
      "Oxidation Mechanism of Phenols by Copper(II)-halide Complexes",
      "(<sup>1</sup>Osaka Univ.) 〇Lan YANG<sup>1</sup>, Rin ITO<sup>1</sup>, Hideki SUGIMOTO<sup>1</sup>, Yuma MORIMOTO<sup>1</sup>, Shinobu ITOH<sup>1</sup>"
    ],
    "lab": "3PC-02",
    "pdf": "pdf/3PC-02.pdf",
    "pre": "tn/3PC-02.jpg",
    "reg": "74311",
    "sea": "Cu",
    "ses": "3PC",
    "con": "3PC-02 Oxidation Mechanism of Phenols by Copper(II)-halide Complexes (<sup>1</sup>Osaka Univ.) 〇Lan YANG<sup>1</sup>, Rin ITO<sup>1</sup>, Hideki SUGIMOTO<sup>1</sup>, Yuma MORIMOTO<sup>1</sup>, Shinobu ITOH<sup>1</sup> Cu"
  },
  {
    "inf": [
      "Water-induced Selectivity Switching and Steric Control of Activity in Photochemical CO<sub>2</sub> Reduction Catalyzed by RhCp*(bpy) Derivatives",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Dongseb LEE<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "3PC-03",
    "pdf": "pdf/3PC-03.pdf",
    "pre": "tn/3PC-03.jpg",
    "reg": "74323",
    "sea": "Rh, Ru",
    "ses": "3PC",
    "con": "3PC-03 Water-induced Selectivity Switching and Steric Control of Activity in Photochemical CO<sub>2</sub> Reduction Catalyzed by RhCp*(bpy) Derivatives (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Dongseb LEE<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Rh, Ru"
  },
  {
    "inf": [
      "無水フタル酸への電気化学的窒素原子挿入反応の開発",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇石代 史哉<sup>1</sup>・福原 みなみ<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup>",
      "Development of the Electrochemical Nitrogen Atom Insertion Reaction into Phthalic Anhydride",
      "(<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>School of Science, Tokyo Institute of Technology) 〇Fumiya KOKUDAI<sup>1</sup>, Minami FUKUHARA<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA <sup>1</sup>"
    ],
    "lab": "3PC-04",
    "pdf": "pdf/3PC-04.pdf",
    "pre": "tn/3PC-04.jpg",
    "reg": "74376",
    "sea": "Ti",
    "ses": "3PC",
    "con": "3PC-04 無水フタル酸への電気化学的窒素原子挿入反応の開発 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇石代 史哉<sup>1</sup>・福原 みなみ<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup> Development of the Electrochemical Nitrogen Atom Insertion Reaction into Phthalic Anhydride (<sup>1</sup>Graduate School of Engineering, Osaka University, <sup>2</sup>School of Science, Tokyo Institute of Technology) 〇Fumiya KOKUDAI<sup>1</sup>, Minami FUKUHARA<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA <sup>1</sup> Ti"
  },
  {
    "inf": [
      "_N_-ヘテロ環状カルベン配位子を有するコバルト錯体を触媒とする光触媒的CO<sub>2</sub>還元反応",
      "(<sup>1</sup>筑波大院数物) 〇小椋 準也<sup>1</sup>・石塚 智也<sup>1</sup>・小島 隆彦<sup>1</sup>",
      "Photocatalytic CO<sub>2</sub> reduction catalyzed by cobalt complexes bearing _N_-heterocyclic carbene ligands",
      "(<sup>1</sup>Graduate School of Pure and Applied Sciences, University of Tsukuba.) 〇Junya Ogura<sup>1</sup>, Tomoya Ishizuka<sup>1</sup>, Takahiko Kojima<sup>1</sup>"
    ],
    "lab": "3PC-05",
    "pdf": "pdf/3PC-05.pdf",
    "pre": "tn/3PC-05.jpg",
    "reg": "74200",
    "sea": "Co",
    "ses": "3PC",
    "con": "3PC-05 _N_-ヘテロ環状カルベン配位子を有するコバルト錯体を触媒とする光触媒的CO<sub>2</sub>還元反応 (<sup>1</sup>筑波大院数物) 〇小椋 準也<sup>1</sup>・石塚 智也<sup>1</sup>・小島 隆彦<sup>1</sup> Photocatalytic CO<sub>2</sub> reduction catalyzed by cobalt complexes bearing _N_-heterocyclic carbene ligands (<sup>1</sup>Graduate School of Pure and Applied Sciences, University of Tsukuba.) 〇Junya Ogura<sup>1</sup>, Tomoya Ishizuka<sup>1</sup>, Takahiko Kojima<sup>1</sup> Co"
  },
  {
    "inf": [
      "電子蓄積型新規コバルト二核NHC錯体の合成と二酸化炭素還元特性",
      "(<sup>1</sup>九大理化) 〇千綿 晃史郎<sup>1</sup>・山内 幸正<sup>1</sup>・酒井 健<sup>1</sup>",
      "Electron-accumulating New Dinuclear Co-NHC Catalysts for CO<sub>2</sub> Reduction",
      "(<sup>1</sup>Kyushu Univ.) 〇Koshiro CHIWATA<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "3PC-06",
    "pdf": "pdf/3PC-06.pdf",
    "pre": "tn/3PC-06.jpg",
    "reg": "74273",
    "sea": "Co",
    "ses": "3PC",
    "con": "3PC-06 電子蓄積型新規コバルト二核NHC錯体の合成と二酸化炭素還元特性 (<sup>1</sup>九大理化) 〇千綿 晃史郎<sup>1</sup>・山内 幸正<sup>1</sup>・酒井 健<sup>1</sup> Electron-accumulating New Dinuclear Co-NHC Catalysts for CO<sub>2</sub> Reduction (<sup>1</sup>Kyushu Univ.) 〇Koshiro CHIWATA<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Co"
  },
  {
    "inf": [
      "Cu<sup>+</sup>及びAg<sup>+</sup>を含むアルキニルクラスターのAAC反応に対する触媒活性",
      "(<sup>1</sup>広島大院先進理工) 〇小笠原 泰成<sup>1</sup>・久保 和幸<sup>1</sup>・久米 昌子<sup>1</sup>・水田 勉<sup>1</sup>",
      "Catalytic activity of alkynyl clusters containing Cu<sup>+</sup> and Ag<sup>+</sup> for AAC reaction",
      "(<sup>1</sup>Hiroshima University) 〇Taisei OGASAWARA<sup>1</sup>, Kazuyuki KUBO<sup>1</sup>, Shoko KUME<sup>1</sup>, Tsutomu MIZUTA<sup>1</sup>"
    ],
    "lab": "3PC-07",
    "pdf": "pdf/3PC-07.pdf",
    "pre": "tn/3PC-07.jpg",
    "reg": "74309",
    "sea": "Ag, Cu",
    "ses": "3PC",
    "con": "3PC-07 Cu<sup>+</sup>及びAg<sup>+</sup>を含むアルキニルクラスターのAAC反応に対する触媒活性 (<sup>1</sup>広島大院先進理工) 〇小笠原 泰成<sup>1</sup>・久保 和幸<sup>1</sup>・久米 昌子<sup>1</sup>・水田 勉<sup>1</sup> Catalytic activity of alkynyl clusters containing Cu<sup>+</sup> and Ag<sup>+</sup> for AAC reaction (<sup>1</sup>Hiroshima University) 〇Taisei OGASAWARA<sup>1</sup>, Kazuyuki KUBO<sup>1</sup>, Shoko KUME<sup>1</sup>, Tsutomu MIZUTA<sup>1</sup> Ag, Cu"
  },
  {
    "inf": [
      "鉄イオンとビピリジン配位子からなる混合触媒を用いたCO<sub>2</sub>還元光触媒反応",
      "(<sup>1</sup>群馬大院理工) 〇竹田 浩之<sup>1</sup>・黒須 雅雄<sup>1</sup>・松浦 祐奈<sup>1</sup>・浅野 素子<sup>1</sup>",
      "Photocatalytic CO<sub>2</sub> Reduction Using Mixed Catalyst Comprising an Fe Ion and Bipyridine Ligands",
      "(<sup>1</sup>Gunma Univ.) 〇Hiroyuki TAKEDA<sup>1</sup>, Masao Kurosu<sup>1</sup>, Yuna Matsuura<sup>1</sup>, Motoko S. Asano<sup>1</sup>"
    ],
    "lab": "3PC-08",
    "pdf": "pdf/3PC-08.pdf",
    "pre": "tn/3PC-08.jpg",
    "reg": "74341",
    "sea": "Fe, Cu",
    "ses": "3PC",
    "con": "3PC-08 鉄イオンとビピリジン配位子からなる混合触媒を用いたCO<sub>2</sub>還元光触媒反応 (<sup>1</sup>群馬大院理工) 〇竹田 浩之<sup>1</sup>・黒須 雅雄<sup>1</sup>・松浦 祐奈<sup>1</sup>・浅野 素子<sup>1</sup> Photocatalytic CO<sub>2</sub> Reduction Using Mixed Catalyst Comprising an Fe Ion and Bipyridine Ligands (<sup>1</sup>Gunma Univ.) 〇Hiroyuki TAKEDA<sup>1</sup>, Masao Kurosu<sup>1</sup>, Yuna Matsuura<sup>1</sup>, Motoko S. Asano<sup>1</sup> Fe, Cu"
  },
  {
    "inf": [
      "電子供与性三座配位子を有する二核ルテニウム錯体の酸化還元挙動 ",
      "(<sup>1</sup>立教大院理) 〇 網田 義樹<sup>1</sup>・和田 亨 <sup>1</sup>",
      "Redox Behavior of the Dinuclear Ruthenium Complex with Electron-Donating Tridentate Ligands",
      "(<sup>1</sup>Rikkyo Univ.) 〇Yoshiki Amita<sup>1</sup>, Tohru Wada<sup>1</sup>"
    ],
    "lab": "3PC-09",
    "pdf": "pdf/3PC-09.pdf",
    "pre": "tn/3PC-09.jpg",
    "reg": "74359",
    "sea": "Ru",
    "ses": "3PC",
    "con": "3PC-09 電子供与性三座配位子を有する二核ルテニウム錯体の酸化還元挙動  (<sup>1</sup>立教大院理) 〇 網田 義樹<sup>1</sup>・和田 亨 <sup>1</sup> Redox Behavior of the Dinuclear Ruthenium Complex with Electron-Donating Tridentate Ligands (<sup>1</sup>Rikkyo Univ.) 〇Yoshiki Amita<sup>1</sup>, Tohru Wada<sup>1</sup> Ru"
  },
  {
    "inf": [
      "酢酸を用いた2-フェニルピリジンC(sp<sup>2</sup>)-H結合の電気化学的化学修飾",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇鴋澤 翔也<sup>1</sup>・森井 佑真<sup>1</sup>・渡部 太登<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup>",
      "Electrochemical Modification of C(sp<sup>2</sup>)-H Bonds in 2-Phenylpyridine Using Acetic Acid",
      "(<sup>1</sup>Osaka Univ. , <sup>2</sup>Tokyo Tech) 〇Shoya BANZAWA<sup>1</sup>, Yuma MORII<sup>1</sup>, Taito WATANABE<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "3PC-10",
    "pdf": "pdf/3PC-10.pdf",
    "pre": "tn/3PC-10.jpg",
    "reg": "74379",
    "sea": "Ni",
    "ses": "3PC",
    "con": "3PC-10 酢酸を用いた2-フェニルピリジンC(sp<sup>2</sup>)-H結合の電気化学的化学修飾 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇鴋澤 翔也<sup>1</sup>・森井 佑真<sup>1</sup>・渡部 太登<sup>1</sup>・嵯峨 裕<sup>1</sup>・神戸 徹也<sup>1</sup>・近藤 美欧<sup>1,2</sup>・正岡 重行<sup>1</sup> Electrochemical Modification of C(sp<sup>2</sup>)-H Bonds in 2-Phenylpyridine Using Acetic Acid (<sup>1</sup>Osaka Univ. , <sup>2</sup>Tokyo Tech) 〇Shoya BANZAWA<sup>1</sup>, Yuma MORII<sup>1</sup>, Taito WATANABE<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup> Ni"
  },
  {
    "inf": [
      "各種アンカー基を有するコバルトフタロシアニンを修飾したTiO<sub>2</sub>電極を用いたCO<sub>2</sub>還元触媒反応",
      "(<sup>1</sup>九大理化) 〇浦 陸人<sup>1</sup>・酒井 健<sup>1</sup>・小澤 弘宜<sup>1</sup>",
      "Electrocatalytic CO<sub>2</sub> Reduction by the TiO<sub>2</sub> electrode modified with Co phthalocyanine having a various kinds of anchor",
      "(<sup>1</sup>Kyushu University, Department of Science ) 〇Rikuto URA<sup>1</sup>, Ken SAKAI<sup>1</sup>, Hironobu OZAWA<sup>1</sup>"
    ],
    "lab": "3PC-11",
    "pdf": "pdf/3PC-11.pdf",
    "pre": "tn/3PC-11.jpg",
    "reg": "74397",
    "sea": "Co",
    "ses": "3PC",
    "con": "3PC-11 各種アンカー基を有するコバルトフタロシアニンを修飾したTiO<sub>2</sub>電極を用いたCO<sub>2</sub>還元触媒反応 (<sup>1</sup>九大理化) 〇浦 陸人<sup>1</sup>・酒井 健<sup>1</sup>・小澤 弘宜<sup>1</sup> Electrocatalytic CO<sub>2</sub> Reduction by the TiO<sub>2</sub> electrode modified with Co phthalocyanine having a various kinds of anchor (<sup>1</sup>Kyushu University, Department of Science ) 〇Rikuto URA<sup>1</sup>, Ken SAKAI<sup>1</sup>, Hironobu OZAWA<sup>1</sup> Co"
  },
  {
    "inf": [
      "長波長可視光駆動型フレームワーク触媒の構築に向けたアクセプター部位を有する金属ポルフィリン錯体の開発",
      "(<sup>1</sup>東工大院理) 〇黄 文青<sup>1</sup>・今井 真秀<sup>1</sup>・小杉 健斗<sup>1</sup>・近藤 美欧<sup>1</sup>",
      "Synthesis of a metal porphyrin complex with acceptor moieties for the construction of framework catalysts with long-wavelength visible light absorption ability",
      "(<sup>1</sup>Tokyo Tech.) 〇Wenqing HUANG<sup>1</sup>, Maho IMAI<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Mio KONDO<sup>1</sup>"
    ],
    "lab": "3PC-12",
    "pdf": "pdf/3PC-12.pdf",
    "pre": "tn/3PC-12.jpg",
    "reg": "74421",
    "sea": "Fe",
    "ses": "3PC",
    "con": "3PC-12 長波長可視光駆動型フレームワーク触媒の構築に向けたアクセプター部位を有する金属ポルフィリン錯体の開発 (<sup>1</sup>東工大院理) 〇黄 文青<sup>1</sup>・今井 真秀<sup>1</sup>・小杉 健斗<sup>1</sup>・近藤 美欧<sup>1</sup> Synthesis of a metal porphyrin complex with acceptor moieties for the construction of framework catalysts with long-wavelength visible light absorption ability (<sup>1</sup>Tokyo Tech.) 〇Wenqing HUANG<sup>1</sup>, Maho IMAI<sup>1</sup>, Kento KOSUGI<sup>1</sup>, Mio KONDO<sup>1</sup> Fe"
  },
  {
    "inf": [
      " C(sp<sup>3</sup>)-H結合への電気化学的CO<sub>2</sub>挿入反応の開発",
      "(<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇前地友翔<sup>1</sup>・小林利通<sup>1</sup>・嵯峨裕<sup>1</sup>・神戸徹也<sup>1</sup>・近藤美欧<sup>1,2</sup>・正岡重行<sup>1</sup>",
      "Electrochemical Insertion of CO<sub>2</sub> into C(sp<sup>3</sup>)-H Bonds",
      "(<sup>1</sup>1.\\tGraduate School of Engineering, Osaka University, <sup>2</sup>2.\\tSchool of Science, Tokyo Institute of Technology) 〇Yuto MAEJI<sup>1</sup>, Toshimichi KOBAYASHI<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "3PC-13",
    "pdf": "pdf/3PC-13.pdf",
    "pre": "tn/3PC-13.jpg",
    "reg": "74433",
    "sea": "Ni",
    "ses": "3PC",
    "con": "3PC-13  C(sp<sup>3</sup>)-H結合への電気化学的CO<sub>2</sub>挿入反応の開発 (<sup>1</sup>阪大院工・<sup>2</sup>東工大院理) 〇前地友翔<sup>1</sup>・小林利通<sup>1</sup>・嵯峨裕<sup>1</sup>・神戸徹也<sup>1</sup>・近藤美欧<sup>1,2</sup>・正岡重行<sup>1</sup> Electrochemical Insertion of CO<sub>2</sub> into C(sp<sup>3</sup>)-H Bonds (<sup>1</sup>1.\\tGraduate School of Engineering, Osaka University, <sup>2</sup>2.\\tSchool of Science, Tokyo Institute of Technology) 〇Yuto MAEJI<sup>1</sup>, Toshimichi KOBAYASHI<sup>1</sup>, Yutaka SAGA<sup>1</sup>, Tetsuya KAMBE<sup>1</sup>, Mio KONDO<sup>1,2</sup>, Shigeyuki MASAOKA<sup>1</sup> Ni"
  },
  {
    "inf": [
      "アミド含有配位子の二核及び四核銅錯体が触媒するH<sub>2</sub>O<sub>2</sub>によるアルカン酸化に及ぼすアミドドナーの効果",
      "(<sup>1</sup>同志社大大学院理工) 〇赤松 杏香<sup>1</sup>・藤川 恭祐<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup>",
      "Effect of amide donor on alkane oxidation with H<sub>2</sub>O<sub>2</sub> catalyzed by di- and tetracopper complexes with amide-containing ligand",
      "(<sup>1</sup>Department of Science and Engineering, Doshisha Univ.) 〇Kyoka AKAMATSU<sup>1</sup>, Kyosuke FUJIKAWA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masato KODERA<sup>1</sup>"
    ],
    "lab": "3PC-14",
    "pdf": "pdf/3PC-14.pdf",
    "pre": "tn/3PC-14.jpg",
    "reg": "74456",
    "sea": "Cu",
    "ses": "3PC",
    "con": "3PC-14 アミド含有配位子の二核及び四核銅錯体が触媒するH<sub>2</sub>O<sub>2</sub>によるアルカン酸化に及ぼすアミドドナーの効果 (<sup>1</sup>同志社大大学院理工) 〇赤松 杏香<sup>1</sup>・藤川 恭祐<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup> Effect of amide donor on alkane oxidation with H<sub>2</sub>O<sub>2</sub> catalyzed by di- and tetracopper complexes with amide-containing ligand (<sup>1</sup>Department of Science and Engineering, Doshisha Univ.) 〇Kyoka AKAMATSU<sup>1</sup>, Kyosuke FUJIKAWA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masato KODERA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "メチレン鎖部位の脱プロトン化に伴うCo(III)ピリジルアミン錯体の反応性評価",
      "(<sup>1</sup>筑波大院数物) 〇野呂 航一郎<sup>1</sup>・小谷 弘明<sup>1</sup>・石塚 智也<sup>1</sup>・小島 隆彦<sup>1</sup>",
      "Reactivity of Co(III) pyridylamine complexes with a deprotonated pyridylamine ligand.",
      "(<sup>1</sup>Univ. of Tsukuba) 〇Koichiro NORO<sup>1</sup>, Hiroaki KOTANI<sup>1</sup>, Tomoya ISIZUKA<sup>1</sup>, Takahiko KOJIMA<sup>1</sup>"
    ],
    "lab": "3PC-15",
    "pdf": "pdf/3PC-15.pdf",
    "pre": "tn/3PC-15.jpg",
    "reg": "74464",
    "sea": "Co",
    "ses": "3PC",
    "con": "3PC-15 メチレン鎖部位の脱プロトン化に伴うCo(III)ピリジルアミン錯体の反応性評価 (<sup>1</sup>筑波大院数物) 〇野呂 航一郎<sup>1</sup>・小谷 弘明<sup>1</sup>・石塚 智也<sup>1</sup>・小島 隆彦<sup>1</sup> Reactivity of Co(III) pyridylamine complexes with a deprotonated pyridylamine ligand. (<sup>1</sup>Univ. of Tsukuba) 〇Koichiro NORO<sup>1</sup>, Hiroaki KOTANI<sup>1</sup>, Tomoya ISIZUKA<sup>1</sup>, Takahiko KOJIMA<sup>1</sup> Co"
  },
  {
    "inf": [
      "アルキンの還元的_anti_-1,2-二金属化反応",
      "(<sup>1</sup>京大院理) 〇山口 華佳<sup>1</sup>・高橋 郁也<sup>1</sup>・黒木 尭<sup>1</sup>・依光 英樹<sup>1</sup>",
      "Reductive _anti_-1,2-Dimatallation of Alkynes",
      "(<sup>1</sup>Kyoto Univ.) 〇Haruka YAMAGUCHI<sup>1</sup>, Fumiya TAKAHASHI<sup>1</sup>, Takashi KUROGI<sup>1</sup>, Hideki YORIMITSU<sup>1</sup>"
    ],
    "lab": "3PD-01",
    "pdf": "pdf/3PD-01.pdf",
    "pre": "tn/3PD-01.jpg",
    "reg": "74030",
    "sea": "Zn, Mg, Na",
    "ses": "3PD",
    "con": "3PD-01 アルキンの還元的_anti_-1,2-二金属化反応 (<sup>1</sup>京大院理) 〇山口 華佳<sup>1</sup>・高橋 郁也<sup>1</sup>・黒木 尭<sup>1</sup>・依光 英樹<sup>1</sup> Reductive _anti_-1,2-Dimatallation of Alkynes (<sup>1</sup>Kyoto Univ.) 〇Haruka YAMAGUCHI<sup>1</sup>, Fumiya TAKAHASHI<sup>1</sup>, Takashi KUROGI<sup>1</sup>, Hideki YORIMITSU<sup>1</sup> Zn, Mg, Na"
  },
  {
    "inf": [
      "キラルなヒドロキシアルキル置換ベンズイミダゾリウム塩からの_N_-ヘテロサイクリックカルベン(NHC)をもつ遷移金属錯体の合成",
      "(<sup>1</sup>関西大化学生命工) 〇松尾 将吾<sup>1</sup>・臼井 亮汰<sup>1</sup>・坂口 聡<sup>1</sup>",
      "Synthesis of transition metal complexes having _N_-heterocyclic carbene (NHC) ligand from chiral hydroxyalkyl-substituted benzimidazolium salt",
      "(<sup>1</sup>Department of Chemistry and Materials Engineering, Kansai Univ.) 〇Shogo MATSUO<sup>1</sup>, Ryota USUI<sup>1</sup>, Satoshi SAKAGUCHI<sup>1</sup>"
    ],
    "lab": "3PD-02",
    "pdf": "pdf/3PD-02.pdf",
    "pre": "tn/3PD-02.jpg",
    "reg": "74046",
    "sea": "Ru, Pd, Rh",
    "ses": "3PD",
    "con": "3PD-02 キラルなヒドロキシアルキル置換ベンズイミダゾリウム塩からの_N_-ヘテロサイクリックカルベン(NHC)をもつ遷移金属錯体の合成 (<sup>1</sup>関西大化学生命工) 〇松尾 将吾<sup>1</sup>・臼井 亮汰<sup>1</sup>・坂口 聡<sup>1</sup> Synthesis of transition metal complexes having _N_-heterocyclic carbene (NHC) ligand from chiral hydroxyalkyl-substituted benzimidazolium salt (<sup>1</sup>Department of Chemistry and Materials Engineering, Kansai Univ.) 〇Shogo MATSUO<sup>1</sup>, Ryota USUI<sup>1</sup>, Satoshi SAKAGUCHI<sup>1</sup> Ru, Pd, Rh"
  },
  {
    "inf": [
      "バナドセン骨格を有する鉄およびコバルトビスアミド錯体の合成と還元反応",
      "(<sup>1</sup>阪大院理) 〇鈴木 朝陽<sup>1</sup>・佐藤 優<sup>1</sup>・楠瀬 ひなの<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup>",
      "Synthesis and Reduction of Iron and Cobalt Bisamides Bearing a Vanadocene Skeleton",
      "(<sup>1</sup>Osaka Univ.) 〇Asahi SUZUKI<sup>1</sup>, Yu SATO<sup>1</sup>, Hinano KUSUNOSE<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup>"
    ],
    "lab": "3PD-03",
    "pdf": "pdf/3PD-03.pdf",
    "pre": "tn/3PD-03.jpg",
    "reg": "74087",
    "sea": "Fe, Co",
    "ses": "3PD",
    "con": "3PD-03 バナドセン骨格を有する鉄およびコバルトビスアミド錯体の合成と還元反応 (<sup>1</sup>阪大院理) 〇鈴木 朝陽<sup>1</sup>・佐藤 優<sup>1</sup>・楠瀬 ひなの<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup> Synthesis and Reduction of Iron and Cobalt Bisamides Bearing a Vanadocene Skeleton (<sup>1</sup>Osaka Univ.) 〇Asahi SUZUKI<sup>1</sup>, Yu SATO<sup>1</sup>, Hinano KUSUNOSE<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup> Fe, Co"
  },
  {
    "inf": [
      "Cp配位子を有するキュバン型[Mo<sub>3</sub>S<sub>4</sub>M] (M = Rh, Ir) クラスターの合成とC-Hボリル化反応への応用",
      "(<sup>1</sup>京大化研) 〇下山 さやか<sup>1</sup>・伊豆 仁<sup>1</sup>・谷藤 一樹<sup>1</sup>・大木 靖弘<sup>1</sup>",
      "Synthesis of a Cuboidal [Mo<sub>3</sub>S<sub>4</sub>M] (M = Rh, Ir) Clusters Bearing Cp Ligands and Their Applications in C-H Borylation Reactions",
      "(<sup>1</sup>Institute for Chemical Research, Kyoto University) 〇Sayaka SHIMOYAMA<sup>1</sup>, Hitoshi IZU<sup>1</sup>, Kazuki TANIFUJI<sup>1</sup>, Yasuhiro OHKI<sup>1</sup>"
    ],
    "lab": "3PD-04",
    "pdf": "pdf/3PD-04.pdf",
    "pre": "tn/3PD-04.jpg",
    "reg": "74104",
    "sea": "Rh, Ir, Mo",
    "ses": "3PD",
    "con": "3PD-04 Cp配位子を有するキュバン型[Mo<sub>3</sub>S<sub>4</sub>M] (M = Rh, Ir) クラスターの合成とC-Hボリル化反応への応用 (<sup>1</sup>京大化研) 〇下山 さやか<sup>1</sup>・伊豆 仁<sup>1</sup>・谷藤 一樹<sup>1</sup>・大木 靖弘<sup>1</sup> Synthesis of a Cuboidal [Mo<sub>3</sub>S<sub>4</sub>M] (M = Rh, Ir) Clusters Bearing Cp Ligands and Their Applications in C-H Borylation Reactions (<sup>1</sup>Institute for Chemical Research, Kyoto University) 〇Sayaka SHIMOYAMA<sup>1</sup>, Hitoshi IZU<sup>1</sup>, Kazuki TANIFUJI<sup>1</sup>, Yasuhiro OHKI<sup>1</sup> Rh, Ir, Mo"
  },
  {
    "inf": [
      "ビス(インドリル)配位チタンジメチルアミド錯体を触媒として用いたアルキン類の環化三量化反応",
      "(<sup>1</sup>弘前大院理工) 〇及川 香梨<sup>1</sup>・川原 優輝<sup>1</sup>・岡崎 雅明<sup>1</sup>・太田 俊<sup>1</sup>",
      "Cyclotrimerization of Alkynes Catalyzed by a Bis(indolyl)–coordinated Titanium Dimethylamido Complex",
      "(<sup>1</sup>Grad. Sch. of Sci. and Tech., Hirosaki Univ.) 〇Karin OIKAWA<sup>1</sup>, Yuuki KAWAHARA<sup>1</sup>, Masaaki OKAZAKI<sup>1</sup>, Shun OHTA<sup>1</sup>"
    ],
    "lab": "3PD-05",
    "pdf": "pdf/3PD-05.pdf",
    "pre": "tn/3PD-05.jpg",
    "reg": "74115",
    "sea": "Ti",
    "ses": "3PD",
    "con": "3PD-05 ビス(インドリル)配位チタンジメチルアミド錯体を触媒として用いたアルキン類の環化三量化反応 (<sup>1</sup>弘前大院理工) 〇及川 香梨<sup>1</sup>・川原 優輝<sup>1</sup>・岡崎 雅明<sup>1</sup>・太田 俊<sup>1</sup> Cyclotrimerization of Alkynes Catalyzed by a Bis(indolyl)–coordinated Titanium Dimethylamido Complex (<sup>1</sup>Grad. Sch. of Sci. and Tech., Hirosaki Univ.) 〇Karin OIKAWA<sup>1</sup>, Yuuki KAWAHARA<sup>1</sup>, Masaaki OKAZAKI<sup>1</sup>, Shun OHTA<sup>1</sup> Ti"
  },
  {
    "inf": [
      "バナドセンまたはクロモセンビスアミド配位子を有する鉄およびコバルト錯体の合成と窒素分子活性化",
      "(<sup>1</sup>阪大院理) 〇佐藤 優<sup>1</sup>・鈴木 朝陽<sup>1</sup>・楠瀬 ひなの<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup>",
      "Dinitrogen Activation Mediated by Iron and Cobalt Complexes Having Vanadocene or Chromocene Bisamides",
      "(<sup>1</sup>Osaka Univ.) 〇Yu SATO<sup>1</sup>, Asahi SUZUKI<sup>1</sup>, Hinano KUSUNOSE<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup>"
    ],
    "lab": "3PD-06",
    "pdf": "pdf/3PD-06.pdf",
    "pre": "tn/3PD-06.jpg",
    "reg": "74144",
    "sea": "Fe, Co",
    "ses": "3PD",
    "con": "3PD-06 バナドセンまたはクロモセンビスアミド配位子を有する鉄およびコバルト錯体の合成と窒素分子活性化 (<sup>1</sup>阪大院理) 〇佐藤 優<sup>1</sup>・鈴木 朝陽<sup>1</sup>・楠瀬 ひなの<sup>1</sup>・畑中 翼<sup>1</sup>・舩橋 靖博<sup>1</sup> Dinitrogen Activation Mediated by Iron and Cobalt Complexes Having Vanadocene or Chromocene Bisamides (<sup>1</sup>Osaka Univ.) 〇Yu SATO<sup>1</sup>, Asahi SUZUKI<sup>1</sup>, Hinano KUSUNOSE<sup>1</sup>, Tsubasa HATANAKA<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup> Fe, Co"
  },
  {
    "inf": [
      "直鎖状四座ホスフィン配位子を支持配位子とする銅二核ヒドリド錯体の合成とそれを用いた二酸化炭素の還元反応",
      "(<sup>1</sup>奈良女子大学理) 〇三木萌夏<sup>1</sup>・安達なつみ<sup>1</sup>・中島隆行<sup>1</sup>・棚瀬知明<sup>1</sup>",
      "Synthesis of Dinuclear Copper Hydride Complexes Supported by Linear Tetraphosphine Ligands and their Application for CO<sub>2</sub> Reduction",
      "(<sup>1</sup>Nara Women's Univ.) 〇Moeka MIKI<sup>1</sup>, Natsumi ADACHI<sup>1</sup>, Takayuki NAKAJIMA<sup>1</sup>, Tomoaki TANASE<sup>1</sup>"
    ],
    "lab": "3PD-07",
    "pdf": "pdf/3PD-07.pdf",
    "pre": "tn/3PD-07.jpg",
    "reg": "74145",
    "sea": "Cu",
    "ses": "3PD",
    "con": "3PD-07 直鎖状四座ホスフィン配位子を支持配位子とする銅二核ヒドリド錯体の合成とそれを用いた二酸化炭素の還元反応 (<sup>1</sup>奈良女子大学理) 〇三木萌夏<sup>1</sup>・安達なつみ<sup>1</sup>・中島隆行<sup>1</sup>・棚瀬知明<sup>1</sup> Synthesis of Dinuclear Copper Hydride Complexes Supported by Linear Tetraphosphine Ligands and their Application for CO<sub>2</sub> Reduction (<sup>1</sup>Nara Women's Univ.) 〇Moeka MIKI<sup>1</sup>, Natsumi ADACHI<sup>1</sup>, Takayuki NAKAJIMA<sup>1</sup>, Tomoaki TANASE<sup>1</sup> Cu"
  },
  {
    "inf": [
      "電気還元法によるPbナノ粒子/MOF複合材料の作製",
      "(<sup>1</sup>東理大院理) 〇王 威樺<sup>1</sup>・原口 知之<sup>1</sup>",
      "Preparation of Pb nanoparticles/MOF composites by electrochemical method",
      "(<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Weihua Wang<sup>1</sup>, Tomoyuki Haraguchi<sup>1</sup>"
    ],
    "lab": "3PD-08",
    "pdf": "pdf/3PD-08.pdf",
    "pre": "tn/3PD-08.jpg",
    "reg": "74251",
    "sea": "Co, Pb",
    "ses": "3PD",
    "con": "3PD-08 電気還元法によるPbナノ粒子/MOF複合材料の作製 (<sup>1</sup>東理大院理) 〇王 威樺<sup>1</sup>・原口 知之<sup>1</sup> Preparation of Pb nanoparticles/MOF composites by electrochemical method (<sup>1</sup>Graduate School of Science, Tokyo University of Science) 〇Weihua Wang<sup>1</sup>, Tomoyuki Haraguchi<sup>1</sup> Co, Pb"
  },
  {
    "inf": [
      "インドリル系補助配位子を持つチタンアミド錯体を用いたカルボジイミドの触媒的ヒドロアミノ化およびヒドロアルコキシ化反応",
      "(<sup>1</sup>弘前大院理工) 〇木村 和希<sup>1</sup>・山内 俊輝<sup>1</sup>・畑中 励介<sup>1</sup>・岡崎 雅明 <sup>1</sup>・太田 俊<sup>1</sup>",
      "Catalytic Hydroamination and Hydroalkoxylation of Carbodiimides with Titanium Amido Complexes Bearing Indolyl-based Ancillary Ligands",
      "(<sup>1</sup>Grad. Sch. of Sci. and Tech., Hirosaki Univ.) 〇Kazuki KIMURA<sup>1</sup>, Toshiki YAMAUCHI<sup>1</sup>, Reisuke HATANAKA<sup>1</sup>, Masaaki OKAZAKI<sup>1</sup>, Shun OHTA<sup>1</sup>"
    ],
    "lab": "3PD-09",
    "pdf": "pdf/3PD-09.pdf",
    "pre": "tn/3PD-09.jpg",
    "reg": "74116",
    "sea": "Ti",
    "ses": "3PD",
    "con": "3PD-09 インドリル系補助配位子を持つチタンアミド錯体を用いたカルボジイミドの触媒的ヒドロアミノ化およびヒドロアルコキシ化反応 (<sup>1</sup>弘前大院理工) 〇木村 和希<sup>1</sup>・山内 俊輝<sup>1</sup>・畑中 励介<sup>1</sup>・岡崎 雅明 <sup>1</sup>・太田 俊<sup>1</sup> Catalytic Hydroamination and Hydroalkoxylation of Carbodiimides with Titanium Amido Complexes Bearing Indolyl-based Ancillary Ligands (<sup>1</sup>Grad. Sch. of Sci. and Tech., Hirosaki Univ.) 〇Kazuki KIMURA<sup>1</sup>, Toshiki YAMAUCHI<sup>1</sup>, Reisuke HATANAKA<sup>1</sup>, Masaaki OKAZAKI<sup>1</sup>, Shun OHTA<sup>1</sup> Ti"
  },
  {
    "inf": [
      "新規非対称型三座含硫NHC-Pd(II)錯体の合成と性質",
      "(<sup>1</sup>名工大院工) 〇伊藤 匠哉<sup>1</sup>・土本 寛之<sup>1</sup>・柳生 剛義<sup>1</sup>",
      "Synthesis and Characterization of Unsymmetric Pd(II) Complexes with a sulfur-containing tridentate NHC ligand",
      "(<sup>1</sup>Nagoya Institute of Technology) 〇Shoya Ito <sup>1</sup>, Hiroyuki Tsuchimoto<sup>1</sup>, Takeyoshi Yagyu<sup>1</sup>"
    ],
    "lab": "3PD-10",
    "pdf": "pdf/3PD-10.pdf",
    "pre": "tn/3PD-10.jpg",
    "reg": "74258",
    "sea": "Pd",
    "ses": "3PD",
    "con": "3PD-10 新規非対称型三座含硫NHC-Pd(II)錯体の合成と性質 (<sup>1</sup>名工大院工) 〇伊藤 匠哉<sup>1</sup>・土本 寛之<sup>1</sup>・柳生 剛義<sup>1</sup> Synthesis and Characterization of Unsymmetric Pd(II) Complexes with a sulfur-containing tridentate NHC ligand (<sup>1</sup>Nagoya Institute of Technology) 〇Shoya Ito <sup>1</sup>, Hiroyuki Tsuchimoto<sup>1</sup>, Takeyoshi Yagyu<sup>1</sup> Pd"
  },
  {
    "inf": [
      "ジチオカルボン酸配位子を用いた耐水性MOPの合成",
      "(<sup>1</sup>九大院理) 〇下川 真依<sup>1</sup>・ルウェ バンジャマン<sup>1</sup>・大谷 亮<sup>1</sup>・大場 正昭<sup>1</sup>",
      "Development of Water-Stable MOPs with Dithiocarboxylate Ligands",
      "(<sup>1</sup>Graduate School of Science, Kyushu Univ.) 〇Mai SHIMOGAWA<sup>1</sup>, Benjamin LE OUAY<sup>1</sup>, Ryo OHTANI<sup>1</sup>, Masaaki OHBA<sup>1</sup>"
    ],
    "lab": "3PD-11",
    "pdf": "pdf/3PD-11.pdf",
    "pre": "tn/3PD-11.jpg",
    "reg": "74326",
    "sea": "Cu",
    "ses": "3PD",
    "con": "3PD-11 ジチオカルボン酸配位子を用いた耐水性MOPの合成 (<sup>1</sup>九大院理) 〇下川 真依<sup>1</sup>・ルウェ バンジャマン<sup>1</sup>・大谷 亮<sup>1</sup>・大場 正昭<sup>1</sup> Development of Water-Stable MOPs with Dithiocarboxylate Ligands (<sup>1</sup>Graduate School of Science, Kyushu Univ.) 〇Mai SHIMOGAWA<sup>1</sup>, Benjamin LE OUAY<sup>1</sup>, Ryo OHTANI<sup>1</sup>, Masaaki OHBA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "コバルトビスアミド錯体を用いたC–H結合活性化と修飾反応",
      "(<sup>1</sup>阪大院理) 〇畑中 翼<sup>1</sup>・小林 翠穂<sup>1</sup>・舩橋 靖博<sup>1</sup>",
      "C–H Activation and Functionalization Mediated by Cobalt Bisamides",
      "(<sup>1</sup>Osaka Univ.) 〇Tsubasa HATANAKA<sup>1</sup>, Suiho KOBAYASHI<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup>"
    ],
    "lab": "3PD-12",
    "pdf": "pdf/3PD-12.pdf",
    "pre": "tn/3PD-12.jpg",
    "reg": "74391",
    "sea": "Co",
    "ses": "3PD",
    "con": "3PD-12 コバルトビスアミド錯体を用いたC–H結合活性化と修飾反応 (<sup>1</sup>阪大院理) 〇畑中 翼<sup>1</sup>・小林 翠穂<sup>1</sup>・舩橋 靖博<sup>1</sup> C–H Activation and Functionalization Mediated by Cobalt Bisamides (<sup>1</sup>Osaka Univ.) 〇Tsubasa HATANAKA<sup>1</sup>, Suiho KOBAYASHI<sup>1</sup>, Yasuhiro FUNAHASHI<sup>1</sup> Co"
  },
  {
    "inf": [
      "かさ高いC<sub>5</sub>Ar<sub>5</sub>配位子(Ar = 芳香族基)を有する半サンドイッチ型9族金属錯体の合成",
      "(<sup>1</sup>京大化研) 〇足立 平良<sup>1</sup>・伊豆 仁<sup>1</sup>・大木 靖弘<sup>1</sup>",
      "Synthesis of half-sandwich complexes of group 9 metals having bulky C<sub>5</sub>Ar<sub>5</sub> (Ar = aromatic groups) ligands",
      "(<sup>1</sup>Institute for Chemical Research, Kyoto University) 〇Taira ADACHI<sup>1</sup>, Hitoshi IZU<sup>1</sup>, Yasuhiro Ohki<sup>1</sup>"
    ],
    "lab": "3PD-13",
    "pdf": "pdf/3PD-13.pdf",
    "pre": "tn/3PD-13.jpg",
    "reg": "74138",
    "sea": "Rh, Ir",
    "ses": "3PD",
    "con": "3PD-13 かさ高いC<sub>5</sub>Ar<sub>5</sub>配位子(Ar = 芳香族基)を有する半サンドイッチ型9族金属錯体の合成 (<sup>1</sup>京大化研) 〇足立 平良<sup>1</sup>・伊豆 仁<sup>1</sup>・大木 靖弘<sup>1</sup> Synthesis of half-sandwich complexes of group 9 metals having bulky C<sub>5</sub>Ar<sub>5</sub> (Ar = aromatic groups) ligands (<sup>1</sup>Institute for Chemical Research, Kyoto University) 〇Taira ADACHI<sup>1</sup>, Hitoshi IZU<sup>1</sup>, Yasuhiro Ohki<sup>1</sup> Rh, Ir"
  },
  {
    "inf": [
      "歯周病菌 Eikenella corrodensによる嫌気的ヘムの分解反応",
      "(<sup>1</sup>山口大学 創成科学) 高田亜実<sup>1</sup>・沖本雄大<sup>1</sup>・〇小崎紳一<sup>1</sup>",
      "Anaerobic heme degradation by Eikenella corrodens",
      "(<sup>1</sup>Yamaguchi Univ.) Ami TAKATA <sup>1</sup>, Yuta OKIMOTO<sup>1</sup>, 〇Shin-ichi OZAKI<sup>1</sup>"
    ],
    "lab": "3PE-01",
    "pdf": "pdf/3PE-01.pdf",
    "pre": "tn/3PE-01.jpg",
    "reg": "74036",
    "sea": "Fe",
    "ses": "3PE",
    "con": "3PE-01 歯周病菌 Eikenella corrodensによる嫌気的ヘムの分解反応 (<sup>1</sup>山口大学 創成科学) 高田亜実<sup>1</sup>・沖本雄大<sup>1</sup>・〇小崎紳一<sup>1</sup> Anaerobic heme degradation by Eikenella corrodens (<sup>1</sup>Yamaguchi Univ.) Ami TAKATA <sup>1</sup>, Yuta OKIMOTO<sup>1</sup>, 〇Shin-ichi OZAKI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "カーボンナノチューブ表面に固定した鉄ポルフィリン二量体の酸素還元反応",
      "(<sup>1</sup>山口東理大工・<sup>2</sup>京大化研) 〇調 大輔<sup>1</sup>・竹山 知志<sup>1</sup>・檜垣 達也<sup>2</sup>・大木 靖弘<sup>2</sup>・太田 雄大<sup>1</sup>",
      "Oxygen reduction reaction by an iron porphyrin dimer involving an axial pyridine ligand anchored on carbon nanotube",
      "(<sup>1</sup>Sanyo-Onoda City Univ., <sup>2</sup>Kyoto Univ.) 〇Daisuke SHIRABE<sup>1</sup>, Tomoyuki TAKEYAMA<sup>1</sup>, Tatsuya HIGAKI<sup>2</sup>, Yasuhiro OHKI<sup>2</sup>, Takehiro OHTA<sup>1</sup>"
    ],
    "lab": "3PE-02",
    "pdf": "pdf/3PE-02.pdf",
    "pre": "tn/3PE-02.jpg",
    "reg": "74430",
    "sea": "Fe",
    "ses": "3PE",
    "con": "3PE-02 カーボンナノチューブ表面に固定した鉄ポルフィリン二量体の酸素還元反応 (<sup>1</sup>山口東理大工・<sup>2</sup>京大化研) 〇調 大輔<sup>1</sup>・竹山 知志<sup>1</sup>・檜垣 達也<sup>2</sup>・大木 靖弘<sup>2</sup>・太田 雄大<sup>1</sup> Oxygen reduction reaction by an iron porphyrin dimer involving an axial pyridine ligand anchored on carbon nanotube (<sup>1</sup>Sanyo-Onoda City Univ., <sup>2</sup>Kyoto Univ.) 〇Daisuke SHIRABE<sup>1</sup>, Tomoyuki TAKEYAMA<sup>1</sup>, Tatsuya HIGAKI<sup>2</sup>, Yasuhiro OHKI<sup>2</sup>, Takehiro OHTA<sup>1</sup> Fe"
  },
  {
    "inf": [
      "ニトロゲナーゼ活性中心の周囲環境が反応機構に与える影響に関する理論研究",
      "(<sup>1</sup>阪大院基礎工・<sup>2</sup>阪大QIQB・<sup>3</sup>阪大RCSEC・<sup>4</sup>阪大ICS-OTRI・<sup>5</sup>阪大OTRI-Spin) 〇本城 一樹<sup>1</sup>・多田 幸平<sup>1</sup>・岸 亮平<sup>1,2,3,4</sup>・北河 康隆<sup>1,2,3,4,5</sup>",
      "Theoretical study on the effect of the surrounding environment of the nitrogenase active center on the reaction mechanism",
      "(<sup>1</sup>Graduate School of Engineering Science, Osaka University, <sup>2</sup>QIQB, Osaka University, <sup>3</sup>RCSEC, Osaka University, <sup>4</sup>ICS-OTRI, Osaka University, <sup>5</sup>OTRI-Spin, Osaka University) 〇Kazuki HONJO<sup>1</sup>, Kohei TADA<sup>1</sup>, Ryohei KISHI<sup>1,2,3,4</sup>, Yasutaka KITAGAWA<sup>1,2,3,4,5</sup>"
    ],
    "lab": "3PE-03",
    "pdf": "pdf/3PE-03.pdf",
    "pre": "tn/3PE-03.jpg",
    "reg": "74146",
    "sea": "Fe, Mo",
    "ses": "3PE",
    "con": "3PE-03 ニトロゲナーゼ活性中心の周囲環境が反応機構に与える影響に関する理論研究 (<sup>1</sup>阪大院基礎工・<sup>2</sup>阪大QIQB・<sup>3</sup>阪大RCSEC・<sup>4</sup>阪大ICS-OTRI・<sup>5</sup>阪大OTRI-Spin) 〇本城 一樹<sup>1</sup>・多田 幸平<sup>1</sup>・岸 亮平<sup>1,2,3,4</sup>・北河 康隆<sup>1,2,3,4,5</sup> Theoretical study on the effect of the surrounding environment of the nitrogenase active center on the reaction mechanism (<sup>1</sup>Graduate School of Engineering Science, Osaka University, <sup>2</sup>QIQB, Osaka University, <sup>3</sup>RCSEC, Osaka University, <sup>4</sup>ICS-OTRI, Osaka University, <sup>5</sup>OTRI-Spin, Osaka University) 〇Kazuki HONJO<sup>1</sup>, Kohei TADA<sup>1</sup>, Ryohei KISHI<sup>1,2,3,4</sup>, Yasutaka KITAGAWA<sup>1,2,3,4,5</sup> Fe, Mo"
  },
  {
    "inf": [
      "アミド含有配位子を用いた銅錯体の合成とそのがん細胞選択的毒性",
      "(<sup>1</sup>同大理工) 〇中嶋 彩乃<sup>1</sup>・畑 真知<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺政人<sup>1</sup>",
      "Synthesis and cancer-cell selective cytotoxicity of copper complexes with amide-containing ligands",
      "(<sup>1</sup>Doshisha Univ.) 〇Ayano NAKASHIMA<sup>1</sup>, Machi HATA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masahito KODERA<sup>1</sup>"
    ],
    "lab": "3PE-04",
    "pdf": "pdf/3PE-04.pdf",
    "pre": "tn/3PE-04.jpg",
    "reg": "74482",
    "sea": "Cu",
    "ses": "3PE",
    "con": "3PE-04 アミド含有配位子を用いた銅錯体の合成とそのがん細胞選択的毒性 (<sup>1</sup>同大理工) 〇中嶋 彩乃<sup>1</sup>・畑 真知<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺政人<sup>1</sup> Synthesis and cancer-cell selective cytotoxicity of copper complexes with amide-containing ligands (<sup>1</sup>Doshisha Univ.) 〇Ayano NAKASHIMA<sup>1</sup>, Machi HATA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masahito KODERA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "巨大リポソーム内部空間でのリン酸カルシウムの生成反応",
      "(<sup>1</sup>立命館大院生命科) 〇松本 翔太<sup>1</sup>・越山 友美<sup>1</sup>",
      "Calcium phosphate formation in giant liposomes",
      "(<sup>1</sup>Ritsumeikan Univ. Grad. Sch. Life Sci.) 〇Shota MATSUMOTO<sup>1</sup>, Tomomi KOSHIYAMA<sup>1</sup>"
    ],
    "lab": "3PE-05",
    "pdf": "pdf/3PE-05.pdf",
    "pre": "tn/3PE-05.jpg",
    "reg": "74199",
    "sea": "Ca",
    "ses": "3PE",
    "con": "3PE-05 巨大リポソーム内部空間でのリン酸カルシウムの生成反応 (<sup>1</sup>立命館大院生命科) 〇松本 翔太<sup>1</sup>・越山 友美<sup>1</sup> Calcium phosphate formation in giant liposomes (<sup>1</sup>Ritsumeikan Univ. Grad. Sch. Life Sci.) 〇Shota MATSUMOTO<sup>1</sup>, Tomomi KOSHIYAMA<sup>1</sup> Ca"
  },
  {
    "inf": [
      "ヒドロキノン-N4型配位子をもつ金属錯体の合成と抗酸化活性",
      "(<sup>1</sup>山口東理大工・<sup>2</sup>京大化研) 〇増井 礼央<sup></sup>・好川 大智<sup></sup>・竹山 知志<sup></sup>・檜垣 達也<sup></sup>・大木 靖弘<sup></sup>・太田 雄大<sup></sup>",
      "Structure and antioxidant reactivity of metal complexes involving hydroquinone-N4-type ligand",
      "(<sup>1</sup>Sanyo-Onoda City Univ., <sup>2</sup>Kyoto Univ.) 〇Reo MASUI<sup></sup>, Taichi YOSHIKAWA<sup></sup>, Tomoyuki TAKEYAMA<sup></sup>, Tatsuya HIGAKI<sup></sup>, Yasuhiro OHKI<sup></sup>, Takehiro OHTA<sup></sup>"
    ],
    "lab": "3PE-06",
    "pdf": "pdf/3PE-06.pdf",
    "pre": "tn/3PE-06.jpg",
    "reg": "74431",
    "sea": "Fe, Cu, Zn",
    "ses": "3PE",
    "con": "3PE-06 ヒドロキノン-N4型配位子をもつ金属錯体の合成と抗酸化活性 (<sup>1</sup>山口東理大工・<sup>2</sup>京大化研) 〇増井 礼央<sup></sup>・好川 大智<sup></sup>・竹山 知志<sup></sup>・檜垣 達也<sup></sup>・大木 靖弘<sup></sup>・太田 雄大<sup></sup> Structure and antioxidant reactivity of metal complexes involving hydroquinone-N4-type ligand (<sup>1</sup>Sanyo-Onoda City Univ., <sup>2</sup>Kyoto Univ.) 〇Reo MASUI<sup></sup>, Taichi YOSHIKAWA<sup></sup>, Tomoyuki TAKEYAMA<sup></sup>, Tatsuya HIGAKI<sup></sup>, Yasuhiro OHKI<sup></sup>, Takehiro OHTA<sup></sup> Fe, Cu, Zn"
  },
  {
    "inf": [
      "非対称キレート環を有するN₂S₃型NHaseモデル錯体の合成および性質 ",
      "(<sup>1</sup>甲南大学フロンティア) 〇河野 涼真<sup>1</sup>",
      "Synthesis and Properties of N₂S₃-Type NHase Model Complex with Asymmetric Chelate Rings           ",
      "(<sup>1</sup>Konan Univ.) 〇Ryoma Kawano<sup>1</sup>"
    ],
    "lab": "3PE-07",
    "pdf": "pdf/3PE-07.pdf",
    "pre": "tn/3PE-07.jpg",
    "reg": "74206",
    "sea": "Co",
    "ses": "3PE",
    "con": "3PE-07 非対称キレート環を有するN₂S₃型NHaseモデル錯体の合成および性質  (<sup>1</sup>甲南大学フロンティア) 〇河野 涼真<sup>1</sup> Synthesis and Properties of N₂S₃-Type NHase Model Complex with Asymmetric Chelate Rings            (<sup>1</sup>Konan Univ.) 〇Ryoma Kawano<sup>1</sup> Co"
  },
  {
    "inf": [
      "_p_-Cresol Amide-Tether Cyclen Ligand/DNA Target Conjugateの二核銅錯体によるがん細胞選択的毒性:DNA Targetの効果",
      "(<sup>1</sup>同志社大大学院理工) 〇小橋 寛人<sup>1</sup>・畑 真知<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup>",
      "Cancer-Cell-Selective Cytotoxicity by Dicopper Complexes with _p_-Cresol-Amide-Tether-Cyclen Ligands: DNA-Targeting Effect",
      "(<sup>1</sup>Department of Science and Engineering, Doshisha University) 〇Hiroto KOBASHI<sup>1</sup>, Machi HATA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masahito KODERA<sup>1</sup>"
    ],
    "lab": "3PE-08",
    "pdf": "pdf/3PE-08.pdf",
    "pre": "tn/3PE-08.jpg",
    "reg": "74505",
    "sea": "Cu",
    "ses": "3PE",
    "con": "3PE-08 _p_-Cresol Amide-Tether Cyclen Ligand/DNA Target Conjugateの二核銅錯体によるがん細胞選択的毒性:DNA Targetの効果 (<sup>1</sup>同志社大大学院理工) 〇小橋 寛人<sup>1</sup>・畑 真知<sup>1</sup>・北岸 宏亮<sup>1</sup>・小寺 政人<sup>1</sup> Cancer-Cell-Selective Cytotoxicity by Dicopper Complexes with _p_-Cresol-Amide-Tether-Cyclen Ligands: DNA-Targeting Effect (<sup>1</sup>Department of Science and Engineering, Doshisha University) 〇Hiroto KOBASHI<sup>1</sup>, Machi HATA<sup>1</sup>, Hiroaki KITAGISHI<sup>1</sup>, Masahito KODERA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "ポリエチレングリコールを結合した銅タンパク質生体触媒の調製と反応性評価",
      "(<sup>1</sup>大阪公大院農) 〇岩渕祥吾<sup>1</sup>・森田能次<sup>1</sup>・藤枝伸宇<sup>1</sup>",
      "Preparation of PEGylated copper-protein biocatalyst and its reactivity evaluation",
      "(<sup>1</sup> Osaka Metropolitan University) 〇Shogo Iwabuchi<sup>1</sup>, Yoshitsugu Morita<sup>1</sup>, Nobutaka Fujieda<sup>1</sup>"
    ],
    "lab": "3PE-09",
    "pdf": "pdf/3PE-09.pdf",
    "pre": "tn/3PE-09.jpg",
    "reg": "74276",
    "sea": "Cu",
    "ses": "3PE",
    "con": "3PE-09 ポリエチレングリコールを結合した銅タンパク質生体触媒の調製と反応性評価 (<sup>1</sup>大阪公大院農) 〇岩渕祥吾<sup>1</sup>・森田能次<sup>1</sup>・藤枝伸宇<sup>1</sup> Preparation of PEGylated copper-protein biocatalyst and its reactivity evaluation (<sup>1</sup> Osaka Metropolitan University) 〇Shogo Iwabuchi<sup>1</sup>, Yoshitsugu Morita<sup>1</sup>, Nobutaka Fujieda<sup>1</sup> Cu"
  },
  {
    "inf": [
      "二酸化炭素の光還元を指向したコバルト置換シトクロムP450へのルテニウム光増感剤の共有結合による修飾",
      "(<sup>1</sup>阪大院工) 〇小島 大周<sup>1</sup>・大洞 光司<sup>1</sup>・林 高史<sup>1</sup>",
      "Covalent modification of a Ru photosensitizer to cobalt-substituted cytochrome P450 toward photoinduced reduction of carbon dioxide",
      "(<sup>1</sup>Osaka Univ.) 〇Taishu Kojima<sup>1</sup>, Koji Oohira<sup>1</sup>, Takashi Hayashi<sup>1</sup>"
    ],
    "lab": "3PE-10",
    "pdf": "pdf/3PE-10.pdf",
    "pre": "tn/3PE-10.jpg",
    "reg": "74339",
    "sea": "Ru,Co",
    "ses": "3PE",
    "con": "3PE-10 二酸化炭素の光還元を指向したコバルト置換シトクロムP450へのルテニウム光増感剤の共有結合による修飾 (<sup>1</sup>阪大院工) 〇小島 大周<sup>1</sup>・大洞 光司<sup>1</sup>・林 高史<sup>1</sup> Covalent modification of a Ru photosensitizer to cobalt-substituted cytochrome P450 toward photoinduced reduction of carbon dioxide (<sup>1</sup>Osaka Univ.) 〇Taishu Kojima<sup>1</sup>, Koji Oohira<sup>1</sup>, Takashi Hayashi<sup>1</sup> Ru,Co"
  },
  {
    "inf": [
      "Impact of alkyl spacer on the structure, dynamics, and O<sub>2</sub> reactivity of bis-tridentate chelated cobalt(II) complexes having bis(2-pyridylalkyl)amine ligands",
      "(<sup>1</sup>Indian Institute of Technology Madras, India) 〇N Narasimha Murthy<sup></sup>"
    ],
    "lab": "3PE-11",
    "pdf": "pdf/3PE-11.pdf",
    "pre": "tn/3PE-11.jpg",
    "reg": "74604",
    "sea": "Co",
    "ses": "3PE",
    "con": "3PE-11 Impact of alkyl spacer on the structure, dynamics, and O<sub>2</sub> reactivity of bis-tridentate chelated cobalt(II) complexes having bis(2-pyridylalkyl)amine ligands (<sup>1</sup>Indian Institute of Technology Madras, India) 〇N Narasimha Murthy<sup></sup> Co"
  },
  {
    "inf": [
      "Electrochemical detection of specific alkali metal ions by cyano-bridged Ho<sup>3+</sup>-Fe<sup>3+</sup> dinuclear complex",
      "(<sup>1</sup>Tokyo Univ. of Science) 〇Daisuke NAKANE<sup>1</sup>, Takashi NAGAI<sup>1</sup>, Takashiro AKITSU<sup>1</sup>"
    ],
    "lab": "3PF-01",
    "pdf": "pdf/3PF-01.pdf",
    "pre": "tn/3PF-01.jpg",
    "reg": "74028",
    "sea": "Ho, Fe",
    "ses": "3PF",
    "con": "3PF-01 Electrochemical detection of specific alkali metal ions by cyano-bridged Ho<sup>3+</sup>-Fe<sup>3+</sup> dinuclear complex (<sup>1</sup>Tokyo Univ. of Science) 〇Daisuke NAKANE<sup>1</sup>, Takashi NAGAI<sup>1</sup>, Takashiro AKITSU<sup>1</sup> Ho, Fe"
  },
  {
    "inf": [
      "Pore Design of POM@MOF Hybrids for Enhanced Methylene Blue Capture",
      "(<sup>1</sup>Department of Basic Science, School of Arts and Sciences, The University of Tokyo) 〇Naoki OGIWARA<sup>1</sup>, Shotaro MIYAZAKI<sup></sup>, Cocoro A. NAGASAKA<sup></sup>, Sayaka UCHIDA<sup></sup>"
    ],
    "lab": "3PF-02",
    "pdf": "pdf/3PF-02.pdf",
    "pre": "tn/3PF-02.jpg",
    "reg": "74039",
    "sea": "Zr, W",
    "ses": "3PF",
    "con": "3PF-02 Pore Design of POM@MOF Hybrids for Enhanced Methylene Blue Capture (<sup>1</sup>Department of Basic Science, School of Arts and Sciences, The University of Tokyo) 〇Naoki OGIWARA<sup>1</sup>, Shotaro MIYAZAKI<sup></sup>, Cocoro A. NAGASAKA<sup></sup>, Sayaka UCHIDA<sup></sup> Zr, W"
  },
  {
    "inf": [
      "Preparation and characterization of zeolite-supported Pt nanocluster catalysts for electrochemical hydrogen revolution reaction.",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ) 〇Zili YAO<sup></sup>"
    ],
    "lab": "3PF-03",
    "pdf": "pdf/3PF-03.pdf",
    "pre": "tn/3PF-03.jpg",
    "reg": "74224",
    "sea": "Pt",
    "ses": "3PF",
    "con": "3PF-03 Preparation and characterization of zeolite-supported Pt nanocluster catalysts for electrochemical hydrogen revolution reaction. (<sup>1</sup>Dept. Chem. Kyushu Univ) 〇Zili YAO<sup></sup> Pt"
  },
  {
    "inf": [
      "金原子包接グラファイト状窒化炭素のラマン散乱増強効果に関する計算化学的検討",
      "(<sup>1</sup>近大院総合理工・<sup>2</sup>近大理工) 〇木内 太智<sup>1</sup>・中井 俊吾<sup>2</sup>・大橋 弘暉<sup>2</sup>・藤島 武蔵<sup>1,2</sup>",
      "Computational Study on Raman-Enhancing Effects of Au Atom-Encapsulated Graphitic Carbon Nitride",
      "(<sup>1</sup>Fuculty of Science and Engineering, Kindai Univ., <sup>2</sup>Graduate School of Science and Engineering, Kindai Univ.) 〇Taichi Kiuchi<sup>1</sup>, Syungo Nakai<sup>2</sup>, Koki Ohashi<sup>2</sup>, Musashi Fujishima<sup>1,2</sup>"
    ],
    "lab": "3PF-04",
    "pdf": "pdf/3PF-04.pdf",
    "pre": "tn/3PF-04.jpg",
    "reg": "74008",
    "sea": "Au, Ag, Cu",
    "ses": "3PF",
    "con": "3PF-04 金原子包接グラファイト状窒化炭素のラマン散乱増強効果に関する計算化学的検討 (<sup>1</sup>近大院総合理工・<sup>2</sup>近大理工) 〇木内 太智<sup>1</sup>・中井 俊吾<sup>2</sup>・大橋 弘暉<sup>2</sup>・藤島 武蔵<sup>1,2</sup> Computational Study on Raman-Enhancing Effects of Au Atom-Encapsulated Graphitic Carbon Nitride (<sup>1</sup>Fuculty of Science and Engineering, Kindai Univ., <sup>2</sup>Graduate School of Science and Engineering, Kindai Univ.) 〇Taichi Kiuchi<sup>1</sup>, Syungo Nakai<sup>2</sup>, Koki Ohashi<sup>2</sup>, Musashi Fujishima<sup>1,2</sup> Au, Ag, Cu"
  },
  {
    "inf": [
      "Antibacterial activity of azo-amino acid Schiff bases and their copper(II) complexes",
      "(<sup>1</sup>Tokyo Univ. of Science, <sup>2</sup>Rani Channamma Univ.) 〇Takashiro AKITSU<sup>1</sup>, Yuma YAMAMOTO<sup>1</sup>, Daisuke NAKANE<sup>1</sup>, Basavarai PADMASHALI<sup>2</sup>"
    ],
    "lab": "3PF-05",
    "pdf": "pdf/3PF-05.pdf",
    "pre": "tn/3PF-05.jpg",
    "reg": "74022",
    "sea": "Cu",
    "ses": "3PF",
    "con": "3PF-05 Antibacterial activity of azo-amino acid Schiff bases and their copper(II) complexes (<sup>1</sup>Tokyo Univ. of Science, <sup>2</sup>Rani Channamma Univ.) 〇Takashiro AKITSU<sup>1</sup>, Yuma YAMAMOTO<sup>1</sup>, Daisuke NAKANE<sup>1</sup>, Basavarai PADMASHALI<sup>2</sup> Cu"
  },
  {
    "inf": [
      "Transition behavior inside thermal hysteresis in rubidium manganese hexacyanidoferrate exhibiting charge-transfer phase transition phenomena",
      "(<sup>1</sup>Department of Chemistry, The University of Tokyo) 〇Yoshinori Tanaka<sup>1</sup>, Kenta Imoto<sup>1</sup>, Koji Nakabayashi<sup>1</sup>, Shin-ichi Ohkoshi<sup>1</sup>"
    ],
    "lab": "3PF-06",
    "pdf": "pdf/3PF-06.pdf",
    "pre": "tn/3PF-06.jpg",
    "reg": "74126",
    "sea": "Rb,Mn,Fe,Co",
    "ses": "3PF",
    "con": "3PF-06 Transition behavior inside thermal hysteresis in rubidium manganese hexacyanidoferrate exhibiting charge-transfer phase transition phenomena (<sup>1</sup>Department of Chemistry, The University of Tokyo) 〇Yoshinori Tanaka<sup>1</sup>, Kenta Imoto<sup>1</sup>, Koji Nakabayashi<sup>1</sup>, Shin-ichi Ohkoshi<sup>1</sup> Rb,Mn,Fe,Co"
  },
  {
    "inf": [
      "親水性側鎖を有する二次元銀一価半導体配位高分子の合成と相転移挙動の評価",
      "(<sup>1</sup>関学大理・<sup>2</sup>阪大院工・<sup>3</sup>阪大蛋白研) 〇澤田智絵<sup>1</sup>・福田沙取<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯昭紀<sup>2</sup>・中根崇智<sup>3</sup>・川本晃大<sup>3</sup>・栗栖源嗣<sup>3</sup>・田中大輔<sup>1</sup>",
      "Synthesis and Phase Transition Observation of Two-Dimensional Semiconductive Ag(I) Coordination Polymers ",
      "(<sup>1</sup>School of Science, Kwansei Gakuin University, <sup>2</sup>Graduate School of Engineering, Osaka University, <sup>3</sup>Institute for Protein Research, Osaka University) 〇Chie SAWADA<sup>1</sup>, Satori FUKUTA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Takanori NAKANE<sup>3</sup>, Akihiro KAWAMOTO<sup>3</sup>, Genji KURISU<sup>3</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "3PF-07",
    "pdf": "pdf/3PF-07.pdf",
    "pre": "tn/3PF-07.jpg",
    "reg": "74038",
    "sea": "Ag",
    "ses": "3PF",
    "con": "3PF-07 親水性側鎖を有する二次元銀一価半導体配位高分子の合成と相転移挙動の評価 (<sup>1</sup>関学大理・<sup>2</sup>阪大院工・<sup>3</sup>阪大蛋白研) 〇澤田智絵<sup>1</sup>・福田沙取<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯昭紀<sup>2</sup>・中根崇智<sup>3</sup>・川本晃大<sup>3</sup>・栗栖源嗣<sup>3</sup>・田中大輔<sup>1</sup> Synthesis and Phase Transition Observation of Two-Dimensional Semiconductive Ag(I) Coordination Polymers  (<sup>1</sup>School of Science, Kwansei Gakuin University, <sup>2</sup>Graduate School of Engineering, Osaka University, <sup>3</sup>Institute for Protein Research, Osaka University) 〇Chie SAWADA<sup>1</sup>, Satori FUKUTA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Takanori NAKANE<sup>3</sup>, Akihiro KAWAMOTO<sup>3</sup>, Genji KURISU<sup>3</sup>, Daisuke TANAKA<sup>1</sup> Ag"
  },
  {
    "inf": [
      "カルボキシ基導入単分子磁石からなるHOF薄膜の構築と配向性評価",
      "(<sup>1</sup>奈良女大院理) 〇山田 実季<sup>1</sup>・溝口 茜子<sup>1</sup>・堀井 洋司<sup>1</sup>・梶原 孝志<sup>1</sup>",
      "Construction and characterization of HOF thin films composed of single-molecule magnets with carboxy groups",
      "(<sup>1</sup>Nara Women's Univ.) 〇Miki YAMADA<sup>1</sup>, Akane MIZOGUCHI<sup>1</sup>, Yoji HORII<sup>1</sup>, Takashi KAJIWARA<sup>1</sup>"
    ],
    "lab": "3PF-08",
    "pdf": "pdf/3PF-08.pdf",
    "pre": "tn/3PF-08.jpg",
    "reg": "74050",
    "sea": "Tb",
    "ses": "3PF",
    "con": "3PF-08 カルボキシ基導入単分子磁石からなるHOF薄膜の構築と配向性評価 (<sup>1</sup>奈良女大院理) 〇山田 実季<sup>1</sup>・溝口 茜子<sup>1</sup>・堀井 洋司<sup>1</sup>・梶原 孝志<sup>1</sup> Construction and characterization of HOF thin films composed of single-molecule magnets with carboxy groups (<sup>1</sup>Nara Women's Univ.) 〇Miki YAMADA<sup>1</sup>, Akane MIZOGUCHI<sup>1</sup>, Yoji HORII<sup>1</sup>, Takashi KAJIWARA<sup>1</sup> Tb"
  },
  {
    "inf": [
      "Metal Substitution Effects on Luminescent Octacyanidemetallate Magnetic Cocrystals",
      "(<sup>1</sup>Univ. of Tokyo) 〇Tatsuya KONISHI<sup>1</sup>, Kunal KUMAR<sup>1</sup>, Kazuki NAKAMURA<sup>1</sup>, Yuuki MINEO<sup>1</sup>, Koji NAKABAYASHI<sup>1</sup>, Shin-ichi OHKOSHI<sup>1</sup>"
    ],
    "lab": "3PF-09",
    "pdf": "pdf/3PF-09.pdf",
    "pre": "tn/3PF-09.jpg",
    "reg": "74180",
    "sea": "W, Mo",
    "ses": "3PF",
    "con": "3PF-09 Metal Substitution Effects on Luminescent Octacyanidemetallate Magnetic Cocrystals (<sup>1</sup>Univ. of Tokyo) 〇Tatsuya KONISHI<sup>1</sup>, Kunal KUMAR<sup>1</sup>, Kazuki NAKAMURA<sup>1</sup>, Yuuki MINEO<sup>1</sup>, Koji NAKABAYASHI<sup>1</sup>, Shin-ichi OHKOSHI<sup>1</sup> W, Mo"
  },
  {
    "inf": [
      "異なるスズ-硫黄鎖を有する一次元配位高分子の合成と半導体特性の評価",
      "(<sup>1</sup>関学大理・<sup>2</sup>阪大院工) 〇酒井孝輔<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯明紀<sup>2</sup>・田中大輔<sup>1</sup>",
      "Synthesis and semiconductor characterization of one-dimensional coordination polymers with different tin-sulfur chains",
      "(<sup>1</sup>Kwansei Gakuin Univ., <sup>2</sup>Osaka Univ.) 〇Kosuke SAKAI<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "3PF-10",
    "pdf": "pdf/3PF-10.pdf",
    "pre": "tn/3PF-10.jpg",
    "reg": "74060",
    "sea": "Sn",
    "ses": "3PF",
    "con": "3PF-10 異なるスズ-硫黄鎖を有する一次元配位高分子の合成と半導体特性の評価 (<sup>1</sup>関学大理・<sup>2</sup>阪大院工) 〇酒井孝輔<sup>1</sup>・秋吉亮平<sup>1</sup>・佐伯明紀<sup>2</sup>・田中大輔<sup>1</sup> Synthesis and semiconductor characterization of one-dimensional coordination polymers with different tin-sulfur chains (<sup>1</sup>Kwansei Gakuin Univ., <sup>2</sup>Osaka Univ.) 〇Kosuke SAKAI<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Akinori SAEKI<sup>2</sup>, Daisuke TANAKA<sup>1</sup> Sn"
  },
  {
    "inf": [
      "紫色, 青紫色, 青色, 赤色を示すN^C^N型白金二価錯体結晶の研究",
      "(<sup>1</sup>横市大院生命ナノ・<sup>2</sup>横市大理) 〇藤谷 景星<sup>1</sup>・山下 夏生<sup>2</sup>・服部 伸吾<sup>1,2</sup>・篠﨑 一英<sup>1,2</sup>",
      "A study on the N^C^N type Pt (II) complex crystal showing purple, navy-blue, blue and red color.",
      "(<sup>1</sup>YCU, <sup>2</sup>YCU) 〇Keisei FUJITANI<sup>1</sup>, Natsuo YAMASHITA<sup>2</sup>, Shingo HATTORI<sup>1,2</sup>, Kazuteru SHINOZAKI<sup>1,2</sup>"
    ],
    "lab": "3PF-11",
    "pdf": "pdf/3PF-11.pdf",
    "pre": "tn/3PF-11.jpg",
    "reg": "74088",
    "sea": "Pt",
    "ses": "3PF",
    "con": "3PF-11 紫色, 青紫色, 青色, 赤色を示すN^C^N型白金二価錯体結晶の研究 (<sup>1</sup>横市大院生命ナノ・<sup>2</sup>横市大理) 〇藤谷 景星<sup>1</sup>・山下 夏生<sup>2</sup>・服部 伸吾<sup>1,2</sup>・篠﨑 一英<sup>1,2</sup> A study on the N^C^N type Pt (II) complex crystal showing purple, navy-blue, blue and red color. (<sup>1</sup>YCU, <sup>2</sup>YCU) 〇Keisei FUJITANI<sup>1</sup>, Natsuo YAMASHITA<sup>2</sup>, Shingo HATTORI<sup>1,2</sup>, Kazuteru SHINOZAKI<sup>1,2</sup> Pt"
  },
  {
    "inf": [
      "プルシアンブルー薄膜の温度依存する電気伝導挙動",
      "(<sup>1</sup>山形大院理工) 〇及川 理沙<sup>1</sup>・石﨑 学<sup>1</sup>・栗原 正人<sup>1</sup>",
      "Electrical-Conductivity Behavior of Prussian-Blue Thin Films           under Various Temperature Conditions",
      "(<sup>1</sup>Yamagata Univ.) 〇Risa OIKAWA<sup>1</sup>, Manabu ISHIZAKI<sup>1</sup>, Masato KURIHARA<sup>1</sup>"
    ],
    "lab": "3PF-12",
    "pdf": "pdf/3PF-12.pdf",
    "pre": "tn/3PF-12.jpg",
    "reg": "74089",
    "sea": "Fe,Ni",
    "ses": "3PF",
    "con": "3PF-12 プルシアンブルー薄膜の温度依存する電気伝導挙動 (<sup>1</sup>山形大院理工) 〇及川 理沙<sup>1</sup>・石﨑 学<sup>1</sup>・栗原 正人<sup>1</sup> Electrical-Conductivity Behavior of Prussian-Blue Thin Films           under Various Temperature Conditions (<sup>1</sup>Yamagata Univ.) 〇Risa OIKAWA<sup>1</sup>, Manabu ISHIZAKI<sup>1</sup>, Masato KURIHARA<sup>1</sup> Fe,Ni"
  },
  {
    "inf": [
      "_S_=1/2 オキソバナジウム(IV)置換Dawson 型リンタングステン酸の磁気緩和現象",
      "(<sup>1</sup>日大院総合基・<sup>2</sup>日大文理) 〇和田 玲於<sup>1</sup>・石崎 聡晴<sup>2</sup>・尾関 智二<sup>2</sup>",
      "Magnetic relaxation phenomena of _S_=1/2 oxovanadium(IV)-substituted Dawson-type phosphotungstate",
      "(<sup>1</sup>Graduate School of Integrated Basic Sciences, Nihon University, <sup>2</sup>College of Humanities & Sciences, Nihon University) 〇Reo WADA<sup>1</sup>, Toshiharu ISHIZAKI<sup>2</sup>, Tomoji OZEKI<sup>2</sup>"
    ],
    "lab": "3PF-13",
    "pdf": "pdf/3PF-13.pdf",
    "pre": "tn/3PF-13.jpg",
    "reg": "74158",
    "sea": "V, W",
    "ses": "3PF",
    "con": "3PF-13 _S_=1/2 オキソバナジウム(IV)置換Dawson 型リンタングステン酸の磁気緩和現象 (<sup>1</sup>日大院総合基・<sup>2</sup>日大文理) 〇和田 玲於<sup>1</sup>・石崎 聡晴<sup>2</sup>・尾関 智二<sup>2</sup> Magnetic relaxation phenomena of _S_=1/2 oxovanadium(IV)-substituted Dawson-type phosphotungstate (<sup>1</sup>Graduate School of Integrated Basic Sciences, Nihon University, <sup>2</sup>College of Humanities & Sciences, Nihon University) 〇Reo WADA<sup>1</sup>, Toshiharu ISHIZAKI<sup>2</sup>, Tomoji OZEKI<sup>2</sup> V, W"
  },
  {
    "inf": [
      "機械学習法による白金錯体スタックジャンクションの電気伝導挙動解明",
      "(<sup>1</sup>東工大化生研・<sup>2</sup>東工大理・<sup>3</sup>東工大物質理工・<sup>4</sup>阪大産研・<sup>5</sup>名古屋大工) 〇田中 裕也<sup>1</sup>・本間 寛治<sup>2</sup>・金子 哲<sup>3</sup>・小本 祐貴<sup>4</sup>・大戸 達彦<sup>5</sup>・西野 智昭<sup>2</sup>・吉沢 道人<sup>1</sup>",
      "Elucidation of Electrical Conductance Behaviors of Platinum Complex Stack Junctions Using Machine Learning Methods",
      "(<sup>1</sup>Tokyo Tech, CLS, <sup>2</sup>Tokyo Tech, Sci., <sup>3</sup>Tokyo Tech, Mater. Chem. Tech., <sup>4</sup>Osaka U., <sup>5</sup>Nagoya U.) 〇Yuya TANAKA<sup>1</sup>, Kanji HOMMA<sup>2</sup>, Satoshi KANEKO<sup>3</sup>, Yuki KOMOTO<sup>4</sup>, Tatsuhiko OHTO<sup>5</sup>, Tomoaki NISHINO<sup>2</sup>, Michito YOSHIZAWA<sup>1</sup>"
    ],
    "lab": "3PF-14",
    "pdf": "pdf/3PF-14.pdf",
    "pre": "tn/3PF-14.jpg",
    "reg": "74164",
    "sea": "Pt",
    "ses": "3PF",
    "con": "3PF-14 機械学習法による白金錯体スタックジャンクションの電気伝導挙動解明 (<sup>1</sup>東工大化生研・<sup>2</sup>東工大理・<sup>3</sup>東工大物質理工・<sup>4</sup>阪大産研・<sup>5</sup>名古屋大工) 〇田中 裕也<sup>1</sup>・本間 寛治<sup>2</sup>・金子 哲<sup>3</sup>・小本 祐貴<sup>4</sup>・大戸 達彦<sup>5</sup>・西野 智昭<sup>2</sup>・吉沢 道人<sup>1</sup> Elucidation of Electrical Conductance Behaviors of Platinum Complex Stack Junctions Using Machine Learning Methods (<sup>1</sup>Tokyo Tech, CLS, <sup>2</sup>Tokyo Tech, Sci., <sup>3</sup>Tokyo Tech, Mater. Chem. Tech., <sup>4</sup>Osaka U., <sup>5</sup>Nagoya U.) 〇Yuya TANAKA<sup>1</sup>, Kanji HOMMA<sup>2</sup>, Satoshi KANEKO<sup>3</sup>, Yuki KOMOTO<sup>4</sup>, Tatsuhiko OHTO<sup>5</sup>, Tomoaki NISHINO<sup>2</sup>, Michito YOSHIZAWA<sup>1</sup> Pt"
  },
  {
    "inf": [
      "Pb-S-Br 2Dレイヤーを有する三次元半導体配位高分子の合成と水素発生触媒特性の評価",
      "(<sup>1</sup>関学大理) 〇西垣 綾音<sup>1</sup>・柴原 大樹<sup>1</sup>・秋吉 亮平<sup>1</sup>・田中 大輔<sup>1</sup>",
      "Synthesis of three-dimensional semiconductive coordination polymers with Pb-S-Br 2D layers and evaluation of their catalytic properties for hydrogen evolution",
      "(<sup>1</sup>Kwansei Gakuin University) 〇Ayane NISHIGAKI<sup>1</sup>, Hiroki SHIBAHARA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Daisuke TANAKA<sup>1</sup>"
    ],
    "lab": "3PF-15",
    "pdf": "pdf/3PF-15.pdf",
    "pre": "tn/3PF-15.jpg",
    "reg": "74069",
    "sea": "Pb",
    "ses": "3PF",
    "con": "3PF-15 Pb-S-Br 2Dレイヤーを有する三次元半導体配位高分子の合成と水素発生触媒特性の評価 (<sup>1</sup>関学大理) 〇西垣 綾音<sup>1</sup>・柴原 大樹<sup>1</sup>・秋吉 亮平<sup>1</sup>・田中 大輔<sup>1</sup> Synthesis of three-dimensional semiconductive coordination polymers with Pb-S-Br 2D layers and evaluation of their catalytic properties for hydrogen evolution (<sup>1</sup>Kwansei Gakuin University) 〇Ayane NISHIGAKI<sup>1</sup>, Hiroki SHIBAHARA<sup>1</sup>, Ryohei AKIYOSHI<sup>1</sup>, Daisuke TANAKA<sup>1</sup> Pb"
  },
  {
    "inf": [
      "カプセル状ポリオキソメタレートを活用した還元的なプロトン導入",
      "(<sup>1</sup>東大院総合文化) 〇岩野 司<sup>1</sup>・内田 さやか<sup>1</sup>",
      "Redox-Induced Proton Uptake Utilizing Polyoxometalate Capsules",
      "(<sup>1</sup>Grad. Sch. Arts and Sci., The Univ. of Tokyo) 〇Tsukasa Iwano<sup>1</sup>, Sayaka Uchida<sup>1</sup>"
    ],
    "lab": "3PF-16",
    "pdf": "pdf/3PF-16.pdf",
    "pre": "tn/3PF-16.jpg",
    "reg": "74169",
    "sea": "Mo, Fe",
    "ses": "3PF",
    "con": "3PF-16 カプセル状ポリオキソメタレートを活用した還元的なプロトン導入 (<sup>1</sup>東大院総合文化) 〇岩野 司<sup>1</sup>・内田 さやか<sup>1</sup> Redox-Induced Proton Uptake Utilizing Polyoxometalate Capsules (<sup>1</sup>Grad. Sch. Arts and Sci., The Univ. of Tokyo) 〇Tsukasa Iwano<sup>1</sup>, Sayaka Uchida<sup>1</sup> Mo, Fe"
  },
  {
    "inf": [
      "ナトリウムイオンと過塩素酸イオンの間の錯形成とその錯体の電気二重層における振る舞い          ",
      "(<sup>1</sup>クオルテック・<sup>2</sup>ORIST・<sup>3</sup>東工大ゼロカーボンエネルギー研・<sup>4</sup>東海大学工) 杉林 祐至<sup>1</sup>・〇冨安 博<sup>1</sup>・朴 潤烈<sup>1</sup>・新子 比呂志<sup>1 </sup>・斎藤 誠<sup>2 </sup>・鷹尾 康一朗<sup>3 </sup>・浅沼 徳子<sup>4 </sup>",
      "Complex formation between sodium and perchlorate ions, and its behavior in the electric double layer          ",
      "(<sup>1</sup>株式会社 クオルテック, <sup>2</sup>大阪産業技術研究所, <sup>3</sup>東工大ゼロカーボンエネルギー研, <sup>4</sup>東海大学工) Y. Sugibyashi<sup>1</sup>, 〇H. Tomiyasu<sup>1</sup>,  Y.Y. Park<sup>1</sup>, H. Atarashi<sup>1 </sup>, M. Saito<sup>2 </sup>, K. Takao<sup>3 </sup>, N. Asanuma<sup>4 </sup>"
    ],
    "lab": "3PF-17",
    "pdf": "pdf/3PF-17.pdf",
    "pre": "tn/3PF-17.jpg",
    "reg": "74216",
    "sea": "Na",
    "ses": "3PF",
    "con": "3PF-17 ナトリウムイオンと過塩素酸イオンの間の錯形成とその錯体の電気二重層における振る舞い           (<sup>1</sup>クオルテック・<sup>2</sup>ORIST・<sup>3</sup>東工大ゼロカーボンエネルギー研・<sup>4</sup>東海大学工) 杉林 祐至<sup>1</sup>・〇冨安 博<sup>1</sup>・朴 潤烈<sup>1</sup>・新子 比呂志<sup>1 </sup>・斎藤 誠<sup>2 </sup>・鷹尾 康一朗<sup>3 </sup>・浅沼 徳子<sup>4 </sup> Complex formation between sodium and perchlorate ions, and its behavior in the electric double layer           (<sup>1</sup>株式会社 クオルテック, <sup>2</sup>大阪産業技術研究所, <sup>3</sup>東工大ゼロカーボンエネルギー研, <sup>4</sup>東海大学工) Y. Sugibyashi<sup>1</sup>, 〇H. Tomiyasu<sup>1</sup>,  Y.Y. Park<sup>1</sup>, H. Atarashi<sup>1 </sup>, M. Saito<sup>2 </sup>, K. Takao<sup>3 </sup>, N. Asanuma<sup>4 </sup> Na"
  },
  {
    "inf": [
      "AFMによるMOFナノ細孔への高分子吸着挙動の直接観察",
      "(<sup>1</sup>東大院工) 〇勝谷 祐輔<sup>1</sup>・細野 暢彦<sup>1</sup>・植村 卓史<sup>1</sup>",
      "Direct Observation of Polymer Adsorption into MOF Nanopores by AFM",
      "(<sup>1</sup>Graduate School of Engineering, The University of Tokyo) 〇Yusuke KATSUTANI<sup>1</sup>, Nobuhiko HOSONO<sup>1</sup>, Takashi UEMURA<sup>1</sup>"
    ],
    "lab": "3PF-18",
    "pdf": "pdf/3PF-18.pdf",
    "pre": "tn/3PF-18.jpg",
    "reg": "74171",
    "sea": "Zn",
    "ses": "3PF",
    "con": "3PF-18 AFMによるMOFナノ細孔への高分子吸着挙動の直接観察 (<sup>1</sup>東大院工) 〇勝谷 祐輔<sup>1</sup>・細野 暢彦<sup>1</sup>・植村 卓史<sup>1</sup> Direct Observation of Polymer Adsorption into MOF Nanopores by AFM (<sup>1</sup>Graduate School of Engineering, The University of Tokyo) 〇Yusuke KATSUTANI<sup>1</sup>, Nobuhiko HOSONO<sup>1</sup>, Takashi UEMURA<sup>1</sup> Zn"
  },
  {
    "inf": [
      "ビフェニル誘導体ゲストとNDI-MOFからなる発光材料の熱応答性",
      "(<sup>1</sup>甲南大学大学院(FIRST)・<sup>2</sup>甲南大学) 〇山下 翔斗<sup>1</sup>・髙嶋 洋平<sup>2</sup>・鶴岡 孝章<sup>2</sup>・赤松 謙祐<sup>2</sup>",
      "Heat responsive properties of the luminescent NDI-based MOF with biphenyl derivatives as guests",
      "(<sup>1</sup>FIRST, Konan Univ., <sup>2</sup>Konan Univ.) 〇Shoto YAMASHITA<sup>1</sup>, Yohei TAKASHIMA<sup>2</sup>, Takaaki TSURUOKA<sup>2</sup>, Kensuke AKAMATSU<sup>2</sup>"
    ],
    "lab": "3PF-19",
    "pdf": "pdf/3PF-19.pdf",
    "pre": "tn/3PF-19.jpg",
    "reg": "74228",
    "sea": "Zn",
    "ses": "3PF",
    "con": "3PF-19 ビフェニル誘導体ゲストとNDI-MOFからなる発光材料の熱応答性 (<sup>1</sup>甲南大学大学院(FIRST)・<sup>2</sup>甲南大学) 〇山下 翔斗<sup>1</sup>・髙嶋 洋平<sup>2</sup>・鶴岡 孝章<sup>2</sup>・赤松 謙祐<sup>2</sup> Heat responsive properties of the luminescent NDI-based MOF with biphenyl derivatives as guests (<sup>1</sup>FIRST, Konan Univ., <sup>2</sup>Konan Univ.) 〇Shoto YAMASHITA<sup>1</sup>, Yohei TAKASHIMA<sup>2</sup>, Takaaki TSURUOKA<sup>2</sup>, Kensuke AKAMATSU<sup>2</sup> Zn"
  },
  {
    "inf": [
      "無加湿条件下で機能する強誘電イオン伝導体の開発",
      "(<sup>1</sup>九大院理) 〇木村 紗彩<sup></sup>・大谷 亮<sup></sup>・大場 正昭<sup></sup>",
      "Synthesis of anhydrous ferroelectric ion conductors",
      "(<sup>1</sup>Graduate School of Science, Kyushu Univ.) 〇Saaya Kimura<sup></sup>, Ryo Ohtani<sup></sup>, Masaaki Ohba<sup></sup>"
    ],
    "lab": "3PF-20",
    "pdf": "pdf/3PF-20.pdf",
    "pre": "tn/3PF-20.jpg",
    "reg": "74243",
    "sea": "Re",
    "ses": "3PF",
    "con": "3PF-20 無加湿条件下で機能する強誘電イオン伝導体の開発 (<sup>1</sup>九大院理) 〇木村 紗彩<sup></sup>・大谷 亮<sup></sup>・大場 正昭<sup></sup> Synthesis of anhydrous ferroelectric ion conductors (<sup>1</sup>Graduate School of Science, Kyushu Univ.) 〇Saaya Kimura<sup></sup>, Ryo Ohtani<sup></sup>, Masaaki Ohba<sup></sup> Re"
  },
  {
    "inf": [
      "金属有機ゲルへの四重鎖(G4)DNA吸着メカニズム解明",
      "(<sup>1</sup>甲南大学大学院・<sup>2</sup>甲南大学先端生命工学研究所 ・<sup>3</sup>甲南大学) 〇福岡 美海<sup>1</sup>・建石 寿枝<sup>2</sup>・高嶋 洋平<sup>3</sup>・赤松 謙祐<sup>3</sup>・鶴岡 孝章<sup>3</sup>",
      "Adsorption mechanism of DNA G-quadruplexes to metal-organic gels",
      "(<sup>1</sup>Graduate School of FIRST, Konan Univ., <sup>2</sup>FIBER, Konan Univ., <sup>3</sup>Konan Univ.) 〇Myu Fukuoka<sup>1</sup>, Hisae Tateishi-Karimata<sup>2</sup>, Yohei Takashima<sup>3</sup>, Kensuke Akamatsu<sup>3</sup>, Takaaki Tsuruoka<sup>3</sup>"
    ],
    "lab": "3PF-21",
    "pdf": "pdf/3PF-21.pdf",
    "pre": "tn/3PF-21.jpg",
    "reg": "74238",
    "sea": "Zr",
    "ses": "3PF",
    "con": "3PF-21 金属有機ゲルへの四重鎖(G4)DNA吸着メカニズム解明 (<sup>1</sup>甲南大学大学院・<sup>2</sup>甲南大学先端生命工学研究所 ・<sup>3</sup>甲南大学) 〇福岡 美海<sup>1</sup>・建石 寿枝<sup>2</sup>・高嶋 洋平<sup>3</sup>・赤松 謙祐<sup>3</sup>・鶴岡 孝章<sup>3</sup> Adsorption mechanism of DNA G-quadruplexes to metal-organic gels (<sup>1</sup>Graduate School of FIRST, Konan Univ., <sup>2</sup>FIBER, Konan Univ., <sup>3</sup>Konan Univ.) 〇Myu Fukuoka<sup>1</sup>, Hisae Tateishi-Karimata<sup>2</sup>, Yohei Takashima<sup>3</sup>, Kensuke Akamatsu<sup>3</sup>, Takaaki Tsuruoka<sup>3</sup> Zr"
  },
  {
    "inf": [
      "GaSb基板のエッチング液内挙動",
      "(<sup>1</sup>富士通(株) 富士通研究所) 〇大津 博義<sup>1</sup>・松宮 康夫<sup>1</sup>・角田 浩司<sup>1</sup>",
      "Behaviors of GaSb substrates in Etchants",
      "(<sup>1</sup>Fujitsu Research, Fujitsu Limited) 〇Hiroyoshi Ohtsu<sup>1</sup>, Yasuo Matsumiya<sup>1</sup>, Koji Tsunoda<sup>1</sup>"
    ],
    "lab": "3PF-22",
    "pdf": "pdf/3PF-22.pdf",
    "pre": "tn/3PF-22.jpg",
    "reg": "74244",
    "sea": "Sb",
    "ses": "3PF",
    "con": "3PF-22 GaSb基板のエッチング液内挙動 (<sup>1</sup>富士通(株) 富士通研究所) 〇大津 博義<sup>1</sup>・松宮 康夫<sup>1</sup>・角田 浩司<sup>1</sup> Behaviors of GaSb substrates in Etchants (<sup>1</sup>Fujitsu Research, Fujitsu Limited) 〇Hiroyoshi Ohtsu<sup>1</sup>, Yasuo Matsumiya<sup>1</sup>, Koji Tsunoda<sup>1</sup> Sb"
  },
  {
    "inf": [
      "アルカリ金属イオンの拡散/水和状態に応答するプルシアンブルーナノ粒子",
      "(<sup>1</sup>山形大院理工) 〇森 史宇<sup>1</sup>・石﨑 学<sup>1</sup>・栗原 正人<sup>1</sup>",
      "Prussian-Blue Nanoparticles Responding to Diffusion/Hydration States of Alkali-Metal Ions",
      "(<sup>1</sup>Yamagata Univ.) 〇Fumitaka MORI<sup>1</sup>, Manabu ISHIZAKI<sup>1</sup>, Masato KURIHARA<sup>1</sup>"
    ],
    "lab": "3PF-23",
    "pdf": "pdf/3PF-23.pdf",
    "pre": "tn/3PF-23.jpg",
    "reg": "74248",
    "sea": "Fe",
    "ses": "3PF",
    "con": "3PF-23 アルカリ金属イオンの拡散/水和状態に応答するプルシアンブルーナノ粒子 (<sup>1</sup>山形大院理工) 〇森 史宇<sup>1</sup>・石﨑 学<sup>1</sup>・栗原 正人<sup>1</sup> Prussian-Blue Nanoparticles Responding to Diffusion/Hydration States of Alkali-Metal Ions (<sup>1</sup>Yamagata Univ.) 〇Fumitaka MORI<sup>1</sup>, Manabu ISHIZAKI<sup>1</sup>, Masato KURIHARA<sup>1</sup> Fe"
  },
  {
    "inf": [
      "銅とエチレンジアミンを用いた二酸化炭素濃淡電池",
      "(<sup>1</sup>東大理) 〇柿澤 彩花<sup>1</sup>・若山 悠有佑<sup>1</sup>・周 泓遥<sup>1</sup>・山田 鉄兵<sup>1</sup>",
      "Stimuli-responsible redox reaction of copper cation  and ethylenediamine",
      "(<sup>1</sup>Department of Chemistry,School of Science, the University of Tokyo) 〇Ayaka Kakizawa<sup>1</sup>, Wakayama Yusuke<sup>1</sup>, Zhou Hongyao<sup>1</sup>, Teppei Yamada<sup>1</sup>"
    ],
    "lab": "3PF-24",
    "pdf": "pdf/3PF-24.pdf",
    "pre": "tn/3PF-24.jpg",
    "reg": "74254",
    "sea": "Cu",
    "ses": "3PF",
    "con": "3PF-24 銅とエチレンジアミンを用いた二酸化炭素濃淡電池 (<sup>1</sup>東大理) 〇柿澤 彩花<sup>1</sup>・若山 悠有佑<sup>1</sup>・周 泓遥<sup>1</sup>・山田 鉄兵<sup>1</sup> Stimuli-responsible redox reaction of copper cation  and ethylenediamine (<sup>1</sup>Department of Chemistry,School of Science, the University of Tokyo) 〇Ayaka Kakizawa<sup>1</sup>, Wakayama Yusuke<sup>1</sup>, Zhou Hongyao<sup>1</sup>, Teppei Yamada<sup>1</sup> Cu"
  },
  {
    "inf": [
      "新規水溶性二核化配位子の合成と各種光触媒反応への応用",
      "(<sup>1</sup>九大理化) 〇末吉 史佳<sup>1</sup>・山内 幸正<sup>1</sup>・酒井 健<sup>1</sup>",
      "Synthesis of New Water-soluble Dinucleating Ligands and Their Applications in Photocatalytic Reactions",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Fumika SUEYOSHI<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup>"
    ],
    "lab": "3PF-25",
    "pdf": "pdf/3PF-25.pdf",
    "pre": "tn/3PF-25.jpg",
    "reg": "74269",
    "sea": "Pt",
    "ses": "3PF",
    "con": "3PF-25 新規水溶性二核化配位子の合成と各種光触媒反応への応用 (<sup>1</sup>九大理化) 〇末吉 史佳<sup>1</sup>・山内 幸正<sup>1</sup>・酒井 健<sup>1</sup> Synthesis of New Water-soluble Dinucleating Ligands and Their Applications in Photocatalytic Reactions (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Fumika SUEYOSHI<sup>1</sup>, Kosei YAMAUCHI<sup>1</sup>, Ken SAKAI<sup>1</sup> Pt"
  },
  {
    "inf": [
      "金属ポルフィリンを用いた三元系有機薄膜太陽電池の作製および特性評価 ",
      "(<sup>1</sup>近大理工) 〇森田 秀穂<sup>1</sup>・西山 智貴<sup>1</sup>・田中 仙君<sup>1</sup>・鬼頭 宏任<sup>1</sup>・大久保 貴志<sup>1</sup>",
      "Fabrication of Ternary Blend Organic Thin-Film Solar Cells Including Metal Porphyrins and Their Photoconversion Characteristics",
      "(<sup>1</sup>Kindai Univ.) 〇Shuho MORITA<sup>1</sup>, Tomoki NISHIYAMA<sup>1</sup>, Senku TANAKA<sup>1</sup>, Hirotaka KITOH-NISHIOKA<sup>1</sup>, Takashi Okubo<sup>1</sup>"
    ],
    "lab": "3PF-26",
    "pdf": "pdf/3PF-26.pdf",
    "pre": "tn/3PF-26.jpg",
    "reg": "74363",
    "sea": "Zn, Pd, Pt",
    "ses": "3PF",
    "con": "3PF-26 金属ポルフィリンを用いた三元系有機薄膜太陽電池の作製および特性評価  (<sup>1</sup>近大理工) 〇森田 秀穂<sup>1</sup>・西山 智貴<sup>1</sup>・田中 仙君<sup>1</sup>・鬼頭 宏任<sup>1</sup>・大久保 貴志<sup>1</sup> Fabrication of Ternary Blend Organic Thin-Film Solar Cells Including Metal Porphyrins and Their Photoconversion Characteristics (<sup>1</sup>Kindai Univ.) 〇Shuho MORITA<sup>1</sup>, Tomoki NISHIYAMA<sup>1</sup>, Senku TANAKA<sup>1</sup>, Hirotaka KITOH-NISHIOKA<sup>1</sup>, Takashi Okubo<sup>1</sup> Zn, Pd, Pt"
  },
  {
    "inf": [
      "ITO電極上のAl含有メソポーラスシリカ薄膜へのRu錯体の固定化と光・電気化学特性",
      "(<sup>1</sup>神奈川大工) 〇中野 成美<sup>1</sup>・原田 駿平<sup>1</sup>・山田 綾乃<sup>1</sup>・渡邊 翔太<sup>1</sup>・岡村 将也<sup>1</sup>・引地 史郎<sup>1</sup>",
      "Photo and electrochemical properties of Ru complexes immobilized on Al-containing mesoporous silica thin films on ITO electrodes.",
      "(<sup>1</sup>Kanagawa Univ.) 〇Narumi NAKANO<sup>1</sup>, Shunpei HARADA<sup>1</sup>, Ayano YAMADA<sup>1</sup>, Shota WATANABE<sup>1</sup>, Masaya OKAMURA<sup>1</sup>, Shiro HIKICHI<sup>1</sup>"
    ],
    "lab": "3PF-27",
    "pdf": "pdf/3PF-27.pdf",
    "pre": "tn/3PF-27.jpg",
    "reg": "74367",
    "sea": "Ru",
    "ses": "3PF",
    "con": "3PF-27 ITO電極上のAl含有メソポーラスシリカ薄膜へのRu錯体の固定化と光・電気化学特性 (<sup>1</sup>神奈川大工) 〇中野 成美<sup>1</sup>・原田 駿平<sup>1</sup>・山田 綾乃<sup>1</sup>・渡邊 翔太<sup>1</sup>・岡村 将也<sup>1</sup>・引地 史郎<sup>1</sup> Photo and electrochemical properties of Ru complexes immobilized on Al-containing mesoporous silica thin films on ITO electrodes. (<sup>1</sup>Kanagawa Univ.) 〇Narumi NAKANO<sup>1</sup>, Shunpei HARADA<sup>1</sup>, Ayano YAMADA<sup>1</sup>, Shota WATANABE<sup>1</sup>, Masaya OKAMURA<sup>1</sup>, Shiro HIKICHI<sup>1</sup> Ru"
  },
  {
    "inf": [
      "金属有機構造体を正極に用いた全固体Li電池の作製と評価",
      "(<sup>1</sup>東大・<sup>2</sup>東工大・<sup>3</sup>静岡大) 〇彌永 和輝<sup>1</sup>・中山 亮<sup>1</sup>・Chon Seoungmin<sup>2</sup>・鄭 瑞杰<sup>2</sup>・和泉 智也<sup>1</sup>・東根 宗純<sup>1</sup>・小林 成<sup>1</sup>・西尾 和記<sup>1</sup>・清水 亮太<sup>1</sup>・守谷 誠<sup>3</sup>・一杉 太郎<sup>1</sup>",
      "Fabrication and Evaluation of All-Solid-State Lithium Batteries Using Metal-Organic Frameworks as the Cathode",
      "(<sup>1</sup>UToyko, <sup>2</sup>Tokyo Tech, <sup>3</sup>Shizuoka Univ.) 〇Kazuki Iyanaga<sup>1</sup>, Ryo Nakayama<sup>1</sup>, Chon Seoungmin<sup>2</sup>, Ruijie Zheng<sup>2</sup>, Tomoya Izumi<sup>1</sup>, Sojun Higashine<sup>1</sup>, Shigeru Kobayashi<sup>1</sup>, Kazunori Nishio<sup>1</sup>, Ryota Shimizu<sup>1</sup>, Makoto Moriya<sup>3</sup>, Taro Hitosugi<sup>1</sup>"
    ],
    "lab": "3PF-28",
    "pdf": "pdf/3PF-28.pdf",
    "pre": "tn/3PF-28.jpg",
    "reg": "74399",
    "sea": "Cu, Li",
    "ses": "3PF",
    "con": "3PF-28 金属有機構造体を正極に用いた全固体Li電池の作製と評価 (<sup>1</sup>東大・<sup>2</sup>東工大・<sup>3</sup>静岡大) 〇彌永 和輝<sup>1</sup>・中山 亮<sup>1</sup>・Chon Seoungmin<sup>2</sup>・鄭 瑞杰<sup>2</sup>・和泉 智也<sup>1</sup>・東根 宗純<sup>1</sup>・小林 成<sup>1</sup>・西尾 和記<sup>1</sup>・清水 亮太<sup>1</sup>・守谷 誠<sup>3</sup>・一杉 太郎<sup>1</sup> Fabrication and Evaluation of All-Solid-State Lithium Batteries Using Metal-Organic Frameworks as the Cathode (<sup>1</sup>UToyko, <sup>2</sup>Tokyo Tech, <sup>3</sup>Shizuoka Univ.) 〇Kazuki Iyanaga<sup>1</sup>, Ryo Nakayama<sup>1</sup>, Chon Seoungmin<sup>2</sup>, Ruijie Zheng<sup>2</sup>, Tomoya Izumi<sup>1</sup>, Sojun Higashine<sup>1</sup>, Shigeru Kobayashi<sup>1</sup>, Kazunori Nishio<sup>1</sup>, Ryota Shimizu<sup>1</sup>, Makoto Moriya<sup>3</sup>, Taro Hitosugi<sup>1</sup> Cu, Li"
  },
  {
    "inf": [
      "MOFと金属ナノ粒子からなるコア-サテライト複合体の合成と触媒性能評価",
      "(<sup>1</sup>甲南大学大学院・<sup>2</sup>甲南大学) 〇村上 由依<sup>1</sup>・髙嶋 洋平<sup>2</sup>・鶴岡 孝章<sup>2</sup>・赤松 謙祐<sup>2</sup>",
      "Syntheses and catalytic properties of core-satellite composite constructed from a metal-organic framework and metal nanoparticles",
      "(<sup>1</sup>Graduate School of FIRST, Konan Univ., <sup>2</sup>Konan Univ.) 〇Yui MURAKAMI<sup>1</sup>, Yohei TAKASHIMA<sup>2</sup>, Takaaki TSURUOKA<sup>2</sup>, Kensuke AKAMATSU<sup>2</sup>"
    ],
    "lab": "3PF-29",
    "pdf": "pdf/3PF-29.pdf",
    "pre": "tn/3PF-29.jpg",
    "reg": "74414",
    "sea": "Cr, Pd, Ag",
    "ses": "3PF",
    "con": "3PF-29 MOFと金属ナノ粒子からなるコア-サテライト複合体の合成と触媒性能評価 (<sup>1</sup>甲南大学大学院・<sup>2</sup>甲南大学) 〇村上 由依<sup>1</sup>・髙嶋 洋平<sup>2</sup>・鶴岡 孝章<sup>2</sup>・赤松 謙祐<sup>2</sup> Syntheses and catalytic properties of core-satellite composite constructed from a metal-organic framework and metal nanoparticles (<sup>1</sup>Graduate School of FIRST, Konan Univ., <sup>2</sup>Konan Univ.) 〇Yui MURAKAMI<sup>1</sup>, Yohei TAKASHIMA<sup>2</sup>, Takaaki TSURUOKA<sup>2</sup>, Kensuke AKAMATSU<sup>2</sup> Cr, Pd, Ag"
  },
  {
    "inf": [
      "金属有機構造体内における「ラジカルスピン空間」の創生と応用",
      "(<sup>1</sup>東工大理) 〇Alexander Kashlakov<sup>1</sup>・鈴木啓朗<sup>1</sup>・Pavel M. Usov<sup>1</sup>・和田雄貴<sup>1</sup>・河野正規<sup>1</sup>",
      "Synthesis and application of a “radical spin space\" inside the pores of Metal-Organic Frameworks (MOFs)",
      "(<sup>1</sup>Tokyo Institute of Technology) 〇Alexander Kashlakov<sup>1</sup>, Hiroaki Suzuki<sup>1</sup>, Pavel M. Usov<sup>1</sup>, Yuki Wada<sup>1</sup>, Masaki Kawano<sup>1</sup>"
    ],
    "lab": "3PF-30",
    "pdf": "pdf/3PF-30.pdf",
    "pre": "tn/3PF-30.jpg",
    "reg": "74415",
    "sea": "In, Co, Ni",
    "ses": "3PF",
    "con": "3PF-30 金属有機構造体内における「ラジカルスピン空間」の創生と応用 (<sup>1</sup>東工大理) 〇Alexander Kashlakov<sup>1</sup>・鈴木啓朗<sup>1</sup>・Pavel M. Usov<sup>1</sup>・和田雄貴<sup>1</sup>・河野正規<sup>1</sup> Synthesis and application of a “radical spin space\" inside the pores of Metal-Organic Frameworks (MOFs) (<sup>1</sup>Tokyo Institute of Technology) 〇Alexander Kashlakov<sup>1</sup>, Hiroaki Suzuki<sup>1</sup>, Pavel M. Usov<sup>1</sup>, Yuki Wada<sup>1</sup>, Masaki Kawano<sup>1</sup> In, Co, Ni"
  },
  {
    "inf": [
      "NHC銅(I)錯体を用いた発光性結晶分子ギアの連動運動の制御",
      "(<sup>1</sup>北大院総化・<sup>2</sup>北大WPI-ICReDD) 〇安藤 廉平<sup>1</sup>・富田 龍之介<sup>1</sup>・陳 旻究<sup>2</sup>",
      "Tuning the molecular correlated motion of emissive NHC Cu(I) complexes in the crystal",
      "(<sup>1</sup>北海道大学大学院総合化学院, <sup>2</sup>北海道大学化学反応創成研究拠点) 〇Rempei ANDO<sup>1</sup>, Ryunosuke TOMITA<sup>1</sup>, Mingoo JIN<sup>2</sup>"
    ],
    "lab": "3PF-31",
    "pdf": "pdf/3PF-31.pdf",
    "pre": "tn/3PF-31.jpg",
    "reg": "74416",
    "sea": "Cu",
    "ses": "3PF",
    "con": "3PF-31 NHC銅(I)錯体を用いた発光性結晶分子ギアの連動運動の制御 (<sup>1</sup>北大院総化・<sup>2</sup>北大WPI-ICReDD) 〇安藤 廉平<sup>1</sup>・富田 龍之介<sup>1</sup>・陳 旻究<sup>2</sup> Tuning the molecular correlated motion of emissive NHC Cu(I) complexes in the crystal (<sup>1</sup>北海道大学大学院総合化学院, <sup>2</sup>北海道大学化学反応創成研究拠点) 〇Rempei ANDO<sup>1</sup>, Ryunosuke TOMITA<sup>1</sup>, Mingoo JIN<sup>2</sup> Cu"
  },
  {
    "inf": [
      "金属錯体を層間に有するホウ素二次元物質の合成",
      "(<sup>1</sup>阪大院工) 〇川口 純平<sup>1</sup>・Nicole Sallier de la Tour<sup>1</sup>・神戸徹也<sup>1</sup>・正岡重行<sup>1</sup>",
      "Synthesis of boron two-dimensional materials with metal complexes between the layers",
      "(<sup>1</sup>Graduate School of Engineering, Osaka University.) 〇Junpei KAWAGUCHI<sup>1</sup>, Nicole Sallier de la Tour<sup>1</sup>, Tetsuya KAMBE <sup>1</sup>, Shigeyuki MASAOKA<sup>1</sup>"
    ],
    "lab": "3PF-32",
    "pdf": "pdf/3PF-32.pdf",
    "pre": "tn/3PF-32.jpg",
    "reg": "74436",
    "sea": "K,B",
    "ses": "3PF",
    "con": "3PF-32 金属錯体を層間に有するホウ素二次元物質の合成 (<sup>1</sup>阪大院工) 〇川口 純平<sup>1</sup>・Nicole Sallier de la Tour<sup>1</sup>・神戸徹也<sup>1</sup>・正岡重行<sup>1</sup> Synthesis of boron two-dimensional materials with metal complexes between the layers (<sup>1</sup>Graduate School of Engineering, Osaka University.) 〇Junpei KAWAGUCHI<sup>1</sup>, Nicole Sallier de la Tour<sup>1</sup>, Tetsuya KAMBE <sup>1</sup>, Shigeyuki MASAOKA<sup>1</sup> K,B"
  },
  {
    "inf": [
      "ジピロメテン骨格を利用した新規イリジウム(III)錯体の光物性および光反応調査",
      "(<sup>1</sup>長崎大院総合生産科学・<sup>2</sup>長崎大院工) 〇田中 颯時<sup>1</sup>・高木 皇遥<sup>2</sup>・作田 絵里<sup>1,2</sup>・尾本 賢一郎<sup>1,2</sup>・有川 康弘<sup>1,2</sup>・馬越 啓介<sup>1,2</sup>",
      "Photophysical Properties and Photoreaction Investigation of Novel Iridium(III) Complexes Utilizing Dipyrromethene Structure",
      "(<sup>1</sup>Graduate School of Integrated Science and Technology, Nagasaki University, <sup>2</sup>Graduate School of Engineering, Nagasaki University) 〇Soshi TANAKA<sup>1</sup>, Koyo TAKAKI<sup>2</sup>, Eri SAKUDA<sup>1,2</sup>, Kenichiro OMOTO<sup>1,2</sup>, Yasuhiro ARIKAWA<sup>1,2</sup>, Keisuke UMAKOSHI<sup>1,2</sup>"
    ],
    "lab": "3PF-33",
    "pdf": "pdf/3PF-33.pdf",
    "pre": "tn/3PF-33.jpg",
    "reg": "74474",
    "sea": "Ir",
    "ses": "3PF",
    "con": "3PF-33 ジピロメテン骨格を利用した新規イリジウム(III)錯体の光物性および光反応調査 (<sup>1</sup>長崎大院総合生産科学・<sup>2</sup>長崎大院工) 〇田中 颯時<sup>1</sup>・高木 皇遥<sup>2</sup>・作田 絵里<sup>1,2</sup>・尾本 賢一郎<sup>1,2</sup>・有川 康弘<sup>1,2</sup>・馬越 啓介<sup>1,2</sup> Photophysical Properties and Photoreaction Investigation of Novel Iridium(III) Complexes Utilizing Dipyrromethene Structure (<sup>1</sup>Graduate School of Integrated Science and Technology, Nagasaki University, <sup>2</sup>Graduate School of Engineering, Nagasaki University) 〇Soshi TANAKA<sup>1</sup>, Koyo TAKAKI<sup>2</sup>, Eri SAKUDA<sup>1,2</sup>, Kenichiro OMOTO<sup>1,2</sup>, Yasuhiro ARIKAWA<sup>1,2</sup>, Keisuke UMAKOSHI<sup>1,2</sup> Ir"
  },
  {
    "inf": [
      "鉄(Ⅲ)錯体のスピン緩和特性の評価",
      "(<sup>1</sup>熊大院自然) 〇三宅 貫太<sup>1</sup>・張 中岳<sup>1</sup>・関根 良博<sup>1</sup>・速水 真也<sup>1</sup>",
      "Evaluation of spin relaxation properties of iron(Ⅲ) complexes",
      "(<sup>1</sup>Kumamoto Univ.) 〇Kanta MIYAKE<sup>1</sup>, Zhongyue ZHANG<sup>1</sup>, Yoshihiro SEKINE<sup>1</sup>, Shinya HAYAMI<sup>1</sup>"
    ],
    "lab": "3PF-34",
    "pdf": "pdf/3PF-34.pdf",
    "pre": "tn/3PF-34.jpg",
    "reg": "74491",
    "sea": "Fe",
    "ses": "3PF",
    "con": "3PF-34 鉄(Ⅲ)錯体のスピン緩和特性の評価 (<sup>1</sup>熊大院自然) 〇三宅 貫太<sup>1</sup>・張 中岳<sup>1</sup>・関根 良博<sup>1</sup>・速水 真也<sup>1</sup> Evaluation of spin relaxation properties of iron(Ⅲ) complexes (<sup>1</sup>Kumamoto Univ.) 〇Kanta MIYAKE<sup>1</sup>, Zhongyue ZHANG<sup>1</sup>, Yoshihiro SEKINE<sup>1</sup>, Shinya HAYAMI<sup>1</sup> Fe"
  },
  {
    "inf": [
      "ピリジルアンカーを導入した新規コバルトポリオキソメタレート酸素生成触媒の合成と分子性TiO<sub>2</sub>フォトアノードへの応用",
      "(<sup>1</sup>九大理化) 〇冨田 侑樹<sup>1</sup>・酒井 健<sup>1</sup>・小澤 弘宜<sup>1</sup>",
      "Synthesis of a novel cobalt polyoxometalate having a pyridyl anchor and its application to a molecular-based TiO<sub>2</sub> photoanode",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Yuki TOMITA<sup>1</sup>, Ken SAKAI<sup>1</sup>, Hironobu OZAWA<sup>1</sup>"
    ],
    "lab": "3PF-35",
    "pdf": "pdf/3PF-35.pdf",
    "pre": "tn/3PF-35.jpg",
    "reg": "74507",
    "sea": "Co, Mo, Ru",
    "ses": "3PF",
    "con": "3PF-35 ピリジルアンカーを導入した新規コバルトポリオキソメタレート酸素生成触媒の合成と分子性TiO<sub>2</sub>フォトアノードへの応用 (<sup>1</sup>九大理化) 〇冨田 侑樹<sup>1</sup>・酒井 健<sup>1</sup>・小澤 弘宜<sup>1</sup> Synthesis of a novel cobalt polyoxometalate having a pyridyl anchor and its application to a molecular-based TiO<sub>2</sub> photoanode (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Yuki TOMITA<sup>1</sup>, Ken SAKAI<sup>1</sup>, Hironobu OZAWA<sup>1</sup> Co, Mo, Ru"
  },
  {
    "inf": [
      "_N-_ヘテロ環状カルベン配位子を導入した金アセチリド錯体の凝集相における発光挙動",
      "(<sup>1</sup>立命館大生命) 〇森本 陽菜<sup>1</sup>・アルシ ラワット<sup>1</sup>・松本 浩輔<sup>1</sup>・堤 治<sup>1</sup>",
      "Emission Behavior in Condensed Phases of Gold Acetylide Complexes with _N-_ Heterocyclic Carbene Ligands",
      "(<sup>1</sup>Ritsumeikan Univ.) 〇Haruna MORIMOTO<sup>1</sup>, Arushi RAWAT<sup>1</sup>, Kohsuke MATSUMOTO<sup>1</sup>, Osamu TSUTSUMI<sup>1</sup>"
    ],
    "lab": "3PF-36",
    "pdf": "pdf/3PF-36.pdf",
    "pre": "tn/3PF-36.jpg",
    "reg": "74513",
    "sea": "Au",
    "ses": "3PF",
    "con": "3PF-36 _N-_ヘテロ環状カルベン配位子を導入した金アセチリド錯体の凝集相における発光挙動 (<sup>1</sup>立命館大生命) 〇森本 陽菜<sup>1</sup>・アルシ ラワット<sup>1</sup>・松本 浩輔<sup>1</sup>・堤 治<sup>1</sup> Emission Behavior in Condensed Phases of Gold Acetylide Complexes with _N-_ Heterocyclic Carbene Ligands (<sup>1</sup>Ritsumeikan Univ.) 〇Haruna MORIMOTO<sup>1</sup>, Arushi RAWAT<sup>1</sup>, Kohsuke MATSUMOTO<sup>1</sup>, Osamu TSUTSUMI<sup>1</sup> Au"
  },
  {
    "inf": [
      "一次元チャネル構造を形成する水素結合型ヘキサゴナル六量体結晶におけるプロトン伝導特性",
      "(<sup>1</sup>東理大院理) 〇滝本 直樹<sup>1</sup>・小林 文也<sup>1</sup>・田所 誠<sup>1</sup>",
      "Proton conduction behavior in hydrogen-bonded hexameric crystal forming 1D channel structure",
      "(<sup>1</sup>Tokyo Univ. of Sci.) 〇Naoki TAKIMOTO<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup>"
    ],
    "lab": "3PF-37",
    "pdf": "pdf/3PF-37.pdf",
    "pre": "tn/3PF-37.jpg",
    "reg": "74525",
    "sea": "Co",
    "ses": "3PF",
    "con": "3PF-37 一次元チャネル構造を形成する水素結合型ヘキサゴナル六量体結晶におけるプロトン伝導特性 (<sup>1</sup>東理大院理) 〇滝本 直樹<sup>1</sup>・小林 文也<sup>1</sup>・田所 誠<sup>1</sup> Proton conduction behavior in hydrogen-bonded hexameric crystal forming 1D channel structure (<sup>1</sup>Tokyo Univ. of Sci.) 〇Naoki TAKIMOTO<sup>1</sup>, Fumiya KOBAYASHI<sup>1</sup>, Makoto TADOKORO<sup>1</sup> Co"
  },
  {
    "inf": [
      "白金ナノクラスター修飾電極の作製と水素生成触媒特性",
      "(<sup>1</sup>九大理化) 〇池田 達紀<sup>1</sup>・山内 幸正<sup>1</sup>・小澤 弘宜<sup>1</sup>・酒井 健<sup>1</sup>",
      "Preparation of the Electrodes Modified with Platinum Nanoclusters and their Catalytic Properties in Hydrogen Evolution Reaction",
      "(<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Tatsunori Ikeda<sup>1</sup>, Kosei Yamauchi<sup>1</sup>, Hironobu Ozawa<sup>1</sup>, Ken Sakai<sup>1</sup>"
    ],
    "lab": "3PF-38",
    "pdf": "pdf/3PF-38.pdf",
    "pre": "tn/3PF-38.jpg",
    "reg": "74545",
    "sea": "Pt",
    "ses": "3PF",
    "con": "3PF-38 白金ナノクラスター修飾電極の作製と水素生成触媒特性 (<sup>1</sup>九大理化) 〇池田 達紀<sup>1</sup>・山内 幸正<sup>1</sup>・小澤 弘宜<sup>1</sup>・酒井 健<sup>1</sup> Preparation of the Electrodes Modified with Platinum Nanoclusters and their Catalytic Properties in Hydrogen Evolution Reaction (<sup>1</sup>Dept. Chem. Kyushu Univ.) 〇Tatsunori Ikeda<sup>1</sup>, Kosei Yamauchi<sup>1</sup>, Hironobu Ozawa<sup>1</sup>, Ken Sakai<sup>1</sup> Pt"
  },
  {
    "inf": [
      "ナノポーラス銅錯体の結晶-アモルファス転移による熱伝導特性の変化          ",
      "(<sup>1</sup>名大院工) 〇吉村 元希<sup>1</sup>・Jenny PIRILLO<sup>1</sup>・Liyuan QU<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1</sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup>",
      "Change in Thermal Conducting Properties of a Nanoporous Copper Complex by Crystal-Amorphous Transition          ",
      "(<sup>1</sup>Nagoya Univ.) 〇Motoki YOSHIMURA<sup>1</sup>, Jenny PIRILLO<sup>1</sup>, Liyuan QU<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1</sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup>"
    ],
    "lab": "3PF-39",
    "pdf": "pdf/3PF-39.pdf",
    "pre": "tn/3PF-39.jpg",
    "reg": "74586",
    "sea": "Cu",
    "ses": "3PF",
    "con": "3PF-39 ナノポーラス銅錯体の結晶-アモルファス転移による熱伝導特性の変化           (<sup>1</sup>名大院工) 〇吉村 元希<sup>1</sup>・Jenny PIRILLO<sup>1</sup>・Liyuan QU<sup>1</sup>・日下 心平<sup>1</sup>・土方 優<sup>1</sup>・井口 弘章<sup>1</sup>・松田 亮太郎<sup>1</sup> Change in Thermal Conducting Properties of a Nanoporous Copper Complex by Crystal-Amorphous Transition           (<sup>1</sup>Nagoya Univ.) 〇Motoki YOSHIMURA<sup>1</sup>, Jenny PIRILLO<sup>1</sup>, Liyuan QU<sup>1</sup>, Shinpei KUSAKA<sup>1</sup>, Yuh HIJIKATA<sup>1</sup>, Hiroaki IGUCHI<sup>1</sup>, Ryotaro MATSUDA<sup>1</sup> Cu"
  },
  {
    "inf": [
      "アントラセンで架橋した二核レニウム錯体触媒による光化学的二酸化炭素還元反応",
      "(<sup>1</sup>立教大院理・<sup>2</sup>阪公大人工光合成セ) 〇有働 まゆみ<sup>1</sup>・櫻井 翔太<sup>1</sup>・上原 拓弥<sup>1</sup>・中薗 孝志<sup>2</sup>・和田 亨<sup>1</sup>",
      "Photochemical CO<sub>2</sub> Reduction Catalyzed by a Dinuclear Rhenium Complex Bridged by Anthracene",
      "(<sup>1</sup>Rikkyo Univ., <sup>2</sup>Osaka Metropolitan Univ.) 〇Mayumi UDO<sup>1</sup>, Shota SAKURAI<sup>1</sup>, Takumi UEHARA<sup>1</sup>, Takashi NAKAZONO<sup>2</sup>, Tohru WADA<sup>1</sup>"
    ],
    "lab": "3PF-40",
    "pdf": "pdf/3PF-40.pdf",
    "pre": "tn/3PF-40.jpg",
    "reg": "74593",
    "sea": "Re",
    "ses": "3PF",
    "con": "3PF-40 アントラセンで架橋した二核レニウム錯体触媒による光化学的二酸化炭素還元反応 (<sup>1</sup>立教大院理・<sup>2</sup>阪公大人工光合成セ) 〇有働 まゆみ<sup>1</sup>・櫻井 翔太<sup>1</sup>・上原 拓弥<sup>1</sup>・中薗 孝志<sup>2</sup>・和田 亨<sup>1</sup> Photochemical CO<sub>2</sub> Reduction Catalyzed by a Dinuclear Rhenium Complex Bridged by Anthracene (<sup>1</sup>Rikkyo Univ., <sup>2</sup>Osaka Metropolitan Univ.) 〇Mayumi UDO<sup>1</sup>, Shota SAKURAI<sup>1</sup>, Takumi UEHARA<sup>1</sup>, Takashi NAKAZONO<sup>2</sup>, Tohru WADA<sup>1</sup> Re"
  },
  {
    "lab": "S1-01",
    "tit": "Metal Sandwich Complexes and Beyond: Cyclic Unsaturated Hydrocarbon Ligands as Face-Capping Ligands",
    "spe": "Tetsuro Murahashi ",
    "loc": "Tokyo Institute of Technology ",
    "inf": [
      "Metal Sandwich Complexes and Beyond: Cyclic Unsaturated Hydrocarbon Ligands as Face-Capping Ligands",
      "(Tokyo Institute of Technology ) Tetsuro Murahashi "
    ],
    "sea": "",
    "pdf": "pdf/S1-01.pdf",
    "pre": "tn/S1-01.jpg",
    "con": "S1-01 Metal Sandwich Complexes and Beyond: Cyclic Unsaturated Hydrocarbon Ligands as Face-Capping Ligands (Tokyo Institute of Technology ) Tetsuro Murahashi  "
  },
  {
    "lab": "S1-02",
    "tit": "20-electron Ferrocene Derivatives: Synthesis, Characterization, and Reactivity ",
    "spe": "Satoshi Takebayashi ",
    "loc": "Okinawa Institute of Science and Technology ",
    "inf": [
      "20-electron Ferrocene Derivatives: Synthesis, Characterization, and Reactivity ",
      "(Okinawa Institute of Science and Technology ) Satoshi Takebayashi "
    ],
    "sea": "",
    "pdf": "pdf/S1-02.pdf",
    "pre": "tn/S1-02.jpg",
    "con": "S1-02 20-electron Ferrocene Derivatives: Synthesis, Characterization, and Reactivity  (Okinawa Institute of Science and Technology ) Satoshi Takebayashi  "
  },
  {
    "lab": "S1-03",
    "tit": "Catalytic C(sp3)–H Functionalization Using Group 9 Metal Catalysts with Cp-type Ligands ",
    "spe": "Tatsuhiko Yoshino ",
    "loc": "Kyoto Univ.",
    "inf": [
      "Catalytic C(sp3)–H Functionalization Using Group 9 Metal Catalysts with Cp-type Ligands ",
      "(Kyoto Univ.) Tatsuhiko Yoshino "
    ],
    "sea": "",
    "pdf": "pdf/S1-03.pdf",
    "pre": "tn/S1-03.jpg",
    "con": "S1-03 Catalytic C(sp3)–H Functionalization Using Group 9 Metal Catalysts with Cp-type Ligands  (Kyoto Univ.) Tatsuhiko Yoshino  "
  },
  {
    "lab": "S1-04",
    "tit": "Synthesis and Properties of Germanium and Silicon Analogs of Carbyne Complexes Supported by Cp* Ligands",
    "spe": "Hisako Hashimoto",
    "loc": "Tohoku Univ. ",
    "inf": [
      "Synthesis and Properties of Germanium and Silicon Analogs of Carbyne Complexes Supported by Cp* Ligands",
      "(Tohoku Univ. ) Hisako Hashimoto"
    ],
    "sea": "",
    "pdf": "pdf/S1-04.pdf",
    "pre": "tn/S1-04.jpg",
    "con": "S1-04 Synthesis and Properties of Germanium and Silicon Analogs of Carbyne Complexes Supported by Cp* Ligands (Tohoku Univ. ) Hisako Hashimoto "
  },
  {
    "lab": "S1-05",
    "tit": "Metal–Ligand Cooperative Group 13/14 Element–Hydrogen Bond Cleavage by Cyclopentadienone Metal Complexes",
    "spe": "Shuhei Kusumoto ",
    "loc": "Tokyo Metropolitan Univ. ",
    "inf": [
      "Metal–Ligand Cooperative Group 13/14 Element–Hydrogen Bond Cleavage by Cyclopentadienone Metal Complexes",
      "(Tokyo Metropolitan Univ. ) Shuhei Kusumoto "
    ],
    "sea": "",
    "pdf": "pdf/S1-05.pdf",
    "pre": "tn/S1-05.jpg",
    "con": "S1-05 Metal–Ligand Cooperative Group 13/14 Element–Hydrogen Bond Cleavage by Cyclopentadienone Metal Complexes (Tokyo Metropolitan Univ. ) Shuhei Kusumoto  "
  },
  {
    "lab": "S1-06",
    "tit": "Fused Tropone-Based Metal Complexes and Beyond ",
    "spe": "Takuya Kodama ",
    "loc": "Osaka Univ. ",
    "inf": [
      "Fused Tropone-Based Metal Complexes and Beyond ",
      "(Osaka Univ. ) Takuya Kodama "
    ],
    "sea": "",
    "pdf": "pdf/S1-06.pdf",
    "pre": "tn/S1-06.jpg",
    "con": "S1-06 Fused Tropone-Based Metal Complexes and Beyond  (Osaka Univ. ) Takuya Kodama  "
  },
  {
    "lab": "S1-07",
    "tit": "Synthesis and Catalytic Activity of Functionalized CpRh/Ir Complexes ",
    "spe": "Ken Tanaka",
    "loc": "Tokyo Institute of Technology",
    "inf": [
      "Synthesis and Catalytic Activity of Functionalized CpRh/Ir Complexes ",
      "(Tokyo Institute of Technology) Ken Tanaka"
    ],
    "sea": "",
    "pdf": "pdf/S1-07.pdf",
    "pre": "tn/S1-07.jpg",
    "con": "S1-07 Synthesis and Catalytic Activity of Functionalized CpRh/Ir Complexes  (Tokyo Institute of Technology) Ken Tanaka "
  },
  {
    "lab": "S2-01",
    "tit": "Efficient Fluoride Recovery from Functional Fluoropolymers: Poly(vinylidene fluoride) and Related Copolymers Using Superheated Water",
    "spe": "Hisao Hori ",
    "loc": "Kanagawa Univ.",
    "inf": [
      "Efficient Fluoride Recovery from Functional Fluoropolymers: Poly(vinylidene fluoride) and Related Copolymers Using Superheated Water",
      "(Kanagawa Univ.) Hisao Hori "
    ],
    "sea": "",
    "pdf": "pdf/S2-01.pdf",
    "pre": "tn/S2-01.jpg",
    "con": "S2-01 Efficient Fluoride Recovery from Functional Fluoropolymers: Poly(vinylidene fluoride) and Related Copolymers Using Superheated Water (Kanagawa Univ.) Hisao Hori  "
  },
  {
    "lab": "S2-02",
    "tit": "Catalytic Hydrogenation of Carboxylic Acids Using Tailored Metal Complexes",
    "spe": "Susumu Saito ",
    "loc": "Nagoya Univ. ",
    "inf": [
      "Catalytic Hydrogenation of Carboxylic Acids Using Tailored Metal Complexes",
      "(Nagoya Univ. ) Susumu Saito "
    ],
    "sea": "",
    "pdf": "pdf/S2-02.pdf",
    "pre": "tn/S2-02.jpg",
    "con": "S2-02 Catalytic Hydrogenation of Carboxylic Acids Using Tailored Metal Complexes (Nagoya Univ. ) Susumu Saito  "
  },
  {
    "lab": "S2-03",
    "tit": "Iridium Complex Catalyzed Hydrogen Production from Cellulose under Mild Conditions ",
    "spe": "Ken-ichi Fujita",
    "loc": "Kyoto Univ. ",
    "inf": [
      "Iridium Complex Catalyzed Hydrogen Production from Cellulose under Mild Conditions ",
      "(Kyoto Univ. ) Ken-ichi Fujita"
    ],
    "sea": "",
    "pdf": "pdf/S2-03.pdf",
    "pre": "tn/S2-03.jpg",
    "con": "S2-03 Iridium Complex Catalyzed Hydrogen Production from Cellulose under Mild Conditions  (Kyoto Univ. ) Ken-ichi Fujita "
  },
  {
    "lab": "S2-04",
    "tit": "Utilization of Biological Functions to Remove Toxic Metals or Recover Valuable Metals from the Aquatic Environment ",
    "spe": "Mei-Fang Chien",
    "loc": "Tohoku Univ. ",
    "inf": [
      "Utilization of Biological Functions to Remove Toxic Metals or Recover Valuable Metals from the Aquatic Environment ",
      "(Tohoku Univ. ) Mei-Fang Chien"
    ],
    "sea": "",
    "pdf": "pdf/S2-04.pdf",
    "pre": "tn/S2-04.jpg",
    "con": "S2-04 Utilization of Biological Functions to Remove Toxic Metals or Recover Valuable Metals from the Aquatic Environment  (Tohoku Univ. ) Mei-Fang Chien "
  },
  {
    "lab": "S2-05",
    "tit": "Nanocatalysts for a Low-Carbon Society: Upgrading Chemicals through Electrochemical Hydrogenation",
    "spe": "Miho Yamauchi",
    "loc": "Kyushu Univ.; Tohoku Univ. ",
    "inf": [
      "Nanocatalysts for a Low-Carbon Society: Upgrading Chemicals through Electrochemical Hydrogenation",
      "(Kyushu Univ.; Tohoku Univ. ) Miho Yamauchi"
    ],
    "sea": "",
    "pdf": "pdf/S2-05.pdf",
    "pre": "tn/S2-05.jpg",
    "con": "S2-05 Nanocatalysts for a Low-Carbon Society: Upgrading Chemicals through Electrochemical Hydrogenation (Kyushu Univ.; Tohoku Univ. ) Miho Yamauchi "
  },
  {
    "lab": "S2-06",
    "tit": "Electrocatalytic Hydrogenation of Pyridines by Using an Anion-Exchange Membrane (AEM) Electrolyzer",
    "spe": "Naoki Shida ",
    "loc": "Yokohama Natl. Univ.; JST PRESTO ",
    "inf": [
      "Electrocatalytic Hydrogenation of Pyridines by Using an Anion-Exchange Membrane (AEM) Electrolyzer",
      "(Yokohama Natl. Univ.; JST PRESTO ) Naoki Shida "
    ],
    "sea": "",
    "pdf": "pdf/S2-06.pdf",
    "pre": "tn/S2-06.jpg",
    "con": "S2-06 Electrocatalytic Hydrogenation of Pyridines by Using an Anion-Exchange Membrane (AEM) Electrolyzer (Yokohama Natl. Univ.; JST PRESTO ) Naoki Shida  "
  },
  {
    "lab": "S3-01",
    "tit": "“カイラルイオントロニクス”の創出と新奇キラル物性の開拓 ",
    "spe": "須田 理行",
    "loc": "京都大学",
    "inf": [
      "“カイラルイオントロニクス”の創出と新奇キラル物性の開拓 ",
      "(京都大学) 須田 理行"
    ],
    "sea": "",
    "pdf": "pdf/S3-01.pdf",
    "pre": "tn/S3-01.jpg",
    "con": "S3-01 “カイラルイオントロニクス”の創出と新奇キラル物性の開拓  (京都大学) 須田 理行 "
  },
  {
    "lab": "S3-02",
    "tit": "動的らせん型金属錯体のキラリティー反転とその時間変化過程の ",
    "spe": "秋根 茂久 ",
    "loc": "金沢大学",
    "inf": [
      "動的らせん型金属錯体のキラリティー反転とその時間変化過程の ",
      "(金沢大学) 秋根 茂久 "
    ],
    "sea": "",
    "pdf": "pdf/S3-02.pdf",
    "pre": "tn/S3-02.jpg",
    "con": "S3-02 動的らせん型金属錯体のキラリティー反転とその時間変化過程の  (金沢大学) 秋根 茂久  "
  },
  {
    "lab": "S3-03",
    "tit": "空間反転対称性の破れた磁性体における非相反的方向二色性 ",
    "spe": "谷口 耕治 ",
    "loc": "東京工業大学",
    "inf": [
      "空間反転対称性の破れた磁性体における非相反的方向二色性 ",
      "(東京工業大学) 谷口 耕治 "
    ],
    "sea": "",
    "pdf": "pdf/S3-03.pdf",
    "pre": "tn/S3-03.jpg",
    "con": "S3-03 空間反転対称性の破れた磁性体における非相反的方向二色性  (東京工業大学) 谷口 耕治  "
  },
  {
    "lab": "S3-04",
    "tit": "「単分子誘電体」の開発と応用 ",
    "spe": "⻄原 禎文 ",
    "loc": "広島大学 ",
    "inf": [
      "「単分子誘電体」の開発と応用 ",
      "(広島大学 ) ⻄原 禎文 "
    ],
    "sea": "",
    "pdf": "pdf/S3-04.pdf",
    "pre": "tn/S3-04.jpg",
    "con": "S3-04 「単分子誘電体」の開発と応用  (広島大学 ) ⻄原 禎文  "
  },
  {
    "lab": "S3-05",
    "tit": "極性結晶構造の原子価互変異性錯体:合理的合成法と磁気・電気特性 ",
    "spe": "金川 慎治 ",
    "loc": "九州大学 ",
    "inf": [
      "極性結晶構造の原子価互変異性錯体:合理的合成法と磁気・電気特性 ",
      "(九州大学 ) 金川 慎治 "
    ],
    "sea": "",
    "pdf": "pdf/S3-05.pdf",
    "pre": "tn/S3-05.jpg",
    "con": "S3-05 極性結晶構造の原子価互変異性錯体:合理的合成法と磁気・電気特性  (九州大学 ) 金川 慎治  "
  },
  {
    "lab": "S3-06",
    "tit": "空間反転対称性を持たない遷移金属錯体の電気磁気効果 ",
    "spe": "木村 尚次郎 ",
    "loc": "東北大学 ",
    "inf": [
      "空間反転対称性を持たない遷移金属錯体の電気磁気効果 ",
      "(東北大学 ) 木村 尚次郎 "
    ],
    "sea": "",
    "pdf": "pdf/S3-06.pdf",
    "pre": "tn/S3-06.jpg",
    "con": "S3-06 空間反転対称性を持たない遷移金属錯体の電気磁気効果  (東北大学 ) 木村 尚次郎  "
  },
  {
    "lab": "Aw-01",
    "awn": "学会賞",
    "loc": "南方科技大学 ",
    "spe": "徐 強 ",
    "tit": "金属−有機骨格材料の触媒及びエネルギー応用 ",
    "inf": [
      "金属−有機骨格材料の触媒及びエネルギー応用 ",
      "(南方科技大学 ) 徐 強 "
    ],
    "sea": "",
    "pdf": "pdf/Aw-01.pdf",
    "pre": "tn/Aw-01.jpg",
    "con": "Aw-01 金属−有機骨格材料の触媒及びエネルギー応用  (南方科技大学 ) 徐 強  "
  },
  {
    "lab": "Aw-02",
    "awn": "国際賞",
    "loc": "Sorbonne University ",
    "spe": "Marc Robert ",
    "tit": "Molecular Catalysis of Small Molecules Activation through Synergistic Electrochemical and Photochemical Innovations ",
    "inf": [
      "Molecular Catalysis of Small Molecules Activation through Synergistic Electrochemical and Photochemical Innovations ",
      "(Sorbonne University ) Marc Robert "
    ],
    "sea": "",
    "pdf": "pdf/Aw-02.pdf",
    "pre": "tn/Aw-02.jpg",
    "con": "Aw-02 Molecular Catalysis of Small Molecules Activation through Synergistic Electrochemical and Photochemical Innovations  (Sorbonne University ) Marc Robert  "
  },
  {
    "lab": "Aw-03",
    "awn": "学術賞",
    "loc": "同志社大学 ",
    "spe": "小寺 政人 ",
    "tit": "多核金属錯体による酸素活性化とがん細胞選択的毒性 ",
    "inf": [
      "多核金属錯体による酸素活性化とがん細胞選択的毒性 ",
      "(同志社大学 ) 小寺 政人 "
    ],
    "sea": "",
    "pdf": "pdf/Aw-03.pdf",
    "pre": "tn/Aw-03.jpg",
    "con": "Aw-03 多核金属錯体による酸素活性化とがん細胞選択的毒性  (同志社大学 ) 小寺 政人  "
  },
  {
    "lab": "Aw-04",
    "awn": "貢献賞",
    "loc": "東京大学 ",
    "spe": "野崎 京子 ",
    "tit": "精密な分子設計と反応機構の精確な理解を通した高活性均一系触媒の創製 ",
    "inf": [
      "精密な分子設計と反応機構の精確な理解を通した高活性均一系触媒の創製 ",
      "(東京大学 ) 野崎 京子 "
    ],
    "sea": "",
    "pdf": "pdf/Aw-04.pdf",
    "pre": "tn/Aw-04.jpg",
    "con": "Aw-04 精密な分子設計と反応機構の精確な理解を通した高活性均一系触媒の創製  (東京大学 ) 野崎 京子  "
  },
  {
    "lab": "Aw-05",
    "awn": "貢献賞",
    "loc": "桐蔭横浜大学 ",
    "spe": "宮坂 力 ",
    "tit": "金属ハロゲン化物ペロブスカイト結晶による光電変換の高効率化の研究 ",
    "inf": [
      "金属ハロゲン化物ペロブスカイト結晶による光電変換の高効率化の研究 ",
      "(桐蔭横浜大学 ) 宮坂 力 "
    ],
    "sea": "",
    "pdf": "pdf/Aw-05.pdf",
    "pre": "tn/Aw-05.jpg",
    "con": "Aw-05 金属ハロゲン化物ペロブスカイト結晶による光電変換の高効率化の研究  (桐蔭横浜大学 ) 宮坂 力  "
  },
  {
    "lab": "Aw-06",
    "awn": "国際奨励賞",
    "loc": "Massachusetts Institute of Technology ",
    "spe": "Danna E. Freedman ",
    "tit": "Coordination Chemistry Approach to Quantum Information Science ",
    "inf": [
      "Coordination Chemistry Approach to Quantum Information Science ",
      "(Massachusetts Institute of Technology ) Danna E. Freedman "
    ],
    "sea": "",
    "pdf": "pdf/Aw-06.pdf",
    "pre": "tn/Aw-06.jpg",
    "con": "Aw-06 Coordination Chemistry Approach to Quantum Information Science  (Massachusetts Institute of Technology ) Danna E. Freedman  "
  },
  {
    "lab": "Aw-07",
    "awn": "研究奨励賞",
    "loc": "東京都立大学 ",
    "spe": "楠本 周平 ",
    "tit": "シクロペンタジエノン金属錯体の金属-配位子協働を基軸とする結合の不均等切断・形成",
    "inf": [
      "シクロペンタジエノン金属錯体の金属-配位子協働を基軸とする結合の不均等切断・形成",
      "(東京都立大学 ) 楠本 周平 "
    ],
    "sea": "",
    "pdf": "pdf/Aw-07.pdf",
    "pre": "tn/Aw-07.jpg",
    "con": "Aw-07 シクロペンタジエノン金属錯体の金属-配位子協働を基軸とする結合の不均等切断・形成 (東京都立大学 ) 楠本 周平  "
  },
  {
    "lab": "Aw-08",
    "awn": "研究奨励賞",
    "loc": "東京工業大学 ",
    "spe": "森本 祐麻 ",
    "tit": "活性酸素-遷移金属錯体による不活性炭化水素化合物の酸化に関する研究 ",
    "inf": [
      "活性酸素-遷移金属錯体による不活性炭化水素化合物の酸化に関する研究 ",
      "(東京工業大学 ) 森本 祐麻 "
    ],
    "sea": "",
    "pdf": "pdf/Aw-08.pdf",
    "pre": "tn/Aw-08.jpg",
    "con": "Aw-08 活性酸素-遷移金属錯体による不活性炭化水素化合物の酸化に関する研究  (東京工業大学 ) 森本 祐麻  "
  },
  {
    "lab": "ls-1",
    "tit": "ランチョンセミナー 「家族と考えるワークライフバランス ~研 究 職 の 魅 力 ~」",
    "inf": [
      "ランチョンセミナー 「家族と考えるワークライフバランス ~研 究 職 の 魅 力 ~」"
    ],
    "pdf": "pdf/ls-1.pdf",
    "pre": "tn/ls-1.jpg",
    "sea": "",
    "spe": "",
    "loc": "",
    "con": "ls-1 ランチョンセミナー 「家族と考えるワークライフバランス ~研 究 職 の 魅 力 ~」 "
  },
  {
    "lab": "hc-1",
    "tit": "錯体化学ホームカミングデー",
    "inf": [
      "錯体化学ホームカミングデー"
    ],
    "pdf": "pdf/hc-1.pdf",
    "pre": "tn/hc-1.jpg",
    "sea": "",
    "spe": "",
    "loc": "",
    "con": "hc-1 錯体化学ホームカミングデー "
  }
]
;
